/* tslint:disable */
/* eslint-disable */
/**
 * Photo Upload API
 * The API description
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from './configuration';
import type { AxiosPromise, AxiosInstance, AxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from './common';
import type { RequestArgs } from './base';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, BaseAPI, RequiredError } from './base';

/**
 * 
 * @export
 * @interface AbandonPaymentDto
 */
export interface AbandonPaymentDto {
    /**
     * The `paymentGeneration` from the payment answer. Given, the call acts only while the order is still at it.
     * @type {number}
     * @memberof AbandonPaymentDto
     */
    'generation'?: number;
    /**
     * The `attemptId` from the payment answer (also the `attempt` query parameter on Stripe\'s cancel URL), or the Stripe session/intent id. Given, the call acts only while that attempt is the order\'s open one.
     * @type {string}
     * @memberof AbandonPaymentDto
     */
    'attemptId'?: string;
}
/**
 * 
 * @export
 * @interface AbandonPaymentResponseDto
 */
export interface AbandonPaymentResponseDto {
    /**
     * unpinned: the open Stripe attempt was closed and the order\'s price pin cleared (a FAILED order is PENDING again). not-pinned: nothing was pinned; nothing to do. payment-in-progress: the attempt completed, is paying, or could not be closed; nothing changed. not-payable: the order is paid or final; nothing changed. stale: the named attempt or generation is no longer the order\'s current one; nothing changed.
     * @type {string}
     * @memberof AbandonPaymentResponseDto
     */
    'outcome': AbandonPaymentResponseDtoOutcomeEnum;
}

export const AbandonPaymentResponseDtoOutcomeEnum = {
    Unpinned: 'unpinned',
    NotPinned: 'not-pinned',
    PaymentInProgress: 'payment-in-progress',
    NotPayable: 'not-payable',
    Stale: 'stale'
} as const;

export type AbandonPaymentResponseDtoOutcomeEnum = typeof AbandonPaymentResponseDtoOutcomeEnum[keyof typeof AbandonPaymentResponseDtoOutcomeEnum];

/**
 * 
 * @export
 * @interface AbandonedCartByStageDto
 */
export interface AbandonedCartByStageDto {
    /**
     * 
     * @type {AbandonedCartStageDto}
     * @memberof AbandonedCartByStageDto
     */
    'first': AbandonedCartStageDto;
    /**
     * 
     * @type {AbandonedCartStageDto}
     * @memberof AbandonedCartByStageDto
     */
    'second': AbandonedCartStageDto;
    /**
     * 
     * @type {AbandonedCartStageDto}
     * @memberof AbandonedCartByStageDto
     */
    'third': AbandonedCartStageDto;
}
/**
 * 
 * @export
 * @interface AbandonedCartConversionDto
 */
export interface AbandonedCartConversionDto {
    /**
     * Total orders that received at least one abandoned-cart email
     * @type {number}
     * @memberof AbandonedCartConversionDto
     */
    'totalSent': number;
    /**
     * Orders that reached a completed status after an email was sent
     * @type {number}
     * @memberof AbandonedCartConversionDto
     */
    'totalConverted': number;
    /**
     * Overall conversion rate (0-1)
     * @type {number}
     * @memberof AbandonedCartConversionDto
     */
    'conversionRate': number;
    /**
     * 
     * @type {AbandonedCartByStageDto}
     * @memberof AbandonedCartConversionDto
     */
    'byStage': AbandonedCartByStageDto;
}
/**
 * 
 * @export
 * @interface AbandonedCartStageDto
 */
export interface AbandonedCartStageDto {
    /**
     * Number of orders that received this email
     * @type {number}
     * @memberof AbandonedCartStageDto
     */
    'sent': number;
    /**
     * Orders that converted after this email was sent
     * @type {number}
     * @memberof AbandonedCartStageDto
     */
    'converted': number;
}
/**
 * 
 * @export
 * @interface AcceptInviteDto
 */
export interface AcceptInviteDto {
    /**
     * 
     * @type {string}
     * @memberof AcceptInviteDto
     */
    'token': string;
}
/**
 * 
 * @export
 * @interface ActiveCashbackDto
 */
export interface ActiveCashbackDto {
    /**
     * 
     * @type {boolean}
     * @memberof ActiveCashbackDto
     */
    'active': boolean;
    /**
     * 
     * @type {string}
     * @memberof ActiveCashbackDto
     */
    'promotionId'?: string;
    /**
     * 
     * @type {string}
     * @memberof ActiveCashbackDto
     */
    'currency'?: string;
    /**
     * 
     * @type {number}
     * @memberof ActiveCashbackDto
     */
    'rateBp'?: number;
    /**
     * 
     * @type {number}
     * @memberof ActiveCashbackDto
     */
    'minimumCents'?: number;
    /**
     * 
     * @type {number}
     * @memberof ActiveCashbackDto
     */
    'capCents'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof ActiveCashbackDto
     */
    'rewardAtMinimumCents'?: number;
    /**
     * 
     * @type {string}
     * @memberof ActiveCashbackDto
     */
    'endsAt'?: string;
    /**
     * 
     * @type {number}
     * @memberof ActiveCashbackDto
     */
    'lotLifetimeDays'?: number;
    /**
     * 
     * @type {CashbackPromotionChannel}
     * @memberof ActiveCashbackDto
     */
    'channel'?: CashbackPromotionChannel;
}


/**
 * 
 * @export
 * @interface AddArtworkToOrderDto
 */
export interface AddArtworkToOrderDto {
    /**
     * Artwork slug, as it appears in the URL.
     * @type {string}
     * @memberof AddArtworkToOrderDto
     */
    'slug': string;
    /**
     * The chosen size, as a variant id.
     * @type {string}
     * @memberof AddArtworkToOrderDto
     */
    'variantId': string;
    /**
     * 
     * @type {number}
     * @memberof AddArtworkToOrderDto
     */
    'quantity': number;
}
/**
 * 
 * @export
 * @interface AddMapToOrderDto
 */
export interface AddMapToOrderDto {
    /**
     * The chosen size, as a map variant id.
     * @type {string}
     * @memberof AddMapToOrderDto
     */
    'variantId': string;
    /**
     * 
     * @type {number}
     * @memberof AddMapToOrderDto
     */
    'quantity': number;
    /**
     * 
     * @type {MapSpecDto}
     * @memberof AddMapToOrderDto
     */
    'map': MapSpecDto;
}
/**
 * 
 * @export
 * @interface AddPartyPhotosDto
 */
export interface AddPartyPhotosDto {
    /**
     * 
     * @type {string}
     * @memberof AddPartyPhotosDto
     */
    'partyCode': string;
    /**
     * 
     * @type {Array<string>}
     * @memberof AddPartyPhotosDto
     */
    'photoIds': Array<string>;
    /**
     * 
     * @type {string}
     * @memberof AddPartyPhotosDto
     */
    'photoSizeId': string;
    /**
     * Party guest token, for a guest who joined without an account
     * @type {string}
     * @memberof AddPartyPhotosDto
     */
    'partyToken'?: string;
}
/**
 * 
 * @export
 * @interface AddProductWithMediaToOrderDto
 */
export interface AddProductWithMediaToOrderDto {
    /**
     * 
     * @type {string}
     * @memberof AddProductWithMediaToOrderDto
     */
    'definitionId': string;
    /**
     * 
     * @type {number}
     * @memberof AddProductWithMediaToOrderDto
     */
    'quantity': number;
    /**
     * 
     * @type {Array<MediaItemDto>}
     * @memberof AddProductWithMediaToOrderDto
     */
    'media': Array<MediaItemDto>;
    /**
     * Paper id to use for this line
     * @type {string}
     * @memberof AddProductWithMediaToOrderDto
     */
    'selectedPaperId'?: string;
    /**
     * Required when the definition declares variantAxes; omit for definitions without a variant matrix.
     * @type {string}
     * @memberof AddProductWithMediaToOrderDto
     */
    'variantId'?: string;
}
/**
 * 
 * @export
 * @interface AdminCashbackAwardDto
 */
export interface AdminCashbackAwardDto {
    /**
     * 
     * @type {string}
     * @memberof AdminCashbackAwardDto
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof AdminCashbackAwardDto
     */
    'orderId': string;
    /**
     * Null for a coupon award.
     * @type {string}
     * @memberof AdminCashbackAwardDto
     */
    'promotionId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AdminCashbackAwardDto
     */
    'promotionName'?: string | null;
    /**
     * 
     * @type {CashbackPromotionChannel}
     * @memberof AdminCashbackAwardDto
     */
    'promotionChannel'?: CashbackPromotionChannel | null;
    /**
     * 
     * @type {string}
     * @memberof AdminCashbackAwardDto
     */
    'source': AdminCashbackAwardDtoSourceEnum;
    /**
     * Null once the coupon is deleted.
     * @type {string}
     * @memberof AdminCashbackAwardDto
     */
    'couponId'?: string | null;
    /**
     * The code as placed; kept after a delete.
     * @type {string}
     * @memberof AdminCashbackAwardDto
     */
    'couponCode'?: string | null;
    /**
     * The candidate that lost under \"larger wins\": { source, amountCents, couponId?, couponCode?, promotionId?, promotionName? }.
     * @type {{ [key: string]: any; }}
     * @memberof AdminCashbackAwardDto
     */
    'runnerUp'?: { [key: string]: any; } | null;
    /**
     * 
     * @type {CashbackOrderChannel}
     * @memberof AdminCashbackAwardDto
     */
    'orderChannel': CashbackOrderChannel;
    /**
     * 
     * @type {string}
     * @memberof AdminCashbackAwardDto
     */
    'email': string;
    /**
     * 
     * @type {string}
     * @memberof AdminCashbackAwardDto
     */
    'currency': string;
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof AdminCashbackAwardDto
     */
    'terms': { [key: string]: any; };
    /**
     * 
     * @type {string}
     * @memberof AdminCashbackAwardDto
     */
    'placedAt': string;
    /**
     * 
     * @type {number}
     * @memberof AdminCashbackAwardDto
     */
    'qualifyingCents': number;
    /**
     * 
     * @type {number}
     * @memberof AdminCashbackAwardDto
     */
    'amountCents': number;
    /**
     * 
     * @type {number}
     * @memberof AdminCashbackAwardDto
     */
    'entitledCents': number;
    /**
     * 
     * @type {number}
     * @memberof AdminCashbackAwardDto
     */
    'refundedCents': number;
    /**
     * 
     * @type {string}
     * @memberof AdminCashbackAwardDto
     */
    'status': AdminCashbackAwardDtoStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof AdminCashbackAwardDto
     */
    'creditLotId'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof AdminCashbackAwardDto
     */
    'recoveredCents': number;
    /**
     * 
     * @type {number}
     * @memberof AdminCashbackAwardDto
     */
    'unrecoveredCents': number;
    /**
     * 
     * @type {string}
     * @memberof AdminCashbackAwardDto
     */
    'grantedAt'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AdminCashbackAwardDto
     */
    'canceledAt'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AdminCashbackAwardDto
     */
    'voidedAt'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AdminCashbackAwardDto
     */
    'notifiedAt'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof AdminCashbackAwardDto
     */
    'attempts': number;
    /**
     * 
     * @type {string}
     * @memberof AdminCashbackAwardDto
     */
    'lastError'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AdminCashbackAwardDto
     */
    'nextAttemptAt'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AdminCashbackAwardDto
     */
    'blockedSince'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AdminCashbackAwardDto
     */
    'alertedAt'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AdminCashbackAwardDto
     */
    'createdAt': string;
    /**
     * 
     * @type {string}
     * @memberof AdminCashbackAwardDto
     */
    'updatedAt': string;
    /**
     * 
     * @type {number}
     * @memberof AdminCashbackAwardDto
     */
    'lotRemainingCents'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof AdminCashbackAwardDto
     */
    'lotExpiresAt'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AdminCashbackAwardDto
     */
    'lotVoidedAt'?: string | null;
    /**
     * Unreleased redemptions of the lot on placed orders (holds on open carts excluded).
     * @type {number}
     * @memberof AdminCashbackAwardDto
     */
    'spentCents': number;
}

export const AdminCashbackAwardDtoSourceEnum = {
    Promotion: 'PROMOTION',
    Coupon: 'COUPON'
} as const;

export type AdminCashbackAwardDtoSourceEnum = typeof AdminCashbackAwardDtoSourceEnum[keyof typeof AdminCashbackAwardDtoSourceEnum];
export const AdminCashbackAwardDtoStatusEnum = {
    Pending: 'PENDING',
    Granted: 'GRANTED',
    Canceled: 'CANCELED',
    Voided: 'VOIDED'
} as const;

export type AdminCashbackAwardDtoStatusEnum = typeof AdminCashbackAwardDtoStatusEnum[keyof typeof AdminCashbackAwardDtoStatusEnum];

/**
 * 
 * @export
 * @interface AdminCashbackAwardListDto
 */
export interface AdminCashbackAwardListDto {
    /**
     * 
     * @type {Array<AdminCashbackAwardDto>}
     * @memberof AdminCashbackAwardListDto
     */
    'rows': Array<AdminCashbackAwardDto>;
    /**
     * 
     * @type {number}
     * @memberof AdminCashbackAwardListDto
     */
    'total': number;
    /**
     * 
     * @type {Array<AdminCashbackTotalsDto>}
     * @memberof AdminCashbackAwardListDto
     */
    'totals': Array<AdminCashbackTotalsDto>;
}
/**
 * 
 * @export
 * @interface AdminCashbackOrderAwardDto
 */
export interface AdminCashbackOrderAwardDto {
    /**
     * 
     * @type {AdminCashbackOrderAwardDtoAward}
     * @memberof AdminCashbackOrderAwardDto
     */
    'award': AdminCashbackOrderAwardDtoAward | null;
}
/**
 * null when the order has no award.
 * @export
 * @interface AdminCashbackOrderAwardDtoAward
 */
export interface AdminCashbackOrderAwardDtoAward {
    /**
     * 
     * @type {string}
     * @memberof AdminCashbackOrderAwardDtoAward
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof AdminCashbackOrderAwardDtoAward
     */
    'orderId': string;
    /**
     * Null for a coupon award.
     * @type {string}
     * @memberof AdminCashbackOrderAwardDtoAward
     */
    'promotionId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AdminCashbackOrderAwardDtoAward
     */
    'promotionName'?: string | null;
    /**
     * 
     * @type {CashbackPromotionChannel}
     * @memberof AdminCashbackOrderAwardDtoAward
     */
    'promotionChannel'?: CashbackPromotionChannel | null;
    /**
     * 
     * @type {string}
     * @memberof AdminCashbackOrderAwardDtoAward
     */
    'source': AdminCashbackOrderAwardDtoAwardSourceEnum;
    /**
     * Null once the coupon is deleted.
     * @type {string}
     * @memberof AdminCashbackOrderAwardDtoAward
     */
    'couponId'?: string | null;
    /**
     * The code as placed; kept after a delete.
     * @type {string}
     * @memberof AdminCashbackOrderAwardDtoAward
     */
    'couponCode'?: string | null;
    /**
     * The candidate that lost under \"larger wins\": { source, amountCents, couponId?, couponCode?, promotionId?, promotionName? }.
     * @type {{ [key: string]: any; }}
     * @memberof AdminCashbackOrderAwardDtoAward
     */
    'runnerUp'?: { [key: string]: any; } | null;
    /**
     * 
     * @type {CashbackOrderChannel}
     * @memberof AdminCashbackOrderAwardDtoAward
     */
    'orderChannel': CashbackOrderChannel;
    /**
     * 
     * @type {string}
     * @memberof AdminCashbackOrderAwardDtoAward
     */
    'email': string;
    /**
     * 
     * @type {string}
     * @memberof AdminCashbackOrderAwardDtoAward
     */
    'currency': string;
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof AdminCashbackOrderAwardDtoAward
     */
    'terms': { [key: string]: any; };
    /**
     * 
     * @type {string}
     * @memberof AdminCashbackOrderAwardDtoAward
     */
    'placedAt': string;
    /**
     * 
     * @type {number}
     * @memberof AdminCashbackOrderAwardDtoAward
     */
    'qualifyingCents': number;
    /**
     * 
     * @type {number}
     * @memberof AdminCashbackOrderAwardDtoAward
     */
    'amountCents': number;
    /**
     * 
     * @type {number}
     * @memberof AdminCashbackOrderAwardDtoAward
     */
    'entitledCents': number;
    /**
     * 
     * @type {number}
     * @memberof AdminCashbackOrderAwardDtoAward
     */
    'refundedCents': number;
    /**
     * 
     * @type {string}
     * @memberof AdminCashbackOrderAwardDtoAward
     */
    'status': AdminCashbackOrderAwardDtoAwardStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof AdminCashbackOrderAwardDtoAward
     */
    'creditLotId'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof AdminCashbackOrderAwardDtoAward
     */
    'recoveredCents': number;
    /**
     * 
     * @type {number}
     * @memberof AdminCashbackOrderAwardDtoAward
     */
    'unrecoveredCents': number;
    /**
     * 
     * @type {string}
     * @memberof AdminCashbackOrderAwardDtoAward
     */
    'grantedAt'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AdminCashbackOrderAwardDtoAward
     */
    'canceledAt'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AdminCashbackOrderAwardDtoAward
     */
    'voidedAt'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AdminCashbackOrderAwardDtoAward
     */
    'notifiedAt'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof AdminCashbackOrderAwardDtoAward
     */
    'attempts': number;
    /**
     * 
     * @type {string}
     * @memberof AdminCashbackOrderAwardDtoAward
     */
    'lastError'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AdminCashbackOrderAwardDtoAward
     */
    'nextAttemptAt'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AdminCashbackOrderAwardDtoAward
     */
    'blockedSince'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AdminCashbackOrderAwardDtoAward
     */
    'alertedAt'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AdminCashbackOrderAwardDtoAward
     */
    'createdAt': string;
    /**
     * 
     * @type {string}
     * @memberof AdminCashbackOrderAwardDtoAward
     */
    'updatedAt': string;
    /**
     * 
     * @type {number}
     * @memberof AdminCashbackOrderAwardDtoAward
     */
    'lotRemainingCents'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof AdminCashbackOrderAwardDtoAward
     */
    'lotExpiresAt'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AdminCashbackOrderAwardDtoAward
     */
    'lotVoidedAt'?: string | null;
    /**
     * Unreleased redemptions of the lot on placed orders (holds on open carts excluded).
     * @type {number}
     * @memberof AdminCashbackOrderAwardDtoAward
     */
    'spentCents': number;
}

export const AdminCashbackOrderAwardDtoAwardSourceEnum = {
    Promotion: 'PROMOTION',
    Coupon: 'COUPON'
} as const;

export type AdminCashbackOrderAwardDtoAwardSourceEnum = typeof AdminCashbackOrderAwardDtoAwardSourceEnum[keyof typeof AdminCashbackOrderAwardDtoAwardSourceEnum];
export const AdminCashbackOrderAwardDtoAwardStatusEnum = {
    Pending: 'PENDING',
    Granted: 'GRANTED',
    Canceled: 'CANCELED',
    Voided: 'VOIDED'
} as const;

export type AdminCashbackOrderAwardDtoAwardStatusEnum = typeof AdminCashbackOrderAwardDtoAwardStatusEnum[keyof typeof AdminCashbackOrderAwardDtoAwardStatusEnum];

/**
 * 
 * @export
 * @interface AdminCashbackTotalsDto
 */
export interface AdminCashbackTotalsDto {
    /**
     * 
     * @type {string}
     * @memberof AdminCashbackTotalsDto
     */
    'currency': string;
    /**
     * 
     * @type {number}
     * @memberof AdminCashbackTotalsDto
     */
    'awards': number;
    /**
     * Awarded but not granted yet (COD waiting for delivery).
     * @type {number}
     * @memberof AdminCashbackTotalsDto
     */
    'pendingCents': number;
    /**
     * Every lot minted, whatever happened to it since.
     * @type {number}
     * @memberof AdminCashbackTotalsDto
     */
    'grantedCents': number;
    /**
     * Live lot balance: not voided, not expired.
     * @type {number}
     * @memberof AdminCashbackTotalsDto
     */
    'outstandingCents': number;
    /**
     * Redeemed on placed orders.
     * @type {number}
     * @memberof AdminCashbackTotalsDto
     */
    'spentCents': number;
    /**
     * 
     * @type {number}
     * @memberof AdminCashbackTotalsDto
     */
    'recoveredCents': number;
    /**
     * 
     * @type {number}
     * @memberof AdminCashbackTotalsDto
     */
    'unrecoveredCents': number;
}
/**
 * 
 * @export
 * @interface AdminCreditCurrencyTotalsDto
 */
export interface AdminCreditCurrencyTotalsDto {
    /**
     * 
     * @type {string}
     * @memberof AdminCreditCurrencyTotalsDto
     */
    'currency': string;
    /**
     * 
     * @type {number}
     * @memberof AdminCreditCurrencyTotalsDto
     */
    'lots': number;
    /**
     * Everything ever granted.
     * @type {number}
     * @memberof AdminCreditCurrencyTotalsDto
     */
    'grantedCents': number;
    /**
     * Granted minus what remains on the lots.
     * @type {number}
     * @memberof AdminCreditCurrencyTotalsDto
     */
    'spentCents': number;
    /**
     * The live liability: unexpired credit customers can still spend.
     * @type {number}
     * @memberof AdminCreditCurrencyTotalsDto
     */
    'outstandingCents': number;
    /**
     * Left on lots that have expired. Will never be spent; not owed.
     * @type {number}
     * @memberof AdminCreditCurrencyTotalsDto
     */
    'expiredUnusedCents': number;
}
/**
 * 
 * @export
 * @interface AdminCreditListDto
 */
export interface AdminCreditListDto {
    /**
     * 
     * @type {Array<AdminCreditLotDto>}
     * @memberof AdminCreditListDto
     */
    'data': Array<AdminCreditLotDto>;
    /**
     * 
     * @type {number}
     * @memberof AdminCreditListDto
     */
    'total': number;
    /**
     * 
     * @type {number}
     * @memberof AdminCreditListDto
     */
    'page': number;
    /**
     * 
     * @type {number}
     * @memberof AdminCreditListDto
     */
    'limit': number;
    /**
     * Across ALL lots, not this page.
     * @type {Array<AdminCreditCurrencyTotalsDto>}
     * @memberof AdminCreditListDto
     */
    'totals': Array<AdminCreditCurrencyTotalsDto>;
}
/**
 * 
 * @export
 * @interface AdminCreditLookupDto
 */
export interface AdminCreditLookupDto {
    /**
     * Orders placed from or for this address.
     * @type {number}
     * @memberof AdminCreditLookupDto
     */
    'orderCount': number;
    /**
     * 
     * @type {boolean}
     * @memberof AdminCreditLookupDto
     */
    'hasAccount': boolean;
    /**
     * Currency of the address\'s latest order, normalised.
     * @type {string}
     * @memberof AdminCreditLookupDto
     */
    'currency': string | null;
    /**
     * Email locale matching the latest order\'s language.
     * @type {string}
     * @memberof AdminCreditLookupDto
     */
    'locale': string | null;
}
/**
 * 
 * @export
 * @interface AdminCreditLotDto
 */
export interface AdminCreditLotDto {
    /**
     * 
     * @type {string}
     * @memberof AdminCreditLotDto
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof AdminCreditLotDto
     */
    'origin': AdminCreditLotDtoOriginEnum;
    /**
     * 
     * @type {string}
     * @memberof AdminCreditLotDto
     */
    'email': string | null;
    /**
     * 
     * @type {string}
     * @memberof AdminCreditLotDto
     */
    'currency': string;
    /**
     * Minor units, as granted.
     * @type {number}
     * @memberof AdminCreditLotDto
     */
    'amountCents': number;
    /**
     * Minor units, still spendable.
     * @type {number}
     * @memberof AdminCreditLotDto
     */
    'remainingCents': number;
    /**
     * 
     * @type {number}
     * @memberof AdminCreditLotDto
     */
    'minimumOrderCents': number;
    /**
     * 
     * @type {string}
     * @memberof AdminCreditLotDto
     */
    'expiresAt': string | null;
    /**
     * 
     * @type {string}
     * @memberof AdminCreditLotDto
     */
    'reason': string | null;
    /**
     * 
     * @type {string}
     * @memberof AdminCreditLotDto
     */
    'createdBy': string;
    /**
     * 
     * @type {string}
     * @memberof AdminCreditLotDto
     */
    'createdAt': string;
    /**
     * 
     * @type {string}
     * @memberof AdminCreditLotDto
     */
    'status': AdminCreditLotDtoStatusEnum;
    /**
     * 
     * @type {Array<AdminCreditRedemptionDto>}
     * @memberof AdminCreditLotDto
     */
    'redemptions': Array<AdminCreditRedemptionDto>;
}

export const AdminCreditLotDtoOriginEnum = {
    Granted: 'GRANTED',
    Purchased: 'PURCHASED'
} as const;

export type AdminCreditLotDtoOriginEnum = typeof AdminCreditLotDtoOriginEnum[keyof typeof AdminCreditLotDtoOriginEnum];
export const AdminCreditLotDtoStatusEnum = {
    Active: 'active',
    Spent: 'spent',
    Expired: 'expired'
} as const;

export type AdminCreditLotDtoStatusEnum = typeof AdminCreditLotDtoStatusEnum[keyof typeof AdminCreditLotDtoStatusEnum];

/**
 * 
 * @export
 * @interface AdminCreditRedemptionDto
 */
export interface AdminCreditRedemptionDto {
    /**
     * 
     * @type {string}
     * @memberof AdminCreditRedemptionDto
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof AdminCreditRedemptionDto
     */
    'orderId': string;
    /**
     * Minor units.
     * @type {number}
     * @memberof AdminCreditRedemptionDto
     */
    'amountCents': number;
    /**
     * 
     * @type {string}
     * @memberof AdminCreditRedemptionDto
     */
    'createdAt': string;
    /**
     * Set when the credit went back to the lot (order cancelled, refunded, or the credit removed at checkout). A released row is history, not a spend.
     * @type {string}
     * @memberof AdminCreditRedemptionDto
     */
    'releasedAt': string | null;
}
/**
 * 
 * @export
 * @interface AdminGiftCardLookupByCodeDto
 */
export interface AdminGiftCardLookupByCodeDto {
    /**
     * As printed or typed.
     * @type {string}
     * @memberof AdminGiftCardLookupByCodeDto
     */
    'code': string;
}
/**
 * 
 * @export
 * @interface AdminGiftCardLookupDto
 */
export interface AdminGiftCardLookupDto {
    /**
     * 
     * @type {AdminGiftCardLotDto}
     * @memberof AdminGiftCardLookupDto
     */
    'lot': AdminGiftCardLotDto;
    /**
     * The GIFT_CARD order that bought it.
     * @type {string}
     * @memberof AdminGiftCardLookupDto
     */
    'orderId': string | null;
    /**
     * 
     * @type {Array<AdminCreditRedemptionDto>}
     * @memberof AdminGiftCardLookupDto
     */
    'redemptions': Array<AdminCreditRedemptionDto>;
}
/**
 * 
 * @export
 * @interface AdminGiftCardLotDto
 */
export interface AdminGiftCardLotDto {
    /**
     * 
     * @type {string}
     * @memberof AdminGiftCardLotDto
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof AdminGiftCardLotDto
     */
    'codeMasked': string;
    /**
     * The whole code, so it can be read out or resent.
     * @type {string}
     * @memberof AdminGiftCardLotDto
     */
    'code': string;
    /**
     * 
     * @type {string}
     * @memberof AdminGiftCardLotDto
     */
    'market': string | null;
    /**
     * 
     * @type {string}
     * @memberof AdminGiftCardLotDto
     */
    'currency': string;
    /**
     * Minor units, as bought.
     * @type {number}
     * @memberof AdminGiftCardLotDto
     */
    'amountCents': number;
    /**
     * Minor units, still spendable.
     * @type {number}
     * @memberof AdminGiftCardLotDto
     */
    'remainingCents': number;
    /**
     * Who claimed it; null until its code is entered.
     * @type {string}
     * @memberof AdminGiftCardLotDto
     */
    'email': string | null;
    /**
     * 
     * @type {string}
     * @memberof AdminGiftCardLotDto
     */
    'createdAt': string;
    /**
     * When the card was voided (by an admin or a refund); null while it is live.
     * @type {string}
     * @memberof AdminGiftCardLotDto
     */
    'voidedAt': string | null;
}
/**
 * 
 * @export
 * @interface AdminGiftCardMarketDto
 */
export interface AdminGiftCardMarketDto {
    /**
     * 
     * @type {string}
     * @memberof AdminGiftCardMarketDto
     */
    'market': AdminGiftCardMarketDtoMarketEnum;
}

export const AdminGiftCardMarketDtoMarketEnum = {
    Si: 'si',
    Hr: 'hr',
    Sk: 'sk',
    De: 'de',
    At: 'at',
    Cz: 'cz',
    Pl: 'pl',
    Ro: 'ro'
} as const;

export type AdminGiftCardMarketDtoMarketEnum = typeof AdminGiftCardMarketDtoMarketEnum[keyof typeof AdminGiftCardMarketDtoMarketEnum];

/**
 * 
 * @export
 * @interface AdminGiftCardOwnerDto
 */
export interface AdminGiftCardOwnerDto {
    /**
     * The new owner, or null to un-claim the card.
     * @type {string}
     * @memberof AdminGiftCardOwnerDto
     */
    'email': string | null;
}
/**
 * 
 * @export
 * @interface AdminGiftCardPurchaseDto
 */
export interface AdminGiftCardPurchaseDto {
    /**
     * The GIFT_CARD order.
     * @type {string}
     * @memberof AdminGiftCardPurchaseDto
     */
    'orderId': string;
    /**
     * The order status (PAID, PENDING, REFUNDED, …).
     * @type {string}
     * @memberof AdminGiftCardPurchaseDto
     */
    'status': string;
    /**
     * 
     * @type {string}
     * @memberof AdminGiftCardPurchaseDto
     */
    'createdAt': string;
    /**
     * 
     * @type {string}
     * @memberof AdminGiftCardPurchaseDto
     */
    'paidAt': string | null;
    /**
     * Minor units, as bought.
     * @type {number}
     * @memberof AdminGiftCardPurchaseDto
     */
    'amountCents': number;
    /**
     * 
     * @type {string}
     * @memberof AdminGiftCardPurchaseDto
     */
    'currency': string;
    /**
     * The card; null until the payment has minted it.
     * @type {string}
     * @memberof AdminGiftCardPurchaseDto
     */
    'lotId': string | null;
    /**
     * 
     * @type {string}
     * @memberof AdminGiftCardPurchaseDto
     */
    'codeMasked': string | null;
    /**
     * Minor units.
     * @type {number}
     * @memberof AdminGiftCardPurchaseDto
     */
    'remainingCents': number | null;
    /**
     * Who claimed the card; null until its code is entered.
     * @type {string}
     * @memberof AdminGiftCardPurchaseDto
     */
    'owner': string | null;
    /**
     * 
     * @type {string}
     * @memberof AdminGiftCardPurchaseDto
     */
    'voidedAt': string | null;
}
/**
 * 
 * @export
 * @interface AdminGrantCreditDto
 */
export interface AdminGrantCreditDto {
    /**
     * 
     * @type {string}
     * @memberof AdminGrantCreditDto
     */
    'email': string;
    /**
     * Minor units, > 0.
     * @type {number}
     * @memberof AdminGrantCreditDto
     */
    'amountCents': number;
    /**
     * 
     * @type {string}
     * @memberof AdminGrantCreditDto
     */
    'currency': AdminGrantCreditDtoCurrencyEnum;
    /**
     * The language the customer is emailed in.
     * @type {string}
     * @memberof AdminGrantCreditDto
     */
    'locale': AdminGrantCreditDtoLocaleEnum;
    /**
     * ISO date or datetime. Omitted: 12 months from now.
     * @type {string}
     * @memberof AdminGrantCreditDto
     */
    'expiresAt'?: string;
    /**
     * Minimum order GOODS, minor units. 0 or omitted: any order.
     * @type {number}
     * @memberof AdminGrantCreditDto
     */
    'minimumOrderCents'?: number;
    /**
     * Why. Kept on the lot for the audit trail; never shown to the customer.
     * @type {string}
     * @memberof AdminGrantCreditDto
     */
    'reason': string;
    /**
     * Grant in a currency the market is not priced in.
     * @type {boolean}
     * @memberof AdminGrantCreditDto
     */
    'allowCurrencyMismatch'?: boolean;
    /**
     * Confirm a second identical grant on purpose.
     * @type {boolean}
     * @memberof AdminGrantCreditDto
     */
    'allowDuplicate'?: boolean;
}

export const AdminGrantCreditDtoCurrencyEnum = {
    Eur: 'eur',
    EurAt: 'eur-at',
    Pln: 'pln',
    Czk: 'czk',
    Ron: 'ron'
} as const;

export type AdminGrantCreditDtoCurrencyEnum = typeof AdminGrantCreditDtoCurrencyEnum[keyof typeof AdminGrantCreditDtoCurrencyEnum];
export const AdminGrantCreditDtoLocaleEnum = {
    Sl: 'sl',
    Hr: 'hr',
    Sk: 'sk',
    Cs: 'cs',
    Pl: 'pl',
    DeAt: 'de-AT',
    En: 'en',
    It: 'it'
} as const;

export type AdminGrantCreditDtoLocaleEnum = typeof AdminGrantCreditDtoLocaleEnum[keyof typeof AdminGrantCreditDtoLocaleEnum];

/**
 * 
 * @export
 * @interface AdminGrantResultDto
 */
export interface AdminGrantResultDto {
    /**
     * 
     * @type {string}
     * @memberof AdminGrantResultDto
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof AdminGrantResultDto
     */
    'email': string | null;
    /**
     * 
     * @type {string}
     * @memberof AdminGrantResultDto
     */
    'currency': string;
    /**
     * 
     * @type {number}
     * @memberof AdminGrantResultDto
     */
    'amountCents': number;
    /**
     * 
     * @type {string}
     * @memberof AdminGrantResultDto
     */
    'expiresAt': string | null;
    /**
     * 
     * @type {string}
     * @memberof AdminGrantResultDto
     */
    'createdBy': string;
}
/**
 * 
 * @export
 * @interface AdminKeepUntilDto
 */
export interface AdminKeepUntilDto {
    /**
     * 
     * @type {string}
     * @memberof AdminKeepUntilDto
     */
    'date': string | null;
}
/**
 * 
 * @export
 * @interface AdminTranslateRequestDto
 */
export interface AdminTranslateRequestDto {
    /**
     * Slovenian source text per field key.
     * @type {{ [key: string]: string; }}
     * @memberof AdminTranslateRequestDto
     */
    'fields': { [key: string]: string; };
    /**
     * Locale keys to translate into, exactly as the form stores them.
     * @type {Array<string>}
     * @memberof AdminTranslateRequestDto
     */
    'targets': Array<string>;
    /**
     * Optional maximum length (characters) per field key.
     * @type {{ [key: string]: number; }}
     * @memberof AdminTranslateRequestDto
     */
    'maxLengths'?: { [key: string]: number; };
}
/**
 * 
 * @export
 * @interface AdminTranslateResponseDto
 */
export interface AdminTranslateResponseDto {
    /**
     * Translations per target locale, then per field key. Anything the model returned malformed is left out.
     * @type {{ [key: string]: { [key: string]: string; }; }}
     * @memberof AdminTranslateResponseDto
     */
    'translations': { [key: string]: { [key: string]: string; }; };
}
/**
 * 
 * @export
 * @interface AdminVoidGiftCardDto
 */
export interface AdminVoidGiftCardDto {
    /**
     * Why. Appended to the card for the audit trail.
     * @type {string}
     * @memberof AdminVoidGiftCardDto
     */
    'reason': string;
}
/**
 * 
 * @export
 * @interface AnalyticsResponseDto
 */
export interface AnalyticsResponseDto {
    /**
     * Distribution of orders by status
     * @type {{ [key: string]: number; }}
     * @memberof AnalyticsResponseDto
     */
    'orderStatusDistribution': { [key: string]: number; };
    /**
     * Daily amount data
     * @type {Array<DailyAmountDataDto>}
     * @memberof AnalyticsResponseDto
     */
    'dailyAmounts': Array<DailyAmountDataDto>;
    /**
     * Cumulative amount data
     * @type {Array<CumulativeAmountDataDto>}
     * @memberof AnalyticsResponseDto
     */
    'cumulativeAmounts': Array<CumulativeAmountDataDto>;
    /**
     * Average order values over time
     * @type {Array<AverageOrderValueDataDto>}
     * @memberof AnalyticsResponseDto
     */
    'averageOrderValues': Array<AverageOrderValueDataDto>;
    /**
     * Daily orders grouped by day of week
     * @type {{ [key: string]: number; }}
     * @memberof AnalyticsResponseDto
     */
    'dailyOrdersByDay': { [key: string]: number; };
    /**
     * Orders grouped by hour of day
     * @type {{ [key: string]: number; }}
     * @memberof AnalyticsResponseDto
     */
    'hourlyOrders': { [key: string]: number; };
    /**
     * Daily order amounts grouped by day of week
     * @type {{ [key: string]: number; }}
     * @memberof AnalyticsResponseDto
     */
    'dailyOrdersByDayAmount': { [key: string]: number; };
    /**
     * Order amounts grouped by hour of day
     * @type {{ [key: string]: number; }}
     * @memberof AnalyticsResponseDto
     */
    'hourlyOrdersAmount': { [key: string]: number; };
    /**
     * Photo histogram data showing distribution by size
     * @type {Array<PhotoHistogramDataDto>}
     * @memberof AnalyticsResponseDto
     */
    'photoHistogramData': Array<PhotoHistogramDataDto>;
    /**
     * Top products ranked by sales volume
     * @type {Array<ProductSalesDataDto>}
     * @memberof AnalyticsResponseDto
     */
    'topProductsBySalesVolume': Array<ProductSalesDataDto>;
    /**
     * 
     * @type {MetricsDataDto}
     * @memberof AnalyticsResponseDto
     */
    'metrics': MetricsDataDto;
}
/**
 * 
 * @export
 * @interface AuthControllerFirebaseLoginRequest
 */
export interface AuthControllerFirebaseLoginRequest {
    /**
     * 
     * @type {string}
     * @memberof AuthControllerFirebaseLoginRequest
     */
    'idToken'?: string;
}
/**
 * 
 * @export
 * @interface AverageOrderValueDataDto
 */
export interface AverageOrderValueDataDto {
    /**
     * Date in YYYY-MM-DD format
     * @type {string}
     * @memberof AverageOrderValueDataDto
     */
    'date': string;
    /**
     * Average order value for the day
     * @type {number}
     * @memberof AverageOrderValueDataDto
     */
    'averageValue': number;
    /**
     * Average failed order value for the day
     * @type {number}
     * @memberof AverageOrderValueDataDto
     */
    'averageValueFailed': number;
    /**
     * Cumulative average order value
     * @type {number}
     * @memberof AverageOrderValueDataDto
     */
    'cumulativeAverage': number;
    /**
     * Cumulative average failed order value
     * @type {number}
     * @memberof AverageOrderValueDataDto
     */
    'cumulativeAverageFailed': number;
}
/**
 * 
 * @export
 * @interface BestCustomerDto
 */
export interface BestCustomerDto {
    /**
     * Customer email (lowercased)
     * @type {string}
     * @memberof BestCustomerDto
     */
    'email': string;
    /**
     * Total completed orders
     * @type {number}
     * @memberof BestCustomerDto
     */
    'totalOrders': number;
    /**
     * Lifetime spend (EUR)
     * @type {number}
     * @memberof BestCustomerDto
     */
    'lifetimeEur': number;
    /**
     * Average order value (EUR)
     * @type {number}
     * @memberof BestCustomerDto
     */
    'avgOrderValueEur': number;
    /**
     * First order timestamp (ISO 8601)
     * @type {string}
     * @memberof BestCustomerDto
     */
    'firstOrderAt': string;
    /**
     * Last order timestamp (ISO 8601)
     * @type {string}
     * @memberof BestCustomerDto
     */
    'lastOrderAt': string;
    /**
     * Days since last order
     * @type {number}
     * @memberof BestCustomerDto
     */
    'daysSinceLastOrder': number;
    /**
     * Template keys this customer converted on
     * @type {Array<string>}
     * @memberof BestCustomerDto
     */
    'convertedTemplates': Array<string>;
}
/**
 * 
 * @export
 * @interface BroadcastPushDto
 */
export interface BroadcastPushDto {
    /**
     * 
     * @type {string}
     * @memberof BroadcastPushDto
     */
    'market'?: BroadcastPushDtoMarketEnum;
    /**
     * 
     * @type {string}
     * @memberof BroadcastPushDto
     */
    'title': string;
    /**
     * 
     * @type {string}
     * @memberof BroadcastPushDto
     */
    'body': string;
    /**
     * 
     * @type {string}
     * @memberof BroadcastPushDto
     */
    'url'?: string;
}

export const BroadcastPushDtoMarketEnum = {
    Sl: 'sl',
    Hr: 'hr',
    Sk: 'sk',
    Pl: 'pl'
} as const;

export type BroadcastPushDtoMarketEnum = typeof BroadcastPushDtoMarketEnum[keyof typeof BroadcastPushDtoMarketEnum];

/**
 * 
 * @export
 * @interface BundleCardDto
 */
export interface BundleCardDto {
    /**
     * 
     * @type {string}
     * @memberof BundleCardDto
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof BundleCardDto
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof BundleCardDto
     */
    'description': string | null;
    /**
     * 
     * @type {string}
     * @memberof BundleCardDto
     */
    'imageUrl': string | null;
    /**
     * 
     * @type {string}
     * @memberof BundleCardDto
     */
    'currency': string;
    /**
     * 
     * @type {number}
     * @memberof BundleCardDto
     */
    'priceCents': number;
    /**
     * 
     * @type {number}
     * @memberof BundleCardDto
     */
    'normalPriceCents': number;
    /**
     * 
     * @type {number}
     * @memberof BundleCardDto
     */
    'savingCents': number;
    /**
     * 
     * @type {boolean}
     * @memberof BundleCardDto
     */
    'repeatable': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof BundleCardDto
     */
    'couponsAllowed': boolean;
    /**
     * 
     * @type {Array<BundleSlotCardDto>}
     * @memberof BundleCardDto
     */
    'slots': Array<BundleSlotCardDto>;
}
/**
 * 
 * @export
 * @interface BundleSlotCardDto
 */
export interface BundleSlotCardDto {
    /**
     * 
     * @type {string}
     * @memberof BundleSlotCardDto
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof BundleSlotCardDto
     */
    'kind': BundleSlotCardDtoKindEnum;
    /**
     * 
     * @type {number}
     * @memberof BundleSlotCardDto
     */
    'quantity': number;
    /**
     * 
     * @type {string}
     * @memberof BundleSlotCardDto
     */
    'label': string;
    /**
     * 
     * @type {string}
     * @memberof BundleSlotCardDto
     */
    'photoSizeId': string | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof BundleSlotCardDto
     */
    'variantIds': Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof BundleSlotCardDto
     */
    'productIds': Array<string>;
    /**
     * The cheapest allowed target (photo size, variant or product id).
     * @type {string}
     * @memberof BundleSlotCardDto
     */
    'targetId': string | null;
    /**
     * 
     * @type {string}
     * @memberof BundleSlotCardDto
     */
    'definitionId': string | null;
    /**
     * 
     * @type {string}
     * @memberof BundleSlotCardDto
     */
    'definitionKind': string | null;
    /**
     * 
     * @type {string}
     * @memberof BundleSlotCardDto
     */
    'thumbnailUrl': string | null;
    /**
     * 
     * @type {number}
     * @memberof BundleSlotCardDto
     */
    'unitPriceCents': number;
    /**
     * 
     * @type {number}
     * @memberof BundleSlotCardDto
     */
    'normalCents': number;
}

export const BundleSlotCardDtoKindEnum = {
    PhotoSize: 'PHOTO_SIZE',
    PwmVariant: 'PWM_VARIANT',
    Product: 'PRODUCT'
} as const;

export type BundleSlotCardDtoKindEnum = typeof BundleSlotCardDtoKindEnum[keyof typeof BundleSlotCardDtoKindEnum];

/**
 * 
 * @export
 * @interface BundleSlotInputDto
 */
export interface BundleSlotInputDto {
    /**
     * 
     * @type {string}
     * @memberof BundleSlotInputDto
     */
    'kind': BundleSlotInputDtoKindEnum;
    /**
     * 
     * @type {string}
     * @memberof BundleSlotInputDto
     */
    'photoSizeId'?: string | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof BundleSlotInputDto
     */
    'variantIds'?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof BundleSlotInputDto
     */
    'productIds'?: Array<string>;
    /**
     * 
     * @type {number}
     * @memberof BundleSlotInputDto
     */
    'quantity': number;
    /**
     * 
     * @type {object}
     * @memberof BundleSlotInputDto
     */
    'label'?: object | null;
    /**
     * 
     * @type {number}
     * @memberof BundleSlotInputDto
     */
    'position'?: number;
}

export const BundleSlotInputDtoKindEnum = {
    PhotoSize: 'PHOTO_SIZE',
    PwmVariant: 'PWM_VARIANT',
    Product: 'PRODUCT'
} as const;

export type BundleSlotInputDtoKindEnum = typeof BundleSlotInputDtoKindEnum[keyof typeof BundleSlotInputDtoKindEnum];

/**
 * 
 * @export
 * @interface CalculatePriceDto
 */
export interface CalculatePriceDto {
    /**
     * List of photo sizes with quantities
     * @type {Array<PhotoSizeItemExtraDto>}
     * @memberof CalculatePriceDto
     */
    'photoSizeItems': Array<PhotoSizeItemExtraDto>;
    /**
     * List of products with quantities
     * @type {Array<ProductItemExtraDto>}
     * @memberof CalculatePriceDto
     */
    'productItems': Array<ProductItemExtraDto>;
    /**
     * List of calendars with quantities
     * @type {Array<CalendarItemExtraDto>}
     * @memberof CalculatePriceDto
     */
    'calendarItems'?: Array<CalendarItemExtraDto>;
    /**
     * Coupon ID to apply
     * @type {string}
     * @memberof CalculatePriceDto
     */
    'couponId'?: string;
    /**
     * Currency code
     * @type {string}
     * @memberof CalculatePriceDto
     */
    'currency'?: string;
    /**
     * Storefront market the quote is for, e.g. \'si\' or \'sk\'. Currency alone cannot separate two euro storefronts, and without it market-scoped pricing overrides are invisible to the preview: it would misquote exactly the orders those overrides exist for.
     * @type {string}
     * @memberof CalculatePriceDto
     */
    'market'?: string;
    /**
     * Shipping method
     * @type {string}
     * @memberof CalculatePriceDto
     */
    'shippingMethod'?: CalculatePriceDtoShippingMethodEnum;
    /**
     * Payment option
     * @type {string}
     * @memberof CalculatePriceDto
     */
    'paymentOption'?: CalculatePriceDtoPaymentOptionEnum;
    /**
     * Delivery type
     * @type {string}
     * @memberof CalculatePriceDto
     */
    'deliveryType'?: CalculatePriceDtoDeliveryTypeEnum;
    /**
     * Ecological packaging option (+1.00 EUR)
     * @type {boolean}
     * @memberof CalculatePriceDto
     */
    'ecologicalPackaging'?: boolean;
    /**
     * Priority complaint option (+0.80 EUR)
     * @type {boolean}
     * @memberof CalculatePriceDto
     */
    'priorityComplaint'?: boolean;
    /**
     * Wrap as gift option (+6.00 EUR)
     * @type {boolean}
     * @memberof CalculatePriceDto
     */
    'wrapAsGift'?: boolean;
    /**
     * Premium paper option (price per photo, photoSize-dependent)
     * @type {boolean}
     * @memberof CalculatePriceDto
     */
    'premiumPaper'?: boolean;
    /**
     * Professional crop option (+2.00 EUR flat fee)
     * @type {boolean}
     * @memberof CalculatePriceDto
     */
    'professionalCrop'?: boolean;
    /**
     * White border option (price per photo, photoSize-dependent)
     * @type {boolean}
     * @memberof CalculatePriceDto
     */
    'whiteBorder'?: boolean;
    /**
     * Black and white option (price per photo, photoSize-dependent)
     * @type {boolean}
     * @memberof CalculatePriceDto
     */
    'blackAndWhite'?: boolean;
}

export const CalculatePriceDtoShippingMethodEnum = {
    Free: 'free',
    Normal: 'normal',
    Express: 'express'
} as const;

export type CalculatePriceDtoShippingMethodEnum = typeof CalculatePriceDtoShippingMethodEnum[keyof typeof CalculatePriceDtoShippingMethodEnum];
export const CalculatePriceDtoPaymentOptionEnum = {
    Normal: 'NORMAL',
    PaymentOnDelivery: 'PAYMENT_ON_DELIVERY'
} as const;

export type CalculatePriceDtoPaymentOptionEnum = typeof CalculatePriceDtoPaymentOptionEnum[keyof typeof CalculatePriceDtoPaymentOptionEnum];
export const CalculatePriceDtoDeliveryTypeEnum = {
    Home: 'HOME',
    ParcelLock: 'PARCEL_LOCK'
} as const;

export type CalculatePriceDtoDeliveryTypeEnum = typeof CalculatePriceDtoDeliveryTypeEnum[keyof typeof CalculatePriceDtoDeliveryTypeEnum];

/**
 * 
 * @export
 * @enum {string}
 */

export const CalendarFormat = {
    A2: 'A2',
    A3: 'A3',
    A4: 'A4',
    A5: 'A5',
    PlannerA3: 'PLANNER_A3',
    SpreadA4: 'SPREAD_A4'
} as const;

export type CalendarFormat = typeof CalendarFormat[keyof typeof CalendarFormat];


/**
 * 
 * @export
 * @interface CalendarItemDto
 */
export interface CalendarItemDto {
    /**
     * Calendar format (A2, A3, A4, A5)
     * @type {string}
     * @memberof CalendarItemDto
     */
    'format': string;
    /**
     * Number of calendars
     * @type {number}
     * @memberof CalendarItemDto
     */
    'quantity': number;
    /**
     * Calendar paper (\'white\' | \'silver\' | \'gold\'); defaults to \'white\'
     * @type {string}
     * @memberof CalendarItemDto
     */
    'paper'?: string;
}
/**
 * 
 * @export
 * @interface CalendarItemExtraDto
 */
export interface CalendarItemExtraDto {
    /**
     * Calendar format (A2, A3, A4, A5)
     * @type {string}
     * @memberof CalendarItemExtraDto
     */
    'format': string;
    /**
     * Number of calendars
     * @type {number}
     * @memberof CalendarItemExtraDto
     */
    'quantity': number;
    /**
     * Calendar paper (\'white\' | \'silver\' | \'gold\'); defaults to \'white\'
     * @type {string}
     * @memberof CalendarItemExtraDto
     */
    'paper'?: string;
    /**
     * Discount for the calendar
     * @type {number}
     * @memberof CalendarItemExtraDto
     */
    'discount': number;
}
/**
 * 
 * @export
 * @interface CalendarItemResponseDto
 */
export interface CalendarItemResponseDto {
    /**
     * Calendar format (A2, A3, A4, A5)
     * @type {string}
     * @memberof CalendarItemResponseDto
     */
    'format': string;
    /**
     * Number of calendars
     * @type {number}
     * @memberof CalendarItemResponseDto
     */
    'quantity': number;
    /**
     * Price for this calendar item (in cents)
     * @type {number}
     * @memberof CalendarItemResponseDto
     */
    'price': number;
    /**
     * Discount applied to this item (in cents)
     * @type {number}
     * @memberof CalendarItemResponseDto
     */
    'discount': number;
}
/**
 * 
 * @export
 * @interface CalendarPriceDto
 */
export interface CalendarPriceDto {
    /**
     * 
     * @type {CalendarFormat}
     * @memberof CalendarPriceDto
     */
    'format': CalendarFormat;
    /**
     * Price of ONE calendar of this format, in integer minor units of the parent currency. Zero is a real value; test presence, never truthiness.
     * @type {number}
     * @memberof CalendarPriceDto
     */
    'unitPriceCents': number;
}


/**
 * 
 * @export
 * @interface CalendarPricesResponseDto
 */
export interface CalendarPricesResponseDto {
    /**
     * Lowercase currency code as pricing knows it (\'eur\', \'eur-at\', \'czk\', \'pln\', \'ron\').
     * @type {string}
     * @memberof CalendarPricesResponseDto
     */
    'currency': string;
    /**
     * Unit price for every calendar format in this currency.
     * @type {Array<CalendarPriceDto>}
     * @memberof CalendarPricesResponseDto
     */
    'prices': Array<CalendarPriceDto>;
}
/**
 * 
 * @export
 * @interface CampaignListResponseDto
 */
export interface CampaignListResponseDto {
    /**
     * List of email campaigns
     * @type {Array<object>}
     * @memberof CampaignListResponseDto
     */
    'campaigns': Array<object>;
    /**
     * Total number of campaigns
     * @type {number}
     * @memberof CampaignListResponseDto
     */
    'total': number;
}
/**
 * 
 * @export
 * @interface CampaignStatsResponseDto
 */
export interface CampaignStatsResponseDto {
    /**
     * Total number of campaigns
     * @type {number}
     * @memberof CampaignStatsResponseDto
     */
    'total': number;
    /**
     * Number of pending campaigns
     * @type {number}
     * @memberof CampaignStatsResponseDto
     */
    'pending': number;
    /**
     * Number of campaigns in progress
     * @type {number}
     * @memberof CampaignStatsResponseDto
     */
    'inProgress': number;
    /**
     * Number of completed campaigns
     * @type {number}
     * @memberof CampaignStatsResponseDto
     */
    'completed': number;
    /**
     * Number of failed campaigns
     * @type {number}
     * @memberof CampaignStatsResponseDto
     */
    'failed': number;
    /**
     * Number of cancelled campaigns
     * @type {number}
     * @memberof CampaignStatsResponseDto
     */
    'cancelled': number;
}
/**
 * 
 * @export
 * @interface CancelRequestDecisionDto
 */
export interface CancelRequestDecisionDto {
    /**
     * 
     * @type {CancelRequestState}
     * @memberof CancelRequestDecisionDto
     */
    'state': CancelRequestState;
    /**
     * This decision moved the order to CANCELED.
     * @type {boolean}
     * @memberof CancelRequestDecisionDto
     */
    'canceled': boolean;
    /**
     * The unfiscalized invoice was voided.
     * @type {boolean}
     * @memberof CancelRequestDecisionDto
     */
    'invoiceVoided': boolean;
    /**
     * Card amount to refund by hand in Stripe, minor units; 0 when nothing was paid by card.
     * @type {number}
     * @memberof CancelRequestDecisionDto
     */
    'refundCents': number;
    /**
     * 
     * @type {string}
     * @memberof CancelRequestDecisionDto
     */
    'currency': string | null;
}


/**
 * 
 * @export
 * @interface CancelRequestQueueDto
 */
export interface CancelRequestQueueDto {
    /**
     * Requests waiting for a decision, oldest first.
     * @type {Array<CancelRequestQueueRowDto>}
     * @memberof CancelRequestQueueDto
     */
    'open': Array<CancelRequestQueueRowDto>;
    /**
     * Approved card orders still CANCELED: the Stripe refund has not arrived yet (\"Čaka na vračilo\").
     * @type {Array<CancelRequestQueueRowDto>}
     * @memberof CancelRequestQueueDto
     */
    'awaitingRefund': Array<CancelRequestQueueRowDto>;
}
/**
 * 
 * @export
 * @interface CancelRequestQueueRowDto
 */
export interface CancelRequestQueueRowDto {
    /**
     * 
     * @type {string}
     * @memberof CancelRequestQueueRowDto
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof CancelRequestQueueRowDto
     */
    'createdAt': string;
    /**
     * 
     * @type {string}
     * @memberof CancelRequestQueueRowDto
     */
    'status': string;
    /**
     * 
     * @type {string}
     * @memberof CancelRequestQueueRowDto
     */
    'paymentOption': string | null;
    /**
     * 
     * @type {string}
     * @memberof CancelRequestQueueRowDto
     */
    'currency': string | null;
    /**
     * 
     * @type {string}
     * @memberof CancelRequestQueueRowDto
     */
    'shippingEmail': string | null;
    /**
     * 
     * @type {string}
     * @memberof CancelRequestQueueRowDto
     */
    'cancelRequestedAt': string;
    /**
     * 
     * @type {string}
     * @memberof CancelRequestQueueRowDto
     */
    'cancelRequestReason': string | null;
    /**
     * 
     * @type {string}
     * @memberof CancelRequestQueueRowDto
     */
    'cancelRequestNote': string | null;
    /**
     * 
     * @type {string}
     * @memberof CancelRequestQueueRowDto
     */
    'cancelRequestDecidedAt': string | null;
    /**
     * 
     * @type {number}
     * @memberof CancelRequestQueueRowDto
     */
    'stripeAmount': number | null;
    /**
     * 
     * @type {string}
     * @memberof CancelRequestQueueRowDto
     */
    'stripeCurrency': string | null;
    /**
     * 
     * @type {string}
     * @memberof CancelRequestQueueRowDto
     */
    'stripePaymentIntentId': string | null;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const CancelRequestReason = {
    WrongPhotos: 'WRONG_PHOTOS',
    WrongAddress: 'WRONG_ADDRESS',
    WrongProduct: 'WRONG_PRODUCT',
    Other: 'OTHER'
} as const;

export type CancelRequestReason = typeof CancelRequestReason[keyof typeof CancelRequestReason];


/**
 * 
 * @export
 * @enum {string}
 */

export const CancelRequestState = {
    Open: 'OPEN',
    Approved: 'APPROVED',
    Declined: 'DECLINED'
} as const;

export type CancelRequestState = typeof CancelRequestState[keyof typeof CancelRequestState];


/**
 * 
 * @export
 * @interface CancelRequestViewDto
 */
export interface CancelRequestViewDto {
    /**
     * 
     * @type {CancelRequestState}
     * @memberof CancelRequestViewDto
     */
    'state': CancelRequestState;
    /**
     * ISO timestamp of the request (server clock).
     * @type {string}
     * @memberof CancelRequestViewDto
     */
    'requestedAt': string;
}


/**
 * The order\'s platform, from its orderSource.
 * @export
 * @enum {string}
 */

export const CashbackOrderChannel = {
    Web: 'WEB',
    Mobile: 'MOBILE'
} as const;

export type CashbackOrderChannel = typeof CashbackOrderChannel[keyof typeof CashbackOrderChannel];


/**
 * The running promotion\'s scope: ALL or the caller\'s platform.
 * @export
 * @enum {string}
 */

export const CashbackPromotionChannel = {
    All: 'ALL',
    Web: 'WEB',
    Mobile: 'MOBILE'
} as const;

export type CashbackPromotionChannel = typeof CashbackPromotionChannel[keyof typeof CashbackPromotionChannel];


/**
 * 
 * @export
 * @interface CashbackPromotionDto
 */
export interface CashbackPromotionDto {
    /**
     * 
     * @type {string}
     * @memberof CashbackPromotionDto
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof CashbackPromotionDto
     */
    'name': string;
    /**
     * 
     * @type {number}
     * @memberof CashbackPromotionDto
     */
    'rateBp': number;
    /**
     * 
     * @type {number}
     * @memberof CashbackPromotionDto
     */
    'lotLifetimeDays': number;
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof CashbackPromotionDto
     */
    'currencyRules': { [key: string]: any; };
    /**
     * 
     * @type {string}
     * @memberof CashbackPromotionDto
     */
    'startsAt': string;
    /**
     * 
     * @type {string}
     * @memberof CashbackPromotionDto
     */
    'endsAt': string;
    /**
     * 
     * @type {CashbackPromotionChannel}
     * @memberof CashbackPromotionDto
     */
    'channel': CashbackPromotionChannel;
    /**
     * 
     * @type {string}
     * @memberof CashbackPromotionDto
     */
    'createdBy': string;
    /**
     * 
     * @type {string}
     * @memberof CashbackPromotionDto
     */
    'updatedBy'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CashbackPromotionDto
     */
    'createdAt': string;
    /**
     * 
     * @type {string}
     * @memberof CashbackPromotionDto
     */
    'updatedAt': string;
}


/**
 * 
 * @export
 * @interface CashbackPromotionTotalsDto
 */
export interface CashbackPromotionTotalsDto {
    /**
     * 
     * @type {string}
     * @memberof CashbackPromotionTotalsDto
     */
    'promotionId': string;
    /**
     * 
     * @type {string}
     * @memberof CashbackPromotionTotalsDto
     */
    'currency': string;
    /**
     * 
     * @type {number}
     * @memberof CashbackPromotionTotalsDto
     */
    'awards': number;
    /**
     * 
     * @type {number}
     * @memberof CashbackPromotionTotalsDto
     */
    'orders': number;
    /**
     * 
     * @type {number}
     * @memberof CashbackPromotionTotalsDto
     */
    'qualifyingCents': number;
    /**
     * 
     * @type {number}
     * @memberof CashbackPromotionTotalsDto
     */
    'averageQualifyingCents': number;
    /**
     * 
     * @type {number}
     * @memberof CashbackPromotionTotalsDto
     */
    'pendingCents': number;
    /**
     * 
     * @type {number}
     * @memberof CashbackPromotionTotalsDto
     */
    'grantedCents': number;
    /**
     * 
     * @type {number}
     * @memberof CashbackPromotionTotalsDto
     */
    'spentCents': number;
    /**
     * 
     * @type {number}
     * @memberof CashbackPromotionTotalsDto
     */
    'outstandingCents': number;
    /**
     * 
     * @type {number}
     * @memberof CashbackPromotionTotalsDto
     */
    'recoveredCents': number;
    /**
     * 
     * @type {number}
     * @memberof CashbackPromotionTotalsDto
     */
    'unrecoveredCents': number;
}
/**
 * 
 * @export
 * @interface CashbackPromotionWithTotalsDto
 */
export interface CashbackPromotionWithTotalsDto {
    /**
     * 
     * @type {string}
     * @memberof CashbackPromotionWithTotalsDto
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof CashbackPromotionWithTotalsDto
     */
    'name': string;
    /**
     * 
     * @type {number}
     * @memberof CashbackPromotionWithTotalsDto
     */
    'rateBp': number;
    /**
     * 
     * @type {number}
     * @memberof CashbackPromotionWithTotalsDto
     */
    'lotLifetimeDays': number;
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof CashbackPromotionWithTotalsDto
     */
    'currencyRules': { [key: string]: any; };
    /**
     * 
     * @type {string}
     * @memberof CashbackPromotionWithTotalsDto
     */
    'startsAt': string;
    /**
     * 
     * @type {string}
     * @memberof CashbackPromotionWithTotalsDto
     */
    'endsAt': string;
    /**
     * 
     * @type {CashbackPromotionChannel}
     * @memberof CashbackPromotionWithTotalsDto
     */
    'channel': CashbackPromotionChannel;
    /**
     * 
     * @type {string}
     * @memberof CashbackPromotionWithTotalsDto
     */
    'createdBy': string;
    /**
     * 
     * @type {string}
     * @memberof CashbackPromotionWithTotalsDto
     */
    'updatedBy'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CashbackPromotionWithTotalsDto
     */
    'createdAt': string;
    /**
     * 
     * @type {string}
     * @memberof CashbackPromotionWithTotalsDto
     */
    'updatedAt': string;
    /**
     * Per currency; empty before the first award.
     * @type {Array<CashbackPromotionTotalsDto>}
     * @memberof CashbackPromotionWithTotalsDto
     */
    'totals': Array<CashbackPromotionTotalsDto>;
}


/**
 * 
 * @export
 * @interface ChangeOrderPhotoSizeDto
 */
export interface ChangeOrderPhotoSizeDto {
    /**
     * Photo size the group should print at
     * @type {string}
     * @memberof ChangeOrderPhotoSizeDto
     */
    'photoSizeId': string;
}
/**
 * 
 * @export
 * @interface ChartDataResponseDto
 */
export interface ChartDataResponseDto {
    /**
     * Daily orders grouped by day of week
     * @type {{ [key: string]: number; }}
     * @memberof ChartDataResponseDto
     */
    'dailyOrdersByDay': { [key: string]: number; };
    /**
     * Orders grouped by hour of day
     * @type {{ [key: string]: number; }}
     * @memberof ChartDataResponseDto
     */
    'hourlyOrders': { [key: string]: number; };
    /**
     * Daily order amounts grouped by day of week
     * @type {{ [key: string]: number; }}
     * @memberof ChartDataResponseDto
     */
    'dailyOrdersByDayAmount': { [key: string]: number; };
    /**
     * Order amounts grouped by hour of day
     * @type {{ [key: string]: number; }}
     * @memberof ChartDataResponseDto
     */
    'hourlyOrdersAmount': { [key: string]: number; };
    /**
     * Photo histogram data showing distribution by size
     * @type {Array<PhotoHistogramDataDto>}
     * @memberof ChartDataResponseDto
     */
    'photoHistogramData': Array<PhotoHistogramDataDto>;
    /**
     * Top products ranked by sales volume
     * @type {Array<ProductSalesDataDto>}
     * @memberof ChartDataResponseDto
     */
    'topProductsBySalesVolume': Array<ProductSalesDataDto>;
    /**
     * Average order values over time
     * @type {Array<AverageOrderValueDataDto>}
     * @memberof ChartDataResponseDto
     */
    'averageOrderValues': Array<AverageOrderValueDataDto>;
}
/**
 * 
 * @export
 * @interface ChooseFreeEnlargementDto
 */
export interface ChooseFreeEnlargementDto {
    /**
     * Id of a photo already in one of the order\'s paid photo lines.
     * @type {string}
     * @memberof ChooseFreeEnlargementDto
     */
    'photoId': string;
}
/**
 * 
 * @export
 * @interface CompanyDetailsDto
 */
export interface CompanyDetailsDto {
    /**
     * Company name
     * @type {string}
     * @memberof CompanyDetailsDto
     */
    'name': string;
    /**
     * Company address
     * @type {string}
     * @memberof CompanyDetailsDto
     */
    'address': string;
    /**
     * City
     * @type {string}
     * @memberof CompanyDetailsDto
     */
    'city': string;
    /**
     * ZIP code
     * @type {string}
     * @memberof CompanyDetailsDto
     */
    'zipCode': string;
    /**
     * Country
     * @type {string}
     * @memberof CompanyDetailsDto
     */
    'country': string;
    /**
     * Tax number
     * @type {string}
     * @memberof CompanyDetailsDto
     */
    'taxNumber': string;
    /**
     * Phone number
     * @type {string}
     * @memberof CompanyDetailsDto
     */
    'phone': string;
    /**
     * Email address
     * @type {string}
     * @memberof CompanyDetailsDto
     */
    'email': string;
    /**
     * Website URL
     * @type {string}
     * @memberof CompanyDetailsDto
     */
    'website': string;
    /**
     * Bank account number
     * @type {string}
     * @memberof CompanyDetailsDto
     */
    'bankAccount': string;
    /**
     * Bank name
     * @type {string}
     * @memberof CompanyDetailsDto
     */
    'bankName': string;
}
/**
 * DISCOUNT (default) or CASHBACK: no discount at checkout, credit after payment. Fixed once created.
 * @export
 * @enum {string}
 */

export const CouponRewardType = {
    Discount: 'DISCOUNT',
    Cashback: 'CASHBACK'
} as const;

export type CouponRewardType = typeof CouponRewardType[keyof typeof CouponRewardType];


/**
 * 
 * @export
 * @interface CreateAppEventDto
 */
export interface CreateAppEventDto {
    /**
     * 
     * @type {string}
     * @memberof CreateAppEventDto
     */
    'name': CreateAppEventDtoNameEnum;
    /**
     * Integer counts, 0..1000000. trips_scan_done: trips, photosScanned; trip_opened: tripPhotos, suggested; trip_continued: suggested, kept, added; newsletter_popup_shown, newsletter_popup_subscribed: variant, market.
     * @type {{ [key: string]: number; }}
     * @memberof CreateAppEventDto
     */
    'fields': { [key: string]: number; };
}

export const CreateAppEventDtoNameEnum = {
    TripsScanDone: 'trips_scan_done',
    TripOpened: 'trip_opened',
    TripContinued: 'trip_continued',
    NewsletterPopupShown: 'newsletter_popup_shown',
    NewsletterPopupSubscribed: 'newsletter_popup_subscribed'
} as const;

export type CreateAppEventDtoNameEnum = typeof CreateAppEventDtoNameEnum[keyof typeof CreateAppEventDtoNameEnum];

/**
 * 
 * @export
 * @interface CreateArtworkDto
 */
export interface CreateArtworkDto {
    /**
     * 
     * @type {string}
     * @memberof CreateArtworkDto
     */
    'kind': CreateArtworkDtoKindEnum;
    /**
     * 
     * @type {string}
     * @memberof CreateArtworkDto
     */
    'slug': string;
    /**
     * 
     * @type {object}
     * @memberof CreateArtworkDto
     */
    'title': object;
    /**
     * 
     * @type {string}
     * @memberof CreateArtworkDto
     */
    'artist': string;
    /**
     * 
     * @type {number}
     * @memberof CreateArtworkDto
     */
    'year'?: number;
    /**
     * 
     * @type {object}
     * @memberof CreateArtworkDto
     */
    'description'?: object;
    /**
     * 
     * @type {string}
     * @memberof CreateArtworkDto
     */
    'sourceKey': string;
    /**
     * 
     * @type {string}
     * @memberof CreateArtworkDto
     */
    'displayKey'?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateArtworkDto
     */
    'thumbKey'?: string;
    /**
     * 
     * @type {number}
     * @memberof CreateArtworkDto
     */
    'widthPx': number;
    /**
     * 
     * @type {number}
     * @memberof CreateArtworkDto
     */
    'heightPx': number;
    /**
     * 
     * @type {string}
     * @memberof CreateArtworkDto
     */
    'licence': CreateArtworkDtoLicenceEnum;
    /**
     * 
     * @type {string}
     * @memberof CreateArtworkDto
     */
    'rightsHolder'?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateArtworkDto
     */
    'attribution'?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateArtworkDto
     */
    'sourceUrl'?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateArtworkDto
     */
    'contributorId'?: string;
    /**
     * 
     * @type {number}
     * @memberof CreateArtworkDto
     */
    'royaltyBps'?: number;
    /**
     * 
     * @type {Array<string>}
     * @memberof CreateArtworkDto
     */
    'tags'?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof CreateArtworkDto
     */
    'collectionIds'?: Array<string>;
    /**
     * 
     * @type {boolean}
     * @memberof CreateArtworkDto
     */
    'featured'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CreateArtworkDto
     */
    'active'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof CreateArtworkDto
     */
    'sortOrder'?: number;
}

export const CreateArtworkDtoKindEnum = {
    Art: 'ART',
    Photo: 'PHOTO'
} as const;

export type CreateArtworkDtoKindEnum = typeof CreateArtworkDtoKindEnum[keyof typeof CreateArtworkDtoKindEnum];
export const CreateArtworkDtoLicenceEnum = {
    PublicDomain: 'PUBLIC_DOMAIN',
    Contributor: 'CONTRIBUTOR'
} as const;

export type CreateArtworkDtoLicenceEnum = typeof CreateArtworkDtoLicenceEnum[keyof typeof CreateArtworkDtoLicenceEnum];

/**
 * 
 * @export
 * @interface CreateBannerMessageDto
 */
export interface CreateBannerMessageDto {
    /**
     * Localized message
     * @type {object}
     * @memberof CreateBannerMessageDto
     */
    'message': object;
    /**
     * Date until the message is valid
     * @type {object}
     * @memberof CreateBannerMessageDto
     */
    'validUntil': object;
    /**
     * Rank of the message
     * @type {number}
     * @memberof CreateBannerMessageDto
     */
    'rank': number;
    /**
     * Time to show the message
     * @type {number}
     * @memberof CreateBannerMessageDto
     */
    'timeToShow': number;
    /**
     * Background color of the message
     * @type {string}
     * @memberof CreateBannerMessageDto
     */
    'backGroundColor': string;
    /**
     * Text color of the message
     * @type {string}
     * @memberof CreateBannerMessageDto
     */
    'textColor': string;
    /**
     * Font size of the message
     * @type {string}
     * @memberof CreateBannerMessageDto
     */
    'fontSize': string;
}
/**
 * 
 * @export
 * @interface CreateBundleDto
 */
export interface CreateBundleDto {
    /**
     * At most 60 characters per locale.
     * @type {object}
     * @memberof CreateBundleDto
     */
    'name': object;
    /**
     * 
     * @type {object}
     * @memberof CreateBundleDto
     */
    'description'?: object | null;
    /**
     * 
     * @type {string}
     * @memberof CreateBundleDto
     */
    'imageKey'?: string | null;
    /**
     * EUR minor units
     * @type {number}
     * @memberof CreateBundleDto
     */
    'price'?: number | null;
    /**
     * 
     * @type {object}
     * @memberof CreateBundleDto
     */
    'priceCurrencies'?: object;
    /**
     * 
     * @type {string}
     * @memberof CreateBundleDto
     */
    'channel'?: CreateBundleDtoChannelEnum;
    /**
     * 
     * @type {boolean}
     * @memberof CreateBundleDto
     */
    'active'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof CreateBundleDto
     */
    'startsAt'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateBundleDto
     */
    'endsAt'?: string | null;
    /**
     * Kuponi dovoljeni; default false
     * @type {boolean}
     * @memberof CreateBundleDto
     */
    'couponsAllowed'?: boolean;
    /**
     * Večkrat v naročilu; default true
     * @type {boolean}
     * @memberof CreateBundleDto
     */
    'repeatable'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof CreateBundleDto
     */
    'sortOrder'?: number;
    /**
     * 
     * @type {Array<BundleSlotInputDto>}
     * @memberof CreateBundleDto
     */
    'slots': Array<BundleSlotInputDto>;
}

export const CreateBundleDtoChannelEnum = {
    All: 'ALL',
    Web: 'WEB',
    Mobile: 'MOBILE'
} as const;

export type CreateBundleDtoChannelEnum = typeof CreateBundleDtoChannelEnum[keyof typeof CreateBundleDtoChannelEnum];

/**
 * 
 * @export
 * @interface CreateCancelRequestDto
 */
export interface CreateCancelRequestDto {
    /**
     * 
     * @type {CancelRequestReason}
     * @memberof CreateCancelRequestDto
     */
    'reason'?: CancelRequestReason;
    /**
     * 
     * @type {string}
     * @memberof CreateCancelRequestDto
     */
    'note'?: string;
}


/**
 * 
 * @export
 * @interface CreateCashbackPromotionDto
 */
export interface CreateCashbackPromotionDto {
    /**
     * 
     * @type {string}
     * @memberof CreateCashbackPromotionDto
     */
    'name': string;
    /**
     * Basis points: 1000 = 10 %.
     * @type {number}
     * @memberof CreateCashbackPromotionDto
     */
    'rateBp': number;
    /**
     * 
     * @type {number}
     * @memberof CreateCashbackPromotionDto
     */
    'lotLifetimeDays': number;
    /**
     * Per currency (eur, pln, czk, ron): { minimumCents, capCents | null }.
     * @type {{ [key: string]: any; }}
     * @memberof CreateCashbackPromotionDto
     */
    'currencyRules': { [key: string]: any; };
    /**
     * 
     * @type {string}
     * @memberof CreateCashbackPromotionDto
     */
    'startsAt': string;
    /**
     * 
     * @type {string}
     * @memberof CreateCashbackPromotionDto
     */
    'endsAt': string;
    /**
     * 
     * @type {CashbackPromotionChannel}
     * @memberof CreateCashbackPromotionDto
     */
    'channel'?: CashbackPromotionChannel;
}


/**
 * 
 * @export
 * @interface CreateCouponDto
 */
export interface CreateCouponDto {
    /**
     * Date until the coupon is valid
     * @type {object}
     * @memberof CreateCouponDto
     */
    'validUntil': object;
    /**
     * Unique code of the coupon
     * @type {string}
     * @memberof CreateCouponDto
     */
    'code': string;
    /**
     * Discount percentage or amount
     * @type {number}
     * @memberof CreateCouponDto
     */
    'discount': number;
    /**
     * Coupon type
     * @type {string}
     * @memberof CreateCouponDto
     */
    'type'?: string;
    /**
     * Description of the coupon
     * @type {string}
     * @memberof CreateCouponDto
     */
    'description': string;
    /**
     * Free shipping
     * @type {boolean}
     * @memberof CreateCouponDto
     */
    'freeShipping'?: boolean;
    /**
     * Minimum amount of the order
     * @type {number}
     * @memberof CreateCouponDto
     */
    'minimumAmount': number;
    /**
     * Minimum amount of the order
     * @type {number}
     * @memberof CreateCouponDto
     */
    'minimumAmountShipping': number;
    /**
     * Maximum discount amount of the order
     * @type {object}
     * @memberof CreateCouponDto
     */
    'maximumDiscountAmount'?: object;
    /**
     * Applicable photo sizes IDs
     * @type {Array<string>}
     * @memberof CreateCouponDto
     */
    'photoSizesIds'?: Array<string>;
    /**
     * Applicable currencies
     * @type {Array<string>}
     * @memberof CreateCouponDto
     */
    'currencies'?: Array<string>;
    /**
     * 
     * @type {CouponRewardType}
     * @memberof CreateCouponDto
     */
    'rewardType'?: CouponRewardType;
    /**
     * CASHBACK only: days the granted credit stays usable.
     * @type {number}
     * @memberof CreateCouponDto
     */
    'cashbackLifetimeDays'?: number;
}


/**
 * 
 * @export
 * @interface CreateCreditNoteDto
 */
export interface CreateCreditNoteDto {
    /**
     * Original invoice ID to create credit note for
     * @type {string}
     * @memberof CreateCreditNoteDto
     */
    'originalInvoiceId': string;
    /**
     * Reason for credit note
     * @type {string}
     * @memberof CreateCreditNoteDto
     */
    'reason': string;
    /**
     * Optional reference number
     * @type {string}
     * @memberof CreateCreditNoteDto
     */
    'referenceNumber'?: string;
}
/**
 * 
 * @export
 * @interface CreateElementImageDto
 */
export interface CreateElementImageDto {
    /**
     * 
     * @type {string}
     * @memberof CreateElementImageDto
     */
    'key': string;
    /**
     * Localized name { locale: string }
     * @type {object}
     * @memberof CreateElementImageDto
     */
    'name': object;
    /**
     * 
     * @type {string}
     * @memberof CreateElementImageDto
     */
    'category'?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateElementImageDto
     */
    'mimeType'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof CreateElementImageDto
     */
    'active'?: boolean;
    /**
     * 
     * @type {Array<string>}
     * @memberof CreateElementImageDto
     */
    'keywords'?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof CreateElementImageDto
     */
    'type'?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateElementImageDto
     */
    'style'?: string;
}
/**
 * 
 * @export
 * @interface CreateEmailCampaignDto
 */
export interface CreateEmailCampaignDto {
    /**
     * Target country code (e.g., SI, DE, IT)
     * @type {string}
     * @memberof CreateEmailCampaignDto
     */
    'targetCountry': string;
    /**
     * Company name to display in the email
     * @type {string}
     * @memberof CreateEmailCampaignDto
     */
    'companyName': string;
    /**
     * Email subject line
     * @type {string}
     * @memberof CreateEmailCampaignDto
     */
    'subject': string;
    /**
     * HTML content of the email
     * @type {string}
     * @memberof CreateEmailCampaignDto
     */
    'htmlContent': string;
    /**
     * Optional custom mailing list. If not provided, will extract emails from orders in the target country.
     * @type {Array<string>}
     * @memberof CreateEmailCampaignDto
     */
    'customMailingList'?: Array<string>;
}
/**
 * 
 * @export
 * @interface CreateEmailRuleDto
 */
export interface CreateEmailRuleDto {
    /**
     * 
     * @type {string}
     * @memberof CreateEmailRuleDto
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof CreateEmailRuleDto
     */
    'templateKey': string;
    /**
     * 
     * @type {string}
     * @memberof CreateEmailRuleDto
     */
    'trigger': CreateEmailRuleDtoTriggerEnum;
    /**
     * 
     * @type {number}
     * @memberof CreateEmailRuleDto
     */
    'delayHours': number;
    /**
     * 
     * @type {number}
     * @memberof CreateEmailRuleDto
     */
    'maxDelayHours'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof CreateEmailRuleDto
     */
    'fireAtHour'?: number | null;
    /**
     * 
     * @type {object}
     * @memberof CreateEmailRuleDto
     */
    'conditions'?: object | null;
    /**
     * 
     * @type {boolean}
     * @memberof CreateEmailRuleDto
     */
    'oncePerRecipient'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CreateEmailRuleDto
     */
    'promotional'?: boolean;
    /**
     * Dedupe cooldown in days. Null = never re-fire; promotional rules with null fall back to 90.
     * @type {number}
     * @memberof CreateEmailRuleDto
     */
    'dedupeWindowDays'?: number | null;
    /**
     * Skip an order whose customer paid for a newer order since the anchor.
     * @type {boolean}
     * @memberof CreateEmailRuleDto
     */
    'stopIfReordered'?: boolean;
    /**
     * Send only while the recipient holds unspent granted credit (expiry reminder).
     * @type {boolean}
     * @memberof CreateEmailRuleDto
     */
    'requireUnspentCredit'?: boolean;
    /**
     * Mint a credit lot when the rule fires: { amountsByCurrency: { eur: 500 }, lifetimeDays: 14, minimumByCurrency?: { eur: 1500 } }, minor units.
     * @type {object}
     * @memberof CreateEmailRuleDto
     */
    'grantCredit'?: object | null;
    /**
     * 
     * @type {boolean}
     * @memberof CreateEmailRuleDto
     */
    'active'?: boolean;
}

export const CreateEmailRuleDtoTriggerEnum = {
    OrderCreated: 'ORDER_CREATED',
    OrderPaid: 'ORDER_PAID',
    OrderShipped: 'ORDER_SHIPPED',
    OrderDelivered: 'ORDER_DELIVERED',
    OrderCanceled: 'ORDER_CANCELED',
    PaymentUnfinished: 'PAYMENT_UNFINISHED'
} as const;

export type CreateEmailRuleDtoTriggerEnum = typeof CreateEmailRuleDtoTriggerEnum[keyof typeof CreateEmailRuleDtoTriggerEnum];

/**
 * 
 * @export
 * @interface CreateEmailTemplateDto
 */
export interface CreateEmailTemplateDto {
    /**
     * 
     * @type {string}
     * @memberof CreateEmailTemplateDto
     */
    'key': string;
    /**
     * 
     * @type {string}
     * @memberof CreateEmailTemplateDto
     */
    'locale': string;
    /**
     * 
     * @type {string}
     * @memberof CreateEmailTemplateDto
     */
    'subject': string;
    /**
     * 
     * @type {string}
     * @memberof CreateEmailTemplateDto
     */
    'htmlBody': string;
    /**
     * 
     * @type {string}
     * @memberof CreateEmailTemplateDto
     */
    'textBody'?: string | null;
}
/**
 * 
 * @export
 * @interface CreateGiftCardOrderDto
 */
export interface CreateGiftCardOrderDto {
    /**
     * Minor units; one of the market\'s amounts.
     * @type {number}
     * @memberof CreateGiftCardOrderDto
     */
    'amountCents': number;
    /**
     * The buyer; receives the card and the invoice.
     * @type {string}
     * @memberof CreateGiftCardOrderDto
     */
    'email': string;
    /**
     * \"Za\" on the card; trimmed, max 40.
     * @type {string}
     * @memberof CreateGiftCardOrderDto
     */
    'toName'?: string;
    /**
     * \"Od\" on the card; trimmed, max 40.
     * @type {string}
     * @memberof CreateGiftCardOrderDto
     */
    'fromName'?: string;
    /**
     * Message on the card; trimmed, max 200.
     * @type {string}
     * @memberof CreateGiftCardOrderDto
     */
    'message'?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateGiftCardOrderDto
     */
    'languagePreference'?: string;
    /**
     * The storefront host; decides market and currency.
     * @type {string}
     * @memberof CreateGiftCardOrderDto
     */
    'domain': string;
}
/**
 * 
 * @export
 * @interface CreateInviteDto
 */
export interface CreateInviteDto {
    /**
     * 
     * @type {string}
     * @memberof CreateInviteDto
     */
    'role': CreateInviteDtoRoleEnum;
}

export const CreateInviteDtoRoleEnum = {
    Organizer: 'organizer',
    Photographer: 'photographer'
} as const;

export type CreateInviteDtoRoleEnum = typeof CreateInviteDtoRoleEnum[keyof typeof CreateInviteDtoRoleEnum];

/**
 * 
 * @export
 * @interface CreateInvoiceFromOrderDto
 */
export interface CreateInvoiceFromOrderDto {
    /**
     * Order ID to create invoice from
     * @type {string}
     * @memberof CreateInvoiceFromOrderDto
     */
    'orderId': string;
    /**
     * 
     * @type {InvoiceOverridesDto}
     * @memberof CreateInvoiceFromOrderDto
     */
    'overrides'?: InvoiceOverridesDto;
}
/**
 * 
 * @export
 * @interface CreateManyArtworkCollectionDto
 */
export interface CreateManyArtworkCollectionDto {
    /**
     * 
     * @type {Array<object>}
     * @memberof CreateManyArtworkCollectionDto
     */
    'bulk': Array<object>;
}
/**
 * 
 * @export
 * @interface CreateManyArtworkDto
 */
export interface CreateManyArtworkDto {
    /**
     * 
     * @type {Array<CreateArtworkDto>}
     * @memberof CreateManyArtworkDto
     */
    'bulk': Array<CreateArtworkDto>;
}
/**
 * 
 * @export
 * @interface CreateManyBannerMessageDto
 */
export interface CreateManyBannerMessageDto {
    /**
     * 
     * @type {Array<CreateBannerMessageDto>}
     * @memberof CreateManyBannerMessageDto
     */
    'bulk': Array<CreateBannerMessageDto>;
}
/**
 * 
 * @export
 * @interface CreateManyElementImageDto
 */
export interface CreateManyElementImageDto {
    /**
     * 
     * @type {Array<CreateElementImageDto>}
     * @memberof CreateManyElementImageDto
     */
    'bulk': Array<CreateElementImageDto>;
}
/**
 * 
 * @export
 * @interface CreateManyEmailRuleDto
 */
export interface CreateManyEmailRuleDto {
    /**
     * 
     * @type {Array<CreateEmailRuleDto>}
     * @memberof CreateManyEmailRuleDto
     */
    'bulk': Array<CreateEmailRuleDto>;
}
/**
 * 
 * @export
 * @interface CreateManyEmailTemplateDto
 */
export interface CreateManyEmailTemplateDto {
    /**
     * 
     * @type {Array<CreateEmailTemplateDto>}
     * @memberof CreateManyEmailTemplateDto
     */
    'bulk': Array<CreateEmailTemplateDto>;
}
/**
 * 
 * @export
 * @interface CreateManyOrderCalendarDto
 */
export interface CreateManyOrderCalendarDto {
    /**
     * 
     * @type {Array<CreateOrderCalendarDto>}
     * @memberof CreateManyOrderCalendarDto
     */
    'bulk': Array<CreateOrderCalendarDto>;
}
/**
 * 
 * @export
 * @interface CreateManyOrderProductDetailDto
 */
export interface CreateManyOrderProductDetailDto {
    /**
     * 
     * @type {Array<CreateOrderProductDetailDto>}
     * @memberof CreateManyOrderProductDetailDto
     */
    'bulk': Array<CreateOrderProductDetailDto>;
}
/**
 * 
 * @export
 * @interface CreateManyPaperDto
 */
export interface CreateManyPaperDto {
    /**
     * 
     * @type {Array<CreatePaperDto>}
     * @memberof CreateManyPaperDto
     */
    'bulk': Array<CreatePaperDto>;
}
/**
 * 
 * @export
 * @interface CreateManyPhotoSizeDto
 */
export interface CreateManyPhotoSizeDto {
    /**
     * 
     * @type {Array<CreatePhotoSizeDto>}
     * @memberof CreateManyPhotoSizeDto
     */
    'bulk': Array<CreatePhotoSizeDto>;
}
/**
 * 
 * @export
 * @interface CreateManyPostDto
 */
export interface CreateManyPostDto {
    /**
     * 
     * @type {Array<CreatePostDto>}
     * @memberof CreateManyPostDto
     */
    'bulk': Array<CreatePostDto>;
}
/**
 * 
 * @export
 * @interface CreateManyProductDto
 */
export interface CreateManyProductDto {
    /**
     * 
     * @type {Array<CreateProductDto>}
     * @memberof CreateManyProductDto
     */
    'bulk': Array<CreateProductDto>;
}
/**
 * 
 * @export
 * @interface CreateManyProductTagDto
 */
export interface CreateManyProductTagDto {
    /**
     * 
     * @type {Array<CreateProductTagDto>}
     * @memberof CreateManyProductTagDto
     */
    'bulk': Array<CreateProductTagDto>;
}
/**
 * 
 * @export
 * @interface CreateManyProductWithMediaDefinitionDto
 */
export interface CreateManyProductWithMediaDefinitionDto {
    /**
     * 
     * @type {Array<CreateProductWithMediaDefinitionDto>}
     * @memberof CreateManyProductWithMediaDefinitionDto
     */
    'bulk': Array<CreateProductWithMediaDefinitionDto>;
}
/**
 * 
 * @export
 * @interface CreateManyProductWithMediaOrderDto
 */
export interface CreateManyProductWithMediaOrderDto {
    /**
     * 
     * @type {Array<CreateProductWithMediaOrderDto>}
     * @memberof CreateManyProductWithMediaOrderDto
     */
    'bulk': Array<CreateProductWithMediaOrderDto>;
}
/**
 * 
 * @export
 * @interface CreateManyProductWithMediaVariantDto
 */
export interface CreateManyProductWithMediaVariantDto {
    /**
     * 
     * @type {Array<CreateProductWithMediaVariantDto>}
     * @memberof CreateManyProductWithMediaVariantDto
     */
    'bulk': Array<CreateProductWithMediaVariantDto>;
}
/**
 * 
 * @export
 * @interface CreateManyTemplateDto
 */
export interface CreateManyTemplateDto {
    /**
     * 
     * @type {Array<CreateTemplateDto>}
     * @memberof CreateManyTemplateDto
     */
    'bulk': Array<CreateTemplateDto>;
}
/**
 * 
 * @export
 * @interface CreateOrderCalendarDto
 */
export interface CreateOrderCalendarDto {
    /**
     * 
     * @type {string}
     * @memberof CreateOrderCalendarDto
     */
    'format': CreateOrderCalendarDtoFormatEnum;
    /**
     * 
     * @type {number}
     * @memberof CreateOrderCalendarDto
     */
    'quantity': number;
    /**
     * Optional calendar settings from frontend
     * @type {object}
     * @memberof CreateOrderCalendarDto
     */
    'calendarData'?: object;
    /**
     * Calendar paper; defaults to \'white\'. Only orderable papers are accepted.
     * @type {string}
     * @memberof CreateOrderCalendarDto
     */
    'paper'?: CreateOrderCalendarDtoPaperEnum;
}

export const CreateOrderCalendarDtoFormatEnum = {
    A2: 'A2',
    A3: 'A3',
    A4: 'A4',
    A5: 'A5',
    PlannerA3: 'PLANNER_A3',
    SpreadA4: 'SPREAD_A4'
} as const;

export type CreateOrderCalendarDtoFormatEnum = typeof CreateOrderCalendarDtoFormatEnum[keyof typeof CreateOrderCalendarDtoFormatEnum];
export const CreateOrderCalendarDtoPaperEnum = {
    White: 'white'
} as const;

export type CreateOrderCalendarDtoPaperEnum = typeof CreateOrderCalendarDtoPaperEnum[keyof typeof CreateOrderCalendarDtoPaperEnum];

/**
 * 
 * @export
 * @interface CreateOrderDto
 */
export interface CreateOrderDto {
    /**
     * Status of the order
     * @type {string}
     * @memberof CreateOrderDto
     */
    'status': string;
    /**
     * Photo size ID
     * @type {string}
     * @memberof CreateOrderDto
     */
    'photoSizeId': string;
    /**
     * User ID of the order owner
     * @type {string}
     * @memberof CreateOrderDto
     */
    'userId': string;
    /**
     * Total amount of the order
     * @type {number}
     * @memberof CreateOrderDto
     */
    'amount': number;
    /**
     * Coupon ID used for the order
     * @type {string}
     * @memberof CreateOrderDto
     */
    'couponUsedId'?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateOrderDto
     */
    'shippingAddress1': string;
    /**
     * 
     * @type {string}
     * @memberof CreateOrderDto
     */
    'shippingAddress2': string;
    /**
     * 
     * @type {string}
     * @memberof CreateOrderDto
     */
    'shippingCity': string;
    /**
     * 
     * @type {string}
     * @memberof CreateOrderDto
     */
    'shippingZip': string;
    /**
     * 
     * @type {string}
     * @memberof CreateOrderDto
     */
    'shippingCountry': string;
    /**
     * 
     * @type {string}
     * @memberof CreateOrderDto
     */
    'shippingState': string;
    /**
     * 
     * @type {string}
     * @memberof CreateOrderDto
     */
    'shippingPhone': string;
    /**
     * 
     * @type {string}
     * @memberof CreateOrderDto
     */
    'shippingEmail': string;
    /**
     * 
     * @type {string}
     * @memberof CreateOrderDto
     */
    'shippingFirstName': string;
    /**
     * 
     * @type {string}
     * @memberof CreateOrderDto
     */
    'shippingLastName': string;
    /**
     * 
     * @type {string}
     * @memberof CreateOrderDto
     */
    'shippingMethod': string;
    /**
     * 
     * @type {string}
     * @memberof CreateOrderDto
     */
    'shippingNotes': string;
    /**
     * 
     * @type {number}
     * @memberof CreateOrderDto
     */
    'shippingPrice': number;
    /**
     * 
     * @type {string}
     * @memberof CreateOrderDto
     */
    'paymentOption': string;
    /**
     * 
     * @type {string}
     * @memberof CreateOrderDto
     */
    'ipAddress': string;
    /**
     * 
     * @type {string}
     * @memberof CreateOrderDto
     */
    'userAgent': string;
    /**
     * 
     * @type {string}
     * @memberof CreateOrderDto
     */
    'fbc': string;
    /**
     * 
     * @type {string}
     * @memberof CreateOrderDto
     */
    'fbp': string;
    /**
     * Google Ads click identifier (gclid/gbraid/wbraid) captured from landing URL
     * @type {string}
     * @memberof CreateOrderDto
     */
    'gclid'?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateOrderDto
     */
    'currency': string;
    /**
     * 
     * @type {number}
     * @memberof CreateOrderDto
     */
    'downlink': number | null;
    /**
     * 
     * @type {string}
     * @memberof CreateOrderDto
     */
    'domain': string | null;
    /**
     * Order origin channel, e.g. \'WEB\' or \'MOBILE\'. Admin-only endpoint, so the explicit value is trusted: an operator placing an order for a customer knows the channel better than the request header does. Customer order creation ignores the body and derives it from the X-Client-Channel header instead.
     * @type {string}
     * @memberof CreateOrderDto
     */
    'orderSource'?: string | null;
}
/**
 * 
 * @export
 * @interface CreateOrderProductDetailDto
 */
export interface CreateOrderProductDetailDto {
    /**
     * IDs of order
     * @type {string}
     * @memberof CreateOrderProductDetailDto
     */
    'orderId': string;
    /**
     * ID of the product
     * @type {string}
     * @memberof CreateOrderProductDetailDto
     */
    'productId': string;
    /**
     * Quantity of the product
     * @type {number}
     * @memberof CreateOrderProductDetailDto
     */
    'quantity': number;
}
/**
 * 
 * @export
 * @interface CreatePaperDto
 */
export interface CreatePaperDto {
    /**
     * Localized name { locale: string }
     * @type {object}
     * @memberof CreatePaperDto
     */
    'name': object;
    /**
     * Hex colour code, e.g. \"#FFFFFF\"
     * @type {string}
     * @memberof CreatePaperDto
     */
    'colorHex': string;
    /**
     * Object key of the paper background image (not a URL)
     * @type {string}
     * @memberof CreatePaperDto
     */
    'backgroundImage'?: string | null;
    /**
     * Weight in g/m²
     * @type {number}
     * @memberof CreatePaperDto
     */
    'weightGsm'?: number;
    /**
     * Price in integer cents
     * @type {number}
     * @memberof CreatePaperDto
     */
    'price': number;
    /**
     * 
     * @type {object}
     * @memberof CreatePaperDto
     */
    'priceCurrencies'?: object;
    /**
     * 
     * @type {boolean}
     * @memberof CreatePaperDto
     */
    'active'?: boolean;
    /**
     * Display/pick order (ascending); lowest is the editor default
     * @type {number}
     * @memberof CreatePaperDto
     */
    'sortOrder'?: number;
}
/**
 * 
 * @export
 * @interface CreatePartyDto
 */
export interface CreatePartyDto {
    /**
     * 
     * @type {string}
     * @memberof CreatePartyDto
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof CreatePartyDto
     */
    'kind': CreatePartyDtoKindEnum;
    /**
     * 
     * @type {string}
     * @memberof CreatePartyDto
     */
    'startsAt': string;
    /**
     * Who takes the photos
     * @type {string}
     * @memberof CreatePartyDto
     */
    'whoShoots'?: CreatePartyDtoWhoShootsEnum;
    /**
     * What the creator is on this event
     * @type {string}
     * @memberof CreatePartyDto
     */
    'creatorRole'?: CreatePartyDtoCreatorRoleEnum;
    /**
     * Required unless whoShoots is photographers (then forced live)
     * @type {string}
     * @memberof CreatePartyDto
     */
    'revealMode': CreatePartyDtoRevealModeEnum;
    /**
     * Required for scheduled reveal; ignored when whoShoots is photographers
     * @type {string}
     * @memberof CreatePartyDto
     */
    'revealAt'?: string;
    /**
     * null = unlimited; ignored when whoShoots is photographers
     * @type {number}
     * @memberof CreatePartyDto
     */
    'shotsPerGuest'?: CreatePartyDtoShotsPerGuestEnum;
    /**
     * 
     * @type {string}
     * @memberof CreatePartyDto
     */
    'market': string;
    /**
     * 
     * @type {string}
     * @memberof CreatePartyDto
     */
    'currency': string;
    /**
     * 
     * @type {string}
     * @memberof CreatePartyDto
     */
    'hostMessage'?: string;
}

export const CreatePartyDtoKindEnum = {
    Wedding: 'wedding',
    Birthday: 'birthday',
    Party: 'party',
    Company: 'company',
    Other: 'other'
} as const;

export type CreatePartyDtoKindEnum = typeof CreatePartyDtoKindEnum[keyof typeof CreatePartyDtoKindEnum];
export const CreatePartyDtoWhoShootsEnum = {
    Guests: 'guests',
    Photographers: 'photographers',
    Both: 'both'
} as const;

export type CreatePartyDtoWhoShootsEnum = typeof CreatePartyDtoWhoShootsEnum[keyof typeof CreatePartyDtoWhoShootsEnum];
export const CreatePartyDtoCreatorRoleEnum = {
    Organizer: 'organizer',
    Photographer: 'photographer'
} as const;

export type CreatePartyDtoCreatorRoleEnum = typeof CreatePartyDtoCreatorRoleEnum[keyof typeof CreatePartyDtoCreatorRoleEnum];
export const CreatePartyDtoRevealModeEnum = {
    Scheduled: 'scheduled',
    Live: 'live'
} as const;

export type CreatePartyDtoRevealModeEnum = typeof CreatePartyDtoRevealModeEnum[keyof typeof CreatePartyDtoRevealModeEnum];
export const CreatePartyDtoShotsPerGuestEnum = {
    NUMBER_10: 10,
    NUMBER_15: 15,
    NUMBER_25: 25,
    NUMBER_null: null
} as const;

export type CreatePartyDtoShotsPerGuestEnum = typeof CreatePartyDtoShotsPerGuestEnum[keyof typeof CreatePartyDtoShotsPerGuestEnum];

/**
 * 
 * @export
 * @interface CreatePhotoSizeDto
 */
export interface CreatePhotoSizeDto {
    /**
     * Localized names of the photo size
     * @type {object}
     * @memberof CreatePhotoSizeDto
     */
    'name': object;
    /**
     * Pixel width of the photo
     * @type {number}
     * @memberof CreatePhotoSizeDto
     */
    'pixelWidth'?: number;
    /**
     * Pixel height of the photo
     * @type {number}
     * @memberof CreatePhotoSizeDto
     */
    'pixelHeight'?: number;
    /**
     * Format of the photo
     * @type {string}
     * @memberof CreatePhotoSizeDto
     */
    'format': string;
    /**
     * Physical width of the photo
     * @type {number}
     * @memberof CreatePhotoSizeDto
     */
    'width': number;
    /**
     * Physical height of the photo
     * @type {number}
     * @memberof CreatePhotoSizeDto
     */
    'height': number;
    /**
     * Price of the photo
     * @type {number}
     * @memberof CreatePhotoSizeDto
     */
    'price': number;
    /**
     * Factory price of the photo
     * @type {number}
     * @memberof CreatePhotoSizeDto
     */
    'factoryPrice'?: number;
    /**
     * Type of paper used for the photo
     * @type {string}
     * @memberof CreatePhotoSizeDto
     */
    'paper'?: string;
    /**
     * Pricing ladder for the photo size
     * @type {Array<PriceRangeDto>}
     * @memberof CreatePhotoSizeDto
     */
    'pricingLadder': Array<PriceRangeDto>;
    /**
     * Pricing ladder for different currencies
     * @type {object}
     * @memberof CreatePhotoSizeDto
     */
    'pricingLadderCurrencies': object;
    /**
     * Prices in different currencies
     * @type {object}
     * @memberof CreatePhotoSizeDto
     */
    'priceCurrencies': object;
    /**
     * Whether premium paper is available for this photo size
     * @type {boolean}
     * @memberof CreatePhotoSizeDto
     */
    'premiumPaperAvailable'?: boolean;
    /**
     * Premium paper price per photo in cents (default 5 cents)
     * @type {number}
     * @memberof CreatePhotoSizeDto
     */
    'premiumPaperPrice'?: number;
    /**
     * Premium paper prices in different currencies (in cents)
     * @type {object}
     * @memberof CreatePhotoSizeDto
     */
    'premiumPaperPriceCurrencies'?: object;
    /**
     * Whether white border is available for this photo size
     * @type {boolean}
     * @memberof CreatePhotoSizeDto
     */
    'whiteBorderAvailable'?: boolean;
    /**
     * White border price per photo in cents (default 5 cents)
     * @type {number}
     * @memberof CreatePhotoSizeDto
     */
    'whiteBorderPrice'?: number;
    /**
     * White border prices in different currencies (in cents)
     * @type {object}
     * @memberof CreatePhotoSizeDto
     */
    'whiteBorderPriceCurrencies'?: object;
    /**
     * Whether black and white conversion is available for this photo size
     * @type {boolean}
     * @memberof CreatePhotoSizeDto
     */
    'blackAndWhiteAvailable'?: boolean;
    /**
     * Black and white price per photo in cents (default 5 cents)
     * @type {number}
     * @memberof CreatePhotoSizeDto
     */
    'blackAndWhitePrice'?: number;
    /**
     * Black and white prices in different currencies (in cents)
     * @type {object}
     * @memberof CreatePhotoSizeDto
     */
    'blackAndWhitePriceCurrencies'?: object;
    /**
     * Optional preview photo id shown on the photo-size selector in the order flow
     * @type {string}
     * @memberof CreatePhotoSizeDto
     */
    'previewPhotoId'?: string;
    /**
     * When true, this size is hidden from the public photo-size list (promotional). Default false.
     * @type {boolean}
     * @memberof CreatePhotoSizeDto
     */
    'hidden'?: boolean;
    /**
     * Optional id of another photo size to compare against for combo savings (struck-through normal price)
     * @type {string}
     * @memberof CreatePhotoSizeDto
     */
    'compareAtPhotoSizeId'?: string;
}
/**
 * 
 * @export
 * @interface CreatePostDto
 */
export interface CreatePostDto {
    /**
     * 
     * @type {string}
     * @memberof CreatePostDto
     */
    'category': CreatePostDtoCategoryEnum;
    /**
     * 
     * @type {{ [key: string]: string; }}
     * @memberof CreatePostDto
     */
    'title': { [key: string]: string; };
    /**
     * 
     * @type {{ [key: string]: string; }}
     * @memberof CreatePostDto
     */
    'excerpt': { [key: string]: string; };
    /**
     * 
     * @type {{ [key: string]: string; }}
     * @memberof CreatePostDto
     */
    'body': { [key: string]: string; };
    /**
     * 
     * @type {{ [key: string]: string; }}
     * @memberof CreatePostDto
     */
    'imageUrl'?: { [key: string]: string; };
    /**
     * 
     * @type {{ [key: string]: string; }}
     * @memberof CreatePostDto
     */
    'ctaUrl'?: { [key: string]: string; };
    /**
     * 
     * @type {{ [key: string]: string; }}
     * @memberof CreatePostDto
     */
    'ctaLabel'?: { [key: string]: string; };
    /**
     * 
     * @type {Array<string>}
     * @memberof CreatePostDto
     */
    'audience'?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof CreatePostDto
     */
    'publishedAt'?: string;
    /**
     * 
     * @type {string}
     * @memberof CreatePostDto
     */
    'expiresAt'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof CreatePostDto
     */
    'active'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CreatePostDto
     */
    'pinned'?: boolean;
}

export const CreatePostDtoCategoryEnum = {
    News: 'news',
    Promo: 'promo',
    Tip: 'tip',
    Update: 'update'
} as const;

export type CreatePostDtoCategoryEnum = typeof CreatePostDtoCategoryEnum[keyof typeof CreatePostDtoCategoryEnum];

/**
 * 
 * @export
 * @interface CreatePricingOverrideDto
 */
export interface CreatePricingOverrideDto {
    /**
     * 
     * @type {string}
     * @memberof CreatePricingOverrideDto
     */
    'key': CreatePricingOverrideDtoKeyEnum;
    /**
     * 
     * @type {string}
     * @memberof CreatePricingOverrideDto
     */
    'scope': CreatePricingOverrideDtoScopeEnum;
    /**
     * 
     * @type {string}
     * @memberof CreatePricingOverrideDto
     */
    'scopeValue': string;
    /**
     * 
     * @type {string}
     * @memberof CreatePricingOverrideDto
     */
    'channel'?: CreatePricingOverrideDtoChannelEnum;
    /**
     * Minor units, >= 0. Null reverts this slot to the built-in default. Zero is a real value meaning \"no threshold\".
     * @type {number}
     * @memberof CreatePricingOverrideDto
     */
    'valueCents'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof CreatePricingOverrideDto
     */
    'reason'?: string;
}

export const CreatePricingOverrideDtoKeyEnum = {
    FreeShippingThreshold: 'freeShippingThreshold',
    CodFee: 'codFee',
    CodMinimum: 'codMinimum',
    EcoPackaging: 'ecoPackaging',
    PriorityComplaint: 'priorityComplaint',
    GiftWrap: 'giftWrap',
    ProfessionalCrop: 'professionalCrop'
} as const;

export type CreatePricingOverrideDtoKeyEnum = typeof CreatePricingOverrideDtoKeyEnum[keyof typeof CreatePricingOverrideDtoKeyEnum];
export const CreatePricingOverrideDtoScopeEnum = {
    Currency: 'currency',
    Market: 'market'
} as const;

export type CreatePricingOverrideDtoScopeEnum = typeof CreatePricingOverrideDtoScopeEnum[keyof typeof CreatePricingOverrideDtoScopeEnum];
export const CreatePricingOverrideDtoChannelEnum = {
    Mobile: 'MOBILE'
} as const;

export type CreatePricingOverrideDtoChannelEnum = typeof CreatePricingOverrideDtoChannelEnum[keyof typeof CreatePricingOverrideDtoChannelEnum];

/**
 * 
 * @export
 * @interface CreateProductDto
 */
export interface CreateProductDto {
    /**
     * Localized names of the product
     * @type {object}
     * @memberof CreateProductDto
     */
    'name': object;
    /**
     * Localized descriptions of the product
     * @type {object}
     * @memberof CreateProductDto
     */
    'description': object;
    /**
     * Price of the product
     * @type {number}
     * @memberof CreateProductDto
     */
    'price': number;
    /**
     * Price in different currencies
     * @type {object}
     * @memberof CreateProductDto
     */
    'priceCurrencies': object | null;
    /**
     * IDs of photos associated with the product
     * @type {Array<string>}
     * @memberof CreateProductDto
     */
    'photoIds'?: Array<string>;
    /**
     * Is the product active
     * @type {boolean}
     * @memberof CreateProductDto
     */
    'active': boolean;
    /**
     * Is the product featured
     * @type {boolean}
     * @memberof CreateProductDto
     */
    'featured': boolean;
    /**
     * Price per unit
     * @type {number}
     * @memberof CreateProductDto
     */
    'pricePerUnit': number;
    /**
     * Number of units
     * @type {number}
     * @memberof CreateProductDto
     */
    'nOfUnits': number;
    /**
     * Action price
     * @type {number}
     * @memberof CreateProductDto
     */
    'actionPrice': number | null;
    /**
     * Action price in different currencies
     * @type {object}
     * @memberof CreateProductDto
     */
    'actionPriceCurrencies': object | null;
    /**
     * Pantheon product code
     * @type {string}
     * @memberof CreateProductDto
     */
    'pantheonCode'?: string;
    /**
     * IDs of tags associated with the product
     * @type {Array<string>}
     * @memberof CreateProductDto
     */
    'tagIds'?: Array<string>;
    /**
     * Display order, lower first
     * @type {number}
     * @memberof CreateProductDto
     */
    'rank'?: number;
    /**
     * How many photos it holds
     * @type {number}
     * @memberof CreateProductDto
     */
    'capacity'?: number | null;
    /**
     * Print size, e.g. 10x15
     * @type {string}
     * @memberof CreateProductDto
     */
    'photoSize'?: string | null;
}
/**
 * 
 * @export
 * @interface CreateProductTagDto
 */
export interface CreateProductTagDto {
    /**
     * Localized names of the product tag
     * @type {object}
     * @memberof CreateProductTagDto
     */
    'name': object;
    /**
     * Localized descriptions of the product tag
     * @type {object}
     * @memberof CreateProductTagDto
     */
    'description': object;
    /**
     * 
     * @type {string}
     * @memberof CreateProductTagDto
     */
    'tag': string;
    /**
     * 
     * @type {number}
     * @memberof CreateProductTagDto
     */
    'rank': number;
}
/**
 * 
 * @export
 * @interface CreateProductWithMediaDefinitionDto
 */
export interface CreateProductWithMediaDefinitionDto {
    /**
     * Localized name { locale: string }
     * @type {object}
     * @memberof CreateProductWithMediaDefinitionDto
     */
    'name': object;
    /**
     * Localized description { locale: string }
     * @type {object}
     * @memberof CreateProductWithMediaDefinitionDto
     */
    'description': object;
    /**
     * Base price (integer, cents)
     * @type {number}
     * @memberof CreateProductWithMediaDefinitionDto
     */
    'price': number;
    /**
     * 
     * @type {object}
     * @memberof CreateProductWithMediaDefinitionDto
     */
    'priceCurrencies'?: object;
    /**
     * 
     * @type {boolean}
     * @memberof CreateProductWithMediaDefinitionDto
     */
    'active'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CreateProductWithMediaDefinitionDto
     */
    'featured'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof CreateProductWithMediaDefinitionDto
     */
    'minQuantity'?: number;
    /**
     * Product family id, e.g. \"greeting-card\"
     * @type {string}
     * @memberof CreateProductWithMediaDefinitionDto
     */
    'kind': string;
    /**
     * Declared media slots
     * @type {Array<MediaSlotDto>}
     * @memberof CreateProductWithMediaDefinitionDto
     */
    'mediaSlots': Array<MediaSlotDto>;
    /**
     * 
     * @type {string}
     * @memberof CreateProductWithMediaDefinitionDto
     */
    'previewImageKey'?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof CreateProductWithMediaDefinitionDto
     */
    'paperIds'?: Array<string>;
    /**
     * 
     * @type {Array<VariantAxisDto>}
     * @memberof CreateProductWithMediaDefinitionDto
     */
    'variantAxes'?: Array<VariantAxisDto>;
    /**
     * 
     * @type {string}
     * @memberof CreateProductWithMediaDefinitionDto
     */
    'outputFormat'?: CreateProductWithMediaDefinitionDtoOutputFormatEnum;
}

export const CreateProductWithMediaDefinitionDtoOutputFormatEnum = {
    Pdf: 'pdf',
    Tiff: 'tiff',
    Jpeg: 'jpeg'
} as const;

export type CreateProductWithMediaDefinitionDtoOutputFormatEnum = typeof CreateProductWithMediaDefinitionDtoOutputFormatEnum[keyof typeof CreateProductWithMediaDefinitionDtoOutputFormatEnum];

/**
 * 
 * @export
 * @interface CreateProductWithMediaOrderDto
 */
export interface CreateProductWithMediaOrderDto {
    /**
     * Order id
     * @type {string}
     * @memberof CreateProductWithMediaOrderDto
     */
    'orderId': string;
    /**
     * ProductWithMediaDefinition id
     * @type {string}
     * @memberof CreateProductWithMediaOrderDto
     */
    'definitionId': string;
    /**
     * 
     * @type {number}
     * @memberof CreateProductWithMediaOrderDto
     */
    'quantity': number;
    /**
     * 
     * @type {Array<MediaItemDto>}
     * @memberof CreateProductWithMediaOrderDto
     */
    'media': Array<MediaItemDto>;
    /**
     * Paper id to use for this line
     * @type {string}
     * @memberof CreateProductWithMediaOrderDto
     */
    'selectedPaperId'?: string;
    /**
     * Required when the definition declares variantAxes; omit for definitions without a variant matrix.
     * @type {string}
     * @memberof CreateProductWithMediaOrderDto
     */
    'variantId'?: string;
}
/**
 * 
 * @export
 * @interface CreateProductWithMediaVariantDto
 */
export interface CreateProductWithMediaVariantDto {
    /**
     * Owning definition id
     * @type {string}
     * @memberof CreateProductWithMediaVariantDto
     */
    'definitionId': string;
    /**
     * Operator handle, e.g. CANVAS-40x60-PLATNO-20
     * @type {string}
     * @memberof CreateProductWithMediaVariantDto
     */
    'sku': string;
    /**
     * Localized name { locale: string }
     * @type {object}
     * @memberof CreateProductWithMediaVariantDto
     */
    'name': object;
    /**
     * One value per declared axis, e.g. { size: \"40x60\" }
     * @type {object}
     * @memberof CreateProductWithMediaVariantDto
     */
    'axisValues': object;
    /**
     * { widthMm, heightMm, bleedMm, safeMm?, dpi }
     * @type {object}
     * @memberof CreateProductWithMediaVariantDto
     */
    'printSpec': object;
    /**
     * ABSOLUTE unit price, integer cents
     * @type {number}
     * @memberof CreateProductWithMediaVariantDto
     */
    'price': number;
    /**
     * 
     * @type {object}
     * @memberof CreateProductWithMediaVariantDto
     */
    'priceCurrencies'?: object;
    /**
     * Per-unit shipping surcharge, integer cents
     * @type {number}
     * @memberof CreateProductWithMediaVariantDto
     */
    'shippingCostCents'?: number;
    /**
     * 
     * @type {object}
     * @memberof CreateProductWithMediaVariantDto
     */
    'shippingCostCurrencies'?: object;
    /**
     * Cost price, integer cents
     * @type {number}
     * @memberof CreateProductWithMediaVariantDto
     */
    'factoryPriceCents'?: number;
    /**
     * Too large for a parcel locker
     * @type {boolean}
     * @memberof CreateProductWithMediaVariantDto
     */
    'oversize'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CreateProductWithMediaVariantDto
     */
    'active'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof CreateProductWithMediaVariantDto
     */
    'sortOrder'?: number;
}
/**
 * 
 * @export
 * @interface CreateTemplateDto
 */
export interface CreateTemplateDto {
    /**
     * 
     * @type {string}
     * @memberof CreateTemplateDto
     */
    'code': string;
    /**
     * 
     * @type {string}
     * @memberof CreateTemplateDto
     */
    'kind': CreateTemplateDtoKindEnum;
    /**
     * 
     * @type {Array<string>}
     * @memberof CreateTemplateDto
     */
    'categories'?: Array<CreateTemplateDtoCategoriesEnum>;
    /**
     * Localized name { locale: string }
     * @type {object}
     * @memberof CreateTemplateDto
     */
    'name': object;
    /**
     * 
     * @type {Array<object>}
     * @memberof CreateTemplateDto
     */
    'slots': Array<object>;
    /**
     * 
     * @type {Array<string>}
     * @memberof CreateTemplateDto
     */
    'paperIds'?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof CreateTemplateDto
     */
    'showcasePaperId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateTemplateDto
     */
    'thumbnailKey'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof CreateTemplateDto
     */
    'active'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof CreateTemplateDto
     */
    'sortOrder'?: number;
}

export const CreateTemplateDtoKindEnum = {
    GreetingCard: 'greeting-card',
    Invitation: 'invitation',
    Menu: 'menu'
} as const;

export type CreateTemplateDtoKindEnum = typeof CreateTemplateDtoKindEnum[keyof typeof CreateTemplateDtoKindEnum];
export const CreateTemplateDtoCategoriesEnum = {
    Birthday: 'birthday',
    Congrats: 'congrats',
    Thankyou: 'thankyou',
    Love: 'love',
    Wedding: 'wedding',
    Baby: 'baby',
    Getwell: 'getwell',
    Holiday: 'holiday',
    Sympathy: 'sympathy',
    Faith: 'faith',
    Family: 'family',
    Elegant: 'elegant',
    Modern: 'modern',
    Fun: 'fun',
    Cafe: 'cafe'
} as const;

export type CreateTemplateDtoCategoriesEnum = typeof CreateTemplateDtoCategoriesEnum[keyof typeof CreateTemplateDtoCategoriesEnum];

/**
 * 
 * @export
 * @interface CreateUserDto
 */
export interface CreateUserDto {
    /**
     * Email address of the user
     * @type {string}
     * @memberof CreateUserDto
     */
    'email': string;
    /**
     * Password of the user
     * @type {string}
     * @memberof CreateUserDto
     */
    'password': string;
    /**
     * Verification status of the user
     * @type {boolean}
     * @memberof CreateUserDto
     */
    'verified': boolean;
    /**
     * User role
     * @type {string}
     * @memberof CreateUserDto
     */
    'role'?: string;
}
/**
 * 
 * @export
 * @interface CreateUserOrderDTO
 */
export interface CreateUserOrderDTO {
    /**
     * 
     * @type {string}
     * @memberof CreateUserOrderDTO
     */
    'userId': string;
    /**
     * 
     * @type {string}
     * @memberof CreateUserOrderDTO
     */
    'photoSizeId': string;
    /**
     * 
     * @type {string}
     * @memberof CreateUserOrderDTO
     */
    'fbc': string;
    /**
     * 
     * @type {string}
     * @memberof CreateUserOrderDTO
     */
    'fbp': string;
    /**
     * Google Ads click identifier (gclid/gbraid/wbraid) captured from landing URL
     * @type {string}
     * @memberof CreateUserOrderDTO
     */
    'gclid'?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateUserOrderDTO
     */
    'currency': string;
    /**
     * 
     * @type {number}
     * @memberof CreateUserOrderDTO
     */
    'downlink': number | null;
    /**
     * 
     * @type {string}
     * @memberof CreateUserOrderDTO
     */
    'domain': string | null;
    /**
     * Fallback only: the X-Client-Channel header wins outright when it names MOBILE; without a usable header, exactly \'MOBILE\' here still counts (the shipping mobile app sends it this way). Prefer the header — this fallback goes away once every client sends it.
     * @type {string}
     * @memberof CreateUserOrderDTO
     * @deprecated
     */
    'orderSource': string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateUserOrderDTO
     */
    'languagePreference': string;
}
/**
 * 
 * @export
 * @interface CreditBalanceDto
 */
export interface CreditBalanceDto {
    /**
     * Normalised ledger currency: \'eur-at\' is reported as \'eur\', because Austrian orders spend ordinary euro credit.
     * @type {string}
     * @memberof CreditBalanceDto
     */
    'currency': string;
    /**
     * Spendable now, in minor units: unexpired lots with something left. A lot\'s order minimum is not applied — that gates an order, not a balance — so this INCLUDES any lockedByMinimum. 0 is a real answer, not a missing one.
     * @type {number}
     * @memberof CreditBalanceDto
     */
    'balanceCents': number;
    /**
     * Only with orderId, for an order the proven address owns: its goods (pre-credit total minus shipping), in minor units — the measure a lot\'s minimum is judged on.
     * @type {number}
     * @memberof CreditBalanceDto
     */
    'orderGoodsCents'?: number;
    /**
     * Only with orderId, for an order the proven address owns: the part of balanceCents this order cannot use ONLY because its goods are below the lots\' minimum, one entry per minimum, lowest first. Usable on this order now = balanceCents minus their sum. [] = nothing held back.
     * @type {Array<CreditLockedByMinimumDto>}
     * @memberof CreditBalanceDto
     */
    'lockedByMinimum'?: Array<CreditLockedByMinimumDto>;
    /**
     * Every live lot of the caller\'s proof (lot-scoped for a gift-card token), in any currency: applicable ones first, each group soonest-expiring first. Spent, expired and void lots are left out. Order facts (missingCents, selected, appliedCents) only for an order the proven address owns.
     * @type {Array<CreditLotViewDto>}
     * @memberof CreditBalanceDto
     */
    'lots'?: Array<CreditLotViewDto>;
    /**
     * Only with orderId, for an order the proven address owns. AUTO: every applicable lot, soonest-expiring first (no choice made, or apply-credit called without lotIds). MANUAL: the customer chose lotIds (possibly none).
     * @type {string}
     * @memberof CreditBalanceDto
     */
    'selectionMode'?: CreditBalanceDtoSelectionModeEnum;
}

export const CreditBalanceDtoSelectionModeEnum = {
    Auto: 'AUTO',
    Manual: 'MANUAL'
} as const;

export type CreditBalanceDtoSelectionModeEnum = typeof CreditBalanceDtoSelectionModeEnum[keyof typeof CreditBalanceDtoSelectionModeEnum];

/**
 * 
 * @export
 * @interface CreditLockedByMinimumDto
 */
export interface CreditLockedByMinimumDto {
    /**
     * What these lots still hold, in minor units.
     * @type {number}
     * @memberof CreditLockedByMinimumDto
     */
    'amountCents': number;
    /**
     * The goods (order total minus shipping, before credit) the order must reach before this credit applies, in minor units.
     * @type {number}
     * @memberof CreditLockedByMinimumDto
     */
    'minimumOrderCents': number;
    /**
     * 
     * @type {string}
     * @memberof CreditLockedByMinimumDto
     */
    'currency': string;
}
/**
 * 
 * @export
 * @interface CreditLotViewDto
 */
export interface CreditLotViewDto {
    /**
     * The lot id; what PATCH /order/apply-credit takes in lotIds.
     * @type {string}
     * @memberof CreditLotViewDto
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof CreditLotViewDto
     */
    'kind': CreditLotViewDtoKindEnum;
    /**
     * A gift card\'s last four code characters (never more); null for granted credit.
     * @type {string}
     * @memberof CreditLotViewDto
     */
    'codeHint': string | null;
    /**
     * Minor units this lot can give this cart: its remainder plus what it holds on this cart and on the owner\'s other open, unpinned carts. For HELD_ON_OTHER_CART, the amount held there.
     * @type {number}
     * @memberof CreditLotViewDto
     */
    'availableCents': number;
    /**
     * 
     * @type {string}
     * @memberof CreditLotViewDto
     */
    'currency': string;
    /**
     * null = never.
     * @type {string}
     * @memberof CreditLotViewDto
     */
    'expiresAt': string | null;
    /**
     * Minimum order goods (without shipping), minor units. 0 = any.
     * @type {number}
     * @memberof CreditLotViewDto
     */
    'minimumOrderCents': number;
    /**
     * The shop a gift card was bought on (\'si\', \'hr\', …); null = any shop.
     * @type {string}
     * @memberof CreditLotViewDto
     */
    'market': string | null;
    /**
     * Whether it can pay this cart now.
     * @type {boolean}
     * @memberof CreditLotViewDto
     */
    'applicable': boolean;
    /**
     * Why not, when applicable is false. MINIMUM_ORDER: the goods are below minimumOrderCents (missingCents says by how much, when known). OTHER_MARKET: a gift card of another shop. OTHER_CURRENCY. HELD_ON_OTHER_CART: all of it is on another cart whose payment is under way.
     * @type {string}
     * @memberof CreditLotViewDto
     */
    'reason': CreditLotViewDtoReasonEnum;
    /**
     * MINIMUM_ORDER only, minor units.
     * @type {number}
     * @memberof CreditLotViewDto
     */
    'missingCents': number | null;
    /**
     * Chosen for this cart: explicitly (selectionMode MANUAL — may include a lot that does not apply right now), or by automatic mode (the lots it spends). Always false without an order the proven address owns.
     * @type {boolean}
     * @memberof CreditLotViewDto
     */
    'selected': boolean;
    /**
     * What this lot pays on this cart now, minor units.
     * @type {number}
     * @memberof CreditLotViewDto
     */
    'appliedCents': number;
}

export const CreditLotViewDtoKindEnum = {
    GiftCard: 'GIFT_CARD',
    Granted: 'GRANTED'
} as const;

export type CreditLotViewDtoKindEnum = typeof CreditLotViewDtoKindEnum[keyof typeof CreditLotViewDtoKindEnum];
export const CreditLotViewDtoReasonEnum = {
    MinimumOrder: 'MINIMUM_ORDER',
    OtherMarket: 'OTHER_MARKET',
    OtherCurrency: 'OTHER_CURRENCY',
    HeldOnOtherCart: 'HELD_ON_OTHER_CART'
} as const;

export type CreditLotViewDtoReasonEnum = typeof CreditLotViewDtoReasonEnum[keyof typeof CreditLotViewDtoReasonEnum];

/**
 * 
 * @export
 * @interface CumulativeAmountDataDto
 */
export interface CumulativeAmountDataDto {
    /**
     * Date in YYYY-MM-DD format
     * @type {string}
     * @memberof CumulativeAmountDataDto
     */
    'date': string;
    /**
     * Cumulative total amount
     * @type {number}
     * @memberof CumulativeAmountDataDto
     */
    'cumulativeAmount': number;
    /**
     * Cumulative amount with shipping and VAT
     * @type {number}
     * @memberof CumulativeAmountDataDto
     */
    'cumulativeAmountWithShippingAndVAT': number;
    /**
     * Cumulative failed order amount
     * @type {number}
     * @memberof CumulativeAmountDataDto
     */
    'cumulativeAmountFailed': number;
    /**
     * Predicted cumulative amount
     * @type {number}
     * @memberof CumulativeAmountDataDto
     */
    'cumulativeAmountPrediction'?: number;
    /**
     * Predicted cumulative amount with shipping and VAT
     * @type {number}
     * @memberof CumulativeAmountDataDto
     */
    'cumulativeAmountWithShippingAndVATPrediction'?: number;
    /**
     * Predicted cumulative failed amount
     * @type {number}
     * @memberof CumulativeAmountDataDto
     */
    'cumulativeAmountFailedPrediction'?: number;
}
/**
 * 
 * @export
 * @interface CurrencyBreakdownEntryDto
 */
export interface CurrencyBreakdownEntryDto {
    /**
     * Currency code (e.g. eur, czk)
     * @type {string}
     * @memberof CurrencyBreakdownEntryDto
     */
    'currency': string;
    /**
     * Number of orders in this currency
     * @type {number}
     * @memberof CurrencyBreakdownEntryDto
     */
    'orderCount': number;
    /**
     * Sum of order.amount values in native minor units for this currency (intentionally NOT EUR-normalised — divide by 100 on the client to get native major units, e.g. 1854300 = 18543.00 CZK).
     * @type {number}
     * @memberof CurrencyBreakdownEntryDto
     */
    'totalAmount': number;
}
/**
 * 
 * @export
 * @interface CustomerDetailsDto
 */
export interface CustomerDetailsDto {
    /**
     * Customer name
     * @type {string}
     * @memberof CustomerDetailsDto
     */
    'name': string;
    /**
     * Customer email
     * @type {string}
     * @memberof CustomerDetailsDto
     */
    'email': string;
    /**
     * Customer address
     * @type {string}
     * @memberof CustomerDetailsDto
     */
    'address': string;
    /**
     * Customer city
     * @type {string}
     * @memberof CustomerDetailsDto
     */
    'city': string;
    /**
     * Customer ZIP code
     * @type {string}
     * @memberof CustomerDetailsDto
     */
    'zipCode'?: string;
    /**
     * Customer country code
     * @type {string}
     * @memberof CustomerDetailsDto
     */
    'country'?: string;
    /**
     * Customer tax number for EU transactions
     * @type {string}
     * @memberof CustomerDetailsDto
     */
    'taxNumber'?: string;
}
/**
 * 
 * @export
 * @interface CustomerSegmentsDto
 */
export interface CustomerSegmentsDto {
    /**
     * Customers with exactly one order
     * @type {number}
     * @memberof CustomerSegmentsDto
     */
    'oneTime': number;
    /**
     * Customers with 2+ orders
     * @type {number}
     * @memberof CustomerSegmentsDto
     */
    'repeat': number;
    /**
     * VIPs: >=3 orders OR >=€200 lifetime spend
     * @type {number}
     * @memberof CustomerSegmentsDto
     */
    'vip': number;
    /**
     * At-risk: had an order but none in the last 90 days
     * @type {number}
     * @memberof CustomerSegmentsDto
     */
    'atRisk': number;
}
/**
 * 
 * @export
 * @interface DailyAmountDataDto
 */
export interface DailyAmountDataDto {
    /**
     * Date in YYYY-MM-DD format
     * @type {string}
     * @memberof DailyAmountDataDto
     */
    'date': string;
    /**
     * Total amount for the day (in default currency)
     * @type {number}
     * @memberof DailyAmountDataDto
     */
    'amount': number;
    /**
     * Photo and calendar production cost for the day (EUR). factoryPrice per print plus the per-format calendar cost — the same arithmetic totalProfit uses.
     * @type {number}
     * @memberof DailyAmountDataDto
     */
    'productionCost': number;
    /**
     * Amount including shipping and VAT
     * @type {number}
     * @memberof DailyAmountDataDto
     */
    'amountWithShippingAndVAT': number;
    /**
     * Failed order amount for the day
     * @type {number}
     * @memberof DailyAmountDataDto
     */
    'amountFailed': number;
    /**
     * Number of successful orders
     * @type {number}
     * @memberof DailyAmountDataDto
     */
    'nOfOrders': number;
    /**
     * Number of failed orders
     * @type {number}
     * @memberof DailyAmountDataDto
     */
    'nOfOrdersFailed': number;
    /**
     * Total number of photos ordered
     * @type {number}
     * @memberof DailyAmountDataDto
     */
    'totalNOfPhotos': number;
    /**
     * Total number of photos in failed orders
     * @type {number}
     * @memberof DailyAmountDataDto
     */
    'totalFailedPhotos': number;
    /**
     * Number of products ordered
     * @type {number}
     * @memberof DailyAmountDataDto
     */
    'numberOfProducts': number;
    /**
     * Number of calendars ordered
     * @type {number}
     * @memberof DailyAmountDataDto
     */
    'numberOfCalendars': number;
}
/**
 * 
 * @export
 * @interface DailyAmountsResponseDto
 */
export interface DailyAmountsResponseDto {
    /**
     * Daily amount data
     * @type {Array<DailyAmountDataDto>}
     * @memberof DailyAmountsResponseDto
     */
    'dailyAmounts': Array<DailyAmountDataDto>;
    /**
     * Cumulative amount data
     * @type {Array<CumulativeAmountDataDto>}
     * @memberof DailyAmountsResponseDto
     */
    'cumulativeAmounts': Array<CumulativeAmountDataDto>;
}
/**
 * 
 * @export
 * @interface DaysBetweenBucketDto
 */
export interface DaysBetweenBucketDto {
    /**
     * Bucket label
     * @type {string}
     * @memberof DaysBetweenBucketDto
     */
    'label': string;
    /**
     * Inclusive lower bound (days)
     * @type {number}
     * @memberof DaysBetweenBucketDto
     */
    'min': number;
    /**
     * Inclusive upper bound (days), null = open-ended
     * @type {number}
     * @memberof DaysBetweenBucketDto
     */
    'max': number | null;
    /**
     * Count of consecutive-order gaps in this bucket
     * @type {number}
     * @memberof DaysBetweenBucketDto
     */
    'count': number;
}
/**
 * 
 * @export
 * @interface DeclineCancelRequestDto
 */
export interface DeclineCancelRequestDto {
    /**
     * Internal note for the order log; never sent to the customer.
     * @type {string}
     * @memberof DeclineCancelRequestDto
     */
    'note'?: string;
}
/**
 * 
 * @export
 * @interface DeliverySpeedBucketDto
 */
export interface DeliverySpeedBucketDto {
    /**
     * Human-readable label
     * @type {string}
     * @memberof DeliverySpeedBucketDto
     */
    'label': string;
    /**
     * Inclusive lower bound in days
     * @type {number}
     * @memberof DeliverySpeedBucketDto
     */
    'min': number;
    /**
     * Exclusive upper bound in days, null means open-ended
     * @type {number}
     * @memberof DeliverySpeedBucketDto
     */
    'max': number | null;
    /**
     * Number of delivered orders in this bucket
     * @type {number}
     * @memberof DeliverySpeedBucketDto
     */
    'count': number;
}
/**
 * 
 * @export
 * @interface DeliverySpeedDto
 */
export interface DeliverySpeedDto {
    /**
     * Distribution of delivery times across day-range buckets
     * @type {Array<DeliverySpeedBucketDto>}
     * @memberof DeliverySpeedDto
     */
    'buckets': Array<DeliverySpeedBucketDto>;
    /**
     * Mean delivery days across the sample, null if no data
     * @type {number}
     * @memberof DeliverySpeedDto
     */
    'averageDays': number | null;
    /**
     * Median delivery days across the sample, null if no data
     * @type {number}
     * @memberof DeliverySpeedDto
     */
    'medianDays': number | null;
    /**
     * Number of delivered orders with both timestamps
     * @type {number}
     * @memberof DeliverySpeedDto
     */
    'sampleSize': number;
}
/**
 * 
 * @export
 * @interface EmailEffectivenessResponseDto
 */
export interface EmailEffectivenessResponseDto {
    /**
     * Attribution window in days
     * @type {number}
     * @memberof EmailEffectivenessResponseDto
     */
    'windowDays': number;
    /**
     * Total SENT emails across all templates
     * @type {number}
     * @memberof EmailEffectivenessResponseDto
     */
    'totalEmailsSent': number;
    /**
     * Per-template effectiveness rows
     * @type {Array<PerTemplateEffectivenessDto>}
     * @memberof EmailEffectivenessResponseDto
     */
    'perTemplate': Array<PerTemplateEffectivenessDto>;
    /**
     * Last-touch total email-attributed revenue (EUR)
     * @type {number}
     * @memberof EmailEffectivenessResponseDto
     */
    'totalEmailAttributedRevenueEur': number;
    /**
     * Last-touch revenue split by template
     * @type {Array<LastTouchTemplateDto>}
     * @memberof EmailEffectivenessResponseDto
     */
    'lastTouchByTemplate': Array<LastTouchTemplateDto>;
}
/**
 * 
 * @export
 * @interface EmailUnsubscribeControllerManualUnsubscribeRequest
 */
export interface EmailUnsubscribeControllerManualUnsubscribeRequest {
    /**
     * 
     * @type {string}
     * @memberof EmailUnsubscribeControllerManualUnsubscribeRequest
     */
    'email': string;
    /**
     * 
     * @type {string}
     * @memberof EmailUnsubscribeControllerManualUnsubscribeRequest
     */
    'scope'?: EmailUnsubscribeControllerManualUnsubscribeRequestScopeEnum;
}

export const EmailUnsubscribeControllerManualUnsubscribeRequestScopeEnum = {
    Promotional: 'promotional',
    All: 'all'
} as const;

export type EmailUnsubscribeControllerManualUnsubscribeRequestScopeEnum = typeof EmailUnsubscribeControllerManualUnsubscribeRequestScopeEnum[keyof typeof EmailUnsubscribeControllerManualUnsubscribeRequestScopeEnum];

/**
 * 
 * @export
 * @interface FulfillmentFunnelDto
 */
export interface FulfillmentFunnelDto {
    /**
     * Orders in PENDING status
     * @type {number}
     * @memberof FulfillmentFunnelDto
     */
    'pending': number;
    /**
     * Orders in PAID or PAYMENT_ON_DELIVERY status
     * @type {number}
     * @memberof FulfillmentFunnelDto
     */
    'paid': number;
    /**
     * Orders in IN_PRODUCTION status
     * @type {number}
     * @memberof FulfillmentFunnelDto
     */
    'inProduction': number;
    /**
     * Orders in SHIPPED status
     * @type {number}
     * @memberof FulfillmentFunnelDto
     */
    'shipped': number;
    /**
     * Orders in DELIVERED status
     * @type {number}
     * @memberof FulfillmentFunnelDto
     */
    'delivered': number;
    /**
     * Orders in CANCELED status
     * @type {number}
     * @memberof FulfillmentFunnelDto
     */
    'canceled': number;
    /**
     * Orders in FAILED status
     * @type {number}
     * @memberof FulfillmentFunnelDto
     */
    'failed': number;
}
/**
 * 
 * @export
 * @interface GetBannerMessageDto
 */
export interface GetBannerMessageDto {
    /**
     * The unique identifier of the entity.
     * @type {string}
     * @memberof GetBannerMessageDto
     */
    'id': string;
    /**
     * The creation date of the entity.
     * @type {string}
     * @memberof GetBannerMessageDto
     */
    'createdAt': string;
    /**
     * The last update date of the entity.
     * @type {string}
     * @memberof GetBannerMessageDto
     */
    'updatedAt': string;
    /**
     * Message of the coupon
     * @type {string}
     * @memberof GetBannerMessageDto
     */
    'message': string;
    /**
     * Date until the message is valid
     * @type {string}
     * @memberof GetBannerMessageDto
     */
    'validUntil': string;
    /**
     * Rank of the message
     * @type {number}
     * @memberof GetBannerMessageDto
     */
    'rank': number;
    /**
     * Time to show the message
     * @type {number}
     * @memberof GetBannerMessageDto
     */
    'timeToShow': number;
    /**
     * Background color of the message
     * @type {string}
     * @memberof GetBannerMessageDto
     */
    'backGroundColor': string;
    /**
     * Text color of the message
     * @type {string}
     * @memberof GetBannerMessageDto
     */
    'textColor': string;
    /**
     * Font size of the message
     * @type {string}
     * @memberof GetBannerMessageDto
     */
    'fontSize': string;
}
/**
 * 
 * @export
 * @interface GetCouponDto
 */
export interface GetCouponDto {
    /**
     * The unique identifier of the entity.
     * @type {string}
     * @memberof GetCouponDto
     */
    'id': string;
    /**
     * The creation date of the entity.
     * @type {string}
     * @memberof GetCouponDto
     */
    'createdAt': string;
    /**
     * The last update date of the entity.
     * @type {string}
     * @memberof GetCouponDto
     */
    'updatedAt': string;
    /**
     * Date until the coupon is valid
     * @type {string}
     * @memberof GetCouponDto
     */
    'validUntil': string;
    /**
     * Unique code of the coupon
     * @type {string}
     * @memberof GetCouponDto
     */
    'code': string;
    /**
     * Discount percentage or amount
     * @type {number}
     * @memberof GetCouponDto
     */
    'discount': number;
    /**
     * Coupon type
     * @type {string}
     * @memberof GetCouponDto
     */
    'type'?: string;
    /**
     * Description of the coupon
     * @type {string}
     * @memberof GetCouponDto
     */
    'description': string;
    /**
     * Free shipping
     * @type {boolean}
     * @memberof GetCouponDto
     */
    'freeShipping': boolean;
    /**
     * Minimum amount of the order
     * @type {number}
     * @memberof GetCouponDto
     */
    'minimumAmount': number;
    /**
     * Minimum amount of the order
     * @type {number}
     * @memberof GetCouponDto
     */
    'minimumAmountShipping': number;
    /**
     * Maximum discount amount of the order
     * @type {number}
     * @memberof GetCouponDto
     */
    'maximumDiscountAmount'?: number;
    /**
     * Applicable photo sizes 
     * @type {Array<GetPhotoSizeDto>}
     * @memberof GetCouponDto
     */
    'photoSizes'?: Array<GetPhotoSizeDto>;
    /**
     * Applicable currencies
     * @type {Array<string>}
     * @memberof GetCouponDto
     */
    'currencies': Array<string>;
    /**
     * 
     * @type {CouponRewardType}
     * @memberof GetCouponDto
     */
    'rewardType': CouponRewardType;
    /**
     * CASHBACK only: lot lifetime in days.
     * @type {number}
     * @memberof GetCouponDto
     */
    'cashbackLifetimeDays': number;
}


/**
 * 
 * @export
 * @interface GetDeliveryPointDto
 */
export interface GetDeliveryPointDto {
    /**
     * 
     * @type {string}
     * @memberof GetDeliveryPointDto
     */
    'deliveryPointId': string;
    /**
     * 
     * @type {string}
     * @memberof GetDeliveryPointDto
     */
    'deliveryPointName': string;
    /**
     * 
     * @type {string}
     * @memberof GetDeliveryPointDto
     */
    'deliveryPointStreet': string;
    /**
     * 
     * @type {string}
     * @memberof GetDeliveryPointDto
     */
    'deliveryPointHouseNumber': string;
    /**
     * 
     * @type {string}
     * @memberof GetDeliveryPointDto
     */
    'deliveryPointCity': string;
    /**
     * 
     * @type {string}
     * @memberof GetDeliveryPointDto
     */
    'deliveryPointZipCode': string;
    /**
     * 
     * @type {string}
     * @memberof GetDeliveryPointDto
     */
    'deliveryPointCountryIsoCode': string;
}
/**
 * 
 * @export
 * @interface GetInvoiceDto
 */
export interface GetInvoiceDto {
    /**
     * 
     * @type {string}
     * @memberof GetInvoiceDto
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof GetInvoiceDto
     */
    'invoiceNumber': string;
    /**
     * 
     * @type {string}
     * @memberof GetInvoiceDto
     */
    'orderId': string;
    /**
     * 
     * @type {number}
     * @memberof GetInvoiceDto
     */
    'totalAmount': number;
    /**
     * 
     * @type {number}
     * @memberof GetInvoiceDto
     */
    'vatAmount': number;
    /**
     * 
     * @type {number}
     * @memberof GetInvoiceDto
     */
    'subtotal': number;
    /**
     * 
     * @type {string}
     * @memberof GetInvoiceDto
     */
    'fiscalizationStatus': GetInvoiceDtoFiscalizationStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof GetInvoiceDto
     */
    'zoi': string | null;
    /**
     * 
     * @type {string}
     * @memberof GetInvoiceDto
     */
    'eor': string | null;
    /**
     * 
     * @type {string}
     * @memberof GetInvoiceDto
     */
    'fiscalizationDate': string | null;
    /**
     * 
     * @type {string}
     * @memberof GetInvoiceDto
     */
    'fiscalizationError': string | null;
    /**
     * Invoice issue date and time
     * @type {string}
     * @memberof GetInvoiceDto
     */
    'issueDateTime': string;
    /**
     * Invoice line items
     * @type {Array<InvoiceItemDto>}
     * @memberof GetInvoiceDto
     */
    'items': Array<InvoiceItemDto> | null;
    /**
     * Invoice utility items
     * @type {Array<InvoiceUtilityItemDto>}
     * @memberof GetInvoiceDto
     */
    'utilityItems': Array<InvoiceUtilityItemDto> | null;
    /**
     * 
     * @type {GetInvoiceDtoCustomerDetails}
     * @memberof GetInvoiceDto
     */
    'customerDetails': GetInvoiceDtoCustomerDetails | null;
    /**
     * 
     * @type {string}
     * @memberof GetInvoiceDto
     */
    'notes': string | null;
    /**
     * 
     * @type {string}
     * @memberof GetInvoiceDto
     */
    'createdAt': string;
    /**
     * 
     * @type {string}
     * @memberof GetInvoiceDto
     */
    'updatedAt': string;
    /**
     * 
     * @type {string}
     * @memberof GetInvoiceDto
     */
    's3Key': string | null;
    /**
     * 
     * @type {number}
     * @memberof GetInvoiceDto
     */
    'downloadCount': number;
    /**
     * Whether a credit note (storno/dobropis) has been issued against this invoice
     * @type {boolean}
     * @memberof GetInvoiceDto
     */
    'hasCreditNote': boolean;
    /**
     * ID of the credit note that reverses/corrects this invoice, if any
     * @type {string}
     * @memberof GetInvoiceDto
     */
    'creditNoteId'?: string | null;
    /**
     * Reason recorded when the credit note was issued
     * @type {string}
     * @memberof GetInvoiceDto
     */
    'creditNoteReason'?: string | null;
}

export const GetInvoiceDtoFiscalizationStatusEnum = {
    Pending: 'PENDING',
    Success: 'SUCCESS',
    Failed: 'FAILED',
    Retry: 'RETRY',
    Pantheon: 'PANTHEON'
} as const;

export type GetInvoiceDtoFiscalizationStatusEnum = typeof GetInvoiceDtoFiscalizationStatusEnum[keyof typeof GetInvoiceDtoFiscalizationStatusEnum];

/**
 * Customer details
 * @export
 * @interface GetInvoiceDtoCustomerDetails
 */
export interface GetInvoiceDtoCustomerDetails {
    /**
     * Customer name
     * @type {string}
     * @memberof GetInvoiceDtoCustomerDetails
     */
    'name': string;
    /**
     * Customer email
     * @type {string}
     * @memberof GetInvoiceDtoCustomerDetails
     */
    'email': string;
    /**
     * Customer address
     * @type {string}
     * @memberof GetInvoiceDtoCustomerDetails
     */
    'address': string;
    /**
     * Customer city
     * @type {string}
     * @memberof GetInvoiceDtoCustomerDetails
     */
    'city': string;
    /**
     * Customer zip code
     * @type {string}
     * @memberof GetInvoiceDtoCustomerDetails
     */
    'zipCode'?: string;
    /**
     * Customer country
     * @type {string}
     * @memberof GetInvoiceDtoCustomerDetails
     */
    'country'?: string;
    /**
     * Customer tax number
     * @type {string}
     * @memberof GetInvoiceDtoCustomerDetails
     */
    'taxNumber'?: string;
}
/**
 * 
 * @export
 * @interface GetManyArtworkCollectionResponseDto
 */
export interface GetManyArtworkCollectionResponseDto {
    /**
     * 
     * @type {Array<object>}
     * @memberof GetManyArtworkCollectionResponseDto
     */
    'data': Array<object>;
    /**
     * 
     * @type {number}
     * @memberof GetManyArtworkCollectionResponseDto
     */
    'count': number;
    /**
     * 
     * @type {number}
     * @memberof GetManyArtworkCollectionResponseDto
     */
    'total': number;
    /**
     * 
     * @type {number}
     * @memberof GetManyArtworkCollectionResponseDto
     */
    'page': number;
    /**
     * 
     * @type {number}
     * @memberof GetManyArtworkCollectionResponseDto
     */
    'pageCount': number;
}
/**
 * 
 * @export
 * @interface GetManyArtworkResponseDto
 */
export interface GetManyArtworkResponseDto {
    /**
     * 
     * @type {Array<object>}
     * @memberof GetManyArtworkResponseDto
     */
    'data': Array<object>;
    /**
     * 
     * @type {number}
     * @memberof GetManyArtworkResponseDto
     */
    'count': number;
    /**
     * 
     * @type {number}
     * @memberof GetManyArtworkResponseDto
     */
    'total': number;
    /**
     * 
     * @type {number}
     * @memberof GetManyArtworkResponseDto
     */
    'page': number;
    /**
     * 
     * @type {number}
     * @memberof GetManyArtworkResponseDto
     */
    'pageCount': number;
}
/**
 * 
 * @export
 * @interface GetManyBannerMessageResponseDto
 */
export interface GetManyBannerMessageResponseDto {
    /**
     * 
     * @type {Array<GetBannerMessageDto>}
     * @memberof GetManyBannerMessageResponseDto
     */
    'data': Array<GetBannerMessageDto>;
    /**
     * 
     * @type {number}
     * @memberof GetManyBannerMessageResponseDto
     */
    'count': number;
    /**
     * 
     * @type {number}
     * @memberof GetManyBannerMessageResponseDto
     */
    'total': number;
    /**
     * 
     * @type {number}
     * @memberof GetManyBannerMessageResponseDto
     */
    'page': number;
    /**
     * 
     * @type {number}
     * @memberof GetManyBannerMessageResponseDto
     */
    'pageCount': number;
}
/**
 * 
 * @export
 * @interface GetManyCouponResponseDto
 */
export interface GetManyCouponResponseDto {
    /**
     * 
     * @type {Array<GetCouponDto>}
     * @memberof GetManyCouponResponseDto
     */
    'data': Array<GetCouponDto>;
    /**
     * 
     * @type {number}
     * @memberof GetManyCouponResponseDto
     */
    'count': number;
    /**
     * 
     * @type {number}
     * @memberof GetManyCouponResponseDto
     */
    'total': number;
    /**
     * 
     * @type {number}
     * @memberof GetManyCouponResponseDto
     */
    'page': number;
    /**
     * 
     * @type {number}
     * @memberof GetManyCouponResponseDto
     */
    'pageCount': number;
}
/**
 * 
 * @export
 * @interface GetManyElementImageResponseDto
 */
export interface GetManyElementImageResponseDto {
    /**
     * 
     * @type {Array<object>}
     * @memberof GetManyElementImageResponseDto
     */
    'data': Array<object>;
    /**
     * 
     * @type {number}
     * @memberof GetManyElementImageResponseDto
     */
    'count': number;
    /**
     * 
     * @type {number}
     * @memberof GetManyElementImageResponseDto
     */
    'total': number;
    /**
     * 
     * @type {number}
     * @memberof GetManyElementImageResponseDto
     */
    'page': number;
    /**
     * 
     * @type {number}
     * @memberof GetManyElementImageResponseDto
     */
    'pageCount': number;
}
/**
 * 
 * @export
 * @interface GetManyEmailLogResponseDto
 */
export interface GetManyEmailLogResponseDto {
    /**
     * 
     * @type {Array<object>}
     * @memberof GetManyEmailLogResponseDto
     */
    'data': Array<object>;
    /**
     * 
     * @type {number}
     * @memberof GetManyEmailLogResponseDto
     */
    'count': number;
    /**
     * 
     * @type {number}
     * @memberof GetManyEmailLogResponseDto
     */
    'total': number;
    /**
     * 
     * @type {number}
     * @memberof GetManyEmailLogResponseDto
     */
    'page': number;
    /**
     * 
     * @type {number}
     * @memberof GetManyEmailLogResponseDto
     */
    'pageCount': number;
}
/**
 * 
 * @export
 * @interface GetManyEmailRuleResponseDto
 */
export interface GetManyEmailRuleResponseDto {
    /**
     * 
     * @type {Array<object>}
     * @memberof GetManyEmailRuleResponseDto
     */
    'data': Array<object>;
    /**
     * 
     * @type {number}
     * @memberof GetManyEmailRuleResponseDto
     */
    'count': number;
    /**
     * 
     * @type {number}
     * @memberof GetManyEmailRuleResponseDto
     */
    'total': number;
    /**
     * 
     * @type {number}
     * @memberof GetManyEmailRuleResponseDto
     */
    'page': number;
    /**
     * 
     * @type {number}
     * @memberof GetManyEmailRuleResponseDto
     */
    'pageCount': number;
}
/**
 * 
 * @export
 * @interface GetManyEmailTemplateResponseDto
 */
export interface GetManyEmailTemplateResponseDto {
    /**
     * 
     * @type {Array<object>}
     * @memberof GetManyEmailTemplateResponseDto
     */
    'data': Array<object>;
    /**
     * 
     * @type {number}
     * @memberof GetManyEmailTemplateResponseDto
     */
    'count': number;
    /**
     * 
     * @type {number}
     * @memberof GetManyEmailTemplateResponseDto
     */
    'total': number;
    /**
     * 
     * @type {number}
     * @memberof GetManyEmailTemplateResponseDto
     */
    'page': number;
    /**
     * 
     * @type {number}
     * @memberof GetManyEmailTemplateResponseDto
     */
    'pageCount': number;
}
/**
 * 
 * @export
 * @interface GetManyInvoiceResponseDto
 */
export interface GetManyInvoiceResponseDto {
    /**
     * 
     * @type {Array<GetInvoiceDto>}
     * @memberof GetManyInvoiceResponseDto
     */
    'data': Array<GetInvoiceDto>;
    /**
     * 
     * @type {number}
     * @memberof GetManyInvoiceResponseDto
     */
    'count': number;
    /**
     * 
     * @type {number}
     * @memberof GetManyInvoiceResponseDto
     */
    'total': number;
    /**
     * 
     * @type {number}
     * @memberof GetManyInvoiceResponseDto
     */
    'page': number;
    /**
     * 
     * @type {number}
     * @memberof GetManyInvoiceResponseDto
     */
    'pageCount': number;
}
/**
 * 
 * @export
 * @interface GetManyOrderCalendarResponseDto
 */
export interface GetManyOrderCalendarResponseDto {
    /**
     * 
     * @type {Array<GetOrderCalendarDto>}
     * @memberof GetManyOrderCalendarResponseDto
     */
    'data': Array<GetOrderCalendarDto>;
    /**
     * 
     * @type {number}
     * @memberof GetManyOrderCalendarResponseDto
     */
    'count': number;
    /**
     * 
     * @type {number}
     * @memberof GetManyOrderCalendarResponseDto
     */
    'total': number;
    /**
     * 
     * @type {number}
     * @memberof GetManyOrderCalendarResponseDto
     */
    'page': number;
    /**
     * 
     * @type {number}
     * @memberof GetManyOrderCalendarResponseDto
     */
    'pageCount': number;
}
/**
 * 
 * @export
 * @interface GetManyOrderProductDetailResponseDto
 */
export interface GetManyOrderProductDetailResponseDto {
    /**
     * 
     * @type {Array<GetOrderProductDetailDto>}
     * @memberof GetManyOrderProductDetailResponseDto
     */
    'data': Array<GetOrderProductDetailDto>;
    /**
     * 
     * @type {number}
     * @memberof GetManyOrderProductDetailResponseDto
     */
    'count': number;
    /**
     * 
     * @type {number}
     * @memberof GetManyOrderProductDetailResponseDto
     */
    'total': number;
    /**
     * 
     * @type {number}
     * @memberof GetManyOrderProductDetailResponseDto
     */
    'page': number;
    /**
     * 
     * @type {number}
     * @memberof GetManyOrderProductDetailResponseDto
     */
    'pageCount': number;
}
/**
 * 
 * @export
 * @interface GetManyOrderResponseDto
 */
export interface GetManyOrderResponseDto {
    /**
     * 
     * @type {Array<GetOrderDto>}
     * @memberof GetManyOrderResponseDto
     */
    'data': Array<GetOrderDto>;
    /**
     * 
     * @type {number}
     * @memberof GetManyOrderResponseDto
     */
    'count': number;
    /**
     * 
     * @type {number}
     * @memberof GetManyOrderResponseDto
     */
    'total': number;
    /**
     * 
     * @type {number}
     * @memberof GetManyOrderResponseDto
     */
    'page': number;
    /**
     * 
     * @type {number}
     * @memberof GetManyOrderResponseDto
     */
    'pageCount': number;
}
/**
 * 
 * @export
 * @interface GetManyPaperResponseDto
 */
export interface GetManyPaperResponseDto {
    /**
     * 
     * @type {Array<object>}
     * @memberof GetManyPaperResponseDto
     */
    'data': Array<object>;
    /**
     * 
     * @type {number}
     * @memberof GetManyPaperResponseDto
     */
    'count': number;
    /**
     * 
     * @type {number}
     * @memberof GetManyPaperResponseDto
     */
    'total': number;
    /**
     * 
     * @type {number}
     * @memberof GetManyPaperResponseDto
     */
    'page': number;
    /**
     * 
     * @type {number}
     * @memberof GetManyPaperResponseDto
     */
    'pageCount': number;
}
/**
 * 
 * @export
 * @interface GetManyPhotoSizeResponseDto
 */
export interface GetManyPhotoSizeResponseDto {
    /**
     * 
     * @type {Array<GetPhotoSizeDto>}
     * @memberof GetManyPhotoSizeResponseDto
     */
    'data': Array<GetPhotoSizeDto>;
    /**
     * 
     * @type {number}
     * @memberof GetManyPhotoSizeResponseDto
     */
    'count': number;
    /**
     * 
     * @type {number}
     * @memberof GetManyPhotoSizeResponseDto
     */
    'total': number;
    /**
     * 
     * @type {number}
     * @memberof GetManyPhotoSizeResponseDto
     */
    'page': number;
    /**
     * 
     * @type {number}
     * @memberof GetManyPhotoSizeResponseDto
     */
    'pageCount': number;
}
/**
 * 
 * @export
 * @interface GetManyPostResponseDto
 */
export interface GetManyPostResponseDto {
    /**
     * 
     * @type {Array<GetPostDto>}
     * @memberof GetManyPostResponseDto
     */
    'data': Array<GetPostDto>;
    /**
     * 
     * @type {number}
     * @memberof GetManyPostResponseDto
     */
    'count': number;
    /**
     * 
     * @type {number}
     * @memberof GetManyPostResponseDto
     */
    'total': number;
    /**
     * 
     * @type {number}
     * @memberof GetManyPostResponseDto
     */
    'page': number;
    /**
     * 
     * @type {number}
     * @memberof GetManyPostResponseDto
     */
    'pageCount': number;
}
/**
 * 
 * @export
 * @interface GetManyProductResponseDto
 */
export interface GetManyProductResponseDto {
    /**
     * 
     * @type {Array<GetProductDto>}
     * @memberof GetManyProductResponseDto
     */
    'data': Array<GetProductDto>;
    /**
     * 
     * @type {number}
     * @memberof GetManyProductResponseDto
     */
    'count': number;
    /**
     * 
     * @type {number}
     * @memberof GetManyProductResponseDto
     */
    'total': number;
    /**
     * 
     * @type {number}
     * @memberof GetManyProductResponseDto
     */
    'page': number;
    /**
     * 
     * @type {number}
     * @memberof GetManyProductResponseDto
     */
    'pageCount': number;
}
/**
 * 
 * @export
 * @interface GetManyProductTagResponseDto
 */
export interface GetManyProductTagResponseDto {
    /**
     * 
     * @type {Array<GetProductTagDto>}
     * @memberof GetManyProductTagResponseDto
     */
    'data': Array<GetProductTagDto>;
    /**
     * 
     * @type {number}
     * @memberof GetManyProductTagResponseDto
     */
    'count': number;
    /**
     * 
     * @type {number}
     * @memberof GetManyProductTagResponseDto
     */
    'total': number;
    /**
     * 
     * @type {number}
     * @memberof GetManyProductTagResponseDto
     */
    'page': number;
    /**
     * 
     * @type {number}
     * @memberof GetManyProductTagResponseDto
     */
    'pageCount': number;
}
/**
 * 
 * @export
 * @interface GetManyProductWithMediaDefinitionResponseDto
 */
export interface GetManyProductWithMediaDefinitionResponseDto {
    /**
     * 
     * @type {Array<object>}
     * @memberof GetManyProductWithMediaDefinitionResponseDto
     */
    'data': Array<object>;
    /**
     * 
     * @type {number}
     * @memberof GetManyProductWithMediaDefinitionResponseDto
     */
    'count': number;
    /**
     * 
     * @type {number}
     * @memberof GetManyProductWithMediaDefinitionResponseDto
     */
    'total': number;
    /**
     * 
     * @type {number}
     * @memberof GetManyProductWithMediaDefinitionResponseDto
     */
    'page': number;
    /**
     * 
     * @type {number}
     * @memberof GetManyProductWithMediaDefinitionResponseDto
     */
    'pageCount': number;
}
/**
 * 
 * @export
 * @interface GetManyProductWithMediaOrderResponseDto
 */
export interface GetManyProductWithMediaOrderResponseDto {
    /**
     * 
     * @type {Array<object>}
     * @memberof GetManyProductWithMediaOrderResponseDto
     */
    'data': Array<object>;
    /**
     * 
     * @type {number}
     * @memberof GetManyProductWithMediaOrderResponseDto
     */
    'count': number;
    /**
     * 
     * @type {number}
     * @memberof GetManyProductWithMediaOrderResponseDto
     */
    'total': number;
    /**
     * 
     * @type {number}
     * @memberof GetManyProductWithMediaOrderResponseDto
     */
    'page': number;
    /**
     * 
     * @type {number}
     * @memberof GetManyProductWithMediaOrderResponseDto
     */
    'pageCount': number;
}
/**
 * 
 * @export
 * @interface GetManyProductWithMediaVariantResponseDto
 */
export interface GetManyProductWithMediaVariantResponseDto {
    /**
     * 
     * @type {Array<object>}
     * @memberof GetManyProductWithMediaVariantResponseDto
     */
    'data': Array<object>;
    /**
     * 
     * @type {number}
     * @memberof GetManyProductWithMediaVariantResponseDto
     */
    'count': number;
    /**
     * 
     * @type {number}
     * @memberof GetManyProductWithMediaVariantResponseDto
     */
    'total': number;
    /**
     * 
     * @type {number}
     * @memberof GetManyProductWithMediaVariantResponseDto
     */
    'page': number;
    /**
     * 
     * @type {number}
     * @memberof GetManyProductWithMediaVariantResponseDto
     */
    'pageCount': number;
}
/**
 * 
 * @export
 * @interface GetManyTemplateResponseDto
 */
export interface GetManyTemplateResponseDto {
    /**
     * 
     * @type {Array<object>}
     * @memberof GetManyTemplateResponseDto
     */
    'data': Array<object>;
    /**
     * 
     * @type {number}
     * @memberof GetManyTemplateResponseDto
     */
    'count': number;
    /**
     * 
     * @type {number}
     * @memberof GetManyTemplateResponseDto
     */
    'total': number;
    /**
     * 
     * @type {number}
     * @memberof GetManyTemplateResponseDto
     */
    'page': number;
    /**
     * 
     * @type {number}
     * @memberof GetManyTemplateResponseDto
     */
    'pageCount': number;
}
/**
 * 
 * @export
 * @interface GetManyUserResponseDto
 */
export interface GetManyUserResponseDto {
    /**
     * 
     * @type {Array<GetUserDto>}
     * @memberof GetManyUserResponseDto
     */
    'data': Array<GetUserDto>;
    /**
     * 
     * @type {number}
     * @memberof GetManyUserResponseDto
     */
    'count': number;
    /**
     * 
     * @type {number}
     * @memberof GetManyUserResponseDto
     */
    'total': number;
    /**
     * 
     * @type {number}
     * @memberof GetManyUserResponseDto
     */
    'page': number;
    /**
     * 
     * @type {number}
     * @memberof GetManyUserResponseDto
     */
    'pageCount': number;
}
/**
 * 
 * @export
 * @interface GetOrderCalendarDto
 */
export interface GetOrderCalendarDto {
    /**
     * 
     * @type {string}
     * @memberof GetOrderCalendarDto
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof GetOrderCalendarDto
     */
    'format': GetOrderCalendarDtoFormatEnum;
    /**
     * 
     * @type {number}
     * @memberof GetOrderCalendarDto
     */
    'quantity': number;
    /**
     * \'white\' | \'silver\' | \'gold\'
     * @type {string}
     * @memberof GetOrderCalendarDto
     */
    'paper': string;
    /**
     * 
     * @type {number}
     * @memberof GetOrderCalendarDto
     */
    'price': number;
    /**
     * 
     * @type {number}
     * @memberof GetOrderCalendarDto
     */
    'discount': number;
    /**
     * 
     * @type {object}
     * @memberof GetOrderCalendarDto
     */
    'calendarData'?: object;
    /**
     * 
     * @type {string}
     * @memberof GetOrderCalendarDto
     */
    'pdfKey'?: string;
    /**
     * 
     * @type {string}
     * @memberof GetOrderCalendarDto
     */
    'pdfUrl'?: string;
    /**
     * 
     * @type {Array<GetPhotoDto>}
     * @memberof GetOrderCalendarDto
     */
    'photos': Array<GetPhotoDto>;
    /**
     * 
     * @type {Array<object>}
     * @memberof GetOrderCalendarDto
     */
    'photoSettings': Array<object>;
    /**
     * 
     * @type {string}
     * @memberof GetOrderCalendarDto
     */
    'createdAt': string;
    /**
     * 
     * @type {string}
     * @memberof GetOrderCalendarDto
     */
    'updatedAt': string;
}

export const GetOrderCalendarDtoFormatEnum = {
    A2: 'A2',
    A3: 'A3',
    A4: 'A4',
    A5: 'A5',
    PlannerA3: 'PLANNER_A3',
    SpreadA4: 'SPREAD_A4'
} as const;

export type GetOrderCalendarDtoFormatEnum = typeof GetOrderCalendarDtoFormatEnum[keyof typeof GetOrderCalendarDtoFormatEnum];

/**
 * 
 * @export
 * @interface GetOrderDto
 */
export interface GetOrderDto {
    /**
     * The unique identifier of the entity.
     * @type {string}
     * @memberof GetOrderDto
     */
    'id': string;
    /**
     * The creation date of the entity.
     * @type {string}
     * @memberof GetOrderDto
     */
    'createdAt': string;
    /**
     * The last update date of the entity.
     * @type {string}
     * @memberof GetOrderDto
     */
    'updatedAt': string;
    /**
     * 
     * @type {string}
     * @memberof GetOrderDto
     */
    'status': string;
    /**
     * 
     * @type {OrderKind}
     * @memberof GetOrderDto
     */
    'kind': OrderKind;
    /**
     * 
     * @type {number}
     * @memberof GetOrderDto
     */
    'amount': number;
    /**
     * Customer account credit already redeemed against this order, in integer cents of `currency`. It is NOT a coupon and is independent of `couponUsed`: an order may carry both, and credit applies after the coupon, on the post-discount total, because credit is payment rather than a discount on the goods. `amount` is what is still owed, so the pre-credit total the customer sees is `amount + creditAppliedCents`.  0 is a real value, not \"absent\": an order that had its credit removed reads 0 here, exactly like one that never had any. Clients must test for presence, never truthiness — `if (!order.creditAppliedCents)` is a bug. Always serialized, including the 0.  This is the order\'s own applied amount only. The remaining balance on the account is a separate resource; read it from the credit endpoints.
     * @type {number}
     * @memberof GetOrderDto
     */
    'creditAppliedCents': number;
    /**
     * 
     * @type {object}
     * @memberof GetOrderDto
     */
    'user': object;
    /**
     * 
     * @type {object}
     * @memberof GetOrderDto
     */
    'couponUsed': object;
    /**
     * 
     * @type {string}
     * @memberof GetOrderDto
     */
    'stripePaymentIntentId': string;
    /**
     * 
     * @type {number}
     * @memberof GetOrderDto
     */
    'stripeAmount': number;
    /**
     * 
     * @type {string}
     * @memberof GetOrderDto
     */
    'stripeCurrency': string;
    /**
     * 
     * @type {string}
     * @memberof GetOrderDto
     */
    'stripeStatus': string;
    /**
     * 
     * @type {string}
     * @memberof GetOrderDto
     */
    'stripeCreated': string;
    /**
     * 
     * @type {string}
     * @memberof GetOrderDto
     */
    'stripeClientSecret': string;
    /**
     * 
     * @type {string}
     * @memberof GetOrderDto
     */
    'shippingAddress1': string;
    /**
     * 
     * @type {string}
     * @memberof GetOrderDto
     */
    'stripeSessionId': string;
    /**
     * Moves when an open payment attempt is abandoned, or the amount of a pinned order changes. POST /order/:id/abandon-payment takes it (with the attempt id from the payment response) to act on one attempt only.
     * @type {number}
     * @memberof GetOrderDto
     */
    'paymentGeneration': number;
    /**
     * Stripe hosted checkout URL (transient, only on prepare-payment response)
     * @type {string}
     * @memberof GetOrderDto
     */
    'stripeCheckoutUrl'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetOrderDto
     */
    'shippingAddress2': string;
    /**
     * 
     * @type {string}
     * @memberof GetOrderDto
     */
    'shippingCity': string;
    /**
     * 
     * @type {string}
     * @memberof GetOrderDto
     */
    'shippingZip': string;
    /**
     * 
     * @type {string}
     * @memberof GetOrderDto
     */
    'shippingCountry': string;
    /**
     * 
     * @type {string}
     * @memberof GetOrderDto
     */
    'shippingState': string;
    /**
     * 
     * @type {string}
     * @memberof GetOrderDto
     */
    'shippingPhone': string;
    /**
     * 
     * @type {string}
     * @memberof GetOrderDto
     */
    'shippingEmail': string;
    /**
     * 
     * @type {string}
     * @memberof GetOrderDto
     */
    'shippingFirstName': string;
    /**
     * 
     * @type {string}
     * @memberof GetOrderDto
     */
    'shippingLastName': string;
    /**
     * 
     * @type {string}
     * @memberof GetOrderDto
     */
    'shippingNotes': string;
    /**
     * 
     * @type {string}
     * @memberof GetOrderDto
     */
    'shippingMethod': string;
    /**
     * 
     * @type {number}
     * @memberof GetOrderDto
     */
    'shippingPrice': number;
    /**
     * 
     * @type {string}
     * @memberof GetOrderDto
     */
    'paymentOption': string;
    /**
     * 
     * @type {string}
     * @memberof GetOrderDto
     */
    'ipAddress': string;
    /**
     * 
     * @type {string}
     * @memberof GetOrderDto
     */
    'userAgent': string;
    /**
     * 
     * @type {string}
     * @memberof GetOrderDto
     */
    'fbc': string;
    /**
     * 
     * @type {string}
     * @memberof GetOrderDto
     */
    'fbp': string;
    /**
     * 
     * @type {boolean}
     * @memberof GetOrderDto
     */
    'isOrdered': boolean;
    /**
     * 
     * @type {string}
     * @memberof GetOrderDto
     */
    'mailCompletePurchaseSent': string;
    /**
     * 
     * @type {number}
     * @memberof GetOrderDto
     */
    'totalNOfPhotos': number;
    /**
     * 
     * @type {number}
     * @memberof GetOrderDto
     */
    'totalNOfDifferentPhotos': number;
    /**
     * 
     * @type {Array<GetOrderProductDetailDto>}
     * @memberof GetOrderDto
     */
    'orderProductDetails': Array<GetOrderProductDetailDto>;
    /**
     * 
     * @type {Array<GetOrderPhotosDto>}
     * @memberof GetOrderDto
     */
    'orderPhotos': Array<GetOrderPhotosDto>;
    /**
     * 
     * @type {Array<GetOrderCalendarDto>}
     * @memberof GetOrderDto
     */
    'orderCalendars': Array<GetOrderCalendarDto>;
    /**
     * 
     * @type {Array<GetProductWithMediaOrderDto>}
     * @memberof GetOrderDto
     */
    'productWithMediaOrders': Array<GetProductWithMediaOrderDto>;
    /**
     * 
     * @type {number}
     * @memberof GetOrderDto
     */
    'glsParcelNumber': number;
    /**
     * 
     * @type {string}
     * @memberof GetOrderDto
     */
    'glsStatus': string;
    /**
     * 
     * @type {string}
     * @memberof GetOrderDto
     */
    'currency': string;
    /**
     * 
     * @type {number}
     * @memberof GetOrderDto
     */
    'downlink': number;
    /**
     * 
     * @type {string}
     * @memberof GetOrderDto
     */
    'domain': string;
    /**
     * 
     * @type {string}
     * @memberof GetOrderDto
     */
    'orderSource'?: string | null;
    /**
     * Type of delivery
     * @type {string}
     * @memberof GetOrderDto
     */
    'deliveryType': GetOrderDtoDeliveryTypeEnum;
    /**
     * 
     * @type {GetDeliveryPointDto}
     * @memberof GetOrderDto
     */
    'deliveryPoint': GetDeliveryPointDto;
    /**
     * 
     * @type {string}
     * @memberof GetOrderDto
     */
    'deliveryPointId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetOrderDto
     */
    'deliveryPointName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetOrderDto
     */
    'deliveryPointStreet'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetOrderDto
     */
    'deliveryPointHouseNumber'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetOrderDto
     */
    'deliveryPointCity'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetOrderDto
     */
    'deliveryPointZipCode'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetOrderDto
     */
    'deliveryPointCountryIsoCode'?: string | null;
    /**
     * Invoice fiscalization status
     * @type {string}
     * @memberof GetOrderDto
     */
    'invoiceStatus'?: GetOrderDtoInvoiceStatusEnum;
    /**
     * Ecological packaging option (+1.00 EUR)
     * @type {boolean}
     * @memberof GetOrderDto
     */
    'ecologicalPackaging': boolean;
    /**
     * Priority complaint option (+0.80 EUR)
     * @type {boolean}
     * @memberof GetOrderDto
     */
    'priorityComplaint': boolean;
    /**
     * Wrap as gift option (+6.00 EUR)
     * @type {boolean}
     * @memberof GetOrderDto
     */
    'wrapAsGift': boolean;
    /**
     * Gift text (if wrapAsGift is true)
     * @type {string}
     * @memberof GetOrderDto
     */
    'giftText': string | null;
    /**
     * Professional crop option
     * @type {boolean}
     * @memberof GetOrderDto
     */
    'professionalCrop': boolean;
    /**
     * Premium paper option
     * @type {boolean}
     * @memberof GetOrderDto
     */
    'premiumPaper': boolean;
    /**
     * White border option
     * @type {boolean}
     * @memberof GetOrderDto
     */
    'whiteBorder': boolean;
    /**
     * Black and white option
     * @type {boolean}
     * @memberof GetOrderDto
     */
    'blackAndWhite': boolean;
    /**
     * Frozen line-items price breakdown, captured at finalization
     * @type {object}
     * @memberof GetOrderDto
     */
    'lineItemsSnapshot'?: object | null;
    /**
     * The bundle the customer is filling (UI state).
     * @type {string}
     * @memberof GetOrderDto
     */
    'selectedBundleId'?: string | null;
    /**
     * Bundle terms frozen at commit.
     * @type {object}
     * @memberof GetOrderDto
     */
    'bundleTermsSnapshot'?: object | null;
    /**
     * Sum of applied bundle discounts, minor units.
     * @type {number}
     * @memberof GetOrderDto
     */
    'bundleDiscountCents'?: number;
    /**
     * Applied bundles: bundleId, name, times, discountCents, couponsAllowed.
     * @type {Array<object>}
     * @memberof GetOrderDto
     */
    'appliedBundles'?: Array<object> | null;
    /**
     * When the order was placed (card paid or COD confirmed).
     * @type {string}
     * @memberof GetOrderDto
     */
    'placedAt'?: string | null;
    /**
     * 
     * @type {GetOrderDtoCancelRequest}
     * @memberof GetOrderDto
     */
    'cancelRequest'?: GetOrderDtoCancelRequest | null;
    /**
     * Whether the quiet \"cancel this order\" link may be shown now. Computed on GET /order/:id.
     * @type {boolean}
     * @memberof GetOrderDto
     */
    'canRequestCancel'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof GetOrderDto
     */
    'cancelRequestState'?: GetOrderDtoCancelRequestStateEnum;
    /**
     * 
     * @type {string}
     * @memberof GetOrderDto
     */
    'cancelRequestedAt'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetOrderDto
     */
    'cancelRequestReason'?: GetOrderDtoCancelRequestReasonEnum;
    /**
     * 
     * @type {string}
     * @memberof GetOrderDto
     */
    'cancelRequestNote'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetOrderDto
     */
    'cancelRequestDecidedAt'?: string | null;
}

export const GetOrderDtoDeliveryTypeEnum = {
    Home: 'HOME',
    ParcelLock: 'PARCEL_LOCK'
} as const;

export type GetOrderDtoDeliveryTypeEnum = typeof GetOrderDtoDeliveryTypeEnum[keyof typeof GetOrderDtoDeliveryTypeEnum];
export const GetOrderDtoInvoiceStatusEnum = {
    Pending: 'PENDING',
    Success: 'SUCCESS',
    Failed: 'FAILED',
    Retry: 'RETRY',
    Pantheon: 'PANTHEON'
} as const;

export type GetOrderDtoInvoiceStatusEnum = typeof GetOrderDtoInvoiceStatusEnum[keyof typeof GetOrderDtoInvoiceStatusEnum];
export const GetOrderDtoCancelRequestStateEnum = {
    Open: 'OPEN',
    Approved: 'APPROVED',
    Declined: 'DECLINED'
} as const;

export type GetOrderDtoCancelRequestStateEnum = typeof GetOrderDtoCancelRequestStateEnum[keyof typeof GetOrderDtoCancelRequestStateEnum];
export const GetOrderDtoCancelRequestReasonEnum = {
    WrongPhotos: 'WRONG_PHOTOS',
    WrongAddress: 'WRONG_ADDRESS',
    WrongProduct: 'WRONG_PRODUCT',
    Other: 'OTHER'
} as const;

export type GetOrderDtoCancelRequestReasonEnum = typeof GetOrderDtoCancelRequestReasonEnum[keyof typeof GetOrderDtoCancelRequestReasonEnum];

/**
 * The customer\'s cancel request, or null. Computed on GET /order/:id.
 * @export
 * @interface GetOrderDtoCancelRequest
 */
export interface GetOrderDtoCancelRequest {
    /**
     * 
     * @type {CancelRequestState}
     * @memberof GetOrderDtoCancelRequest
     */
    'state': CancelRequestState;
    /**
     * ISO timestamp of the request (server clock).
     * @type {string}
     * @memberof GetOrderDtoCancelRequest
     */
    'requestedAt': string;
}


/**
 * 
 * @export
 * @interface GetOrderPhotosDto
 */
export interface GetOrderPhotosDto {
    /**
     * The unique identifier of the entity.
     * @type {string}
     * @memberof GetOrderPhotosDto
     */
    'id': string;
    /**
     * The creation date of the entity.
     * @type {string}
     * @memberof GetOrderPhotosDto
     */
    'createdAt': string;
    /**
     * The last update date of the entity.
     * @type {string}
     * @memberof GetOrderPhotosDto
     */
    'updatedAt': string;
    /**
     * 
     * @type {GetPhotoSizeDto}
     * @memberof GetOrderPhotosDto
     */
    'photoSize': GetPhotoSizeDto;
    /**
     * 
     * @type {Array<GetPhotoDto>}
     * @memberof GetOrderPhotosDto
     */
    'photos': Array<GetPhotoDto>;
    /**
     * 
     * @type {number}
     * @memberof GetOrderPhotosDto
     */
    'price': number;
    /**
     * 
     * @type {number}
     * @memberof GetOrderPhotosDto
     */
    'totalNOfPhotos': number;
    /**
     * 
     * @type {number}
     * @memberof GetOrderPhotosDto
     */
    'totalNOfDifferentPhotos': number;
    /**
     * 
     * @type {number}
     * @memberof GetOrderPhotosDto
     */
    'discount': number;
    /**
     * 
     * @type {boolean}
     * @memberof GetOrderPhotosDto
     */
    'premiumPaper': boolean;
    /**
     * Premium paper fee for this order photo group (in cents)
     * @type {number}
     * @memberof GetOrderPhotosDto
     */
    'premiumPaperFee': number;
    /**
     * 
     * @type {boolean}
     * @memberof GetOrderPhotosDto
     */
    'whiteBorder': boolean;
    /**
     * White border fee for this order photo group (in cents)
     * @type {number}
     * @memberof GetOrderPhotosDto
     */
    'whiteBorderFee': number;
    /**
     * 
     * @type {boolean}
     * @memberof GetOrderPhotosDto
     */
    'blackAndWhite': boolean;
    /**
     * Black and white fee for this order photo group (in cents)
     * @type {number}
     * @memberof GetOrderPhotosDto
     */
    'blackAndWhiteFee': number;
    /**
     * The free 30 x 40 enlargement the basket earned: one photo, 0 €, added and removed by repricing. Change its photo with PUT /order/:id/free-enlargement.
     * @type {boolean}
     * @memberof GetOrderPhotosDto
     */
    'isFreeEnlargement': boolean;
}
/**
 * 
 * @export
 * @interface GetOrderProductDetailDto
 */
export interface GetOrderProductDetailDto {
    /**
     * 
     * @type {string}
     * @memberof GetOrderProductDetailDto
     */
    'id': string;
    /**
     * 
     * @type {GetOrderDto}
     * @memberof GetOrderProductDetailDto
     */
    'order': GetOrderDto;
    /**
     * 
     * @type {number}
     * @memberof GetOrderProductDetailDto
     */
    'quantity': number;
    /**
     * 
     * @type {GetProductDto}
     * @memberof GetOrderProductDetailDto
     */
    'product': GetProductDto;
    /**
     * 
     * @type {number}
     * @memberof GetOrderProductDetailDto
     */
    'price': number;
    /**
     * 
     * @type {number}
     * @memberof GetOrderProductDetailDto
     */
    'discount': number;
}
/**
 * 
 * @export
 * @interface GetPhotoDto
 */
export interface GetPhotoDto {
    /**
     * 
     * @type {number}
     * @memberof GetPhotoDto
     */
    'id': number;
    /**
     * 
     * @type {string}
     * @memberof GetPhotoDto
     */
    'url': string;
    /**
     * 
     * @type {number}
     * @memberof GetPhotoDto
     */
    'count': number;
    /**
     * 
     * @type {boolean}
     * @memberof GetPhotoDto
     */
    'printed': boolean;
    /**
     * 
     * @type {string}
     * @memberof GetPhotoDto
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof GetPhotoDto
     */
    'type': string;
    /**
     * 
     * @type {number}
     * @memberof GetPhotoDto
     */
    'rank': number;
}
/**
 * 
 * @export
 * @interface GetPhotoSizeDto
 */
export interface GetPhotoSizeDto {
    /**
     * The unique identifier of the entity.
     * @type {string}
     * @memberof GetPhotoSizeDto
     */
    'id': string;
    /**
     * The creation date of the entity.
     * @type {string}
     * @memberof GetPhotoSizeDto
     */
    'createdAt': string;
    /**
     * The last update date of the entity.
     * @type {string}
     * @memberof GetPhotoSizeDto
     */
    'updatedAt': string;
    /**
     * Localized names of the product
     * @type {{ [key: string]: string; }}
     * @memberof GetPhotoSizeDto
     */
    'name': { [key: string]: string; };
    /**
     * Pixel width of the photo
     * @type {number}
     * @memberof GetPhotoSizeDto
     */
    'pixelWidth': number;
    /**
     * Pixel height of the photo
     * @type {number}
     * @memberof GetPhotoSizeDto
     */
    'pixelHeight': number;
    /**
     * Format of the photo
     * @type {string}
     * @memberof GetPhotoSizeDto
     */
    'format': string;
    /**
     * Physical width of the photo
     * @type {number}
     * @memberof GetPhotoSizeDto
     */
    'width': number;
    /**
     * Physical height of the photo
     * @type {number}
     * @memberof GetPhotoSizeDto
     */
    'height': number;
    /**
     * Price of the photo
     * @type {number}
     * @memberof GetPhotoSizeDto
     */
    'price': number;
    /**
     * Factory price of the photo
     * @type {number}
     * @memberof GetPhotoSizeDto
     */
    'factoryPrice': number;
    /**
     * Type of paper used for the photo
     * @type {string}
     * @memberof GetPhotoSizeDto
     */
    'paper': string;
    /**
     * Pricing ladder for the photo size
     * @type {Array<PriceRangeDto>}
     * @memberof GetPhotoSizeDto
     */
    'pricingLadder': Array<PriceRangeDto>;
    /**
     * Pricing ladder for different currencies
     * @type {object}
     * @memberof GetPhotoSizeDto
     */
    'pricingLadderCurrencies': object;
    /**
     * Prices in different currencies
     * @type {{ [key: string]: number; }}
     * @memberof GetPhotoSizeDto
     */
    'priceCurrencies': { [key: string]: number; };
    /**
     * Whether premium paper is available for this photo size
     * @type {boolean}
     * @memberof GetPhotoSizeDto
     */
    'premiumPaperAvailable': boolean;
    /**
     * Premium paper price per photo in cents (default 5 cents)
     * @type {number}
     * @memberof GetPhotoSizeDto
     */
    'premiumPaperPrice': number;
    /**
     * Premium paper prices in different currencies (in cents)
     * @type {{ [key: string]: number; }}
     * @memberof GetPhotoSizeDto
     */
    'premiumPaperPriceCurrencies': { [key: string]: number; };
    /**
     * Whether white border is available for this photo size
     * @type {boolean}
     * @memberof GetPhotoSizeDto
     */
    'whiteBorderAvailable': boolean;
    /**
     * White border price per photo in cents (default 5 cents)
     * @type {number}
     * @memberof GetPhotoSizeDto
     */
    'whiteBorderPrice': number;
    /**
     * White border prices in different currencies (in cents)
     * @type {{ [key: string]: number; }}
     * @memberof GetPhotoSizeDto
     */
    'whiteBorderPriceCurrencies': { [key: string]: number; };
    /**
     * Whether black and white is available for this photo size
     * @type {boolean}
     * @memberof GetPhotoSizeDto
     */
    'blackAndWhiteAvailable': boolean;
    /**
     * Black and white price per photo in cents (default 5 cents)
     * @type {number}
     * @memberof GetPhotoSizeDto
     */
    'blackAndWhitePrice': number;
    /**
     * Black and white prices in different currencies (in cents)
     * @type {{ [key: string]: number; }}
     * @memberof GetPhotoSizeDto
     */
    'blackAndWhitePriceCurrencies': { [key: string]: number; };
    /**
     * Optional preview photo shown on the photo-size selector in the order flow
     * @type {object}
     * @memberof GetPhotoSizeDto
     */
    'previewPhoto'?: object;
    /**
     * FK to the preview photo entity
     * @type {string}
     * @memberof GetPhotoSizeDto
     */
    'previewPhotoId'?: string;
    /**
     * When true, hidden from the public photo-size list
     * @type {boolean}
     * @memberof GetPhotoSizeDto
     */
    'hidden'?: boolean;
    /**
     * Optional id of another photo size to compare against for combo savings
     * @type {string}
     * @memberof GetPhotoSizeDto
     */
    'compareAtPhotoSizeId'?: string;
}
/**
 * 
 * @export
 * @interface GetPostDto
 */
export interface GetPostDto {
    /**
     * The unique identifier of the entity.
     * @type {string}
     * @memberof GetPostDto
     */
    'id': string;
    /**
     * The creation date of the entity.
     * @type {string}
     * @memberof GetPostDto
     */
    'createdAt': string;
    /**
     * The last update date of the entity.
     * @type {string}
     * @memberof GetPostDto
     */
    'updatedAt': string;
    /**
     * 
     * @type {string}
     * @memberof GetPostDto
     */
    'category': GetPostDtoCategoryEnum;
    /**
     * Localized title (one entry per locale)
     * @type {{ [key: string]: string; }}
     * @memberof GetPostDto
     */
    'title': { [key: string]: string; };
    /**
     * Localized excerpt (one entry per locale)
     * @type {{ [key: string]: string; }}
     * @memberof GetPostDto
     */
    'excerpt': { [key: string]: string; };
    /**
     * Localized HTML body (one entry per locale)
     * @type {{ [key: string]: string; }}
     * @memberof GetPostDto
     */
    'body': { [key: string]: string; };
    /**
     * Localized hero image URL (one entry per locale)
     * @type {{ [key: string]: string; }}
     * @memberof GetPostDto
     */
    'imageUrl': { [key: string]: string; } | null;
    /**
     * Localized CTA destination URL (one entry per locale)
     * @type {{ [key: string]: string; }}
     * @memberof GetPostDto
     */
    'ctaUrl': { [key: string]: string; } | null;
    /**
     * Localized CTA label (one entry per locale)
     * @type {{ [key: string]: string; }}
     * @memberof GetPostDto
     */
    'ctaLabel': { [key: string]: string; } | null;
    /**
     * Locales the post is targeted at; null = all
     * @type {Array<string>}
     * @memberof GetPostDto
     */
    'audience': Array<string> | null;
    /**
     * 
     * @type {string}
     * @memberof GetPostDto
     */
    'publishedAt': string;
    /**
     * 
     * @type {string}
     * @memberof GetPostDto
     */
    'expiresAt': string | null;
    /**
     * 
     * @type {boolean}
     * @memberof GetPostDto
     */
    'active': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetPostDto
     */
    'pinned': boolean;
}

export const GetPostDtoCategoryEnum = {
    News: 'news',
    Promo: 'promo',
    Tip: 'tip',
    Update: 'update'
} as const;

export type GetPostDtoCategoryEnum = typeof GetPostDtoCategoryEnum[keyof typeof GetPostDtoCategoryEnum];

/**
 * 
 * @export
 * @interface GetProductDto
 */
export interface GetProductDto {
    /**
     * 
     * @type {string}
     * @memberof GetProductDto
     */
    'id': string;
    /**
     * Localized names of the product
     * @type {{ [key: string]: string; }}
     * @memberof GetProductDto
     */
    'name': { [key: string]: string; };
    /**
     * Localized descriptions of the product
     * @type {{ [key: string]: string; }}
     * @memberof GetProductDto
     */
    'description': { [key: string]: string; };
    /**
     * 
     * @type {number}
     * @memberof GetProductDto
     */
    'price': number;
    /**
     * 
     * @type {{ [key: string]: number; }}
     * @memberof GetProductDto
     */
    'priceCurrencies': { [key: string]: number; };
    /**
     * 
     * @type {Array<GetPhotoDto>}
     * @memberof GetProductDto
     */
    'photos': Array<GetPhotoDto>;
    /**
     * 
     * @type {boolean}
     * @memberof GetProductDto
     */
    'active': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetProductDto
     */
    'featured': boolean;
    /**
     * 
     * @type {number}
     * @memberof GetProductDto
     */
    'pricePerUnit': number;
    /**
     * 
     * @type {number}
     * @memberof GetProductDto
     */
    'nOfUnits': number;
    /**
     * 
     * @type {number}
     * @memberof GetProductDto
     */
    'actionPrice': number;
    /**
     * 
     * @type {{ [key: string]: number; }}
     * @memberof GetProductDto
     */
    'actionPriceCurrencies': { [key: string]: number; };
    /**
     * 
     * @type {string}
     * @memberof GetProductDto
     */
    'pantheonCode'?: string;
    /**
     * 
     * @type {Array<GetProductTagDto>}
     * @memberof GetProductDto
     */
    'tags': Array<GetProductTagDto>;
    /**
     * 
     * @type {number}
     * @memberof GetProductDto
     */
    'rank': number;
    /**
     * 
     * @type {number}
     * @memberof GetProductDto
     */
    'capacity'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof GetProductDto
     */
    'photoSize'?: string | null;
}
/**
 * 
 * @export
 * @interface GetProductTagDto
 */
export interface GetProductTagDto {
    /**
     * The unique identifier of the entity.
     * @type {string}
     * @memberof GetProductTagDto
     */
    'id': string;
    /**
     * The creation date of the entity.
     * @type {string}
     * @memberof GetProductTagDto
     */
    'createdAt': string;
    /**
     * The last update date of the entity.
     * @type {string}
     * @memberof GetProductTagDto
     */
    'updatedAt': string;
    /**
     * Localized names of the product
     * @type {{ [key: string]: string; }}
     * @memberof GetProductTagDto
     */
    'name': { [key: string]: string; };
    /**
     * Localized descriptions of the product
     * @type {{ [key: string]: string; }}
     * @memberof GetProductTagDto
     */
    'description': { [key: string]: string; };
    /**
     * 
     * @type {string}
     * @memberof GetProductTagDto
     */
    'tag': string;
    /**
     * 
     * @type {Array<GetProductDto>}
     * @memberof GetProductTagDto
     */
    'products': Array<GetProductDto>;
    /**
     * 
     * @type {number}
     * @memberof GetProductTagDto
     */
    'rank': number;
}
/**
 * 
 * @export
 * @interface GetProductWithMediaItemDto
 */
export interface GetProductWithMediaItemDto {
    /**
     * 
     * @type {string}
     * @memberof GetProductWithMediaItemDto
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof GetProductWithMediaItemDto
     */
    'slotKey': string;
    /**
     * 
     * @type {number}
     * @memberof GetProductWithMediaItemDto
     */
    'rank': number;
    /**
     * 
     * @type {string}
     * @memberof GetProductWithMediaItemDto
     */
    'previewKey'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetProductWithMediaItemDto
     */
    'renderKey'?: string | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof GetProductWithMediaItemDto
     */
    'sourcePhotoKeys': Array<string>;
    /**
     * 
     * @type {object}
     * @memberof GetProductWithMediaItemDto
     */
    'designData'?: object | null;
}
/**
 * 
 * @export
 * @interface GetProductWithMediaOrderDto
 */
export interface GetProductWithMediaOrderDto {
    /**
     * 
     * @type {string}
     * @memberof GetProductWithMediaOrderDto
     */
    'id': string;
    /**
     * 
     * @type {number}
     * @memberof GetProductWithMediaOrderDto
     */
    'quantity': number;
    /**
     * 
     * @type {number}
     * @memberof GetProductWithMediaOrderDto
     */
    'price': number;
    /**
     * 
     * @type {number}
     * @memberof GetProductWithMediaOrderDto
     */
    'discount': number;
    /**
     * 
     * @type {object}
     * @memberof GetProductWithMediaOrderDto
     */
    'definition'?: object;
    /**
     * 
     * @type {Array<GetProductWithMediaItemDto>}
     * @memberof GetProductWithMediaOrderDto
     */
    'media': Array<GetProductWithMediaItemDto>;
}
/**
 * 
 * @export
 * @interface GetUserDto
 */
export interface GetUserDto {
    /**
     * The unique identifier of the entity.
     * @type {string}
     * @memberof GetUserDto
     */
    'id': string;
    /**
     * The creation date of the entity.
     * @type {string}
     * @memberof GetUserDto
     */
    'createdAt': string;
    /**
     * The last update date of the entity.
     * @type {string}
     * @memberof GetUserDto
     */
    'updatedAt': string;
    /**
     * Email address of the user
     * @type {string}
     * @memberof GetUserDto
     */
    'email': string;
    /**
     * Verification status of the user
     * @type {boolean}
     * @memberof GetUserDto
     */
    'verified': boolean;
    /**
     * Role of the user
     * @type {string}
     * @memberof GetUserDto
     */
    'role': string;
    /**
     * 
     * @type {GetUserDtoShippingAddress}
     * @memberof GetUserDto
     */
    'shippingAddress'?: GetUserDtoShippingAddress | null;
}
/**
 * The customer\'s saved delivery address, or null when they have not saved one
 * @export
 * @interface GetUserDtoShippingAddress
 */
export interface GetUserDtoShippingAddress {
    /**
     * 
     * @type {string}
     * @memberof GetUserDtoShippingAddress
     */
    'firstName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetUserDtoShippingAddress
     */
    'lastName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetUserDtoShippingAddress
     */
    'email'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetUserDtoShippingAddress
     */
    'phone'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetUserDtoShippingAddress
     */
    'address1'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetUserDtoShippingAddress
     */
    'address2'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetUserDtoShippingAddress
     */
    'zip'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetUserDtoShippingAddress
     */
    'city'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetUserDtoShippingAddress
     */
    'country'?: string | null;
}
/**
 * 
 * @export
 * @interface GiftCardOrderCreatedDto
 */
export interface GiftCardOrderCreatedDto {
    /**
     * 
     * @type {string}
     * @memberof GiftCardOrderCreatedDto
     */
    'orderId': string;
    /**
     * Guest session for this order — the same token POST /order/user-order issues.
     * @type {string}
     * @memberof GiftCardOrderCreatedDto
     */
    'guestSessionToken': string;
}
/**
 * 
 * @export
 * @interface InsightsResponseDto
 */
export interface InsightsResponseDto {
    /**
     * 
     * @type {FulfillmentFunnelDto}
     * @memberof InsightsResponseDto
     */
    'fulfillmentFunnel': FulfillmentFunnelDto;
    /**
     * 
     * @type {DeliverySpeedDto}
     * @memberof InsightsResponseDto
     */
    'deliverySpeed': DeliverySpeedDto;
    /**
     * 
     * @type {RepeatCustomersDto}
     * @memberof InsightsResponseDto
     */
    'repeatCustomers': RepeatCustomersDto;
    /**
     * Revenue breakdown by currency
     * @type {Array<CurrencyBreakdownEntryDto>}
     * @memberof InsightsResponseDto
     */
    'currencyBreakdown': Array<CurrencyBreakdownEntryDto>;
    /**
     * 
     * @type {AbandonedCartConversionDto}
     * @memberof InsightsResponseDto
     */
    'abandonedCartConversion': AbandonedCartConversionDto;
}
/**
 * 
 * @export
 * @interface InvoiceControllerCreateCreditNote201Response
 */
export interface InvoiceControllerCreateCreditNote201Response {
    /**
     * 
     * @type {string}
     * @memberof InvoiceControllerCreateCreditNote201Response
     */
    'creditNoteId'?: string;
    /**
     * 
     * @type {string}
     * @memberof InvoiceControllerCreateCreditNote201Response
     */
    'creditNoteNumber'?: string;
    /**
     * 
     * @type {string}
     * @memberof InvoiceControllerCreateCreditNote201Response
     */
    'originalInvoiceId'?: string;
    /**
     * 
     * @type {string}
     * @memberof InvoiceControllerCreateCreditNote201Response
     */
    'message'?: string;
}
/**
 * 
 * @export
 * @interface InvoiceControllerCreateInvoiceFromOrder201Response
 */
export interface InvoiceControllerCreateInvoiceFromOrder201Response {
    /**
     * 
     * @type {string}
     * @memberof InvoiceControllerCreateInvoiceFromOrder201Response
     */
    'invoiceId'?: string;
    /**
     * 
     * @type {string}
     * @memberof InvoiceControllerCreateInvoiceFromOrder201Response
     */
    'invoiceNumber'?: string;
    /**
     * 
     * @type {string}
     * @memberof InvoiceControllerCreateInvoiceFromOrder201Response
     */
    'message'?: string;
}
/**
 * 
 * @export
 * @interface InvoiceControllerFiscalizeInvoice200Response
 */
export interface InvoiceControllerFiscalizeInvoice200Response {
    /**
     * 
     * @type {string}
     * @memberof InvoiceControllerFiscalizeInvoice200Response
     */
    'message'?: string;
    /**
     * 
     * @type {string}
     * @memberof InvoiceControllerFiscalizeInvoice200Response
     */
    'fiscalizationStatus'?: string;
    /**
     * 
     * @type {string}
     * @memberof InvoiceControllerFiscalizeInvoice200Response
     */
    'eor'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof InvoiceControllerFiscalizeInvoice200Response
     */
    'zoi'?: string | null;
}
/**
 * 
 * @export
 * @interface InvoiceControllerFiscalizePendingInvoices200Response
 */
export interface InvoiceControllerFiscalizePendingInvoices200Response {
    /**
     * 
     * @type {string}
     * @memberof InvoiceControllerFiscalizePendingInvoices200Response
     */
    'message'?: string;
    /**
     * 
     * @type {number}
     * @memberof InvoiceControllerFiscalizePendingInvoices200Response
     */
    'processed'?: number;
    /**
     * 
     * @type {number}
     * @memberof InvoiceControllerFiscalizePendingInvoices200Response
     */
    'successful'?: number;
    /**
     * 
     * @type {number}
     * @memberof InvoiceControllerFiscalizePendingInvoices200Response
     */
    'failed'?: number;
}
/**
 * 
 * @export
 * @interface InvoiceControllerGetBusinessPremises200Response
 */
export interface InvoiceControllerGetBusinessPremises200Response {
    /**
     * 
     * @type {Array<InvoiceControllerGetBusinessPremises200ResponseBusinessPremisesInner>}
     * @memberof InvoiceControllerGetBusinessPremises200Response
     */
    'businessPremises'?: Array<InvoiceControllerGetBusinessPremises200ResponseBusinessPremisesInner>;
}
/**
 * 
 * @export
 * @interface InvoiceControllerGetBusinessPremises200ResponseBusinessPremisesInner
 */
export interface InvoiceControllerGetBusinessPremises200ResponseBusinessPremisesInner {
    /**
     * 
     * @type {string}
     * @memberof InvoiceControllerGetBusinessPremises200ResponseBusinessPremisesInner
     */
    'id'?: string;
    /**
     * 
     * @type {string}
     * @memberof InvoiceControllerGetBusinessPremises200ResponseBusinessPremisesInner
     */
    'businessPremiseId'?: string;
    /**
     * 
     * @type {string}
     * @memberof InvoiceControllerGetBusinessPremises200ResponseBusinessPremisesInner
     */
    'name'?: string;
    /**
     * 
     * @type {string}
     * @memberof InvoiceControllerGetBusinessPremises200ResponseBusinessPremisesInner
     */
    'address'?: string;
    /**
     * 
     * @type {string}
     * @memberof InvoiceControllerGetBusinessPremises200ResponseBusinessPremisesInner
     */
    'city'?: string;
    /**
     * 
     * @type {string}
     * @memberof InvoiceControllerGetBusinessPremises200ResponseBusinessPremisesInner
     */
    'zipCode'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof InvoiceControllerGetBusinessPremises200ResponseBusinessPremisesInner
     */
    'isActive'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof InvoiceControllerGetBusinessPremises200ResponseBusinessPremisesInner
     */
    'isRegisteredWithFurs'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof InvoiceControllerGetBusinessPremises200ResponseBusinessPremisesInner
     */
    'registeredAt'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof InvoiceControllerGetBusinessPremises200ResponseBusinessPremisesInner
     */
    'fursRegistrationError'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof InvoiceControllerGetBusinessPremises200ResponseBusinessPremisesInner
     */
    'electronicDevicesCount'?: number;
}
/**
 * 
 * @export
 * @interface InvoiceControllerGetElectronicDevices200Response
 */
export interface InvoiceControllerGetElectronicDevices200Response {
    /**
     * 
     * @type {Array<InvoiceControllerGetElectronicDevices200ResponseElectronicDevicesInner>}
     * @memberof InvoiceControllerGetElectronicDevices200Response
     */
    'electronicDevices'?: Array<InvoiceControllerGetElectronicDevices200ResponseElectronicDevicesInner>;
}
/**
 * 
 * @export
 * @interface InvoiceControllerGetElectronicDevices200ResponseElectronicDevicesInner
 */
export interface InvoiceControllerGetElectronicDevices200ResponseElectronicDevicesInner {
    /**
     * 
     * @type {string}
     * @memberof InvoiceControllerGetElectronicDevices200ResponseElectronicDevicesInner
     */
    'id'?: string;
    /**
     * 
     * @type {string}
     * @memberof InvoiceControllerGetElectronicDevices200ResponseElectronicDevicesInner
     */
    'electronicDeviceId'?: string;
    /**
     * 
     * @type {string}
     * @memberof InvoiceControllerGetElectronicDevices200ResponseElectronicDevicesInner
     */
    'name'?: string;
    /**
     * 
     * @type {string}
     * @memberof InvoiceControllerGetElectronicDevices200ResponseElectronicDevicesInner
     */
    'description'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof InvoiceControllerGetElectronicDevices200ResponseElectronicDevicesInner
     */
    'isActive'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof InvoiceControllerGetElectronicDevices200ResponseElectronicDevicesInner
     */
    'isRegisteredWithFurs'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof InvoiceControllerGetElectronicDevices200ResponseElectronicDevicesInner
     */
    'registeredAt'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof InvoiceControllerGetElectronicDevices200ResponseElectronicDevicesInner
     */
    'fursRegistrationError'?: string | null;
    /**
     * 
     * @type {InvoiceControllerGetElectronicDevices200ResponseElectronicDevicesInnerBusinessPremise}
     * @memberof InvoiceControllerGetElectronicDevices200ResponseElectronicDevicesInner
     */
    'businessPremise'?: InvoiceControllerGetElectronicDevices200ResponseElectronicDevicesInnerBusinessPremise;
}
/**
 * 
 * @export
 * @interface InvoiceControllerGetElectronicDevices200ResponseElectronicDevicesInnerBusinessPremise
 */
export interface InvoiceControllerGetElectronicDevices200ResponseElectronicDevicesInnerBusinessPremise {
    /**
     * 
     * @type {string}
     * @memberof InvoiceControllerGetElectronicDevices200ResponseElectronicDevicesInnerBusinessPremise
     */
    'id'?: string;
    /**
     * 
     * @type {string}
     * @memberof InvoiceControllerGetElectronicDevices200ResponseElectronicDevicesInnerBusinessPremise
     */
    'businessPremiseId'?: string;
    /**
     * 
     * @type {string}
     * @memberof InvoiceControllerGetElectronicDevices200ResponseElectronicDevicesInnerBusinessPremise
     */
    'name'?: string;
}
/**
 * 
 * @export
 * @interface InvoiceControllerGetFiscalizationStatus200Response
 */
export interface InvoiceControllerGetFiscalizationStatus200Response {
    /**
     * 
     * @type {boolean}
     * @memberof InvoiceControllerGetFiscalizationStatus200Response
     */
    'configured'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof InvoiceControllerGetFiscalizationStatus200Response
     */
    'environment'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof InvoiceControllerGetFiscalizationStatus200Response
     */
    'certificateExists'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof InvoiceControllerGetFiscalizationStatus200Response
     */
    'pendingInvoices'?: number;
    /**
     * 
     * @type {number}
     * @memberof InvoiceControllerGetFiscalizationStatus200Response
     */
    'failedInvoices'?: number;
}
/**
 * 
 * @export
 * @interface InvoiceControllerGetFursDebugInfo200Response
 */
export interface InvoiceControllerGetFursDebugInfo200Response {
    /**
     * 
     * @type {InvoiceControllerGetFursDebugInfo200ResponseInvoice}
     * @memberof InvoiceControllerGetFursDebugInfo200Response
     */
    'invoice'?: InvoiceControllerGetFursDebugInfo200ResponseInvoice;
    /**
     * 
     * @type {object}
     * @memberof InvoiceControllerGetFursDebugInfo200Response
     */
    'businessPremise'?: object | null;
    /**
     * 
     * @type {object}
     * @memberof InvoiceControllerGetFursDebugInfo200Response
     */
    'electronicDevice'?: object | null;
    /**
     * 
     * @type {object}
     * @memberof InvoiceControllerGetFursDebugInfo200Response
     */
    'fursSystemStatus'?: object;
}
/**
 * 
 * @export
 * @interface InvoiceControllerGetFursDebugInfo200ResponseInvoice
 */
export interface InvoiceControllerGetFursDebugInfo200ResponseInvoice {
    /**
     * 
     * @type {string}
     * @memberof InvoiceControllerGetFursDebugInfo200ResponseInvoice
     */
    'id'?: string;
    /**
     * 
     * @type {string}
     * @memberof InvoiceControllerGetFursDebugInfo200ResponseInvoice
     */
    'invoiceNumber'?: string;
    /**
     * 
     * @type {string}
     * @memberof InvoiceControllerGetFursDebugInfo200ResponseInvoice
     */
    'businessPremiseId'?: string;
    /**
     * 
     * @type {string}
     * @memberof InvoiceControllerGetFursDebugInfo200ResponseInvoice
     */
    'electronicDeviceIdValue'?: string;
    /**
     * 
     * @type {string}
     * @memberof InvoiceControllerGetFursDebugInfo200ResponseInvoice
     */
    'fiscalizationStatus'?: string;
    /**
     * 
     * @type {string}
     * @memberof InvoiceControllerGetFursDebugInfo200ResponseInvoice
     */
    'fiscalizationError'?: string | null;
}
/**
 * 
 * @export
 * @interface InvoiceControllerGetInvoiceStatistics200Response
 */
export interface InvoiceControllerGetInvoiceStatistics200Response {
    /**
     * 
     * @type {number}
     * @memberof InvoiceControllerGetInvoiceStatistics200Response
     */
    'totalInvoices'?: number;
    /**
     * 
     * @type {number}
     * @memberof InvoiceControllerGetInvoiceStatistics200Response
     */
    'totalAmount'?: number;
    /**
     * 
     * @type {number}
     * @memberof InvoiceControllerGetInvoiceStatistics200Response
     */
    'fiscalizedCount'?: number;
    /**
     * 
     * @type {number}
     * @memberof InvoiceControllerGetInvoiceStatistics200Response
     */
    'pendingCount'?: number;
    /**
     * 
     * @type {number}
     * @memberof InvoiceControllerGetInvoiceStatistics200Response
     */
    'failedCount'?: number;
}
/**
 * 
 * @export
 * @interface InvoiceControllerGetInvoiceStatusForOrder200Response
 */
export interface InvoiceControllerGetInvoiceStatusForOrder200Response {
    /**
     * 
     * @type {boolean}
     * @memberof InvoiceControllerGetInvoiceStatusForOrder200Response
     */
    'hasInvoice'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof InvoiceControllerGetInvoiceStatusForOrder200Response
     */
    'canCreateNew'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof InvoiceControllerGetInvoiceStatusForOrder200Response
     */
    'requiresCreditNote'?: boolean;
    /**
     * 
     * @type {InvoiceControllerGetInvoiceStatusForOrder200ResponseCurrentInvoice}
     * @memberof InvoiceControllerGetInvoiceStatusForOrder200Response
     */
    'currentInvoice'?: InvoiceControllerGetInvoiceStatusForOrder200ResponseCurrentInvoice | null;
    /**
     * 
     * @type {Array<InvoiceControllerGetInvoiceStatusForOrder200ResponseCreditNotesInner>}
     * @memberof InvoiceControllerGetInvoiceStatusForOrder200Response
     */
    'creditNotes'?: Array<InvoiceControllerGetInvoiceStatusForOrder200ResponseCreditNotesInner>;
}
/**
 * 
 * @export
 * @interface InvoiceControllerGetInvoiceStatusForOrder200ResponseCreditNotesInner
 */
export interface InvoiceControllerGetInvoiceStatusForOrder200ResponseCreditNotesInner {
    /**
     * 
     * @type {string}
     * @memberof InvoiceControllerGetInvoiceStatusForOrder200ResponseCreditNotesInner
     */
    'id'?: string;
    /**
     * 
     * @type {string}
     * @memberof InvoiceControllerGetInvoiceStatusForOrder200ResponseCreditNotesInner
     */
    'creditNoteNumber'?: string;
    /**
     * 
     * @type {string}
     * @memberof InvoiceControllerGetInvoiceStatusForOrder200ResponseCreditNotesInner
     */
    'createdAt'?: string;
}
/**
 * 
 * @export
 * @interface InvoiceControllerGetInvoiceStatusForOrder200ResponseCurrentInvoice
 */
export interface InvoiceControllerGetInvoiceStatusForOrder200ResponseCurrentInvoice {
    /**
     * 
     * @type {string}
     * @memberof InvoiceControllerGetInvoiceStatusForOrder200ResponseCurrentInvoice
     */
    'id'?: string;
    /**
     * 
     * @type {string}
     * @memberof InvoiceControllerGetInvoiceStatusForOrder200ResponseCurrentInvoice
     */
    'invoiceNumber'?: string;
    /**
     * 
     * @type {string}
     * @memberof InvoiceControllerGetInvoiceStatusForOrder200ResponseCurrentInvoice
     */
    'fiscalizationStatus'?: string;
    /**
     * 
     * @type {string}
     * @memberof InvoiceControllerGetInvoiceStatusForOrder200ResponseCurrentInvoice
     */
    'createdAt'?: string;
}
/**
 * 
 * @export
 * @interface InvoiceControllerRegenerateInvoicePdf200Response
 */
export interface InvoiceControllerRegenerateInvoicePdf200Response {
    /**
     * 
     * @type {string}
     * @memberof InvoiceControllerRegenerateInvoicePdf200Response
     */
    'message'?: string;
    /**
     * 
     * @type {string}
     * @memberof InvoiceControllerRegenerateInvoicePdf200Response
     */
    'invoiceNumber'?: string;
    /**
     * 
     * @type {string}
     * @memberof InvoiceControllerRegenerateInvoicePdf200Response
     */
    'filePath'?: string;
}
/**
 * 
 * @export
 * @interface InvoiceControllerRegisterBusinessPremise201Response
 */
export interface InvoiceControllerRegisterBusinessPremise201Response {
    /**
     * 
     * @type {boolean}
     * @memberof InvoiceControllerRegisterBusinessPremise201Response
     */
    'success'?: boolean;
    /**
     * 
     * @type {InvoiceControllerRegisterBusinessPremise201ResponseBusinessPremise}
     * @memberof InvoiceControllerRegisterBusinessPremise201Response
     */
    'businessPremise'?: InvoiceControllerRegisterBusinessPremise201ResponseBusinessPremise;
    /**
     * 
     * @type {object}
     * @memberof InvoiceControllerRegisterBusinessPremise201Response
     */
    'fursResponse'?: object;
    /**
     * 
     * @type {string}
     * @memberof InvoiceControllerRegisterBusinessPremise201Response
     */
    'message'?: string;
}
/**
 * 
 * @export
 * @interface InvoiceControllerRegisterBusinessPremise201ResponseBusinessPremise
 */
export interface InvoiceControllerRegisterBusinessPremise201ResponseBusinessPremise {
    /**
     * 
     * @type {string}
     * @memberof InvoiceControllerRegisterBusinessPremise201ResponseBusinessPremise
     */
    'id'?: string;
    /**
     * 
     * @type {string}
     * @memberof InvoiceControllerRegisterBusinessPremise201ResponseBusinessPremise
     */
    'businessPremiseId'?: string;
    /**
     * 
     * @type {string}
     * @memberof InvoiceControllerRegisterBusinessPremise201ResponseBusinessPremise
     */
    'name'?: string;
    /**
     * 
     * @type {string}
     * @memberof InvoiceControllerRegisterBusinessPremise201ResponseBusinessPremise
     */
    'address'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof InvoiceControllerRegisterBusinessPremise201ResponseBusinessPremise
     */
    'isRegisteredWithFurs'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof InvoiceControllerRegisterBusinessPremise201ResponseBusinessPremise
     */
    'registeredAt'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof InvoiceControllerRegisterBusinessPremise201ResponseBusinessPremise
     */
    'fursRegistrationError'?: string | null;
}
/**
 * 
 * @export
 * @interface InvoiceCustomerDetailsDto
 */
export interface InvoiceCustomerDetailsDto {
    /**
     * Customer name
     * @type {string}
     * @memberof InvoiceCustomerDetailsDto
     */
    'name': string;
    /**
     * Customer email
     * @type {string}
     * @memberof InvoiceCustomerDetailsDto
     */
    'email': string;
    /**
     * Customer address
     * @type {string}
     * @memberof InvoiceCustomerDetailsDto
     */
    'address': string;
    /**
     * Customer city
     * @type {string}
     * @memberof InvoiceCustomerDetailsDto
     */
    'city': string;
    /**
     * Customer zip code
     * @type {string}
     * @memberof InvoiceCustomerDetailsDto
     */
    'zipCode'?: string;
    /**
     * Customer country
     * @type {string}
     * @memberof InvoiceCustomerDetailsDto
     */
    'country'?: string;
    /**
     * Customer tax number
     * @type {string}
     * @memberof InvoiceCustomerDetailsDto
     */
    'taxNumber'?: string;
}
/**
 * 
 * @export
 * @interface InvoiceItemDto
 */
export interface InvoiceItemDto {
    /**
     * Item description
     * @type {string}
     * @memberof InvoiceItemDto
     */
    'description': string;
    /**
     * Quantity
     * @type {number}
     * @memberof InvoiceItemDto
     */
    'quantity': number;
    /**
     * Unit price in EUR
     * @type {number}
     * @memberof InvoiceItemDto
     */
    'unitPrice': number;
    /**
     * Total price for this item
     * @type {number}
     * @memberof InvoiceItemDto
     */
    'totalPrice': number;
    /**
     * Discount amount for this item
     * @type {number}
     * @memberof InvoiceItemDto
     */
    'discount': number;
    /**
     * VAT rate in percentage
     * @type {number}
     * @memberof InvoiceItemDto
     */
    'vatRate': number;
    /**
     * VAT amount for this item
     * @type {number}
     * @memberof InvoiceItemDto
     */
    'vatAmount': number;
}
/**
 * 
 * @export
 * @interface InvoiceOverridesDto
 */
export interface InvoiceOverridesDto {
    /**
     * Override invoice number
     * @type {string}
     * @memberof InvoiceOverridesDto
     */
    'invoiceNumber'?: string;
    /**
     * Override customer details
     * @type {object}
     * @memberof InvoiceOverridesDto
     */
    'customer'?: object;
    /**
     * Override invoice items
     * @type {Array<InvoiceItemDto>}
     * @memberof InvoiceOverridesDto
     */
    'items'?: Array<InvoiceItemDto>;
    /**
     * Override subtotal amount
     * @type {number}
     * @memberof InvoiceOverridesDto
     */
    'subtotal'?: number;
    /**
     * Override VAT amount
     * @type {number}
     * @memberof InvoiceOverridesDto
     */
    'vatAmount'?: number;
    /**
     * Override total amount
     * @type {number}
     * @memberof InvoiceOverridesDto
     */
    'totalAmount'?: number;
    /**
     * Override shipping cost
     * @type {number}
     * @memberof InvoiceOverridesDto
     */
    'shippingCost'?: number;
    /**
     * Override discount amount
     * @type {number}
     * @memberof InvoiceOverridesDto
     */
    'discountAmount'?: number;
    /**
     * Custom notes to add to invoice
     * @type {string}
     * @memberof InvoiceOverridesDto
     */
    'notes'?: string;
    /**
     * Language for the invoice
     * @type {string}
     * @memberof InvoiceOverridesDto
     */
    'language'?: string;
}
/**
 * 
 * @export
 * @interface InvoicePreviewDto
 */
export interface InvoicePreviewDto {
    /**
     * Invoice number
     * @type {string}
     * @memberof InvoicePreviewDto
     */
    'invoiceNumber': string;
    /**
     * Issue date and time
     * @type {string}
     * @memberof InvoicePreviewDto
     */
    'issueDateTime': string;
    /**
     * Language code
     * @type {string}
     * @memberof InvoicePreviewDto
     */
    'language': string;
    /**
     * 
     * @type {CompanyDetailsDto}
     * @memberof InvoicePreviewDto
     */
    'company': CompanyDetailsDto;
    /**
     * 
     * @type {CustomerDetailsDto}
     * @memberof InvoicePreviewDto
     */
    'customer': CustomerDetailsDto;
    /**
     * Invoice items
     * @type {Array<InvoiceItemDto>}
     * @memberof InvoicePreviewDto
     */
    'items': Array<InvoiceItemDto>;
    /**
     * Utility items (shipping, fees, etc.)
     * @type {Array<InvoiceUtilityItemDto>}
     * @memberof InvoicePreviewDto
     */
    'utilityItems'?: Array<InvoiceUtilityItemDto>;
    /**
     * Total amount in EUR
     * @type {number}
     * @memberof InvoicePreviewDto
     */
    'totalAmount': number;
    /**
     * VAT amount in EUR
     * @type {number}
     * @memberof InvoicePreviewDto
     */
    'vatAmount': number;
    /**
     * VAT exempt amount in EUR
     * @type {number}
     * @memberof InvoicePreviewDto
     */
    'vatExemptAmount': number;
    /**
     * Part of totalAmount paid by gift card (read from the order snapshot; what was charged is totalAmount − giftCardAmount). Informational: ignored on input.
     * @type {number}
     * @memberof InvoicePreviewDto
     */
    'giftCardAmount'?: number;
    /**
     * Payment method
     * @type {number}
     * @memberof InvoicePreviewDto
     */
    'paymentMethod': InvoicePreviewDtoPaymentMethodEnum;
    /**
     * Business premise ID
     * @type {string}
     * @memberof InvoicePreviewDto
     */
    'businessPremiseId'?: string;
    /**
     * Electronic device ID
     * @type {string}
     * @memberof InvoicePreviewDto
     */
    'electronicDeviceId'?: string;
    /**
     * Is this an EU transaction
     * @type {boolean}
     * @memberof InvoicePreviewDto
     */
    'isEuTransaction'?: boolean;
    /**
     * Notes or special remarks
     * @type {string}
     * @memberof InvoicePreviewDto
     */
    'notes'?: string;
}

export const InvoicePreviewDtoPaymentMethodEnum = {
    NUMBER_1: 1,
    NUMBER_2: 2,
    NUMBER_3: 3,
    NUMBER_4: 4
} as const;

export type InvoicePreviewDtoPaymentMethodEnum = typeof InvoicePreviewDtoPaymentMethodEnum[keyof typeof InvoicePreviewDtoPaymentMethodEnum];

/**
 * 
 * @export
 * @interface InvoiceUtilityItemDto
 */
export interface InvoiceUtilityItemDto {
    /**
     * Type of utility item
     * @type {string}
     * @memberof InvoiceUtilityItemDto
     */
    'type': InvoiceUtilityItemDtoTypeEnum;
    /**
     * Description of the utility item
     * @type {string}
     * @memberof InvoiceUtilityItemDto
     */
    'description': string;
    /**
     * Price in EUR
     * @type {number}
     * @memberof InvoiceUtilityItemDto
     */
    'price': number;
    /**
     * VAT rate in percentage
     * @type {number}
     * @memberof InvoiceUtilityItemDto
     */
    'vatRate': number;
    /**
     * VAT amount
     * @type {number}
     * @memberof InvoiceUtilityItemDto
     */
    'vatAmount': number;
}

export const InvoiceUtilityItemDtoTypeEnum = {
    Shipping: 'SHIPPING',
    PaymentOnDelivery: 'PAYMENT_ON_DELIVERY',
    EcologicalPackaging: 'ECOLOGICAL_PACKAGING',
    PriorityComplaint: 'PRIORITY_COMPLAINT',
    WrapAsGift: 'WRAP_AS_GIFT',
    ExpressDelivery: 'EXPRESS_DELIVERY',
    PremiumPaper: 'PREMIUM_PAPER',
    ProfessionalCrop: 'PROFESSIONAL_CROP',
    WhiteBorder: 'WHITE_BORDER',
    BlackAndWhite: 'BLACK_AND_WHITE',
    Other: 'OTHER'
} as const;

export type InvoiceUtilityItemDtoTypeEnum = typeof InvoiceUtilityItemDtoTypeEnum[keyof typeof InvoiceUtilityItemDtoTypeEnum];

/**
 * 
 * @export
 * @interface JoinPartyDto
 */
export interface JoinPartyDto {
    /**
     * 
     * @type {string}
     * @memberof JoinPartyDto
     */
    'displayName': string;
    /**
     * 
     * @type {boolean}
     * @memberof JoinPartyDto
     */
    'consent': boolean;
    /**
     * 
     * @type {string}
     * @memberof JoinPartyDto
     */
    'email'?: string;
}
/**
 * 
 * @export
 * @interface LastTouchTemplateDto
 */
export interface LastTouchTemplateDto {
    /**
     * Email template key
     * @type {string}
     * @memberof LastTouchTemplateDto
     */
    'templateKey': string;
    /**
     * Orders last-touch attributed to this template
     * @type {number}
     * @memberof LastTouchTemplateDto
     */
    'orders': number;
    /**
     * EUR revenue last-touch attributed (de-duplicated)
     * @type {number}
     * @memberof LastTouchTemplateDto
     */
    'revenueEur': number;
}
/**
 * 
 * @export
 * @interface LoginDto
 */
export interface LoginDto {
    /**
     * 
     * @type {string}
     * @memberof LoginDto
     */
    'username': string;
    /**
     * 
     * @type {string}
     * @memberof LoginDto
     */
    'password': string;
}
/**
 * 
 * @export
 * @interface LoginResponseDto
 */
export interface LoginResponseDto {
    /**
     * Access token for authentication
     * @type {string}
     * @memberof LoginResponseDto
     */
    'access_token': string;
    /**
     * Refresh token for renewing the access token
     * @type {string}
     * @memberof LoginResponseDto
     */
    'refresh_token': string;
}
/**
 * 
 * @export
 * @interface MapPreviewDto
 */
export interface MapPreviewDto {
    /**
     * The chosen size, as a map variant id.
     * @type {string}
     * @memberof MapPreviewDto
     */
    'variantId': string;
    /**
     * 
     * @type {MapSpecDto}
     * @memberof MapPreviewDto
     */
    'map': MapSpecDto;
    /**
     * \"full\": the whole preview. \"frame\": the still layer — ground, border, text, ring and credit, the map window transparent. \"map\": the movable layer — the map alone, overscanned past the window.
     * @type {string}
     * @memberof MapPreviewDto
     */
    'layer'?: MapPreviewDtoLayerEnum;
}

export const MapPreviewDtoLayerEnum = {
    Full: 'full',
    Map: 'map',
    Frame: 'frame'
} as const;

export type MapPreviewDtoLayerEnum = typeof MapPreviewDtoLayerEnum[keyof typeof MapPreviewDtoLayerEnum];

/**
 * 
 * @export
 * @interface MapSpecDto
 */
export interface MapSpecDto {
    /**
     * 
     * @type {number}
     * @memberof MapSpecDto
     */
    'lat': number;
    /**
     * 
     * @type {number}
     * @memberof MapSpecDto
     */
    'lon': number;
    /**
     * 
     * @type {number}
     * @memberof MapSpecDto
     */
    'radiusM': number;
    /**
     * 
     * @type {string}
     * @memberof MapSpecDto
     */
    'style': MapSpecDtoStyleEnum;
    /**
     * 
     * @type {string}
     * @memberof MapSpecDto
     */
    'shape': MapSpecDtoShapeEnum;
    /**
     * 
     * @type {string}
     * @memberof MapSpecDto
     */
    'text': MapSpecDtoTextEnum;
    /**
     * 
     * @type {string}
     * @memberof MapSpecDto
     */
    'title': string;
    /**
     * 
     * @type {boolean}
     * @memberof MapSpecDto
     */
    'border': boolean;
    /**
     * 
     * @type {string}
     * @memberof MapSpecDto
     */
    'orientation'?: MapSpecDtoOrientationEnum;
}

export const MapSpecDtoStyleEnum = {
    Classic: 'classic',
    Mono: 'mono',
    Night: 'night',
    Pastel: 'pastel'
} as const;

export type MapSpecDtoStyleEnum = typeof MapSpecDtoStyleEnum[keyof typeof MapSpecDtoStyleEnum];
export const MapSpecDtoShapeEnum = {
    Circle: 'circle',
    Full: 'full'
} as const;

export type MapSpecDtoShapeEnum = typeof MapSpecDtoShapeEnum[keyof typeof MapSpecDtoShapeEnum];
export const MapSpecDtoTextEnum = {
    None: 'none',
    Name: 'name',
    NameCoords: 'name_coords'
} as const;

export type MapSpecDtoTextEnum = typeof MapSpecDtoTextEnum[keyof typeof MapSpecDtoTextEnum];
export const MapSpecDtoOrientationEnum = {
    Portrait: 'portrait',
    Landscape: 'landscape'
} as const;

export type MapSpecDtoOrientationEnum = typeof MapSpecDtoOrientationEnum[keyof typeof MapSpecDtoOrientationEnum];

/**
 * 
 * @export
 * @interface MediaItemDto
 */
export interface MediaItemDto {
    /**
     * Slot key (matches definition.mediaSlots[].key)
     * @type {string}
     * @memberof MediaItemDto
     */
    'slotKey': string;
    /**
     * 
     * @type {number}
     * @memberof MediaItemDto
     */
    'rank'?: number;
    /**
     * Structured design JSON
     * @type {object}
     * @memberof MediaItemDto
     */
    'designData'?: object;
    /**
     * 
     * @type {Array<string>}
     * @memberof MediaItemDto
     */
    'sourcePhotoKeys'?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof MediaItemDto
     */
    'renderKey'?: string;
    /**
     * 
     * @type {string}
     * @memberof MediaItemDto
     */
    'previewKey'?: string;
}
/**
 * 
 * @export
 * @interface MediaSlotDto
 */
export interface MediaSlotDto {
    /**
     * 
     * @type {string}
     * @memberof MediaSlotDto
     */
    'key': string;
    /**
     * Localized label { locale: string }
     * @type {object}
     * @memberof MediaSlotDto
     */
    'label': object;
    /**
     * 
     * @type {MediaSlotPrintSpecDto}
     * @memberof MediaSlotDto
     */
    'printSpec': MediaSlotPrintSpecDto;
    /**
     * 
     * @type {string}
     * @memberof MediaSlotDto
     */
    'input': MediaSlotDtoInputEnum;
    /**
     * 
     * @type {Array<string>}
     * @memberof MediaSlotDto
     */
    'templates'?: Array<string>;
    /**
     * 
     * @type {boolean}
     * @memberof MediaSlotDto
     */
    'required': boolean;
}

export const MediaSlotDtoInputEnum = {
    Design: 'design',
    Upload: 'upload'
} as const;

export type MediaSlotDtoInputEnum = typeof MediaSlotDtoInputEnum[keyof typeof MediaSlotDtoInputEnum];

/**
 * 
 * @export
 * @interface MediaSlotPrintSpecDto
 */
export interface MediaSlotPrintSpecDto {
    /**
     * 
     * @type {number}
     * @memberof MediaSlotPrintSpecDto
     */
    'widthMm': number;
    /**
     * 
     * @type {number}
     * @memberof MediaSlotPrintSpecDto
     */
    'heightMm': number;
    /**
     * 
     * @type {number}
     * @memberof MediaSlotPrintSpecDto
     */
    'bleedMm': number;
    /**
     * Printable safe margin inset (mm) from trim. Default 5.
     * @type {number}
     * @memberof MediaSlotPrintSpecDto
     */
    'safeMm'?: number;
    /**
     * 
     * @type {number}
     * @memberof MediaSlotPrintSpecDto
     */
    'dpi': number;
}
/**
 * 
 * @export
 * @interface MetricsDataDto
 */
export interface MetricsDataDto {
    /**
     * Average price per order
     * @type {number}
     * @memberof MetricsDataDto
     */
    'averagePrice': number;
    /**
     * Average number of photos per order
     * @type {number}
     * @memberof MetricsDataDto
     */
    'averagePhotos': number;
    /**
     * Most popular shipping method
     * @type {string}
     * @memberof MetricsDataDto
     */
    'popularShippingMethod': string;
    /**
     * Number of successful orders
     * @type {number}
     * @memberof MetricsDataDto
     */
    'successfulOrdersCount': number;
    /**
     * Total amount (in default currency)
     * @type {number}
     * @memberof MetricsDataDto
     */
    'totalAmount': number;
    /**
     * Total amount without VAT
     * @type {number}
     * @memberof MetricsDataDto
     */
    'totalAmountWithoutVAT': number;
    /**
     * Predicted total amount for the month
     * @type {number}
     * @memberof MetricsDataDto
     */
    'totalAmountPrediction': number;
    /**
     * Predicted total amount based on last week trend
     * @type {number}
     * @memberof MetricsDataDto
     */
    'totalAmountPredictionBasedOnLastWeek': number;
    /**
     * Total amount excluding shipping costs
     * @type {number}
     * @memberof MetricsDataDto
     */
    'totalAmountWithoutShipping': number;
    /**
     * Total cost (production costs)
     * @type {number}
     * @memberof MetricsDataDto
     */
    'totalCost': number;
    /**
     * Total number of photos
     * @type {number}
     * @memberof MetricsDataDto
     */
    'totalPhotos': number;
    /**
     * Total profit
     * @type {number}
     * @memberof MetricsDataDto
     */
    'totalProfit': number;
    /**
     * Number of days in the current period
     * @type {number}
     * @memberof MetricsDataDto
     */
    'numberOfDays': number;
    /**
     * Total shipping costs
     * @type {number}
     * @memberof MetricsDataDto
     */
    'totalShipping': number;
    /**
     * Total profit excluding shipping
     * @type {number}
     * @memberof MetricsDataDto
     */
    'totalProfitWithoutShipping': number;
    /**
     * Order count by country
     * @type {{ [key: string]: number; }}
     * @memberof MetricsDataDto
     */
    'countries': { [key: string]: number; };
    /**
     * Profit by country
     * @type {{ [key: string]: number; }}
     * @memberof MetricsDataDto
     */
    'countriesProfit': { [key: string]: number; };
    /**
     * Total profit with VAT included
     * @type {number}
     * @memberof MetricsDataDto
     */
    'totalProfitWithVAT': number;
    /**
     * Total amount per coupon code
     * @type {{ [key: string]: number; }}
     * @memberof MetricsDataDto
     */
    'couponUsage': { [key: string]: number; };
    /**
     * Usage count per coupon code
     * @type {{ [key: string]: number; }}
     * @memberof MetricsDataDto
     */
    'couponUsageCount': { [key: string]: number; };
    /**
     * Order value statistics by shipping method
     * @type {{ [key: string]: any; }}
     * @memberof MetricsDataDto
     */
    'orderValueByShipping': { [key: string]: any; };
    /**
     * Count of orders by payment option
     * @type {{ [key: string]: number; }}
     * @memberof MetricsDataDto
     */
    'paymentOptionCount': { [key: string]: number; };
    /**
     * Total amount by payment option
     * @type {{ [key: string]: number; }}
     * @memberof MetricsDataDto
     */
    'paymentOptionAmount': { [key: string]: number; };
    /**
     * Total amount by product
     * @type {{ [key: string]: number; }}
     * @memberof MetricsDataDto
     */
    'productsAmount': { [key: string]: number; };
    /**
     * Count by product
     * @type {{ [key: string]: number; }}
     * @memberof MetricsDataDto
     */
    'productsCount': { [key: string]: number; };
    /**
     * Amount earned today
     * @type {number}
     * @memberof MetricsDataDto
     */
    'amountToday': number;
    /**
     * Deprecated — alias of todayAmountPredictionLinear, kept for backward compatibility
     * @type {number}
     * @memberof MetricsDataDto
     * @deprecated
     */
    'todayAmountPrediction': number;
    /**
     * Today\'s revenue prediction via linear extrapolation over the 7am–1am operational window (18 hours). Successful-only, EUR-normalised.
     * @type {number}
     * @memberof MetricsDataDto
     */
    'todayAmountPredictionLinear': number;
    /**
     * Today\'s revenue prediction as the average of same-weekday revenue over the last 4 weeks (7, 14, 21, 28 days ago). Returns 0 when fewer than 2 same-weekday samples exist in the supplied window. Successful-only, EUR-normalised.
     * @type {number}
     * @memberof MetricsDataDto
     */
    'todayAmountPredictionSameWeekday': number;
    /**
     * Today\'s revenue prediction as the average daily revenue across the last 7 full days (days -1..-7, excluding today). Successful-only, EUR-normalised.
     * @type {number}
     * @memberof MetricsDataDto
     */
    'todayAmountPredictionTrailing7d': number;
    /**
     * Current server time (ISO 8601)
     * @type {string}
     * @memberof MetricsDataDto
     */
    'currentServerTime': string;
    /**
     * Total number of calendars ordered
     * @type {number}
     * @memberof MetricsDataDto
     */
    'totalCalendars': number;
    /**
     * Count by calendar format
     * @type {{ [key: string]: number; }}
     * @memberof MetricsDataDto
     */
    'calendarsCount': { [key: string]: number; };
    /**
     * Total amount by calendar format
     * @type {{ [key: string]: number; }}
     * @memberof MetricsDataDto
     */
    'calendarsAmount': { [key: string]: number; };
    /**
     * Total production cost for calendars
     * @type {number}
     * @memberof MetricsDataDto
     */
    'totalCalendarsCost': number;
    /**
     * Total profit from calendars
     * @type {number}
     * @memberof MetricsDataDto
     */
    'totalCalendarsProfit': number;
    /**
     * Customer credit redeemed on the successful orders of the period, EUR. totalAmount is already net of it (order.amount is post-credit).
     * @type {number}
     * @memberof MetricsDataDto
     */
    'creditSpent': number;
    /**
     * 
     * @type {ProductLineSummaryDto}
     * @memberof MetricsDataDto
     */
    'enlargements': ProductLineSummaryDto;
    /**
     * 
     * @type {ProductLineSummaryDto}
     * @memberof MetricsDataDto
     */
    'invitations': ProductLineSummaryDto;
}
/**
 * 
 * @export
 * @interface MyCreditDto
 */
export interface MyCreditDto {
    /**
     * 
     * @type {Array<MyCreditTotalDto>}
     * @memberof MyCreditDto
     */
    'totals': Array<MyCreditTotalDto>;
    /**
     * Soonest expiry first.
     * @type {Array<MyCreditLotDto>}
     * @memberof MyCreditDto
     */
    'lots': Array<MyCreditLotDto>;
}
/**
 * 
 * @export
 * @interface MyCreditLotDto
 */
export interface MyCreditLotDto {
    /**
     * 
     * @type {string}
     * @memberof MyCreditLotDto
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof MyCreditLotDto
     */
    'kind': MyCreditLotDtoKindEnum;
    /**
     * A gift card\'s last four code characters; null for granted credit.
     * @type {string}
     * @memberof MyCreditLotDto
     */
    'codeHint': string | null;
    /**
     * 
     * @type {string}
     * @memberof MyCreditLotDto
     */
    'currency': string;
    /**
     * Minor units still spendable.
     * @type {number}
     * @memberof MyCreditLotDto
     */
    'remainingCents': number;
    /**
     * 
     * @type {string}
     * @memberof MyCreditLotDto
     */
    'expiresAt': string | null;
    /**
     * Minimum order goods, minor units. 0 = any order.
     * @type {number}
     * @memberof MyCreditLotDto
     */
    'minimumOrderCents': number;
    /**
     * 
     * @type {string}
     * @memberof MyCreditLotDto
     */
    'market': string | null;
}

export const MyCreditLotDtoKindEnum = {
    GiftCard: 'GIFT_CARD',
    Granted: 'GRANTED'
} as const;

export type MyCreditLotDtoKindEnum = typeof MyCreditLotDtoKindEnum[keyof typeof MyCreditLotDtoKindEnum];

/**
 * 
 * @export
 * @interface MyCreditTotalDto
 */
export interface MyCreditTotalDto {
    /**
     * 
     * @type {string}
     * @memberof MyCreditTotalDto
     */
    'currency': string;
    /**
     * Minor units spendable now.
     * @type {number}
     * @memberof MyCreditTotalDto
     */
    'balanceCents': number;
    /**
     * When the soonest-expiring part of this balance lapses.
     * @type {string}
     * @memberof MyCreditTotalDto
     */
    'nextExpiresAt': string | null;
}
/**
 * 
 * @export
 * @interface NotifyPartyDto
 */
export interface NotifyPartyDto {
    /**
     * 
     * @type {string}
     * @memberof NotifyPartyDto
     */
    'email': string;
}
/**
 * 
 * @export
 * @interface OrderBundlesDto
 */
export interface OrderBundlesDto {
    /**
     * 
     * @type {string}
     * @memberof OrderBundlesDto
     */
    'currency': string;
    /**
     * AppliedBundle: bundleId, name (localized map), times, discountCents, couponsAllowed
     * @type {Array<object>}
     * @memberof OrderBundlesDto
     */
    'applied': Array<object>;
    /**
     * 
     * @type {number}
     * @memberof OrderBundlesDto
     */
    'bundleDiscountCents': number;
    /**
     * 
     * @type {number}
     * @memberof OrderBundlesDto
     */
    'couponDiscountCents': number;
    /**
     * 
     * @type {string}
     * @memberof OrderBundlesDto
     */
    'couponBlockedByBundle': string | null;
    /**
     * SelectedBundleView (order-bundles-view.ts)
     * @type {object}
     * @memberof OrderBundlesDto
     */
    'selected': object | null;
    /**
     * BundleHintView (order-bundles-view.ts)
     * @type {object}
     * @memberof OrderBundlesDto
     */
    'hint': object | null;
    /**
     * Pakets the cart had (applied at its last pricing, or selected) that are no longer offered: { bundleId, name (localized map) }
     * @type {Array<object>}
     * @memberof OrderBundlesDto
     */
    'bundleExpired': Array<object>;
}
/**
 * 
 * @export
 * @interface OrderCashbackCouponDto
 */
export interface OrderCashbackCouponDto {
    /**
     * 
     * @type {string}
     * @memberof OrderCashbackCouponDto
     */
    'code': string;
    /**
     * Minor units; what the coupon gives on this cart.
     * @type {number}
     * @memberof OrderCashbackCouponDto
     */
    'rewardCents': number;
    /**
     * 
     * @type {number}
     * @memberof OrderCashbackCouponDto
     */
    'minimumCents': number;
    /**
     * 
     * @type {number}
     * @memberof OrderCashbackCouponDto
     */
    'missingCents': number;
    /**
     * True when the coupon is the cashback this order gets.
     * @type {boolean}
     * @memberof OrderCashbackCouponDto
     */
    'wins': boolean;
}
/**
 * 
 * @export
 * @interface OrderCashbackDto
 */
export interface OrderCashbackDto {
    /**
     * 
     * @type {string}
     * @memberof OrderCashbackDto
     */
    'state': OrderCashbackDtoStateEnum;
    /**
     * 
     * @type {string}
     * @memberof OrderCashbackDto
     */
    'currency': string | null;
    /**
     * Minor units: goods total without fees and shipping.
     * @type {number}
     * @memberof OrderCashbackDto
     */
    'qualifyingCents': number;
    /**
     * Minor units.
     * @type {number}
     * @memberof OrderCashbackDto
     */
    'rewardCents': number;
    /**
     * 
     * @type {number}
     * @memberof OrderCashbackDto
     */
    'minimumCents': number;
    /**
     * How much more the cart needs to reach the minimum.
     * @type {number}
     * @memberof OrderCashbackDto
     */
    'missingCents': number;
    /**
     * 
     * @type {number}
     * @memberof OrderCashbackDto
     */
    'rewardAtMinimumCents': number;
    /**
     * 
     * @type {boolean}
     * @memberof OrderCashbackDto
     */
    'capped': boolean;
    /**
     * 
     * @type {string}
     * @memberof OrderCashbackDto
     */
    'email': string | null;
    /**
     * Cash on delivery: the reward comes once the parcel is delivered.
     * @type {boolean}
     * @memberof OrderCashbackDto
     */
    'codPendingDelivery': boolean;
    /**
     * 
     * @type {string}
     * @memberof OrderCashbackDto
     */
    'grantedAt': string | null;
    /**
     * 
     * @type {string}
     * @memberof OrderCashbackDto
     */
    'expiresAt': string | null;
    /**
     * 
     * @type {number}
     * @memberof OrderCashbackDto
     */
    'remainingCents': number | null;
    /**
     * Whose figures the top-level fields are.
     * @type {string}
     * @memberof OrderCashbackDto
     */
    'source': OrderCashbackDtoSourceEnum;
    /**
     * 
     * @type {OrderCashbackDtoCoupon}
     * @memberof OrderCashbackDto
     */
    'coupon': OrderCashbackDtoCoupon | null;
}

export const OrderCashbackDtoStateEnum = {
    None: 'none',
    Preview: 'preview',
    Pending: 'pending',
    Granted: 'granted',
    Reduced: 'reduced',
    Canceled: 'canceled',
    Voided: 'voided'
} as const;

export type OrderCashbackDtoStateEnum = typeof OrderCashbackDtoStateEnum[keyof typeof OrderCashbackDtoStateEnum];
export const OrderCashbackDtoSourceEnum = {
    Promotion: 'promotion',
    Coupon: 'coupon'
} as const;

export type OrderCashbackDtoSourceEnum = typeof OrderCashbackDtoSourceEnum[keyof typeof OrderCashbackDtoSourceEnum];

/**
 * 
 * @export
 * @interface OrderCashbackDtoCoupon
 */
export interface OrderCashbackDtoCoupon {
    /**
     * 
     * @type {string}
     * @memberof OrderCashbackDtoCoupon
     */
    'code': string;
    /**
     * Minor units; what the coupon gives on this cart.
     * @type {number}
     * @memberof OrderCashbackDtoCoupon
     */
    'rewardCents': number;
    /**
     * 
     * @type {number}
     * @memberof OrderCashbackDtoCoupon
     */
    'minimumCents': number;
    /**
     * 
     * @type {number}
     * @memberof OrderCashbackDtoCoupon
     */
    'missingCents': number;
    /**
     * True when the coupon is the cashback this order gets.
     * @type {boolean}
     * @memberof OrderCashbackDtoCoupon
     */
    'wins': boolean;
}
/**
 * 
 * @export
 * @interface OrderControllerAddOrderPhotosRequest
 */
export interface OrderControllerAddOrderPhotosRequest {
    /**
     * 
     * @type {string}
     * @memberof OrderControllerAddOrderPhotosRequest
     */
    'photoSizeId': string;
    /**
     * 
     * @type {string}
     * @memberof OrderControllerAddOrderPhotosRequest
     */
    'photoId'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof OrderControllerAddOrderPhotosRequest
     */
    'count'?: number | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof OrderControllerAddOrderPhotosRequest
     */
    'photoIds'?: Array<string> | null;
}
/**
 * 
 * @export
 * @interface OrderControllerAddOrderProductDetailRequest
 */
export interface OrderControllerAddOrderProductDetailRequest {
    /**
     * Product ID to add to the order
     * @type {string}
     * @memberof OrderControllerAddOrderProductDetailRequest
     */
    'productId': string;
    /**
     * Quantity of the product
     * @type {number}
     * @memberof OrderControllerAddOrderProductDetailRequest
     */
    'quantity': number;
}
/**
 * 
 * @export
 * @interface OrderControllerRemoveOrderCalendarRequest
 */
export interface OrderControllerRemoveOrderCalendarRequest {
    /**
     * Order calendar ID to remove
     * @type {string}
     * @memberof OrderControllerRemoveOrderCalendarRequest
     */
    'orderCalendarId': string;
}
/**
 * 
 * @export
 * @interface OrderControllerRemoveOrderProductDetailsRequest
 */
export interface OrderControllerRemoveOrderProductDetailsRequest {
    /**
     * Order product detail ID to remove
     * @type {string}
     * @memberof OrderControllerRemoveOrderProductDetailsRequest
     */
    'orderProductDetailId': string;
}
/**
 * 
 * @export
 * @interface OrderControllerSendPostPurchaseTestEmailRequest
 */
export interface OrderControllerSendPostPurchaseTestEmailRequest {
    /**
     * Which post-purchase template to render: referral=7d, upsell_30x40=30d, winback_60d=60d, vip=90d
     * @type {string}
     * @memberof OrderControllerSendPostPurchaseTestEmailRequest
     */
    'stage': OrderControllerSendPostPurchaseTestEmailRequestStageEnum;
    /**
     * Optional override recipient; defaults to order.shippingEmail.
     * @type {string}
     * @memberof OrderControllerSendPostPurchaseTestEmailRequest
     */
    'email'?: string | null;
}

export const OrderControllerSendPostPurchaseTestEmailRequestStageEnum = {
    Referral: 'referral',
    Upsell30x40: 'upsell_30x40',
    Winback60d: 'winback_60d',
    Vip: 'vip'
} as const;

export type OrderControllerSendPostPurchaseTestEmailRequestStageEnum = typeof OrderControllerSendPostPurchaseTestEmailRequestStageEnum[keyof typeof OrderControllerSendPostPurchaseTestEmailRequestStageEnum];

/**
 * 
 * @export
 * @interface OrderControllerUpdateOrderCalendarQuantityRequest
 */
export interface OrderControllerUpdateOrderCalendarQuantityRequest {
    /**
     * Order calendar ID to update
     * @type {string}
     * @memberof OrderControllerUpdateOrderCalendarQuantityRequest
     */
    'orderCalendarId': string;
    /**
     * New quantity for the calendar
     * @type {number}
     * @memberof OrderControllerUpdateOrderCalendarQuantityRequest
     */
    'quantity': number;
}
/**
 * 
 * @export
 * @interface OrderControllerUpdateOrderProductDetailQuantityRequest
 */
export interface OrderControllerUpdateOrderProductDetailQuantityRequest {
    /**
     * Order product detail ID to update
     * @type {string}
     * @memberof OrderControllerUpdateOrderProductDetailQuantityRequest
     */
    'orderProductDetailId': string;
    /**
     * New quantity for the product
     * @type {number}
     * @memberof OrderControllerUpdateOrderProductDetailQuantityRequest
     */
    'quantity': number;
}
/**
 * 
 * @export
 * @interface OrderControllerUpdateOrderProductQuantityRequest
 */
export interface OrderControllerUpdateOrderProductQuantityRequest {
    /**
     * 
     * @type {number}
     * @memberof OrderControllerUpdateOrderProductQuantityRequest
     */
    'quantity': number;
}
/**
 * 
 * @export
 * @interface OrderControllerUpdateProductWithMediaQuantityRequest
 */
export interface OrderControllerUpdateProductWithMediaQuantityRequest {
    /**
     * New quantity; must be at least the product minimum
     * @type {number}
     * @memberof OrderControllerUpdateProductWithMediaQuantityRequest
     */
    'quantity': number;
}
/**
 * 
 * @export
 * @interface OrderControllerUpsertOrderProductRequest
 */
export interface OrderControllerUpsertOrderProductRequest {
    /**
     * 
     * @type {string}
     * @memberof OrderControllerUpsertOrderProductRequest
     */
    'productId': string;
    /**
     * 
     * @type {number}
     * @memberof OrderControllerUpsertOrderProductRequest
     */
    'quantity': number;
}
/**
 * GOODS: a print order. GIFT_CARD: the sale of one gift card, paid by card and delivered by email — no photos, products, shipping or credit.
 * @export
 * @enum {string}
 */

export const OrderKind = {
    Goods: 'GOODS',
    GiftCard: 'GIFT_CARD'
} as const;

export type OrderKind = typeof OrderKind[keyof typeof OrderKind];


/**
 * 
 * @export
 * @interface PerTemplateEffectivenessDto
 */
export interface PerTemplateEffectivenessDto {
    /**
     * Email template key
     * @type {string}
     * @memberof PerTemplateEffectivenessDto
     */
    'templateKey': string;
    /**
     * Human rule name if a matching EmailRule exists, else templateKey
     * @type {string}
     * @memberof PerTemplateEffectivenessDto
     */
    'ruleName': string;
    /**
     * Whether the matching rule is promotional
     * @type {boolean}
     * @memberof PerTemplateEffectivenessDto
     */
    'promotional': boolean;
    /**
     * Trigger of the matching rule, null if no rule
     * @type {string}
     * @memberof PerTemplateEffectivenessDto
     */
    'trigger': string | null;
    /**
     * Number of SENT emails for this template
     * @type {number}
     * @memberof PerTemplateEffectivenessDto
     */
    'emailsSent': number;
    /**
     * Emails followed by a completed order in window
     * @type {number}
     * @memberof PerTemplateEffectivenessDto
     */
    'converted': number;
    /**
     * converted / emailsSent (0-1)
     * @type {number}
     * @memberof PerTemplateEffectivenessDto
     */
    'conversionRate': number;
    /**
     * Median hours from send to first order, null if none
     * @type {number}
     * @memberof PerTemplateEffectivenessDto
     */
    'medianHoursToOrder': number | null;
    /**
     * Mean hours from send to first order, null if none
     * @type {number}
     * @memberof PerTemplateEffectivenessDto
     */
    'avgHoursToOrder': number | null;
    /**
     * EUR revenue of matched orders (per-rule view)
     * @type {number}
     * @memberof PerTemplateEffectivenessDto
     */
    'attributedRevenueEur': number;
    /**
     * The 10 newest orders credited to this template (who ordered after it), newest first; `converted` is the full count
     * @type {Array<TemplateConversionDto>}
     * @memberof PerTemplateEffectivenessDto
     */
    'conversions': Array<TemplateConversionDto>;
}
/**
 * 
 * @export
 * @interface PhotoControllerConfirmUploadsRequest
 */
export interface PhotoControllerConfirmUploadsRequest {
    /**
     * 
     * @type {string}
     * @memberof PhotoControllerConfirmUploadsRequest
     */
    'orderPhotosId': string;
    /**
     * 
     * @type {Array<string>}
     * @memberof PhotoControllerConfirmUploadsRequest
     */
    'keys': Array<string>;
}
/**
 * 
 * @export
 * @interface PhotoControllerGetPresignedUrls200Response
 */
export interface PhotoControllerGetPresignedUrls200Response {
    /**
     * 
     * @type {Array<PhotoControllerGetPresignedUrls200ResponseUrlsInner>}
     * @memberof PhotoControllerGetPresignedUrls200Response
     */
    'urls'?: Array<PhotoControllerGetPresignedUrls200ResponseUrlsInner>;
}
/**
 * 
 * @export
 * @interface PhotoControllerGetPresignedUrls200ResponseUrlsInner
 */
export interface PhotoControllerGetPresignedUrls200ResponseUrlsInner {
    /**
     * 
     * @type {string}
     * @memberof PhotoControllerGetPresignedUrls200ResponseUrlsInner
     */
    'url'?: string;
    /**
     * 
     * @type {string}
     * @memberof PhotoControllerGetPresignedUrls200ResponseUrlsInner
     */
    'key'?: string;
    /**
     * 
     * @type {string}
     * @memberof PhotoControllerGetPresignedUrls200ResponseUrlsInner
     */
    'headUrl'?: string;
}
/**
 * 
 * @export
 * @interface PhotoControllerGetPresignedUrlsRequest
 */
export interface PhotoControllerGetPresignedUrlsRequest {
    /**
     * 
     * @type {Array<PhotoControllerGetPresignedUrlsRequestFilesInner>}
     * @memberof PhotoControllerGetPresignedUrlsRequest
     */
    'files'?: Array<PhotoControllerGetPresignedUrlsRequestFilesInner>;
    /**
     * Records what is about to be uploaded, so the server can finish the upload if the app never comes back. Optional: callers that omit it behave exactly as before.
     * @type {string}
     * @memberof PhotoControllerGetPresignedUrlsRequest
     */
    'orderPhotosId'?: string;
}
/**
 * 
 * @export
 * @interface PhotoControllerGetPresignedUrlsRequestFilesInner
 */
export interface PhotoControllerGetPresignedUrlsRequestFilesInner {
    /**
     * 
     * @type {string}
     * @memberof PhotoControllerGetPresignedUrlsRequestFilesInner
     */
    'name'?: string;
    /**
     * 
     * @type {string}
     * @memberof PhotoControllerGetPresignedUrlsRequestFilesInner
     */
    'type'?: string;
    /**
     * 
     * @type {number}
     * @memberof PhotoControllerGetPresignedUrlsRequestFilesInner
     */
    'count'?: number;
    /**
     * 
     * @type {number}
     * @memberof PhotoControllerGetPresignedUrlsRequestFilesInner
     */
    'rank'?: number;
}
/**
 * 
 * @export
 * @interface PhotoControllerUploadMetadataBatchRequest
 */
export interface PhotoControllerUploadMetadataBatchRequest {
    /**
     * 
     * @type {Array<PhotoControllerUploadMetadataRequest>}
     * @memberof PhotoControllerUploadMetadataBatchRequest
     */
    'metadata'?: Array<PhotoControllerUploadMetadataRequest>;
}
/**
 * 
 * @export
 * @interface PhotoControllerUploadMetadataRequest
 */
export interface PhotoControllerUploadMetadataRequest {
    /**
     * 
     * @type {string}
     * @memberof PhotoControllerUploadMetadataRequest
     */
    'key'?: string;
    /**
     * 
     * @type {string}
     * @memberof PhotoControllerUploadMetadataRequest
     */
    'name'?: string;
    /**
     * 
     * @type {string}
     * @memberof PhotoControllerUploadMetadataRequest
     */
    'type'?: string;
    /**
     * 
     * @type {number}
     * @memberof PhotoControllerUploadMetadataRequest
     */
    'count'?: number;
    /**
     * 
     * @type {number}
     * @memberof PhotoControllerUploadMetadataRequest
     */
    'rank'?: number;
    /**
     * 
     * @type {string}
     * @memberof PhotoControllerUploadMetadataRequest
     */
    'orderPhotosId'?: string;
}
/**
 * 
 * @export
 * @interface PhotoHistogramDataDto
 */
export interface PhotoHistogramDataDto {
    /**
     * Photo size name
     * @type {string}
     * @memberof PhotoHistogramDataDto
     */
    'photoSize': string;
    /**
     * Number of photos of this size
     * @type {number}
     * @memberof PhotoHistogramDataDto
     */
    'count': number;
    /**
     * Total amount for this photo size
     * @type {number}
     * @memberof PhotoHistogramDataDto
     */
    'amount': number;
}
/**
 * 
 * @export
 * @interface PhotoItemResponseDto
 */
export interface PhotoItemResponseDto {
    /**
     * ID of the photo size
     * @type {string}
     * @memberof PhotoItemResponseDto
     */
    'photoSizeId': string;
    /**
     * Number of photos for this size
     * @type {number}
     * @memberof PhotoItemResponseDto
     */
    'nOfPhotos': number;
    /**
     * Price for this photo size item (in cents)
     * @type {number}
     * @memberof PhotoItemResponseDto
     */
    'price': number;
    /**
     * Discount applied to this item (in cents)
     * @type {number}
     * @memberof PhotoItemResponseDto
     */
    'discount': number;
}
/**
 * 
 * @export
 * @interface PhotoOptionDto
 */
export interface PhotoOptionDto {
    /**
     * 
     * @type {string}
     * @memberof PhotoOptionDto
     */
    'key': PhotoOptionDtoKeyEnum;
    /**
     * 
     * @type {PhotoOptionPricingDto}
     * @memberof PhotoOptionDto
     */
    'pricing': PhotoOptionPricingDto;
}

export const PhotoOptionDtoKeyEnum = {
    EcologicalPackaging: 'ecologicalPackaging',
    PriorityComplaintFree: 'priorityComplaintFree',
    WrapAsGift: 'wrapAsGift',
    ProfessionalCrop: 'professionalCrop',
    WhiteBorder: 'whiteBorder',
    BlackAndWhite: 'blackAndWhite',
    PremiumPaper: 'premiumPaper'
} as const;

export type PhotoOptionDtoKeyEnum = typeof PhotoOptionDtoKeyEnum[keyof typeof PhotoOptionDtoKeyEnum];

/**
 * 
 * @export
 * @interface PhotoOptionPricingDto
 */
export interface PhotoOptionPricingDto {
    /**
     * 
     * @type {string}
     * @memberof PhotoOptionPricingDto
     */
    'kind': PhotoOptionPricingDtoKindEnum;
    /**
     * Unit price in cents. Absent when kind = \"varies\".
     * @type {number}
     * @memberof PhotoOptionPricingDto
     */
    'cents': number | null;
}

export const PhotoOptionPricingDtoKindEnum = {
    Flat: 'flat',
    PerPhoto: 'perPhoto',
    Varies: 'varies'
} as const;

export type PhotoOptionPricingDtoKindEnum = typeof PhotoOptionPricingDtoKindEnum[keyof typeof PhotoOptionPricingDtoKindEnum];

/**
 * 
 * @export
 * @interface PhotoOptionsResponseDto
 */
export interface PhotoOptionsResponseDto {
    /**
     * 
     * @type {string}
     * @memberof PhotoOptionsResponseDto
     */
    'currency': string;
    /**
     * 
     * @type {Array<PhotoOptionDto>}
     * @memberof PhotoOptionsResponseDto
     */
    'options': Array<PhotoOptionDto>;
}
/**
 * 
 * @export
 * @interface PhotoSizeItemDto
 */
export interface PhotoSizeItemDto {
    /**
     * ID of the photo size
     * @type {string}
     * @memberof PhotoSizeItemDto
     */
    'photoSizeId': string;
    /**
     * Number of photos for this size
     * @type {number}
     * @memberof PhotoSizeItemDto
     */
    'nOfPhotos': number;
}
/**
 * 
 * @export
 * @interface PhotoSizeItemExtraDto
 */
export interface PhotoSizeItemExtraDto {
    /**
     * ID of the photo size
     * @type {string}
     * @memberof PhotoSizeItemExtraDto
     */
    'photoSizeId': string;
    /**
     * Number of photos for this size
     * @type {number}
     * @memberof PhotoSizeItemExtraDto
     */
    'nOfPhotos': number;
    /**
     * Price of the photo size
     * @type {number}
     * @memberof PhotoSizeItemExtraDto
     */
    'price': number;
    /**
     * Discount for the photo size
     * @type {number}
     * @memberof PhotoSizeItemExtraDto
     */
    'discount': number;
}
/**
 * 
 * @export
 * @interface PlaceResultDto
 */
export interface PlaceResultDto {
    /**
     * 
     * @type {string}
     * @memberof PlaceResultDto
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof PlaceResultDto
     */
    'displayName': string;
    /**
     * 
     * @type {number}
     * @memberof PlaceResultDto
     */
    'lat': number;
    /**
     * 
     * @type {number}
     * @memberof PlaceResultDto
     */
    'lon': number;
}
/**
 * 
 * @export
 * @interface PrepareNativePaymentResponseDto
 */
export interface PrepareNativePaymentResponseDto {
    /**
     * Client secret of the Stripe PaymentIntent for PaymentSheet. Null only when the order was paid in full by credit — see `paidWithCredit`.
     * @type {string}
     * @memberof PrepareNativePaymentResponseDto
     */
    'paymentIntentClientSecret': string | null;
    /**
     * Stripe ephemeral key for saved-card management. Null when the order has no email to attach a customer to, and when it was paid by credit.
     * @type {string}
     * @memberof PrepareNativePaymentResponseDto
     */
    'ephemeralKeySecret': string | null;
    /**
     * Stripe customer id the PaymentIntent belongs to. Null when the order has no email to attach a customer to, and when it was paid by credit.
     * @type {string}
     * @memberof PrepareNativePaymentResponseDto
     */
    'customerId': string | null;
    /**
     * Present and true when account credit covered the whole total: nothing was charged, no PaymentIntent exists, and the order is already PAID. Absent on every other response.
     * @type {boolean}
     * @memberof PrepareNativePaymentResponseDto
     */
    'paidWithCredit'?: boolean;
    /**
     * The payment attempt this PaymentSheet is (its reference). Send it, with `paymentGeneration`, to POST /order/:id/abandon-payment when the sheet is dismissed, so only THIS attempt is abandoned. Absent when paid with credit.
     * @type {string}
     * @memberof PrepareNativePaymentResponseDto
     */
    'attemptId'?: string;
    /**
     * The payment generation the attempt belongs to (see attemptId). Absent when paid with credit.
     * @type {number}
     * @memberof PrepareNativePaymentResponseDto
     */
    'paymentGeneration'?: number;
}
/**
 * 
 * @export
 * @interface PreparePaymentRequestDto
 */
export interface PreparePaymentRequestDto {
    /**
     * false: 409 UPLOADS_PENDING (with `pending`) while photos are still uploading. true: drop the photos still uploading and charge for the ones on the order. Omitted: previous behaviour.
     * @type {boolean}
     * @memberof PreparePaymentRequestDto
     */
    'allowMissingPhotos'?: boolean;
}
/**
 * 
 * @export
 * @interface PreparePaymentResponseDto
 */
export interface PreparePaymentResponseDto {
    /**
     * The unique identifier of the entity.
     * @type {string}
     * @memberof PreparePaymentResponseDto
     */
    'id': string;
    /**
     * The creation date of the entity.
     * @type {string}
     * @memberof PreparePaymentResponseDto
     */
    'createdAt': string;
    /**
     * The last update date of the entity.
     * @type {string}
     * @memberof PreparePaymentResponseDto
     */
    'updatedAt': string;
    /**
     * 
     * @type {string}
     * @memberof PreparePaymentResponseDto
     */
    'status': string;
    /**
     * 
     * @type {OrderKind}
     * @memberof PreparePaymentResponseDto
     */
    'kind': OrderKind;
    /**
     * 
     * @type {number}
     * @memberof PreparePaymentResponseDto
     */
    'amount': number;
    /**
     * Customer account credit already redeemed against this order, in integer cents of `currency`. It is NOT a coupon and is independent of `couponUsed`: an order may carry both, and credit applies after the coupon, on the post-discount total, because credit is payment rather than a discount on the goods. `amount` is what is still owed, so the pre-credit total the customer sees is `amount + creditAppliedCents`.  0 is a real value, not \"absent\": an order that had its credit removed reads 0 here, exactly like one that never had any. Clients must test for presence, never truthiness — `if (!order.creditAppliedCents)` is a bug. Always serialized, including the 0.  This is the order\'s own applied amount only. The remaining balance on the account is a separate resource; read it from the credit endpoints.
     * @type {number}
     * @memberof PreparePaymentResponseDto
     */
    'creditAppliedCents': number;
    /**
     * 
     * @type {object}
     * @memberof PreparePaymentResponseDto
     */
    'user': object;
    /**
     * 
     * @type {object}
     * @memberof PreparePaymentResponseDto
     */
    'couponUsed': object;
    /**
     * 
     * @type {string}
     * @memberof PreparePaymentResponseDto
     */
    'stripePaymentIntentId': string;
    /**
     * 
     * @type {number}
     * @memberof PreparePaymentResponseDto
     */
    'stripeAmount': number;
    /**
     * 
     * @type {string}
     * @memberof PreparePaymentResponseDto
     */
    'stripeCurrency': string;
    /**
     * 
     * @type {string}
     * @memberof PreparePaymentResponseDto
     */
    'stripeStatus': string;
    /**
     * 
     * @type {string}
     * @memberof PreparePaymentResponseDto
     */
    'stripeCreated': string;
    /**
     * 
     * @type {string}
     * @memberof PreparePaymentResponseDto
     */
    'stripeClientSecret': string;
    /**
     * 
     * @type {string}
     * @memberof PreparePaymentResponseDto
     */
    'shippingAddress1': string;
    /**
     * 
     * @type {string}
     * @memberof PreparePaymentResponseDto
     */
    'stripeSessionId': string;
    /**
     * Moves when an open payment attempt is abandoned, or the amount of a pinned order changes. POST /order/:id/abandon-payment takes it (with the attempt id from the payment response) to act on one attempt only.
     * @type {number}
     * @memberof PreparePaymentResponseDto
     */
    'paymentGeneration': number;
    /**
     * Stripe hosted checkout URL (transient, only on prepare-payment response)
     * @type {string}
     * @memberof PreparePaymentResponseDto
     */
    'stripeCheckoutUrl'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PreparePaymentResponseDto
     */
    'shippingAddress2': string;
    /**
     * 
     * @type {string}
     * @memberof PreparePaymentResponseDto
     */
    'shippingCity': string;
    /**
     * 
     * @type {string}
     * @memberof PreparePaymentResponseDto
     */
    'shippingZip': string;
    /**
     * 
     * @type {string}
     * @memberof PreparePaymentResponseDto
     */
    'shippingCountry': string;
    /**
     * 
     * @type {string}
     * @memberof PreparePaymentResponseDto
     */
    'shippingState': string;
    /**
     * 
     * @type {string}
     * @memberof PreparePaymentResponseDto
     */
    'shippingPhone': string;
    /**
     * 
     * @type {string}
     * @memberof PreparePaymentResponseDto
     */
    'shippingEmail': string;
    /**
     * 
     * @type {string}
     * @memberof PreparePaymentResponseDto
     */
    'shippingFirstName': string;
    /**
     * 
     * @type {string}
     * @memberof PreparePaymentResponseDto
     */
    'shippingLastName': string;
    /**
     * 
     * @type {string}
     * @memberof PreparePaymentResponseDto
     */
    'shippingNotes': string;
    /**
     * 
     * @type {string}
     * @memberof PreparePaymentResponseDto
     */
    'shippingMethod': string;
    /**
     * 
     * @type {number}
     * @memberof PreparePaymentResponseDto
     */
    'shippingPrice': number;
    /**
     * 
     * @type {string}
     * @memberof PreparePaymentResponseDto
     */
    'paymentOption': string;
    /**
     * 
     * @type {string}
     * @memberof PreparePaymentResponseDto
     */
    'ipAddress': string;
    /**
     * 
     * @type {string}
     * @memberof PreparePaymentResponseDto
     */
    'userAgent': string;
    /**
     * 
     * @type {string}
     * @memberof PreparePaymentResponseDto
     */
    'fbc': string;
    /**
     * 
     * @type {string}
     * @memberof PreparePaymentResponseDto
     */
    'fbp': string;
    /**
     * 
     * @type {boolean}
     * @memberof PreparePaymentResponseDto
     */
    'isOrdered': boolean;
    /**
     * 
     * @type {string}
     * @memberof PreparePaymentResponseDto
     */
    'mailCompletePurchaseSent': string;
    /**
     * 
     * @type {number}
     * @memberof PreparePaymentResponseDto
     */
    'totalNOfPhotos': number;
    /**
     * 
     * @type {number}
     * @memberof PreparePaymentResponseDto
     */
    'totalNOfDifferentPhotos': number;
    /**
     * 
     * @type {Array<GetOrderProductDetailDto>}
     * @memberof PreparePaymentResponseDto
     */
    'orderProductDetails': Array<GetOrderProductDetailDto>;
    /**
     * 
     * @type {Array<GetOrderPhotosDto>}
     * @memberof PreparePaymentResponseDto
     */
    'orderPhotos': Array<GetOrderPhotosDto>;
    /**
     * 
     * @type {Array<GetOrderCalendarDto>}
     * @memberof PreparePaymentResponseDto
     */
    'orderCalendars': Array<GetOrderCalendarDto>;
    /**
     * 
     * @type {Array<GetProductWithMediaOrderDto>}
     * @memberof PreparePaymentResponseDto
     */
    'productWithMediaOrders': Array<GetProductWithMediaOrderDto>;
    /**
     * 
     * @type {number}
     * @memberof PreparePaymentResponseDto
     */
    'glsParcelNumber': number;
    /**
     * 
     * @type {string}
     * @memberof PreparePaymentResponseDto
     */
    'glsStatus': string;
    /**
     * 
     * @type {string}
     * @memberof PreparePaymentResponseDto
     */
    'currency': string;
    /**
     * 
     * @type {number}
     * @memberof PreparePaymentResponseDto
     */
    'downlink': number;
    /**
     * 
     * @type {string}
     * @memberof PreparePaymentResponseDto
     */
    'domain': string;
    /**
     * 
     * @type {string}
     * @memberof PreparePaymentResponseDto
     */
    'orderSource'?: string | null;
    /**
     * Type of delivery
     * @type {string}
     * @memberof PreparePaymentResponseDto
     */
    'deliveryType': PreparePaymentResponseDtoDeliveryTypeEnum;
    /**
     * 
     * @type {GetDeliveryPointDto}
     * @memberof PreparePaymentResponseDto
     */
    'deliveryPoint': GetDeliveryPointDto;
    /**
     * 
     * @type {string}
     * @memberof PreparePaymentResponseDto
     */
    'deliveryPointId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PreparePaymentResponseDto
     */
    'deliveryPointName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PreparePaymentResponseDto
     */
    'deliveryPointStreet'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PreparePaymentResponseDto
     */
    'deliveryPointHouseNumber'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PreparePaymentResponseDto
     */
    'deliveryPointCity'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PreparePaymentResponseDto
     */
    'deliveryPointZipCode'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PreparePaymentResponseDto
     */
    'deliveryPointCountryIsoCode'?: string | null;
    /**
     * Invoice fiscalization status
     * @type {string}
     * @memberof PreparePaymentResponseDto
     */
    'invoiceStatus'?: PreparePaymentResponseDtoInvoiceStatusEnum;
    /**
     * Ecological packaging option (+1.00 EUR)
     * @type {boolean}
     * @memberof PreparePaymentResponseDto
     */
    'ecologicalPackaging': boolean;
    /**
     * Priority complaint option (+0.80 EUR)
     * @type {boolean}
     * @memberof PreparePaymentResponseDto
     */
    'priorityComplaint': boolean;
    /**
     * Wrap as gift option (+6.00 EUR)
     * @type {boolean}
     * @memberof PreparePaymentResponseDto
     */
    'wrapAsGift': boolean;
    /**
     * Gift text (if wrapAsGift is true)
     * @type {string}
     * @memberof PreparePaymentResponseDto
     */
    'giftText': string | null;
    /**
     * Professional crop option
     * @type {boolean}
     * @memberof PreparePaymentResponseDto
     */
    'professionalCrop': boolean;
    /**
     * Premium paper option
     * @type {boolean}
     * @memberof PreparePaymentResponseDto
     */
    'premiumPaper': boolean;
    /**
     * White border option
     * @type {boolean}
     * @memberof PreparePaymentResponseDto
     */
    'whiteBorder': boolean;
    /**
     * Black and white option
     * @type {boolean}
     * @memberof PreparePaymentResponseDto
     */
    'blackAndWhite': boolean;
    /**
     * Frozen line-items price breakdown, captured at finalization
     * @type {object}
     * @memberof PreparePaymentResponseDto
     */
    'lineItemsSnapshot'?: object | null;
    /**
     * The bundle the customer is filling (UI state).
     * @type {string}
     * @memberof PreparePaymentResponseDto
     */
    'selectedBundleId'?: string | null;
    /**
     * Bundle terms frozen at commit.
     * @type {object}
     * @memberof PreparePaymentResponseDto
     */
    'bundleTermsSnapshot'?: object | null;
    /**
     * Sum of applied bundle discounts, minor units.
     * @type {number}
     * @memberof PreparePaymentResponseDto
     */
    'bundleDiscountCents'?: number;
    /**
     * Applied bundles: bundleId, name, times, discountCents, couponsAllowed.
     * @type {Array<object>}
     * @memberof PreparePaymentResponseDto
     */
    'appliedBundles'?: Array<object> | null;
    /**
     * When the order was placed (card paid or COD confirmed).
     * @type {string}
     * @memberof PreparePaymentResponseDto
     */
    'placedAt'?: string | null;
    /**
     * 
     * @type {GetOrderDtoCancelRequest}
     * @memberof PreparePaymentResponseDto
     */
    'cancelRequest'?: GetOrderDtoCancelRequest | null;
    /**
     * Whether the quiet \"cancel this order\" link may be shown now. Computed on GET /order/:id.
     * @type {boolean}
     * @memberof PreparePaymentResponseDto
     */
    'canRequestCancel'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof PreparePaymentResponseDto
     */
    'cancelRequestState'?: PreparePaymentResponseDtoCancelRequestStateEnum;
    /**
     * 
     * @type {string}
     * @memberof PreparePaymentResponseDto
     */
    'cancelRequestedAt'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PreparePaymentResponseDto
     */
    'cancelRequestReason'?: PreparePaymentResponseDtoCancelRequestReasonEnum;
    /**
     * 
     * @type {string}
     * @memberof PreparePaymentResponseDto
     */
    'cancelRequestNote'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PreparePaymentResponseDto
     */
    'cancelRequestDecidedAt'?: string | null;
    /**
     * Present and true when account credit covered the whole total: nothing was charged, no Stripe Checkout Session was created, and the order is already PAID. There is no `stripeCheckoutUrl` to redirect to — show the confirmation instead. Absent on every other response.
     * @type {boolean}
     * @memberof PreparePaymentResponseDto
     */
    'paidWithCredit'?: boolean;
    /**
     * The payment attempt this checkout is (its reference; the Stripe cancel URL carries the same value as `attempt`). Send it, with `paymentGeneration`, to POST /order/:id/abandon-payment so that only THIS attempt is abandoned. Absent when paid with credit.
     * @type {string}
     * @memberof PreparePaymentResponseDto
     */
    'attemptId'?: string;
}

export const PreparePaymentResponseDtoDeliveryTypeEnum = {
    Home: 'HOME',
    ParcelLock: 'PARCEL_LOCK'
} as const;

export type PreparePaymentResponseDtoDeliveryTypeEnum = typeof PreparePaymentResponseDtoDeliveryTypeEnum[keyof typeof PreparePaymentResponseDtoDeliveryTypeEnum];
export const PreparePaymentResponseDtoInvoiceStatusEnum = {
    Pending: 'PENDING',
    Success: 'SUCCESS',
    Failed: 'FAILED',
    Retry: 'RETRY',
    Pantheon: 'PANTHEON'
} as const;

export type PreparePaymentResponseDtoInvoiceStatusEnum = typeof PreparePaymentResponseDtoInvoiceStatusEnum[keyof typeof PreparePaymentResponseDtoInvoiceStatusEnum];
export const PreparePaymentResponseDtoCancelRequestStateEnum = {
    Open: 'OPEN',
    Approved: 'APPROVED',
    Declined: 'DECLINED'
} as const;

export type PreparePaymentResponseDtoCancelRequestStateEnum = typeof PreparePaymentResponseDtoCancelRequestStateEnum[keyof typeof PreparePaymentResponseDtoCancelRequestStateEnum];
export const PreparePaymentResponseDtoCancelRequestReasonEnum = {
    WrongPhotos: 'WRONG_PHOTOS',
    WrongAddress: 'WRONG_ADDRESS',
    WrongProduct: 'WRONG_PRODUCT',
    Other: 'OTHER'
} as const;

export type PreparePaymentResponseDtoCancelRequestReasonEnum = typeof PreparePaymentResponseDtoCancelRequestReasonEnum[keyof typeof PreparePaymentResponseDtoCancelRequestReasonEnum];

/**
 * 
 * @export
 * @interface PreviewBundleDto
 */
export interface PreviewBundleDto {
    /**
     * 
     * @type {Array<BundleSlotInputDto>}
     * @memberof PreviewBundleDto
     */
    'slots': Array<BundleSlotInputDto>;
    /**
     * 
     * @type {string}
     * @memberof PreviewBundleDto
     */
    'currency': string;
}
/**
 * 
 * @export
 * @interface PriceCalculationResponseDto
 */
export interface PriceCalculationResponseDto {
    /**
     * Total amount to pay (in cents)
     * @type {number}
     * @memberof PriceCalculationResponseDto
     */
    'totalAmount': number;
    /**
     * Subtotal before shipping and fees (in cents)
     * @type {number}
     * @memberof PriceCalculationResponseDto
     */
    'subtotal': number;
    /**
     * Total cost of all photos (in cents)
     * @type {number}
     * @memberof PriceCalculationResponseDto
     */
    'photoTotal': number;
    /**
     * Total cost of all products (in cents)
     * @type {number}
     * @memberof PriceCalculationResponseDto
     */
    'productTotal': number;
    /**
     * Total cost of all calendars (in cents)
     * @type {number}
     * @memberof PriceCalculationResponseDto
     */
    'calendarTotal': number;
    /**
     * Shipping cost (in cents)
     * @type {number}
     * @memberof PriceCalculationResponseDto
     */
    'shippingCost': number;
    /**
     * Discount amount (in cents)
     * @type {number}
     * @memberof PriceCalculationResponseDto
     */
    'discount': number;
    /**
     * Payment on delivery fee (in cents)
     * @type {number}
     * @memberof PriceCalculationResponseDto
     */
    'paymentFee': number;
    /**
     * Ecological packaging fee (in cents, +1.00 EUR if selected)
     * @type {number}
     * @memberof PriceCalculationResponseDto
     */
    'ecologicalPackagingFee': number;
    /**
     * Priority complaint fee (in cents, +0.80 EUR if selected)
     * @type {number}
     * @memberof PriceCalculationResponseDto
     */
    'priorityComplaintFee': number;
    /**
     * Wrap as gift fee (in cents, +6.00 EUR if selected)
     * @type {number}
     * @memberof PriceCalculationResponseDto
     */
    'wrapAsGiftFee': number;
    /**
     * Premium paper fee (in cents, per-photo pricing based on photoSize configuration, default 5 cents per photo)
     * @type {number}
     * @memberof PriceCalculationResponseDto
     */
    'premiumPaperFee': number;
    /**
     * Professional crop service fee (in cents, +2.00 EUR flat fee)
     * @type {number}
     * @memberof PriceCalculationResponseDto
     */
    'professionalCropFee': number;
    /**
     * Detailed breakdown of photo items with pricing
     * @type {Array<PhotoItemResponseDto>}
     * @memberof PriceCalculationResponseDto
     */
    'photoItems': Array<PhotoItemResponseDto>;
    /**
     * Detailed breakdown of product items with pricing
     * @type {Array<ProductItemResponseDto>}
     * @memberof PriceCalculationResponseDto
     */
    'productItems': Array<ProductItemResponseDto>;
    /**
     * Detailed breakdown of calendar items with pricing
     * @type {Array<CalendarItemResponseDto>}
     * @memberof PriceCalculationResponseDto
     */
    'calendarItems': Array<CalendarItemResponseDto>;
    /**
     * A cashback coupon\'s terms ({ couponId, code, rateBp, fixedCents, minimumCents, capCents, lotLifetimeDays }); null otherwise. It discounts nothing: `discount` stays 0.
     * @type {{ [key: string]: any; }}
     * @memberof PriceCalculationResponseDto
     */
    'cashbackCoupon'?: { [key: string]: any; } | null;
}
/**
 * 
 * @export
 * @interface PriceRangeDto
 */
export interface PriceRangeDto {
    /**
     * Minimum quantity of photos for specified price
     * @type {number}
     * @memberof PriceRangeDto
     */
    'minQuantity': number;
    /**
     * Maximum quantity of photos for specified price
     * @type {number}
     * @memberof PriceRangeDto
     */
    'maxQuantity': number;
    /**
     * Price per photo for the specified range
     * @type {number}
     * @memberof PriceRangeDto
     */
    'pricePerPhoto': number;
}
/**
 * 
 * @export
 * @interface PricingBootstrapResponseDto
 */
export interface PricingBootstrapResponseDto {
    /**
     * Shipping rate table for every supported country.
     * @type {Array<ShippingRatesResponseDto>}
     * @memberof PricingBootstrapResponseDto
     */
    'shipping': Array<ShippingRatesResponseDto>;
    /**
     * Photo-option pricing for every supported currency.
     * @type {Array<PhotoOptionsResponseDto>}
     * @memberof PricingBootstrapResponseDto
     */
    'photoOptions': Array<PhotoOptionsResponseDto>;
    /**
     * Calendar unit prices for every supported currency, from the same table the checkout charges from. Not overridable — deliberately outside the pricing-override system.
     * @type {Array<CalendarPricesResponseDto>}
     * @memberof PricingBootstrapResponseDto
     */
    'calendarPrices': Array<CalendarPricesResponseDto>;
}
/**
 * 
 * @export
 * @interface ProSlotDto
 */
export interface ProSlotDto {
    /**
     * image/heic only when the server can decode HEIC, else 415 unsupported-type
     * @type {string}
     * @memberof ProSlotDto
     */
    'contentType': ProSlotDtoContentTypeEnum;
    /**
     * File size in bytes; over 50 MB is 413 too-large
     * @type {number}
     * @memberof ProSlotDto
     */
    'bytes': number;
}

export const ProSlotDtoContentTypeEnum = {
    Jpeg: 'image/jpeg',
    Png: 'image/png',
    Heic: 'image/heic'
} as const;

export type ProSlotDtoContentTypeEnum = typeof ProSlotDtoContentTypeEnum[keyof typeof ProSlotDtoContentTypeEnum];

/**
 * 
 * @export
 * @interface ProductItemDto
 */
export interface ProductItemDto {
    /**
     * ID of the product
     * @type {string}
     * @memberof ProductItemDto
     */
    'productId': string;
    /**
     * Number of products
     * @type {number}
     * @memberof ProductItemDto
     */
    'nOfProducts': number;
}
/**
 * 
 * @export
 * @interface ProductItemExtraDto
 */
export interface ProductItemExtraDto {
    /**
     * ID of the product
     * @type {string}
     * @memberof ProductItemExtraDto
     */
    'productId': string;
    /**
     * Number of products
     * @type {number}
     * @memberof ProductItemExtraDto
     */
    'nOfProducts': number;
    /**
     * Discount for the product
     * @type {number}
     * @memberof ProductItemExtraDto
     */
    'discount': number;
}
/**
 * 
 * @export
 * @interface ProductItemResponseDto
 */
export interface ProductItemResponseDto {
    /**
     * ID of the product
     * @type {string}
     * @memberof ProductItemResponseDto
     */
    'productId': string;
    /**
     * Number of products
     * @type {number}
     * @memberof ProductItemResponseDto
     */
    'nOfProducts': number;
    /**
     * Price for this product item (in cents)
     * @type {number}
     * @memberof ProductItemResponseDto
     */
    'price': number;
    /**
     * Discount applied to this item (in cents)
     * @type {number}
     * @memberof ProductItemResponseDto
     */
    'discount': number;
}
/**
 * 
 * @export
 * @interface ProductLineSummaryDto
 */
export interface ProductLineSummaryDto {
    /**
     * Units sold (sum of line quantities)
     * @type {number}
     * @memberof ProductLineSummaryDto
     */
    'total': number;
    /**
     * Units per format label
     * @type {{ [key: string]: number; }}
     * @memberof ProductLineSummaryDto
     */
    'count': { [key: string]: number; };
    /**
     * Revenue per format label, EUR: line price minus coupon, bundle and credit shares. VAT-inclusive, like calendarsAmount.
     * @type {{ [key: string]: number; }}
     * @memberof ProductLineSummaryDto
     */
    'amount': { [key: string]: number; };
    /**
     * Sum of amount, EUR
     * @type {number}
     * @memberof ProductLineSummaryDto
     */
    'revenue': number;
    /**
     * Production cost, EUR. Null when the product has no cost data at all (invitations) — never estimated.
     * @type {number}
     * @memberof ProductLineSummaryDto
     */
    'cost': number | null;
    /**
     * revenue − cost, EUR. Null whenever cost is null.
     * @type {number}
     * @memberof ProductLineSummaryDto
     */
    'profit': number | null;
    /**
     * Units whose line carried no cost (counted as 0 in cost)
     * @type {number}
     * @memberof ProductLineSummaryDto
     */
    'unitsWithoutCost': number;
    /**
     * Units that were a catalogue artwork, not the customer photo
     * @type {number}
     * @memberof ProductLineSummaryDto
     */
    'artworkUnits': number;
}
/**
 * 
 * @export
 * @interface ProductSalesDataDto
 */
export interface ProductSalesDataDto {
    /**
     * Product name
     * @type {string}
     * @memberof ProductSalesDataDto
     */
    'productName': string;
    /**
     * Total sales volume (quantity)
     * @type {number}
     * @memberof ProductSalesDataDto
     */
    'salesVolume': number;
}
/**
 * 
 * @export
 * @interface RecordCheckpointDto
 */
export interface RecordCheckpointDto {
    /**
     * 
     * @type {string}
     * @memberof RecordCheckpointDto
     */
    'type': RecordCheckpointDtoTypeEnum;
    /**
     * 
     * @type {object}
     * @memberof RecordCheckpointDto
     */
    'metadata'?: object;
}

export const RecordCheckpointDtoTypeEnum = {
    CartViewed: 'CART_VIEWED',
    CheckoutStarted: 'CHECKOUT_STARTED',
    DeliveryViewed: 'DELIVERY_VIEWED',
    DeliveryMethodChosen: 'DELIVERY_METHOD_CHOSEN',
    PaymentViewed: 'PAYMENT_VIEWED',
    PaymentAttempted: 'PAYMENT_ATTEMPTED',
    PaymentFailed: 'PAYMENT_FAILED',
    UpsellsViewed: 'UPSELLS_VIEWED'
} as const;

export type RecordCheckpointDtoTypeEnum = typeof RecordCheckpointDtoTypeEnum[keyof typeof RecordCheckpointDtoTypeEnum];

/**
 * 
 * @export
 * @interface RedeemGiftCardCodeDto
 */
export interface RedeemGiftCardCodeDto {
    /**
     * As printed or typed.
     * @type {string}
     * @memberof RedeemGiftCardCodeDto
     */
    'giftCardCode': string;
    /**
     * The cart it is being entered on; the caller must own it.
     * @type {string}
     * @memberof RedeemGiftCardCodeDto
     */
    'orderId': string;
    /**
     * The credit token the caller already holds (from an earlier redeem or the email link). When it is valid and for the address this card is claimed to, the returned token keeps its credit too: a lot-scoped token is widened to include this card (the 10 newest cards at most), a whole-address token is returned unchanged. Anything else is ignored.
     * @type {string}
     * @memberof RedeemGiftCardCodeDto
     */
    'creditToken'?: string;
}
/**
 * 
 * @export
 * @interface RedeemGiftCardCodeResultDto
 */
export interface RedeemGiftCardCodeResultDto {
    /**
     * The exchanged (two-hour) credit token, scoped to this card (and to the cards of the creditToken sent, when it was carried forward; the creditToken sent itself, unchanged, when it was a whole-address one): send it as x-credit-token, and as creditToken when applying credit to the order. It reads and spends those cards only, never the address\'s other credit — unless the creditToken sent was a whole-address one.
     * @type {string}
     * @memberof RedeemGiftCardCodeResultDto
     */
    'creditToken': string;
    /**
     * 
     * @type {string}
     * @memberof RedeemGiftCardCodeResultDto
     */
    'currency': string;
    /**
     * What is left on the card, in minor units.
     * @type {number}
     * @memberof RedeemGiftCardCodeResultDto
     */
    'remainingCents': number;
}
/**
 * 
 * @export
 * @interface RegisterDeviceTokenDto
 */
export interface RegisterDeviceTokenDto {
    /**
     * Expo push token
     * @type {string}
     * @memberof RegisterDeviceTokenDto
     */
    'token': string;
    /**
     * 
     * @type {string}
     * @memberof RegisterDeviceTokenDto
     */
    'market'?: RegisterDeviceTokenDtoMarketEnum;
}

export const RegisterDeviceTokenDtoMarketEnum = {
    Sl: 'sl',
    Hr: 'hr',
    Sk: 'sk',
    Pl: 'pl'
} as const;

export type RegisterDeviceTokenDtoMarketEnum = typeof RegisterDeviceTokenDtoMarketEnum[keyof typeof RegisterDeviceTokenDtoMarketEnum];

/**
 * 
 * @export
 * @interface RegisterDto
 */
export interface RegisterDto {
    /**
     * 
     * @type {string}
     * @memberof RegisterDto
     */
    'email': string;
    /**
     * 
     * @type {string}
     * @memberof RegisterDto
     */
    'password': string;
    /**
     * 
     * @type {string}
     * @memberof RegisterDto
     */
    'passwordConfirm': string;
}
/**
 * 
 * @export
 * @interface RepeatCustomerEntryDto
 */
export interface RepeatCustomerEntryDto {
    /**
     * Customer email (lowercased)
     * @type {string}
     * @memberof RepeatCustomerEntryDto
     */
    'email': string;
    /**
     * Number of completed orders
     * @type {number}
     * @memberof RepeatCustomerEntryDto
     */
    'orderCount': number;
    /**
     * Total spent across completed orders in EUR units (already normalised from per-order currencies and divided by 100). A value of 549.0 means €549.00.
     * @type {number}
     * @memberof RepeatCustomerEntryDto
     */
    'totalSpent': number;
}
/**
 * 
 * @export
 * @interface RepeatCustomersDto
 */
export interface RepeatCustomersDto {
    /**
     * Distinct customers with at least one completed order
     * @type {number}
     * @memberof RepeatCustomersDto
     */
    'totalCustomers': number;
    /**
     * Customers with 2 or more completed orders
     * @type {number}
     * @memberof RepeatCustomersDto
     */
    'repeatCustomers': number;
    /**
     * Fraction of customers who placed more than one order (0-1)
     * @type {number}
     * @memberof RepeatCustomersDto
     */
    'repeatRate': number;
    /**
     * Average completed orders per customer
     * @type {number}
     * @memberof RepeatCustomersDto
     */
    'averageOrdersPerCustomer': number;
    /**
     * Top 10 customers by total spend
     * @type {Array<RepeatCustomerEntryDto>}
     * @memberof RepeatCustomersDto
     */
    'top': Array<RepeatCustomerEntryDto>;
}
/**
 * 
 * @export
 * @interface RequestPasswordResetDto
 */
export interface RequestPasswordResetDto {
    /**
     * Your email address.
     * @type {string}
     * @memberof RequestPasswordResetDto
     */
    'email': string;
}
/**
 * 
 * @export
 * @interface ResendVerificationResponseDto
 */
export interface ResendVerificationResponseDto {
    /**
     * A new confirmation link was mailed to the account address.
     * @type {boolean}
     * @memberof ResendVerificationResponseDto
     */
    'sent'?: boolean;
    /**
     * The address is already confirmed; nothing was sent.
     * @type {boolean}
     * @memberof ResendVerificationResponseDto
     */
    'alreadyVerified'?: boolean;
}
/**
 * 
 * @export
 * @interface ResetPasswordDto
 */
export interface ResetPasswordDto {
    /**
     * The unique reset token for password reset.
     * @type {string}
     * @memberof ResetPasswordDto
     */
    'token': string;
    /**
     * The new password the user wants to set.
     * @type {string}
     * @memberof ResetPasswordDto
     */
    'newPassword': string;
}
/**
 * 
 * @export
 * @interface ResolveScanDto
 */
export interface ResolveScanDto {
    /**
     * Raw payload the camera read.
     * @type {string}
     * @memberof ResolveScanDto
     */
    'code': string;
}
/**
 * 
 * @export
 * @interface ReturningCustomersResponseDto
 */
export interface ReturningCustomersResponseDto {
    /**
     * Distinct customers with >=1 completed order
     * @type {number}
     * @memberof ReturningCustomersResponseDto
     */
    'totalCustomers': number;
    /**
     * Customers with 2+ completed orders
     * @type {number}
     * @memberof ReturningCustomersResponseDto
     */
    'repeatCustomers': number;
    /**
     * repeatCustomers / totalCustomers (0-1)
     * @type {number}
     * @memberof ReturningCustomersResponseDto
     */
    'repeatRate': number;
    /**
     * Average completed orders per customer
     * @type {number}
     * @memberof ReturningCustomersResponseDto
     */
    'averageOrdersPerCustomer': number;
    /**
     * Total completed orders (all customers)
     * @type {number}
     * @memberof ReturningCustomersResponseDto
     */
    'totalOrders': number;
    /**
     * Total revenue across completed orders (EUR)
     * @type {number}
     * @memberof ReturningCustomersResponseDto
     */
    'totalRevenueEur': number;
    /**
     * Average order value across all completed orders (EUR)
     * @type {number}
     * @memberof ReturningCustomersResponseDto
     */
    'averageOrderValueEur': number;
    /**
     * Histogram of days between consecutive orders
     * @type {Array<DaysBetweenBucketDto>}
     * @memberof ReturningCustomersResponseDto
     */
    'daysBetweenOrders': Array<DaysBetweenBucketDto>;
    /**
     * 
     * @type {CustomerSegmentsDto}
     * @memberof ReturningCustomersResponseDto
     */
    'segments': CustomerSegmentsDto;
    /**
     * Best customers ranked by lifetime spend
     * @type {Array<BestCustomerDto>}
     * @memberof ReturningCustomersResponseDto
     */
    'bestCustomers': Array<BestCustomerDto>;
    /**
     * Customer lifetime value at 3, 6 and 12 months
     * @type {CustomerLtvDto}
     * @memberof ReturningCustomersResponseDto
     */
    'ltv': CustomerLtvDto;
}
/**
 *
 * @export
 * @interface CustomerLtvDto
 */
export interface CustomerLtvDto {
    /**
     * One row per horizon (3, 6, 12 months)
     * @type {Array<LtvHorizonDto>}
     * @memberof CustomerLtvDto
     */
    'horizons': Array<LtvHorizonDto>;
    /**
     * First-order quarters, newest first
     * @type {Array<LtvCohortDto>}
     * @memberof CustomerLtvDto
     */
    'cohorts': Array<LtvCohortDto>;
}
/**
 *
 * @export
 * @interface LtvCohortDto
 */
export interface LtvCohortDto {
    /**
     * Quarter of the first order
     * @type {string}
     * @memberof LtvCohortDto
     */
    'cohort': string;
    /**
     * Customers whose first order fell in this quarter
     * @type {number}
     * @memberof LtvCohortDto
     */
    'customers': number;
    /**
     * LTV (EUR) keyed by horizon in months (\"3\", \"6\", \"12\"); null while the window is not over for the whole cohort
     * @type {{ [key: string]: number | null; }}
     * @memberof LtvCohortDto
     */
    'ltvEur': { [key: string]: number | null; };
}
/**
 *
 * @export
 * @interface LtvHorizonDto
 */
export interface LtvHorizonDto {
    /**
     * Months from the first order
     * @type {number}
     * @memberof LtvHorizonDto
     */
    'months': number;
    /**
     * Customers whose first order is at least `months` old
     * @type {number}
     * @memberof LtvHorizonDto
     */
    'customers': number;
    /**
     * Average spend in the first `months` months, first order included (EUR)
     * @type {number}
     * @memberof LtvHorizonDto
     */
    'ltvEur': number;
    /**
     * Average first-order value of the same customers (EUR)
     * @type {number}
     * @memberof LtvHorizonDto
     */
    'firstOrderEur': number;
    /**
     * Average completed orders in the window
     * @type {number}
     * @memberof LtvHorizonDto
     */
    'ordersPerCustomer': number;
    /**
     * Share with a second order inside the window (0-1)
     * @type {number}
     * @memberof LtvHorizonDto
     */
    'repeatRate': number;
}
/**
 * 
 * @export
 * @interface SaveShippingAddressDto
 */
export interface SaveShippingAddressDto {
    /**
     * 
     * @type {string}
     * @memberof SaveShippingAddressDto
     */
    'firstName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SaveShippingAddressDto
     */
    'lastName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SaveShippingAddressDto
     */
    'email'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SaveShippingAddressDto
     */
    'phone'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SaveShippingAddressDto
     */
    'address1'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SaveShippingAddressDto
     */
    'address2'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SaveShippingAddressDto
     */
    'zip'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SaveShippingAddressDto
     */
    'city'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SaveShippingAddressDto
     */
    'country'?: string | null;
}
/**
 * 
 * @export
 * @interface SetAppMinVersionDto
 */
export interface SetAppMinVersionDto {
    /**
     * MAJOR.MINOR.PATCH; 0.0.0 blocks nobody.
     * @type {string}
     * @memberof SetAppMinVersionDto
     */
    'minimum': string;
}
/**
 * 
 * @export
 * @interface SetLeadDto
 */
export interface SetLeadDto {
    /**
     * 
     * @type {string}
     * @memberof SetLeadDto
     */
    'memberId': string;
}
/**
 * 
 * @export
 * @interface SetNumberSettingDto
 */
export interface SetNumberSettingDto {
    /**
     * 
     * @type {number}
     * @memberof SetNumberSettingDto
     */
    'value': number;
}
/**
 * 
 * @export
 * @interface SetScannedOrderStatusDto
 */
export interface SetScannedOrderStatusDto {
    /**
     * 
     * @type {string}
     * @memberof SetScannedOrderStatusDto
     */
    'status': SetScannedOrderStatusDtoStatusEnum;
    /**
     * Send the customer the usual status-change email.
     * @type {boolean}
     * @memberof SetScannedOrderStatusDto
     */
    'notifyCustomer'?: boolean;
    /**
     * Why it was changed by hand.
     * @type {string}
     * @memberof SetScannedOrderStatusDto
     */
    'reason'?: string;
}

export const SetScannedOrderStatusDtoStatusEnum = {
    Processing: 'PROCESSING',
    InProduction: 'IN_PRODUCTION',
    Shipped: 'SHIPPED',
    Delivered: 'DELIVERED',
    Canceled: 'CANCELED'
} as const;

export type SetScannedOrderStatusDtoStatusEnum = typeof SetScannedOrderStatusDtoStatusEnum[keyof typeof SetScannedOrderStatusDtoStatusEnum];

/**
 * 
 * @export
 * @interface SetSelectedBundleDto
 */
export interface SetSelectedBundleDto {
    /**
     * null clears the selection
     * @type {string}
     * @memberof SetSelectedBundleDto
     */
    'bundleId': string | null;
}
/**
 * 
 * @export
 * @interface SetSettingDto
 */
export interface SetSettingDto {
    /**
     * 
     * @type {boolean}
     * @memberof SetSettingDto
     */
    'value': boolean;
}
/**
 * 
 * @export
 * @interface SetTrackingConsentDto
 */
export interface SetTrackingConsentDto {
    /**
     * True if the customer allowed tracking. Do not call this until the prompt has been answered.
     * @type {boolean}
     * @memberof SetTrackingConsentDto
     */
    'authorized': boolean;
}
/**
 * 
 * @export
 * @interface ShippingRateOptionDto
 */
export interface ShippingRateOptionDto {
    /**
     * 
     * @type {string}
     * @memberof ShippingRateOptionDto
     */
    'method': ShippingRateOptionDtoMethodEnum;
    /**
     * null for free / store-pickup which has no delivery type
     * @type {string}
     * @memberof ShippingRateOptionDto
     */
    'deliveryType': ShippingRateOptionDtoDeliveryTypeEnum;
    /**
     * 
     * @type {number}
     * @memberof ShippingRateOptionDto
     */
    'priceCents': number;
}

export const ShippingRateOptionDtoMethodEnum = {
    Free: 'free',
    Normal: 'normal',
    Express: 'express'
} as const;

export type ShippingRateOptionDtoMethodEnum = typeof ShippingRateOptionDtoMethodEnum[keyof typeof ShippingRateOptionDtoMethodEnum];
export const ShippingRateOptionDtoDeliveryTypeEnum = {
    Home: 'HOME',
    ParcelLock: 'PARCEL_LOCK'
} as const;

export type ShippingRateOptionDtoDeliveryTypeEnum = typeof ShippingRateOptionDtoDeliveryTypeEnum[keyof typeof ShippingRateOptionDtoDeliveryTypeEnum];

/**
 * 
 * @export
 * @interface ShippingRatesResponseDto
 */
export interface ShippingRatesResponseDto {
    /**
     * 
     * @type {string}
     * @memberof ShippingRatesResponseDto
     */
    'currency': string;
    /**
     * ISO country code used to derive currency / store-pickup
     * @type {string}
     * @memberof ShippingRatesResponseDto
     */
    'country': string;
    /**
     * 
     * @type {Array<ShippingRateOptionDto>}
     * @memberof ShippingRatesResponseDto
     */
    'methods': Array<ShippingRateOptionDto>;
    /**
     * Cash-on-delivery fee in cents (or 0 if not available)
     * @type {number}
     * @memberof ShippingRatesResponseDto
     */
    'codFeeCents': number;
    /**
     * Minimum subtotal in cents for cash on delivery. 0 means COD is not offered for this country — not \"no minimum\". Never truthiness-test.
     * @type {number}
     * @memberof ShippingRatesResponseDto
     */
    'codMinimumCents': number;
    /**
     * Subtotal in cents at which normal shipping becomes free (null if no threshold)
     * @type {number}
     * @memberof ShippingRatesResponseDto
     */
    'freeShippingThresholdCents': number | null;
}
/**
 * 
 * @export
 * @interface SubscribeDto
 */
export interface SubscribeDto {
    /**
     * 
     * @type {string}
     * @memberof SubscribeDto
     */
    'email': string;
    /**
     * 
     * @type {string}
     * @memberof SubscribeDto
     */
    'locale'?: SubscribeDtoLocaleEnum;
    /**
     * Leave empty. Spam trap.
     * @type {string}
     * @memberof SubscribeDto
     */
    'company'?: string;
}

export const SubscribeDtoLocaleEnum = {
    Sl: 'sl',
    Hr: 'hr',
    Sk: 'sk',
    Pl: 'pl'
} as const;

export type SubscribeDtoLocaleEnum = typeof SubscribeDtoLocaleEnum[keyof typeof SubscribeDtoLocaleEnum];

/**
 * 
 * @export
 * @interface SubscribeResponseDto
 */
export interface SubscribeResponseDto {
    /**
     * 
     * @type {boolean}
     * @memberof SubscribeResponseDto
     */
    'ok': boolean;
}
/**
 *
 * @export
 * @interface TemplateConversionDto
 */
export interface TemplateConversionDto {
    /**
     * Order id
     * @type {string}
     * @memberof TemplateConversionDto
     */
    'orderId': string | null;
    /**
     * Recipient / order email (lowercased)
     * @type {string}
     * @memberof TemplateConversionDto
     */
    'email': string;
    /**
     * When the email was sent
     * @type {string}
     * @memberof TemplateConversionDto
     */
    'sentAt': string;
    /**
     * When the order was bought (paidAt, else placedAt, else createdAt)
     * @type {string}
     * @memberof TemplateConversionDto
     */
    'orderedAt': string;
    /**
     * Hours from send to order
     * @type {number}
     * @memberof TemplateConversionDto
     */
    'hoursToOrder': number;
    /**
     * Order value in EUR
     * @type {number}
     * @memberof TemplateConversionDto
     */
    'amountEur': number;
}
/**
 *
 * @export
 * @interface TrackPageViewDto
 */
export interface TrackPageViewDto {
    /**
     * URL of the page being viewed
     * @type {string}
     * @memberof TrackPageViewDto
     */
    'pageUrl': string;
    /**
     * Title of the page being viewed
     * @type {string}
     * @memberof TrackPageViewDto
     */
    'pageTitle'?: string;
    /**
     * Facebook Click ID (fbc cookie)
     * @type {string}
     * @memberof TrackPageViewDto
     */
    'fbc'?: string;
    /**
     * Facebook Browser ID (fbp cookie)
     * @type {string}
     * @memberof TrackPageViewDto
     */
    'fbp'?: string;
    /**
     * Country code (ISO 2-letter)
     * @type {string}
     * @memberof TrackPageViewDto
     */
    'country': string;
}
/**
 * 
 * @export
 * @interface TripSuggestionDto
 */
export interface TripSuggestionDto {
    /**
     * 
     * @type {number}
     * @memberof TripSuggestionDto
     */
    'suggested': number;
    /**
     * ≤ suggested
     * @type {number}
     * @memberof TripSuggestionDto
     */
    'kept': number;
    /**
     * 
     * @type {number}
     * @memberof TripSuggestionDto
     */
    'added': number;
}
/**
 * 
 * @export
 * @interface UpdateArtworkDto
 */
export interface UpdateArtworkDto {
    /**
     * 
     * @type {string}
     * @memberof UpdateArtworkDto
     */
    'kind'?: UpdateArtworkDtoKindEnum;
    /**
     * 
     * @type {string}
     * @memberof UpdateArtworkDto
     */
    'slug'?: string;
    /**
     * 
     * @type {object}
     * @memberof UpdateArtworkDto
     */
    'title'?: object;
    /**
     * 
     * @type {string}
     * @memberof UpdateArtworkDto
     */
    'artist'?: string;
    /**
     * 
     * @type {number}
     * @memberof UpdateArtworkDto
     */
    'year'?: number;
    /**
     * 
     * @type {object}
     * @memberof UpdateArtworkDto
     */
    'description'?: object;
    /**
     * 
     * @type {string}
     * @memberof UpdateArtworkDto
     */
    'sourceKey'?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateArtworkDto
     */
    'displayKey'?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateArtworkDto
     */
    'thumbKey'?: string;
    /**
     * 
     * @type {number}
     * @memberof UpdateArtworkDto
     */
    'widthPx'?: number;
    /**
     * 
     * @type {number}
     * @memberof UpdateArtworkDto
     */
    'heightPx'?: number;
    /**
     * 
     * @type {string}
     * @memberof UpdateArtworkDto
     */
    'licence'?: UpdateArtworkDtoLicenceEnum;
    /**
     * 
     * @type {string}
     * @memberof UpdateArtworkDto
     */
    'rightsHolder'?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateArtworkDto
     */
    'attribution'?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateArtworkDto
     */
    'sourceUrl'?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateArtworkDto
     */
    'contributorId'?: string;
    /**
     * 
     * @type {number}
     * @memberof UpdateArtworkDto
     */
    'royaltyBps'?: number;
    /**
     * 
     * @type {Array<string>}
     * @memberof UpdateArtworkDto
     */
    'tags'?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof UpdateArtworkDto
     */
    'collectionIds'?: Array<string>;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateArtworkDto
     */
    'featured'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateArtworkDto
     */
    'active'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof UpdateArtworkDto
     */
    'sortOrder'?: number;
}

export const UpdateArtworkDtoKindEnum = {
    Art: 'ART',
    Photo: 'PHOTO'
} as const;

export type UpdateArtworkDtoKindEnum = typeof UpdateArtworkDtoKindEnum[keyof typeof UpdateArtworkDtoKindEnum];
export const UpdateArtworkDtoLicenceEnum = {
    PublicDomain: 'PUBLIC_DOMAIN',
    Contributor: 'CONTRIBUTOR'
} as const;

export type UpdateArtworkDtoLicenceEnum = typeof UpdateArtworkDtoLicenceEnum[keyof typeof UpdateArtworkDtoLicenceEnum];

/**
 * 
 * @export
 * @interface UpdateBannerMessageDto
 */
export interface UpdateBannerMessageDto {
    /**
     * Localized message
     * @type {object}
     * @memberof UpdateBannerMessageDto
     */
    'message': object;
    /**
     * Date until the message is valid
     * @type {object}
     * @memberof UpdateBannerMessageDto
     */
    'validUntil': object;
    /**
     * Rank of the message
     * @type {number}
     * @memberof UpdateBannerMessageDto
     */
    'rank': number;
    /**
     * Time to show the message
     * @type {number}
     * @memberof UpdateBannerMessageDto
     */
    'timeToShow': number;
    /**
     * Background color of the message
     * @type {string}
     * @memberof UpdateBannerMessageDto
     */
    'backGroundColor': string;
    /**
     * Text color of the message
     * @type {string}
     * @memberof UpdateBannerMessageDto
     */
    'textColor': string;
    /**
     * Font size of the message
     * @type {string}
     * @memberof UpdateBannerMessageDto
     */
    'fontSize': string;
}
/**
 * 
 * @export
 * @interface UpdateBundleDto
 */
export interface UpdateBundleDto {
    /**
     * At most 60 characters per locale.
     * @type {object}
     * @memberof UpdateBundleDto
     */
    'name'?: object;
    /**
     * 
     * @type {object}
     * @memberof UpdateBundleDto
     */
    'description'?: object | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateBundleDto
     */
    'imageKey'?: string | null;
    /**
     * EUR minor units
     * @type {number}
     * @memberof UpdateBundleDto
     */
    'price'?: number | null;
    /**
     * 
     * @type {object}
     * @memberof UpdateBundleDto
     */
    'priceCurrencies'?: object;
    /**
     * 
     * @type {string}
     * @memberof UpdateBundleDto
     */
    'channel'?: UpdateBundleDtoChannelEnum;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateBundleDto
     */
    'active'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof UpdateBundleDto
     */
    'startsAt'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateBundleDto
     */
    'endsAt'?: string | null;
    /**
     * Kuponi dovoljeni; default false
     * @type {boolean}
     * @memberof UpdateBundleDto
     */
    'couponsAllowed'?: boolean;
    /**
     * Večkrat v naročilu; default true
     * @type {boolean}
     * @memberof UpdateBundleDto
     */
    'repeatable'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof UpdateBundleDto
     */
    'sortOrder'?: number;
    /**
     * 
     * @type {Array<BundleSlotInputDto>}
     * @memberof UpdateBundleDto
     */
    'slots'?: Array<BundleSlotInputDto>;
}

export const UpdateBundleDtoChannelEnum = {
    All: 'ALL',
    Web: 'WEB',
    Mobile: 'MOBILE'
} as const;

export type UpdateBundleDtoChannelEnum = typeof UpdateBundleDtoChannelEnum[keyof typeof UpdateBundleDtoChannelEnum];

/**
 * 
 * @export
 * @interface UpdateCashbackPromotionDto
 */
export interface UpdateCashbackPromotionDto {
    /**
     * 
     * @type {string}
     * @memberof UpdateCashbackPromotionDto
     */
    'name'?: string;
    /**
     * 
     * @type {number}
     * @memberof UpdateCashbackPromotionDto
     */
    'rateBp'?: number;
    /**
     * 
     * @type {number}
     * @memberof UpdateCashbackPromotionDto
     */
    'lotLifetimeDays'?: number;
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof UpdateCashbackPromotionDto
     */
    'currencyRules'?: { [key: string]: any; };
    /**
     * 
     * @type {string}
     * @memberof UpdateCashbackPromotionDto
     */
    'startsAt'?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateCashbackPromotionDto
     */
    'endsAt'?: string;
    /**
     * 
     * @type {CashbackPromotionChannel}
     * @memberof UpdateCashbackPromotionDto
     */
    'channel'?: CashbackPromotionChannel;
}


/**
 * 
 * @export
 * @interface UpdateCouponDto
 */
export interface UpdateCouponDto {
    /**
     * Date until the coupon is valid
     * @type {object}
     * @memberof UpdateCouponDto
     */
    'validUntil'?: object;
    /**
     * Unique code of the coupon
     * @type {string}
     * @memberof UpdateCouponDto
     */
    'code'?: string;
    /**
     * Discount percentage or amount
     * @type {number}
     * @memberof UpdateCouponDto
     */
    'discount'?: number;
    /**
     * 
     * @type {string}
     * @memberof UpdateCouponDto
     */
    'type'?: string;
    /**
     * Description of the coupon
     * @type {string}
     * @memberof UpdateCouponDto
     */
    'description'?: string;
    /**
     * Free shipping
     * @type {boolean}
     * @memberof UpdateCouponDto
     */
    'freeShipping'?: boolean;
    /**
     * Minimum amount of the order to use the coupon
     * @type {number}
     * @memberof UpdateCouponDto
     */
    'minimumAmount'?: number;
    /**
     * Minimum amount of the order for free shipping
     * @type {number}
     * @memberof UpdateCouponDto
     */
    'minimumAmountShipping'?: number;
    /**
     * Maximum discount amount of the order
     * @type {number}
     * @memberof UpdateCouponDto
     */
    'maximumDiscountAmount'?: number;
    /**
     * Applicable photo sizes IDs
     * @type {Array<string>}
     * @memberof UpdateCouponDto
     */
    'photoSizesIds'?: Array<string>;
    /**
     * Applicable currencies
     * @type {Array<string>}
     * @memberof UpdateCouponDto
     */
    'currencies'?: Array<string>;
    /**
     * 
     * @type {CouponRewardType}
     * @memberof UpdateCouponDto
     */
    'rewardType'?: CouponRewardType;
    /**
     * CASHBACK only: days the granted credit stays usable.
     * @type {number}
     * @memberof UpdateCouponDto
     */
    'cashbackLifetimeDays'?: number;
}


/**
 * 
 * @export
 * @interface UpdateDeliveryPointDto
 */
export interface UpdateDeliveryPointDto {
    /**
     * Delivery point ID
     * @type {string}
     * @memberof UpdateDeliveryPointDto
     */
    'deliveryPointId': string;
    /**
     * Delivery point name
     * @type {string}
     * @memberof UpdateDeliveryPointDto
     */
    'deliveryPointName': string;
    /**
     * Delivery point street
     * @type {string}
     * @memberof UpdateDeliveryPointDto
     */
    'deliveryPointStreet': string;
    /**
     * Delivery point house number
     * @type {string}
     * @memberof UpdateDeliveryPointDto
     */
    'deliveryPointHouseNumber': string;
    /**
     * Delivery point city
     * @type {string}
     * @memberof UpdateDeliveryPointDto
     */
    'deliveryPointCity': string;
    /**
     * Delivery point ZIP code
     * @type {string}
     * @memberof UpdateDeliveryPointDto
     */
    'deliveryPointZipCode': string;
    /**
     * Delivery point country ISO code
     * @type {string}
     * @memberof UpdateDeliveryPointDto
     */
    'deliveryPointCountryIsoCode': string;
}
/**
 * 
 * @export
 * @interface UpdateDeliveryTypeDto
 */
export interface UpdateDeliveryTypeDto {
    /**
     * Type of delivery
     * @type {string}
     * @memberof UpdateDeliveryTypeDto
     */
    'deliveryType': UpdateDeliveryTypeDtoDeliveryTypeEnum;
    /**
     * 
     * @type {UpdateDeliveryPointDto}
     * @memberof UpdateDeliveryTypeDto
     */
    'deliveryPoint'?: UpdateDeliveryPointDto;
}

export const UpdateDeliveryTypeDtoDeliveryTypeEnum = {
    Home: 'HOME',
    ParcelLock: 'PARCEL_LOCK'
} as const;

export type UpdateDeliveryTypeDtoDeliveryTypeEnum = typeof UpdateDeliveryTypeDtoDeliveryTypeEnum[keyof typeof UpdateDeliveryTypeDtoDeliveryTypeEnum];

/**
 * 
 * @export
 * @interface UpdateElementImageDto
 */
export interface UpdateElementImageDto {
    /**
     * 
     * @type {string}
     * @memberof UpdateElementImageDto
     */
    'key'?: string;
    /**
     * Localized name { locale: string }
     * @type {object}
     * @memberof UpdateElementImageDto
     */
    'name'?: object;
    /**
     * 
     * @type {string}
     * @memberof UpdateElementImageDto
     */
    'category'?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateElementImageDto
     */
    'mimeType'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateElementImageDto
     */
    'active'?: boolean;
    /**
     * 
     * @type {Array<string>}
     * @memberof UpdateElementImageDto
     */
    'keywords'?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof UpdateElementImageDto
     */
    'type'?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateElementImageDto
     */
    'style'?: string;
}
/**
 * 
 * @export
 * @interface UpdateEmailRuleDto
 */
export interface UpdateEmailRuleDto {
    /**
     * 
     * @type {string}
     * @memberof UpdateEmailRuleDto
     */
    'name'?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateEmailRuleDto
     */
    'templateKey'?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateEmailRuleDto
     */
    'trigger'?: UpdateEmailRuleDtoTriggerEnum;
    /**
     * 
     * @type {number}
     * @memberof UpdateEmailRuleDto
     */
    'delayHours'?: number;
    /**
     * 
     * @type {number}
     * @memberof UpdateEmailRuleDto
     */
    'maxDelayHours'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof UpdateEmailRuleDto
     */
    'fireAtHour'?: number | null;
    /**
     * 
     * @type {object}
     * @memberof UpdateEmailRuleDto
     */
    'conditions'?: object | null;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateEmailRuleDto
     */
    'oncePerRecipient'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateEmailRuleDto
     */
    'promotional'?: boolean;
    /**
     * Dedupe cooldown in days. Null = never re-fire; promotional rules with null fall back to 90.
     * @type {number}
     * @memberof UpdateEmailRuleDto
     */
    'dedupeWindowDays'?: number | null;
    /**
     * Skip an order whose customer paid for a newer order since the anchor.
     * @type {boolean}
     * @memberof UpdateEmailRuleDto
     */
    'stopIfReordered'?: boolean;
    /**
     * Send only while the recipient holds unspent granted credit (expiry reminder).
     * @type {boolean}
     * @memberof UpdateEmailRuleDto
     */
    'requireUnspentCredit'?: boolean;
    /**
     * Mint a credit lot when the rule fires: { amountsByCurrency: { eur: 500 }, lifetimeDays: 14, minimumByCurrency?: { eur: 1500 } }, minor units.
     * @type {object}
     * @memberof UpdateEmailRuleDto
     */
    'grantCredit'?: object | null;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateEmailRuleDto
     */
    'active'?: boolean;
}

export const UpdateEmailRuleDtoTriggerEnum = {
    OrderCreated: 'ORDER_CREATED',
    OrderPaid: 'ORDER_PAID',
    OrderShipped: 'ORDER_SHIPPED',
    OrderDelivered: 'ORDER_DELIVERED',
    OrderCanceled: 'ORDER_CANCELED',
    PaymentUnfinished: 'PAYMENT_UNFINISHED'
} as const;

export type UpdateEmailRuleDtoTriggerEnum = typeof UpdateEmailRuleDtoTriggerEnum[keyof typeof UpdateEmailRuleDtoTriggerEnum];

/**
 * 
 * @export
 * @interface UpdateEmailTemplateDto
 */
export interface UpdateEmailTemplateDto {
    /**
     * 
     * @type {string}
     * @memberof UpdateEmailTemplateDto
     */
    'key'?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateEmailTemplateDto
     */
    'locale'?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateEmailTemplateDto
     */
    'subject'?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateEmailTemplateDto
     */
    'htmlBody'?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateEmailTemplateDto
     */
    'textBody'?: string | null;
}
/**
 * 
 * @export
 * @interface UpdateInvoiceDto
 */
export interface UpdateInvoiceDto {
    /**
     * Override invoice number
     * @type {string}
     * @memberof UpdateInvoiceDto
     */
    'invoiceNumber'?: string;
    /**
     * Override customer details
     * @type {object}
     * @memberof UpdateInvoiceDto
     */
    'customer'?: object;
    /**
     * Override invoice items
     * @type {Array<InvoiceItemDto>}
     * @memberof UpdateInvoiceDto
     */
    'items'?: Array<InvoiceItemDto>;
    /**
     * Override utility items (shipping, fees). vatAmount is recomputed from price + vatRate server-side.
     * @type {Array<InvoiceUtilityItemDto>}
     * @memberof UpdateInvoiceDto
     */
    'utilityItems'?: Array<InvoiceUtilityItemDto>;
    /**
     * Custom notes to add to invoice
     * @type {string}
     * @memberof UpdateInvoiceDto
     */
    'notes'?: string;
    /**
     * Language for the invoice
     * @type {string}
     * @memberof UpdateInvoiceDto
     */
    'language'?: string;
    /**
     * Fiscalization status
     * @type {string}
     * @memberof UpdateInvoiceDto
     */
    'fiscalizationStatus'?: UpdateInvoiceDtoFiscalizationStatusEnum;
    /**
     * Fiscalization error message
     * @type {string}
     * @memberof UpdateInvoiceDto
     */
    'fiscalizationError'?: string;
}

export const UpdateInvoiceDtoFiscalizationStatusEnum = {
    Pending: 'PENDING',
    Success: 'SUCCESS',
    Failed: 'FAILED',
    Retry: 'RETRY',
    Pantheon: 'PANTHEON'
} as const;

export type UpdateInvoiceDtoFiscalizationStatusEnum = typeof UpdateInvoiceDtoFiscalizationStatusEnum[keyof typeof UpdateInvoiceDtoFiscalizationStatusEnum];

/**
 * 
 * @export
 * @interface UpdateMyMembershipDto
 */
export interface UpdateMyMembershipDto {
    /**
     * Shown on professional photos; blank or null clears it
     * @type {string}
     * @memberof UpdateMyMembershipDto
     */
    'creditName': string | null;
}
/**
 * 
 * @export
 * @interface UpdateOrderCalendarDto
 */
export interface UpdateOrderCalendarDto {
    /**
     * 
     * @type {string}
     * @memberof UpdateOrderCalendarDto
     */
    'format'?: UpdateOrderCalendarDtoFormatEnum;
    /**
     * 
     * @type {number}
     * @memberof UpdateOrderCalendarDto
     */
    'quantity'?: number;
    /**
     * 
     * @type {object}
     * @memberof UpdateOrderCalendarDto
     */
    'calendarData'?: object;
}

export const UpdateOrderCalendarDtoFormatEnum = {
    A2: 'A2',
    A3: 'A3',
    A4: 'A4',
    A5: 'A5',
    PlannerA3: 'PLANNER_A3',
    SpreadA4: 'SPREAD_A4'
} as const;

export type UpdateOrderCalendarDtoFormatEnum = typeof UpdateOrderCalendarDtoFormatEnum[keyof typeof UpdateOrderCalendarDtoFormatEnum];

/**
 * 
 * @export
 * @interface UpdateOrderCouponDto
 */
export interface UpdateOrderCouponDto {
    /**
     * 
     * @type {string}
     * @memberof UpdateOrderCouponDto
     */
    'couponCode': string;
}
/**
 * 
 * @export
 * @interface UpdateOrderCreditDto
 */
export interface UpdateOrderCreditDto {
    /**
     * The two-hour credit token from ?credit_token= in the claim redirect. Omit when the caller is signed in as the credit owner.
     * @type {string}
     * @memberof UpdateOrderCreditDto
     */
    'creditToken'?: string;
    /**
     * The lots to spend, by id (GET /credit/balance lots[].id). Omit for automatic mode: every applicable lot, soonest-expiring first. Given, only these are spent, soonest-expiring first, and the choice is kept on the order through later cart changes (a chosen lot that does not apply now is not spent, but stays chosen). [] takes the credit off, like remove-credit. Ids the caller has not proven are ignored.
     * @type {Array<string>}
     * @memberof UpdateOrderCreditDto
     */
    'lotIds'?: Array<string>;
}
/**
 * 
 * @export
 * @interface UpdateOrderDto
 */
export interface UpdateOrderDto {
    /**
     * Status of the order
     * @type {string}
     * @memberof UpdateOrderDto
     */
    'status'?: string;
    /**
     * Photo size ID
     * @type {string}
     * @memberof UpdateOrderDto
     */
    'photoSizeId'?: string;
    /**
     * User ID of the order owner
     * @type {string}
     * @memberof UpdateOrderDto
     */
    'userId'?: string;
    /**
     * Total amount of the order
     * @type {number}
     * @memberof UpdateOrderDto
     */
    'amount'?: number;
    /**
     * Coupon ID used for the order
     * @type {string}
     * @memberof UpdateOrderDto
     */
    'couponUsedId'?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateOrderDto
     */
    'stripePaymentIntentId': string;
    /**
     * 
     * @type {number}
     * @memberof UpdateOrderDto
     */
    'stripeAmount': number;
    /**
     * 
     * @type {string}
     * @memberof UpdateOrderDto
     */
    'stripeCurrency': string;
    /**
     * 
     * @type {string}
     * @memberof UpdateOrderDto
     */
    'stripeStatus': string;
    /**
     * 
     * @type {string}
     * @memberof UpdateOrderDto
     */
    'stripeCreated': string;
    /**
     * 
     * @type {string}
     * @memberof UpdateOrderDto
     */
    'stripeClientSecret': string;
    /**
     * 
     * @type {string}
     * @memberof UpdateOrderDto
     */
    'shippingAddress1': string;
    /**
     * 
     * @type {string}
     * @memberof UpdateOrderDto
     */
    'shippingAddress2': string;
    /**
     * 
     * @type {string}
     * @memberof UpdateOrderDto
     */
    'shippingCity': string;
    /**
     * 
     * @type {string}
     * @memberof UpdateOrderDto
     */
    'shippingZip': string;
    /**
     * 
     * @type {string}
     * @memberof UpdateOrderDto
     */
    'shippingCountry': string;
    /**
     * 
     * @type {string}
     * @memberof UpdateOrderDto
     */
    'shippingState': string;
    /**
     * 
     * @type {string}
     * @memberof UpdateOrderDto
     */
    'shippingPhone': string;
    /**
     * 
     * @type {string}
     * @memberof UpdateOrderDto
     */
    'shippingEmail': string;
    /**
     * 
     * @type {string}
     * @memberof UpdateOrderDto
     */
    'shippingFirstName': string;
    /**
     * 
     * @type {string}
     * @memberof UpdateOrderDto
     */
    'shippingLastName': string;
    /**
     * 
     * @type {string}
     * @memberof UpdateOrderDto
     */
    'shippingNotes': string;
    /**
     * 
     * @type {string}
     * @memberof UpdateOrderDto
     */
    'shippingMethod': string;
    /**
     * 
     * @type {string}
     * @memberof UpdateOrderDto
     */
    'paymentOption': string;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateOrderDto
     */
    'shouldNotifyUser': boolean;
    /**
     * 
     * @type {string}
     * @memberof UpdateOrderDto
     */
    'ipAddress': string;
    /**
     * 
     * @type {string}
     * @memberof UpdateOrderDto
     */
    'userAgent': string;
    /**
     * 
     * @type {string}
     * @memberof UpdateOrderDto
     */
    'fbc': string;
    /**
     * 
     * @type {string}
     * @memberof UpdateOrderDto
     */
    'fbp': string;
    /**
     * 
     * @type {string}
     * @memberof UpdateOrderDto
     */
    'currency': string;
    /**
     * 
     * @type {number}
     * @memberof UpdateOrderDto
     */
    'downlink': number | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateOrderDto
     */
    'domain': string | null;
    /**
     * Invoice fiscalization status - can be updated manually if fiscalized using a different system
     * @type {string}
     * @memberof UpdateOrderDto
     */
    'invoiceStatus'?: UpdateOrderDtoInvoiceStatusEnum;
    /**
     * Ecological packaging option (+1.00 EUR)
     * @type {boolean}
     * @memberof UpdateOrderDto
     */
    'ecologicalPackaging': boolean;
    /**
     * Priority complaint option (+0.80 EUR)
     * @type {boolean}
     * @memberof UpdateOrderDto
     */
    'priorityComplaint': boolean;
    /**
     * Wrap as gift option (+6.00 EUR)
     * @type {boolean}
     * @memberof UpdateOrderDto
     */
    'wrapAsGift': boolean;
    /**
     * Gift text (required if wrapAsGift is true)
     * @type {string}
     * @memberof UpdateOrderDto
     */
    'giftText': string;
    /**
     * Premium paper option (price per photo, photoSize-dependent)
     * @type {boolean}
     * @memberof UpdateOrderDto
     */
    'premiumPaper': boolean;
    /**
     * Professional crop option (+2.00 EUR flat fee)
     * @type {boolean}
     * @memberof UpdateOrderDto
     */
    'professionalCrop': boolean;
    /**
     * White border option (price per photo, photoSize-dependent)
     * @type {boolean}
     * @memberof UpdateOrderDto
     */
    'whiteBorder': boolean;
    /**
     * Black and white option (price per photo, photoSize-dependent)
     * @type {boolean}
     * @memberof UpdateOrderDto
     */
    'blackAndWhite': boolean;
}

export const UpdateOrderDtoInvoiceStatusEnum = {
    Pending: 'PENDING',
    Success: 'SUCCESS',
    Failed: 'FAILED',
    Retry: 'RETRY',
    Pantheon: 'PANTHEON'
} as const;

export type UpdateOrderDtoInvoiceStatusEnum = typeof UpdateOrderDtoInvoiceStatusEnum[keyof typeof UpdateOrderDtoInvoiceStatusEnum];

/**
 * 
 * @export
 * @interface UpdateOrderProductDetailDto
 */
export interface UpdateOrderProductDetailDto {
    /**
     * IDs of order
     * @type {string}
     * @memberof UpdateOrderProductDetailDto
     */
    'orderId'?: string;
    /**
     * ID of the product
     * @type {string}
     * @memberof UpdateOrderProductDetailDto
     */
    'productId'?: string;
    /**
     * Quantity of the product
     * @type {number}
     * @memberof UpdateOrderProductDetailDto
     */
    'quantity'?: number;
}
/**
 * 
 * @export
 * @interface UpdateOrderShippingDto
 */
export interface UpdateOrderShippingDto {
    /**
     * 
     * @type {string}
     * @memberof UpdateOrderShippingDto
     */
    'shippingAddress1'?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateOrderShippingDto
     */
    'shippingAddress2'?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateOrderShippingDto
     */
    'shippingCity'?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateOrderShippingDto
     */
    'shippingZip'?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateOrderShippingDto
     */
    'shippingCountry'?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateOrderShippingDto
     */
    'shippingState'?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateOrderShippingDto
     */
    'shippingPhone'?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateOrderShippingDto
     */
    'shippingEmail'?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateOrderShippingDto
     */
    'shippingFirstName'?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateOrderShippingDto
     */
    'shippingLastName'?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateOrderShippingDto
     */
    'shippingNotes'?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateOrderShippingDto
     */
    'shippingMethod'?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateOrderShippingDto
     */
    'paymentOption'?: string;
    /**
     * Ecological packaging option (+1.00 EUR)
     * @type {boolean}
     * @memberof UpdateOrderShippingDto
     */
    'ecologicalPackaging'?: boolean;
    /**
     * Priority complaint option (+0.80 EUR)
     * @type {boolean}
     * @memberof UpdateOrderShippingDto
     */
    'priorityComplaint'?: boolean;
    /**
     * Wrap as gift option (+6.00 EUR)
     * @type {boolean}
     * @memberof UpdateOrderShippingDto
     */
    'wrapAsGift'?: boolean;
    /**
     * Gift text (required if wrapAsGift is true)
     * @type {string}
     * @memberof UpdateOrderShippingDto
     */
    'giftText'?: string;
    /**
     * Premium paper option (price per photo, photoSize-dependent)
     * @type {boolean}
     * @memberof UpdateOrderShippingDto
     */
    'premiumPaper'?: boolean;
    /**
     * Professional crop option (+2.00 EUR flat fee)
     * @type {boolean}
     * @memberof UpdateOrderShippingDto
     */
    'professionalCrop'?: boolean;
    /**
     * White border option (price per photo, photoSize-dependent)
     * @type {boolean}
     * @memberof UpdateOrderShippingDto
     */
    'whiteBorder'?: boolean;
    /**
     * Black and white option (price per photo, photoSize-dependent)
     * @type {boolean}
     * @memberof UpdateOrderShippingDto
     */
    'blackAndWhite'?: boolean;
}
/**
 * 
 * @export
 * @interface UpdateOrderUserDTO
 */
export interface UpdateOrderUserDTO {
    /**
     * 
     * @type {string}
     * @memberof UpdateOrderUserDTO
     */
    'userId': string;
}
/**
 * 
 * @export
 * @interface UpdatePaperDto
 */
export interface UpdatePaperDto {
    /**
     * Localized name { locale: string }
     * @type {object}
     * @memberof UpdatePaperDto
     */
    'name'?: object;
    /**
     * Hex colour code, e.g. \"#FFFFFF\"
     * @type {string}
     * @memberof UpdatePaperDto
     */
    'colorHex'?: string;
    /**
     * Object key of the paper background image (not a URL)
     * @type {string}
     * @memberof UpdatePaperDto
     */
    'backgroundImage'?: string | null;
    /**
     * Weight in g/m²
     * @type {number}
     * @memberof UpdatePaperDto
     */
    'weightGsm'?: number;
    /**
     * Price in integer cents
     * @type {number}
     * @memberof UpdatePaperDto
     */
    'price'?: number;
    /**
     * 
     * @type {object}
     * @memberof UpdatePaperDto
     */
    'priceCurrencies'?: object;
    /**
     * 
     * @type {boolean}
     * @memberof UpdatePaperDto
     */
    'active'?: boolean;
    /**
     * Display/pick order (ascending); lowest is the editor default
     * @type {number}
     * @memberof UpdatePaperDto
     */
    'sortOrder'?: number;
}
/**
 * 
 * @export
 * @interface UpdatePartyDto
 */
export interface UpdatePartyDto {
    /**
     * 
     * @type {string}
     * @memberof UpdatePartyDto
     */
    'name'?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdatePartyDto
     */
    'hostMessage'?: string;
    /**
     * Only while not revealed
     * @type {string}
     * @memberof UpdatePartyDto
     */
    'revealAt'?: string;
    /**
     * Only while not revealed; null = unlimited
     * @type {number}
     * @memberof UpdatePartyDto
     */
    'shotsPerGuest'?: UpdatePartyDtoShotsPerGuestEnum;
    /**
     * Lead photographer only: whether organizers see professional photos before publish
     * @type {boolean}
     * @memberof UpdatePartyDto
     */
    'organizerPreview'?: boolean;
    /**
     * Lead photographer only: whether guests may download professional photos full size
     * @type {boolean}
     * @memberof UpdatePartyDto
     */
    'guestDownloads'?: boolean;
    /**
     * Creator only; never to photographers once guests joined
     * @type {string}
     * @memberof UpdatePartyDto
     */
    'whoShoots'?: UpdatePartyDtoWhoShootsEnum;
}

export const UpdatePartyDtoShotsPerGuestEnum = {
    NUMBER_10: 10,
    NUMBER_15: 15,
    NUMBER_25: 25,
    NUMBER_null: null
} as const;

export type UpdatePartyDtoShotsPerGuestEnum = typeof UpdatePartyDtoShotsPerGuestEnum[keyof typeof UpdatePartyDtoShotsPerGuestEnum];
export const UpdatePartyDtoWhoShootsEnum = {
    Guests: 'guests',
    Photographers: 'photographers',
    Both: 'both'
} as const;

export type UpdatePartyDtoWhoShootsEnum = typeof UpdatePartyDtoWhoShootsEnum[keyof typeof UpdatePartyDtoWhoShootsEnum];

/**
 * 
 * @export
 * @interface UpdatePhotoSizeDto
 */
export interface UpdatePhotoSizeDto {
    /**
     * Localized names of the photo size
     * @type {object}
     * @memberof UpdatePhotoSizeDto
     */
    'name': object;
    /**
     * Pixel width of the photo
     * @type {number}
     * @memberof UpdatePhotoSizeDto
     */
    'pixelWidth'?: number;
    /**
     * Pixel height of the photo
     * @type {number}
     * @memberof UpdatePhotoSizeDto
     */
    'pixelHeight'?: number;
    /**
     * Format of the photo
     * @type {string}
     * @memberof UpdatePhotoSizeDto
     */
    'format'?: string;
    /**
     * Physical width of the photo
     * @type {number}
     * @memberof UpdatePhotoSizeDto
     */
    'width'?: number;
    /**
     * Physical height of the photo
     * @type {number}
     * @memberof UpdatePhotoSizeDto
     */
    'height'?: number;
    /**
     * Price of the photo
     * @type {number}
     * @memberof UpdatePhotoSizeDto
     */
    'price'?: number;
    /**
     * Factory price of the photo
     * @type {number}
     * @memberof UpdatePhotoSizeDto
     */
    'factoryPrice'?: number;
    /**
     * Type of paper used for the photo
     * @type {string}
     * @memberof UpdatePhotoSizeDto
     */
    'paper'?: string;
    /**
     * Pricing ladder for the photo size
     * @type {Array<PriceRangeDto>}
     * @memberof UpdatePhotoSizeDto
     */
    'pricingLadder'?: Array<PriceRangeDto>;
    /**
     * Pricing ladder for different currencies
     * @type {object}
     * @memberof UpdatePhotoSizeDto
     */
    'pricingLadderCurrencies': object;
    /**
     * Prices in different currencies
     * @type {object}
     * @memberof UpdatePhotoSizeDto
     */
    'priceCurrencies': object;
    /**
     * Whether premium paper is available for this photo size
     * @type {boolean}
     * @memberof UpdatePhotoSizeDto
     */
    'premiumPaperAvailable'?: boolean;
    /**
     * Premium paper price per photo in cents (default 5 cents)
     * @type {number}
     * @memberof UpdatePhotoSizeDto
     */
    'premiumPaperPrice'?: number;
    /**
     * Premium paper prices in different currencies (in cents)
     * @type {object}
     * @memberof UpdatePhotoSizeDto
     */
    'premiumPaperPriceCurrencies'?: object;
    /**
     * Whether white border is available for this photo size
     * @type {boolean}
     * @memberof UpdatePhotoSizeDto
     */
    'whiteBorderAvailable'?: boolean;
    /**
     * White border price per photo in cents (default 5 cents)
     * @type {number}
     * @memberof UpdatePhotoSizeDto
     */
    'whiteBorderPrice'?: number;
    /**
     * White border prices in different currencies (in cents)
     * @type {object}
     * @memberof UpdatePhotoSizeDto
     */
    'whiteBorderPriceCurrencies'?: object;
    /**
     * Whether black and white conversion is available for this photo size
     * @type {boolean}
     * @memberof UpdatePhotoSizeDto
     */
    'blackAndWhiteAvailable'?: boolean;
    /**
     * Black and white price per photo in cents (default 5 cents)
     * @type {number}
     * @memberof UpdatePhotoSizeDto
     */
    'blackAndWhitePrice'?: number;
    /**
     * Black and white prices in different currencies (in cents)
     * @type {object}
     * @memberof UpdatePhotoSizeDto
     */
    'blackAndWhitePriceCurrencies'?: object;
    /**
     * Optional preview photo id shown on the photo-size selector in the order flow
     * @type {string}
     * @memberof UpdatePhotoSizeDto
     */
    'previewPhotoId'?: string;
    /**
     * When true, this size is hidden from the public photo-size list (promotional). Default false.
     * @type {boolean}
     * @memberof UpdatePhotoSizeDto
     */
    'hidden'?: boolean;
    /**
     * Optional id of another photo size to compare against for combo savings (struck-through normal price)
     * @type {string}
     * @memberof UpdatePhotoSizeDto
     */
    'compareAtPhotoSizeId'?: string;
}
/**
 * 
 * @export
 * @interface UpdatePostDto
 */
export interface UpdatePostDto {
    /**
     * 
     * @type {string}
     * @memberof UpdatePostDto
     */
    'category'?: UpdatePostDtoCategoryEnum;
    /**
     * 
     * @type {object}
     * @memberof UpdatePostDto
     */
    'title'?: object;
    /**
     * 
     * @type {object}
     * @memberof UpdatePostDto
     */
    'excerpt'?: object;
    /**
     * 
     * @type {object}
     * @memberof UpdatePostDto
     */
    'body'?: object;
    /**
     * 
     * @type {object}
     * @memberof UpdatePostDto
     */
    'imageUrl'?: object;
    /**
     * 
     * @type {object}
     * @memberof UpdatePostDto
     */
    'ctaUrl'?: object;
    /**
     * 
     * @type {object}
     * @memberof UpdatePostDto
     */
    'ctaLabel'?: object;
    /**
     * 
     * @type {Array<string>}
     * @memberof UpdatePostDto
     */
    'audience'?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof UpdatePostDto
     */
    'publishedAt'?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdatePostDto
     */
    'expiresAt'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof UpdatePostDto
     */
    'active'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UpdatePostDto
     */
    'pinned'?: boolean;
}

export const UpdatePostDtoCategoryEnum = {
    News: 'news',
    Promo: 'promo',
    Tip: 'tip',
    Update: 'update'
} as const;

export type UpdatePostDtoCategoryEnum = typeof UpdatePostDtoCategoryEnum[keyof typeof UpdatePostDtoCategoryEnum];

/**
 * 
 * @export
 * @interface UpdateProductDto
 */
export interface UpdateProductDto {
    /**
     * Localized names of the product
     * @type {object}
     * @memberof UpdateProductDto
     */
    'name'?: object;
    /**
     * Localized descriptions of the product
     * @type {object}
     * @memberof UpdateProductDto
     */
    'description'?: object;
    /**
     * Price of the product
     * @type {number}
     * @memberof UpdateProductDto
     */
    'price'?: number;
    /**
     * Price in different currencies
     * @type {object}
     * @memberof UpdateProductDto
     */
    'priceCurrencies'?: object | null;
    /**
     * IDs of photos associated with the product
     * @type {Array<string>}
     * @memberof UpdateProductDto
     */
    'photoIds'?: Array<string>;
    /**
     * Is the product active
     * @type {boolean}
     * @memberof UpdateProductDto
     */
    'active'?: boolean;
    /**
     * Is the product featured
     * @type {boolean}
     * @memberof UpdateProductDto
     */
    'featured'?: boolean;
    /**
     * Price per unit
     * @type {number}
     * @memberof UpdateProductDto
     */
    'pricePerUnit'?: number;
    /**
     * Number of units
     * @type {number}
     * @memberof UpdateProductDto
     */
    'nOfUnits'?: number;
    /**
     * Action price
     * @type {number}
     * @memberof UpdateProductDto
     */
    'actionPrice'?: number | null;
    /**
     * Action price in different currencies
     * @type {object}
     * @memberof UpdateProductDto
     */
    'actionPriceCurrencies'?: object | null;
    /**
     * Pantheon product code
     * @type {string}
     * @memberof UpdateProductDto
     */
    'pantheonCode'?: string;
    /**
     * IDs of tags associated with the product
     * @type {Array<string>}
     * @memberof UpdateProductDto
     */
    'tagIds'?: Array<string>;
    /**
     * Display order, lower first
     * @type {number}
     * @memberof UpdateProductDto
     */
    'rank'?: number;
    /**
     * How many photos it holds
     * @type {number}
     * @memberof UpdateProductDto
     */
    'capacity'?: number | null;
    /**
     * Print size, e.g. 10x15
     * @type {string}
     * @memberof UpdateProductDto
     */
    'photoSize'?: string | null;
}
/**
 * 
 * @export
 * @interface UpdateProductTagDto
 */
export interface UpdateProductTagDto {
    /**
     * Localized names of the product tag
     * @type {object}
     * @memberof UpdateProductTagDto
     */
    'name'?: object;
    /**
     * Localized descriptions of the product tag
     * @type {object}
     * @memberof UpdateProductTagDto
     */
    'description'?: object;
    /**
     * 
     * @type {string}
     * @memberof UpdateProductTagDto
     */
    'tag'?: string;
    /**
     * 
     * @type {number}
     * @memberof UpdateProductTagDto
     */
    'rank'?: number;
}
/**
 * 
 * @export
 * @interface UpdateProductWithMediaDefinitionDto
 */
export interface UpdateProductWithMediaDefinitionDto {
    /**
     * Localized name { locale: string }
     * @type {object}
     * @memberof UpdateProductWithMediaDefinitionDto
     */
    'name'?: object;
    /**
     * Localized description { locale: string }
     * @type {object}
     * @memberof UpdateProductWithMediaDefinitionDto
     */
    'description'?: object;
    /**
     * Base price (integer, cents)
     * @type {number}
     * @memberof UpdateProductWithMediaDefinitionDto
     */
    'price'?: number;
    /**
     * 
     * @type {object}
     * @memberof UpdateProductWithMediaDefinitionDto
     */
    'priceCurrencies'?: object;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateProductWithMediaDefinitionDto
     */
    'active'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateProductWithMediaDefinitionDto
     */
    'featured'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof UpdateProductWithMediaDefinitionDto
     */
    'minQuantity'?: number;
    /**
     * Product family id, e.g. \"greeting-card\"
     * @type {string}
     * @memberof UpdateProductWithMediaDefinitionDto
     */
    'kind'?: string;
    /**
     * Declared media slots
     * @type {Array<MediaSlotDto>}
     * @memberof UpdateProductWithMediaDefinitionDto
     */
    'mediaSlots'?: Array<MediaSlotDto>;
    /**
     * 
     * @type {string}
     * @memberof UpdateProductWithMediaDefinitionDto
     */
    'previewImageKey'?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof UpdateProductWithMediaDefinitionDto
     */
    'paperIds'?: Array<string>;
    /**
     * 
     * @type {Array<VariantAxisDto>}
     * @memberof UpdateProductWithMediaDefinitionDto
     */
    'variantAxes'?: Array<VariantAxisDto>;
    /**
     * 
     * @type {string}
     * @memberof UpdateProductWithMediaDefinitionDto
     */
    'outputFormat'?: UpdateProductWithMediaDefinitionDtoOutputFormatEnum;
}

export const UpdateProductWithMediaDefinitionDtoOutputFormatEnum = {
    Pdf: 'pdf',
    Tiff: 'tiff',
    Jpeg: 'jpeg'
} as const;

export type UpdateProductWithMediaDefinitionDtoOutputFormatEnum = typeof UpdateProductWithMediaDefinitionDtoOutputFormatEnum[keyof typeof UpdateProductWithMediaDefinitionDtoOutputFormatEnum];

/**
 * 
 * @export
 * @interface UpdateProductWithMediaVariantDto
 */
export interface UpdateProductWithMediaVariantDto {
    /**
     * Owning definition id
     * @type {string}
     * @memberof UpdateProductWithMediaVariantDto
     */
    'definitionId'?: string;
    /**
     * Operator handle, e.g. CANVAS-40x60-PLATNO-20
     * @type {string}
     * @memberof UpdateProductWithMediaVariantDto
     */
    'sku'?: string;
    /**
     * Localized name { locale: string }
     * @type {object}
     * @memberof UpdateProductWithMediaVariantDto
     */
    'name'?: object;
    /**
     * One value per declared axis, e.g. { size: \"40x60\" }
     * @type {object}
     * @memberof UpdateProductWithMediaVariantDto
     */
    'axisValues'?: object;
    /**
     * { widthMm, heightMm, bleedMm, safeMm?, dpi }
     * @type {object}
     * @memberof UpdateProductWithMediaVariantDto
     */
    'printSpec'?: object;
    /**
     * ABSOLUTE unit price, integer cents
     * @type {number}
     * @memberof UpdateProductWithMediaVariantDto
     */
    'price'?: number;
    /**
     * 
     * @type {object}
     * @memberof UpdateProductWithMediaVariantDto
     */
    'priceCurrencies'?: object;
    /**
     * Per-unit shipping surcharge, integer cents
     * @type {number}
     * @memberof UpdateProductWithMediaVariantDto
     */
    'shippingCostCents'?: number;
    /**
     * 
     * @type {object}
     * @memberof UpdateProductWithMediaVariantDto
     */
    'shippingCostCurrencies'?: object;
    /**
     * Cost price, integer cents
     * @type {number}
     * @memberof UpdateProductWithMediaVariantDto
     */
    'factoryPriceCents'?: number;
    /**
     * Too large for a parcel locker
     * @type {boolean}
     * @memberof UpdateProductWithMediaVariantDto
     */
    'oversize'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateProductWithMediaVariantDto
     */
    'active'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof UpdateProductWithMediaVariantDto
     */
    'sortOrder'?: number;
}
/**
 * 
 * @export
 * @interface UpdateTemplateDto
 */
export interface UpdateTemplateDto {
    /**
     * 
     * @type {string}
     * @memberof UpdateTemplateDto
     */
    'code'?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateTemplateDto
     */
    'kind'?: UpdateTemplateDtoKindEnum;
    /**
     * 
     * @type {Array<string>}
     * @memberof UpdateTemplateDto
     */
    'categories'?: Array<UpdateTemplateDtoCategoriesEnum>;
    /**
     * Localized name { locale: string }
     * @type {object}
     * @memberof UpdateTemplateDto
     */
    'name'?: object;
    /**
     * 
     * @type {Array<object>}
     * @memberof UpdateTemplateDto
     */
    'slots'?: Array<object>;
    /**
     * 
     * @type {Array<string>}
     * @memberof UpdateTemplateDto
     */
    'paperIds'?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof UpdateTemplateDto
     */
    'showcasePaperId'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateTemplateDto
     */
    'thumbnailKey'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateTemplateDto
     */
    'active'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof UpdateTemplateDto
     */
    'sortOrder'?: number;
}

export const UpdateTemplateDtoKindEnum = {
    GreetingCard: 'greeting-card',
    Invitation: 'invitation',
    Menu: 'menu'
} as const;

export type UpdateTemplateDtoKindEnum = typeof UpdateTemplateDtoKindEnum[keyof typeof UpdateTemplateDtoKindEnum];
export const UpdateTemplateDtoCategoriesEnum = {
    Birthday: 'birthday',
    Congrats: 'congrats',
    Thankyou: 'thankyou',
    Love: 'love',
    Wedding: 'wedding',
    Baby: 'baby',
    Getwell: 'getwell',
    Holiday: 'holiday',
    Sympathy: 'sympathy',
    Faith: 'faith',
    Family: 'family',
    Elegant: 'elegant',
    Modern: 'modern',
    Fun: 'fun',
    Cafe: 'cafe'
} as const;

export type UpdateTemplateDtoCategoriesEnum = typeof UpdateTemplateDtoCategoriesEnum[keyof typeof UpdateTemplateDtoCategoriesEnum];

/**
 * 
 * @export
 * @interface UpdateUserDto
 */
export interface UpdateUserDto {
    /**
     * Email address of the user
     * @type {string}
     * @memberof UpdateUserDto
     */
    'email'?: string;
    /**
     * Verification status of the user
     * @type {boolean}
     * @memberof UpdateUserDto
     */
    'verified'?: boolean;
    /**
     * Password of the user
     * @type {string}
     * @memberof UpdateUserDto
     */
    'password'?: string;
    /**
     * Role of the user
     * @type {string}
     * @memberof UpdateUserDto
     */
    'role'?: string;
}
/**
 * 
 * @export
 * @interface UploadJournalControllerIngestRequest
 */
export interface UploadJournalControllerIngestRequest {
    /**
     * 
     * @type {string}
     * @memberof UploadJournalControllerIngestRequest
     */
    'device'?: string;
    /**
     * 
     * @type {Array<UploadJournalControllerIngestRequestEntriesInner>}
     * @memberof UploadJournalControllerIngestRequest
     */
    'entries'?: Array<UploadJournalControllerIngestRequestEntriesInner>;
}
/**
 * 
 * @export
 * @interface UploadJournalControllerIngestRequestEntriesInner
 */
export interface UploadJournalControllerIngestRequestEntriesInner {
    /**
     * 
     * @type {number}
     * @memberof UploadJournalControllerIngestRequestEntriesInner
     */
    'ts'?: number;
    /**
     * 
     * @type {string}
     * @memberof UploadJournalControllerIngestRequestEntriesInner
     */
    'batchId'?: string;
    /**
     * 
     * @type {string}
     * @memberof UploadJournalControllerIngestRequestEntriesInner
     */
    'event'?: string;
    /**
     * 
     * @type {string}
     * @memberof UploadJournalControllerIngestRequestEntriesInner
     */
    'key'?: string;
    /**
     * 
     * @type {number}
     * @memberof UploadJournalControllerIngestRequestEntriesInner
     */
    'rank'?: number;
    /**
     * 
     * @type {string}
     * @memberof UploadJournalControllerIngestRequestEntriesInner
     */
    'detail'?: string;
}
/**
 * 
 * @export
 * @interface UploadPhotoResponseDto
 */
export interface UploadPhotoResponseDto {
    /**
     * Unique id of the uploaded photo (uuid)
     * @type {string}
     * @memberof UploadPhotoResponseDto
     */
    'id': string;
    /**
     * Public URL of the uploaded photo
     * @type {string}
     * @memberof UploadPhotoResponseDto
     */
    'url': string;
    /**
     * Original file name
     * @type {string}
     * @memberof UploadPhotoResponseDto
     */
    'name': string;
    /**
     * MIME type of the uploaded photo
     * @type {string}
     * @memberof UploadPhotoResponseDto
     */
    'type': string;
    /**
     * Object-storage key
     * @type {string}
     * @memberof UploadPhotoResponseDto
     */
    'key': string;
}
/**
 * 
 * @export
 * @interface VariantAxisDto
 */
export interface VariantAxisDto {
    /**
     * Axis key, e.g. \"size\" | \"material\" | \"depth\"
     * @type {string}
     * @memberof VariantAxisDto
     */
    'key': string;
    /**
     * Localized label { locale: string }
     * @type {object}
     * @memberof VariantAxisDto
     */
    'label': object;
    /**
     * 
     * @type {Array<VariantAxisValueDto>}
     * @memberof VariantAxisDto
     */
    'values': Array<VariantAxisValueDto>;
}
/**
 * 
 * @export
 * @interface VariantAxisValueDto
 */
export interface VariantAxisValueDto {
    /**
     * Stable key, e.g. \"40x60\"
     * @type {string}
     * @memberof VariantAxisValueDto
     */
    'value': string;
    /**
     * Localized label { locale: string }
     * @type {object}
     * @memberof VariantAxisValueDto
     */
    'label': object;
    /**
     * 
     * @type {number}
     * @memberof VariantAxisValueDto
     */
    'sortOrder'?: number;
}
/**
 * 
 * @export
 * @interface VoidCashbackAwardDto
 */
export interface VoidCashbackAwardDto {
    /**
     * Why: goes into the order timeline and the credit lot note.
     * @type {string}
     * @memberof VoidCashbackAwardDto
     */
    'reason': string;
}

/**
 * AdminTranslateApi - axios parameter creator
 * @export
 */
export const AdminTranslateApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Admin: translate Slovenian form text into other shop languages. Returns translations only; nothing is saved.
         * @param {AdminTranslateRequestDto} adminTranslateRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminTranslateControllerTranslate: async (adminTranslateRequestDto: AdminTranslateRequestDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'adminTranslateRequestDto' is not null or undefined
            assertParamExists('adminTranslateControllerTranslate', 'adminTranslateRequestDto', adminTranslateRequestDto)
            const localVarPath = `/admin/translate`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(adminTranslateRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AdminTranslateApi - functional programming interface
 * @export
 */
export const AdminTranslateApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AdminTranslateApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Admin: translate Slovenian form text into other shop languages. Returns translations only; nothing is saved.
         * @param {AdminTranslateRequestDto} adminTranslateRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async adminTranslateControllerTranslate(adminTranslateRequestDto: AdminTranslateRequestDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AdminTranslateResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.adminTranslateControllerTranslate(adminTranslateRequestDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * AdminTranslateApi - factory interface
 * @export
 */
export const AdminTranslateApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AdminTranslateApiFp(configuration)
    return {
        /**
         * 
         * @summary Admin: translate Slovenian form text into other shop languages. Returns translations only; nothing is saved.
         * @param {AdminTranslateRequestDto} adminTranslateRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminTranslateControllerTranslate(adminTranslateRequestDto: AdminTranslateRequestDto, options?: any): AxiosPromise<AdminTranslateResponseDto> {
            return localVarFp.adminTranslateControllerTranslate(adminTranslateRequestDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * AdminTranslateApi - object-oriented interface
 * @export
 * @class AdminTranslateApi
 * @extends {BaseAPI}
 */
export class AdminTranslateApi extends BaseAPI {
    /**
     * 
     * @summary Admin: translate Slovenian form text into other shop languages. Returns translations only; nothing is saved.
     * @param {AdminTranslateRequestDto} adminTranslateRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminTranslateApi
     */
    public adminTranslateControllerTranslate(adminTranslateRequestDto: AdminTranslateRequestDto, options?: AxiosRequestConfig) {
        return AdminTranslateApiFp(this.configuration).adminTranslateControllerTranslate(adminTranslateRequestDto, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * AiToolsApi - axios parameter creator
 * @export
 */
export const AiToolsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {CreateCouponDto} createCouponDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        aiToolsControllerCreateCoupon: async (createCouponDto: CreateCouponDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createCouponDto' is not null or undefined
            assertParamExists('aiToolsControllerCreateCoupon', 'createCouponDto', createCouponDto)
            const localVarPath = `/tools/coupons`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createCouponDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} email 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        aiToolsControllerFindOrdersByEmail: async (email: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'email' is not null or undefined
            assertParamExists('aiToolsControllerFindOrdersByEmail', 'email', email)
            const localVarPath = `/tools/orders`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (email !== undefined) {
                localVarQueryParameter['email'] = email;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} firstName 
         * @param {string} lastName 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        aiToolsControllerFindOrdersByName: async (firstName: string, lastName: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'firstName' is not null or undefined
            assertParamExists('aiToolsControllerFindOrdersByName', 'firstName', firstName)
            // verify required parameter 'lastName' is not null or undefined
            assertParamExists('aiToolsControllerFindOrdersByName', 'lastName', lastName)
            const localVarPath = `/tools/orders/by-name`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (firstName !== undefined) {
                localVarQueryParameter['firstName'] = firstName;
            }

            if (lastName !== undefined) {
                localVarQueryParameter['lastName'] = lastName;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} parcelNumber 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        aiToolsControllerGetGlsTracking: async (parcelNumber: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'parcelNumber' is not null or undefined
            assertParamExists('aiToolsControllerGetGlsTracking', 'parcelNumber', parcelNumber)
            const localVarPath = `/tools/shipment/{parcelNumber}`
                .replace(`{${"parcelNumber"}}`, encodeURIComponent(String(parcelNumber)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        aiToolsControllerGetOrderById: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('aiToolsControllerGetOrderById', 'id', id)
            const localVarPath = `/tools/order/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} order 
         * @param {string} email 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        aiToolsControllerGetOrderStatus: async (order: string, email: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'order' is not null or undefined
            assertParamExists('aiToolsControllerGetOrderStatus', 'order', order)
            // verify required parameter 'email' is not null or undefined
            assertParamExists('aiToolsControllerGetOrderStatus', 'email', email)
            const localVarPath = `/tools/order-status`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (order !== undefined) {
                localVarQueryParameter['order'] = order;
            }

            if (email !== undefined) {
                localVarQueryParameter['email'] = email;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {string} locale 
         * @param {string} currency 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        aiToolsControllerGetProductPricing: async (id: string, locale: string, currency: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('aiToolsControllerGetProductPricing', 'id', id)
            // verify required parameter 'locale' is not null or undefined
            assertParamExists('aiToolsControllerGetProductPricing', 'locale', locale)
            // verify required parameter 'currency' is not null or undefined
            assertParamExists('aiToolsControllerGetProductPricing', 'currency', currency)
            const localVarPath = `/tools/pricing/products/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (locale !== undefined) {
                localVarQueryParameter['locale'] = locale;
            }

            if (currency !== undefined) {
                localVarQueryParameter['currency'] = currency;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} locale 
         * @param {string} currency 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        aiToolsControllerListCanvasPricing: async (locale: string, currency: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'locale' is not null or undefined
            assertParamExists('aiToolsControllerListCanvasPricing', 'locale', locale)
            // verify required parameter 'currency' is not null or undefined
            assertParamExists('aiToolsControllerListCanvasPricing', 'currency', currency)
            const localVarPath = `/tools/pricing/canvas`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (locale !== undefined) {
                localVarQueryParameter['locale'] = locale;
            }

            if (currency !== undefined) {
                localVarQueryParameter['currency'] = currency;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} locale 
         * @param {string} currency 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        aiToolsControllerListPhotoSizesWithPricing: async (locale: string, currency: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'locale' is not null or undefined
            assertParamExists('aiToolsControllerListPhotoSizesWithPricing', 'locale', locale)
            // verify required parameter 'currency' is not null or undefined
            assertParamExists('aiToolsControllerListPhotoSizesWithPricing', 'currency', currency)
            const localVarPath = `/tools/pricing/photo-sizes`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (locale !== undefined) {
                localVarQueryParameter['locale'] = locale;
            }

            if (currency !== undefined) {
                localVarQueryParameter['currency'] = currency;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} locale 
         * @param {string} currency 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        aiToolsControllerListProducts: async (locale: string, currency: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'locale' is not null or undefined
            assertParamExists('aiToolsControllerListProducts', 'locale', locale)
            // verify required parameter 'currency' is not null or undefined
            assertParamExists('aiToolsControllerListProducts', 'currency', currency)
            const localVarPath = `/tools/pricing/products`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (locale !== undefined) {
                localVarQueryParameter['locale'] = locale;
            }

            if (currency !== undefined) {
                localVarQueryParameter['currency'] = currency;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AiToolsApi - functional programming interface
 * @export
 */
export const AiToolsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AiToolsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {CreateCouponDto} createCouponDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async aiToolsControllerCreateCoupon(createCouponDto: CreateCouponDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.aiToolsControllerCreateCoupon(createCouponDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} email 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async aiToolsControllerFindOrdersByEmail(email: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.aiToolsControllerFindOrdersByEmail(email, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} firstName 
         * @param {string} lastName 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async aiToolsControllerFindOrdersByName(firstName: string, lastName: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.aiToolsControllerFindOrdersByName(firstName, lastName, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} parcelNumber 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async aiToolsControllerGetGlsTracking(parcelNumber: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.aiToolsControllerGetGlsTracking(parcelNumber, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async aiToolsControllerGetOrderById(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.aiToolsControllerGetOrderById(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} order 
         * @param {string} email 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async aiToolsControllerGetOrderStatus(order: string, email: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.aiToolsControllerGetOrderStatus(order, email, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} id 
         * @param {string} locale 
         * @param {string} currency 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async aiToolsControllerGetProductPricing(id: string, locale: string, currency: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.aiToolsControllerGetProductPricing(id, locale, currency, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} locale 
         * @param {string} currency 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async aiToolsControllerListCanvasPricing(locale: string, currency: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.aiToolsControllerListCanvasPricing(locale, currency, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} locale 
         * @param {string} currency 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async aiToolsControllerListPhotoSizesWithPricing(locale: string, currency: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.aiToolsControllerListPhotoSizesWithPricing(locale, currency, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} locale 
         * @param {string} currency 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async aiToolsControllerListProducts(locale: string, currency: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.aiToolsControllerListProducts(locale, currency, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * AiToolsApi - factory interface
 * @export
 */
export const AiToolsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AiToolsApiFp(configuration)
    return {
        /**
         * 
         * @param {CreateCouponDto} createCouponDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        aiToolsControllerCreateCoupon(createCouponDto: CreateCouponDto, options?: any): AxiosPromise<void> {
            return localVarFp.aiToolsControllerCreateCoupon(createCouponDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} email 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        aiToolsControllerFindOrdersByEmail(email: string, options?: any): AxiosPromise<void> {
            return localVarFp.aiToolsControllerFindOrdersByEmail(email, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} firstName 
         * @param {string} lastName 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        aiToolsControllerFindOrdersByName(firstName: string, lastName: string, options?: any): AxiosPromise<void> {
            return localVarFp.aiToolsControllerFindOrdersByName(firstName, lastName, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} parcelNumber 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        aiToolsControllerGetGlsTracking(parcelNumber: string, options?: any): AxiosPromise<void> {
            return localVarFp.aiToolsControllerGetGlsTracking(parcelNumber, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        aiToolsControllerGetOrderById(id: string, options?: any): AxiosPromise<void> {
            return localVarFp.aiToolsControllerGetOrderById(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} order 
         * @param {string} email 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        aiToolsControllerGetOrderStatus(order: string, email: string, options?: any): AxiosPromise<void> {
            return localVarFp.aiToolsControllerGetOrderStatus(order, email, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {string} locale 
         * @param {string} currency 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        aiToolsControllerGetProductPricing(id: string, locale: string, currency: string, options?: any): AxiosPromise<void> {
            return localVarFp.aiToolsControllerGetProductPricing(id, locale, currency, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} locale 
         * @param {string} currency 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        aiToolsControllerListCanvasPricing(locale: string, currency: string, options?: any): AxiosPromise<void> {
            return localVarFp.aiToolsControllerListCanvasPricing(locale, currency, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} locale 
         * @param {string} currency 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        aiToolsControllerListPhotoSizesWithPricing(locale: string, currency: string, options?: any): AxiosPromise<void> {
            return localVarFp.aiToolsControllerListPhotoSizesWithPricing(locale, currency, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} locale 
         * @param {string} currency 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        aiToolsControllerListProducts(locale: string, currency: string, options?: any): AxiosPromise<void> {
            return localVarFp.aiToolsControllerListProducts(locale, currency, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * AiToolsApi - object-oriented interface
 * @export
 * @class AiToolsApi
 * @extends {BaseAPI}
 */
export class AiToolsApi extends BaseAPI {
    /**
     * 
     * @param {CreateCouponDto} createCouponDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AiToolsApi
     */
    public aiToolsControllerCreateCoupon(createCouponDto: CreateCouponDto, options?: AxiosRequestConfig) {
        return AiToolsApiFp(this.configuration).aiToolsControllerCreateCoupon(createCouponDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} email 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AiToolsApi
     */
    public aiToolsControllerFindOrdersByEmail(email: string, options?: AxiosRequestConfig) {
        return AiToolsApiFp(this.configuration).aiToolsControllerFindOrdersByEmail(email, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} firstName 
     * @param {string} lastName 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AiToolsApi
     */
    public aiToolsControllerFindOrdersByName(firstName: string, lastName: string, options?: AxiosRequestConfig) {
        return AiToolsApiFp(this.configuration).aiToolsControllerFindOrdersByName(firstName, lastName, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} parcelNumber 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AiToolsApi
     */
    public aiToolsControllerGetGlsTracking(parcelNumber: string, options?: AxiosRequestConfig) {
        return AiToolsApiFp(this.configuration).aiToolsControllerGetGlsTracking(parcelNumber, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AiToolsApi
     */
    public aiToolsControllerGetOrderById(id: string, options?: AxiosRequestConfig) {
        return AiToolsApiFp(this.configuration).aiToolsControllerGetOrderById(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} order 
     * @param {string} email 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AiToolsApi
     */
    public aiToolsControllerGetOrderStatus(order: string, email: string, options?: AxiosRequestConfig) {
        return AiToolsApiFp(this.configuration).aiToolsControllerGetOrderStatus(order, email, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {string} locale 
     * @param {string} currency 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AiToolsApi
     */
    public aiToolsControllerGetProductPricing(id: string, locale: string, currency: string, options?: AxiosRequestConfig) {
        return AiToolsApiFp(this.configuration).aiToolsControllerGetProductPricing(id, locale, currency, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} locale 
     * @param {string} currency 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AiToolsApi
     */
    public aiToolsControllerListCanvasPricing(locale: string, currency: string, options?: AxiosRequestConfig) {
        return AiToolsApiFp(this.configuration).aiToolsControllerListCanvasPricing(locale, currency, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} locale 
     * @param {string} currency 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AiToolsApi
     */
    public aiToolsControllerListPhotoSizesWithPricing(locale: string, currency: string, options?: AxiosRequestConfig) {
        return AiToolsApiFp(this.configuration).aiToolsControllerListPhotoSizesWithPricing(locale, currency, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} locale 
     * @param {string} currency 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AiToolsApi
     */
    public aiToolsControllerListProducts(locale: string, currency: string, options?: AxiosRequestConfig) {
        return AiToolsApiFp(this.configuration).aiToolsControllerListProducts(locale, currency, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * AnalyticsApi - axios parameter creator
 * @export
 */
export const AnalyticsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Get advanced business insights
         * @param {string} [startDate] Start date (YYYY-MM-DD)
         * @param {string} [endDate] End date (YYYY-MM-DD)
         * @param {string} [country] Filter by shipping country
         * @param {string} [domain] Filter by the shop the order started on. Unlike country this is set at cart creation, so it covers abandoned carts too.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        analyticsControllerAnalyticsControllerGetInsights: async (startDate?: string, endDate?: string, country?: string, domain?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/analytics/insights`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (startDate !== undefined) {
                localVarQueryParameter['startDate'] = startDate;
            }

            if (endDate !== undefined) {
                localVarQueryParameter['endDate'] = endDate;
            }

            if (country !== undefined) {
                localVarQueryParameter['country'] = country;
            }

            if (domain !== undefined) {
                localVarQueryParameter['domain'] = domain;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get comprehensive analytics data
         * @param {string} [startDate] Start date (YYYY-MM-DD)
         * @param {string} [endDate] End date (YYYY-MM-DD)
         * @param {string} [country] Filter by shipping country
         * @param {string} [domain] Filter by the shop the order started on. Unlike country this is set at cart creation, so it covers abandoned carts too.
         * @param {string} [status] Filter by order status
         * @param {any} [language] Language for localized data
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        analyticsControllerGetAnalytics: async (startDate?: string, endDate?: string, country?: string, domain?: string, status?: string, language?: any, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/analytics`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (startDate !== undefined) {
                localVarQueryParameter['startDate'] = startDate;
            }

            if (endDate !== undefined) {
                localVarQueryParameter['endDate'] = endDate;
            }

            if (country !== undefined) {
                localVarQueryParameter['country'] = country;
            }

            if (domain !== undefined) {
                localVarQueryParameter['domain'] = domain;
            }

            if (status !== undefined) {
                localVarQueryParameter['status'] = status;
            }

            if (language !== undefined) {
                localVarQueryParameter['language'] = language;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get chart data for frontend visualization
         * @param {string} [startDate] Start date (YYYY-MM-DD)
         * @param {string} [endDate] End date (YYYY-MM-DD)
         * @param {string} [country] Filter by shipping country
         * @param {string} [domain] Filter by the shop the order started on. Unlike country this is set at cart creation, so it covers abandoned carts too.
         * @param {any} [language] Language for localized data
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        analyticsControllerGetChartData: async (startDate?: string, endDate?: string, country?: string, domain?: string, language?: any, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/analytics/charts`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (startDate !== undefined) {
                localVarQueryParameter['startDate'] = startDate;
            }

            if (endDate !== undefined) {
                localVarQueryParameter['endDate'] = endDate;
            }

            if (country !== undefined) {
                localVarQueryParameter['country'] = country;
            }

            if (domain !== undefined) {
                localVarQueryParameter['domain'] = domain;
            }

            if (language !== undefined) {
                localVarQueryParameter['language'] = language;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get daily amounts data
         * @param {string} [startDate] Start date (YYYY-MM-DD)
         * @param {string} [endDate] End date (YYYY-MM-DD)
         * @param {string} [country] Filter by shipping country
         * @param {string} [domain] Filter by the shop the order started on. Unlike country this is set at cart creation, so it covers abandoned carts too.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        analyticsControllerGetDailyAmounts: async (startDate?: string, endDate?: string, country?: string, domain?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/analytics/daily-amounts`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (startDate !== undefined) {
                localVarQueryParameter['startDate'] = startDate;
            }

            if (endDate !== undefined) {
                localVarQueryParameter['endDate'] = endDate;
            }

            if (country !== undefined) {
                localVarQueryParameter['country'] = country;
            }

            if (domain !== undefined) {
                localVarQueryParameter['domain'] = domain;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Conversion split by device, per shop (admin)
         * @param {string} [startDate] 
         * @param {string} [endDate] 
         * @param {string} [domain] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        analyticsControllerGetDeviceConversion: async (startDate?: string, endDate?: string, domain?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/analytics/device-conversion`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (startDate !== undefined) {
                localVarQueryParameter['startDate'] = startDate;
            }

            if (endDate !== undefined) {
                localVarQueryParameter['endDate'] = endDate;
            }

            if (domain !== undefined) {
                localVarQueryParameter['domain'] = domain;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Shops that have orders, for the analytics filter
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        analyticsControllerGetDomains: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/analytics/domains`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Per-email-rule conversion + last-touch attributed revenue (whole DB)
         * @param {string} [windowDays] Attribution window in days (clamped 1-90, default 7)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        analyticsControllerGetEmailEffectiveness: async (windowDays?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/analytics/email-effectiveness`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (windowDays !== undefined) {
                localVarQueryParameter['windowDays'] = windowDays;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Where each shop loses people, upload to payment (admin)
         * @param {string} [startDate] 
         * @param {string} [endDate] 
         * @param {string} [domain] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        analyticsControllerGetFunnelByShop: async (startDate?: string, endDate?: string, domain?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/analytics/funnel-by-shop`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (startDate !== undefined) {
                localVarQueryParameter['startDate'] = startDate;
            }

            if (endDate !== undefined) {
                localVarQueryParameter['endDate'] = endDate;
            }

            if (domain !== undefined) {
                localVarQueryParameter['domain'] = domain;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get key metrics only
         * @param {string} [startDate] Start date (YYYY-MM-DD)
         * @param {string} [endDate] End date (YYYY-MM-DD)
         * @param {string} [country] Filter by shipping country
         * @param {string} [domain] Filter by the shop the order started on. Unlike country this is set at cart creation, so it covers abandoned carts too.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        analyticsControllerGetMetrics: async (startDate?: string, endDate?: string, country?: string, domain?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/analytics/metrics`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (startDate !== undefined) {
                localVarQueryParameter['startDate'] = startDate;
            }

            if (endDate !== undefined) {
                localVarQueryParameter['endDate'] = endDate;
            }

            if (country !== undefined) {
                localVarQueryParameter['country'] = country;
            }

            if (domain !== undefined) {
                localVarQueryParameter['domain'] = domain;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get order status distribution
         * @param {string} [startDate] Start date (YYYY-MM-DD)
         * @param {string} [endDate] End date (YYYY-MM-DD)
         * @param {string} [country] Filter by shipping country
         * @param {string} [domain] Filter by the shop the order started on. Unlike country this is set at cart creation, so it covers abandoned carts too.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        analyticsControllerGetOrderStatusDistribution: async (startDate?: string, endDate?: string, country?: string, domain?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/analytics/status-distribution`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (startDate !== undefined) {
                localVarQueryParameter['startDate'] = startDate;
            }

            if (endDate !== undefined) {
                localVarQueryParameter['endDate'] = endDate;
            }

            if (country !== undefined) {
                localVarQueryParameter['country'] = country;
            }

            if (domain !== undefined) {
                localVarQueryParameter['domain'] = domain;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Per-currency prices checked against the euro price (admin)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        analyticsControllerGetPriceParity: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/analytics/price-parity`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Daily revenue, less production cost, less advertising. Revenue is already net of VAT and shipping (see analytics.service orderNet) — VAT was never ours and shipping is charged on and paid out. Production is photo_size.factoryPrice per print plus the per-format calendar cost. STILL NOT full profit: packaging, payment fees, labour and every fixed cost remain. Named for what it is so nobody reads it as money in the bank. A spend source that cannot be read is listed in `unavailable` and contributes nothing — never zero, which would read as margin.
         * @summary Revenue against advertising spend, per day
         * @param {string} [startDate] YYYY-MM-DD
         * @param {string} [endDate] YYYY-MM-DD
         * @param {string} [country] 
         * @param {string} [domain] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        analyticsControllerGetProfit: async (startDate?: string, endDate?: string, country?: string, domain?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/analytics/profit`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (startDate !== undefined) {
                localVarQueryParameter['startDate'] = startDate;
            }

            if (endDate !== undefined) {
                localVarQueryParameter['endDate'] = endDate;
            }

            if (country !== undefined) {
                localVarQueryParameter['country'] = country;
            }

            if (domain !== undefined) {
                localVarQueryParameter['domain'] = domain;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Returning-customer stats, segments and best-customer leaderboard (whole DB)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        analyticsControllerGetReturningCustomers: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/analytics/returning-customers`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AnalyticsApi - functional programming interface
 * @export
 */
export const AnalyticsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AnalyticsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Get advanced business insights
         * @param {string} [startDate] Start date (YYYY-MM-DD)
         * @param {string} [endDate] End date (YYYY-MM-DD)
         * @param {string} [country] Filter by shipping country
         * @param {string} [domain] Filter by the shop the order started on. Unlike country this is set at cart creation, so it covers abandoned carts too.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async analyticsControllerAnalyticsControllerGetInsights(startDate?: string, endDate?: string, country?: string, domain?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InsightsResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.analyticsControllerAnalyticsControllerGetInsights(startDate, endDate, country, domain, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get comprehensive analytics data
         * @param {string} [startDate] Start date (YYYY-MM-DD)
         * @param {string} [endDate] End date (YYYY-MM-DD)
         * @param {string} [country] Filter by shipping country
         * @param {string} [domain] Filter by the shop the order started on. Unlike country this is set at cart creation, so it covers abandoned carts too.
         * @param {string} [status] Filter by order status
         * @param {any} [language] Language for localized data
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async analyticsControllerGetAnalytics(startDate?: string, endDate?: string, country?: string, domain?: string, status?: string, language?: any, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AnalyticsResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.analyticsControllerGetAnalytics(startDate, endDate, country, domain, status, language, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get chart data for frontend visualization
         * @param {string} [startDate] Start date (YYYY-MM-DD)
         * @param {string} [endDate] End date (YYYY-MM-DD)
         * @param {string} [country] Filter by shipping country
         * @param {string} [domain] Filter by the shop the order started on. Unlike country this is set at cart creation, so it covers abandoned carts too.
         * @param {any} [language] Language for localized data
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async analyticsControllerGetChartData(startDate?: string, endDate?: string, country?: string, domain?: string, language?: any, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ChartDataResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.analyticsControllerGetChartData(startDate, endDate, country, domain, language, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get daily amounts data
         * @param {string} [startDate] Start date (YYYY-MM-DD)
         * @param {string} [endDate] End date (YYYY-MM-DD)
         * @param {string} [country] Filter by shipping country
         * @param {string} [domain] Filter by the shop the order started on. Unlike country this is set at cart creation, so it covers abandoned carts too.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async analyticsControllerGetDailyAmounts(startDate?: string, endDate?: string, country?: string, domain?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DailyAmountsResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.analyticsControllerGetDailyAmounts(startDate, endDate, country, domain, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Conversion split by device, per shop (admin)
         * @param {string} [startDate] 
         * @param {string} [endDate] 
         * @param {string} [domain] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async analyticsControllerGetDeviceConversion(startDate?: string, endDate?: string, domain?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.analyticsControllerGetDeviceConversion(startDate, endDate, domain, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Shops that have orders, for the analytics filter
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async analyticsControllerGetDomains(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.analyticsControllerGetDomains(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Per-email-rule conversion + last-touch attributed revenue (whole DB)
         * @param {string} [windowDays] Attribution window in days (clamped 1-90, default 7)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async analyticsControllerGetEmailEffectiveness(windowDays?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EmailEffectivenessResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.analyticsControllerGetEmailEffectiveness(windowDays, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Where each shop loses people, upload to payment (admin)
         * @param {string} [startDate] 
         * @param {string} [endDate] 
         * @param {string} [domain] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async analyticsControllerGetFunnelByShop(startDate?: string, endDate?: string, domain?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.analyticsControllerGetFunnelByShop(startDate, endDate, domain, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get key metrics only
         * @param {string} [startDate] Start date (YYYY-MM-DD)
         * @param {string} [endDate] End date (YYYY-MM-DD)
         * @param {string} [country] Filter by shipping country
         * @param {string} [domain] Filter by the shop the order started on. Unlike country this is set at cart creation, so it covers abandoned carts too.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async analyticsControllerGetMetrics(startDate?: string, endDate?: string, country?: string, domain?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MetricsDataDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.analyticsControllerGetMetrics(startDate, endDate, country, domain, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get order status distribution
         * @param {string} [startDate] Start date (YYYY-MM-DD)
         * @param {string} [endDate] End date (YYYY-MM-DD)
         * @param {string} [country] Filter by shipping country
         * @param {string} [domain] Filter by the shop the order started on. Unlike country this is set at cart creation, so it covers abandoned carts too.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async analyticsControllerGetOrderStatusDistribution(startDate?: string, endDate?: string, country?: string, domain?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<{ [key: string]: number; }>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.analyticsControllerGetOrderStatusDistribution(startDate, endDate, country, domain, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Per-currency prices checked against the euro price (admin)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async analyticsControllerGetPriceParity(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.analyticsControllerGetPriceParity(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Daily revenue, less production cost, less advertising. Revenue is already net of VAT and shipping (see analytics.service orderNet) — VAT was never ours and shipping is charged on and paid out. Production is photo_size.factoryPrice per print plus the per-format calendar cost. STILL NOT full profit: packaging, payment fees, labour and every fixed cost remain. Named for what it is so nobody reads it as money in the bank. A spend source that cannot be read is listed in `unavailable` and contributes nothing — never zero, which would read as margin.
         * @summary Revenue against advertising spend, per day
         * @param {string} [startDate] YYYY-MM-DD
         * @param {string} [endDate] YYYY-MM-DD
         * @param {string} [country] 
         * @param {string} [domain] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async analyticsControllerGetProfit(startDate?: string, endDate?: string, country?: string, domain?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.analyticsControllerGetProfit(startDate, endDate, country, domain, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Returning-customer stats, segments and best-customer leaderboard (whole DB)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async analyticsControllerGetReturningCustomers(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ReturningCustomersResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.analyticsControllerGetReturningCustomers(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * AnalyticsApi - factory interface
 * @export
 */
export const AnalyticsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AnalyticsApiFp(configuration)
    return {
        /**
         * 
         * @summary Get advanced business insights
         * @param {string} [startDate] Start date (YYYY-MM-DD)
         * @param {string} [endDate] End date (YYYY-MM-DD)
         * @param {string} [country] Filter by shipping country
         * @param {string} [domain] Filter by the shop the order started on. Unlike country this is set at cart creation, so it covers abandoned carts too.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        analyticsControllerAnalyticsControllerGetInsights(startDate?: string, endDate?: string, country?: string, domain?: string, options?: any): AxiosPromise<InsightsResponseDto> {
            return localVarFp.analyticsControllerAnalyticsControllerGetInsights(startDate, endDate, country, domain, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get comprehensive analytics data
         * @param {string} [startDate] Start date (YYYY-MM-DD)
         * @param {string} [endDate] End date (YYYY-MM-DD)
         * @param {string} [country] Filter by shipping country
         * @param {string} [domain] Filter by the shop the order started on. Unlike country this is set at cart creation, so it covers abandoned carts too.
         * @param {string} [status] Filter by order status
         * @param {any} [language] Language for localized data
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        analyticsControllerGetAnalytics(startDate?: string, endDate?: string, country?: string, domain?: string, status?: string, language?: any, options?: any): AxiosPromise<AnalyticsResponseDto> {
            return localVarFp.analyticsControllerGetAnalytics(startDate, endDate, country, domain, status, language, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get chart data for frontend visualization
         * @param {string} [startDate] Start date (YYYY-MM-DD)
         * @param {string} [endDate] End date (YYYY-MM-DD)
         * @param {string} [country] Filter by shipping country
         * @param {string} [domain] Filter by the shop the order started on. Unlike country this is set at cart creation, so it covers abandoned carts too.
         * @param {any} [language] Language for localized data
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        analyticsControllerGetChartData(startDate?: string, endDate?: string, country?: string, domain?: string, language?: any, options?: any): AxiosPromise<ChartDataResponseDto> {
            return localVarFp.analyticsControllerGetChartData(startDate, endDate, country, domain, language, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get daily amounts data
         * @param {string} [startDate] Start date (YYYY-MM-DD)
         * @param {string} [endDate] End date (YYYY-MM-DD)
         * @param {string} [country] Filter by shipping country
         * @param {string} [domain] Filter by the shop the order started on. Unlike country this is set at cart creation, so it covers abandoned carts too.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        analyticsControllerGetDailyAmounts(startDate?: string, endDate?: string, country?: string, domain?: string, options?: any): AxiosPromise<DailyAmountsResponseDto> {
            return localVarFp.analyticsControllerGetDailyAmounts(startDate, endDate, country, domain, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Conversion split by device, per shop (admin)
         * @param {string} [startDate] 
         * @param {string} [endDate] 
         * @param {string} [domain] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        analyticsControllerGetDeviceConversion(startDate?: string, endDate?: string, domain?: string, options?: any): AxiosPromise<void> {
            return localVarFp.analyticsControllerGetDeviceConversion(startDate, endDate, domain, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Shops that have orders, for the analytics filter
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        analyticsControllerGetDomains(options?: any): AxiosPromise<void> {
            return localVarFp.analyticsControllerGetDomains(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Per-email-rule conversion + last-touch attributed revenue (whole DB)
         * @param {string} [windowDays] Attribution window in days (clamped 1-90, default 7)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        analyticsControllerGetEmailEffectiveness(windowDays?: string, options?: any): AxiosPromise<EmailEffectivenessResponseDto> {
            return localVarFp.analyticsControllerGetEmailEffectiveness(windowDays, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Where each shop loses people, upload to payment (admin)
         * @param {string} [startDate] 
         * @param {string} [endDate] 
         * @param {string} [domain] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        analyticsControllerGetFunnelByShop(startDate?: string, endDate?: string, domain?: string, options?: any): AxiosPromise<void> {
            return localVarFp.analyticsControllerGetFunnelByShop(startDate, endDate, domain, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get key metrics only
         * @param {string} [startDate] Start date (YYYY-MM-DD)
         * @param {string} [endDate] End date (YYYY-MM-DD)
         * @param {string} [country] Filter by shipping country
         * @param {string} [domain] Filter by the shop the order started on. Unlike country this is set at cart creation, so it covers abandoned carts too.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        analyticsControllerGetMetrics(startDate?: string, endDate?: string, country?: string, domain?: string, options?: any): AxiosPromise<MetricsDataDto> {
            return localVarFp.analyticsControllerGetMetrics(startDate, endDate, country, domain, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get order status distribution
         * @param {string} [startDate] Start date (YYYY-MM-DD)
         * @param {string} [endDate] End date (YYYY-MM-DD)
         * @param {string} [country] Filter by shipping country
         * @param {string} [domain] Filter by the shop the order started on. Unlike country this is set at cart creation, so it covers abandoned carts too.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        analyticsControllerGetOrderStatusDistribution(startDate?: string, endDate?: string, country?: string, domain?: string, options?: any): AxiosPromise<{ [key: string]: number; }> {
            return localVarFp.analyticsControllerGetOrderStatusDistribution(startDate, endDate, country, domain, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Per-currency prices checked against the euro price (admin)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        analyticsControllerGetPriceParity(options?: any): AxiosPromise<void> {
            return localVarFp.analyticsControllerGetPriceParity(options).then((request) => request(axios, basePath));
        },
        /**
         * Daily revenue, less production cost, less advertising. Revenue is already net of VAT and shipping (see analytics.service orderNet) — VAT was never ours and shipping is charged on and paid out. Production is photo_size.factoryPrice per print plus the per-format calendar cost. STILL NOT full profit: packaging, payment fees, labour and every fixed cost remain. Named for what it is so nobody reads it as money in the bank. A spend source that cannot be read is listed in `unavailable` and contributes nothing — never zero, which would read as margin.
         * @summary Revenue against advertising spend, per day
         * @param {string} [startDate] YYYY-MM-DD
         * @param {string} [endDate] YYYY-MM-DD
         * @param {string} [country] 
         * @param {string} [domain] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        analyticsControllerGetProfit(startDate?: string, endDate?: string, country?: string, domain?: string, options?: any): AxiosPromise<void> {
            return localVarFp.analyticsControllerGetProfit(startDate, endDate, country, domain, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Returning-customer stats, segments and best-customer leaderboard (whole DB)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        analyticsControllerGetReturningCustomers(options?: any): AxiosPromise<ReturningCustomersResponseDto> {
            return localVarFp.analyticsControllerGetReturningCustomers(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * AnalyticsApi - object-oriented interface
 * @export
 * @class AnalyticsApi
 * @extends {BaseAPI}
 */
export class AnalyticsApi extends BaseAPI {
    /**
     * 
     * @summary Get advanced business insights
     * @param {string} [startDate] Start date (YYYY-MM-DD)
     * @param {string} [endDate] End date (YYYY-MM-DD)
     * @param {string} [country] Filter by shipping country
     * @param {string} [domain] Filter by the shop the order started on. Unlike country this is set at cart creation, so it covers abandoned carts too.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AnalyticsApi
     */
    public analyticsControllerAnalyticsControllerGetInsights(startDate?: string, endDate?: string, country?: string, domain?: string, options?: AxiosRequestConfig) {
        return AnalyticsApiFp(this.configuration).analyticsControllerAnalyticsControllerGetInsights(startDate, endDate, country, domain, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get comprehensive analytics data
     * @param {string} [startDate] Start date (YYYY-MM-DD)
     * @param {string} [endDate] End date (YYYY-MM-DD)
     * @param {string} [country] Filter by shipping country
     * @param {string} [domain] Filter by the shop the order started on. Unlike country this is set at cart creation, so it covers abandoned carts too.
     * @param {string} [status] Filter by order status
     * @param {any} [language] Language for localized data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AnalyticsApi
     */
    public analyticsControllerGetAnalytics(startDate?: string, endDate?: string, country?: string, domain?: string, status?: string, language?: any, options?: AxiosRequestConfig) {
        return AnalyticsApiFp(this.configuration).analyticsControllerGetAnalytics(startDate, endDate, country, domain, status, language, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get chart data for frontend visualization
     * @param {string} [startDate] Start date (YYYY-MM-DD)
     * @param {string} [endDate] End date (YYYY-MM-DD)
     * @param {string} [country] Filter by shipping country
     * @param {string} [domain] Filter by the shop the order started on. Unlike country this is set at cart creation, so it covers abandoned carts too.
     * @param {any} [language] Language for localized data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AnalyticsApi
     */
    public analyticsControllerGetChartData(startDate?: string, endDate?: string, country?: string, domain?: string, language?: any, options?: AxiosRequestConfig) {
        return AnalyticsApiFp(this.configuration).analyticsControllerGetChartData(startDate, endDate, country, domain, language, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get daily amounts data
     * @param {string} [startDate] Start date (YYYY-MM-DD)
     * @param {string} [endDate] End date (YYYY-MM-DD)
     * @param {string} [country] Filter by shipping country
     * @param {string} [domain] Filter by the shop the order started on. Unlike country this is set at cart creation, so it covers abandoned carts too.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AnalyticsApi
     */
    public analyticsControllerGetDailyAmounts(startDate?: string, endDate?: string, country?: string, domain?: string, options?: AxiosRequestConfig) {
        return AnalyticsApiFp(this.configuration).analyticsControllerGetDailyAmounts(startDate, endDate, country, domain, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Conversion split by device, per shop (admin)
     * @param {string} [startDate] 
     * @param {string} [endDate] 
     * @param {string} [domain] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AnalyticsApi
     */
    public analyticsControllerGetDeviceConversion(startDate?: string, endDate?: string, domain?: string, options?: AxiosRequestConfig) {
        return AnalyticsApiFp(this.configuration).analyticsControllerGetDeviceConversion(startDate, endDate, domain, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Shops that have orders, for the analytics filter
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AnalyticsApi
     */
    public analyticsControllerGetDomains(options?: AxiosRequestConfig) {
        return AnalyticsApiFp(this.configuration).analyticsControllerGetDomains(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Per-email-rule conversion + last-touch attributed revenue (whole DB)
     * @param {string} [windowDays] Attribution window in days (clamped 1-90, default 7)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AnalyticsApi
     */
    public analyticsControllerGetEmailEffectiveness(windowDays?: string, options?: AxiosRequestConfig) {
        return AnalyticsApiFp(this.configuration).analyticsControllerGetEmailEffectiveness(windowDays, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Where each shop loses people, upload to payment (admin)
     * @param {string} [startDate] 
     * @param {string} [endDate] 
     * @param {string} [domain] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AnalyticsApi
     */
    public analyticsControllerGetFunnelByShop(startDate?: string, endDate?: string, domain?: string, options?: AxiosRequestConfig) {
        return AnalyticsApiFp(this.configuration).analyticsControllerGetFunnelByShop(startDate, endDate, domain, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get key metrics only
     * @param {string} [startDate] Start date (YYYY-MM-DD)
     * @param {string} [endDate] End date (YYYY-MM-DD)
     * @param {string} [country] Filter by shipping country
     * @param {string} [domain] Filter by the shop the order started on. Unlike country this is set at cart creation, so it covers abandoned carts too.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AnalyticsApi
     */
    public analyticsControllerGetMetrics(startDate?: string, endDate?: string, country?: string, domain?: string, options?: AxiosRequestConfig) {
        return AnalyticsApiFp(this.configuration).analyticsControllerGetMetrics(startDate, endDate, country, domain, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get order status distribution
     * @param {string} [startDate] Start date (YYYY-MM-DD)
     * @param {string} [endDate] End date (YYYY-MM-DD)
     * @param {string} [country] Filter by shipping country
     * @param {string} [domain] Filter by the shop the order started on. Unlike country this is set at cart creation, so it covers abandoned carts too.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AnalyticsApi
     */
    public analyticsControllerGetOrderStatusDistribution(startDate?: string, endDate?: string, country?: string, domain?: string, options?: AxiosRequestConfig) {
        return AnalyticsApiFp(this.configuration).analyticsControllerGetOrderStatusDistribution(startDate, endDate, country, domain, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Per-currency prices checked against the euro price (admin)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AnalyticsApi
     */
    public analyticsControllerGetPriceParity(options?: AxiosRequestConfig) {
        return AnalyticsApiFp(this.configuration).analyticsControllerGetPriceParity(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Daily revenue, less production cost, less advertising. Revenue is already net of VAT and shipping (see analytics.service orderNet) — VAT was never ours and shipping is charged on and paid out. Production is photo_size.factoryPrice per print plus the per-format calendar cost. STILL NOT full profit: packaging, payment fees, labour and every fixed cost remain. Named for what it is so nobody reads it as money in the bank. A spend source that cannot be read is listed in `unavailable` and contributes nothing — never zero, which would read as margin.
     * @summary Revenue against advertising spend, per day
     * @param {string} [startDate] YYYY-MM-DD
     * @param {string} [endDate] YYYY-MM-DD
     * @param {string} [country] 
     * @param {string} [domain] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AnalyticsApi
     */
    public analyticsControllerGetProfit(startDate?: string, endDate?: string, country?: string, domain?: string, options?: AxiosRequestConfig) {
        return AnalyticsApiFp(this.configuration).analyticsControllerGetProfit(startDate, endDate, country, domain, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Returning-customer stats, segments and best-customer leaderboard (whole DB)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AnalyticsApi
     */
    public analyticsControllerGetReturningCustomers(options?: AxiosRequestConfig) {
        return AnalyticsApiFp(this.configuration).analyticsControllerGetReturningCustomers(options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * AppApi - axios parameter creator
 * @export
 */
export const AppApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        appControllerGetHello: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AppApi - functional programming interface
 * @export
 */
export const AppApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AppApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async appControllerGetHello(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.appControllerGetHello(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * AppApi - factory interface
 * @export
 */
export const AppApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AppApiFp(configuration)
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        appControllerGetHello(options?: any): AxiosPromise<void> {
            return localVarFp.appControllerGetHello(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * AppApi - object-oriented interface
 * @export
 * @class AppApi
 * @extends {BaseAPI}
 */
export class AppApi extends BaseAPI {
    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AppApi
     */
    public appControllerGetHello(options?: AxiosRequestConfig) {
        return AppApiFp(this.configuration).appControllerGetHello(options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * AppEventApi - axios parameter creator
 * @export
 */
export const AppEventApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Anonymous app event: a fixed name and allow-listed integer fields. 400 APP_EVENT_INVALID otherwise.
         * @param {CreateAppEventDto} createAppEventDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        appEventControllerCreate: async (createAppEventDto: CreateAppEventDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createAppEventDto' is not null or undefined
            assertParamExists('appEventControllerCreate', 'createAppEventDto', createAppEventDto)
            const localVarPath = `/app-event`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createAppEventDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Newsletter popup: times shown and sign-ups per copy variant, overall and per market, over the last N days (admin)
         * @param {string} [days] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        appEventControllerNewsletterPopupStats: async (days?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/app-event/newsletter-popup-stats`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (days !== undefined) {
                localVarQueryParameter['days'] = days;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Trip suggestions: weekly event counts and average photos per app order, with and without a suggestion (admin)
         * @param {string} [weeks] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        appEventControllerTripStats: async (weeks?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/app-event/trip-stats`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (weeks !== undefined) {
                localVarQueryParameter['weeks'] = weeks;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AppEventApi - functional programming interface
 * @export
 */
export const AppEventApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AppEventApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Anonymous app event: a fixed name and allow-listed integer fields. 400 APP_EVENT_INVALID otherwise.
         * @param {CreateAppEventDto} createAppEventDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async appEventControllerCreate(createAppEventDto: CreateAppEventDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.appEventControllerCreate(createAppEventDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Newsletter popup: times shown and sign-ups per copy variant, overall and per market, over the last N days (admin)
         * @param {string} [days] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async appEventControllerNewsletterPopupStats(days?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.appEventControllerNewsletterPopupStats(days, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Trip suggestions: weekly event counts and average photos per app order, with and without a suggestion (admin)
         * @param {string} [weeks] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async appEventControllerTripStats(weeks?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.appEventControllerTripStats(weeks, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * AppEventApi - factory interface
 * @export
 */
export const AppEventApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AppEventApiFp(configuration)
    return {
        /**
         * 
         * @summary Anonymous app event: a fixed name and allow-listed integer fields. 400 APP_EVENT_INVALID otherwise.
         * @param {CreateAppEventDto} createAppEventDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        appEventControllerCreate(createAppEventDto: CreateAppEventDto, options?: any): AxiosPromise<void> {
            return localVarFp.appEventControllerCreate(createAppEventDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Newsletter popup: times shown and sign-ups per copy variant, overall and per market, over the last N days (admin)
         * @param {string} [days] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        appEventControllerNewsletterPopupStats(days?: string, options?: any): AxiosPromise<void> {
            return localVarFp.appEventControllerNewsletterPopupStats(days, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Trip suggestions: weekly event counts and average photos per app order, with and without a suggestion (admin)
         * @param {string} [weeks] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        appEventControllerTripStats(weeks?: string, options?: any): AxiosPromise<void> {
            return localVarFp.appEventControllerTripStats(weeks, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * AppEventApi - object-oriented interface
 * @export
 * @class AppEventApi
 * @extends {BaseAPI}
 */
export class AppEventApi extends BaseAPI {
    /**
     * 
     * @summary Anonymous app event: a fixed name and allow-listed integer fields. 400 APP_EVENT_INVALID otherwise.
     * @param {CreateAppEventDto} createAppEventDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AppEventApi
     */
    public appEventControllerCreate(createAppEventDto: CreateAppEventDto, options?: AxiosRequestConfig) {
        return AppEventApiFp(this.configuration).appEventControllerCreate(createAppEventDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Newsletter popup: times shown and sign-ups per copy variant, overall and per market, over the last N days (admin)
     * @param {string} [days] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AppEventApi
     */
    public appEventControllerNewsletterPopupStats(days?: string, options?: AxiosRequestConfig) {
        return AppEventApiFp(this.configuration).appEventControllerNewsletterPopupStats(days, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Trip suggestions: weekly event counts and average photos per app order, with and without a suggestion (admin)
     * @param {string} [weeks] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AppEventApi
     */
    public appEventControllerTripStats(weeks?: string, options?: AxiosRequestConfig) {
        return AppEventApiFp(this.configuration).appEventControllerTripStats(weeks, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * AppVersionApi - axios parameter creator
 * @export
 */
export const AppVersionApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Minimum app version and where it comes from (admin)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        appVersionControllerAdminView: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/app-version/admin`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Minimum and latest supported app version
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        appVersionControllerPolicy: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/app-version`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Set the minimum app version (admin)
         * @param {SetAppMinVersionDto} setAppMinVersionDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        appVersionControllerSetMinimum: async (setAppMinVersionDto: SetAppMinVersionDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'setAppMinVersionDto' is not null or undefined
            assertParamExists('appVersionControllerSetMinimum', 'setAppMinVersionDto', setAppMinVersionDto)
            const localVarPath = `/app-version/admin`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(setAppMinVersionDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AppVersionApi - functional programming interface
 * @export
 */
export const AppVersionApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AppVersionApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Minimum app version and where it comes from (admin)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async appVersionControllerAdminView(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.appVersionControllerAdminView(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Minimum and latest supported app version
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async appVersionControllerPolicy(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.appVersionControllerPolicy(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Set the minimum app version (admin)
         * @param {SetAppMinVersionDto} setAppMinVersionDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async appVersionControllerSetMinimum(setAppMinVersionDto: SetAppMinVersionDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.appVersionControllerSetMinimum(setAppMinVersionDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * AppVersionApi - factory interface
 * @export
 */
export const AppVersionApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AppVersionApiFp(configuration)
    return {
        /**
         * 
         * @summary Minimum app version and where it comes from (admin)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        appVersionControllerAdminView(options?: any): AxiosPromise<void> {
            return localVarFp.appVersionControllerAdminView(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Minimum and latest supported app version
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        appVersionControllerPolicy(options?: any): AxiosPromise<void> {
            return localVarFp.appVersionControllerPolicy(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Set the minimum app version (admin)
         * @param {SetAppMinVersionDto} setAppMinVersionDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        appVersionControllerSetMinimum(setAppMinVersionDto: SetAppMinVersionDto, options?: any): AxiosPromise<void> {
            return localVarFp.appVersionControllerSetMinimum(setAppMinVersionDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * AppVersionApi - object-oriented interface
 * @export
 * @class AppVersionApi
 * @extends {BaseAPI}
 */
export class AppVersionApi extends BaseAPI {
    /**
     * 
     * @summary Minimum app version and where it comes from (admin)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AppVersionApi
     */
    public appVersionControllerAdminView(options?: AxiosRequestConfig) {
        return AppVersionApiFp(this.configuration).appVersionControllerAdminView(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Minimum and latest supported app version
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AppVersionApi
     */
    public appVersionControllerPolicy(options?: AxiosRequestConfig) {
        return AppVersionApiFp(this.configuration).appVersionControllerPolicy(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Set the minimum app version (admin)
     * @param {SetAppMinVersionDto} setAppMinVersionDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AppVersionApi
     */
    public appVersionControllerSetMinimum(setAppMinVersionDto: SetAppMinVersionDto, options?: AxiosRequestConfig) {
        return AppVersionApiFp(this.configuration).appVersionControllerSetMinimum(setAppMinVersionDto, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * ArtworkApi - axios parameter creator
 * @export
 */
export const ArtworkApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} slug 
         * @param {string} size 
         * @param {string} ifNoneMatch 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        artworkImageControllerImage: async (slug: string, size: string, ifNoneMatch: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'slug' is not null or undefined
            assertParamExists('artworkImageControllerImage', 'slug', slug)
            // verify required parameter 'size' is not null or undefined
            assertParamExists('artworkImageControllerImage', 'size', size)
            // verify required parameter 'ifNoneMatch' is not null or undefined
            assertParamExists('artworkImageControllerImage', 'ifNoneMatch', ifNoneMatch)
            const localVarPath = `/artwork/{slug}/image`
                .replace(`{${"slug"}}`, encodeURIComponent(String(slug)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }

            if (ifNoneMatch != null) {
                localVarHeaderParameter['if-none-match'] = String(ifNoneMatch);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        artworkUploadControllerUpload: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/artwork/master`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Create multiple Artworks
         * @param {CreateManyArtworkDto} createManyArtworkDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createManyBaseArtworkControllerArtwork: async (createManyArtworkDto: CreateManyArtworkDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createManyArtworkDto' is not null or undefined
            assertParamExists('createManyBaseArtworkControllerArtwork', 'createManyArtworkDto', createManyArtworkDto)
            const localVarPath = `/artwork/bulk`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createManyArtworkDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Create a single Artwork
         * @param {CreateArtworkDto} createArtworkDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createOneBaseArtworkControllerArtwork: async (createArtworkDto: CreateArtworkDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createArtworkDto' is not null or undefined
            assertParamExists('createOneBaseArtworkControllerArtwork', 'createArtworkDto', createArtworkDto)
            const localVarPath = `/artwork`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createArtworkDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Delete a single Artwork
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOneBaseArtworkControllerArtwork: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('deleteOneBaseArtworkControllerArtwork', 'id', id)
            const localVarPath = `/artwork/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Retrieve multiple Artworks
         * @param {Array<string>} [fields] Selects resource fields. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#select\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {string} [s] Adds search condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#search\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {Array<string>} [filter] Adds filter condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#filter\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {Array<string>} [or] Adds OR condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#or\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {Array<string>} [sort] Adds sort by field. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#sort\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {Array<string>} [join] Adds relational resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#join\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {number} [limit] Limit amount of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#limit\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {number} [offset] Offset amount of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#offset\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {number} [page] Page portion of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#page\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {number} [cache] Reset cache (if was enabled). &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#cache\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getManyBaseArtworkControllerArtwork: async (fields?: Array<string>, s?: string, filter?: Array<string>, or?: Array<string>, sort?: Array<string>, join?: Array<string>, limit?: number, offset?: number, page?: number, cache?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/artwork`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (fields) {
                localVarQueryParameter['fields'] = fields;
            }

            if (s !== undefined) {
                localVarQueryParameter['s'] = s;
            }

            if (filter) {
                localVarQueryParameter['filter'] = filter;
            }

            if (or) {
                localVarQueryParameter['or'] = or;
            }

            if (sort) {
                localVarQueryParameter['sort'] = sort;
            }

            if (join) {
                localVarQueryParameter['join'] = join;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (cache !== undefined) {
                localVarQueryParameter['cache'] = cache;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Retrieve a single Artwork
         * @param {string} id 
         * @param {Array<string>} [fields] Selects resource fields. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#select\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {Array<string>} [join] Adds relational resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#join\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {number} [cache] Reset cache (if was enabled). &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#cache\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOneBaseArtworkControllerArtwork: async (id: string, fields?: Array<string>, join?: Array<string>, cache?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getOneBaseArtworkControllerArtwork', 'id', id)
            const localVarPath = `/artwork/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (fields) {
                localVarQueryParameter['fields'] = fields;
            }

            if (join) {
                localVarQueryParameter['join'] = join;
            }

            if (cache !== undefined) {
                localVarQueryParameter['cache'] = cache;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Replace a single Artwork
         * @param {string} id 
         * @param {UpdateArtworkDto} updateArtworkDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        replaceOneBaseArtworkControllerArtwork: async (id: string, updateArtworkDto: UpdateArtworkDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('replaceOneBaseArtworkControllerArtwork', 'id', id)
            // verify required parameter 'updateArtworkDto' is not null or undefined
            assertParamExists('replaceOneBaseArtworkControllerArtwork', 'updateArtworkDto', updateArtworkDto)
            const localVarPath = `/artwork/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateArtworkDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update a single Artwork
         * @param {string} id 
         * @param {UpdateArtworkDto} updateArtworkDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateOneBaseArtworkControllerArtwork: async (id: string, updateArtworkDto: UpdateArtworkDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('updateOneBaseArtworkControllerArtwork', 'id', id)
            // verify required parameter 'updateArtworkDto' is not null or undefined
            assertParamExists('updateOneBaseArtworkControllerArtwork', 'updateArtworkDto', updateArtworkDto)
            const localVarPath = `/artwork/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateArtworkDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ArtworkApi - functional programming interface
 * @export
 */
export const ArtworkApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ArtworkApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} slug 
         * @param {string} size 
         * @param {string} ifNoneMatch 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async artworkImageControllerImage(slug: string, size: string, ifNoneMatch: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.artworkImageControllerImage(slug, size, ifNoneMatch, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async artworkUploadControllerUpload(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.artworkUploadControllerUpload(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Create multiple Artworks
         * @param {CreateManyArtworkDto} createManyArtworkDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createManyBaseArtworkControllerArtwork(createManyArtworkDto: CreateManyArtworkDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<object>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createManyBaseArtworkControllerArtwork(createManyArtworkDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Create a single Artwork
         * @param {CreateArtworkDto} createArtworkDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createOneBaseArtworkControllerArtwork(createArtworkDto: CreateArtworkDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createOneBaseArtworkControllerArtwork(createArtworkDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Delete a single Artwork
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteOneBaseArtworkControllerArtwork(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteOneBaseArtworkControllerArtwork(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Retrieve multiple Artworks
         * @param {Array<string>} [fields] Selects resource fields. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#select\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {string} [s] Adds search condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#search\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {Array<string>} [filter] Adds filter condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#filter\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {Array<string>} [or] Adds OR condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#or\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {Array<string>} [sort] Adds sort by field. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#sort\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {Array<string>} [join] Adds relational resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#join\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {number} [limit] Limit amount of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#limit\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {number} [offset] Offset amount of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#offset\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {number} [page] Page portion of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#page\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {number} [cache] Reset cache (if was enabled). &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#cache\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getManyBaseArtworkControllerArtwork(fields?: Array<string>, s?: string, filter?: Array<string>, or?: Array<string>, sort?: Array<string>, join?: Array<string>, limit?: number, offset?: number, page?: number, cache?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetManyArtworkResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getManyBaseArtworkControllerArtwork(fields, s, filter, or, sort, join, limit, offset, page, cache, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Retrieve a single Artwork
         * @param {string} id 
         * @param {Array<string>} [fields] Selects resource fields. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#select\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {Array<string>} [join] Adds relational resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#join\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {number} [cache] Reset cache (if was enabled). &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#cache\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getOneBaseArtworkControllerArtwork(id: string, fields?: Array<string>, join?: Array<string>, cache?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getOneBaseArtworkControllerArtwork(id, fields, join, cache, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Replace a single Artwork
         * @param {string} id 
         * @param {UpdateArtworkDto} updateArtworkDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async replaceOneBaseArtworkControllerArtwork(id: string, updateArtworkDto: UpdateArtworkDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.replaceOneBaseArtworkControllerArtwork(id, updateArtworkDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Update a single Artwork
         * @param {string} id 
         * @param {UpdateArtworkDto} updateArtworkDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateOneBaseArtworkControllerArtwork(id: string, updateArtworkDto: UpdateArtworkDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateOneBaseArtworkControllerArtwork(id, updateArtworkDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * ArtworkApi - factory interface
 * @export
 */
export const ArtworkApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ArtworkApiFp(configuration)
    return {
        /**
         * 
         * @param {string} slug 
         * @param {string} size 
         * @param {string} ifNoneMatch 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        artworkImageControllerImage(slug: string, size: string, ifNoneMatch: string, options?: any): AxiosPromise<void> {
            return localVarFp.artworkImageControllerImage(slug, size, ifNoneMatch, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        artworkUploadControllerUpload(options?: any): AxiosPromise<void> {
            return localVarFp.artworkUploadControllerUpload(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Create multiple Artworks
         * @param {CreateManyArtworkDto} createManyArtworkDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createManyBaseArtworkControllerArtwork(createManyArtworkDto: CreateManyArtworkDto, options?: any): AxiosPromise<Array<object>> {
            return localVarFp.createManyBaseArtworkControllerArtwork(createManyArtworkDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Create a single Artwork
         * @param {CreateArtworkDto} createArtworkDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createOneBaseArtworkControllerArtwork(createArtworkDto: CreateArtworkDto, options?: any): AxiosPromise<object> {
            return localVarFp.createOneBaseArtworkControllerArtwork(createArtworkDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Delete a single Artwork
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOneBaseArtworkControllerArtwork(id: string, options?: any): AxiosPromise<object> {
            return localVarFp.deleteOneBaseArtworkControllerArtwork(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Retrieve multiple Artworks
         * @param {Array<string>} [fields] Selects resource fields. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#select\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {string} [s] Adds search condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#search\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {Array<string>} [filter] Adds filter condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#filter\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {Array<string>} [or] Adds OR condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#or\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {Array<string>} [sort] Adds sort by field. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#sort\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {Array<string>} [join] Adds relational resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#join\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {number} [limit] Limit amount of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#limit\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {number} [offset] Offset amount of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#offset\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {number} [page] Page portion of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#page\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {number} [cache] Reset cache (if was enabled). &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#cache\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getManyBaseArtworkControllerArtwork(fields?: Array<string>, s?: string, filter?: Array<string>, or?: Array<string>, sort?: Array<string>, join?: Array<string>, limit?: number, offset?: number, page?: number, cache?: number, options?: any): AxiosPromise<GetManyArtworkResponseDto> {
            return localVarFp.getManyBaseArtworkControllerArtwork(fields, s, filter, or, sort, join, limit, offset, page, cache, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Retrieve a single Artwork
         * @param {string} id 
         * @param {Array<string>} [fields] Selects resource fields. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#select\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {Array<string>} [join] Adds relational resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#join\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {number} [cache] Reset cache (if was enabled). &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#cache\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOneBaseArtworkControllerArtwork(id: string, fields?: Array<string>, join?: Array<string>, cache?: number, options?: any): AxiosPromise<object> {
            return localVarFp.getOneBaseArtworkControllerArtwork(id, fields, join, cache, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Replace a single Artwork
         * @param {string} id 
         * @param {UpdateArtworkDto} updateArtworkDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        replaceOneBaseArtworkControllerArtwork(id: string, updateArtworkDto: UpdateArtworkDto, options?: any): AxiosPromise<object> {
            return localVarFp.replaceOneBaseArtworkControllerArtwork(id, updateArtworkDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update a single Artwork
         * @param {string} id 
         * @param {UpdateArtworkDto} updateArtworkDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateOneBaseArtworkControllerArtwork(id: string, updateArtworkDto: UpdateArtworkDto, options?: any): AxiosPromise<object> {
            return localVarFp.updateOneBaseArtworkControllerArtwork(id, updateArtworkDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ArtworkApi - object-oriented interface
 * @export
 * @class ArtworkApi
 * @extends {BaseAPI}
 */
export class ArtworkApi extends BaseAPI {
    /**
     * 
     * @param {string} slug 
     * @param {string} size 
     * @param {string} ifNoneMatch 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ArtworkApi
     */
    public artworkImageControllerImage(slug: string, size: string, ifNoneMatch: string, options?: AxiosRequestConfig) {
        return ArtworkApiFp(this.configuration).artworkImageControllerImage(slug, size, ifNoneMatch, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ArtworkApi
     */
    public artworkUploadControllerUpload(options?: AxiosRequestConfig) {
        return ArtworkApiFp(this.configuration).artworkUploadControllerUpload(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Create multiple Artworks
     * @param {CreateManyArtworkDto} createManyArtworkDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ArtworkApi
     */
    public createManyBaseArtworkControllerArtwork(createManyArtworkDto: CreateManyArtworkDto, options?: AxiosRequestConfig) {
        return ArtworkApiFp(this.configuration).createManyBaseArtworkControllerArtwork(createManyArtworkDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Create a single Artwork
     * @param {CreateArtworkDto} createArtworkDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ArtworkApi
     */
    public createOneBaseArtworkControllerArtwork(createArtworkDto: CreateArtworkDto, options?: AxiosRequestConfig) {
        return ArtworkApiFp(this.configuration).createOneBaseArtworkControllerArtwork(createArtworkDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Delete a single Artwork
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ArtworkApi
     */
    public deleteOneBaseArtworkControllerArtwork(id: string, options?: AxiosRequestConfig) {
        return ArtworkApiFp(this.configuration).deleteOneBaseArtworkControllerArtwork(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Retrieve multiple Artworks
     * @param {Array<string>} [fields] Selects resource fields. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#select\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param {string} [s] Adds search condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#search\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param {Array<string>} [filter] Adds filter condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#filter\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param {Array<string>} [or] Adds OR condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#or\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param {Array<string>} [sort] Adds sort by field. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#sort\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param {Array<string>} [join] Adds relational resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#join\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param {number} [limit] Limit amount of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#limit\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param {number} [offset] Offset amount of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#offset\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param {number} [page] Page portion of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#page\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param {number} [cache] Reset cache (if was enabled). &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#cache\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ArtworkApi
     */
    public getManyBaseArtworkControllerArtwork(fields?: Array<string>, s?: string, filter?: Array<string>, or?: Array<string>, sort?: Array<string>, join?: Array<string>, limit?: number, offset?: number, page?: number, cache?: number, options?: AxiosRequestConfig) {
        return ArtworkApiFp(this.configuration).getManyBaseArtworkControllerArtwork(fields, s, filter, or, sort, join, limit, offset, page, cache, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Retrieve a single Artwork
     * @param {string} id 
     * @param {Array<string>} [fields] Selects resource fields. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#select\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param {Array<string>} [join] Adds relational resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#join\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param {number} [cache] Reset cache (if was enabled). &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#cache\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ArtworkApi
     */
    public getOneBaseArtworkControllerArtwork(id: string, fields?: Array<string>, join?: Array<string>, cache?: number, options?: AxiosRequestConfig) {
        return ArtworkApiFp(this.configuration).getOneBaseArtworkControllerArtwork(id, fields, join, cache, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Replace a single Artwork
     * @param {string} id 
     * @param {UpdateArtworkDto} updateArtworkDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ArtworkApi
     */
    public replaceOneBaseArtworkControllerArtwork(id: string, updateArtworkDto: UpdateArtworkDto, options?: AxiosRequestConfig) {
        return ArtworkApiFp(this.configuration).replaceOneBaseArtworkControllerArtwork(id, updateArtworkDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update a single Artwork
     * @param {string} id 
     * @param {UpdateArtworkDto} updateArtworkDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ArtworkApi
     */
    public updateOneBaseArtworkControllerArtwork(id: string, updateArtworkDto: UpdateArtworkDto, options?: AxiosRequestConfig) {
        return ArtworkApiFp(this.configuration).updateOneBaseArtworkControllerArtwork(id, updateArtworkDto, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * ArtworkCollectionApi - axios parameter creator
 * @export
 */
export const ArtworkCollectionApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Create multiple ArtworkCollections
         * @param {CreateManyArtworkCollectionDto} createManyArtworkCollectionDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createManyBaseArtworkCollectionControllerArtworkCollection: async (createManyArtworkCollectionDto: CreateManyArtworkCollectionDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createManyArtworkCollectionDto' is not null or undefined
            assertParamExists('createManyBaseArtworkCollectionControllerArtworkCollection', 'createManyArtworkCollectionDto', createManyArtworkCollectionDto)
            const localVarPath = `/artworkCollection/bulk`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createManyArtworkCollectionDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Create a single ArtworkCollection
         * @param {object} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createOneBaseArtworkCollectionControllerArtworkCollection: async (body: object, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'body' is not null or undefined
            assertParamExists('createOneBaseArtworkCollectionControllerArtworkCollection', 'body', body)
            const localVarPath = `/artworkCollection`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Delete a single ArtworkCollection
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOneBaseArtworkCollectionControllerArtworkCollection: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('deleteOneBaseArtworkCollectionControllerArtworkCollection', 'id', id)
            const localVarPath = `/artworkCollection/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Retrieve multiple ArtworkCollections
         * @param {Array<string>} [fields] Selects resource fields. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#select\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {string} [s] Adds search condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#search\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {Array<string>} [filter] Adds filter condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#filter\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {Array<string>} [or] Adds OR condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#or\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {Array<string>} [sort] Adds sort by field. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#sort\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {Array<string>} [join] Adds relational resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#join\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {number} [limit] Limit amount of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#limit\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {number} [offset] Offset amount of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#offset\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {number} [page] Page portion of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#page\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {number} [cache] Reset cache (if was enabled). &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#cache\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getManyBaseArtworkCollectionControllerArtworkCollection: async (fields?: Array<string>, s?: string, filter?: Array<string>, or?: Array<string>, sort?: Array<string>, join?: Array<string>, limit?: number, offset?: number, page?: number, cache?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/artworkCollection`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (fields) {
                localVarQueryParameter['fields'] = fields;
            }

            if (s !== undefined) {
                localVarQueryParameter['s'] = s;
            }

            if (filter) {
                localVarQueryParameter['filter'] = filter;
            }

            if (or) {
                localVarQueryParameter['or'] = or;
            }

            if (sort) {
                localVarQueryParameter['sort'] = sort;
            }

            if (join) {
                localVarQueryParameter['join'] = join;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (cache !== undefined) {
                localVarQueryParameter['cache'] = cache;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Retrieve a single ArtworkCollection
         * @param {string} id 
         * @param {Array<string>} [fields] Selects resource fields. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#select\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {Array<string>} [join] Adds relational resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#join\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {number} [cache] Reset cache (if was enabled). &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#cache\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOneBaseArtworkCollectionControllerArtworkCollection: async (id: string, fields?: Array<string>, join?: Array<string>, cache?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getOneBaseArtworkCollectionControllerArtworkCollection', 'id', id)
            const localVarPath = `/artworkCollection/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (fields) {
                localVarQueryParameter['fields'] = fields;
            }

            if (join) {
                localVarQueryParameter['join'] = join;
            }

            if (cache !== undefined) {
                localVarQueryParameter['cache'] = cache;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Replace a single ArtworkCollection
         * @param {string} id 
         * @param {object} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        replaceOneBaseArtworkCollectionControllerArtworkCollection: async (id: string, body: object, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('replaceOneBaseArtworkCollectionControllerArtworkCollection', 'id', id)
            // verify required parameter 'body' is not null or undefined
            assertParamExists('replaceOneBaseArtworkCollectionControllerArtworkCollection', 'body', body)
            const localVarPath = `/artworkCollection/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update a single ArtworkCollection
         * @param {string} id 
         * @param {object} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateOneBaseArtworkCollectionControllerArtworkCollection: async (id: string, body: object, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('updateOneBaseArtworkCollectionControllerArtworkCollection', 'id', id)
            // verify required parameter 'body' is not null or undefined
            assertParamExists('updateOneBaseArtworkCollectionControllerArtworkCollection', 'body', body)
            const localVarPath = `/artworkCollection/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ArtworkCollectionApi - functional programming interface
 * @export
 */
export const ArtworkCollectionApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ArtworkCollectionApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Create multiple ArtworkCollections
         * @param {CreateManyArtworkCollectionDto} createManyArtworkCollectionDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createManyBaseArtworkCollectionControllerArtworkCollection(createManyArtworkCollectionDto: CreateManyArtworkCollectionDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<object>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createManyBaseArtworkCollectionControllerArtworkCollection(createManyArtworkCollectionDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Create a single ArtworkCollection
         * @param {object} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createOneBaseArtworkCollectionControllerArtworkCollection(body: object, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createOneBaseArtworkCollectionControllerArtworkCollection(body, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Delete a single ArtworkCollection
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteOneBaseArtworkCollectionControllerArtworkCollection(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteOneBaseArtworkCollectionControllerArtworkCollection(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Retrieve multiple ArtworkCollections
         * @param {Array<string>} [fields] Selects resource fields. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#select\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {string} [s] Adds search condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#search\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {Array<string>} [filter] Adds filter condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#filter\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {Array<string>} [or] Adds OR condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#or\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {Array<string>} [sort] Adds sort by field. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#sort\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {Array<string>} [join] Adds relational resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#join\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {number} [limit] Limit amount of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#limit\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {number} [offset] Offset amount of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#offset\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {number} [page] Page portion of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#page\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {number} [cache] Reset cache (if was enabled). &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#cache\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getManyBaseArtworkCollectionControllerArtworkCollection(fields?: Array<string>, s?: string, filter?: Array<string>, or?: Array<string>, sort?: Array<string>, join?: Array<string>, limit?: number, offset?: number, page?: number, cache?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetManyArtworkCollectionResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getManyBaseArtworkCollectionControllerArtworkCollection(fields, s, filter, or, sort, join, limit, offset, page, cache, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Retrieve a single ArtworkCollection
         * @param {string} id 
         * @param {Array<string>} [fields] Selects resource fields. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#select\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {Array<string>} [join] Adds relational resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#join\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {number} [cache] Reset cache (if was enabled). &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#cache\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getOneBaseArtworkCollectionControllerArtworkCollection(id: string, fields?: Array<string>, join?: Array<string>, cache?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getOneBaseArtworkCollectionControllerArtworkCollection(id, fields, join, cache, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Replace a single ArtworkCollection
         * @param {string} id 
         * @param {object} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async replaceOneBaseArtworkCollectionControllerArtworkCollection(id: string, body: object, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.replaceOneBaseArtworkCollectionControllerArtworkCollection(id, body, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Update a single ArtworkCollection
         * @param {string} id 
         * @param {object} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateOneBaseArtworkCollectionControllerArtworkCollection(id: string, body: object, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateOneBaseArtworkCollectionControllerArtworkCollection(id, body, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * ArtworkCollectionApi - factory interface
 * @export
 */
export const ArtworkCollectionApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ArtworkCollectionApiFp(configuration)
    return {
        /**
         * 
         * @summary Create multiple ArtworkCollections
         * @param {CreateManyArtworkCollectionDto} createManyArtworkCollectionDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createManyBaseArtworkCollectionControllerArtworkCollection(createManyArtworkCollectionDto: CreateManyArtworkCollectionDto, options?: any): AxiosPromise<Array<object>> {
            return localVarFp.createManyBaseArtworkCollectionControllerArtworkCollection(createManyArtworkCollectionDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Create a single ArtworkCollection
         * @param {object} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createOneBaseArtworkCollectionControllerArtworkCollection(body: object, options?: any): AxiosPromise<object> {
            return localVarFp.createOneBaseArtworkCollectionControllerArtworkCollection(body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Delete a single ArtworkCollection
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOneBaseArtworkCollectionControllerArtworkCollection(id: string, options?: any): AxiosPromise<object> {
            return localVarFp.deleteOneBaseArtworkCollectionControllerArtworkCollection(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Retrieve multiple ArtworkCollections
         * @param {Array<string>} [fields] Selects resource fields. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#select\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {string} [s] Adds search condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#search\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {Array<string>} [filter] Adds filter condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#filter\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {Array<string>} [or] Adds OR condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#or\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {Array<string>} [sort] Adds sort by field. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#sort\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {Array<string>} [join] Adds relational resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#join\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {number} [limit] Limit amount of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#limit\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {number} [offset] Offset amount of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#offset\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {number} [page] Page portion of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#page\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {number} [cache] Reset cache (if was enabled). &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#cache\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getManyBaseArtworkCollectionControllerArtworkCollection(fields?: Array<string>, s?: string, filter?: Array<string>, or?: Array<string>, sort?: Array<string>, join?: Array<string>, limit?: number, offset?: number, page?: number, cache?: number, options?: any): AxiosPromise<GetManyArtworkCollectionResponseDto> {
            return localVarFp.getManyBaseArtworkCollectionControllerArtworkCollection(fields, s, filter, or, sort, join, limit, offset, page, cache, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Retrieve a single ArtworkCollection
         * @param {string} id 
         * @param {Array<string>} [fields] Selects resource fields. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#select\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {Array<string>} [join] Adds relational resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#join\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {number} [cache] Reset cache (if was enabled). &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#cache\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOneBaseArtworkCollectionControllerArtworkCollection(id: string, fields?: Array<string>, join?: Array<string>, cache?: number, options?: any): AxiosPromise<object> {
            return localVarFp.getOneBaseArtworkCollectionControllerArtworkCollection(id, fields, join, cache, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Replace a single ArtworkCollection
         * @param {string} id 
         * @param {object} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        replaceOneBaseArtworkCollectionControllerArtworkCollection(id: string, body: object, options?: any): AxiosPromise<object> {
            return localVarFp.replaceOneBaseArtworkCollectionControllerArtworkCollection(id, body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update a single ArtworkCollection
         * @param {string} id 
         * @param {object} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateOneBaseArtworkCollectionControllerArtworkCollection(id: string, body: object, options?: any): AxiosPromise<object> {
            return localVarFp.updateOneBaseArtworkCollectionControllerArtworkCollection(id, body, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ArtworkCollectionApi - object-oriented interface
 * @export
 * @class ArtworkCollectionApi
 * @extends {BaseAPI}
 */
export class ArtworkCollectionApi extends BaseAPI {
    /**
     * 
     * @summary Create multiple ArtworkCollections
     * @param {CreateManyArtworkCollectionDto} createManyArtworkCollectionDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ArtworkCollectionApi
     */
    public createManyBaseArtworkCollectionControllerArtworkCollection(createManyArtworkCollectionDto: CreateManyArtworkCollectionDto, options?: AxiosRequestConfig) {
        return ArtworkCollectionApiFp(this.configuration).createManyBaseArtworkCollectionControllerArtworkCollection(createManyArtworkCollectionDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Create a single ArtworkCollection
     * @param {object} body 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ArtworkCollectionApi
     */
    public createOneBaseArtworkCollectionControllerArtworkCollection(body: object, options?: AxiosRequestConfig) {
        return ArtworkCollectionApiFp(this.configuration).createOneBaseArtworkCollectionControllerArtworkCollection(body, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Delete a single ArtworkCollection
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ArtworkCollectionApi
     */
    public deleteOneBaseArtworkCollectionControllerArtworkCollection(id: string, options?: AxiosRequestConfig) {
        return ArtworkCollectionApiFp(this.configuration).deleteOneBaseArtworkCollectionControllerArtworkCollection(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Retrieve multiple ArtworkCollections
     * @param {Array<string>} [fields] Selects resource fields. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#select\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param {string} [s] Adds search condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#search\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param {Array<string>} [filter] Adds filter condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#filter\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param {Array<string>} [or] Adds OR condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#or\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param {Array<string>} [sort] Adds sort by field. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#sort\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param {Array<string>} [join] Adds relational resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#join\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param {number} [limit] Limit amount of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#limit\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param {number} [offset] Offset amount of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#offset\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param {number} [page] Page portion of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#page\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param {number} [cache] Reset cache (if was enabled). &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#cache\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ArtworkCollectionApi
     */
    public getManyBaseArtworkCollectionControllerArtworkCollection(fields?: Array<string>, s?: string, filter?: Array<string>, or?: Array<string>, sort?: Array<string>, join?: Array<string>, limit?: number, offset?: number, page?: number, cache?: number, options?: AxiosRequestConfig) {
        return ArtworkCollectionApiFp(this.configuration).getManyBaseArtworkCollectionControllerArtworkCollection(fields, s, filter, or, sort, join, limit, offset, page, cache, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Retrieve a single ArtworkCollection
     * @param {string} id 
     * @param {Array<string>} [fields] Selects resource fields. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#select\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param {Array<string>} [join] Adds relational resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#join\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param {number} [cache] Reset cache (if was enabled). &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#cache\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ArtworkCollectionApi
     */
    public getOneBaseArtworkCollectionControllerArtworkCollection(id: string, fields?: Array<string>, join?: Array<string>, cache?: number, options?: AxiosRequestConfig) {
        return ArtworkCollectionApiFp(this.configuration).getOneBaseArtworkCollectionControllerArtworkCollection(id, fields, join, cache, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Replace a single ArtworkCollection
     * @param {string} id 
     * @param {object} body 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ArtworkCollectionApi
     */
    public replaceOneBaseArtworkCollectionControllerArtworkCollection(id: string, body: object, options?: AxiosRequestConfig) {
        return ArtworkCollectionApiFp(this.configuration).replaceOneBaseArtworkCollectionControllerArtworkCollection(id, body, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update a single ArtworkCollection
     * @param {string} id 
     * @param {object} body 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ArtworkCollectionApi
     */
    public updateOneBaseArtworkCollectionControllerArtworkCollection(id: string, body: object, options?: AxiosRequestConfig) {
        return ArtworkCollectionApiFp(this.configuration).updateOneBaseArtworkCollectionControllerArtworkCollection(id, body, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * AuthApi - axios parameter creator
 * @export
 */
export const AuthApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Sign in with Firebase (Google / Apple)
         * @param {AuthControllerFirebaseLoginRequest} authControllerFirebaseLoginRequest Firebase ID token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authControllerFirebaseLogin: async (authControllerFirebaseLoginRequest: AuthControllerFirebaseLoginRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'authControllerFirebaseLoginRequest' is not null or undefined
            assertParamExists('authControllerFirebaseLogin', 'authControllerFirebaseLoginRequest', authControllerFirebaseLoginRequest)
            const localVarPath = `/auth/firebase-login`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(authControllerFirebaseLoginRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {LoginDto} loginDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authControllerLogin: async (loginDto: LoginDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'loginDto' is not null or undefined
            assertParamExists('authControllerLogin', 'loginDto', loginDto)
            const localVarPath = `/auth/login`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(loginDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authControllerLogout: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/auth/logout`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authControllerRefresh: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/auth/refresh`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {RegisterDto} registerDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authControllerRegister: async (registerDto: RegisterDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'registerDto' is not null or undefined
            assertParamExists('authControllerRegister', 'registerDto', registerDto)
            const localVarPath = `/auth/register`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(registerDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authControllerRenderAccess: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/auth/render-access`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Request password reset
         * @param {RequestPasswordResetDto} requestPasswordResetDto Email
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authControllerRequestReset: async (requestPasswordResetDto: RequestPasswordResetDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'requestPasswordResetDto' is not null or undefined
            assertParamExists('authControllerRequestReset', 'requestPasswordResetDto', requestPasswordResetDto)
            const localVarPath = `/auth/request-reset`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(requestPasswordResetDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Resend the email-confirmation link
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authControllerResendVerification: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/auth/resend-verification`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Reset password
         * @param {ResetPasswordDto} resetPasswordDto Token and New Password
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authControllerResetPassword: async (resetPasswordDto: ResetPasswordDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'resetPasswordDto' is not null or undefined
            assertParamExists('authControllerResetPassword', 'resetPasswordDto', resetPasswordDto)
            const localVarPath = `/auth/reset-password`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(resetPasswordDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} token 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authControllerVerifyAccount: async (token: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'token' is not null or undefined
            assertParamExists('authControllerVerifyAccount', 'token', token)
            const localVarPath = `/auth/verify`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (token !== undefined) {
                localVarQueryParameter['token'] = token;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AuthApi - functional programming interface
 * @export
 */
export const AuthApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AuthApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Sign in with Firebase (Google / Apple)
         * @param {AuthControllerFirebaseLoginRequest} authControllerFirebaseLoginRequest Firebase ID token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async authControllerFirebaseLogin(authControllerFirebaseLoginRequest: AuthControllerFirebaseLoginRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LoginResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.authControllerFirebaseLogin(authControllerFirebaseLoginRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {LoginDto} loginDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async authControllerLogin(loginDto: LoginDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LoginResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.authControllerLogin(loginDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async authControllerLogout(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.authControllerLogout(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async authControllerRefresh(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LoginResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.authControllerRefresh(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {RegisterDto} registerDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async authControllerRegister(registerDto: RegisterDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.authControllerRegister(registerDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async authControllerRenderAccess(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.authControllerRenderAccess(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Request password reset
         * @param {RequestPasswordResetDto} requestPasswordResetDto Email
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async authControllerRequestReset(requestPasswordResetDto: RequestPasswordResetDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.authControllerRequestReset(requestPasswordResetDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Resend the email-confirmation link
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async authControllerResendVerification(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResendVerificationResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.authControllerResendVerification(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Reset password
         * @param {ResetPasswordDto} resetPasswordDto Token and New Password
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async authControllerResetPassword(resetPasswordDto: ResetPasswordDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.authControllerResetPassword(resetPasswordDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} token 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async authControllerVerifyAccount(token: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.authControllerVerifyAccount(token, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * AuthApi - factory interface
 * @export
 */
export const AuthApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AuthApiFp(configuration)
    return {
        /**
         * 
         * @summary Sign in with Firebase (Google / Apple)
         * @param {AuthControllerFirebaseLoginRequest} authControllerFirebaseLoginRequest Firebase ID token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authControllerFirebaseLogin(authControllerFirebaseLoginRequest: AuthControllerFirebaseLoginRequest, options?: any): AxiosPromise<LoginResponseDto> {
            return localVarFp.authControllerFirebaseLogin(authControllerFirebaseLoginRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {LoginDto} loginDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authControllerLogin(loginDto: LoginDto, options?: any): AxiosPromise<LoginResponseDto> {
            return localVarFp.authControllerLogin(loginDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authControllerLogout(options?: any): AxiosPromise<void> {
            return localVarFp.authControllerLogout(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authControllerRefresh(options?: any): AxiosPromise<LoginResponseDto> {
            return localVarFp.authControllerRefresh(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {RegisterDto} registerDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authControllerRegister(registerDto: RegisterDto, options?: any): AxiosPromise<void> {
            return localVarFp.authControllerRegister(registerDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authControllerRenderAccess(options?: any): AxiosPromise<void> {
            return localVarFp.authControllerRenderAccess(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Request password reset
         * @param {RequestPasswordResetDto} requestPasswordResetDto Email
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authControllerRequestReset(requestPasswordResetDto: RequestPasswordResetDto, options?: any): AxiosPromise<void> {
            return localVarFp.authControllerRequestReset(requestPasswordResetDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Resend the email-confirmation link
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authControllerResendVerification(options?: any): AxiosPromise<ResendVerificationResponseDto> {
            return localVarFp.authControllerResendVerification(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Reset password
         * @param {ResetPasswordDto} resetPasswordDto Token and New Password
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authControllerResetPassword(resetPasswordDto: ResetPasswordDto, options?: any): AxiosPromise<void> {
            return localVarFp.authControllerResetPassword(resetPasswordDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} token 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authControllerVerifyAccount(token: string, options?: any): AxiosPromise<void> {
            return localVarFp.authControllerVerifyAccount(token, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * AuthApi - object-oriented interface
 * @export
 * @class AuthApi
 * @extends {BaseAPI}
 */
export class AuthApi extends BaseAPI {
    /**
     * 
     * @summary Sign in with Firebase (Google / Apple)
     * @param {AuthControllerFirebaseLoginRequest} authControllerFirebaseLoginRequest Firebase ID token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthApi
     */
    public authControllerFirebaseLogin(authControllerFirebaseLoginRequest: AuthControllerFirebaseLoginRequest, options?: AxiosRequestConfig) {
        return AuthApiFp(this.configuration).authControllerFirebaseLogin(authControllerFirebaseLoginRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {LoginDto} loginDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthApi
     */
    public authControllerLogin(loginDto: LoginDto, options?: AxiosRequestConfig) {
        return AuthApiFp(this.configuration).authControllerLogin(loginDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthApi
     */
    public authControllerLogout(options?: AxiosRequestConfig) {
        return AuthApiFp(this.configuration).authControllerLogout(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthApi
     */
    public authControllerRefresh(options?: AxiosRequestConfig) {
        return AuthApiFp(this.configuration).authControllerRefresh(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {RegisterDto} registerDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthApi
     */
    public authControllerRegister(registerDto: RegisterDto, options?: AxiosRequestConfig) {
        return AuthApiFp(this.configuration).authControllerRegister(registerDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthApi
     */
    public authControllerRenderAccess(options?: AxiosRequestConfig) {
        return AuthApiFp(this.configuration).authControllerRenderAccess(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Request password reset
     * @param {RequestPasswordResetDto} requestPasswordResetDto Email
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthApi
     */
    public authControllerRequestReset(requestPasswordResetDto: RequestPasswordResetDto, options?: AxiosRequestConfig) {
        return AuthApiFp(this.configuration).authControllerRequestReset(requestPasswordResetDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Resend the email-confirmation link
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthApi
     */
    public authControllerResendVerification(options?: AxiosRequestConfig) {
        return AuthApiFp(this.configuration).authControllerResendVerification(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Reset password
     * @param {ResetPasswordDto} resetPasswordDto Token and New Password
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthApi
     */
    public authControllerResetPassword(resetPasswordDto: ResetPasswordDto, options?: AxiosRequestConfig) {
        return AuthApiFp(this.configuration).authControllerResetPassword(resetPasswordDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} token 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthApi
     */
    public authControllerVerifyAccount(token: string, options?: AxiosRequestConfig) {
        return AuthApiFp(this.configuration).authControllerVerifyAccount(token, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * BannerMessageApi - axios parameter creator
 * @export
 */
export const BannerMessageApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Create multiple BannerMessages
         * @param {CreateManyBannerMessageDto} createManyBannerMessageDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createManyBaseBannerMessageControllerBannerMessage: async (createManyBannerMessageDto: CreateManyBannerMessageDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createManyBannerMessageDto' is not null or undefined
            assertParamExists('createManyBaseBannerMessageControllerBannerMessage', 'createManyBannerMessageDto', createManyBannerMessageDto)
            const localVarPath = `/banner-message/bulk`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createManyBannerMessageDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Create a single BannerMessage
         * @param {CreateBannerMessageDto} createBannerMessageDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createOneBaseBannerMessageControllerBannerMessage: async (createBannerMessageDto: CreateBannerMessageDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createBannerMessageDto' is not null or undefined
            assertParamExists('createOneBaseBannerMessageControllerBannerMessage', 'createBannerMessageDto', createBannerMessageDto)
            const localVarPath = `/banner-message`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createBannerMessageDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Delete a single BannerMessage
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOneBaseBannerMessageControllerBannerMessage: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('deleteOneBaseBannerMessageControllerBannerMessage', 'id', id)
            const localVarPath = `/banner-message/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Retrieve multiple BannerMessages
         * @param {Array<string>} [fields] Selects resource fields. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#select\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {string} [s] Adds search condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#search\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {Array<string>} [filter] Adds filter condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#filter\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {Array<string>} [or] Adds OR condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#or\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {Array<string>} [sort] Adds sort by field. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#sort\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {Array<string>} [join] Adds relational resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#join\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {number} [limit] Limit amount of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#limit\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {number} [offset] Offset amount of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#offset\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {number} [page] Page portion of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#page\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {number} [cache] Reset cache (if was enabled). &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#cache\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getManyBaseBannerMessageControllerBannerMessage: async (fields?: Array<string>, s?: string, filter?: Array<string>, or?: Array<string>, sort?: Array<string>, join?: Array<string>, limit?: number, offset?: number, page?: number, cache?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/banner-message`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (fields) {
                localVarQueryParameter['fields'] = fields;
            }

            if (s !== undefined) {
                localVarQueryParameter['s'] = s;
            }

            if (filter) {
                localVarQueryParameter['filter'] = filter;
            }

            if (or) {
                localVarQueryParameter['or'] = or;
            }

            if (sort) {
                localVarQueryParameter['sort'] = sort;
            }

            if (join) {
                localVarQueryParameter['join'] = join;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (cache !== undefined) {
                localVarQueryParameter['cache'] = cache;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Retrieve a single BannerMessage
         * @param {string} id 
         * @param {Array<string>} [fields] Selects resource fields. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#select\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {Array<string>} [join] Adds relational resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#join\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {number} [cache] Reset cache (if was enabled). &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#cache\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOneBaseBannerMessageControllerBannerMessage: async (id: string, fields?: Array<string>, join?: Array<string>, cache?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getOneBaseBannerMessageControllerBannerMessage', 'id', id)
            const localVarPath = `/banner-message/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (fields) {
                localVarQueryParameter['fields'] = fields;
            }

            if (join) {
                localVarQueryParameter['join'] = join;
            }

            if (cache !== undefined) {
                localVarQueryParameter['cache'] = cache;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Replace a single BannerMessage
         * @param {string} id 
         * @param {UpdateBannerMessageDto} updateBannerMessageDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        replaceOneBaseBannerMessageControllerBannerMessage: async (id: string, updateBannerMessageDto: UpdateBannerMessageDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('replaceOneBaseBannerMessageControllerBannerMessage', 'id', id)
            // verify required parameter 'updateBannerMessageDto' is not null or undefined
            assertParamExists('replaceOneBaseBannerMessageControllerBannerMessage', 'updateBannerMessageDto', updateBannerMessageDto)
            const localVarPath = `/banner-message/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateBannerMessageDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update a single BannerMessage
         * @param {string} id 
         * @param {UpdateBannerMessageDto} updateBannerMessageDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateOneBaseBannerMessageControllerBannerMessage: async (id: string, updateBannerMessageDto: UpdateBannerMessageDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('updateOneBaseBannerMessageControllerBannerMessage', 'id', id)
            // verify required parameter 'updateBannerMessageDto' is not null or undefined
            assertParamExists('updateOneBaseBannerMessageControllerBannerMessage', 'updateBannerMessageDto', updateBannerMessageDto)
            const localVarPath = `/banner-message/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateBannerMessageDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * BannerMessageApi - functional programming interface
 * @export
 */
export const BannerMessageApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = BannerMessageApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Create multiple BannerMessages
         * @param {CreateManyBannerMessageDto} createManyBannerMessageDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createManyBaseBannerMessageControllerBannerMessage(createManyBannerMessageDto: CreateManyBannerMessageDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<object>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createManyBaseBannerMessageControllerBannerMessage(createManyBannerMessageDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Create a single BannerMessage
         * @param {CreateBannerMessageDto} createBannerMessageDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createOneBaseBannerMessageControllerBannerMessage(createBannerMessageDto: CreateBannerMessageDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createOneBaseBannerMessageControllerBannerMessage(createBannerMessageDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Delete a single BannerMessage
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteOneBaseBannerMessageControllerBannerMessage(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteOneBaseBannerMessageControllerBannerMessage(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Retrieve multiple BannerMessages
         * @param {Array<string>} [fields] Selects resource fields. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#select\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {string} [s] Adds search condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#search\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {Array<string>} [filter] Adds filter condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#filter\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {Array<string>} [or] Adds OR condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#or\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {Array<string>} [sort] Adds sort by field. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#sort\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {Array<string>} [join] Adds relational resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#join\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {number} [limit] Limit amount of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#limit\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {number} [offset] Offset amount of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#offset\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {number} [page] Page portion of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#page\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {number} [cache] Reset cache (if was enabled). &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#cache\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getManyBaseBannerMessageControllerBannerMessage(fields?: Array<string>, s?: string, filter?: Array<string>, or?: Array<string>, sort?: Array<string>, join?: Array<string>, limit?: number, offset?: number, page?: number, cache?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetManyBannerMessageResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getManyBaseBannerMessageControllerBannerMessage(fields, s, filter, or, sort, join, limit, offset, page, cache, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Retrieve a single BannerMessage
         * @param {string} id 
         * @param {Array<string>} [fields] Selects resource fields. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#select\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {Array<string>} [join] Adds relational resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#join\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {number} [cache] Reset cache (if was enabled). &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#cache\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getOneBaseBannerMessageControllerBannerMessage(id: string, fields?: Array<string>, join?: Array<string>, cache?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetBannerMessageDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getOneBaseBannerMessageControllerBannerMessage(id, fields, join, cache, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Replace a single BannerMessage
         * @param {string} id 
         * @param {UpdateBannerMessageDto} updateBannerMessageDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async replaceOneBaseBannerMessageControllerBannerMessage(id: string, updateBannerMessageDto: UpdateBannerMessageDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.replaceOneBaseBannerMessageControllerBannerMessage(id, updateBannerMessageDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Update a single BannerMessage
         * @param {string} id 
         * @param {UpdateBannerMessageDto} updateBannerMessageDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateOneBaseBannerMessageControllerBannerMessage(id: string, updateBannerMessageDto: UpdateBannerMessageDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateOneBaseBannerMessageControllerBannerMessage(id, updateBannerMessageDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * BannerMessageApi - factory interface
 * @export
 */
export const BannerMessageApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = BannerMessageApiFp(configuration)
    return {
        /**
         * 
         * @summary Create multiple BannerMessages
         * @param {CreateManyBannerMessageDto} createManyBannerMessageDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createManyBaseBannerMessageControllerBannerMessage(createManyBannerMessageDto: CreateManyBannerMessageDto, options?: any): AxiosPromise<Array<object>> {
            return localVarFp.createManyBaseBannerMessageControllerBannerMessage(createManyBannerMessageDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Create a single BannerMessage
         * @param {CreateBannerMessageDto} createBannerMessageDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createOneBaseBannerMessageControllerBannerMessage(createBannerMessageDto: CreateBannerMessageDto, options?: any): AxiosPromise<object> {
            return localVarFp.createOneBaseBannerMessageControllerBannerMessage(createBannerMessageDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Delete a single BannerMessage
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOneBaseBannerMessageControllerBannerMessage(id: string, options?: any): AxiosPromise<object> {
            return localVarFp.deleteOneBaseBannerMessageControllerBannerMessage(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Retrieve multiple BannerMessages
         * @param {Array<string>} [fields] Selects resource fields. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#select\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {string} [s] Adds search condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#search\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {Array<string>} [filter] Adds filter condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#filter\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {Array<string>} [or] Adds OR condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#or\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {Array<string>} [sort] Adds sort by field. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#sort\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {Array<string>} [join] Adds relational resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#join\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {number} [limit] Limit amount of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#limit\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {number} [offset] Offset amount of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#offset\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {number} [page] Page portion of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#page\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {number} [cache] Reset cache (if was enabled). &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#cache\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getManyBaseBannerMessageControllerBannerMessage(fields?: Array<string>, s?: string, filter?: Array<string>, or?: Array<string>, sort?: Array<string>, join?: Array<string>, limit?: number, offset?: number, page?: number, cache?: number, options?: any): AxiosPromise<GetManyBannerMessageResponseDto> {
            return localVarFp.getManyBaseBannerMessageControllerBannerMessage(fields, s, filter, or, sort, join, limit, offset, page, cache, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Retrieve a single BannerMessage
         * @param {string} id 
         * @param {Array<string>} [fields] Selects resource fields. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#select\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {Array<string>} [join] Adds relational resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#join\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {number} [cache] Reset cache (if was enabled). &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#cache\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOneBaseBannerMessageControllerBannerMessage(id: string, fields?: Array<string>, join?: Array<string>, cache?: number, options?: any): AxiosPromise<GetBannerMessageDto> {
            return localVarFp.getOneBaseBannerMessageControllerBannerMessage(id, fields, join, cache, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Replace a single BannerMessage
         * @param {string} id 
         * @param {UpdateBannerMessageDto} updateBannerMessageDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        replaceOneBaseBannerMessageControllerBannerMessage(id: string, updateBannerMessageDto: UpdateBannerMessageDto, options?: any): AxiosPromise<object> {
            return localVarFp.replaceOneBaseBannerMessageControllerBannerMessage(id, updateBannerMessageDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update a single BannerMessage
         * @param {string} id 
         * @param {UpdateBannerMessageDto} updateBannerMessageDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateOneBaseBannerMessageControllerBannerMessage(id: string, updateBannerMessageDto: UpdateBannerMessageDto, options?: any): AxiosPromise<object> {
            return localVarFp.updateOneBaseBannerMessageControllerBannerMessage(id, updateBannerMessageDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * BannerMessageApi - object-oriented interface
 * @export
 * @class BannerMessageApi
 * @extends {BaseAPI}
 */
export class BannerMessageApi extends BaseAPI {
    /**
     * 
     * @summary Create multiple BannerMessages
     * @param {CreateManyBannerMessageDto} createManyBannerMessageDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BannerMessageApi
     */
    public createManyBaseBannerMessageControllerBannerMessage(createManyBannerMessageDto: CreateManyBannerMessageDto, options?: AxiosRequestConfig) {
        return BannerMessageApiFp(this.configuration).createManyBaseBannerMessageControllerBannerMessage(createManyBannerMessageDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Create a single BannerMessage
     * @param {CreateBannerMessageDto} createBannerMessageDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BannerMessageApi
     */
    public createOneBaseBannerMessageControllerBannerMessage(createBannerMessageDto: CreateBannerMessageDto, options?: AxiosRequestConfig) {
        return BannerMessageApiFp(this.configuration).createOneBaseBannerMessageControllerBannerMessage(createBannerMessageDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Delete a single BannerMessage
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BannerMessageApi
     */
    public deleteOneBaseBannerMessageControllerBannerMessage(id: string, options?: AxiosRequestConfig) {
        return BannerMessageApiFp(this.configuration).deleteOneBaseBannerMessageControllerBannerMessage(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Retrieve multiple BannerMessages
     * @param {Array<string>} [fields] Selects resource fields. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#select\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param {string} [s] Adds search condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#search\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param {Array<string>} [filter] Adds filter condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#filter\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param {Array<string>} [or] Adds OR condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#or\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param {Array<string>} [sort] Adds sort by field. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#sort\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param {Array<string>} [join] Adds relational resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#join\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param {number} [limit] Limit amount of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#limit\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param {number} [offset] Offset amount of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#offset\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param {number} [page] Page portion of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#page\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param {number} [cache] Reset cache (if was enabled). &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#cache\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BannerMessageApi
     */
    public getManyBaseBannerMessageControllerBannerMessage(fields?: Array<string>, s?: string, filter?: Array<string>, or?: Array<string>, sort?: Array<string>, join?: Array<string>, limit?: number, offset?: number, page?: number, cache?: number, options?: AxiosRequestConfig) {
        return BannerMessageApiFp(this.configuration).getManyBaseBannerMessageControllerBannerMessage(fields, s, filter, or, sort, join, limit, offset, page, cache, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Retrieve a single BannerMessage
     * @param {string} id 
     * @param {Array<string>} [fields] Selects resource fields. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#select\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param {Array<string>} [join] Adds relational resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#join\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param {number} [cache] Reset cache (if was enabled). &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#cache\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BannerMessageApi
     */
    public getOneBaseBannerMessageControllerBannerMessage(id: string, fields?: Array<string>, join?: Array<string>, cache?: number, options?: AxiosRequestConfig) {
        return BannerMessageApiFp(this.configuration).getOneBaseBannerMessageControllerBannerMessage(id, fields, join, cache, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Replace a single BannerMessage
     * @param {string} id 
     * @param {UpdateBannerMessageDto} updateBannerMessageDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BannerMessageApi
     */
    public replaceOneBaseBannerMessageControllerBannerMessage(id: string, updateBannerMessageDto: UpdateBannerMessageDto, options?: AxiosRequestConfig) {
        return BannerMessageApiFp(this.configuration).replaceOneBaseBannerMessageControllerBannerMessage(id, updateBannerMessageDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update a single BannerMessage
     * @param {string} id 
     * @param {UpdateBannerMessageDto} updateBannerMessageDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BannerMessageApi
     */
    public updateOneBaseBannerMessageControllerBannerMessage(id: string, updateBannerMessageDto: UpdateBannerMessageDto, options?: AxiosRequestConfig) {
        return BannerMessageApiFp(this.configuration).updateOneBaseBannerMessageControllerBannerMessage(id, updateBannerMessageDto, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * BundleApi - axios parameter creator
 * @export
 */
export const BundleApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary The bundles offered now for this currency and platform ([] while bundlesEnabled is off).
         * @param {string} [currency] 
         * @param {string} [locale] 
         * @param {string} [xClientChannel] MOBILE from the app; absent means the web.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        bundleControllerOffered: async (currency?: string, locale?: string, xClientChannel?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/bundle`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (currency !== undefined) {
                localVarQueryParameter['currency'] = currency;
            }

            if (locale !== undefined) {
                localVarQueryParameter['locale'] = locale;
            }

            if (xClientChannel != null) {
                localVarHeaderParameter['x-client-channel'] = String(xClientChannel);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {string} currency 
         * @param {string} locale 
         * @param {string} xClientChannel 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        bundleControllerOne: async (id: string, currency: string, locale: string, xClientChannel: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('bundleControllerOne', 'id', id)
            // verify required parameter 'currency' is not null or undefined
            assertParamExists('bundleControllerOne', 'currency', currency)
            // verify required parameter 'locale' is not null or undefined
            assertParamExists('bundleControllerOne', 'locale', locale)
            // verify required parameter 'xClientChannel' is not null or undefined
            assertParamExists('bundleControllerOne', 'xClientChannel', xClientChannel)
            const localVarPath = `/bundle/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (currency !== undefined) {
                localVarQueryParameter['currency'] = currency;
            }

            if (locale !== undefined) {
                localVarQueryParameter['locale'] = locale;
            }

            if (xClientChannel != null) {
                localVarHeaderParameter['x-client-channel'] = String(xClientChannel);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * BundleApi - functional programming interface
 * @export
 */
export const BundleApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = BundleApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary The bundles offered now for this currency and platform ([] while bundlesEnabled is off).
         * @param {string} [currency] 
         * @param {string} [locale] 
         * @param {string} [xClientChannel] MOBILE from the app; absent means the web.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async bundleControllerOffered(currency?: string, locale?: string, xClientChannel?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<BundleCardDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.bundleControllerOffered(currency, locale, xClientChannel, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} id 
         * @param {string} currency 
         * @param {string} locale 
         * @param {string} xClientChannel 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async bundleControllerOne(id: string, currency: string, locale: string, xClientChannel: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BundleCardDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.bundleControllerOne(id, currency, locale, xClientChannel, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * BundleApi - factory interface
 * @export
 */
export const BundleApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = BundleApiFp(configuration)
    return {
        /**
         * 
         * @summary The bundles offered now for this currency and platform ([] while bundlesEnabled is off).
         * @param {string} [currency] 
         * @param {string} [locale] 
         * @param {string} [xClientChannel] MOBILE from the app; absent means the web.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        bundleControllerOffered(currency?: string, locale?: string, xClientChannel?: string, options?: any): AxiosPromise<Array<BundleCardDto>> {
            return localVarFp.bundleControllerOffered(currency, locale, xClientChannel, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {string} currency 
         * @param {string} locale 
         * @param {string} xClientChannel 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        bundleControllerOne(id: string, currency: string, locale: string, xClientChannel: string, options?: any): AxiosPromise<BundleCardDto> {
            return localVarFp.bundleControllerOne(id, currency, locale, xClientChannel, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * BundleApi - object-oriented interface
 * @export
 * @class BundleApi
 * @extends {BaseAPI}
 */
export class BundleApi extends BaseAPI {
    /**
     * 
     * @summary The bundles offered now for this currency and platform ([] while bundlesEnabled is off).
     * @param {string} [currency] 
     * @param {string} [locale] 
     * @param {string} [xClientChannel] MOBILE from the app; absent means the web.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BundleApi
     */
    public bundleControllerOffered(currency?: string, locale?: string, xClientChannel?: string, options?: AxiosRequestConfig) {
        return BundleApiFp(this.configuration).bundleControllerOffered(currency, locale, xClientChannel, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {string} currency 
     * @param {string} locale 
     * @param {string} xClientChannel 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BundleApi
     */
    public bundleControllerOne(id: string, currency: string, locale: string, xClientChannel: string, options?: AxiosRequestConfig) {
        return BundleApiFp(this.configuration).bundleControllerOne(id, currency, locale, xClientChannel, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * BundleAdminApi - axios parameter creator
 * @export
 */
export const BundleAdminApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {CreateBundleDto} createBundleDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        bundleAdminControllerCreate: async (createBundleDto: CreateBundleDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createBundleDto' is not null or undefined
            assertParamExists('bundleAdminControllerCreate', 'createBundleDto', createBundleDto)
            const localVarPath = `/bundle/admin`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createBundleDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        bundleAdminControllerGet: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('bundleAdminControllerGet', 'id', id)
            const localVarPath = `/bundle/admin/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Admin: every bundle with sales count and total discount per currency.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        bundleAdminControllerList: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/bundle/admin`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} orderId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        bundleAdminControllerOrder: async (orderId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'orderId' is not null or undefined
            assertParamExists('bundleAdminControllerOrder', 'orderId', orderId)
            const localVarPath = `/bundle/admin/order/{orderId}`
                .replace(`{${"orderId"}}`, encodeURIComponent(String(orderId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {PreviewBundleDto} previewBundleDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        bundleAdminControllerPreview: async (previewBundleDto: PreviewBundleDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'previewBundleDto' is not null or undefined
            assertParamExists('bundleAdminControllerPreview', 'previewBundleDto', previewBundleDto)
            const localVarPath = `/bundle/admin/preview`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(previewBundleDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        bundleAdminControllerRemove: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('bundleAdminControllerRemove', 'id', id)
            const localVarPath = `/bundle/admin/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        bundleAdminControllerTargets: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/bundle/admin/targets`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {UpdateBundleDto} updateBundleDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        bundleAdminControllerUpdate: async (id: string, updateBundleDto: UpdateBundleDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('bundleAdminControllerUpdate', 'id', id)
            // verify required parameter 'updateBundleDto' is not null or undefined
            assertParamExists('bundleAdminControllerUpdate', 'updateBundleDto', updateBundleDto)
            const localVarPath = `/bundle/admin/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateBundleDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * BundleAdminApi - functional programming interface
 * @export
 */
export const BundleAdminApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = BundleAdminApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {CreateBundleDto} createBundleDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async bundleAdminControllerCreate(createBundleDto: CreateBundleDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.bundleAdminControllerCreate(createBundleDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async bundleAdminControllerGet(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.bundleAdminControllerGet(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Admin: every bundle with sales count and total discount per currency.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async bundleAdminControllerList(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.bundleAdminControllerList(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} orderId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async bundleAdminControllerOrder(orderId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.bundleAdminControllerOrder(orderId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {PreviewBundleDto} previewBundleDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async bundleAdminControllerPreview(previewBundleDto: PreviewBundleDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.bundleAdminControllerPreview(previewBundleDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async bundleAdminControllerRemove(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.bundleAdminControllerRemove(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async bundleAdminControllerTargets(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.bundleAdminControllerTargets(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} id 
         * @param {UpdateBundleDto} updateBundleDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async bundleAdminControllerUpdate(id: string, updateBundleDto: UpdateBundleDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.bundleAdminControllerUpdate(id, updateBundleDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * BundleAdminApi - factory interface
 * @export
 */
export const BundleAdminApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = BundleAdminApiFp(configuration)
    return {
        /**
         * 
         * @param {CreateBundleDto} createBundleDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        bundleAdminControllerCreate(createBundleDto: CreateBundleDto, options?: any): AxiosPromise<void> {
            return localVarFp.bundleAdminControllerCreate(createBundleDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        bundleAdminControllerGet(id: string, options?: any): AxiosPromise<void> {
            return localVarFp.bundleAdminControllerGet(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Admin: every bundle with sales count and total discount per currency.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        bundleAdminControllerList(options?: any): AxiosPromise<void> {
            return localVarFp.bundleAdminControllerList(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} orderId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        bundleAdminControllerOrder(orderId: string, options?: any): AxiosPromise<void> {
            return localVarFp.bundleAdminControllerOrder(orderId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {PreviewBundleDto} previewBundleDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        bundleAdminControllerPreview(previewBundleDto: PreviewBundleDto, options?: any): AxiosPromise<void> {
            return localVarFp.bundleAdminControllerPreview(previewBundleDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        bundleAdminControllerRemove(id: string, options?: any): AxiosPromise<void> {
            return localVarFp.bundleAdminControllerRemove(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        bundleAdminControllerTargets(options?: any): AxiosPromise<void> {
            return localVarFp.bundleAdminControllerTargets(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {UpdateBundleDto} updateBundleDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        bundleAdminControllerUpdate(id: string, updateBundleDto: UpdateBundleDto, options?: any): AxiosPromise<void> {
            return localVarFp.bundleAdminControllerUpdate(id, updateBundleDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * BundleAdminApi - object-oriented interface
 * @export
 * @class BundleAdminApi
 * @extends {BaseAPI}
 */
export class BundleAdminApi extends BaseAPI {
    /**
     * 
     * @param {CreateBundleDto} createBundleDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BundleAdminApi
     */
    public bundleAdminControllerCreate(createBundleDto: CreateBundleDto, options?: AxiosRequestConfig) {
        return BundleAdminApiFp(this.configuration).bundleAdminControllerCreate(createBundleDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BundleAdminApi
     */
    public bundleAdminControllerGet(id: string, options?: AxiosRequestConfig) {
        return BundleAdminApiFp(this.configuration).bundleAdminControllerGet(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Admin: every bundle with sales count and total discount per currency.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BundleAdminApi
     */
    public bundleAdminControllerList(options?: AxiosRequestConfig) {
        return BundleAdminApiFp(this.configuration).bundleAdminControllerList(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} orderId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BundleAdminApi
     */
    public bundleAdminControllerOrder(orderId: string, options?: AxiosRequestConfig) {
        return BundleAdminApiFp(this.configuration).bundleAdminControllerOrder(orderId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {PreviewBundleDto} previewBundleDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BundleAdminApi
     */
    public bundleAdminControllerPreview(previewBundleDto: PreviewBundleDto, options?: AxiosRequestConfig) {
        return BundleAdminApiFp(this.configuration).bundleAdminControllerPreview(previewBundleDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BundleAdminApi
     */
    public bundleAdminControllerRemove(id: string, options?: AxiosRequestConfig) {
        return BundleAdminApiFp(this.configuration).bundleAdminControllerRemove(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BundleAdminApi
     */
    public bundleAdminControllerTargets(options?: AxiosRequestConfig) {
        return BundleAdminApiFp(this.configuration).bundleAdminControllerTargets(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {UpdateBundleDto} updateBundleDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BundleAdminApi
     */
    public bundleAdminControllerUpdate(id: string, updateBundleDto: UpdateBundleDto, options?: AxiosRequestConfig) {
        return BundleAdminApiFp(this.configuration).bundleAdminControllerUpdate(id, updateBundleDto, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * CashbackApi - axios parameter creator
 * @export
 */
export const CashbackApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary The cashback promotion running now for this currency, if any (banner, cart).
         * @param {string} [currency] Defaults to \&#39;eur\&#39;.
         * @param {string} [xClientChannel] MOBILE from the app; absent (or anything else) means the web. Picks the promotion for that platform.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cashbackControllerActive: async (currency?: string, xClientChannel?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/cashback/active`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (currency !== undefined) {
                localVarQueryParameter['currency'] = currency;
            }

            if (xClientChannel != null) {
                localVarHeaderParameter['x-client-channel'] = String(xClientChannel);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * CashbackApi - functional programming interface
 * @export
 */
export const CashbackApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = CashbackApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary The cashback promotion running now for this currency, if any (banner, cart).
         * @param {string} [currency] Defaults to \&#39;eur\&#39;.
         * @param {string} [xClientChannel] MOBILE from the app; absent (or anything else) means the web. Picks the promotion for that platform.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async cashbackControllerActive(currency?: string, xClientChannel?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ActiveCashbackDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.cashbackControllerActive(currency, xClientChannel, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * CashbackApi - factory interface
 * @export
 */
export const CashbackApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = CashbackApiFp(configuration)
    return {
        /**
         * 
         * @summary The cashback promotion running now for this currency, if any (banner, cart).
         * @param {string} [currency] Defaults to \&#39;eur\&#39;.
         * @param {string} [xClientChannel] MOBILE from the app; absent (or anything else) means the web. Picks the promotion for that platform.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cashbackControllerActive(currency?: string, xClientChannel?: string, options?: any): AxiosPromise<ActiveCashbackDto> {
            return localVarFp.cashbackControllerActive(currency, xClientChannel, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * CashbackApi - object-oriented interface
 * @export
 * @class CashbackApi
 * @extends {BaseAPI}
 */
export class CashbackApi extends BaseAPI {
    /**
     * 
     * @summary The cashback promotion running now for this currency, if any (banner, cart).
     * @param {string} [currency] Defaults to \&#39;eur\&#39;.
     * @param {string} [xClientChannel] MOBILE from the app; absent (or anything else) means the web. Picks the promotion for that platform.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CashbackApi
     */
    public cashbackControllerActive(currency?: string, xClientChannel?: string, options?: AxiosRequestConfig) {
        return CashbackApiFp(this.configuration).cashbackControllerActive(currency, xClientChannel, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * CashbackAdminApi - axios parameter creator
 * @export
 */
export const CashbackAdminApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Admin: awards, newest first, plus per-currency totals.
         * @param {CashbackAdminControllerAwardsStatusEnum} [status] 
         * @param {string} [search] Part of an email address, or the start of an order id.
         * @param {string} [promotionId] 
         * @param {CashbackAdminControllerAwardsSourceEnum} [source] 
         * @param {number} [page] 
         * @param {number} [limit] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cashbackAdminControllerAwards: async (status?: CashbackAdminControllerAwardsStatusEnum, search?: string, promotionId?: string, source?: CashbackAdminControllerAwardsSourceEnum, page?: number, limit?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/cashback/admin/awards`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (status !== undefined) {
                localVarQueryParameter['status'] = status;
            }

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }

            if (promotionId !== undefined) {
                localVarQueryParameter['promotionId'] = promotionId;
            }

            if (source !== undefined) {
                localVarQueryParameter['source'] = source;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Superadmin: create a promotion. 400 CASHBACK_PROMOTION_INVALID, 409 CASHBACK_PROMOTION_OVERLAP.
         * @param {CreateCashbackPromotionDto} createCashbackPromotionDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cashbackAdminControllerCreate: async (createCashbackPromotionDto: CreateCashbackPromotionDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createCashbackPromotionDto' is not null or undefined
            assertParamExists('cashbackAdminControllerCreate', 'createCashbackPromotionDto', createCashbackPromotionDto)
            const localVarPath = `/cashback/admin/promotions`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createCashbackPromotionDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Superadmin: end a running promotion now; one that has not started is deleted ({ deleted: true, id }).
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cashbackAdminControllerEnd: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('cashbackAdminControllerEnd', 'id', id)
            const localVarPath = `/cashback/admin/promotions/{id}/end`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Admin: the order\'s award, as { award } with award null when it has none.
         * @param {string} orderId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cashbackAdminControllerForOrder: async (orderId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'orderId' is not null or undefined
            assertParamExists('cashbackAdminControllerForOrder', 'orderId', orderId)
            const localVarPath = `/cashback/admin/order/{orderId}`
                .replace(`{${"orderId"}}`, encodeURIComponent(String(orderId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Admin: every promotion, newest first, with its per-currency totals.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cashbackAdminControllerPromotions: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/cashback/admin/promotions`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Admin: \"Poskusi znova\" — reconcile the award with its order now.
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cashbackAdminControllerSettleAward: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('cashbackAdminControllerSettleAward', 'id', id)
            const localVarPath = `/cashback/admin/awards/{id}/settle`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Superadmin: edit a promotion. Once started only name and endsAt may change (409 CASHBACK_PROMOTION_STARTED).
         * @param {string} id 
         * @param {UpdateCashbackPromotionDto} updateCashbackPromotionDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cashbackAdminControllerUpdate: async (id: string, updateCashbackPromotionDto: UpdateCashbackPromotionDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('cashbackAdminControllerUpdate', 'id', id)
            // verify required parameter 'updateCashbackPromotionDto' is not null or undefined
            assertParamExists('cashbackAdminControllerUpdate', 'updateCashbackPromotionDto', updateCashbackPromotionDto)
            const localVarPath = `/cashback/admin/promotions/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateCashbackPromotionDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Superadmin: cancel a pending award or take back a granted one.
         * @param {string} id 
         * @param {VoidCashbackAwardDto} voidCashbackAwardDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cashbackAdminControllerVoidAward: async (id: string, voidCashbackAwardDto: VoidCashbackAwardDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('cashbackAdminControllerVoidAward', 'id', id)
            // verify required parameter 'voidCashbackAwardDto' is not null or undefined
            assertParamExists('cashbackAdminControllerVoidAward', 'voidCashbackAwardDto', voidCashbackAwardDto)
            const localVarPath = `/cashback/admin/awards/{id}/void`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(voidCashbackAwardDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * CashbackAdminApi - functional programming interface
 * @export
 */
export const CashbackAdminApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = CashbackAdminApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Admin: awards, newest first, plus per-currency totals.
         * @param {CashbackAdminControllerAwardsStatusEnum} [status] 
         * @param {string} [search] Part of an email address, or the start of an order id.
         * @param {string} [promotionId] 
         * @param {CashbackAdminControllerAwardsSourceEnum} [source] 
         * @param {number} [page] 
         * @param {number} [limit] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async cashbackAdminControllerAwards(status?: CashbackAdminControllerAwardsStatusEnum, search?: string, promotionId?: string, source?: CashbackAdminControllerAwardsSourceEnum, page?: number, limit?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AdminCashbackAwardListDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.cashbackAdminControllerAwards(status, search, promotionId, source, page, limit, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Superadmin: create a promotion. 400 CASHBACK_PROMOTION_INVALID, 409 CASHBACK_PROMOTION_OVERLAP.
         * @param {CreateCashbackPromotionDto} createCashbackPromotionDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async cashbackAdminControllerCreate(createCashbackPromotionDto: CreateCashbackPromotionDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CashbackPromotionDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.cashbackAdminControllerCreate(createCashbackPromotionDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Superadmin: end a running promotion now; one that has not started is deleted ({ deleted: true, id }).
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async cashbackAdminControllerEnd(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.cashbackAdminControllerEnd(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Admin: the order\'s award, as { award } with award null when it has none.
         * @param {string} orderId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async cashbackAdminControllerForOrder(orderId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AdminCashbackOrderAwardDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.cashbackAdminControllerForOrder(orderId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Admin: every promotion, newest first, with its per-currency totals.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async cashbackAdminControllerPromotions(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<CashbackPromotionWithTotalsDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.cashbackAdminControllerPromotions(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Admin: \"Poskusi znova\" — reconcile the award with its order now.
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async cashbackAdminControllerSettleAward(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.cashbackAdminControllerSettleAward(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Superadmin: edit a promotion. Once started only name and endsAt may change (409 CASHBACK_PROMOTION_STARTED).
         * @param {string} id 
         * @param {UpdateCashbackPromotionDto} updateCashbackPromotionDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async cashbackAdminControllerUpdate(id: string, updateCashbackPromotionDto: UpdateCashbackPromotionDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CashbackPromotionDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.cashbackAdminControllerUpdate(id, updateCashbackPromotionDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Superadmin: cancel a pending award or take back a granted one.
         * @param {string} id 
         * @param {VoidCashbackAwardDto} voidCashbackAwardDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async cashbackAdminControllerVoidAward(id: string, voidCashbackAwardDto: VoidCashbackAwardDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.cashbackAdminControllerVoidAward(id, voidCashbackAwardDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * CashbackAdminApi - factory interface
 * @export
 */
export const CashbackAdminApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = CashbackAdminApiFp(configuration)
    return {
        /**
         * 
         * @summary Admin: awards, newest first, plus per-currency totals.
         * @param {CashbackAdminControllerAwardsStatusEnum} [status] 
         * @param {string} [search] Part of an email address, or the start of an order id.
         * @param {string} [promotionId] 
         * @param {CashbackAdminControllerAwardsSourceEnum} [source] 
         * @param {number} [page] 
         * @param {number} [limit] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cashbackAdminControllerAwards(status?: CashbackAdminControllerAwardsStatusEnum, search?: string, promotionId?: string, source?: CashbackAdminControllerAwardsSourceEnum, page?: number, limit?: number, options?: any): AxiosPromise<AdminCashbackAwardListDto> {
            return localVarFp.cashbackAdminControllerAwards(status, search, promotionId, source, page, limit, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Superadmin: create a promotion. 400 CASHBACK_PROMOTION_INVALID, 409 CASHBACK_PROMOTION_OVERLAP.
         * @param {CreateCashbackPromotionDto} createCashbackPromotionDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cashbackAdminControllerCreate(createCashbackPromotionDto: CreateCashbackPromotionDto, options?: any): AxiosPromise<CashbackPromotionDto> {
            return localVarFp.cashbackAdminControllerCreate(createCashbackPromotionDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Superadmin: end a running promotion now; one that has not started is deleted ({ deleted: true, id }).
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cashbackAdminControllerEnd(id: string, options?: any): AxiosPromise<void> {
            return localVarFp.cashbackAdminControllerEnd(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Admin: the order\'s award, as { award } with award null when it has none.
         * @param {string} orderId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cashbackAdminControllerForOrder(orderId: string, options?: any): AxiosPromise<AdminCashbackOrderAwardDto> {
            return localVarFp.cashbackAdminControllerForOrder(orderId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Admin: every promotion, newest first, with its per-currency totals.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cashbackAdminControllerPromotions(options?: any): AxiosPromise<Array<CashbackPromotionWithTotalsDto>> {
            return localVarFp.cashbackAdminControllerPromotions(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Admin: \"Poskusi znova\" — reconcile the award with its order now.
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cashbackAdminControllerSettleAward(id: string, options?: any): AxiosPromise<void> {
            return localVarFp.cashbackAdminControllerSettleAward(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Superadmin: edit a promotion. Once started only name and endsAt may change (409 CASHBACK_PROMOTION_STARTED).
         * @param {string} id 
         * @param {UpdateCashbackPromotionDto} updateCashbackPromotionDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cashbackAdminControllerUpdate(id: string, updateCashbackPromotionDto: UpdateCashbackPromotionDto, options?: any): AxiosPromise<CashbackPromotionDto> {
            return localVarFp.cashbackAdminControllerUpdate(id, updateCashbackPromotionDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Superadmin: cancel a pending award or take back a granted one.
         * @param {string} id 
         * @param {VoidCashbackAwardDto} voidCashbackAwardDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cashbackAdminControllerVoidAward(id: string, voidCashbackAwardDto: VoidCashbackAwardDto, options?: any): AxiosPromise<void> {
            return localVarFp.cashbackAdminControllerVoidAward(id, voidCashbackAwardDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * CashbackAdminApi - object-oriented interface
 * @export
 * @class CashbackAdminApi
 * @extends {BaseAPI}
 */
export class CashbackAdminApi extends BaseAPI {
    /**
     * 
     * @summary Admin: awards, newest first, plus per-currency totals.
     * @param {CashbackAdminControllerAwardsStatusEnum} [status] 
     * @param {string} [search] Part of an email address, or the start of an order id.
     * @param {string} [promotionId] 
     * @param {CashbackAdminControllerAwardsSourceEnum} [source] 
     * @param {number} [page] 
     * @param {number} [limit] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CashbackAdminApi
     */
    public cashbackAdminControllerAwards(status?: CashbackAdminControllerAwardsStatusEnum, search?: string, promotionId?: string, source?: CashbackAdminControllerAwardsSourceEnum, page?: number, limit?: number, options?: AxiosRequestConfig) {
        return CashbackAdminApiFp(this.configuration).cashbackAdminControllerAwards(status, search, promotionId, source, page, limit, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Superadmin: create a promotion. 400 CASHBACK_PROMOTION_INVALID, 409 CASHBACK_PROMOTION_OVERLAP.
     * @param {CreateCashbackPromotionDto} createCashbackPromotionDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CashbackAdminApi
     */
    public cashbackAdminControllerCreate(createCashbackPromotionDto: CreateCashbackPromotionDto, options?: AxiosRequestConfig) {
        return CashbackAdminApiFp(this.configuration).cashbackAdminControllerCreate(createCashbackPromotionDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Superadmin: end a running promotion now; one that has not started is deleted ({ deleted: true, id }).
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CashbackAdminApi
     */
    public cashbackAdminControllerEnd(id: string, options?: AxiosRequestConfig) {
        return CashbackAdminApiFp(this.configuration).cashbackAdminControllerEnd(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Admin: the order\'s award, as { award } with award null when it has none.
     * @param {string} orderId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CashbackAdminApi
     */
    public cashbackAdminControllerForOrder(orderId: string, options?: AxiosRequestConfig) {
        return CashbackAdminApiFp(this.configuration).cashbackAdminControllerForOrder(orderId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Admin: every promotion, newest first, with its per-currency totals.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CashbackAdminApi
     */
    public cashbackAdminControllerPromotions(options?: AxiosRequestConfig) {
        return CashbackAdminApiFp(this.configuration).cashbackAdminControllerPromotions(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Admin: \"Poskusi znova\" — reconcile the award with its order now.
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CashbackAdminApi
     */
    public cashbackAdminControllerSettleAward(id: string, options?: AxiosRequestConfig) {
        return CashbackAdminApiFp(this.configuration).cashbackAdminControllerSettleAward(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Superadmin: edit a promotion. Once started only name and endsAt may change (409 CASHBACK_PROMOTION_STARTED).
     * @param {string} id 
     * @param {UpdateCashbackPromotionDto} updateCashbackPromotionDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CashbackAdminApi
     */
    public cashbackAdminControllerUpdate(id: string, updateCashbackPromotionDto: UpdateCashbackPromotionDto, options?: AxiosRequestConfig) {
        return CashbackAdminApiFp(this.configuration).cashbackAdminControllerUpdate(id, updateCashbackPromotionDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Superadmin: cancel a pending award or take back a granted one.
     * @param {string} id 
     * @param {VoidCashbackAwardDto} voidCashbackAwardDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CashbackAdminApi
     */
    public cashbackAdminControllerVoidAward(id: string, voidCashbackAwardDto: VoidCashbackAwardDto, options?: AxiosRequestConfig) {
        return CashbackAdminApiFp(this.configuration).cashbackAdminControllerVoidAward(id, voidCashbackAwardDto, options).then((request) => request(this.axios, this.basePath));
    }
}

/**
 * @export
 */
export const CashbackAdminControllerAwardsStatusEnum = {
    Pending: 'PENDING',
    Granted: 'GRANTED',
    Canceled: 'CANCELED',
    Voided: 'VOIDED'
} as const;
export type CashbackAdminControllerAwardsStatusEnum = typeof CashbackAdminControllerAwardsStatusEnum[keyof typeof CashbackAdminControllerAwardsStatusEnum];
/**
 * @export
 */
export const CashbackAdminControllerAwardsSourceEnum = {
    Promotion: 'PROMOTION',
    Coupon: 'COUPON'
} as const;
export type CashbackAdminControllerAwardsSourceEnum = typeof CashbackAdminControllerAwardsSourceEnum[keyof typeof CashbackAdminControllerAwardsSourceEnum];


/**
 * CouponsApi - axios parameter creator
 * @export
 */
export const CouponsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Coupon expiry status with redemption counts (admin)
         * @param {string} [days] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        couponControllerHealth: async (days?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/coupons/health`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (days !== undefined) {
                localVarQueryParameter['days'] = days;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Create a single Coupon
         * @param {CreateCouponDto} createCouponDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createOneBaseCouponControllerCoupon: async (createCouponDto: CreateCouponDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createCouponDto' is not null or undefined
            assertParamExists('createOneBaseCouponControllerCoupon', 'createCouponDto', createCouponDto)
            const localVarPath = `/coupons`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createCouponDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Delete a single Coupon
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOneBaseCouponControllerCoupon: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('deleteOneBaseCouponControllerCoupon', 'id', id)
            const localVarPath = `/coupons/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Retrieve multiple Coupons
         * @param {Array<string>} [fields] Selects resource fields. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#select\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {string} [s] Adds search condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#search\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {Array<string>} [filter] Adds filter condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#filter\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {Array<string>} [or] Adds OR condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#or\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {Array<string>} [sort] Adds sort by field. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#sort\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {Array<string>} [join] Adds relational resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#join\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {number} [limit] Limit amount of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#limit\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {number} [offset] Offset amount of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#offset\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {number} [page] Page portion of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#page\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {number} [cache] Reset cache (if was enabled). &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#cache\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getManyBaseCouponControllerCoupon: async (fields?: Array<string>, s?: string, filter?: Array<string>, or?: Array<string>, sort?: Array<string>, join?: Array<string>, limit?: number, offset?: number, page?: number, cache?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/coupons`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (fields) {
                localVarQueryParameter['fields'] = fields;
            }

            if (s !== undefined) {
                localVarQueryParameter['s'] = s;
            }

            if (filter) {
                localVarQueryParameter['filter'] = filter;
            }

            if (or) {
                localVarQueryParameter['or'] = or;
            }

            if (sort) {
                localVarQueryParameter['sort'] = sort;
            }

            if (join) {
                localVarQueryParameter['join'] = join;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (cache !== undefined) {
                localVarQueryParameter['cache'] = cache;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Retrieve a single Coupon
         * @param {string} id 
         * @param {Array<string>} [fields] Selects resource fields. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#select\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {Array<string>} [join] Adds relational resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#join\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {number} [cache] Reset cache (if was enabled). &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#cache\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOneBaseCouponControllerCoupon: async (id: string, fields?: Array<string>, join?: Array<string>, cache?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getOneBaseCouponControllerCoupon', 'id', id)
            const localVarPath = `/coupons/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (fields) {
                localVarQueryParameter['fields'] = fields;
            }

            if (join) {
                localVarQueryParameter['join'] = join;
            }

            if (cache !== undefined) {
                localVarQueryParameter['cache'] = cache;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Replace a single Coupon
         * @param {string} id 
         * @param {UpdateCouponDto} updateCouponDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        replaceOneBaseCouponControllerCoupon: async (id: string, updateCouponDto: UpdateCouponDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('replaceOneBaseCouponControllerCoupon', 'id', id)
            // verify required parameter 'updateCouponDto' is not null or undefined
            assertParamExists('replaceOneBaseCouponControllerCoupon', 'updateCouponDto', updateCouponDto)
            const localVarPath = `/coupons/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateCouponDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update a single Coupon
         * @param {string} id 
         * @param {UpdateCouponDto} updateCouponDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateOneBaseCouponControllerCoupon: async (id: string, updateCouponDto: UpdateCouponDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('updateOneBaseCouponControllerCoupon', 'id', id)
            // verify required parameter 'updateCouponDto' is not null or undefined
            assertParamExists('updateOneBaseCouponControllerCoupon', 'updateCouponDto', updateCouponDto)
            const localVarPath = `/coupons/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateCouponDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * CouponsApi - functional programming interface
 * @export
 */
export const CouponsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = CouponsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Coupon expiry status with redemption counts (admin)
         * @param {string} [days] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async couponControllerHealth(days?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.couponControllerHealth(days, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Create a single Coupon
         * @param {CreateCouponDto} createCouponDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createOneBaseCouponControllerCoupon(createCouponDto: CreateCouponDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createOneBaseCouponControllerCoupon(createCouponDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Delete a single Coupon
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteOneBaseCouponControllerCoupon(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteOneBaseCouponControllerCoupon(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Retrieve multiple Coupons
         * @param {Array<string>} [fields] Selects resource fields. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#select\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {string} [s] Adds search condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#search\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {Array<string>} [filter] Adds filter condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#filter\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {Array<string>} [or] Adds OR condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#or\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {Array<string>} [sort] Adds sort by field. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#sort\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {Array<string>} [join] Adds relational resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#join\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {number} [limit] Limit amount of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#limit\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {number} [offset] Offset amount of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#offset\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {number} [page] Page portion of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#page\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {number} [cache] Reset cache (if was enabled). &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#cache\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getManyBaseCouponControllerCoupon(fields?: Array<string>, s?: string, filter?: Array<string>, or?: Array<string>, sort?: Array<string>, join?: Array<string>, limit?: number, offset?: number, page?: number, cache?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetManyCouponResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getManyBaseCouponControllerCoupon(fields, s, filter, or, sort, join, limit, offset, page, cache, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Retrieve a single Coupon
         * @param {string} id 
         * @param {Array<string>} [fields] Selects resource fields. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#select\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {Array<string>} [join] Adds relational resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#join\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {number} [cache] Reset cache (if was enabled). &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#cache\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getOneBaseCouponControllerCoupon(id: string, fields?: Array<string>, join?: Array<string>, cache?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetCouponDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getOneBaseCouponControllerCoupon(id, fields, join, cache, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Replace a single Coupon
         * @param {string} id 
         * @param {UpdateCouponDto} updateCouponDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async replaceOneBaseCouponControllerCoupon(id: string, updateCouponDto: UpdateCouponDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.replaceOneBaseCouponControllerCoupon(id, updateCouponDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Update a single Coupon
         * @param {string} id 
         * @param {UpdateCouponDto} updateCouponDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateOneBaseCouponControllerCoupon(id: string, updateCouponDto: UpdateCouponDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateOneBaseCouponControllerCoupon(id, updateCouponDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * CouponsApi - factory interface
 * @export
 */
export const CouponsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = CouponsApiFp(configuration)
    return {
        /**
         * 
         * @summary Coupon expiry status with redemption counts (admin)
         * @param {string} [days] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        couponControllerHealth(days?: string, options?: any): AxiosPromise<void> {
            return localVarFp.couponControllerHealth(days, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Create a single Coupon
         * @param {CreateCouponDto} createCouponDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createOneBaseCouponControllerCoupon(createCouponDto: CreateCouponDto, options?: any): AxiosPromise<object> {
            return localVarFp.createOneBaseCouponControllerCoupon(createCouponDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Delete a single Coupon
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOneBaseCouponControllerCoupon(id: string, options?: any): AxiosPromise<object> {
            return localVarFp.deleteOneBaseCouponControllerCoupon(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Retrieve multiple Coupons
         * @param {Array<string>} [fields] Selects resource fields. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#select\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {string} [s] Adds search condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#search\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {Array<string>} [filter] Adds filter condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#filter\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {Array<string>} [or] Adds OR condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#or\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {Array<string>} [sort] Adds sort by field. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#sort\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {Array<string>} [join] Adds relational resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#join\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {number} [limit] Limit amount of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#limit\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {number} [offset] Offset amount of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#offset\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {number} [page] Page portion of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#page\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {number} [cache] Reset cache (if was enabled). &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#cache\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getManyBaseCouponControllerCoupon(fields?: Array<string>, s?: string, filter?: Array<string>, or?: Array<string>, sort?: Array<string>, join?: Array<string>, limit?: number, offset?: number, page?: number, cache?: number, options?: any): AxiosPromise<GetManyCouponResponseDto> {
            return localVarFp.getManyBaseCouponControllerCoupon(fields, s, filter, or, sort, join, limit, offset, page, cache, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Retrieve a single Coupon
         * @param {string} id 
         * @param {Array<string>} [fields] Selects resource fields. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#select\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {Array<string>} [join] Adds relational resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#join\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {number} [cache] Reset cache (if was enabled). &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#cache\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOneBaseCouponControllerCoupon(id: string, fields?: Array<string>, join?: Array<string>, cache?: number, options?: any): AxiosPromise<GetCouponDto> {
            return localVarFp.getOneBaseCouponControllerCoupon(id, fields, join, cache, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Replace a single Coupon
         * @param {string} id 
         * @param {UpdateCouponDto} updateCouponDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        replaceOneBaseCouponControllerCoupon(id: string, updateCouponDto: UpdateCouponDto, options?: any): AxiosPromise<object> {
            return localVarFp.replaceOneBaseCouponControllerCoupon(id, updateCouponDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update a single Coupon
         * @param {string} id 
         * @param {UpdateCouponDto} updateCouponDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateOneBaseCouponControllerCoupon(id: string, updateCouponDto: UpdateCouponDto, options?: any): AxiosPromise<object> {
            return localVarFp.updateOneBaseCouponControllerCoupon(id, updateCouponDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * CouponsApi - object-oriented interface
 * @export
 * @class CouponsApi
 * @extends {BaseAPI}
 */
export class CouponsApi extends BaseAPI {
    /**
     * 
     * @summary Coupon expiry status with redemption counts (admin)
     * @param {string} [days] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CouponsApi
     */
    public couponControllerHealth(days?: string, options?: AxiosRequestConfig) {
        return CouponsApiFp(this.configuration).couponControllerHealth(days, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Create a single Coupon
     * @param {CreateCouponDto} createCouponDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CouponsApi
     */
    public createOneBaseCouponControllerCoupon(createCouponDto: CreateCouponDto, options?: AxiosRequestConfig) {
        return CouponsApiFp(this.configuration).createOneBaseCouponControllerCoupon(createCouponDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Delete a single Coupon
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CouponsApi
     */
    public deleteOneBaseCouponControllerCoupon(id: string, options?: AxiosRequestConfig) {
        return CouponsApiFp(this.configuration).deleteOneBaseCouponControllerCoupon(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Retrieve multiple Coupons
     * @param {Array<string>} [fields] Selects resource fields. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#select\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param {string} [s] Adds search condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#search\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param {Array<string>} [filter] Adds filter condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#filter\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param {Array<string>} [or] Adds OR condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#or\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param {Array<string>} [sort] Adds sort by field. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#sort\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param {Array<string>} [join] Adds relational resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#join\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param {number} [limit] Limit amount of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#limit\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param {number} [offset] Offset amount of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#offset\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param {number} [page] Page portion of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#page\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param {number} [cache] Reset cache (if was enabled). &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#cache\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CouponsApi
     */
    public getManyBaseCouponControllerCoupon(fields?: Array<string>, s?: string, filter?: Array<string>, or?: Array<string>, sort?: Array<string>, join?: Array<string>, limit?: number, offset?: number, page?: number, cache?: number, options?: AxiosRequestConfig) {
        return CouponsApiFp(this.configuration).getManyBaseCouponControllerCoupon(fields, s, filter, or, sort, join, limit, offset, page, cache, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Retrieve a single Coupon
     * @param {string} id 
     * @param {Array<string>} [fields] Selects resource fields. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#select\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param {Array<string>} [join] Adds relational resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#join\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param {number} [cache] Reset cache (if was enabled). &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#cache\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CouponsApi
     */
    public getOneBaseCouponControllerCoupon(id: string, fields?: Array<string>, join?: Array<string>, cache?: number, options?: AxiosRequestConfig) {
        return CouponsApiFp(this.configuration).getOneBaseCouponControllerCoupon(id, fields, join, cache, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Replace a single Coupon
     * @param {string} id 
     * @param {UpdateCouponDto} updateCouponDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CouponsApi
     */
    public replaceOneBaseCouponControllerCoupon(id: string, updateCouponDto: UpdateCouponDto, options?: AxiosRequestConfig) {
        return CouponsApiFp(this.configuration).replaceOneBaseCouponControllerCoupon(id, updateCouponDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update a single Coupon
     * @param {string} id 
     * @param {UpdateCouponDto} updateCouponDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CouponsApi
     */
    public updateOneBaseCouponControllerCoupon(id: string, updateCouponDto: UpdateCouponDto, options?: AxiosRequestConfig) {
        return CouponsApiFp(this.configuration).updateOneBaseCouponControllerCoupon(id, updateCouponDto, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * CreditApi - axios parameter creator
 * @export
 */
export const CreditApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Spendable credit for the signed-in account, or for the holder of an exchanged claim token (sent in the x-credit-token header).
         * @param {string} currency Lowercase: \&#39;eur\&#39;, \&#39;eur-at\&#39;, \&#39;czk\&#39;, \&#39;pln\&#39; or \&#39;ron\&#39;.
         * @param {string} [xCreditToken] The exchanged (two-hour) claim token. Omit when signed in as the owner.
         * @param {string} [orderId] The cart being checked out. Only a cart the proven address owns is used; any other order id is ignored and the reply is the one without orderId. For an owned cart, credit held on the customer\&#39;s other open carts counts as spendable (applying here moves it over), and the reply adds orderGoodsCents, lockedByMinimum, selectionMode and the per-lot selected / appliedCents / missingCents.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        creditControllerBalance: async (currency: string, xCreditToken?: string, orderId?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'currency' is not null or undefined
            assertParamExists('creditControllerBalance', 'currency', currency)
            const localVarPath = `/credit/balance`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (currency !== undefined) {
                localVarQueryParameter['currency'] = currency;
            }

            if (orderId !== undefined) {
                localVarQueryParameter['orderId'] = orderId;
            }

            if (xCreditToken != null) {
                localVarHeaderParameter['x-credit-token'] = String(xCreditToken);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Success: `?credit_token=<exchanged>`. Refusal: `?credit_error=` one of expired (an exchanged token past its two hours: reopen the email), lapsed (the credit expired), spent, on_your_cart (applied to an open cart, not spent: keep the token you hold), voided (cancelled by an operator), unknown, invalid, missing, error (retryable). Every refusal of a validly signed link goes to the token\'s own locale.
         * @summary Public: claim a granted credit from the signed link in its email. Redirects into the shop carrying the token; never 500s on a bad token.
         * @param {string} [t] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        creditControllerClaim: async (t?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/credit/claim`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (t !== undefined) {
                localVarQueryParameter['t'] = t;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary The signed-in customer\'s own credit, by currency.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        creditControllerMine: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/credit/mine`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Redeem a gift-card code on a cart
         * @param {RedeemGiftCardCodeDto} redeemGiftCardCodeDto 
         * @param {string} [xGuestToken] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        giftCardRedeemControllerRedeemCode: async (redeemGiftCardCodeDto: RedeemGiftCardCodeDto, xGuestToken?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'redeemGiftCardCodeDto' is not null or undefined
            assertParamExists('giftCardRedeemControllerRedeemCode', 'redeemGiftCardCodeDto', redeemGiftCardCodeDto)
            const localVarPath = `/credit/redeem-code`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (xGuestToken != null) {
                localVarHeaderParameter['x-guest-token'] = String(xGuestToken);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(redeemGiftCardCodeDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * CreditApi - functional programming interface
 * @export
 */
export const CreditApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = CreditApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Spendable credit for the signed-in account, or for the holder of an exchanged claim token (sent in the x-credit-token header).
         * @param {string} currency Lowercase: \&#39;eur\&#39;, \&#39;eur-at\&#39;, \&#39;czk\&#39;, \&#39;pln\&#39; or \&#39;ron\&#39;.
         * @param {string} [xCreditToken] The exchanged (two-hour) claim token. Omit when signed in as the owner.
         * @param {string} [orderId] The cart being checked out. Only a cart the proven address owns is used; any other order id is ignored and the reply is the one without orderId. For an owned cart, credit held on the customer\&#39;s other open carts counts as spendable (applying here moves it over), and the reply adds orderGoodsCents, lockedByMinimum, selectionMode and the per-lot selected / appliedCents / missingCents.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async creditControllerBalance(currency: string, xCreditToken?: string, orderId?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CreditBalanceDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.creditControllerBalance(currency, xCreditToken, orderId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Success: `?credit_token=<exchanged>`. Refusal: `?credit_error=` one of expired (an exchanged token past its two hours: reopen the email), lapsed (the credit expired), spent, on_your_cart (applied to an open cart, not spent: keep the token you hold), voided (cancelled by an operator), unknown, invalid, missing, error (retryable). Every refusal of a validly signed link goes to the token\'s own locale.
         * @summary Public: claim a granted credit from the signed link in its email. Redirects into the shop carrying the token; never 500s on a bad token.
         * @param {string} [t] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async creditControllerClaim(t?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.creditControllerClaim(t, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary The signed-in customer\'s own credit, by currency.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async creditControllerMine(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MyCreditDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.creditControllerMine(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Redeem a gift-card code on a cart
         * @param {RedeemGiftCardCodeDto} redeemGiftCardCodeDto 
         * @param {string} [xGuestToken] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async giftCardRedeemControllerRedeemCode(redeemGiftCardCodeDto: RedeemGiftCardCodeDto, xGuestToken?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RedeemGiftCardCodeResultDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.giftCardRedeemControllerRedeemCode(redeemGiftCardCodeDto, xGuestToken, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * CreditApi - factory interface
 * @export
 */
export const CreditApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = CreditApiFp(configuration)
    return {
        /**
         * 
         * @summary Spendable credit for the signed-in account, or for the holder of an exchanged claim token (sent in the x-credit-token header).
         * @param {string} currency Lowercase: \&#39;eur\&#39;, \&#39;eur-at\&#39;, \&#39;czk\&#39;, \&#39;pln\&#39; or \&#39;ron\&#39;.
         * @param {string} [xCreditToken] The exchanged (two-hour) claim token. Omit when signed in as the owner.
         * @param {string} [orderId] The cart being checked out. Only a cart the proven address owns is used; any other order id is ignored and the reply is the one without orderId. For an owned cart, credit held on the customer\&#39;s other open carts counts as spendable (applying here moves it over), and the reply adds orderGoodsCents, lockedByMinimum, selectionMode and the per-lot selected / appliedCents / missingCents.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        creditControllerBalance(currency: string, xCreditToken?: string, orderId?: string, options?: any): AxiosPromise<CreditBalanceDto> {
            return localVarFp.creditControllerBalance(currency, xCreditToken, orderId, options).then((request) => request(axios, basePath));
        },
        /**
         * Success: `?credit_token=<exchanged>`. Refusal: `?credit_error=` one of expired (an exchanged token past its two hours: reopen the email), lapsed (the credit expired), spent, on_your_cart (applied to an open cart, not spent: keep the token you hold), voided (cancelled by an operator), unknown, invalid, missing, error (retryable). Every refusal of a validly signed link goes to the token\'s own locale.
         * @summary Public: claim a granted credit from the signed link in its email. Redirects into the shop carrying the token; never 500s on a bad token.
         * @param {string} [t] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        creditControllerClaim(t?: string, options?: any): AxiosPromise<void> {
            return localVarFp.creditControllerClaim(t, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary The signed-in customer\'s own credit, by currency.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        creditControllerMine(options?: any): AxiosPromise<MyCreditDto> {
            return localVarFp.creditControllerMine(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Redeem a gift-card code on a cart
         * @param {RedeemGiftCardCodeDto} redeemGiftCardCodeDto 
         * @param {string} [xGuestToken] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        giftCardRedeemControllerRedeemCode(redeemGiftCardCodeDto: RedeemGiftCardCodeDto, xGuestToken?: string, options?: any): AxiosPromise<RedeemGiftCardCodeResultDto> {
            return localVarFp.giftCardRedeemControllerRedeemCode(redeemGiftCardCodeDto, xGuestToken, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * CreditApi - object-oriented interface
 * @export
 * @class CreditApi
 * @extends {BaseAPI}
 */
export class CreditApi extends BaseAPI {
    /**
     * 
     * @summary Spendable credit for the signed-in account, or for the holder of an exchanged claim token (sent in the x-credit-token header).
     * @param {string} currency Lowercase: \&#39;eur\&#39;, \&#39;eur-at\&#39;, \&#39;czk\&#39;, \&#39;pln\&#39; or \&#39;ron\&#39;.
     * @param {string} [xCreditToken] The exchanged (two-hour) claim token. Omit when signed in as the owner.
     * @param {string} [orderId] The cart being checked out. Only a cart the proven address owns is used; any other order id is ignored and the reply is the one without orderId. For an owned cart, credit held on the customer\&#39;s other open carts counts as spendable (applying here moves it over), and the reply adds orderGoodsCents, lockedByMinimum, selectionMode and the per-lot selected / appliedCents / missingCents.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CreditApi
     */
    public creditControllerBalance(currency: string, xCreditToken?: string, orderId?: string, options?: AxiosRequestConfig) {
        return CreditApiFp(this.configuration).creditControllerBalance(currency, xCreditToken, orderId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Success: `?credit_token=<exchanged>`. Refusal: `?credit_error=` one of expired (an exchanged token past its two hours: reopen the email), lapsed (the credit expired), spent, on_your_cart (applied to an open cart, not spent: keep the token you hold), voided (cancelled by an operator), unknown, invalid, missing, error (retryable). Every refusal of a validly signed link goes to the token\'s own locale.
     * @summary Public: claim a granted credit from the signed link in its email. Redirects into the shop carrying the token; never 500s on a bad token.
     * @param {string} [t] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CreditApi
     */
    public creditControllerClaim(t?: string, options?: AxiosRequestConfig) {
        return CreditApiFp(this.configuration).creditControllerClaim(t, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary The signed-in customer\'s own credit, by currency.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CreditApi
     */
    public creditControllerMine(options?: AxiosRequestConfig) {
        return CreditApiFp(this.configuration).creditControllerMine(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Redeem a gift-card code on a cart
     * @param {RedeemGiftCardCodeDto} redeemGiftCardCodeDto 
     * @param {string} [xGuestToken] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CreditApi
     */
    public giftCardRedeemControllerRedeemCode(redeemGiftCardCodeDto: RedeemGiftCardCodeDto, xGuestToken?: string, options?: AxiosRequestConfig) {
        return CreditApiFp(this.configuration).giftCardRedeemControllerRedeemCode(redeemGiftCardCodeDto, xGuestToken, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * CreditAdminApi - axios parameter creator
 * @export
 */
export const CreditAdminApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Superadmin: give a customer credit. Writes the lot and emails them the claim link. 400 CREDIT_CURRENCY_MISMATCH, 409 CREDIT_DUPLICATE_GRANT.
         * @param {AdminGrantCreditDto} adminGrantCreditDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        creditAdminControllerGrant: async (adminGrantCreditDto: AdminGrantCreditDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'adminGrantCreditDto' is not null or undefined
            assertParamExists('creditAdminControllerGrant', 'adminGrantCreditDto', adminGrantCreditDto)
            const localVarPath = `/credit/admin/lots`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(adminGrantCreditDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Superadmin: what the shop knows about an address — to suggest a grant\'s currency and language, and to flag an address that has never ordered.
         * @param {string} email 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        creditAdminControllerLookup: async (email: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'email' is not null or undefined
            assertParamExists('creditAdminControllerLookup', 'email', email)
            const localVarPath = `/credit/admin/lookup`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (email !== undefined) {
                localVarQueryParameter['email'] = email;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Admin: every credit lot with its redemptions, newest first, plus per-currency totals across the whole ledger.
         * @param {string} [search] Part of an email address.
         * @param {CreditAdminControllerLotsStatusEnum} [status] 
         * @param {string} [createdBy] Exact createdBy, e.g. \&quot;system:cashback\&quot; (the ledger\&#39;s \&quot;Cashback\&quot; chip).
         * @param {number} [page] 
         * @param {number} [limit] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        creditAdminControllerLots: async (search?: string, status?: CreditAdminControllerLotsStatusEnum, createdBy?: string, page?: number, limit?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/credit/admin/lots`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }

            if (status !== undefined) {
                localVarQueryParameter['status'] = status;
            }

            if (createdBy !== undefined) {
                localVarQueryParameter['createdBy'] = createdBy;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * CreditAdminApi - functional programming interface
 * @export
 */
export const CreditAdminApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = CreditAdminApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Superadmin: give a customer credit. Writes the lot and emails them the claim link. 400 CREDIT_CURRENCY_MISMATCH, 409 CREDIT_DUPLICATE_GRANT.
         * @param {AdminGrantCreditDto} adminGrantCreditDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async creditAdminControllerGrant(adminGrantCreditDto: AdminGrantCreditDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AdminGrantResultDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.creditAdminControllerGrant(adminGrantCreditDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Superadmin: what the shop knows about an address — to suggest a grant\'s currency and language, and to flag an address that has never ordered.
         * @param {string} email 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async creditAdminControllerLookup(email: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AdminCreditLookupDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.creditAdminControllerLookup(email, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Admin: every credit lot with its redemptions, newest first, plus per-currency totals across the whole ledger.
         * @param {string} [search] Part of an email address.
         * @param {CreditAdminControllerLotsStatusEnum} [status] 
         * @param {string} [createdBy] Exact createdBy, e.g. \&quot;system:cashback\&quot; (the ledger\&#39;s \&quot;Cashback\&quot; chip).
         * @param {number} [page] 
         * @param {number} [limit] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async creditAdminControllerLots(search?: string, status?: CreditAdminControllerLotsStatusEnum, createdBy?: string, page?: number, limit?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AdminCreditListDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.creditAdminControllerLots(search, status, createdBy, page, limit, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * CreditAdminApi - factory interface
 * @export
 */
export const CreditAdminApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = CreditAdminApiFp(configuration)
    return {
        /**
         * 
         * @summary Superadmin: give a customer credit. Writes the lot and emails them the claim link. 400 CREDIT_CURRENCY_MISMATCH, 409 CREDIT_DUPLICATE_GRANT.
         * @param {AdminGrantCreditDto} adminGrantCreditDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        creditAdminControllerGrant(adminGrantCreditDto: AdminGrantCreditDto, options?: any): AxiosPromise<AdminGrantResultDto> {
            return localVarFp.creditAdminControllerGrant(adminGrantCreditDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Superadmin: what the shop knows about an address — to suggest a grant\'s currency and language, and to flag an address that has never ordered.
         * @param {string} email 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        creditAdminControllerLookup(email: string, options?: any): AxiosPromise<AdminCreditLookupDto> {
            return localVarFp.creditAdminControllerLookup(email, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Admin: every credit lot with its redemptions, newest first, plus per-currency totals across the whole ledger.
         * @param {string} [search] Part of an email address.
         * @param {CreditAdminControllerLotsStatusEnum} [status] 
         * @param {string} [createdBy] Exact createdBy, e.g. \&quot;system:cashback\&quot; (the ledger\&#39;s \&quot;Cashback\&quot; chip).
         * @param {number} [page] 
         * @param {number} [limit] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        creditAdminControllerLots(search?: string, status?: CreditAdminControllerLotsStatusEnum, createdBy?: string, page?: number, limit?: number, options?: any): AxiosPromise<AdminCreditListDto> {
            return localVarFp.creditAdminControllerLots(search, status, createdBy, page, limit, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * CreditAdminApi - object-oriented interface
 * @export
 * @class CreditAdminApi
 * @extends {BaseAPI}
 */
export class CreditAdminApi extends BaseAPI {
    /**
     * 
     * @summary Superadmin: give a customer credit. Writes the lot and emails them the claim link. 400 CREDIT_CURRENCY_MISMATCH, 409 CREDIT_DUPLICATE_GRANT.
     * @param {AdminGrantCreditDto} adminGrantCreditDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CreditAdminApi
     */
    public creditAdminControllerGrant(adminGrantCreditDto: AdminGrantCreditDto, options?: AxiosRequestConfig) {
        return CreditAdminApiFp(this.configuration).creditAdminControllerGrant(adminGrantCreditDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Superadmin: what the shop knows about an address — to suggest a grant\'s currency and language, and to flag an address that has never ordered.
     * @param {string} email 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CreditAdminApi
     */
    public creditAdminControllerLookup(email: string, options?: AxiosRequestConfig) {
        return CreditAdminApiFp(this.configuration).creditAdminControllerLookup(email, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Admin: every credit lot with its redemptions, newest first, plus per-currency totals across the whole ledger.
     * @param {string} [search] Part of an email address.
     * @param {CreditAdminControllerLotsStatusEnum} [status] 
     * @param {string} [createdBy] Exact createdBy, e.g. \&quot;system:cashback\&quot; (the ledger\&#39;s \&quot;Cashback\&quot; chip).
     * @param {number} [page] 
     * @param {number} [limit] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CreditAdminApi
     */
    public creditAdminControllerLots(search?: string, status?: CreditAdminControllerLotsStatusEnum, createdBy?: string, page?: number, limit?: number, options?: AxiosRequestConfig) {
        return CreditAdminApiFp(this.configuration).creditAdminControllerLots(search, status, createdBy, page, limit, options).then((request) => request(this.axios, this.basePath));
    }
}

/**
 * @export
 */
export const CreditAdminControllerLotsStatusEnum = {
    Active: 'active',
    Spent: 'spent',
    Expired: 'expired'
} as const;
export type CreditAdminControllerLotsStatusEnum = typeof CreditAdminControllerLotsStatusEnum[keyof typeof CreditAdminControllerLotsStatusEnum];


/**
 * CreditNotesApi - axios parameter creator
 * @export
 */
export const CreditNotesApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Download the credit note PDF (storno document)
         * @param {string} id Credit note ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        creditNoteControllerDownload: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('creditNoteControllerDownload', 'id', id)
            const localVarPath = `/credit-notes/{id}/download`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Generate (or regenerate) the credit note PDF
         * @param {string} id Credit note ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        creditNoteControllerGeneratePdf: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('creditNoteControllerGeneratePdf', 'id', id)
            const localVarPath = `/credit-notes/{id}/pdf`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get credit note details (incl. negated line items)
         * @param {string} id Credit note ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        creditNoteControllerGetCreditNote: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('creditNoteControllerGetCreditNote', 'id', id)
            const localVarPath = `/credit-notes/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * CreditNotesApi - functional programming interface
 * @export
 */
export const CreditNotesApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = CreditNotesApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Download the credit note PDF (storno document)
         * @param {string} id Credit note ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async creditNoteControllerDownload(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<File>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.creditNoteControllerDownload(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Generate (or regenerate) the credit note PDF
         * @param {string} id Credit note ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async creditNoteControllerGeneratePdf(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.creditNoteControllerGeneratePdf(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get credit note details (incl. negated line items)
         * @param {string} id Credit note ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async creditNoteControllerGetCreditNote(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.creditNoteControllerGetCreditNote(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * CreditNotesApi - factory interface
 * @export
 */
export const CreditNotesApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = CreditNotesApiFp(configuration)
    return {
        /**
         * 
         * @summary Download the credit note PDF (storno document)
         * @param {string} id Credit note ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        creditNoteControllerDownload(id: string, options?: any): AxiosPromise<File> {
            return localVarFp.creditNoteControllerDownload(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Generate (or regenerate) the credit note PDF
         * @param {string} id Credit note ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        creditNoteControllerGeneratePdf(id: string, options?: any): AxiosPromise<void> {
            return localVarFp.creditNoteControllerGeneratePdf(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get credit note details (incl. negated line items)
         * @param {string} id Credit note ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        creditNoteControllerGetCreditNote(id: string, options?: any): AxiosPromise<void> {
            return localVarFp.creditNoteControllerGetCreditNote(id, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * CreditNotesApi - object-oriented interface
 * @export
 * @class CreditNotesApi
 * @extends {BaseAPI}
 */
export class CreditNotesApi extends BaseAPI {
    /**
     * 
     * @summary Download the credit note PDF (storno document)
     * @param {string} id Credit note ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CreditNotesApi
     */
    public creditNoteControllerDownload(id: string, options?: AxiosRequestConfig) {
        return CreditNotesApiFp(this.configuration).creditNoteControllerDownload(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Generate (or regenerate) the credit note PDF
     * @param {string} id Credit note ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CreditNotesApi
     */
    public creditNoteControllerGeneratePdf(id: string, options?: AxiosRequestConfig) {
        return CreditNotesApiFp(this.configuration).creditNoteControllerGeneratePdf(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get credit note details (incl. negated line items)
     * @param {string} id Credit note ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CreditNotesApi
     */
    public creditNoteControllerGetCreditNote(id: string, options?: AxiosRequestConfig) {
        return CreditNotesApiFp(this.configuration).creditNoteControllerGetCreditNote(id, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * ElementImageApi - axios parameter creator
 * @export
 */
export const ElementImageApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Create multiple ElementImages
         * @param {CreateManyElementImageDto} createManyElementImageDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createManyBaseElementImageControllerElementImage: async (createManyElementImageDto: CreateManyElementImageDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createManyElementImageDto' is not null or undefined
            assertParamExists('createManyBaseElementImageControllerElementImage', 'createManyElementImageDto', createManyElementImageDto)
            const localVarPath = `/element-image/bulk`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createManyElementImageDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Create a single ElementImage
         * @param {CreateElementImageDto} createElementImageDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createOneBaseElementImageControllerElementImage: async (createElementImageDto: CreateElementImageDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createElementImageDto' is not null or undefined
            assertParamExists('createOneBaseElementImageControllerElementImage', 'createElementImageDto', createElementImageDto)
            const localVarPath = `/element-image`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createElementImageDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Delete a single ElementImage
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOneBaseElementImageControllerElementImage: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('deleteOneBaseElementImageControllerElementImage', 'id', id)
            const localVarPath = `/element-image/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} category 
         * @param {string} type 
         * @param {string} style 
         * @param {string} search 
         * @param {string} limit 
         * @param {string} offset 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        elementImageControllerLibrary: async (category: string, type: string, style: string, search: string, limit: string, offset: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'category' is not null or undefined
            assertParamExists('elementImageControllerLibrary', 'category', category)
            // verify required parameter 'type' is not null or undefined
            assertParamExists('elementImageControllerLibrary', 'type', type)
            // verify required parameter 'style' is not null or undefined
            assertParamExists('elementImageControllerLibrary', 'style', style)
            // verify required parameter 'search' is not null or undefined
            assertParamExists('elementImageControllerLibrary', 'search', search)
            // verify required parameter 'limit' is not null or undefined
            assertParamExists('elementImageControllerLibrary', 'limit', limit)
            // verify required parameter 'offset' is not null or undefined
            assertParamExists('elementImageControllerLibrary', 'offset', offset)
            const localVarPath = `/element-image/library`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (category !== undefined) {
                localVarQueryParameter['category'] = category;
            }

            if (type !== undefined) {
                localVarQueryParameter['type'] = type;
            }

            if (style !== undefined) {
                localVarQueryParameter['style'] = style;
            }

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} key 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        elementImageControllerSignedUrl: async (key: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'key' is not null or undefined
            assertParamExists('elementImageControllerSignedUrl', 'key', key)
            const localVarPath = `/element-image/signed-url`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (key !== undefined) {
                localVarQueryParameter['key'] = key;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        elementImageControllerUpload: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/element-image/upload`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Retrieve multiple ElementImages
         * @param {Array<string>} [fields] Selects resource fields. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#select\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {string} [s] Adds search condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#search\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {Array<string>} [filter] Adds filter condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#filter\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {Array<string>} [or] Adds OR condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#or\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {Array<string>} [sort] Adds sort by field. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#sort\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {Array<string>} [join] Adds relational resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#join\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {number} [limit] Limit amount of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#limit\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {number} [offset] Offset amount of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#offset\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {number} [page] Page portion of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#page\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {number} [cache] Reset cache (if was enabled). &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#cache\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getManyBaseElementImageControllerElementImage: async (fields?: Array<string>, s?: string, filter?: Array<string>, or?: Array<string>, sort?: Array<string>, join?: Array<string>, limit?: number, offset?: number, page?: number, cache?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/element-image`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (fields) {
                localVarQueryParameter['fields'] = fields;
            }

            if (s !== undefined) {
                localVarQueryParameter['s'] = s;
            }

            if (filter) {
                localVarQueryParameter['filter'] = filter;
            }

            if (or) {
                localVarQueryParameter['or'] = or;
            }

            if (sort) {
                localVarQueryParameter['sort'] = sort;
            }

            if (join) {
                localVarQueryParameter['join'] = join;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (cache !== undefined) {
                localVarQueryParameter['cache'] = cache;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Retrieve a single ElementImage
         * @param {string} id 
         * @param {Array<string>} [fields] Selects resource fields. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#select\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {Array<string>} [join] Adds relational resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#join\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {number} [cache] Reset cache (if was enabled). &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#cache\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOneBaseElementImageControllerElementImage: async (id: string, fields?: Array<string>, join?: Array<string>, cache?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getOneBaseElementImageControllerElementImage', 'id', id)
            const localVarPath = `/element-image/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (fields) {
                localVarQueryParameter['fields'] = fields;
            }

            if (join) {
                localVarQueryParameter['join'] = join;
            }

            if (cache !== undefined) {
                localVarQueryParameter['cache'] = cache;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Replace a single ElementImage
         * @param {string} id 
         * @param {UpdateElementImageDto} updateElementImageDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        replaceOneBaseElementImageControllerElementImage: async (id: string, updateElementImageDto: UpdateElementImageDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('replaceOneBaseElementImageControllerElementImage', 'id', id)
            // verify required parameter 'updateElementImageDto' is not null or undefined
            assertParamExists('replaceOneBaseElementImageControllerElementImage', 'updateElementImageDto', updateElementImageDto)
            const localVarPath = `/element-image/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateElementImageDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update a single ElementImage
         * @param {string} id 
         * @param {UpdateElementImageDto} updateElementImageDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateOneBaseElementImageControllerElementImage: async (id: string, updateElementImageDto: UpdateElementImageDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('updateOneBaseElementImageControllerElementImage', 'id', id)
            // verify required parameter 'updateElementImageDto' is not null or undefined
            assertParamExists('updateOneBaseElementImageControllerElementImage', 'updateElementImageDto', updateElementImageDto)
            const localVarPath = `/element-image/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateElementImageDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ElementImageApi - functional programming interface
 * @export
 */
export const ElementImageApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ElementImageApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Create multiple ElementImages
         * @param {CreateManyElementImageDto} createManyElementImageDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createManyBaseElementImageControllerElementImage(createManyElementImageDto: CreateManyElementImageDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<object>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createManyBaseElementImageControllerElementImage(createManyElementImageDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Create a single ElementImage
         * @param {CreateElementImageDto} createElementImageDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createOneBaseElementImageControllerElementImage(createElementImageDto: CreateElementImageDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createOneBaseElementImageControllerElementImage(createElementImageDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Delete a single ElementImage
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteOneBaseElementImageControllerElementImage(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteOneBaseElementImageControllerElementImage(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} category 
         * @param {string} type 
         * @param {string} style 
         * @param {string} search 
         * @param {string} limit 
         * @param {string} offset 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async elementImageControllerLibrary(category: string, type: string, style: string, search: string, limit: string, offset: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.elementImageControllerLibrary(category, type, style, search, limit, offset, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} key 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async elementImageControllerSignedUrl(key: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.elementImageControllerSignedUrl(key, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async elementImageControllerUpload(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.elementImageControllerUpload(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Retrieve multiple ElementImages
         * @param {Array<string>} [fields] Selects resource fields. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#select\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {string} [s] Adds search condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#search\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {Array<string>} [filter] Adds filter condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#filter\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {Array<string>} [or] Adds OR condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#or\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {Array<string>} [sort] Adds sort by field. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#sort\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {Array<string>} [join] Adds relational resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#join\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {number} [limit] Limit amount of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#limit\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {number} [offset] Offset amount of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#offset\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {number} [page] Page portion of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#page\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {number} [cache] Reset cache (if was enabled). &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#cache\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getManyBaseElementImageControllerElementImage(fields?: Array<string>, s?: string, filter?: Array<string>, or?: Array<string>, sort?: Array<string>, join?: Array<string>, limit?: number, offset?: number, page?: number, cache?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetManyElementImageResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getManyBaseElementImageControllerElementImage(fields, s, filter, or, sort, join, limit, offset, page, cache, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Retrieve a single ElementImage
         * @param {string} id 
         * @param {Array<string>} [fields] Selects resource fields. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#select\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {Array<string>} [join] Adds relational resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#join\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {number} [cache] Reset cache (if was enabled). &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#cache\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getOneBaseElementImageControllerElementImage(id: string, fields?: Array<string>, join?: Array<string>, cache?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getOneBaseElementImageControllerElementImage(id, fields, join, cache, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Replace a single ElementImage
         * @param {string} id 
         * @param {UpdateElementImageDto} updateElementImageDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async replaceOneBaseElementImageControllerElementImage(id: string, updateElementImageDto: UpdateElementImageDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.replaceOneBaseElementImageControllerElementImage(id, updateElementImageDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Update a single ElementImage
         * @param {string} id 
         * @param {UpdateElementImageDto} updateElementImageDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateOneBaseElementImageControllerElementImage(id: string, updateElementImageDto: UpdateElementImageDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateOneBaseElementImageControllerElementImage(id, updateElementImageDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * ElementImageApi - factory interface
 * @export
 */
export const ElementImageApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ElementImageApiFp(configuration)
    return {
        /**
         * 
         * @summary Create multiple ElementImages
         * @param {CreateManyElementImageDto} createManyElementImageDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createManyBaseElementImageControllerElementImage(createManyElementImageDto: CreateManyElementImageDto, options?: any): AxiosPromise<Array<object>> {
            return localVarFp.createManyBaseElementImageControllerElementImage(createManyElementImageDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Create a single ElementImage
         * @param {CreateElementImageDto} createElementImageDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createOneBaseElementImageControllerElementImage(createElementImageDto: CreateElementImageDto, options?: any): AxiosPromise<object> {
            return localVarFp.createOneBaseElementImageControllerElementImage(createElementImageDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Delete a single ElementImage
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOneBaseElementImageControllerElementImage(id: string, options?: any): AxiosPromise<object> {
            return localVarFp.deleteOneBaseElementImageControllerElementImage(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} category 
         * @param {string} type 
         * @param {string} style 
         * @param {string} search 
         * @param {string} limit 
         * @param {string} offset 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        elementImageControllerLibrary(category: string, type: string, style: string, search: string, limit: string, offset: string, options?: any): AxiosPromise<void> {
            return localVarFp.elementImageControllerLibrary(category, type, style, search, limit, offset, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} key 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        elementImageControllerSignedUrl(key: string, options?: any): AxiosPromise<void> {
            return localVarFp.elementImageControllerSignedUrl(key, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        elementImageControllerUpload(options?: any): AxiosPromise<void> {
            return localVarFp.elementImageControllerUpload(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Retrieve multiple ElementImages
         * @param {Array<string>} [fields] Selects resource fields. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#select\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {string} [s] Adds search condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#search\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {Array<string>} [filter] Adds filter condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#filter\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {Array<string>} [or] Adds OR condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#or\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {Array<string>} [sort] Adds sort by field. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#sort\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {Array<string>} [join] Adds relational resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#join\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {number} [limit] Limit amount of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#limit\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {number} [offset] Offset amount of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#offset\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {number} [page] Page portion of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#page\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {number} [cache] Reset cache (if was enabled). &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#cache\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getManyBaseElementImageControllerElementImage(fields?: Array<string>, s?: string, filter?: Array<string>, or?: Array<string>, sort?: Array<string>, join?: Array<string>, limit?: number, offset?: number, page?: number, cache?: number, options?: any): AxiosPromise<GetManyElementImageResponseDto> {
            return localVarFp.getManyBaseElementImageControllerElementImage(fields, s, filter, or, sort, join, limit, offset, page, cache, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Retrieve a single ElementImage
         * @param {string} id 
         * @param {Array<string>} [fields] Selects resource fields. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#select\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {Array<string>} [join] Adds relational resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#join\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {number} [cache] Reset cache (if was enabled). &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#cache\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOneBaseElementImageControllerElementImage(id: string, fields?: Array<string>, join?: Array<string>, cache?: number, options?: any): AxiosPromise<object> {
            return localVarFp.getOneBaseElementImageControllerElementImage(id, fields, join, cache, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Replace a single ElementImage
         * @param {string} id 
         * @param {UpdateElementImageDto} updateElementImageDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        replaceOneBaseElementImageControllerElementImage(id: string, updateElementImageDto: UpdateElementImageDto, options?: any): AxiosPromise<object> {
            return localVarFp.replaceOneBaseElementImageControllerElementImage(id, updateElementImageDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update a single ElementImage
         * @param {string} id 
         * @param {UpdateElementImageDto} updateElementImageDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateOneBaseElementImageControllerElementImage(id: string, updateElementImageDto: UpdateElementImageDto, options?: any): AxiosPromise<object> {
            return localVarFp.updateOneBaseElementImageControllerElementImage(id, updateElementImageDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ElementImageApi - object-oriented interface
 * @export
 * @class ElementImageApi
 * @extends {BaseAPI}
 */
export class ElementImageApi extends BaseAPI {
    /**
     * 
     * @summary Create multiple ElementImages
     * @param {CreateManyElementImageDto} createManyElementImageDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ElementImageApi
     */
    public createManyBaseElementImageControllerElementImage(createManyElementImageDto: CreateManyElementImageDto, options?: AxiosRequestConfig) {
        return ElementImageApiFp(this.configuration).createManyBaseElementImageControllerElementImage(createManyElementImageDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Create a single ElementImage
     * @param {CreateElementImageDto} createElementImageDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ElementImageApi
     */
    public createOneBaseElementImageControllerElementImage(createElementImageDto: CreateElementImageDto, options?: AxiosRequestConfig) {
        return ElementImageApiFp(this.configuration).createOneBaseElementImageControllerElementImage(createElementImageDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Delete a single ElementImage
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ElementImageApi
     */
    public deleteOneBaseElementImageControllerElementImage(id: string, options?: AxiosRequestConfig) {
        return ElementImageApiFp(this.configuration).deleteOneBaseElementImageControllerElementImage(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} category 
     * @param {string} type 
     * @param {string} style 
     * @param {string} search 
     * @param {string} limit 
     * @param {string} offset 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ElementImageApi
     */
    public elementImageControllerLibrary(category: string, type: string, style: string, search: string, limit: string, offset: string, options?: AxiosRequestConfig) {
        return ElementImageApiFp(this.configuration).elementImageControllerLibrary(category, type, style, search, limit, offset, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} key 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ElementImageApi
     */
    public elementImageControllerSignedUrl(key: string, options?: AxiosRequestConfig) {
        return ElementImageApiFp(this.configuration).elementImageControllerSignedUrl(key, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ElementImageApi
     */
    public elementImageControllerUpload(options?: AxiosRequestConfig) {
        return ElementImageApiFp(this.configuration).elementImageControllerUpload(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Retrieve multiple ElementImages
     * @param {Array<string>} [fields] Selects resource fields. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#select\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param {string} [s] Adds search condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#search\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param {Array<string>} [filter] Adds filter condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#filter\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param {Array<string>} [or] Adds OR condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#or\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param {Array<string>} [sort] Adds sort by field. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#sort\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param {Array<string>} [join] Adds relational resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#join\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param {number} [limit] Limit amount of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#limit\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param {number} [offset] Offset amount of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#offset\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param {number} [page] Page portion of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#page\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param {number} [cache] Reset cache (if was enabled). &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#cache\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ElementImageApi
     */
    public getManyBaseElementImageControllerElementImage(fields?: Array<string>, s?: string, filter?: Array<string>, or?: Array<string>, sort?: Array<string>, join?: Array<string>, limit?: number, offset?: number, page?: number, cache?: number, options?: AxiosRequestConfig) {
        return ElementImageApiFp(this.configuration).getManyBaseElementImageControllerElementImage(fields, s, filter, or, sort, join, limit, offset, page, cache, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Retrieve a single ElementImage
     * @param {string} id 
     * @param {Array<string>} [fields] Selects resource fields. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#select\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param {Array<string>} [join] Adds relational resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#join\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param {number} [cache] Reset cache (if was enabled). &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#cache\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ElementImageApi
     */
    public getOneBaseElementImageControllerElementImage(id: string, fields?: Array<string>, join?: Array<string>, cache?: number, options?: AxiosRequestConfig) {
        return ElementImageApiFp(this.configuration).getOneBaseElementImageControllerElementImage(id, fields, join, cache, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Replace a single ElementImage
     * @param {string} id 
     * @param {UpdateElementImageDto} updateElementImageDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ElementImageApi
     */
    public replaceOneBaseElementImageControllerElementImage(id: string, updateElementImageDto: UpdateElementImageDto, options?: AxiosRequestConfig) {
        return ElementImageApiFp(this.configuration).replaceOneBaseElementImageControllerElementImage(id, updateElementImageDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update a single ElementImage
     * @param {string} id 
     * @param {UpdateElementImageDto} updateElementImageDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ElementImageApi
     */
    public updateOneBaseElementImageControllerElementImage(id: string, updateElementImageDto: UpdateElementImageDto, options?: AxiosRequestConfig) {
        return ElementImageApiFp(this.configuration).updateOneBaseElementImageControllerElementImage(id, updateElementImageDto, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * EmailCampaignsApi - axios parameter creator
 * @export
 */
export const EmailCampaignsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Can only cancel campaigns with PENDING status
         * @summary Cancel a pending campaign
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        emailCampaignControllerCancelCampaign: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('emailCampaignControllerCancelCampaign', 'id', id)
            const localVarPath = `/email-campaigns/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Creates a new email campaign and starts sending emails in the background. If customMailingList is provided, emails will be sent to those addresses. Otherwise, emails will be extracted from orders in the target country.
         * @summary Create and start a new email campaign
         * @param {CreateEmailCampaignDto} createEmailCampaignDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        emailCampaignControllerCreateCampaign: async (createEmailCampaignDto: CreateEmailCampaignDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createEmailCampaignDto' is not null or undefined
            assertParamExists('emailCampaignControllerCreateCampaign', 'createEmailCampaignDto', createEmailCampaignDto)
            const localVarPath = `/email-campaigns`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createEmailCampaignDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get all email campaigns
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        emailCampaignControllerGetAllCampaigns: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/email-campaigns`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get campaign statistics
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        emailCampaignControllerGetCampaignStats: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/email-campaigns/stats`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get campaign status by ID
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        emailCampaignControllerGetCampaignStatus: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('emailCampaignControllerGetCampaignStatus', 'id', id)
            const localVarPath = `/email-campaigns/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * This endpoint is called when the tracking pixel is loaded in an email. Returns a 1x1 transparent GIF image. NO AUTHENTICATION REQUIRED.
         * @summary Track email open (tracking pixel endpoint)
         * @param {string} campaignId 
         * @param {string} email 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        emailCampaignControllerTrackEmailOpen: async (campaignId: string, email: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'campaignId' is not null or undefined
            assertParamExists('emailCampaignControllerTrackEmailOpen', 'campaignId', campaignId)
            // verify required parameter 'email' is not null or undefined
            assertParamExists('emailCampaignControllerTrackEmailOpen', 'email', email)
            const localVarPath = `/email-campaigns/track/{campaignId}`
                .replace(`{${"campaignId"}}`, encodeURIComponent(String(campaignId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (email !== undefined) {
                localVarQueryParameter['email'] = email;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * EmailCampaignsApi - functional programming interface
 * @export
 */
export const EmailCampaignsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = EmailCampaignsApiAxiosParamCreator(configuration)
    return {
        /**
         * Can only cancel campaigns with PENDING status
         * @summary Cancel a pending campaign
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async emailCampaignControllerCancelCampaign(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.emailCampaignControllerCancelCampaign(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Creates a new email campaign and starts sending emails in the background. If customMailingList is provided, emails will be sent to those addresses. Otherwise, emails will be extracted from orders in the target country.
         * @summary Create and start a new email campaign
         * @param {CreateEmailCampaignDto} createEmailCampaignDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async emailCampaignControllerCreateCampaign(createEmailCampaignDto: CreateEmailCampaignDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.emailCampaignControllerCreateCampaign(createEmailCampaignDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get all email campaigns
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async emailCampaignControllerGetAllCampaigns(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CampaignListResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.emailCampaignControllerGetAllCampaigns(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get campaign statistics
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async emailCampaignControllerGetCampaignStats(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CampaignStatsResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.emailCampaignControllerGetCampaignStats(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get campaign status by ID
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async emailCampaignControllerGetCampaignStatus(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.emailCampaignControllerGetCampaignStatus(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * This endpoint is called when the tracking pixel is loaded in an email. Returns a 1x1 transparent GIF image. NO AUTHENTICATION REQUIRED.
         * @summary Track email open (tracking pixel endpoint)
         * @param {string} campaignId 
         * @param {string} email 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async emailCampaignControllerTrackEmailOpen(campaignId: string, email: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.emailCampaignControllerTrackEmailOpen(campaignId, email, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * EmailCampaignsApi - factory interface
 * @export
 */
export const EmailCampaignsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = EmailCampaignsApiFp(configuration)
    return {
        /**
         * Can only cancel campaigns with PENDING status
         * @summary Cancel a pending campaign
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        emailCampaignControllerCancelCampaign(id: string, options?: any): AxiosPromise<object> {
            return localVarFp.emailCampaignControllerCancelCampaign(id, options).then((request) => request(axios, basePath));
        },
        /**
         * Creates a new email campaign and starts sending emails in the background. If customMailingList is provided, emails will be sent to those addresses. Otherwise, emails will be extracted from orders in the target country.
         * @summary Create and start a new email campaign
         * @param {CreateEmailCampaignDto} createEmailCampaignDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        emailCampaignControllerCreateCampaign(createEmailCampaignDto: CreateEmailCampaignDto, options?: any): AxiosPromise<object> {
            return localVarFp.emailCampaignControllerCreateCampaign(createEmailCampaignDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get all email campaigns
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        emailCampaignControllerGetAllCampaigns(options?: any): AxiosPromise<CampaignListResponseDto> {
            return localVarFp.emailCampaignControllerGetAllCampaigns(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get campaign statistics
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        emailCampaignControllerGetCampaignStats(options?: any): AxiosPromise<CampaignStatsResponseDto> {
            return localVarFp.emailCampaignControllerGetCampaignStats(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get campaign status by ID
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        emailCampaignControllerGetCampaignStatus(id: string, options?: any): AxiosPromise<object> {
            return localVarFp.emailCampaignControllerGetCampaignStatus(id, options).then((request) => request(axios, basePath));
        },
        /**
         * This endpoint is called when the tracking pixel is loaded in an email. Returns a 1x1 transparent GIF image. NO AUTHENTICATION REQUIRED.
         * @summary Track email open (tracking pixel endpoint)
         * @param {string} campaignId 
         * @param {string} email 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        emailCampaignControllerTrackEmailOpen(campaignId: string, email: string, options?: any): AxiosPromise<void> {
            return localVarFp.emailCampaignControllerTrackEmailOpen(campaignId, email, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * EmailCampaignsApi - object-oriented interface
 * @export
 * @class EmailCampaignsApi
 * @extends {BaseAPI}
 */
export class EmailCampaignsApi extends BaseAPI {
    /**
     * Can only cancel campaigns with PENDING status
     * @summary Cancel a pending campaign
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmailCampaignsApi
     */
    public emailCampaignControllerCancelCampaign(id: string, options?: AxiosRequestConfig) {
        return EmailCampaignsApiFp(this.configuration).emailCampaignControllerCancelCampaign(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Creates a new email campaign and starts sending emails in the background. If customMailingList is provided, emails will be sent to those addresses. Otherwise, emails will be extracted from orders in the target country.
     * @summary Create and start a new email campaign
     * @param {CreateEmailCampaignDto} createEmailCampaignDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmailCampaignsApi
     */
    public emailCampaignControllerCreateCampaign(createEmailCampaignDto: CreateEmailCampaignDto, options?: AxiosRequestConfig) {
        return EmailCampaignsApiFp(this.configuration).emailCampaignControllerCreateCampaign(createEmailCampaignDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get all email campaigns
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmailCampaignsApi
     */
    public emailCampaignControllerGetAllCampaigns(options?: AxiosRequestConfig) {
        return EmailCampaignsApiFp(this.configuration).emailCampaignControllerGetAllCampaigns(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get campaign statistics
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmailCampaignsApi
     */
    public emailCampaignControllerGetCampaignStats(options?: AxiosRequestConfig) {
        return EmailCampaignsApiFp(this.configuration).emailCampaignControllerGetCampaignStats(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get campaign status by ID
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmailCampaignsApi
     */
    public emailCampaignControllerGetCampaignStatus(id: string, options?: AxiosRequestConfig) {
        return EmailCampaignsApiFp(this.configuration).emailCampaignControllerGetCampaignStatus(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * This endpoint is called when the tracking pixel is loaded in an email. Returns a 1x1 transparent GIF image. NO AUTHENTICATION REQUIRED.
     * @summary Track email open (tracking pixel endpoint)
     * @param {string} campaignId 
     * @param {string} email 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmailCampaignsApi
     */
    public emailCampaignControllerTrackEmailOpen(campaignId: string, email: string, options?: AxiosRequestConfig) {
        return EmailCampaignsApiFp(this.configuration).emailCampaignControllerTrackEmailOpen(campaignId, email, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * EmailLogApi - axios parameter creator
 * @export
 */
export const EmailLogApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        emailLogControllerBulkDelete: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/email-log/admin/bulk-delete`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Retrieve multiple EmailLogs
         * @param {Array<string>} [fields] Selects resource fields. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#select\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {string} [s] Adds search condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#search\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {Array<string>} [filter] Adds filter condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#filter\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {Array<string>} [or] Adds OR condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#or\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {Array<string>} [sort] Adds sort by field. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#sort\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {Array<string>} [join] Adds relational resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#join\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {number} [limit] Limit amount of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#limit\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {number} [offset] Offset amount of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#offset\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {number} [page] Page portion of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#page\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {number} [cache] Reset cache (if was enabled). &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#cache\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getManyBaseEmailLogControllerEmailLog: async (fields?: Array<string>, s?: string, filter?: Array<string>, or?: Array<string>, sort?: Array<string>, join?: Array<string>, limit?: number, offset?: number, page?: number, cache?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/email-log`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (fields) {
                localVarQueryParameter['fields'] = fields;
            }

            if (s !== undefined) {
                localVarQueryParameter['s'] = s;
            }

            if (filter) {
                localVarQueryParameter['filter'] = filter;
            }

            if (or) {
                localVarQueryParameter['or'] = or;
            }

            if (sort) {
                localVarQueryParameter['sort'] = sort;
            }

            if (join) {
                localVarQueryParameter['join'] = join;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (cache !== undefined) {
                localVarQueryParameter['cache'] = cache;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Retrieve a single EmailLog
         * @param {string} id 
         * @param {Array<string>} [fields] Selects resource fields. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#select\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {Array<string>} [join] Adds relational resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#join\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {number} [cache] Reset cache (if was enabled). &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#cache\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOneBaseEmailLogControllerEmailLog: async (id: string, fields?: Array<string>, join?: Array<string>, cache?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getOneBaseEmailLogControllerEmailLog', 'id', id)
            const localVarPath = `/email-log/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (fields) {
                localVarQueryParameter['fields'] = fields;
            }

            if (join) {
                localVarQueryParameter['join'] = join;
            }

            if (cache !== undefined) {
                localVarQueryParameter['cache'] = cache;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * EmailLogApi - functional programming interface
 * @export
 */
export const EmailLogApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = EmailLogApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async emailLogControllerBulkDelete(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.emailLogControllerBulkDelete(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Retrieve multiple EmailLogs
         * @param {Array<string>} [fields] Selects resource fields. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#select\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {string} [s] Adds search condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#search\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {Array<string>} [filter] Adds filter condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#filter\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {Array<string>} [or] Adds OR condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#or\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {Array<string>} [sort] Adds sort by field. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#sort\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {Array<string>} [join] Adds relational resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#join\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {number} [limit] Limit amount of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#limit\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {number} [offset] Offset amount of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#offset\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {number} [page] Page portion of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#page\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {number} [cache] Reset cache (if was enabled). &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#cache\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getManyBaseEmailLogControllerEmailLog(fields?: Array<string>, s?: string, filter?: Array<string>, or?: Array<string>, sort?: Array<string>, join?: Array<string>, limit?: number, offset?: number, page?: number, cache?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetManyEmailLogResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getManyBaseEmailLogControllerEmailLog(fields, s, filter, or, sort, join, limit, offset, page, cache, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Retrieve a single EmailLog
         * @param {string} id 
         * @param {Array<string>} [fields] Selects resource fields. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#select\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {Array<string>} [join] Adds relational resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#join\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {number} [cache] Reset cache (if was enabled). &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#cache\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getOneBaseEmailLogControllerEmailLog(id: string, fields?: Array<string>, join?: Array<string>, cache?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getOneBaseEmailLogControllerEmailLog(id, fields, join, cache, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * EmailLogApi - factory interface
 * @export
 */
export const EmailLogApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = EmailLogApiFp(configuration)
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        emailLogControllerBulkDelete(options?: any): AxiosPromise<void> {
            return localVarFp.emailLogControllerBulkDelete(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Retrieve multiple EmailLogs
         * @param {Array<string>} [fields] Selects resource fields. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#select\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {string} [s] Adds search condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#search\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {Array<string>} [filter] Adds filter condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#filter\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {Array<string>} [or] Adds OR condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#or\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {Array<string>} [sort] Adds sort by field. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#sort\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {Array<string>} [join] Adds relational resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#join\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {number} [limit] Limit amount of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#limit\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {number} [offset] Offset amount of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#offset\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {number} [page] Page portion of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#page\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {number} [cache] Reset cache (if was enabled). &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#cache\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getManyBaseEmailLogControllerEmailLog(fields?: Array<string>, s?: string, filter?: Array<string>, or?: Array<string>, sort?: Array<string>, join?: Array<string>, limit?: number, offset?: number, page?: number, cache?: number, options?: any): AxiosPromise<GetManyEmailLogResponseDto> {
            return localVarFp.getManyBaseEmailLogControllerEmailLog(fields, s, filter, or, sort, join, limit, offset, page, cache, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Retrieve a single EmailLog
         * @param {string} id 
         * @param {Array<string>} [fields] Selects resource fields. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#select\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {Array<string>} [join] Adds relational resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#join\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {number} [cache] Reset cache (if was enabled). &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#cache\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOneBaseEmailLogControllerEmailLog(id: string, fields?: Array<string>, join?: Array<string>, cache?: number, options?: any): AxiosPromise<object> {
            return localVarFp.getOneBaseEmailLogControllerEmailLog(id, fields, join, cache, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * EmailLogApi - object-oriented interface
 * @export
 * @class EmailLogApi
 * @extends {BaseAPI}
 */
export class EmailLogApi extends BaseAPI {
    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmailLogApi
     */
    public emailLogControllerBulkDelete(options?: AxiosRequestConfig) {
        return EmailLogApiFp(this.configuration).emailLogControllerBulkDelete(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Retrieve multiple EmailLogs
     * @param {Array<string>} [fields] Selects resource fields. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#select\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param {string} [s] Adds search condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#search\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param {Array<string>} [filter] Adds filter condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#filter\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param {Array<string>} [or] Adds OR condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#or\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param {Array<string>} [sort] Adds sort by field. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#sort\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param {Array<string>} [join] Adds relational resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#join\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param {number} [limit] Limit amount of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#limit\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param {number} [offset] Offset amount of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#offset\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param {number} [page] Page portion of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#page\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param {number} [cache] Reset cache (if was enabled). &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#cache\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmailLogApi
     */
    public getManyBaseEmailLogControllerEmailLog(fields?: Array<string>, s?: string, filter?: Array<string>, or?: Array<string>, sort?: Array<string>, join?: Array<string>, limit?: number, offset?: number, page?: number, cache?: number, options?: AxiosRequestConfig) {
        return EmailLogApiFp(this.configuration).getManyBaseEmailLogControllerEmailLog(fields, s, filter, or, sort, join, limit, offset, page, cache, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Retrieve a single EmailLog
     * @param {string} id 
     * @param {Array<string>} [fields] Selects resource fields. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#select\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param {Array<string>} [join] Adds relational resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#join\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param {number} [cache] Reset cache (if was enabled). &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#cache\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmailLogApi
     */
    public getOneBaseEmailLogControllerEmailLog(id: string, fields?: Array<string>, join?: Array<string>, cache?: number, options?: AxiosRequestConfig) {
        return EmailLogApiFp(this.configuration).getOneBaseEmailLogControllerEmailLog(id, fields, join, cache, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * EmailRuleApi - axios parameter creator
 * @export
 */
export const EmailRuleApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Create multiple EmailRules
         * @param {CreateManyEmailRuleDto} createManyEmailRuleDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createManyBaseEmailRuleControllerEmailRule: async (createManyEmailRuleDto: CreateManyEmailRuleDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createManyEmailRuleDto' is not null or undefined
            assertParamExists('createManyBaseEmailRuleControllerEmailRule', 'createManyEmailRuleDto', createManyEmailRuleDto)
            const localVarPath = `/email-rule/bulk`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createManyEmailRuleDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Create a single EmailRule
         * @param {CreateEmailRuleDto} createEmailRuleDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createOneBaseEmailRuleControllerEmailRule: async (createEmailRuleDto: CreateEmailRuleDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createEmailRuleDto' is not null or undefined
            assertParamExists('createOneBaseEmailRuleControllerEmailRule', 'createEmailRuleDto', createEmailRuleDto)
            const localVarPath = `/email-rule`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createEmailRuleDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Delete a single EmailRule
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOneBaseEmailRuleControllerEmailRule: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('deleteOneBaseEmailRuleControllerEmailRule', 'id', id)
            const localVarPath = `/email-rule/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Admin: dry-run preview — show which orders would receive this rule on next tick
         * @param {string} id Email Rule ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        emailRuleControllerPreviewRule: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('emailRuleControllerPreviewRule', 'id', id)
            const localVarPath = `/email-rule/{id}/admin/preview`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Admin: run a specific rule once (regardless of active flag)
         * @param {string} id Email Rule ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        emailRuleControllerRunRule: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('emailRuleControllerRunRule', 'id', id)
            const localVarPath = `/email-rule/{id}/admin/run`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Admin: run all active rules now (one-shot tick, does not wait for cron)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        emailRuleControllerRunTickNow: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/email-rule/admin/run-tick`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Retrieve multiple EmailRules
         * @param {Array<string>} [fields] Selects resource fields. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#select\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {string} [s] Adds search condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#search\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {Array<string>} [filter] Adds filter condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#filter\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {Array<string>} [or] Adds OR condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#or\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {Array<string>} [sort] Adds sort by field. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#sort\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {Array<string>} [join] Adds relational resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#join\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {number} [limit] Limit amount of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#limit\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {number} [offset] Offset amount of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#offset\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {number} [page] Page portion of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#page\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {number} [cache] Reset cache (if was enabled). &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#cache\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getManyBaseEmailRuleControllerEmailRule: async (fields?: Array<string>, s?: string, filter?: Array<string>, or?: Array<string>, sort?: Array<string>, join?: Array<string>, limit?: number, offset?: number, page?: number, cache?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/email-rule`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (fields) {
                localVarQueryParameter['fields'] = fields;
            }

            if (s !== undefined) {
                localVarQueryParameter['s'] = s;
            }

            if (filter) {
                localVarQueryParameter['filter'] = filter;
            }

            if (or) {
                localVarQueryParameter['or'] = or;
            }

            if (sort) {
                localVarQueryParameter['sort'] = sort;
            }

            if (join) {
                localVarQueryParameter['join'] = join;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (cache !== undefined) {
                localVarQueryParameter['cache'] = cache;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Retrieve a single EmailRule
         * @param {string} id 
         * @param {Array<string>} [fields] Selects resource fields. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#select\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {Array<string>} [join] Adds relational resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#join\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {number} [cache] Reset cache (if was enabled). &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#cache\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOneBaseEmailRuleControllerEmailRule: async (id: string, fields?: Array<string>, join?: Array<string>, cache?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getOneBaseEmailRuleControllerEmailRule', 'id', id)
            const localVarPath = `/email-rule/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (fields) {
                localVarQueryParameter['fields'] = fields;
            }

            if (join) {
                localVarQueryParameter['join'] = join;
            }

            if (cache !== undefined) {
                localVarQueryParameter['cache'] = cache;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Replace a single EmailRule
         * @param {string} id 
         * @param {UpdateEmailRuleDto} updateEmailRuleDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        replaceOneBaseEmailRuleControllerEmailRule: async (id: string, updateEmailRuleDto: UpdateEmailRuleDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('replaceOneBaseEmailRuleControllerEmailRule', 'id', id)
            // verify required parameter 'updateEmailRuleDto' is not null or undefined
            assertParamExists('replaceOneBaseEmailRuleControllerEmailRule', 'updateEmailRuleDto', updateEmailRuleDto)
            const localVarPath = `/email-rule/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateEmailRuleDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update a single EmailRule
         * @param {string} id 
         * @param {UpdateEmailRuleDto} updateEmailRuleDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateOneBaseEmailRuleControllerEmailRule: async (id: string, updateEmailRuleDto: UpdateEmailRuleDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('updateOneBaseEmailRuleControllerEmailRule', 'id', id)
            // verify required parameter 'updateEmailRuleDto' is not null or undefined
            assertParamExists('updateOneBaseEmailRuleControllerEmailRule', 'updateEmailRuleDto', updateEmailRuleDto)
            const localVarPath = `/email-rule/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateEmailRuleDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * EmailRuleApi - functional programming interface
 * @export
 */
export const EmailRuleApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = EmailRuleApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Create multiple EmailRules
         * @param {CreateManyEmailRuleDto} createManyEmailRuleDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createManyBaseEmailRuleControllerEmailRule(createManyEmailRuleDto: CreateManyEmailRuleDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<object>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createManyBaseEmailRuleControllerEmailRule(createManyEmailRuleDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Create a single EmailRule
         * @param {CreateEmailRuleDto} createEmailRuleDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createOneBaseEmailRuleControllerEmailRule(createEmailRuleDto: CreateEmailRuleDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createOneBaseEmailRuleControllerEmailRule(createEmailRuleDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Delete a single EmailRule
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteOneBaseEmailRuleControllerEmailRule(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteOneBaseEmailRuleControllerEmailRule(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Admin: dry-run preview — show which orders would receive this rule on next tick
         * @param {string} id Email Rule ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async emailRuleControllerPreviewRule(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.emailRuleControllerPreviewRule(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Admin: run a specific rule once (regardless of active flag)
         * @param {string} id Email Rule ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async emailRuleControllerRunRule(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.emailRuleControllerRunRule(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Admin: run all active rules now (one-shot tick, does not wait for cron)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async emailRuleControllerRunTickNow(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.emailRuleControllerRunTickNow(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Retrieve multiple EmailRules
         * @param {Array<string>} [fields] Selects resource fields. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#select\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {string} [s] Adds search condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#search\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {Array<string>} [filter] Adds filter condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#filter\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {Array<string>} [or] Adds OR condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#or\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {Array<string>} [sort] Adds sort by field. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#sort\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {Array<string>} [join] Adds relational resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#join\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {number} [limit] Limit amount of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#limit\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {number} [offset] Offset amount of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#offset\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {number} [page] Page portion of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#page\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {number} [cache] Reset cache (if was enabled). &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#cache\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getManyBaseEmailRuleControllerEmailRule(fields?: Array<string>, s?: string, filter?: Array<string>, or?: Array<string>, sort?: Array<string>, join?: Array<string>, limit?: number, offset?: number, page?: number, cache?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetManyEmailRuleResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getManyBaseEmailRuleControllerEmailRule(fields, s, filter, or, sort, join, limit, offset, page, cache, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Retrieve a single EmailRule
         * @param {string} id 
         * @param {Array<string>} [fields] Selects resource fields. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#select\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {Array<string>} [join] Adds relational resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#join\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {number} [cache] Reset cache (if was enabled). &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#cache\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getOneBaseEmailRuleControllerEmailRule(id: string, fields?: Array<string>, join?: Array<string>, cache?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getOneBaseEmailRuleControllerEmailRule(id, fields, join, cache, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Replace a single EmailRule
         * @param {string} id 
         * @param {UpdateEmailRuleDto} updateEmailRuleDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async replaceOneBaseEmailRuleControllerEmailRule(id: string, updateEmailRuleDto: UpdateEmailRuleDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.replaceOneBaseEmailRuleControllerEmailRule(id, updateEmailRuleDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Update a single EmailRule
         * @param {string} id 
         * @param {UpdateEmailRuleDto} updateEmailRuleDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateOneBaseEmailRuleControllerEmailRule(id: string, updateEmailRuleDto: UpdateEmailRuleDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateOneBaseEmailRuleControllerEmailRule(id, updateEmailRuleDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * EmailRuleApi - factory interface
 * @export
 */
export const EmailRuleApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = EmailRuleApiFp(configuration)
    return {
        /**
         * 
         * @summary Create multiple EmailRules
         * @param {CreateManyEmailRuleDto} createManyEmailRuleDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createManyBaseEmailRuleControllerEmailRule(createManyEmailRuleDto: CreateManyEmailRuleDto, options?: any): AxiosPromise<Array<object>> {
            return localVarFp.createManyBaseEmailRuleControllerEmailRule(createManyEmailRuleDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Create a single EmailRule
         * @param {CreateEmailRuleDto} createEmailRuleDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createOneBaseEmailRuleControllerEmailRule(createEmailRuleDto: CreateEmailRuleDto, options?: any): AxiosPromise<object> {
            return localVarFp.createOneBaseEmailRuleControllerEmailRule(createEmailRuleDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Delete a single EmailRule
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOneBaseEmailRuleControllerEmailRule(id: string, options?: any): AxiosPromise<object> {
            return localVarFp.deleteOneBaseEmailRuleControllerEmailRule(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Admin: dry-run preview — show which orders would receive this rule on next tick
         * @param {string} id Email Rule ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        emailRuleControllerPreviewRule(id: string, options?: any): AxiosPromise<void> {
            return localVarFp.emailRuleControllerPreviewRule(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Admin: run a specific rule once (regardless of active flag)
         * @param {string} id Email Rule ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        emailRuleControllerRunRule(id: string, options?: any): AxiosPromise<void> {
            return localVarFp.emailRuleControllerRunRule(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Admin: run all active rules now (one-shot tick, does not wait for cron)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        emailRuleControllerRunTickNow(options?: any): AxiosPromise<void> {
            return localVarFp.emailRuleControllerRunTickNow(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Retrieve multiple EmailRules
         * @param {Array<string>} [fields] Selects resource fields. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#select\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {string} [s] Adds search condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#search\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {Array<string>} [filter] Adds filter condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#filter\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {Array<string>} [or] Adds OR condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#or\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {Array<string>} [sort] Adds sort by field. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#sort\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {Array<string>} [join] Adds relational resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#join\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {number} [limit] Limit amount of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#limit\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {number} [offset] Offset amount of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#offset\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {number} [page] Page portion of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#page\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {number} [cache] Reset cache (if was enabled). &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#cache\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getManyBaseEmailRuleControllerEmailRule(fields?: Array<string>, s?: string, filter?: Array<string>, or?: Array<string>, sort?: Array<string>, join?: Array<string>, limit?: number, offset?: number, page?: number, cache?: number, options?: any): AxiosPromise<GetManyEmailRuleResponseDto> {
            return localVarFp.getManyBaseEmailRuleControllerEmailRule(fields, s, filter, or, sort, join, limit, offset, page, cache, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Retrieve a single EmailRule
         * @param {string} id 
         * @param {Array<string>} [fields] Selects resource fields. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#select\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {Array<string>} [join] Adds relational resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#join\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {number} [cache] Reset cache (if was enabled). &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#cache\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOneBaseEmailRuleControllerEmailRule(id: string, fields?: Array<string>, join?: Array<string>, cache?: number, options?: any): AxiosPromise<object> {
            return localVarFp.getOneBaseEmailRuleControllerEmailRule(id, fields, join, cache, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Replace a single EmailRule
         * @param {string} id 
         * @param {UpdateEmailRuleDto} updateEmailRuleDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        replaceOneBaseEmailRuleControllerEmailRule(id: string, updateEmailRuleDto: UpdateEmailRuleDto, options?: any): AxiosPromise<object> {
            return localVarFp.replaceOneBaseEmailRuleControllerEmailRule(id, updateEmailRuleDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update a single EmailRule
         * @param {string} id 
         * @param {UpdateEmailRuleDto} updateEmailRuleDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateOneBaseEmailRuleControllerEmailRule(id: string, updateEmailRuleDto: UpdateEmailRuleDto, options?: any): AxiosPromise<object> {
            return localVarFp.updateOneBaseEmailRuleControllerEmailRule(id, updateEmailRuleDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * EmailRuleApi - object-oriented interface
 * @export
 * @class EmailRuleApi
 * @extends {BaseAPI}
 */
export class EmailRuleApi extends BaseAPI {
    /**
     * 
     * @summary Create multiple EmailRules
     * @param {CreateManyEmailRuleDto} createManyEmailRuleDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmailRuleApi
     */
    public createManyBaseEmailRuleControllerEmailRule(createManyEmailRuleDto: CreateManyEmailRuleDto, options?: AxiosRequestConfig) {
        return EmailRuleApiFp(this.configuration).createManyBaseEmailRuleControllerEmailRule(createManyEmailRuleDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Create a single EmailRule
     * @param {CreateEmailRuleDto} createEmailRuleDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmailRuleApi
     */
    public createOneBaseEmailRuleControllerEmailRule(createEmailRuleDto: CreateEmailRuleDto, options?: AxiosRequestConfig) {
        return EmailRuleApiFp(this.configuration).createOneBaseEmailRuleControllerEmailRule(createEmailRuleDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Delete a single EmailRule
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmailRuleApi
     */
    public deleteOneBaseEmailRuleControllerEmailRule(id: string, options?: AxiosRequestConfig) {
        return EmailRuleApiFp(this.configuration).deleteOneBaseEmailRuleControllerEmailRule(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Admin: dry-run preview — show which orders would receive this rule on next tick
     * @param {string} id Email Rule ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmailRuleApi
     */
    public emailRuleControllerPreviewRule(id: string, options?: AxiosRequestConfig) {
        return EmailRuleApiFp(this.configuration).emailRuleControllerPreviewRule(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Admin: run a specific rule once (regardless of active flag)
     * @param {string} id Email Rule ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmailRuleApi
     */
    public emailRuleControllerRunRule(id: string, options?: AxiosRequestConfig) {
        return EmailRuleApiFp(this.configuration).emailRuleControllerRunRule(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Admin: run all active rules now (one-shot tick, does not wait for cron)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmailRuleApi
     */
    public emailRuleControllerRunTickNow(options?: AxiosRequestConfig) {
        return EmailRuleApiFp(this.configuration).emailRuleControllerRunTickNow(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Retrieve multiple EmailRules
     * @param {Array<string>} [fields] Selects resource fields. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#select\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param {string} [s] Adds search condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#search\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param {Array<string>} [filter] Adds filter condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#filter\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param {Array<string>} [or] Adds OR condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#or\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param {Array<string>} [sort] Adds sort by field. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#sort\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param {Array<string>} [join] Adds relational resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#join\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param {number} [limit] Limit amount of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#limit\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param {number} [offset] Offset amount of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#offset\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param {number} [page] Page portion of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#page\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param {number} [cache] Reset cache (if was enabled). &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#cache\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmailRuleApi
     */
    public getManyBaseEmailRuleControllerEmailRule(fields?: Array<string>, s?: string, filter?: Array<string>, or?: Array<string>, sort?: Array<string>, join?: Array<string>, limit?: number, offset?: number, page?: number, cache?: number, options?: AxiosRequestConfig) {
        return EmailRuleApiFp(this.configuration).getManyBaseEmailRuleControllerEmailRule(fields, s, filter, or, sort, join, limit, offset, page, cache, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Retrieve a single EmailRule
     * @param {string} id 
     * @param {Array<string>} [fields] Selects resource fields. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#select\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param {Array<string>} [join] Adds relational resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#join\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param {number} [cache] Reset cache (if was enabled). &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#cache\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmailRuleApi
     */
    public getOneBaseEmailRuleControllerEmailRule(id: string, fields?: Array<string>, join?: Array<string>, cache?: number, options?: AxiosRequestConfig) {
        return EmailRuleApiFp(this.configuration).getOneBaseEmailRuleControllerEmailRule(id, fields, join, cache, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Replace a single EmailRule
     * @param {string} id 
     * @param {UpdateEmailRuleDto} updateEmailRuleDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmailRuleApi
     */
    public replaceOneBaseEmailRuleControllerEmailRule(id: string, updateEmailRuleDto: UpdateEmailRuleDto, options?: AxiosRequestConfig) {
        return EmailRuleApiFp(this.configuration).replaceOneBaseEmailRuleControllerEmailRule(id, updateEmailRuleDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update a single EmailRule
     * @param {string} id 
     * @param {UpdateEmailRuleDto} updateEmailRuleDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmailRuleApi
     */
    public updateOneBaseEmailRuleControllerEmailRule(id: string, updateEmailRuleDto: UpdateEmailRuleDto, options?: AxiosRequestConfig) {
        return EmailRuleApiFp(this.configuration).updateOneBaseEmailRuleControllerEmailRule(id, updateEmailRuleDto, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * EmailTemplateApi - axios parameter creator
 * @export
 */
export const EmailTemplateApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Create multiple EmailTemplates
         * @param {CreateManyEmailTemplateDto} createManyEmailTemplateDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createManyBaseEmailTemplateControllerEmailTemplate: async (createManyEmailTemplateDto: CreateManyEmailTemplateDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createManyEmailTemplateDto' is not null or undefined
            assertParamExists('createManyBaseEmailTemplateControllerEmailTemplate', 'createManyEmailTemplateDto', createManyEmailTemplateDto)
            const localVarPath = `/email-template/bulk`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createManyEmailTemplateDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Create a single EmailTemplate
         * @param {CreateEmailTemplateDto} createEmailTemplateDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createOneBaseEmailTemplateControllerEmailTemplate: async (createEmailTemplateDto: CreateEmailTemplateDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createEmailTemplateDto' is not null or undefined
            assertParamExists('createOneBaseEmailTemplateControllerEmailTemplate', 'createEmailTemplateDto', createEmailTemplateDto)
            const localVarPath = `/email-template`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createEmailTemplateDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Delete a single EmailTemplate
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOneBaseEmailTemplateControllerEmailTemplate: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('deleteOneBaseEmailTemplateControllerEmailTemplate', 'id', id)
            const localVarPath = `/email-template/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        emailTemplateControllerPreview: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/email-template/preview`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        emailTemplateControllerTestSend: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('emailTemplateControllerTestSend', 'id', id)
            const localVarPath = `/email-template/{id}/admin/test-send`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Retrieve multiple EmailTemplates
         * @param {Array<string>} [fields] Selects resource fields. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#select\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {string} [s] Adds search condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#search\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {Array<string>} [filter] Adds filter condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#filter\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {Array<string>} [or] Adds OR condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#or\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {Array<string>} [sort] Adds sort by field. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#sort\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {Array<string>} [join] Adds relational resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#join\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {number} [limit] Limit amount of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#limit\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {number} [offset] Offset amount of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#offset\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {number} [page] Page portion of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#page\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {number} [cache] Reset cache (if was enabled). &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#cache\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getManyBaseEmailTemplateControllerEmailTemplate: async (fields?: Array<string>, s?: string, filter?: Array<string>, or?: Array<string>, sort?: Array<string>, join?: Array<string>, limit?: number, offset?: number, page?: number, cache?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/email-template`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (fields) {
                localVarQueryParameter['fields'] = fields;
            }

            if (s !== undefined) {
                localVarQueryParameter['s'] = s;
            }

            if (filter) {
                localVarQueryParameter['filter'] = filter;
            }

            if (or) {
                localVarQueryParameter['or'] = or;
            }

            if (sort) {
                localVarQueryParameter['sort'] = sort;
            }

            if (join) {
                localVarQueryParameter['join'] = join;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (cache !== undefined) {
                localVarQueryParameter['cache'] = cache;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Retrieve a single EmailTemplate
         * @param {string} id 
         * @param {Array<string>} [fields] Selects resource fields. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#select\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {Array<string>} [join] Adds relational resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#join\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {number} [cache] Reset cache (if was enabled). &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#cache\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOneBaseEmailTemplateControllerEmailTemplate: async (id: string, fields?: Array<string>, join?: Array<string>, cache?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getOneBaseEmailTemplateControllerEmailTemplate', 'id', id)
            const localVarPath = `/email-template/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (fields) {
                localVarQueryParameter['fields'] = fields;
            }

            if (join) {
                localVarQueryParameter['join'] = join;
            }

            if (cache !== undefined) {
                localVarQueryParameter['cache'] = cache;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Replace a single EmailTemplate
         * @param {string} id 
         * @param {UpdateEmailTemplateDto} updateEmailTemplateDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        replaceOneBaseEmailTemplateControllerEmailTemplate: async (id: string, updateEmailTemplateDto: UpdateEmailTemplateDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('replaceOneBaseEmailTemplateControllerEmailTemplate', 'id', id)
            // verify required parameter 'updateEmailTemplateDto' is not null or undefined
            assertParamExists('replaceOneBaseEmailTemplateControllerEmailTemplate', 'updateEmailTemplateDto', updateEmailTemplateDto)
            const localVarPath = `/email-template/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateEmailTemplateDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update a single EmailTemplate
         * @param {string} id 
         * @param {UpdateEmailTemplateDto} updateEmailTemplateDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateOneBaseEmailTemplateControllerEmailTemplate: async (id: string, updateEmailTemplateDto: UpdateEmailTemplateDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('updateOneBaseEmailTemplateControllerEmailTemplate', 'id', id)
            // verify required parameter 'updateEmailTemplateDto' is not null or undefined
            assertParamExists('updateOneBaseEmailTemplateControllerEmailTemplate', 'updateEmailTemplateDto', updateEmailTemplateDto)
            const localVarPath = `/email-template/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateEmailTemplateDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * EmailTemplateApi - functional programming interface
 * @export
 */
export const EmailTemplateApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = EmailTemplateApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Create multiple EmailTemplates
         * @param {CreateManyEmailTemplateDto} createManyEmailTemplateDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createManyBaseEmailTemplateControllerEmailTemplate(createManyEmailTemplateDto: CreateManyEmailTemplateDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<object>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createManyBaseEmailTemplateControllerEmailTemplate(createManyEmailTemplateDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Create a single EmailTemplate
         * @param {CreateEmailTemplateDto} createEmailTemplateDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createOneBaseEmailTemplateControllerEmailTemplate(createEmailTemplateDto: CreateEmailTemplateDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createOneBaseEmailTemplateControllerEmailTemplate(createEmailTemplateDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Delete a single EmailTemplate
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteOneBaseEmailTemplateControllerEmailTemplate(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteOneBaseEmailTemplateControllerEmailTemplate(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async emailTemplateControllerPreview(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.emailTemplateControllerPreview(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async emailTemplateControllerTestSend(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.emailTemplateControllerTestSend(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Retrieve multiple EmailTemplates
         * @param {Array<string>} [fields] Selects resource fields. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#select\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {string} [s] Adds search condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#search\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {Array<string>} [filter] Adds filter condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#filter\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {Array<string>} [or] Adds OR condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#or\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {Array<string>} [sort] Adds sort by field. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#sort\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {Array<string>} [join] Adds relational resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#join\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {number} [limit] Limit amount of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#limit\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {number} [offset] Offset amount of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#offset\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {number} [page] Page portion of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#page\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {number} [cache] Reset cache (if was enabled). &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#cache\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getManyBaseEmailTemplateControllerEmailTemplate(fields?: Array<string>, s?: string, filter?: Array<string>, or?: Array<string>, sort?: Array<string>, join?: Array<string>, limit?: number, offset?: number, page?: number, cache?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetManyEmailTemplateResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getManyBaseEmailTemplateControllerEmailTemplate(fields, s, filter, or, sort, join, limit, offset, page, cache, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Retrieve a single EmailTemplate
         * @param {string} id 
         * @param {Array<string>} [fields] Selects resource fields. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#select\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {Array<string>} [join] Adds relational resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#join\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {number} [cache] Reset cache (if was enabled). &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#cache\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getOneBaseEmailTemplateControllerEmailTemplate(id: string, fields?: Array<string>, join?: Array<string>, cache?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getOneBaseEmailTemplateControllerEmailTemplate(id, fields, join, cache, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Replace a single EmailTemplate
         * @param {string} id 
         * @param {UpdateEmailTemplateDto} updateEmailTemplateDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async replaceOneBaseEmailTemplateControllerEmailTemplate(id: string, updateEmailTemplateDto: UpdateEmailTemplateDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.replaceOneBaseEmailTemplateControllerEmailTemplate(id, updateEmailTemplateDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Update a single EmailTemplate
         * @param {string} id 
         * @param {UpdateEmailTemplateDto} updateEmailTemplateDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateOneBaseEmailTemplateControllerEmailTemplate(id: string, updateEmailTemplateDto: UpdateEmailTemplateDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateOneBaseEmailTemplateControllerEmailTemplate(id, updateEmailTemplateDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * EmailTemplateApi - factory interface
 * @export
 */
export const EmailTemplateApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = EmailTemplateApiFp(configuration)
    return {
        /**
         * 
         * @summary Create multiple EmailTemplates
         * @param {CreateManyEmailTemplateDto} createManyEmailTemplateDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createManyBaseEmailTemplateControllerEmailTemplate(createManyEmailTemplateDto: CreateManyEmailTemplateDto, options?: any): AxiosPromise<Array<object>> {
            return localVarFp.createManyBaseEmailTemplateControllerEmailTemplate(createManyEmailTemplateDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Create a single EmailTemplate
         * @param {CreateEmailTemplateDto} createEmailTemplateDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createOneBaseEmailTemplateControllerEmailTemplate(createEmailTemplateDto: CreateEmailTemplateDto, options?: any): AxiosPromise<object> {
            return localVarFp.createOneBaseEmailTemplateControllerEmailTemplate(createEmailTemplateDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Delete a single EmailTemplate
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOneBaseEmailTemplateControllerEmailTemplate(id: string, options?: any): AxiosPromise<object> {
            return localVarFp.deleteOneBaseEmailTemplateControllerEmailTemplate(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        emailTemplateControllerPreview(options?: any): AxiosPromise<void> {
            return localVarFp.emailTemplateControllerPreview(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        emailTemplateControllerTestSend(id: string, options?: any): AxiosPromise<void> {
            return localVarFp.emailTemplateControllerTestSend(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Retrieve multiple EmailTemplates
         * @param {Array<string>} [fields] Selects resource fields. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#select\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {string} [s] Adds search condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#search\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {Array<string>} [filter] Adds filter condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#filter\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {Array<string>} [or] Adds OR condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#or\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {Array<string>} [sort] Adds sort by field. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#sort\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {Array<string>} [join] Adds relational resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#join\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {number} [limit] Limit amount of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#limit\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {number} [offset] Offset amount of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#offset\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {number} [page] Page portion of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#page\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {number} [cache] Reset cache (if was enabled). &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#cache\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getManyBaseEmailTemplateControllerEmailTemplate(fields?: Array<string>, s?: string, filter?: Array<string>, or?: Array<string>, sort?: Array<string>, join?: Array<string>, limit?: number, offset?: number, page?: number, cache?: number, options?: any): AxiosPromise<GetManyEmailTemplateResponseDto> {
            return localVarFp.getManyBaseEmailTemplateControllerEmailTemplate(fields, s, filter, or, sort, join, limit, offset, page, cache, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Retrieve a single EmailTemplate
         * @param {string} id 
         * @param {Array<string>} [fields] Selects resource fields. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#select\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {Array<string>} [join] Adds relational resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#join\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {number} [cache] Reset cache (if was enabled). &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#cache\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOneBaseEmailTemplateControllerEmailTemplate(id: string, fields?: Array<string>, join?: Array<string>, cache?: number, options?: any): AxiosPromise<object> {
            return localVarFp.getOneBaseEmailTemplateControllerEmailTemplate(id, fields, join, cache, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Replace a single EmailTemplate
         * @param {string} id 
         * @param {UpdateEmailTemplateDto} updateEmailTemplateDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        replaceOneBaseEmailTemplateControllerEmailTemplate(id: string, updateEmailTemplateDto: UpdateEmailTemplateDto, options?: any): AxiosPromise<object> {
            return localVarFp.replaceOneBaseEmailTemplateControllerEmailTemplate(id, updateEmailTemplateDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update a single EmailTemplate
         * @param {string} id 
         * @param {UpdateEmailTemplateDto} updateEmailTemplateDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateOneBaseEmailTemplateControllerEmailTemplate(id: string, updateEmailTemplateDto: UpdateEmailTemplateDto, options?: any): AxiosPromise<object> {
            return localVarFp.updateOneBaseEmailTemplateControllerEmailTemplate(id, updateEmailTemplateDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * EmailTemplateApi - object-oriented interface
 * @export
 * @class EmailTemplateApi
 * @extends {BaseAPI}
 */
export class EmailTemplateApi extends BaseAPI {
    /**
     * 
     * @summary Create multiple EmailTemplates
     * @param {CreateManyEmailTemplateDto} createManyEmailTemplateDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmailTemplateApi
     */
    public createManyBaseEmailTemplateControllerEmailTemplate(createManyEmailTemplateDto: CreateManyEmailTemplateDto, options?: AxiosRequestConfig) {
        return EmailTemplateApiFp(this.configuration).createManyBaseEmailTemplateControllerEmailTemplate(createManyEmailTemplateDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Create a single EmailTemplate
     * @param {CreateEmailTemplateDto} createEmailTemplateDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmailTemplateApi
     */
    public createOneBaseEmailTemplateControllerEmailTemplate(createEmailTemplateDto: CreateEmailTemplateDto, options?: AxiosRequestConfig) {
        return EmailTemplateApiFp(this.configuration).createOneBaseEmailTemplateControllerEmailTemplate(createEmailTemplateDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Delete a single EmailTemplate
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmailTemplateApi
     */
    public deleteOneBaseEmailTemplateControllerEmailTemplate(id: string, options?: AxiosRequestConfig) {
        return EmailTemplateApiFp(this.configuration).deleteOneBaseEmailTemplateControllerEmailTemplate(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmailTemplateApi
     */
    public emailTemplateControllerPreview(options?: AxiosRequestConfig) {
        return EmailTemplateApiFp(this.configuration).emailTemplateControllerPreview(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmailTemplateApi
     */
    public emailTemplateControllerTestSend(id: string, options?: AxiosRequestConfig) {
        return EmailTemplateApiFp(this.configuration).emailTemplateControllerTestSend(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Retrieve multiple EmailTemplates
     * @param {Array<string>} [fields] Selects resource fields. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#select\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param {string} [s] Adds search condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#search\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param {Array<string>} [filter] Adds filter condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#filter\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param {Array<string>} [or] Adds OR condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#or\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param {Array<string>} [sort] Adds sort by field. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#sort\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param {Array<string>} [join] Adds relational resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#join\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param {number} [limit] Limit amount of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#limit\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param {number} [offset] Offset amount of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#offset\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param {number} [page] Page portion of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#page\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param {number} [cache] Reset cache (if was enabled). &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#cache\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmailTemplateApi
     */
    public getManyBaseEmailTemplateControllerEmailTemplate(fields?: Array<string>, s?: string, filter?: Array<string>, or?: Array<string>, sort?: Array<string>, join?: Array<string>, limit?: number, offset?: number, page?: number, cache?: number, options?: AxiosRequestConfig) {
        return EmailTemplateApiFp(this.configuration).getManyBaseEmailTemplateControllerEmailTemplate(fields, s, filter, or, sort, join, limit, offset, page, cache, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Retrieve a single EmailTemplate
     * @param {string} id 
     * @param {Array<string>} [fields] Selects resource fields. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#select\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param {Array<string>} [join] Adds relational resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#join\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param {number} [cache] Reset cache (if was enabled). &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#cache\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmailTemplateApi
     */
    public getOneBaseEmailTemplateControllerEmailTemplate(id: string, fields?: Array<string>, join?: Array<string>, cache?: number, options?: AxiosRequestConfig) {
        return EmailTemplateApiFp(this.configuration).getOneBaseEmailTemplateControllerEmailTemplate(id, fields, join, cache, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Replace a single EmailTemplate
     * @param {string} id 
     * @param {UpdateEmailTemplateDto} updateEmailTemplateDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmailTemplateApi
     */
    public replaceOneBaseEmailTemplateControllerEmailTemplate(id: string, updateEmailTemplateDto: UpdateEmailTemplateDto, options?: AxiosRequestConfig) {
        return EmailTemplateApiFp(this.configuration).replaceOneBaseEmailTemplateControllerEmailTemplate(id, updateEmailTemplateDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update a single EmailTemplate
     * @param {string} id 
     * @param {UpdateEmailTemplateDto} updateEmailTemplateDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmailTemplateApi
     */
    public updateOneBaseEmailTemplateControllerEmailTemplate(id: string, updateEmailTemplateDto: UpdateEmailTemplateDto, options?: AxiosRequestConfig) {
        return EmailTemplateApiFp(this.configuration).updateOneBaseEmailTemplateControllerEmailTemplate(id, updateEmailTemplateDto, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * EmailUnsubscribeApi - axios parameter creator
 * @export
 */
export const EmailUnsubscribeApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Admin: check whether one or more emails are unsubscribed
         * @param {Array<any>} email 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        emailUnsubscribeControllerCheck: async (email: Array<any>, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'email' is not null or undefined
            assertParamExists('emailUnsubscribeControllerCheck', 'email', email)
            const localVarPath = `/email-unsubscribe/admin/check`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (email) {
                localVarQueryParameter['email'] = email;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Admin: manually mark an email as unsubscribed (also pushes to Listmonk)
         * @param {EmailUnsubscribeControllerManualUnsubscribeRequest} emailUnsubscribeControllerManualUnsubscribeRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        emailUnsubscribeControllerManualUnsubscribe: async (emailUnsubscribeControllerManualUnsubscribeRequest: EmailUnsubscribeControllerManualUnsubscribeRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'emailUnsubscribeControllerManualUnsubscribeRequest' is not null or undefined
            assertParamExists('emailUnsubscribeControllerManualUnsubscribe', 'emailUnsubscribeControllerManualUnsubscribeRequest', emailUnsubscribeControllerManualUnsubscribeRequest)
            const localVarPath = `/email-unsubscribe/admin/unsubscribe`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(emailUnsubscribeControllerManualUnsubscribeRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Admin: full bidirectional sync — pull Listmonk blocklist into local, push locally-pending unsubscribes to Listmonk
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        emailUnsubscribeControllerSync: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/email-unsubscribe/admin/sync`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * EmailUnsubscribeApi - functional programming interface
 * @export
 */
export const EmailUnsubscribeApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = EmailUnsubscribeApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Admin: check whether one or more emails are unsubscribed
         * @param {Array<any>} email 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async emailUnsubscribeControllerCheck(email: Array<any>, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.emailUnsubscribeControllerCheck(email, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Admin: manually mark an email as unsubscribed (also pushes to Listmonk)
         * @param {EmailUnsubscribeControllerManualUnsubscribeRequest} emailUnsubscribeControllerManualUnsubscribeRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async emailUnsubscribeControllerManualUnsubscribe(emailUnsubscribeControllerManualUnsubscribeRequest: EmailUnsubscribeControllerManualUnsubscribeRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.emailUnsubscribeControllerManualUnsubscribe(emailUnsubscribeControllerManualUnsubscribeRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Admin: full bidirectional sync — pull Listmonk blocklist into local, push locally-pending unsubscribes to Listmonk
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async emailUnsubscribeControllerSync(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.emailUnsubscribeControllerSync(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * EmailUnsubscribeApi - factory interface
 * @export
 */
export const EmailUnsubscribeApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = EmailUnsubscribeApiFp(configuration)
    return {
        /**
         * 
         * @summary Admin: check whether one or more emails are unsubscribed
         * @param {Array<any>} email 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        emailUnsubscribeControllerCheck(email: Array<any>, options?: any): AxiosPromise<void> {
            return localVarFp.emailUnsubscribeControllerCheck(email, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Admin: manually mark an email as unsubscribed (also pushes to Listmonk)
         * @param {EmailUnsubscribeControllerManualUnsubscribeRequest} emailUnsubscribeControllerManualUnsubscribeRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        emailUnsubscribeControllerManualUnsubscribe(emailUnsubscribeControllerManualUnsubscribeRequest: EmailUnsubscribeControllerManualUnsubscribeRequest, options?: any): AxiosPromise<void> {
            return localVarFp.emailUnsubscribeControllerManualUnsubscribe(emailUnsubscribeControllerManualUnsubscribeRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Admin: full bidirectional sync — pull Listmonk blocklist into local, push locally-pending unsubscribes to Listmonk
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        emailUnsubscribeControllerSync(options?: any): AxiosPromise<void> {
            return localVarFp.emailUnsubscribeControllerSync(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * EmailUnsubscribeApi - object-oriented interface
 * @export
 * @class EmailUnsubscribeApi
 * @extends {BaseAPI}
 */
export class EmailUnsubscribeApi extends BaseAPI {
    /**
     * 
     * @summary Admin: check whether one or more emails are unsubscribed
     * @param {Array<any>} email 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmailUnsubscribeApi
     */
    public emailUnsubscribeControllerCheck(email: Array<any>, options?: AxiosRequestConfig) {
        return EmailUnsubscribeApiFp(this.configuration).emailUnsubscribeControllerCheck(email, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Admin: manually mark an email as unsubscribed (also pushes to Listmonk)
     * @param {EmailUnsubscribeControllerManualUnsubscribeRequest} emailUnsubscribeControllerManualUnsubscribeRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmailUnsubscribeApi
     */
    public emailUnsubscribeControllerManualUnsubscribe(emailUnsubscribeControllerManualUnsubscribeRequest: EmailUnsubscribeControllerManualUnsubscribeRequest, options?: AxiosRequestConfig) {
        return EmailUnsubscribeApiFp(this.configuration).emailUnsubscribeControllerManualUnsubscribe(emailUnsubscribeControllerManualUnsubscribeRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Admin: full bidirectional sync — pull Listmonk blocklist into local, push locally-pending unsubscribes to Listmonk
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmailUnsubscribeApi
     */
    public emailUnsubscribeControllerSync(options?: AxiosRequestConfig) {
        return EmailUnsubscribeApiFp(this.configuration).emailUnsubscribeControllerSync(options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * GiftCardApi - axios parameter creator
 * @export
 */
export const GiftCardApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Open a gift-card order (pay it via POST /order/:id/payment)
         * @param {CreateGiftCardOrderDto} createGiftCardOrderDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        giftCardControllerCreateOrder: async (createGiftCardOrderDto: CreateGiftCardOrderDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createGiftCardOrderDto' is not null or undefined
            assertParamExists('giftCardControllerCreateOrder', 'createGiftCardOrderDto', createGiftCardOrderDto)
            const localVarPath = `/gift-card/orders`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createGiftCardOrderDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Download the printable gift-card PDF
         * @param {string} orderId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        giftCardControllerDownloadPdf: async (orderId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'orderId' is not null or undefined
            assertParamExists('giftCardControllerDownloadPdf', 'orderId', orderId)
            const localVarPath = `/gift-card/{orderId}/pdf`
                .replace(`{${"orderId"}}`, encodeURIComponent(String(orderId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * GiftCardApi - functional programming interface
 * @export
 */
export const GiftCardApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = GiftCardApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Open a gift-card order (pay it via POST /order/:id/payment)
         * @param {CreateGiftCardOrderDto} createGiftCardOrderDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async giftCardControllerCreateOrder(createGiftCardOrderDto: CreateGiftCardOrderDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GiftCardOrderCreatedDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.giftCardControllerCreateOrder(createGiftCardOrderDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Download the printable gift-card PDF
         * @param {string} orderId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async giftCardControllerDownloadPdf(orderId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<File>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.giftCardControllerDownloadPdf(orderId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * GiftCardApi - factory interface
 * @export
 */
export const GiftCardApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = GiftCardApiFp(configuration)
    return {
        /**
         * 
         * @summary Open a gift-card order (pay it via POST /order/:id/payment)
         * @param {CreateGiftCardOrderDto} createGiftCardOrderDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        giftCardControllerCreateOrder(createGiftCardOrderDto: CreateGiftCardOrderDto, options?: any): AxiosPromise<GiftCardOrderCreatedDto> {
            return localVarFp.giftCardControllerCreateOrder(createGiftCardOrderDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Download the printable gift-card PDF
         * @param {string} orderId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        giftCardControllerDownloadPdf(orderId: string, options?: any): AxiosPromise<File> {
            return localVarFp.giftCardControllerDownloadPdf(orderId, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * GiftCardApi - object-oriented interface
 * @export
 * @class GiftCardApi
 * @extends {BaseAPI}
 */
export class GiftCardApi extends BaseAPI {
    /**
     * 
     * @summary Open a gift-card order (pay it via POST /order/:id/payment)
     * @param {CreateGiftCardOrderDto} createGiftCardOrderDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GiftCardApi
     */
    public giftCardControllerCreateOrder(createGiftCardOrderDto: CreateGiftCardOrderDto, options?: AxiosRequestConfig) {
        return GiftCardApiFp(this.configuration).giftCardControllerCreateOrder(createGiftCardOrderDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Download the printable gift-card PDF
     * @param {string} orderId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GiftCardApi
     */
    public giftCardControllerDownloadPdf(orderId: string, options?: AxiosRequestConfig) {
        return GiftCardApiFp(this.configuration).giftCardControllerDownloadPdf(orderId, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * GiftCardAdminApi - axios parameter creator
 * @export
 */
export const GiftCardAdminApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Superadmin: a gift card by the order that bought it, with its spends.
         * @param {string} orderId The GIFT_CARD order.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        giftCardAdminControllerLookup: async (orderId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'orderId' is not null or undefined
            assertParamExists('giftCardAdminControllerLookup', 'orderId', orderId)
            const localVarPath = `/gift-card/admin/lookup`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (orderId !== undefined) {
                localVarQueryParameter['orderId'] = orderId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Superadmin: a gift card by its code (in the body), with its spends.
         * @param {AdminGiftCardLookupByCodeDto} adminGiftCardLookupByCodeDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        giftCardAdminControllerLookupByCode: async (adminGiftCardLookupByCodeDto: AdminGiftCardLookupByCodeDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'adminGiftCardLookupByCodeDto' is not null or undefined
            assertParamExists('giftCardAdminControllerLookupByCode', 'adminGiftCardLookupByCodeDto', adminGiftCardLookupByCodeDto)
            const localVarPath = `/gift-card/admin/lookup`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(adminGiftCardLookupByCodeDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Superadmin: move a gift card to another shop in its currency.
         * @param {string} lotId 
         * @param {AdminGiftCardMarketDto} adminGiftCardMarketDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        giftCardAdminControllerMarket: async (lotId: string, adminGiftCardMarketDto: AdminGiftCardMarketDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'lotId' is not null or undefined
            assertParamExists('giftCardAdminControllerMarket', 'lotId', lotId)
            // verify required parameter 'adminGiftCardMarketDto' is not null or undefined
            assertParamExists('giftCardAdminControllerMarket', 'adminGiftCardMarketDto', adminGiftCardMarketDto)
            const localVarPath = `/gift-card/admin/{lotId}/market`
                .replace(`{${"lotId"}}`, encodeURIComponent(String(lotId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(adminGiftCardMarketDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Superadmin: give a gift card to another address, or null to un-claim it.
         * @param {string} lotId 
         * @param {AdminGiftCardOwnerDto} adminGiftCardOwnerDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        giftCardAdminControllerOwner: async (lotId: string, adminGiftCardOwnerDto: AdminGiftCardOwnerDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'lotId' is not null or undefined
            assertParamExists('giftCardAdminControllerOwner', 'lotId', lotId)
            // verify required parameter 'adminGiftCardOwnerDto' is not null or undefined
            assertParamExists('giftCardAdminControllerOwner', 'adminGiftCardOwnerDto', adminGiftCardOwnerDto)
            const localVarPath = `/gift-card/admin/{lotId}/owner`
                .replace(`{${"lotId"}}`, encodeURIComponent(String(lotId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(adminGiftCardOwnerDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Superadmin: the printable card, as its buyer gets it; a void card is stamped RAZVELJAVLJEN / VOID.
         * @param {string} lotId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        giftCardAdminControllerPdf: async (lotId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'lotId' is not null or undefined
            assertParamExists('giftCardAdminControllerPdf', 'lotId', lotId)
            const localVarPath = `/gift-card/admin/{lotId}/pdf`
                .replace(`{${"lotId"}}`, encodeURIComponent(String(lotId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Superadmin: a buyer\'s gift-card purchases, by email.
         * @param {string} email 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        giftCardAdminControllerPurchases: async (email: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'email' is not null or undefined
            assertParamExists('giftCardAdminControllerPurchases', 'email', email)
            const localVarPath = `/gift-card/admin/purchases`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (email !== undefined) {
                localVarQueryParameter['email'] = email;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Superadmin: empty a gift card for good.
         * @param {string} lotId 
         * @param {AdminVoidGiftCardDto} adminVoidGiftCardDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        giftCardAdminControllerVoid: async (lotId: string, adminVoidGiftCardDto: AdminVoidGiftCardDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'lotId' is not null or undefined
            assertParamExists('giftCardAdminControllerVoid', 'lotId', lotId)
            // verify required parameter 'adminVoidGiftCardDto' is not null or undefined
            assertParamExists('giftCardAdminControllerVoid', 'adminVoidGiftCardDto', adminVoidGiftCardDto)
            const localVarPath = `/gift-card/admin/{lotId}/void`
                .replace(`{${"lotId"}}`, encodeURIComponent(String(lotId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(adminVoidGiftCardDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * GiftCardAdminApi - functional programming interface
 * @export
 */
export const GiftCardAdminApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = GiftCardAdminApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Superadmin: a gift card by the order that bought it, with its spends.
         * @param {string} orderId The GIFT_CARD order.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async giftCardAdminControllerLookup(orderId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AdminGiftCardLookupDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.giftCardAdminControllerLookup(orderId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Superadmin: a gift card by its code (in the body), with its spends.
         * @param {AdminGiftCardLookupByCodeDto} adminGiftCardLookupByCodeDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async giftCardAdminControllerLookupByCode(adminGiftCardLookupByCodeDto: AdminGiftCardLookupByCodeDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AdminGiftCardLookupDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.giftCardAdminControllerLookupByCode(adminGiftCardLookupByCodeDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Superadmin: move a gift card to another shop in its currency.
         * @param {string} lotId 
         * @param {AdminGiftCardMarketDto} adminGiftCardMarketDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async giftCardAdminControllerMarket(lotId: string, adminGiftCardMarketDto: AdminGiftCardMarketDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.giftCardAdminControllerMarket(lotId, adminGiftCardMarketDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Superadmin: give a gift card to another address, or null to un-claim it.
         * @param {string} lotId 
         * @param {AdminGiftCardOwnerDto} adminGiftCardOwnerDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async giftCardAdminControllerOwner(lotId: string, adminGiftCardOwnerDto: AdminGiftCardOwnerDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.giftCardAdminControllerOwner(lotId, adminGiftCardOwnerDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Superadmin: the printable card, as its buyer gets it; a void card is stamped RAZVELJAVLJEN / VOID.
         * @param {string} lotId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async giftCardAdminControllerPdf(lotId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<File>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.giftCardAdminControllerPdf(lotId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Superadmin: a buyer\'s gift-card purchases, by email.
         * @param {string} email 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async giftCardAdminControllerPurchases(email: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<AdminGiftCardPurchaseDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.giftCardAdminControllerPurchases(email, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Superadmin: empty a gift card for good.
         * @param {string} lotId 
         * @param {AdminVoidGiftCardDto} adminVoidGiftCardDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async giftCardAdminControllerVoid(lotId: string, adminVoidGiftCardDto: AdminVoidGiftCardDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.giftCardAdminControllerVoid(lotId, adminVoidGiftCardDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * GiftCardAdminApi - factory interface
 * @export
 */
export const GiftCardAdminApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = GiftCardAdminApiFp(configuration)
    return {
        /**
         * 
         * @summary Superadmin: a gift card by the order that bought it, with its spends.
         * @param {string} orderId The GIFT_CARD order.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        giftCardAdminControllerLookup(orderId: string, options?: any): AxiosPromise<AdminGiftCardLookupDto> {
            return localVarFp.giftCardAdminControllerLookup(orderId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Superadmin: a gift card by its code (in the body), with its spends.
         * @param {AdminGiftCardLookupByCodeDto} adminGiftCardLookupByCodeDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        giftCardAdminControllerLookupByCode(adminGiftCardLookupByCodeDto: AdminGiftCardLookupByCodeDto, options?: any): AxiosPromise<AdminGiftCardLookupDto> {
            return localVarFp.giftCardAdminControllerLookupByCode(adminGiftCardLookupByCodeDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Superadmin: move a gift card to another shop in its currency.
         * @param {string} lotId 
         * @param {AdminGiftCardMarketDto} adminGiftCardMarketDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        giftCardAdminControllerMarket(lotId: string, adminGiftCardMarketDto: AdminGiftCardMarketDto, options?: any): AxiosPromise<void> {
            return localVarFp.giftCardAdminControllerMarket(lotId, adminGiftCardMarketDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Superadmin: give a gift card to another address, or null to un-claim it.
         * @param {string} lotId 
         * @param {AdminGiftCardOwnerDto} adminGiftCardOwnerDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        giftCardAdminControllerOwner(lotId: string, adminGiftCardOwnerDto: AdminGiftCardOwnerDto, options?: any): AxiosPromise<void> {
            return localVarFp.giftCardAdminControllerOwner(lotId, adminGiftCardOwnerDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Superadmin: the printable card, as its buyer gets it; a void card is stamped RAZVELJAVLJEN / VOID.
         * @param {string} lotId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        giftCardAdminControllerPdf(lotId: string, options?: any): AxiosPromise<File> {
            return localVarFp.giftCardAdminControllerPdf(lotId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Superadmin: a buyer\'s gift-card purchases, by email.
         * @param {string} email 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        giftCardAdminControllerPurchases(email: string, options?: any): AxiosPromise<Array<AdminGiftCardPurchaseDto>> {
            return localVarFp.giftCardAdminControllerPurchases(email, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Superadmin: empty a gift card for good.
         * @param {string} lotId 
         * @param {AdminVoidGiftCardDto} adminVoidGiftCardDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        giftCardAdminControllerVoid(lotId: string, adminVoidGiftCardDto: AdminVoidGiftCardDto, options?: any): AxiosPromise<void> {
            return localVarFp.giftCardAdminControllerVoid(lotId, adminVoidGiftCardDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * GiftCardAdminApi - object-oriented interface
 * @export
 * @class GiftCardAdminApi
 * @extends {BaseAPI}
 */
export class GiftCardAdminApi extends BaseAPI {
    /**
     * 
     * @summary Superadmin: a gift card by the order that bought it, with its spends.
     * @param {string} orderId The GIFT_CARD order.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GiftCardAdminApi
     */
    public giftCardAdminControllerLookup(orderId: string, options?: AxiosRequestConfig) {
        return GiftCardAdminApiFp(this.configuration).giftCardAdminControllerLookup(orderId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Superadmin: a gift card by its code (in the body), with its spends.
     * @param {AdminGiftCardLookupByCodeDto} adminGiftCardLookupByCodeDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GiftCardAdminApi
     */
    public giftCardAdminControllerLookupByCode(adminGiftCardLookupByCodeDto: AdminGiftCardLookupByCodeDto, options?: AxiosRequestConfig) {
        return GiftCardAdminApiFp(this.configuration).giftCardAdminControllerLookupByCode(adminGiftCardLookupByCodeDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Superadmin: move a gift card to another shop in its currency.
     * @param {string} lotId 
     * @param {AdminGiftCardMarketDto} adminGiftCardMarketDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GiftCardAdminApi
     */
    public giftCardAdminControllerMarket(lotId: string, adminGiftCardMarketDto: AdminGiftCardMarketDto, options?: AxiosRequestConfig) {
        return GiftCardAdminApiFp(this.configuration).giftCardAdminControllerMarket(lotId, adminGiftCardMarketDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Superadmin: give a gift card to another address, or null to un-claim it.
     * @param {string} lotId 
     * @param {AdminGiftCardOwnerDto} adminGiftCardOwnerDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GiftCardAdminApi
     */
    public giftCardAdminControllerOwner(lotId: string, adminGiftCardOwnerDto: AdminGiftCardOwnerDto, options?: AxiosRequestConfig) {
        return GiftCardAdminApiFp(this.configuration).giftCardAdminControllerOwner(lotId, adminGiftCardOwnerDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Superadmin: the printable card, as its buyer gets it; a void card is stamped RAZVELJAVLJEN / VOID.
     * @param {string} lotId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GiftCardAdminApi
     */
    public giftCardAdminControllerPdf(lotId: string, options?: AxiosRequestConfig) {
        return GiftCardAdminApiFp(this.configuration).giftCardAdminControllerPdf(lotId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Superadmin: a buyer\'s gift-card purchases, by email.
     * @param {string} email 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GiftCardAdminApi
     */
    public giftCardAdminControllerPurchases(email: string, options?: AxiosRequestConfig) {
        return GiftCardAdminApiFp(this.configuration).giftCardAdminControllerPurchases(email, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Superadmin: empty a gift card for good.
     * @param {string} lotId 
     * @param {AdminVoidGiftCardDto} adminVoidGiftCardDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GiftCardAdminApi
     */
    public giftCardAdminControllerVoid(lotId: string, adminVoidGiftCardDto: AdminVoidGiftCardDto, options?: AxiosRequestConfig) {
        return GiftCardAdminApiFp(this.configuration).giftCardAdminControllerVoid(lotId, adminVoidGiftCardDto, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * HealthApi - axios parameter creator
 * @export
 */
export const HealthApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Cron and integration heartbeats (admin)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        healthControllerSignals: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/system-health`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * HealthApi - functional programming interface
 * @export
 */
export const HealthApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = HealthApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Cron and integration heartbeats (admin)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async healthControllerSignals(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.healthControllerSignals(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * HealthApi - factory interface
 * @export
 */
export const HealthApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = HealthApiFp(configuration)
    return {
        /**
         * 
         * @summary Cron and integration heartbeats (admin)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        healthControllerSignals(options?: any): AxiosPromise<void> {
            return localVarFp.healthControllerSignals(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * HealthApi - object-oriented interface
 * @export
 * @class HealthApi
 * @extends {BaseAPI}
 */
export class HealthApi extends BaseAPI {
    /**
     * 
     * @summary Cron and integration heartbeats (admin)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof HealthApi
     */
    public healthControllerSignals(options?: AxiosRequestConfig) {
        return HealthApiFp(this.configuration).healthControllerSignals(options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * InvoicesApi - axios parameter creator
 * @export
 */
export const InvoicesApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Delete a single Invoice
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOneBaseInvoiceControllerInvoice: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('deleteOneBaseInvoiceControllerInvoice', 'id', id)
            const localVarPath = `/invoices/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Retrieve multiple Invoices
         * @param {Array<string>} [fields] Selects resource fields. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#select\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {string} [s] Adds search condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#search\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {Array<string>} [filter] Adds filter condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#filter\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {Array<string>} [or] Adds OR condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#or\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {Array<string>} [sort] Adds sort by field. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#sort\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {Array<string>} [join] Adds relational resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#join\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {number} [limit] Limit amount of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#limit\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {number} [offset] Offset amount of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#offset\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {number} [page] Page portion of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#page\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {number} [cache] Reset cache (if was enabled). &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#cache\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getManyBaseInvoiceControllerInvoice: async (fields?: Array<string>, s?: string, filter?: Array<string>, or?: Array<string>, sort?: Array<string>, join?: Array<string>, limit?: number, offset?: number, page?: number, cache?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/invoices`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (fields) {
                localVarQueryParameter['fields'] = fields;
            }

            if (s !== undefined) {
                localVarQueryParameter['s'] = s;
            }

            if (filter) {
                localVarQueryParameter['filter'] = filter;
            }

            if (or) {
                localVarQueryParameter['or'] = or;
            }

            if (sort) {
                localVarQueryParameter['sort'] = sort;
            }

            if (join) {
                localVarQueryParameter['join'] = join;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (cache !== undefined) {
                localVarQueryParameter['cache'] = cache;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Retrieve a single Invoice
         * @param {string} id 
         * @param {Array<string>} [fields] Selects resource fields. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#select\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {Array<string>} [join] Adds relational resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#join\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {number} [cache] Reset cache (if was enabled). &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#cache\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOneBaseInvoiceControllerInvoice: async (id: string, fields?: Array<string>, join?: Array<string>, cache?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getOneBaseInvoiceControllerInvoice', 'id', id)
            const localVarPath = `/invoices/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (fields) {
                localVarQueryParameter['fields'] = fields;
            }

            if (join) {
                localVarQueryParameter['join'] = join;
            }

            if (cache !== undefined) {
                localVarQueryParameter['cache'] = cache;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Creates a credit note (storno) to cancel a fiscalized invoice. This is required before issuing a new invoice with corrections.
         * @summary Create a credit note for a fiscalized invoice
         * @param {CreateCreditNoteDto} createCreditNoteDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        invoiceControllerCreateCreditNote: async (createCreditNoteDto: CreateCreditNoteDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createCreditNoteDto' is not null or undefined
            assertParamExists('invoiceControllerCreateCreditNote', 'createCreditNoteDto', createCreditNoteDto)
            const localVarPath = `/invoices/credit-note`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createCreditNoteDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Creates a new invoice from an order with optional override values
         * @summary Create invoice from order
         * @param {CreateInvoiceFromOrderDto} createInvoiceFromOrderDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        invoiceControllerCreateInvoiceFromOrder: async (createInvoiceFromOrderDto: CreateInvoiceFromOrderDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createInvoiceFromOrderDto' is not null or undefined
            assertParamExists('invoiceControllerCreateInvoiceFromOrder', 'createInvoiceFromOrderDto', createInvoiceFromOrderDto)
            const localVarPath = `/invoices/create-from-order`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createInvoiceFromOrderDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Downloads the invoice PDF file
         * @summary Download invoice PDF
         * @param {string} id Invoice ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        invoiceControllerDownloadInvoice: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('invoiceControllerDownloadInvoice', 'id', id)
            const localVarPath = `/invoices/{id}/download`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Submits an invoice to FURS for fiscalization
         * @summary Fiscalize invoice
         * @param {string} id Invoice ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        invoiceControllerFiscalizeInvoice: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('invoiceControllerFiscalizeInvoice', 'id', id)
            const localVarPath = `/invoices/{id}/fiscalize`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Processes all invoices with pending fiscalization status
         * @summary Fiscalize all pending invoices
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        invoiceControllerFiscalizePendingInvoices: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/invoices/fiscalize-pending`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns all business premises with their FURS registration status
         * @summary Get all business premises
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        invoiceControllerGetBusinessPremises: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/invoices/furs/business-premises`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns all electronic devices with their business premise info
         * @summary Get all electronic devices
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        invoiceControllerGetElectronicDevices: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/invoices/furs/electronic-devices`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns fiscalization system status and statistics
         * @summary Get FURS system status
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        invoiceControllerGetFiscalizationStatus: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/invoices/system/status`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns comprehensive debugging information about business premise and electronic device for a specific invoice
         * @summary Get detailed FURS debug info for an invoice
         * @param {string} invoiceId Invoice ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        invoiceControllerGetFursDebugInfo: async (invoiceId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'invoiceId' is not null or undefined
            assertParamExists('invoiceControllerGetFursDebugInfo', 'invoiceId', invoiceId)
            const localVarPath = `/invoices/furs/debug/{invoiceId}`
                .replace(`{${"invoiceId"}}`, encodeURIComponent(String(invoiceId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns invoice statistics and summary
         * @summary Get invoice statistics
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        invoiceControllerGetInvoiceStatistics: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/invoices/statistics/summary`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns the current invoice status for an order, including whether a new invoice can be created or if a credit note is required.
         * @summary Check invoice status for an order
         * @param {string} orderId Order ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        invoiceControllerGetInvoiceStatusForOrder: async (orderId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'orderId' is not null or undefined
            assertParamExists('invoiceControllerGetInvoiceStatusForOrder', 'orderId', orderId)
            const localVarPath = `/invoices/order/{orderId}/status`
                .replace(`{${"orderId"}}`, encodeURIComponent(String(orderId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns invoice data as JSON
         * @summary Preview invoice data
         * @param {string} id Invoice ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        invoiceControllerPreviewInvoice: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('invoiceControllerPreviewInvoice', 'id', id)
            const localVarPath = `/invoices/{id}/preview`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Regenerates the PDF for an existing invoice without re-fiscalizing. Useful when PDF generation failed or when you need to update the PDF with latest template changes.
         * @summary Regenerate invoice PDF
         * @param {string} id Invoice ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        invoiceControllerRegenerateInvoicePdf: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('invoiceControllerRegenerateInvoicePdf', 'id', id)
            const localVarPath = `/invoices/{id}/regenerate-pdf`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Registers the default business premise with FURS and returns detailed response including any errors
         * @summary Register business premise with FURS
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        invoiceControllerRegisterBusinessPremise: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/invoices/furs/register-business-premise`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Registers a specific business premise with FURS by ID and returns detailed response
         * @summary Register specific business premise with FURS
         * @param {string} businessPremiseId Business Premise ID (e.g., BP001)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        invoiceControllerRegisterSpecificBusinessPremise: async (businessPremiseId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'businessPremiseId' is not null or undefined
            assertParamExists('invoiceControllerRegisterSpecificBusinessPremise', 'businessPremiseId', businessPremiseId)
            const localVarPath = `/invoices/furs/register-business-premise/{businessPremiseId}`
                .replace(`{${"businessPremiseId"}}`, encodeURIComponent(String(businessPremiseId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Used after an admin edits an invoice (e.g. removes a line). Updates the order amount and appends an audit entry to the order snapshot history. Allowed for already-paid orders (the response flags wasPaid so the UI can warn).
         * @summary Set the order total to match this invoice\'s total
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        invoiceControllerSyncOrderTotal: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('invoiceControllerSyncOrderTotal', 'id', id)
            const localVarPath = `/invoices/{id}/sync-order-total`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Exports invoices to CSV or XLSX format for accounting purposes. Supports date range and status filtering. Use ?format=csv or ?format=xlsx to specify the format (default: csv). Authentication: Accepts either JWT token or API key (API_KEY_EXPORT from environment) as Bearer token.
         * @summary Export invoices to CSV or XLSX
         * @param {string} [startDate] Start date for invoice export (ISO 8601 format)
         * @param {string} [endDate] End date for invoice export (ISO 8601 format)
         * @param {InvoiceExportControllerExportInvoicesCsvStatusEnum} [status] Filter by fiscalization status
         * @param {InvoiceExportControllerExportInvoicesCsvFormatEnum} [format] Export format (csv or xlsx)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        invoiceExportControllerExportInvoicesCsv: async (startDate?: string, endDate?: string, status?: InvoiceExportControllerExportInvoicesCsvStatusEnum, format?: InvoiceExportControllerExportInvoicesCsvFormatEnum, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/invoices/export/csv`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (startDate !== undefined) {
                localVarQueryParameter['startDate'] = startDate;
            }

            if (endDate !== undefined) {
                localVarQueryParameter['endDate'] = endDate;
            }

            if (status !== undefined) {
                localVarQueryParameter['status'] = status;
            }

            if (format !== undefined) {
                localVarQueryParameter['format'] = format;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Updates an invoice and regenerates the PDF. Only allowed when fiscalization status is PENDING.
         * @summary Update invoice
         * @param {string} id 
         * @param {UpdateInvoiceDto} updateInvoiceDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateOneBaseInvoiceControllerInvoice: async (id: string, updateInvoiceDto: UpdateInvoiceDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('updateOneBaseInvoiceControllerInvoice', 'id', id)
            // verify required parameter 'updateInvoiceDto' is not null or undefined
            assertParamExists('updateOneBaseInvoiceControllerInvoice', 'updateInvoiceDto', updateInvoiceDto)
            const localVarPath = `/invoices/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateInvoiceDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * InvoicesApi - functional programming interface
 * @export
 */
export const InvoicesApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = InvoicesApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Delete a single Invoice
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteOneBaseInvoiceControllerInvoice(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteOneBaseInvoiceControllerInvoice(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Retrieve multiple Invoices
         * @param {Array<string>} [fields] Selects resource fields. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#select\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {string} [s] Adds search condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#search\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {Array<string>} [filter] Adds filter condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#filter\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {Array<string>} [or] Adds OR condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#or\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {Array<string>} [sort] Adds sort by field. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#sort\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {Array<string>} [join] Adds relational resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#join\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {number} [limit] Limit amount of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#limit\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {number} [offset] Offset amount of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#offset\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {number} [page] Page portion of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#page\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {number} [cache] Reset cache (if was enabled). &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#cache\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getManyBaseInvoiceControllerInvoice(fields?: Array<string>, s?: string, filter?: Array<string>, or?: Array<string>, sort?: Array<string>, join?: Array<string>, limit?: number, offset?: number, page?: number, cache?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetManyInvoiceResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getManyBaseInvoiceControllerInvoice(fields, s, filter, or, sort, join, limit, offset, page, cache, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Retrieve a single Invoice
         * @param {string} id 
         * @param {Array<string>} [fields] Selects resource fields. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#select\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {Array<string>} [join] Adds relational resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#join\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {number} [cache] Reset cache (if was enabled). &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#cache\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getOneBaseInvoiceControllerInvoice(id: string, fields?: Array<string>, join?: Array<string>, cache?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetInvoiceDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getOneBaseInvoiceControllerInvoice(id, fields, join, cache, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Creates a credit note (storno) to cancel a fiscalized invoice. This is required before issuing a new invoice with corrections.
         * @summary Create a credit note for a fiscalized invoice
         * @param {CreateCreditNoteDto} createCreditNoteDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async invoiceControllerCreateCreditNote(createCreditNoteDto: CreateCreditNoteDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InvoiceControllerCreateCreditNote201Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.invoiceControllerCreateCreditNote(createCreditNoteDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Creates a new invoice from an order with optional override values
         * @summary Create invoice from order
         * @param {CreateInvoiceFromOrderDto} createInvoiceFromOrderDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async invoiceControllerCreateInvoiceFromOrder(createInvoiceFromOrderDto: CreateInvoiceFromOrderDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InvoiceControllerCreateInvoiceFromOrder201Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.invoiceControllerCreateInvoiceFromOrder(createInvoiceFromOrderDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Downloads the invoice PDF file
         * @summary Download invoice PDF
         * @param {string} id Invoice ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async invoiceControllerDownloadInvoice(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<File>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.invoiceControllerDownloadInvoice(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Submits an invoice to FURS for fiscalization
         * @summary Fiscalize invoice
         * @param {string} id Invoice ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async invoiceControllerFiscalizeInvoice(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InvoiceControllerFiscalizeInvoice200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.invoiceControllerFiscalizeInvoice(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Processes all invoices with pending fiscalization status
         * @summary Fiscalize all pending invoices
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async invoiceControllerFiscalizePendingInvoices(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InvoiceControllerFiscalizePendingInvoices200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.invoiceControllerFiscalizePendingInvoices(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Returns all business premises with their FURS registration status
         * @summary Get all business premises
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async invoiceControllerGetBusinessPremises(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InvoiceControllerGetBusinessPremises200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.invoiceControllerGetBusinessPremises(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Returns all electronic devices with their business premise info
         * @summary Get all electronic devices
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async invoiceControllerGetElectronicDevices(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InvoiceControllerGetElectronicDevices200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.invoiceControllerGetElectronicDevices(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Returns fiscalization system status and statistics
         * @summary Get FURS system status
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async invoiceControllerGetFiscalizationStatus(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InvoiceControllerGetFiscalizationStatus200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.invoiceControllerGetFiscalizationStatus(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Returns comprehensive debugging information about business premise and electronic device for a specific invoice
         * @summary Get detailed FURS debug info for an invoice
         * @param {string} invoiceId Invoice ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async invoiceControllerGetFursDebugInfo(invoiceId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InvoiceControllerGetFursDebugInfo200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.invoiceControllerGetFursDebugInfo(invoiceId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Returns invoice statistics and summary
         * @summary Get invoice statistics
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async invoiceControllerGetInvoiceStatistics(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InvoiceControllerGetInvoiceStatistics200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.invoiceControllerGetInvoiceStatistics(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Returns the current invoice status for an order, including whether a new invoice can be created or if a credit note is required.
         * @summary Check invoice status for an order
         * @param {string} orderId Order ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async invoiceControllerGetInvoiceStatusForOrder(orderId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InvoiceControllerGetInvoiceStatusForOrder200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.invoiceControllerGetInvoiceStatusForOrder(orderId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Returns invoice data as JSON
         * @summary Preview invoice data
         * @param {string} id Invoice ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async invoiceControllerPreviewInvoice(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InvoicePreviewDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.invoiceControllerPreviewInvoice(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Regenerates the PDF for an existing invoice without re-fiscalizing. Useful when PDF generation failed or when you need to update the PDF with latest template changes.
         * @summary Regenerate invoice PDF
         * @param {string} id Invoice ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async invoiceControllerRegenerateInvoicePdf(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InvoiceControllerRegenerateInvoicePdf200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.invoiceControllerRegenerateInvoicePdf(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Registers the default business premise with FURS and returns detailed response including any errors
         * @summary Register business premise with FURS
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async invoiceControllerRegisterBusinessPremise(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InvoiceControllerRegisterBusinessPremise201Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.invoiceControllerRegisterBusinessPremise(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Registers a specific business premise with FURS by ID and returns detailed response
         * @summary Register specific business premise with FURS
         * @param {string} businessPremiseId Business Premise ID (e.g., BP001)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async invoiceControllerRegisterSpecificBusinessPremise(businessPremiseId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.invoiceControllerRegisterSpecificBusinessPremise(businessPremiseId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Used after an admin edits an invoice (e.g. removes a line). Updates the order amount and appends an audit entry to the order snapshot history. Allowed for already-paid orders (the response flags wasPaid so the UI can warn).
         * @summary Set the order total to match this invoice\'s total
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async invoiceControllerSyncOrderTotal(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.invoiceControllerSyncOrderTotal(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Exports invoices to CSV or XLSX format for accounting purposes. Supports date range and status filtering. Use ?format=csv or ?format=xlsx to specify the format (default: csv). Authentication: Accepts either JWT token or API key (API_KEY_EXPORT from environment) as Bearer token.
         * @summary Export invoices to CSV or XLSX
         * @param {string} [startDate] Start date for invoice export (ISO 8601 format)
         * @param {string} [endDate] End date for invoice export (ISO 8601 format)
         * @param {InvoiceExportControllerExportInvoicesCsvStatusEnum} [status] Filter by fiscalization status
         * @param {InvoiceExportControllerExportInvoicesCsvFormatEnum} [format] Export format (csv or xlsx)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async invoiceExportControllerExportInvoicesCsv(startDate?: string, endDate?: string, status?: InvoiceExportControllerExportInvoicesCsvStatusEnum, format?: InvoiceExportControllerExportInvoicesCsvFormatEnum, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<File>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.invoiceExportControllerExportInvoicesCsv(startDate, endDate, status, format, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Updates an invoice and regenerates the PDF. Only allowed when fiscalization status is PENDING.
         * @summary Update invoice
         * @param {string} id 
         * @param {UpdateInvoiceDto} updateInvoiceDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateOneBaseInvoiceControllerInvoice(id: string, updateInvoiceDto: UpdateInvoiceDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateOneBaseInvoiceControllerInvoice(id, updateInvoiceDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * InvoicesApi - factory interface
 * @export
 */
export const InvoicesApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = InvoicesApiFp(configuration)
    return {
        /**
         * 
         * @summary Delete a single Invoice
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOneBaseInvoiceControllerInvoice(id: string, options?: any): AxiosPromise<object> {
            return localVarFp.deleteOneBaseInvoiceControllerInvoice(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Retrieve multiple Invoices
         * @param {Array<string>} [fields] Selects resource fields. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#select\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {string} [s] Adds search condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#search\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {Array<string>} [filter] Adds filter condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#filter\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {Array<string>} [or] Adds OR condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#or\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {Array<string>} [sort] Adds sort by field. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#sort\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {Array<string>} [join] Adds relational resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#join\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {number} [limit] Limit amount of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#limit\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {number} [offset] Offset amount of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#offset\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {number} [page] Page portion of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#page\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {number} [cache] Reset cache (if was enabled). &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#cache\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getManyBaseInvoiceControllerInvoice(fields?: Array<string>, s?: string, filter?: Array<string>, or?: Array<string>, sort?: Array<string>, join?: Array<string>, limit?: number, offset?: number, page?: number, cache?: number, options?: any): AxiosPromise<GetManyInvoiceResponseDto> {
            return localVarFp.getManyBaseInvoiceControllerInvoice(fields, s, filter, or, sort, join, limit, offset, page, cache, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Retrieve a single Invoice
         * @param {string} id 
         * @param {Array<string>} [fields] Selects resource fields. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#select\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {Array<string>} [join] Adds relational resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#join\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {number} [cache] Reset cache (if was enabled). &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#cache\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOneBaseInvoiceControllerInvoice(id: string, fields?: Array<string>, join?: Array<string>, cache?: number, options?: any): AxiosPromise<GetInvoiceDto> {
            return localVarFp.getOneBaseInvoiceControllerInvoice(id, fields, join, cache, options).then((request) => request(axios, basePath));
        },
        /**
         * Creates a credit note (storno) to cancel a fiscalized invoice. This is required before issuing a new invoice with corrections.
         * @summary Create a credit note for a fiscalized invoice
         * @param {CreateCreditNoteDto} createCreditNoteDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        invoiceControllerCreateCreditNote(createCreditNoteDto: CreateCreditNoteDto, options?: any): AxiosPromise<InvoiceControllerCreateCreditNote201Response> {
            return localVarFp.invoiceControllerCreateCreditNote(createCreditNoteDto, options).then((request) => request(axios, basePath));
        },
        /**
         * Creates a new invoice from an order with optional override values
         * @summary Create invoice from order
         * @param {CreateInvoiceFromOrderDto} createInvoiceFromOrderDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        invoiceControllerCreateInvoiceFromOrder(createInvoiceFromOrderDto: CreateInvoiceFromOrderDto, options?: any): AxiosPromise<InvoiceControllerCreateInvoiceFromOrder201Response> {
            return localVarFp.invoiceControllerCreateInvoiceFromOrder(createInvoiceFromOrderDto, options).then((request) => request(axios, basePath));
        },
        /**
         * Downloads the invoice PDF file
         * @summary Download invoice PDF
         * @param {string} id Invoice ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        invoiceControllerDownloadInvoice(id: string, options?: any): AxiosPromise<File> {
            return localVarFp.invoiceControllerDownloadInvoice(id, options).then((request) => request(axios, basePath));
        },
        /**
         * Submits an invoice to FURS for fiscalization
         * @summary Fiscalize invoice
         * @param {string} id Invoice ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        invoiceControllerFiscalizeInvoice(id: string, options?: any): AxiosPromise<InvoiceControllerFiscalizeInvoice200Response> {
            return localVarFp.invoiceControllerFiscalizeInvoice(id, options).then((request) => request(axios, basePath));
        },
        /**
         * Processes all invoices with pending fiscalization status
         * @summary Fiscalize all pending invoices
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        invoiceControllerFiscalizePendingInvoices(options?: any): AxiosPromise<InvoiceControllerFiscalizePendingInvoices200Response> {
            return localVarFp.invoiceControllerFiscalizePendingInvoices(options).then((request) => request(axios, basePath));
        },
        /**
         * Returns all business premises with their FURS registration status
         * @summary Get all business premises
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        invoiceControllerGetBusinessPremises(options?: any): AxiosPromise<InvoiceControllerGetBusinessPremises200Response> {
            return localVarFp.invoiceControllerGetBusinessPremises(options).then((request) => request(axios, basePath));
        },
        /**
         * Returns all electronic devices with their business premise info
         * @summary Get all electronic devices
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        invoiceControllerGetElectronicDevices(options?: any): AxiosPromise<InvoiceControllerGetElectronicDevices200Response> {
            return localVarFp.invoiceControllerGetElectronicDevices(options).then((request) => request(axios, basePath));
        },
        /**
         * Returns fiscalization system status and statistics
         * @summary Get FURS system status
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        invoiceControllerGetFiscalizationStatus(options?: any): AxiosPromise<InvoiceControllerGetFiscalizationStatus200Response> {
            return localVarFp.invoiceControllerGetFiscalizationStatus(options).then((request) => request(axios, basePath));
        },
        /**
         * Returns comprehensive debugging information about business premise and electronic device for a specific invoice
         * @summary Get detailed FURS debug info for an invoice
         * @param {string} invoiceId Invoice ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        invoiceControllerGetFursDebugInfo(invoiceId: string, options?: any): AxiosPromise<InvoiceControllerGetFursDebugInfo200Response> {
            return localVarFp.invoiceControllerGetFursDebugInfo(invoiceId, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns invoice statistics and summary
         * @summary Get invoice statistics
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        invoiceControllerGetInvoiceStatistics(options?: any): AxiosPromise<InvoiceControllerGetInvoiceStatistics200Response> {
            return localVarFp.invoiceControllerGetInvoiceStatistics(options).then((request) => request(axios, basePath));
        },
        /**
         * Returns the current invoice status for an order, including whether a new invoice can be created or if a credit note is required.
         * @summary Check invoice status for an order
         * @param {string} orderId Order ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        invoiceControllerGetInvoiceStatusForOrder(orderId: string, options?: any): AxiosPromise<InvoiceControllerGetInvoiceStatusForOrder200Response> {
            return localVarFp.invoiceControllerGetInvoiceStatusForOrder(orderId, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns invoice data as JSON
         * @summary Preview invoice data
         * @param {string} id Invoice ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        invoiceControllerPreviewInvoice(id: string, options?: any): AxiosPromise<InvoicePreviewDto> {
            return localVarFp.invoiceControllerPreviewInvoice(id, options).then((request) => request(axios, basePath));
        },
        /**
         * Regenerates the PDF for an existing invoice without re-fiscalizing. Useful when PDF generation failed or when you need to update the PDF with latest template changes.
         * @summary Regenerate invoice PDF
         * @param {string} id Invoice ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        invoiceControllerRegenerateInvoicePdf(id: string, options?: any): AxiosPromise<InvoiceControllerRegenerateInvoicePdf200Response> {
            return localVarFp.invoiceControllerRegenerateInvoicePdf(id, options).then((request) => request(axios, basePath));
        },
        /**
         * Registers the default business premise with FURS and returns detailed response including any errors
         * @summary Register business premise with FURS
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        invoiceControllerRegisterBusinessPremise(options?: any): AxiosPromise<InvoiceControllerRegisterBusinessPremise201Response> {
            return localVarFp.invoiceControllerRegisterBusinessPremise(options).then((request) => request(axios, basePath));
        },
        /**
         * Registers a specific business premise with FURS by ID and returns detailed response
         * @summary Register specific business premise with FURS
         * @param {string} businessPremiseId Business Premise ID (e.g., BP001)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        invoiceControllerRegisterSpecificBusinessPremise(businessPremiseId: string, options?: any): AxiosPromise<void> {
            return localVarFp.invoiceControllerRegisterSpecificBusinessPremise(businessPremiseId, options).then((request) => request(axios, basePath));
        },
        /**
         * Used after an admin edits an invoice (e.g. removes a line). Updates the order amount and appends an audit entry to the order snapshot history. Allowed for already-paid orders (the response flags wasPaid so the UI can warn).
         * @summary Set the order total to match this invoice\'s total
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        invoiceControllerSyncOrderTotal(id: string, options?: any): AxiosPromise<void> {
            return localVarFp.invoiceControllerSyncOrderTotal(id, options).then((request) => request(axios, basePath));
        },
        /**
         * Exports invoices to CSV or XLSX format for accounting purposes. Supports date range and status filtering. Use ?format=csv or ?format=xlsx to specify the format (default: csv). Authentication: Accepts either JWT token or API key (API_KEY_EXPORT from environment) as Bearer token.
         * @summary Export invoices to CSV or XLSX
         * @param {string} [startDate] Start date for invoice export (ISO 8601 format)
         * @param {string} [endDate] End date for invoice export (ISO 8601 format)
         * @param {InvoiceExportControllerExportInvoicesCsvStatusEnum} [status] Filter by fiscalization status
         * @param {InvoiceExportControllerExportInvoicesCsvFormatEnum} [format] Export format (csv or xlsx)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        invoiceExportControllerExportInvoicesCsv(startDate?: string, endDate?: string, status?: InvoiceExportControllerExportInvoicesCsvStatusEnum, format?: InvoiceExportControllerExportInvoicesCsvFormatEnum, options?: any): AxiosPromise<File> {
            return localVarFp.invoiceExportControllerExportInvoicesCsv(startDate, endDate, status, format, options).then((request) => request(axios, basePath));
        },
        /**
         * Updates an invoice and regenerates the PDF. Only allowed when fiscalization status is PENDING.
         * @summary Update invoice
         * @param {string} id 
         * @param {UpdateInvoiceDto} updateInvoiceDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateOneBaseInvoiceControllerInvoice(id: string, updateInvoiceDto: UpdateInvoiceDto, options?: any): AxiosPromise<void> {
            return localVarFp.updateOneBaseInvoiceControllerInvoice(id, updateInvoiceDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * InvoicesApi - object-oriented interface
 * @export
 * @class InvoicesApi
 * @extends {BaseAPI}
 */
export class InvoicesApi extends BaseAPI {
    /**
     * 
     * @summary Delete a single Invoice
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InvoicesApi
     */
    public deleteOneBaseInvoiceControllerInvoice(id: string, options?: AxiosRequestConfig) {
        return InvoicesApiFp(this.configuration).deleteOneBaseInvoiceControllerInvoice(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Retrieve multiple Invoices
     * @param {Array<string>} [fields] Selects resource fields. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#select\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param {string} [s] Adds search condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#search\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param {Array<string>} [filter] Adds filter condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#filter\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param {Array<string>} [or] Adds OR condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#or\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param {Array<string>} [sort] Adds sort by field. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#sort\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param {Array<string>} [join] Adds relational resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#join\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param {number} [limit] Limit amount of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#limit\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param {number} [offset] Offset amount of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#offset\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param {number} [page] Page portion of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#page\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param {number} [cache] Reset cache (if was enabled). &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#cache\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InvoicesApi
     */
    public getManyBaseInvoiceControllerInvoice(fields?: Array<string>, s?: string, filter?: Array<string>, or?: Array<string>, sort?: Array<string>, join?: Array<string>, limit?: number, offset?: number, page?: number, cache?: number, options?: AxiosRequestConfig) {
        return InvoicesApiFp(this.configuration).getManyBaseInvoiceControllerInvoice(fields, s, filter, or, sort, join, limit, offset, page, cache, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Retrieve a single Invoice
     * @param {string} id 
     * @param {Array<string>} [fields] Selects resource fields. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#select\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param {Array<string>} [join] Adds relational resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#join\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param {number} [cache] Reset cache (if was enabled). &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#cache\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InvoicesApi
     */
    public getOneBaseInvoiceControllerInvoice(id: string, fields?: Array<string>, join?: Array<string>, cache?: number, options?: AxiosRequestConfig) {
        return InvoicesApiFp(this.configuration).getOneBaseInvoiceControllerInvoice(id, fields, join, cache, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Creates a credit note (storno) to cancel a fiscalized invoice. This is required before issuing a new invoice with corrections.
     * @summary Create a credit note for a fiscalized invoice
     * @param {CreateCreditNoteDto} createCreditNoteDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InvoicesApi
     */
    public invoiceControllerCreateCreditNote(createCreditNoteDto: CreateCreditNoteDto, options?: AxiosRequestConfig) {
        return InvoicesApiFp(this.configuration).invoiceControllerCreateCreditNote(createCreditNoteDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Creates a new invoice from an order with optional override values
     * @summary Create invoice from order
     * @param {CreateInvoiceFromOrderDto} createInvoiceFromOrderDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InvoicesApi
     */
    public invoiceControllerCreateInvoiceFromOrder(createInvoiceFromOrderDto: CreateInvoiceFromOrderDto, options?: AxiosRequestConfig) {
        return InvoicesApiFp(this.configuration).invoiceControllerCreateInvoiceFromOrder(createInvoiceFromOrderDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Downloads the invoice PDF file
     * @summary Download invoice PDF
     * @param {string} id Invoice ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InvoicesApi
     */
    public invoiceControllerDownloadInvoice(id: string, options?: AxiosRequestConfig) {
        return InvoicesApiFp(this.configuration).invoiceControllerDownloadInvoice(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Submits an invoice to FURS for fiscalization
     * @summary Fiscalize invoice
     * @param {string} id Invoice ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InvoicesApi
     */
    public invoiceControllerFiscalizeInvoice(id: string, options?: AxiosRequestConfig) {
        return InvoicesApiFp(this.configuration).invoiceControllerFiscalizeInvoice(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Processes all invoices with pending fiscalization status
     * @summary Fiscalize all pending invoices
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InvoicesApi
     */
    public invoiceControllerFiscalizePendingInvoices(options?: AxiosRequestConfig) {
        return InvoicesApiFp(this.configuration).invoiceControllerFiscalizePendingInvoices(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns all business premises with their FURS registration status
     * @summary Get all business premises
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InvoicesApi
     */
    public invoiceControllerGetBusinessPremises(options?: AxiosRequestConfig) {
        return InvoicesApiFp(this.configuration).invoiceControllerGetBusinessPremises(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns all electronic devices with their business premise info
     * @summary Get all electronic devices
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InvoicesApi
     */
    public invoiceControllerGetElectronicDevices(options?: AxiosRequestConfig) {
        return InvoicesApiFp(this.configuration).invoiceControllerGetElectronicDevices(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns fiscalization system status and statistics
     * @summary Get FURS system status
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InvoicesApi
     */
    public invoiceControllerGetFiscalizationStatus(options?: AxiosRequestConfig) {
        return InvoicesApiFp(this.configuration).invoiceControllerGetFiscalizationStatus(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns comprehensive debugging information about business premise and electronic device for a specific invoice
     * @summary Get detailed FURS debug info for an invoice
     * @param {string} invoiceId Invoice ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InvoicesApi
     */
    public invoiceControllerGetFursDebugInfo(invoiceId: string, options?: AxiosRequestConfig) {
        return InvoicesApiFp(this.configuration).invoiceControllerGetFursDebugInfo(invoiceId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns invoice statistics and summary
     * @summary Get invoice statistics
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InvoicesApi
     */
    public invoiceControllerGetInvoiceStatistics(options?: AxiosRequestConfig) {
        return InvoicesApiFp(this.configuration).invoiceControllerGetInvoiceStatistics(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns the current invoice status for an order, including whether a new invoice can be created or if a credit note is required.
     * @summary Check invoice status for an order
     * @param {string} orderId Order ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InvoicesApi
     */
    public invoiceControllerGetInvoiceStatusForOrder(orderId: string, options?: AxiosRequestConfig) {
        return InvoicesApiFp(this.configuration).invoiceControllerGetInvoiceStatusForOrder(orderId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns invoice data as JSON
     * @summary Preview invoice data
     * @param {string} id Invoice ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InvoicesApi
     */
    public invoiceControllerPreviewInvoice(id: string, options?: AxiosRequestConfig) {
        return InvoicesApiFp(this.configuration).invoiceControllerPreviewInvoice(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Regenerates the PDF for an existing invoice without re-fiscalizing. Useful when PDF generation failed or when you need to update the PDF with latest template changes.
     * @summary Regenerate invoice PDF
     * @param {string} id Invoice ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InvoicesApi
     */
    public invoiceControllerRegenerateInvoicePdf(id: string, options?: AxiosRequestConfig) {
        return InvoicesApiFp(this.configuration).invoiceControllerRegenerateInvoicePdf(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Registers the default business premise with FURS and returns detailed response including any errors
     * @summary Register business premise with FURS
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InvoicesApi
     */
    public invoiceControllerRegisterBusinessPremise(options?: AxiosRequestConfig) {
        return InvoicesApiFp(this.configuration).invoiceControllerRegisterBusinessPremise(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Registers a specific business premise with FURS by ID and returns detailed response
     * @summary Register specific business premise with FURS
     * @param {string} businessPremiseId Business Premise ID (e.g., BP001)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InvoicesApi
     */
    public invoiceControllerRegisterSpecificBusinessPremise(businessPremiseId: string, options?: AxiosRequestConfig) {
        return InvoicesApiFp(this.configuration).invoiceControllerRegisterSpecificBusinessPremise(businessPremiseId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Used after an admin edits an invoice (e.g. removes a line). Updates the order amount and appends an audit entry to the order snapshot history. Allowed for already-paid orders (the response flags wasPaid so the UI can warn).
     * @summary Set the order total to match this invoice\'s total
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InvoicesApi
     */
    public invoiceControllerSyncOrderTotal(id: string, options?: AxiosRequestConfig) {
        return InvoicesApiFp(this.configuration).invoiceControllerSyncOrderTotal(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Exports invoices to CSV or XLSX format for accounting purposes. Supports date range and status filtering. Use ?format=csv or ?format=xlsx to specify the format (default: csv). Authentication: Accepts either JWT token or API key (API_KEY_EXPORT from environment) as Bearer token.
     * @summary Export invoices to CSV or XLSX
     * @param {string} [startDate] Start date for invoice export (ISO 8601 format)
     * @param {string} [endDate] End date for invoice export (ISO 8601 format)
     * @param {InvoiceExportControllerExportInvoicesCsvStatusEnum} [status] Filter by fiscalization status
     * @param {InvoiceExportControllerExportInvoicesCsvFormatEnum} [format] Export format (csv or xlsx)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InvoicesApi
     */
    public invoiceExportControllerExportInvoicesCsv(startDate?: string, endDate?: string, status?: InvoiceExportControllerExportInvoicesCsvStatusEnum, format?: InvoiceExportControllerExportInvoicesCsvFormatEnum, options?: AxiosRequestConfig) {
        return InvoicesApiFp(this.configuration).invoiceExportControllerExportInvoicesCsv(startDate, endDate, status, format, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Updates an invoice and regenerates the PDF. Only allowed when fiscalization status is PENDING.
     * @summary Update invoice
     * @param {string} id 
     * @param {UpdateInvoiceDto} updateInvoiceDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InvoicesApi
     */
    public updateOneBaseInvoiceControllerInvoice(id: string, updateInvoiceDto: UpdateInvoiceDto, options?: AxiosRequestConfig) {
        return InvoicesApiFp(this.configuration).updateOneBaseInvoiceControllerInvoice(id, updateInvoiceDto, options).then((request) => request(this.axios, this.basePath));
    }
}

/**
 * @export
 */
export const InvoiceExportControllerExportInvoicesCsvStatusEnum = {
    Pending: 'PENDING',
    Success: 'SUCCESS',
    Failed: 'FAILED',
    Retry: 'RETRY',
    Pantheon: 'PANTHEON'
} as const;
export type InvoiceExportControllerExportInvoicesCsvStatusEnum = typeof InvoiceExportControllerExportInvoicesCsvStatusEnum[keyof typeof InvoiceExportControllerExportInvoicesCsvStatusEnum];
/**
 * @export
 */
export const InvoiceExportControllerExportInvoicesCsvFormatEnum = {
    Csv: 'csv',
    Xlsx: 'xlsx'
} as const;
export type InvoiceExportControllerExportInvoicesCsvFormatEnum = typeof InvoiceExportControllerExportInvoicesCsvFormatEnum[keyof typeof InvoiceExportControllerExportInvoicesCsvFormatEnum];


/**
 * MapApi - axios parameter creator
 * @export
 */
export const MapApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Find a place by name (Nominatim proxy, cached, 1 req/s)
         * @param {string} q 
         * @param {string} [lang] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        geocodeControllerSearch: async (q: string, lang?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'q' is not null or undefined
            assertParamExists('geocodeControllerSearch', 'q', q)
            const localVarPath = `/map/search`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (q !== undefined) {
                localVarQueryParameter['q'] = q;
            }

            if (lang !== undefined) {
                localVarQueryParameter['lang'] = lang;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Render a map preview PNG for a place, its options and a size
         * @param {MapPreviewDto} mapPreviewDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mapPreviewControllerPreview: async (mapPreviewDto: MapPreviewDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'mapPreviewDto' is not null or undefined
            assertParamExists('mapPreviewControllerPreview', 'mapPreviewDto', mapPreviewDto)
            const localVarPath = `/map/preview`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(mapPreviewDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * MapApi - functional programming interface
 * @export
 */
export const MapApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = MapApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Find a place by name (Nominatim proxy, cached, 1 req/s)
         * @param {string} q 
         * @param {string} [lang] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async geocodeControllerSearch(q: string, lang?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<PlaceResultDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.geocodeControllerSearch(q, lang, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Render a map preview PNG for a place, its options and a size
         * @param {MapPreviewDto} mapPreviewDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async mapPreviewControllerPreview(mapPreviewDto: MapPreviewDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.mapPreviewControllerPreview(mapPreviewDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * MapApi - factory interface
 * @export
 */
export const MapApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = MapApiFp(configuration)
    return {
        /**
         * 
         * @summary Find a place by name (Nominatim proxy, cached, 1 req/s)
         * @param {string} q 
         * @param {string} [lang] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        geocodeControllerSearch(q: string, lang?: string, options?: any): AxiosPromise<Array<PlaceResultDto>> {
            return localVarFp.geocodeControllerSearch(q, lang, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Render a map preview PNG for a place, its options and a size
         * @param {MapPreviewDto} mapPreviewDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        mapPreviewControllerPreview(mapPreviewDto: MapPreviewDto, options?: any): AxiosPromise<void> {
            return localVarFp.mapPreviewControllerPreview(mapPreviewDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * MapApi - object-oriented interface
 * @export
 * @class MapApi
 * @extends {BaseAPI}
 */
export class MapApi extends BaseAPI {
    /**
     * 
     * @summary Find a place by name (Nominatim proxy, cached, 1 req/s)
     * @param {string} q 
     * @param {string} [lang] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MapApi
     */
    public geocodeControllerSearch(q: string, lang?: string, options?: AxiosRequestConfig) {
        return MapApiFp(this.configuration).geocodeControllerSearch(q, lang, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Render a map preview PNG for a place, its options and a size
     * @param {MapPreviewDto} mapPreviewDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MapApi
     */
    public mapPreviewControllerPreview(mapPreviewDto: MapPreviewDto, options?: AxiosRequestConfig) {
        return MapApiFp(this.configuration).mapPreviewControllerPreview(mapPreviewDto, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * MetaConversionsApi - axios parameter creator
 * @export
 */
export const MetaConversionsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Track page view event
         * @param {string} userAgent 
         * @param {TrackPageViewDto} trackPageViewDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        metaConversionsControllerTrackPageView: async (userAgent: string, trackPageViewDto: TrackPageViewDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userAgent' is not null or undefined
            assertParamExists('metaConversionsControllerTrackPageView', 'userAgent', userAgent)
            // verify required parameter 'trackPageViewDto' is not null or undefined
            assertParamExists('metaConversionsControllerTrackPageView', 'trackPageViewDto', trackPageViewDto)
            const localVarPath = `/meta-conversions/page-view`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (userAgent != null) {
                localVarHeaderParameter['user-agent'] = String(userAgent);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(trackPageViewDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * MetaConversionsApi - functional programming interface
 * @export
 */
export const MetaConversionsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = MetaConversionsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Track page view event
         * @param {string} userAgent 
         * @param {TrackPageViewDto} trackPageViewDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async metaConversionsControllerTrackPageView(userAgent: string, trackPageViewDto: TrackPageViewDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.metaConversionsControllerTrackPageView(userAgent, trackPageViewDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * MetaConversionsApi - factory interface
 * @export
 */
export const MetaConversionsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = MetaConversionsApiFp(configuration)
    return {
        /**
         * 
         * @summary Track page view event
         * @param {string} userAgent 
         * @param {TrackPageViewDto} trackPageViewDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        metaConversionsControllerTrackPageView(userAgent: string, trackPageViewDto: TrackPageViewDto, options?: any): AxiosPromise<void> {
            return localVarFp.metaConversionsControllerTrackPageView(userAgent, trackPageViewDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * MetaConversionsApi - object-oriented interface
 * @export
 * @class MetaConversionsApi
 * @extends {BaseAPI}
 */
export class MetaConversionsApi extends BaseAPI {
    /**
     * 
     * @summary Track page view event
     * @param {string} userAgent 
     * @param {TrackPageViewDto} trackPageViewDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MetaConversionsApi
     */
    public metaConversionsControllerTrackPageView(userAgent: string, trackPageViewDto: TrackPageViewDto, options?: AxiosRequestConfig) {
        return MetaConversionsApiFp(this.configuration).metaConversionsControllerTrackPageView(userAgent, trackPageViewDto, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * NewsletterApi - axios parameter creator
 * @export
 */
export const NewsletterApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Adds the address to the locale newsletter list as confirmed immediately; a consent record (ip, user agent, locale, timestamp) is kept as the audit trail. Always returns ok:true for accepted input.
         * @summary Public newsletter signup (single opt-in)
         * @param {SubscribeDto} subscribeDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        newsletterControllerSubscribe: async (subscribeDto: SubscribeDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'subscribeDto' is not null or undefined
            assertParamExists('newsletterControllerSubscribe', 'subscribeDto', subscribeDto)
            const localVarPath = `/newsletter/subscribe`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(subscribeDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * NewsletterApi - functional programming interface
 * @export
 */
export const NewsletterApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = NewsletterApiAxiosParamCreator(configuration)
    return {
        /**
         * Adds the address to the locale newsletter list as confirmed immediately; a consent record (ip, user agent, locale, timestamp) is kept as the audit trail. Always returns ok:true for accepted input.
         * @summary Public newsletter signup (single opt-in)
         * @param {SubscribeDto} subscribeDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async newsletterControllerSubscribe(subscribeDto: SubscribeDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SubscribeResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.newsletterControllerSubscribe(subscribeDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * NewsletterApi - factory interface
 * @export
 */
export const NewsletterApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = NewsletterApiFp(configuration)
    return {
        /**
         * Adds the address to the locale newsletter list as confirmed immediately; a consent record (ip, user agent, locale, timestamp) is kept as the audit trail. Always returns ok:true for accepted input.
         * @summary Public newsletter signup (single opt-in)
         * @param {SubscribeDto} subscribeDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        newsletterControllerSubscribe(subscribeDto: SubscribeDto, options?: any): AxiosPromise<SubscribeResponseDto> {
            return localVarFp.newsletterControllerSubscribe(subscribeDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * NewsletterApi - object-oriented interface
 * @export
 * @class NewsletterApi
 * @extends {BaseAPI}
 */
export class NewsletterApi extends BaseAPI {
    /**
     * Adds the address to the locale newsletter list as confirmed immediately; a consent record (ip, user agent, locale, timestamp) is kept as the audit trail. Always returns ok:true for accepted input.
     * @summary Public newsletter signup (single opt-in)
     * @param {SubscribeDto} subscribeDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NewsletterApi
     */
    public newsletterControllerSubscribe(subscribeDto: SubscribeDto, options?: AxiosRequestConfig) {
        return NewsletterApiFp(this.configuration).newsletterControllerSubscribe(subscribeDto, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * OrderApi - axios parameter creator
 * @export
 */
export const OrderApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Approve: cancel the order (canceledAt, credit, cashback, ORDER_CANCELED email), void the unfiscalized invoice. Card refunds stay manual in Stripe. 409 CANCEL_REQUEST_NOT_OPEN when already decided.
         * @param {string} id 
         * @param {string} [xGuestToken] Guest JWT token for unauthenticated users
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cancelRequestControllerApprove: async (id: string, xGuestToken?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('cancelRequestControllerApprove', 'id', id)
            const localVarPath = `/order/{id}/cancel-request/approve`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (xGuestToken != null) {
                localVarHeaderParameter['x-guest-token'] = String(xGuestToken);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Decline: release the hold. No customer email. 409 CANCEL_REQUEST_NOT_OPEN when already decided.
         * @param {string} id 
         * @param {DeclineCancelRequestDto} declineCancelRequestDto 
         * @param {string} [xGuestToken] Guest JWT token for unauthenticated users
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cancelRequestControllerDecline: async (id: string, declineCancelRequestDto: DeclineCancelRequestDto, xGuestToken?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('cancelRequestControllerDecline', 'id', id)
            // verify required parameter 'declineCancelRequestDto' is not null or undefined
            assertParamExists('cancelRequestControllerDecline', 'declineCancelRequestDto', declineCancelRequestDto)
            const localVarPath = `/order/{id}/cancel-request/decline`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (xGuestToken != null) {
                localVarHeaderParameter['x-guest-token'] = String(xGuestToken);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(declineCancelRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Open cancel requests, and approved card cancellations whose Stripe refund has not arrived (admin).
         * @param {string} [xGuestToken] Guest JWT token for unauthenticated users
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cancelRequestControllerQueue: async (xGuestToken?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/order/admin/cancel-requests`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (xGuestToken != null) {
                localVarHeaderParameter['x-guest-token'] = String(xGuestToken);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Ask for this order to be canceled. Held out of production until an admin decides. 409 CANCEL_REQUEST_NOT_ALLOWED with reason WINDOW_PASSED | IN_PRODUCTION | STATUS | KIND | ALREADY_REQUESTED; 404 while customerCancelRequestEnabled is off.
         * @param {string} id 
         * @param {CreateCancelRequestDto} createCancelRequestDto 
         * @param {string} [xGuestToken] Guest JWT token for unauthenticated users
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cancelRequestControllerRequest: async (id: string, createCancelRequestDto: CreateCancelRequestDto, xGuestToken?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('cancelRequestControllerRequest', 'id', id)
            // verify required parameter 'createCancelRequestDto' is not null or undefined
            assertParamExists('cancelRequestControllerRequest', 'createCancelRequestDto', createCancelRequestDto)
            const localVarPath = `/order/{id}/cancel-request`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (xGuestToken != null) {
                localVarHeaderParameter['x-guest-token'] = String(xGuestToken);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createCancelRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Create a single Order
         * @param {CreateOrderDto} createOrderDto 
         * @param {string} [xGuestToken] Guest JWT token for unauthenticated users
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createOneBaseOrderControllerOrder: async (createOrderDto: CreateOrderDto, xGuestToken?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createOrderDto' is not null or undefined
            assertParamExists('createOneBaseOrderControllerOrder', 'createOrderDto', createOrderDto)
            const localVarPath = `/order`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (xGuestToken != null) {
                localVarHeaderParameter['x-guest-token'] = String(xGuestToken);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createOrderDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Delete a single Order
         * @param {string} id 
         * @param {string} [xGuestToken] Guest JWT token for unauthenticated users
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOneBaseOrderControllerOrder: async (id: string, xGuestToken?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('deleteOneBaseOrderControllerOrder', 'id', id)
            const localVarPath = `/order/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (xGuestToken != null) {
                localVarHeaderParameter['x-guest-token'] = String(xGuestToken);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Retrieve multiple Orders
         * @param {string} [xGuestToken] Guest JWT token for unauthenticated users
         * @param {Array<string>} [fields] Selects resource fields. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#select\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {string} [s] Adds search condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#search\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {Array<string>} [filter] Adds filter condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#filter\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {Array<string>} [or] Adds OR condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#or\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {Array<string>} [sort] Adds sort by field. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#sort\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {Array<string>} [join] Adds relational resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#join\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {number} [limit] Limit amount of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#limit\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {number} [offset] Offset amount of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#offset\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {number} [page] Page portion of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#page\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {number} [cache] Reset cache (if was enabled). &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#cache\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getManyBaseOrderControllerOrder: async (xGuestToken?: string, fields?: Array<string>, s?: string, filter?: Array<string>, or?: Array<string>, sort?: Array<string>, join?: Array<string>, limit?: number, offset?: number, page?: number, cache?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/order`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (fields) {
                localVarQueryParameter['fields'] = fields;
            }

            if (s !== undefined) {
                localVarQueryParameter['s'] = s;
            }

            if (filter) {
                localVarQueryParameter['filter'] = filter;
            }

            if (or) {
                localVarQueryParameter['or'] = or;
            }

            if (sort) {
                localVarQueryParameter['sort'] = sort;
            }

            if (join) {
                localVarQueryParameter['join'] = join;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (cache !== undefined) {
                localVarQueryParameter['cache'] = cache;
            }

            if (xGuestToken != null) {
                localVarHeaderParameter['x-guest-token'] = String(xGuestToken);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Retrieve a single Order
         * @param {string} id 
         * @param {string} [xGuestToken] Guest JWT token for unauthenticated users
         * @param {Array<string>} [fields] Selects resource fields. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#select\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {Array<string>} [join] Adds relational resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#join\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {number} [cache] Reset cache (if was enabled). &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#cache\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOneBaseOrderControllerOrder: async (id: string, xGuestToken?: string, fields?: Array<string>, join?: Array<string>, cache?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getOneBaseOrderControllerOrder', 'id', id)
            const localVarPath = `/order/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (fields) {
                localVarQueryParameter['fields'] = fields;
            }

            if (join) {
                localVarQueryParameter['join'] = join;
            }

            if (cache !== undefined) {
                localVarQueryParameter['cache'] = cache;
            }

            if (xGuestToken != null) {
                localVarHeaderParameter['x-guest-token'] = String(xGuestToken);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Abandon the order\'s open Stripe payment attempt so its price pin (and credit) can change again. Idempotent.
         * @param {string} id Order ID
         * @param {string} [xGuestToken] Guest JWT token for unauthenticated users
         * @param {AbandonPaymentDto} [abandonPaymentDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        orderControllerAbandonPayment: async (id: string, xGuestToken?: string, abandonPaymentDto?: AbandonPaymentDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('orderControllerAbandonPayment', 'id', id)
            const localVarPath = `/order/{id}/abandon-payment`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (xGuestToken != null) {
                localVarHeaderParameter['x-guest-token'] = String(xGuestToken);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(abandonPaymentDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Add a catalogue artwork to an order
         * @param {string} id Order ID
         * @param {AddArtworkToOrderDto} addArtworkToOrderDto 
         * @param {string} [xGuestToken] Guest JWT token for unauthenticated users
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        orderControllerAddArtwork: async (id: string, addArtworkToOrderDto: AddArtworkToOrderDto, xGuestToken?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('orderControllerAddArtwork', 'id', id)
            // verify required parameter 'addArtworkToOrderDto' is not null or undefined
            assertParamExists('orderControllerAddArtwork', 'addArtworkToOrderDto', addArtworkToOrderDto)
            const localVarPath = `/order/{id}/add-artwork`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (xGuestToken != null) {
                localVarHeaderParameter['x-guest-token'] = String(xGuestToken);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(addArtworkToOrderDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Add a map print to an order
         * @param {string} id Order ID
         * @param {AddMapToOrderDto} addMapToOrderDto 
         * @param {string} [xGuestToken] Guest JWT token for unauthenticated users
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        orderControllerAddMap: async (id: string, addMapToOrderDto: AddMapToOrderDto, xGuestToken?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('orderControllerAddMap', 'id', id)
            // verify required parameter 'addMapToOrderDto' is not null or undefined
            assertParamExists('orderControllerAddMap', 'addMapToOrderDto', addMapToOrderDto)
            const localVarPath = `/order/{id}/add-map`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (xGuestToken != null) {
                localVarHeaderParameter['x-guest-token'] = String(xGuestToken);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(addMapToOrderDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary [Deprecated] Add order calendar — use POST /order/:id/calendars instead
         * @param {string} id Order ID
         * @param {OrderControllerAddOrderCalendarFormatEnum} format Calendar format
         * @param {number} quantity Quantity of calendars
         * @param {File} file Calendar PDF file (required)
         * @param {string} [xGuestToken] Guest JWT token for unauthenticated users
         * @param {OrderControllerAddOrderCalendarPaperEnum} [paper] Calendar paper (optional, defaults to \\\&#39;white\\\&#39;)
         * @param {string} [calendarData] Optional calendar configuration data (JSON string)
         * @param {string} [photoSettings] Optional photo settings array (JSON string) - position, rotation, filters, etc.
         * @param {string} [photoKeys] Optional comma-separated list of existing photo keys/IDs to attach to calendar
         * @param {Array<File>} [photos] Optional array of photo files to upload and attach to calendar
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        orderControllerAddOrderCalendar: async (id: string, format: OrderControllerAddOrderCalendarFormatEnum, quantity: number, file: File, xGuestToken?: string, paper?: OrderControllerAddOrderCalendarPaperEnum, calendarData?: string, photoSettings?: string, photoKeys?: string, photos?: Array<File>, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('orderControllerAddOrderCalendar', 'id', id)
            // verify required parameter 'format' is not null or undefined
            assertParamExists('orderControllerAddOrderCalendar', 'format', format)
            // verify required parameter 'quantity' is not null or undefined
            assertParamExists('orderControllerAddOrderCalendar', 'quantity', quantity)
            // verify required parameter 'file' is not null or undefined
            assertParamExists('orderControllerAddOrderCalendar', 'file', file)
            const localVarPath = `/order/{id}/add-order-calendar`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (xGuestToken != null) {
                localVarHeaderParameter['x-guest-token'] = String(xGuestToken);
            }


            if (format !== undefined) { 
                localVarFormParams.append('format', format as any);
            }
    
            if (paper !== undefined) { 
                localVarFormParams.append('paper', paper as any);
            }
    
            if (quantity !== undefined) { 
                localVarFormParams.append('quantity', quantity as any);
            }
    
            if (calendarData !== undefined) { 
                localVarFormParams.append('calendarData', calendarData as any);
            }
    
            if (photoSettings !== undefined) { 
                localVarFormParams.append('photoSettings', photoSettings as any);
            }
    
            if (photoKeys !== undefined) { 
                localVarFormParams.append('photoKeys', photoKeys as any);
            }
    
            if (file !== undefined) { 
                localVarFormParams.append('file', file as any);
            }
                if (photos) {
                photos.forEach((element) => {
                    localVarFormParams.append('photos', element as any);
                })
            }

    
    
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Add a calendar to an order (multipart)
         * @param {string} id Order ID
         * @param {string} [xGuestToken] Guest JWT token for unauthenticated users
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        orderControllerAddOrderCalendarUnified: async (id: string, xGuestToken?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('orderControllerAddOrderCalendarUnified', 'id', id)
            const localVarPath = `/order/{id}/calendars`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (xGuestToken != null) {
                localVarHeaderParameter['x-guest-token'] = String(xGuestToken);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary [Deprecated] Add order photos — use POST /order/:id/photos instead
         * @param {string} id Order ID
         * @param {OrderControllerAddOrderPhotosRequest} orderControllerAddOrderPhotosRequest Order Data
         * @param {string} [xGuestToken] Guest JWT token for unauthenticated users
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        orderControllerAddOrderPhotos: async (id: string, orderControllerAddOrderPhotosRequest: OrderControllerAddOrderPhotosRequest, xGuestToken?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('orderControllerAddOrderPhotos', 'id', id)
            // verify required parameter 'orderControllerAddOrderPhotosRequest' is not null or undefined
            assertParamExists('orderControllerAddOrderPhotos', 'orderControllerAddOrderPhotosRequest', orderControllerAddOrderPhotosRequest)
            const localVarPath = `/order/{id}/add-order-photos`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (xGuestToken != null) {
                localVarHeaderParameter['x-guest-token'] = String(xGuestToken);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(orderControllerAddOrderPhotosRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Add photos to an order
         * @param {string} id Order ID
         * @param {OrderControllerAddOrderPhotosRequest} orderControllerAddOrderPhotosRequest 
         * @param {string} [xGuestToken] Guest JWT token for unauthenticated users
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        orderControllerAddOrderPhotosUnified: async (id: string, orderControllerAddOrderPhotosRequest: OrderControllerAddOrderPhotosRequest, xGuestToken?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('orderControllerAddOrderPhotosUnified', 'id', id)
            // verify required parameter 'orderControllerAddOrderPhotosRequest' is not null or undefined
            assertParamExists('orderControllerAddOrderPhotosUnified', 'orderControllerAddOrderPhotosRequest', orderControllerAddOrderPhotosRequest)
            const localVarPath = `/order/{id}/photos`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (xGuestToken != null) {
                localVarHeaderParameter['x-guest-token'] = String(xGuestToken);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(orderControllerAddOrderPhotosRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary [Deprecated] Add order product detail — use POST /order/:id/products instead
         * @param {string} id Order ID
         * @param {OrderControllerAddOrderProductDetailRequest} orderControllerAddOrderProductDetailRequest Product detail data to add
         * @param {string} [xGuestToken] Guest JWT token for unauthenticated users
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        orderControllerAddOrderProductDetail: async (id: string, orderControllerAddOrderProductDetailRequest: OrderControllerAddOrderProductDetailRequest, xGuestToken?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('orderControllerAddOrderProductDetail', 'id', id)
            // verify required parameter 'orderControllerAddOrderProductDetailRequest' is not null or undefined
            assertParamExists('orderControllerAddOrderProductDetail', 'orderControllerAddOrderProductDetailRequest', orderControllerAddOrderProductDetailRequest)
            const localVarPath = `/order/{id}/add-order-product-detail`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (xGuestToken != null) {
                localVarHeaderParameter['x-guest-token'] = String(xGuestToken);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(orderControllerAddOrderProductDetailRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Add party-camera photos to an order (one print group)
         * @param {string} id Order ID
         * @param {AddPartyPhotosDto} addPartyPhotosDto 
         * @param {string} [xGuestToken] Guest JWT token for unauthenticated users
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        orderControllerAddPartyPhotos: async (id: string, addPartyPhotosDto: AddPartyPhotosDto, xGuestToken?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('orderControllerAddPartyPhotos', 'id', id)
            // verify required parameter 'addPartyPhotosDto' is not null or undefined
            assertParamExists('orderControllerAddPartyPhotos', 'addPartyPhotosDto', addPartyPhotosDto)
            const localVarPath = `/order/{id}/add-party-photos`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (xGuestToken != null) {
                localVarHeaderParameter['x-guest-token'] = String(xGuestToken);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(addPartyPhotosDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Add a product-with-media (greeting card) line to an order
         * @param {string} id Order ID
         * @param {AddProductWithMediaToOrderDto} addProductWithMediaToOrderDto 
         * @param {string} [xGuestToken] Guest JWT token for unauthenticated users
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        orderControllerAddProductWithMedia: async (id: string, addProductWithMediaToOrderDto: AddProductWithMediaToOrderDto, xGuestToken?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('orderControllerAddProductWithMedia', 'id', id)
            // verify required parameter 'addProductWithMediaToOrderDto' is not null or undefined
            assertParamExists('orderControllerAddProductWithMedia', 'addProductWithMediaToOrderDto', addProductWithMediaToOrderDto)
            const localVarPath = `/order/{id}/add-product-with-media`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (xGuestToken != null) {
                localVarHeaderParameter['x-guest-token'] = String(xGuestToken);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(addProductWithMediaToOrderDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Apply the customer\'s granted credit to this order, after any coupon.
         * @param {string} id Order ID
         * @param {UpdateOrderCreditDto} updateOrderCreditDto Credit token, and optionally the lots to spend
         * @param {string} [xGuestToken] Guest JWT token for unauthenticated users
         * @param {string} [xClientChannel] Client channel; re-derives the order\&#39;s channel on the recalculation after the credit is applied, while the order is unpinned. The exact value \&#39;MOBILE\&#39; switches it to the app\&#39;s own pricing chain, any other present value switches it to WEB, and an absent or blank header leaves the stored channel untouched.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        orderControllerApplyCreditToOrder: async (id: string, updateOrderCreditDto: UpdateOrderCreditDto, xGuestToken?: string, xClientChannel?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('orderControllerApplyCreditToOrder', 'id', id)
            // verify required parameter 'updateOrderCreditDto' is not null or undefined
            assertParamExists('orderControllerApplyCreditToOrder', 'updateOrderCreditDto', updateOrderCreditDto)
            const localVarPath = `/order/apply-credit/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (xGuestToken != null) {
                localVarHeaderParameter['x-guest-token'] = String(xGuestToken);
            }

            if (xClientChannel != null) {
                localVarHeaderParameter['x-client-channel'] = String(xClientChannel);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateOrderCreditDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Bundles for this order: applied, the selected bundle\'s slot progress, the hint, the coupon block.
         * @param {string} id 
         * @param {string} [xGuestToken] Guest JWT token for unauthenticated users
         * @param {string} [locale] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        orderControllerBundles: async (id: string, xGuestToken?: string, locale?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('orderControllerBundles', 'id', id)
            const localVarPath = `/order/{id}/bundles`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (locale !== undefined) {
                localVarQueryParameter['locale'] = locale;
            }

            if (xGuestToken != null) {
                localVarHeaderParameter['x-guest-token'] = String(xGuestToken);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Calculate total amount for an order
         * @param {string} id Order ID
         * @param {string} [xGuestToken] Guest JWT token for unauthenticated users
         * @param {string} [xClientChannel] Client channel; re-derives the order\&#39;s channel on this post-edit recalculation, while the order is unpinned. The exact value \&#39;MOBILE\&#39; switches it to the app\&#39;s own pricing chain, any other present value switches it to WEB, and an absent or blank header leaves the stored channel untouched.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        orderControllerCalculateAmount: async (id: string, xGuestToken?: string, xClientChannel?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('orderControllerCalculateAmount', 'id', id)
            const localVarPath = `/order/{id}/calculate-amount`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (xGuestToken != null) {
                localVarHeaderParameter['x-guest-token'] = String(xGuestToken);
            }

            if (xClientChannel != null) {
                localVarHeaderParameter['x-client-channel'] = String(xClientChannel);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Cashback for this order: a live preview while unpaid, pending once placed, the award once recorded.
         * @param {string} id 
         * @param {string} [xGuestToken] Guest JWT token for unauthenticated users
         * @param {OrderControllerCashbackPaymentOptionEnum} [paymentOption] The cart\&#39;s current choice; only an unpaid cart\&#39;s preview uses it.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        orderControllerCashback: async (id: string, xGuestToken?: string, paymentOption?: OrderControllerCashbackPaymentOptionEnum, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('orderControllerCashback', 'id', id)
            const localVarPath = `/order/{id}/cashback`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (paymentOption !== undefined) {
                localVarQueryParameter['paymentOption'] = paymentOption;
            }

            if (xGuestToken != null) {
                localVarHeaderParameter['x-guest-token'] = String(xGuestToken);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Change a photo group\'s size (merges into an existing group of that size with the same options)
         * @param {string} id Order ID
         * @param {string} childId Order Photo ID
         * @param {ChangeOrderPhotoSizeDto} changeOrderPhotoSizeDto 
         * @param {string} [xGuestToken] Guest JWT token for unauthenticated users
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        orderControllerChangeOrderPhotoSize: async (id: string, childId: string, changeOrderPhotoSizeDto: ChangeOrderPhotoSizeDto, xGuestToken?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('orderControllerChangeOrderPhotoSize', 'id', id)
            // verify required parameter 'childId' is not null or undefined
            assertParamExists('orderControllerChangeOrderPhotoSize', 'childId', childId)
            // verify required parameter 'changeOrderPhotoSizeDto' is not null or undefined
            assertParamExists('orderControllerChangeOrderPhotoSize', 'changeOrderPhotoSizeDto', changeOrderPhotoSizeDto)
            const localVarPath = `/order/{id}/photos/{childId}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)))
                .replace(`{${"childId"}}`, encodeURIComponent(String(childId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (xGuestToken != null) {
                localVarHeaderParameter['x-guest-token'] = String(xGuestToken);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(changeOrderPhotoSizeDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get coupon by code
         * @param {string} code 
         * @param {string} [xGuestToken] Guest JWT token for unauthenticated users
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        orderControllerCheckCoupon: async (code: string, xGuestToken?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'code' is not null or undefined
            assertParamExists('orderControllerCheckCoupon', 'code', code)
            const localVarPath = `/order/check-coupon/{code}`
                .replace(`{${"code"}}`, encodeURIComponent(String(code)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (xGuestToken != null) {
                localVarHeaderParameter['x-guest-token'] = String(xGuestToken);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Choose the photo for the free 30 x 40 enlargement the basket earned. 400 when the order has none; 404 when the photo is not in its paid lines.
         * @param {string} id 
         * @param {ChooseFreeEnlargementDto} chooseFreeEnlargementDto 
         * @param {string} [xGuestToken] Guest JWT token for unauthenticated users
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        orderControllerChooseFreeEnlargement: async (id: string, chooseFreeEnlargementDto: ChooseFreeEnlargementDto, xGuestToken?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('orderControllerChooseFreeEnlargement', 'id', id)
            // verify required parameter 'chooseFreeEnlargementDto' is not null or undefined
            assertParamExists('orderControllerChooseFreeEnlargement', 'chooseFreeEnlargementDto', chooseFreeEnlargementDto)
            const localVarPath = `/order/{id}/free-enlargement`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (xGuestToken != null) {
                localVarHeaderParameter['x-guest-token'] = String(xGuestToken);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(chooseFreeEnlargementDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Clear cache
         * @param {string} [xGuestToken] Guest JWT token for unauthenticated users
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        orderControllerClearCache: async (xGuestToken?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/order/clear-cache`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (xGuestToken != null) {
                localVarHeaderParameter['x-guest-token'] = String(xGuestToken);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Create an order
         * @param {CreateUserOrderDTO} createUserOrderDTO Order Data
         * @param {string} [xGuestToken] Guest JWT token for unauthenticated users
         * @param {string} [xClientChannel] Client channel; selects the channel recorded on the new order. The exact value \&#39;MOBILE\&#39; records an app order and prices it down the app\&#39;s own chain; any other present value records WEB; only an absent header falls back to the body\&#39;s (deprecated) orderSource.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        orderControllerCreateOrder: async (createUserOrderDTO: CreateUserOrderDTO, xGuestToken?: string, xClientChannel?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createUserOrderDTO' is not null or undefined
            assertParamExists('orderControllerCreateOrder', 'createUserOrderDTO', createUserOrderDTO)
            const localVarPath = `/order/user-order`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (xGuestToken != null) {
                localVarHeaderParameter['x-guest-token'] = String(xGuestToken);
            }

            if (xClientChannel != null) {
                localVarHeaderParameter['x-client-channel'] = String(xClientChannel);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createUserOrderDTO, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {string} [xGuestToken] Guest JWT token for unauthenticated users
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        orderControllerCreateReceipt: async (id: string, xGuestToken?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('orderControllerCreateReceipt', 'id', id)
            const localVarPath = `/order/create-receipt/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (xGuestToken != null) {
                localVarHeaderParameter['x-guest-token'] = String(xGuestToken);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Checkout funnel conversion vs the same weekday (admin)
         * @param {string} [xGuestToken] Guest JWT token for unauthenticated users
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        orderControllerFunnelHealth: async (xGuestToken?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/order/funnel-health`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (xGuestToken != null) {
                localVarHeaderParameter['x-guest-token'] = String(xGuestToken);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {string} [xGuestToken] Guest JWT token for unauthenticated users
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        orderControllerGetEditorGuestSession: async (id: string, xGuestToken?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('orderControllerGetEditorGuestSession', 'id', id)
            const localVarPath = `/order/{id}/guest-session`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (xGuestToken != null) {
                localVarHeaderParameter['x-guest-token'] = String(xGuestToken);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Prepares the parcel if it has not been prepared yet, then returns the label document from MyGLS GetPrintedLabels. Safe to call repeatedly: the stored ParcelId is reused, so no duplicate parcel is registered.
         * @summary Download the printable GLS label (prevoznica) for an order
         * @param {string} id 
         * @param {string} [xGuestToken] Guest JWT token for unauthenticated users
         * @param {string} [printer] GLS label format to request, overriding GLS_TYPE_OF_PRINTER. The 62mm workflow asks for Thermo (an 85x85mm square label) because that is the only output worth downscaling — an A4_* sheet scaled to 62mm would shrink the label itself to roughly 18mm. Invalid values are rejected by GlsService before any call to GLS.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        orderControllerGetGlsLabelDocument: async (id: string, xGuestToken?: string, printer?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('orderControllerGetGlsLabelDocument', 'id', id)
            const localVarPath = `/order/glsLabelDocument/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (printer !== undefined) {
                localVarQueryParameter['printer'] = printer;
            }

            if (xGuestToken != null) {
                localVarHeaderParameter['x-guest-token'] = String(xGuestToken);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get all orders for analytics
         * @param {string} [xGuestToken] Guest JWT token for unauthenticated users
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        orderControllerGetManyForAnalytics: async (xGuestToken?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/order/analytics`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (xGuestToken != null) {
                localVarHeaderParameter['x-guest-token'] = String(xGuestToken);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Order event log / audit trail (admin)
         * @param {string} id 
         * @param {string} [xGuestToken] Guest JWT token for unauthenticated users
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        orderControllerGetOrderEvents: async (id: string, xGuestToken?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('orderControllerGetOrderEvents', 'id', id)
            const localVarPath = `/order/{id}/events`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (xGuestToken != null) {
                localVarHeaderParameter['x-guest-token'] = String(xGuestToken);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Orders Stripe charged that we never finalized (admin)
         * @param {string} [xGuestToken] Guest JWT token for unauthenticated users
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        orderControllerGetPaymentAlerts: async (xGuestToken?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/order/admin/payment-alerts`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (xGuestToken != null) {
                localVarHeaderParameter['x-guest-token'] = String(xGuestToken);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get all orders for the authenticated user
         * @param {string} [xGuestToken] Guest JWT token for unauthenticated users
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        orderControllerGetUserOrders: async (xGuestToken?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/order/user-orders`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (xGuestToken != null) {
                localVarHeaderParameter['x-guest-token'] = String(xGuestToken);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {string} [xGuestToken] Guest JWT token for unauthenticated users
         * @param {PreparePaymentRequestDto} [preparePaymentRequestDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        orderControllerNotifyPaymentOnDelivery: async (id: string, xGuestToken?: string, preparePaymentRequestDto?: PreparePaymentRequestDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('orderControllerNotifyPaymentOnDelivery', 'id', id)
            const localVarPath = `/order/notify-payment-on-delivery/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (xGuestToken != null) {
                localVarHeaderParameter['x-guest-token'] = String(xGuestToken);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(preparePaymentRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Notify user to complete purchase
         * @param {string} id Order ID
         * @param {string} [xGuestToken] Guest JWT token for unauthenticated users
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        orderControllerNotifyUserToCompletePurchase: async (id: string, xGuestToken?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('orderControllerNotifyUserToCompletePurchase', 'id', id)
            const localVarPath = `/order/{id}/notify-user-to-complete-purchase`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (xGuestToken != null) {
                localVarHeaderParameter['x-guest-token'] = String(xGuestToken);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Stuck / unfulfillable order counts (admin)
         * @param {string} [xGuestToken] Guest JWT token for unauthenticated users
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        orderControllerOrderHealth: async (xGuestToken?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/order/order-health`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (xGuestToken != null) {
                localVarHeaderParameter['x-guest-token'] = String(xGuestToken);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get all orders for analytics
         * @param {string} id 
         * @param {string} [xGuestToken] Guest JWT token for unauthenticated users
         * @param {string} [newParcel] true registers a replacement parcel at GLS even though the order already has one. Absent (what every existing caller sends), the stored parcel is returned and GLS is not called, so repeated clicks on GLS Label or Print Order no longer register a parcel each.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        orderControllerPrepareGlsLabel: async (id: string, xGuestToken?: string, newParcel?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('orderControllerPrepareGlsLabel', 'id', id)
            const localVarPath = `/order/glsLabel/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (newParcel !== undefined) {
                localVarQueryParameter['newParcel'] = newParcel;
            }

            if (xGuestToken != null) {
                localVarHeaderParameter['x-guest-token'] = String(xGuestToken);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Create a native Stripe PaymentIntent for in-app (mobile) payment
         * @param {string} id Order ID
         * @param {string} [xGuestToken] Guest JWT token for unauthenticated users
         * @param {PreparePaymentRequestDto} [preparePaymentRequestDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        orderControllerPrepareNativeOrderPayment: async (id: string, xGuestToken?: string, preparePaymentRequestDto?: PreparePaymentRequestDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('orderControllerPrepareNativeOrderPayment', 'id', id)
            const localVarPath = `/order/{id}/payment-intent`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (xGuestToken != null) {
                localVarHeaderParameter['x-guest-token'] = String(xGuestToken);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(preparePaymentRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Process payment for an order
         * @param {string} id Order ID
         * @param {string} [xGuestToken] Guest JWT token for unauthenticated users
         * @param {PreparePaymentRequestDto} [preparePaymentRequestDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        orderControllerPrepareOrderPayment: async (id: string, xGuestToken?: string, preparePaymentRequestDto?: PreparePaymentRequestDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('orderControllerPrepareOrderPayment', 'id', id)
            const localVarPath = `/order/{id}/payment`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (xGuestToken != null) {
                localVarHeaderParameter['x-guest-token'] = String(xGuestToken);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(preparePaymentRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Record a checkout-flow checkpoint for an order
         * @param {string} id Order ID
         * @param {RecordCheckpointDto} recordCheckpointDto 
         * @param {string} [xGuestToken] Guest JWT token for unauthenticated users
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        orderControllerRecordCheckpoint: async (id: string, recordCheckpointDto: RecordCheckpointDto, xGuestToken?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('orderControllerRecordCheckpoint', 'id', id)
            // verify required parameter 'recordCheckpointDto' is not null or undefined
            assertParamExists('orderControllerRecordCheckpoint', 'recordCheckpointDto', recordCheckpointDto)
            const localVarPath = `/order/{id}/checkpoint`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (xGuestToken != null) {
                localVarHeaderParameter['x-guest-token'] = String(xGuestToken);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(recordCheckpointDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Remove coupon from an order
         * @param {string} id Order ID
         * @param {string} [xGuestToken] Guest JWT token for unauthenticated users
         * @param {string} [xClientChannel] Client channel; re-derives the order\&#39;s channel on the recalculation after the coupon is removed, while the order is unpinned. The exact value \&#39;MOBILE\&#39; switches it to the app\&#39;s own pricing chain, any other present value switches it to WEB, and an absent or blank header leaves the stored channel untouched.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        orderControllerRemoveCouponFromOrder: async (id: string, xGuestToken?: string, xClientChannel?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('orderControllerRemoveCouponFromOrder', 'id', id)
            const localVarPath = `/order/remove-coupon/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (xGuestToken != null) {
                localVarHeaderParameter['x-guest-token'] = String(xGuestToken);
            }

            if (xClientChannel != null) {
                localVarHeaderParameter['x-client-channel'] = String(xClientChannel);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Take the applied credit back off this order; the lots are restored.
         * @param {string} id Order ID
         * @param {string} [xGuestToken] Guest JWT token for unauthenticated users
         * @param {string} [xClientChannel] Client channel; re-derives the order\&#39;s channel on the recalculation after the credit is removed, while the order is unpinned. The exact value \&#39;MOBILE\&#39; switches it to the app\&#39;s own pricing chain, any other present value switches it to WEB, and an absent or blank header leaves the stored channel untouched.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        orderControllerRemoveCreditFromOrder: async (id: string, xGuestToken?: string, xClientChannel?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('orderControllerRemoveCreditFromOrder', 'id', id)
            const localVarPath = `/order/remove-credit/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (xGuestToken != null) {
                localVarHeaderParameter['x-guest-token'] = String(xGuestToken);
            }

            if (xClientChannel != null) {
                localVarHeaderParameter['x-client-channel'] = String(xClientChannel);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary [Deprecated] Remove order calendar — use DELETE /order/:id/calendars/:childId instead
         * @param {string} id Order ID
         * @param {OrderControllerRemoveOrderCalendarRequest} orderControllerRemoveOrderCalendarRequest Calendar ID to remove
         * @param {string} [xGuestToken] Guest JWT token for unauthenticated users
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        orderControllerRemoveOrderCalendar: async (id: string, orderControllerRemoveOrderCalendarRequest: OrderControllerRemoveOrderCalendarRequest, xGuestToken?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('orderControllerRemoveOrderCalendar', 'id', id)
            // verify required parameter 'orderControllerRemoveOrderCalendarRequest' is not null or undefined
            assertParamExists('orderControllerRemoveOrderCalendar', 'orderControllerRemoveOrderCalendarRequest', orderControllerRemoveOrderCalendarRequest)
            const localVarPath = `/order/{id}/remove-order-calendar`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (xGuestToken != null) {
                localVarHeaderParameter['x-guest-token'] = String(xGuestToken);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(orderControllerRemoveOrderCalendarRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Remove an order calendar
         * @param {string} id Order ID
         * @param {string} childId Order calendar ID
         * @param {string} [xGuestToken] Guest JWT token for unauthenticated users
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        orderControllerRemoveOrderCalendarUnified: async (id: string, childId: string, xGuestToken?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('orderControllerRemoveOrderCalendarUnified', 'id', id)
            // verify required parameter 'childId' is not null or undefined
            assertParamExists('orderControllerRemoveOrderCalendarUnified', 'childId', childId)
            const localVarPath = `/order/{id}/calendars/{childId}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)))
                .replace(`{${"childId"}}`, encodeURIComponent(String(childId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (xGuestToken != null) {
                localVarHeaderParameter['x-guest-token'] = String(xGuestToken);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary [Deprecated] Remove an order photo — use DELETE /order/:id/photos/:childId instead
         * @param {string} id Order ID
         * @param {string} orderPhotoId Order Photo ID
         * @param {string} [xGuestToken] Guest JWT token for unauthenticated users
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        orderControllerRemoveOrderPhoto: async (id: string, orderPhotoId: string, xGuestToken?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('orderControllerRemoveOrderPhoto', 'id', id)
            // verify required parameter 'orderPhotoId' is not null or undefined
            assertParamExists('orderControllerRemoveOrderPhoto', 'orderPhotoId', orderPhotoId)
            const localVarPath = `/order/{id}/remove-order-photo/{orderPhotoId}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)))
                .replace(`{${"orderPhotoId"}}`, encodeURIComponent(String(orderPhotoId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (xGuestToken != null) {
                localVarHeaderParameter['x-guest-token'] = String(xGuestToken);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Remove an order photo from an order
         * @param {string} id Order ID
         * @param {string} childId Order Photo ID
         * @param {string} [xGuestToken] Guest JWT token for unauthenticated users
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        orderControllerRemoveOrderPhotoUnified: async (id: string, childId: string, xGuestToken?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('orderControllerRemoveOrderPhotoUnified', 'id', id)
            // verify required parameter 'childId' is not null or undefined
            assertParamExists('orderControllerRemoveOrderPhotoUnified', 'childId', childId)
            const localVarPath = `/order/{id}/photos/{childId}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)))
                .replace(`{${"childId"}}`, encodeURIComponent(String(childId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (xGuestToken != null) {
                localVarHeaderParameter['x-guest-token'] = String(xGuestToken);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Remove an order product detail
         * @param {string} id Order ID
         * @param {string} childId Order product detail ID
         * @param {string} [xGuestToken] Guest JWT token for unauthenticated users
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        orderControllerRemoveOrderProduct: async (id: string, childId: string, xGuestToken?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('orderControllerRemoveOrderProduct', 'id', id)
            // verify required parameter 'childId' is not null or undefined
            assertParamExists('orderControllerRemoveOrderProduct', 'childId', childId)
            const localVarPath = `/order/{id}/products/{childId}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)))
                .replace(`{${"childId"}}`, encodeURIComponent(String(childId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (xGuestToken != null) {
                localVarHeaderParameter['x-guest-token'] = String(xGuestToken);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Remove order product detail from an order
         * @param {string} id Order ID
         * @param {OrderControllerRemoveOrderProductDetailsRequest} orderControllerRemoveOrderProductDetailsRequest Product detail ID to remove
         * @param {string} [xGuestToken] Guest JWT token for unauthenticated users
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        orderControllerRemoveOrderProductDetails: async (id: string, orderControllerRemoveOrderProductDetailsRequest: OrderControllerRemoveOrderProductDetailsRequest, xGuestToken?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('orderControllerRemoveOrderProductDetails', 'id', id)
            // verify required parameter 'orderControllerRemoveOrderProductDetailsRequest' is not null or undefined
            assertParamExists('orderControllerRemoveOrderProductDetails', 'orderControllerRemoveOrderProductDetailsRequest', orderControllerRemoveOrderProductDetailsRequest)
            const localVarPath = `/order/{id}/remove-order-product-details`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (xGuestToken != null) {
                localVarHeaderParameter['x-guest-token'] = String(xGuestToken);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(orderControllerRemoveOrderProductDetailsRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Remove a product-with-media line from an order
         * @param {string} id 
         * @param {string} lineId 
         * @param {string} [xGuestToken] Guest JWT token for unauthenticated users
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        orderControllerRemoveProductWithMedia: async (id: string, lineId: string, xGuestToken?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('orderControllerRemoveProductWithMedia', 'id', id)
            // verify required parameter 'lineId' is not null or undefined
            assertParamExists('orderControllerRemoveProductWithMedia', 'lineId', lineId)
            const localVarPath = `/order/{id}/product-with-media/{lineId}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)))
                .replace(`{${"lineId"}}`, encodeURIComponent(String(lineId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (xGuestToken != null) {
                localVarHeaderParameter['x-guest-token'] = String(xGuestToken);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Admin: send a post-purchase email for an order through Listmonk, without marking it as sent (idempotent for testing).
         * @param {string} id Order ID
         * @param {OrderControllerSendPostPurchaseTestEmailRequest} orderControllerSendPostPurchaseTestEmailRequest 
         * @param {string} [xGuestToken] Guest JWT token for unauthenticated users
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        orderControllerSendPostPurchaseTestEmail: async (id: string, orderControllerSendPostPurchaseTestEmailRequest: OrderControllerSendPostPurchaseTestEmailRequest, xGuestToken?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('orderControllerSendPostPurchaseTestEmail', 'id', id)
            // verify required parameter 'orderControllerSendPostPurchaseTestEmailRequest' is not null or undefined
            assertParamExists('orderControllerSendPostPurchaseTestEmail', 'orderControllerSendPostPurchaseTestEmailRequest', orderControllerSendPostPurchaseTestEmailRequest)
            const localVarPath = `/order/{id}/admin/send-post-purchase-test`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (xGuestToken != null) {
                localVarHeaderParameter['x-guest-token'] = String(xGuestToken);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(orderControllerSendPostPurchaseTestEmailRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Set delivery type for order
         * @param {string} id Order ID
         * @param {UpdateDeliveryTypeDto} updateDeliveryTypeDto Delivery type and optional delivery point information
         * @param {string} [xGuestToken] Guest JWT token for unauthenticated users
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        orderControllerSetDeliveryType: async (id: string, updateDeliveryTypeDto: UpdateDeliveryTypeDto, xGuestToken?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('orderControllerSetDeliveryType', 'id', id)
            // verify required parameter 'updateDeliveryTypeDto' is not null or undefined
            assertParamExists('orderControllerSetDeliveryType', 'updateDeliveryTypeDto', updateDeliveryTypeDto)
            const localVarPath = `/order/{id}/delivery-type`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (xGuestToken != null) {
                localVarHeaderParameter['x-guest-token'] = String(xGuestToken);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateDeliveryTypeDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Set (or clear with null) the bundle the customer is filling. 404 when not offered to this order.
         * @param {string} id 
         * @param {SetSelectedBundleDto} setSelectedBundleDto 
         * @param {string} [xGuestToken] Guest JWT token for unauthenticated users
         * @param {string} [locale] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        orderControllerSetSelectedBundle: async (id: string, setSelectedBundleDto: SetSelectedBundleDto, xGuestToken?: string, locale?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('orderControllerSetSelectedBundle', 'id', id)
            // verify required parameter 'setSelectedBundleDto' is not null or undefined
            assertParamExists('orderControllerSetSelectedBundle', 'setSelectedBundleDto', setSelectedBundleDto)
            const localVarPath = `/order/{id}/selected-bundle`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (locale !== undefined) {
                localVarQueryParameter['locale'] = locale;
            }

            if (xGuestToken != null) {
                localVarHeaderParameter['x-guest-token'] = String(xGuestToken);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(setSelectedBundleDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update an order shipping
         * @param {any} id Order ID
         * @param {UpdateOrderShippingDto} updateOrderShippingDto Order Data
         * @param {string} [xGuestToken] Guest JWT token for unauthenticated users
         * @param {string} [xClientChannel] Client channel; re-derives the order\&#39;s channel on the recalculation after this shipping update, while the order is unpinned. The exact value \&#39;MOBILE\&#39; switches it to the app\&#39;s own pricing chain, any other present value switches it to WEB, and an absent or blank header leaves the stored channel untouched.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        orderControllerUpdateOneShipping: async (id: any, updateOrderShippingDto: UpdateOrderShippingDto, xGuestToken?: string, xClientChannel?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('orderControllerUpdateOneShipping', 'id', id)
            // verify required parameter 'updateOrderShippingDto' is not null or undefined
            assertParamExists('orderControllerUpdateOneShipping', 'updateOrderShippingDto', updateOrderShippingDto)
            const localVarPath = `/order/shipping/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (xGuestToken != null) {
                localVarHeaderParameter['x-guest-token'] = String(xGuestToken);
            }

            if (xClientChannel != null) {
                localVarHeaderParameter['x-client-channel'] = String(xClientChannel);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateOrderShippingDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary [Deprecated] Update order calendar quantity — use PATCH /order/:id/calendars/:childId instead
         * @param {string} id Order ID
         * @param {OrderControllerUpdateOrderCalendarQuantityRequest} orderControllerUpdateOrderCalendarQuantityRequest Order calendar update data
         * @param {string} [xGuestToken] Guest JWT token for unauthenticated users
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        orderControllerUpdateOrderCalendarQuantity: async (id: string, orderControllerUpdateOrderCalendarQuantityRequest: OrderControllerUpdateOrderCalendarQuantityRequest, xGuestToken?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('orderControllerUpdateOrderCalendarQuantity', 'id', id)
            // verify required parameter 'orderControllerUpdateOrderCalendarQuantityRequest' is not null or undefined
            assertParamExists('orderControllerUpdateOrderCalendarQuantity', 'orderControllerUpdateOrderCalendarQuantityRequest', orderControllerUpdateOrderCalendarQuantityRequest)
            const localVarPath = `/order/{id}/update-order-calendar-quantity`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (xGuestToken != null) {
                localVarHeaderParameter['x-guest-token'] = String(xGuestToken);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(orderControllerUpdateOrderCalendarQuantityRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update an order calendar quantity
         * @param {string} id Order ID
         * @param {string} childId Order calendar ID
         * @param {OrderControllerUpdateOrderProductQuantityRequest} orderControllerUpdateOrderProductQuantityRequest 
         * @param {string} [xGuestToken] Guest JWT token for unauthenticated users
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        orderControllerUpdateOrderCalendarQuantityUnified: async (id: string, childId: string, orderControllerUpdateOrderProductQuantityRequest: OrderControllerUpdateOrderProductQuantityRequest, xGuestToken?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('orderControllerUpdateOrderCalendarQuantityUnified', 'id', id)
            // verify required parameter 'childId' is not null or undefined
            assertParamExists('orderControllerUpdateOrderCalendarQuantityUnified', 'childId', childId)
            // verify required parameter 'orderControllerUpdateOrderProductQuantityRequest' is not null or undefined
            assertParamExists('orderControllerUpdateOrderCalendarQuantityUnified', 'orderControllerUpdateOrderProductQuantityRequest', orderControllerUpdateOrderProductQuantityRequest)
            const localVarPath = `/order/{id}/calendars/{childId}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)))
                .replace(`{${"childId"}}`, encodeURIComponent(String(childId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (xGuestToken != null) {
                localVarHeaderParameter['x-guest-token'] = String(xGuestToken);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(orderControllerUpdateOrderProductQuantityRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update an order
         * @param {string} id 
         * @param {UpdateOrderCouponDto} updateOrderCouponDto Order Data
         * @param {string} [xGuestToken] Guest JWT token for unauthenticated users
         * @param {string} [xClientChannel] Client channel; re-derives the order\&#39;s channel on the recalculation after the coupon is applied, while the order is unpinned. The exact value \&#39;MOBILE\&#39; switches it to the app\&#39;s own pricing chain, any other present value switches it to WEB, and an absent or blank header leaves the stored channel untouched.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        orderControllerUpdateOrderCoupon: async (id: string, updateOrderCouponDto: UpdateOrderCouponDto, xGuestToken?: string, xClientChannel?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('orderControllerUpdateOrderCoupon', 'id', id)
            // verify required parameter 'updateOrderCouponDto' is not null or undefined
            assertParamExists('orderControllerUpdateOrderCoupon', 'updateOrderCouponDto', updateOrderCouponDto)
            const localVarPath = `/order/add-coupon/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (xGuestToken != null) {
                localVarHeaderParameter['x-guest-token'] = String(xGuestToken);
            }

            if (xClientChannel != null) {
                localVarHeaderParameter['x-client-channel'] = String(xClientChannel);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateOrderCouponDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary [Deprecated] Update product detail quantity — use PATCH /order/:id/products/:childId instead
         * @param {string} id Order ID
         * @param {OrderControllerUpdateOrderProductDetailQuantityRequest} orderControllerUpdateOrderProductDetailQuantityRequest Order product detail update data
         * @param {string} [xGuestToken] Guest JWT token for unauthenticated users
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        orderControllerUpdateOrderProductDetailQuantity: async (id: string, orderControllerUpdateOrderProductDetailQuantityRequest: OrderControllerUpdateOrderProductDetailQuantityRequest, xGuestToken?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('orderControllerUpdateOrderProductDetailQuantity', 'id', id)
            // verify required parameter 'orderControllerUpdateOrderProductDetailQuantityRequest' is not null or undefined
            assertParamExists('orderControllerUpdateOrderProductDetailQuantity', 'orderControllerUpdateOrderProductDetailQuantityRequest', orderControllerUpdateOrderProductDetailQuantityRequest)
            const localVarPath = `/order/{id}/update-order-product-detail-quantity`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (xGuestToken != null) {
                localVarHeaderParameter['x-guest-token'] = String(xGuestToken);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(orderControllerUpdateOrderProductDetailQuantityRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update an order product detail quantity
         * @param {string} id Order ID
         * @param {string} childId Order product detail ID
         * @param {OrderControllerUpdateOrderProductQuantityRequest} orderControllerUpdateOrderProductQuantityRequest 
         * @param {string} [xGuestToken] Guest JWT token for unauthenticated users
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        orderControllerUpdateOrderProductQuantity: async (id: string, childId: string, orderControllerUpdateOrderProductQuantityRequest: OrderControllerUpdateOrderProductQuantityRequest, xGuestToken?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('orderControllerUpdateOrderProductQuantity', 'id', id)
            // verify required parameter 'childId' is not null or undefined
            assertParamExists('orderControllerUpdateOrderProductQuantity', 'childId', childId)
            // verify required parameter 'orderControllerUpdateOrderProductQuantityRequest' is not null or undefined
            assertParamExists('orderControllerUpdateOrderProductQuantity', 'orderControllerUpdateOrderProductQuantityRequest', orderControllerUpdateOrderProductQuantityRequest)
            const localVarPath = `/order/{id}/products/{childId}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)))
                .replace(`{${"childId"}}`, encodeURIComponent(String(childId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (xGuestToken != null) {
                localVarHeaderParameter['x-guest-token'] = String(xGuestToken);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(orderControllerUpdateOrderProductQuantityRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Change the quantity of a product-with-media (greeting card) line
         * @param {string} id Order ID
         * @param {string} lineId Product-with-media line ID
         * @param {OrderControllerUpdateProductWithMediaQuantityRequest} orderControllerUpdateProductWithMediaQuantityRequest 
         * @param {string} [xGuestToken] Guest JWT token for unauthenticated users
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        orderControllerUpdateProductWithMediaQuantity: async (id: string, lineId: string, orderControllerUpdateProductWithMediaQuantityRequest: OrderControllerUpdateProductWithMediaQuantityRequest, xGuestToken?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('orderControllerUpdateProductWithMediaQuantity', 'id', id)
            // verify required parameter 'lineId' is not null or undefined
            assertParamExists('orderControllerUpdateProductWithMediaQuantity', 'lineId', lineId)
            // verify required parameter 'orderControllerUpdateProductWithMediaQuantityRequest' is not null or undefined
            assertParamExists('orderControllerUpdateProductWithMediaQuantity', 'orderControllerUpdateProductWithMediaQuantityRequest', orderControllerUpdateProductWithMediaQuantityRequest)
            const localVarPath = `/order/{id}/product-with-media/{lineId}/quantity`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)))
                .replace(`{${"lineId"}}`, encodeURIComponent(String(lineId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (xGuestToken != null) {
                localVarHeaderParameter['x-guest-token'] = String(xGuestToken);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(orderControllerUpdateProductWithMediaQuantityRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update total number of photos for all orders
         * @param {string} [xGuestToken] Guest JWT token for unauthenticated users
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        orderControllerUpdateTotalNumberOfPhotosForAllOrders: async (xGuestToken?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/order/updateTotalNumberOfPhotosForAllOrders`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (xGuestToken != null) {
                localVarHeaderParameter['x-guest-token'] = String(xGuestToken);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update an order with user
         * @param {any} id Order ID
         * @param {UpdateOrderUserDTO} updateOrderUserDTO Order Data
         * @param {string} [xGuestToken] Guest JWT token for unauthenticated users
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        orderControllerUpdateUserOrder: async (id: any, updateOrderUserDTO: UpdateOrderUserDTO, xGuestToken?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('orderControllerUpdateUserOrder', 'id', id)
            // verify required parameter 'updateOrderUserDTO' is not null or undefined
            assertParamExists('orderControllerUpdateUserOrder', 'updateOrderUserDTO', updateOrderUserDTO)
            const localVarPath = `/order/user-order/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (xGuestToken != null) {
                localVarHeaderParameter['x-guest-token'] = String(xGuestToken);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateOrderUserDTO, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Add or upsert an order product detail (increments existing line if the product is already in the order)
         * @param {string} id Order ID
         * @param {OrderControllerUpsertOrderProductRequest} orderControllerUpsertOrderProductRequest 
         * @param {string} [xGuestToken] Guest JWT token for unauthenticated users
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        orderControllerUpsertOrderProduct: async (id: string, orderControllerUpsertOrderProductRequest: OrderControllerUpsertOrderProductRequest, xGuestToken?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('orderControllerUpsertOrderProduct', 'id', id)
            // verify required parameter 'orderControllerUpsertOrderProductRequest' is not null or undefined
            assertParamExists('orderControllerUpsertOrderProduct', 'orderControllerUpsertOrderProductRequest', orderControllerUpsertOrderProductRequest)
            const localVarPath = `/order/{id}/products`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (xGuestToken != null) {
                localVarHeaderParameter['x-guest-token'] = String(xGuestToken);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(orderControllerUpsertOrderProductRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Replace a single Order
         * @param {string} id 
         * @param {UpdateOrderDto} updateOrderDto 
         * @param {string} [xGuestToken] Guest JWT token for unauthenticated users
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        replaceOneBaseOrderControllerOrder: async (id: string, updateOrderDto: UpdateOrderDto, xGuestToken?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('replaceOneBaseOrderControllerOrder', 'id', id)
            // verify required parameter 'updateOrderDto' is not null or undefined
            assertParamExists('replaceOneBaseOrderControllerOrder', 'updateOrderDto', updateOrderDto)
            const localVarPath = `/order/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (xGuestToken != null) {
                localVarHeaderParameter['x-guest-token'] = String(xGuestToken);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateOrderDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Record the trip-suggestion counts on a PENDING order (suggested, kept ≤ suggested, added). 409 ORDER_NOT_PENDING otherwise.
         * @param {string} id 
         * @param {TripSuggestionDto} tripSuggestionDto 
         * @param {string} [xGuestToken] Guest JWT token for unauthenticated users
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        tripSuggestionControllerRecord: async (id: string, tripSuggestionDto: TripSuggestionDto, xGuestToken?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('tripSuggestionControllerRecord', 'id', id)
            // verify required parameter 'tripSuggestionDto' is not null or undefined
            assertParamExists('tripSuggestionControllerRecord', 'tripSuggestionDto', tripSuggestionDto)
            const localVarPath = `/order/{id}/trip-suggestion`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (xGuestToken != null) {
                localVarHeaderParameter['x-guest-token'] = String(xGuestToken);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(tripSuggestionDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update a single Order
         * @param {string} id 
         * @param {UpdateOrderDto} updateOrderDto 
         * @param {string} [xGuestToken] Guest JWT token for unauthenticated users
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateOneBaseOrderControllerOrder: async (id: string, updateOrderDto: UpdateOrderDto, xGuestToken?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('updateOneBaseOrderControllerOrder', 'id', id)
            // verify required parameter 'updateOrderDto' is not null or undefined
            assertParamExists('updateOneBaseOrderControllerOrder', 'updateOrderDto', updateOrderDto)
            const localVarPath = `/order/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (xGuestToken != null) {
                localVarHeaderParameter['x-guest-token'] = String(xGuestToken);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateOrderDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * OrderApi - functional programming interface
 * @export
 */
export const OrderApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = OrderApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Approve: cancel the order (canceledAt, credit, cashback, ORDER_CANCELED email), void the unfiscalized invoice. Card refunds stay manual in Stripe. 409 CANCEL_REQUEST_NOT_OPEN when already decided.
         * @param {string} id 
         * @param {string} [xGuestToken] Guest JWT token for unauthenticated users
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async cancelRequestControllerApprove(id: string, xGuestToken?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CancelRequestDecisionDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.cancelRequestControllerApprove(id, xGuestToken, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Decline: release the hold. No customer email. 409 CANCEL_REQUEST_NOT_OPEN when already decided.
         * @param {string} id 
         * @param {DeclineCancelRequestDto} declineCancelRequestDto 
         * @param {string} [xGuestToken] Guest JWT token for unauthenticated users
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async cancelRequestControllerDecline(id: string, declineCancelRequestDto: DeclineCancelRequestDto, xGuestToken?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CancelRequestDecisionDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.cancelRequestControllerDecline(id, declineCancelRequestDto, xGuestToken, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Open cancel requests, and approved card cancellations whose Stripe refund has not arrived (admin).
         * @param {string} [xGuestToken] Guest JWT token for unauthenticated users
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async cancelRequestControllerQueue(xGuestToken?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CancelRequestQueueDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.cancelRequestControllerQueue(xGuestToken, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Ask for this order to be canceled. Held out of production until an admin decides. 409 CANCEL_REQUEST_NOT_ALLOWED with reason WINDOW_PASSED | IN_PRODUCTION | STATUS | KIND | ALREADY_REQUESTED; 404 while customerCancelRequestEnabled is off.
         * @param {string} id 
         * @param {CreateCancelRequestDto} createCancelRequestDto 
         * @param {string} [xGuestToken] Guest JWT token for unauthenticated users
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async cancelRequestControllerRequest(id: string, createCancelRequestDto: CreateCancelRequestDto, xGuestToken?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CancelRequestViewDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.cancelRequestControllerRequest(id, createCancelRequestDto, xGuestToken, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Create a single Order
         * @param {CreateOrderDto} createOrderDto 
         * @param {string} [xGuestToken] Guest JWT token for unauthenticated users
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createOneBaseOrderControllerOrder(createOrderDto: CreateOrderDto, xGuestToken?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createOneBaseOrderControllerOrder(createOrderDto, xGuestToken, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Delete a single Order
         * @param {string} id 
         * @param {string} [xGuestToken] Guest JWT token for unauthenticated users
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteOneBaseOrderControllerOrder(id: string, xGuestToken?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteOneBaseOrderControllerOrder(id, xGuestToken, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Retrieve multiple Orders
         * @param {string} [xGuestToken] Guest JWT token for unauthenticated users
         * @param {Array<string>} [fields] Selects resource fields. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#select\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {string} [s] Adds search condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#search\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {Array<string>} [filter] Adds filter condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#filter\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {Array<string>} [or] Adds OR condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#or\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {Array<string>} [sort] Adds sort by field. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#sort\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {Array<string>} [join] Adds relational resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#join\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {number} [limit] Limit amount of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#limit\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {number} [offset] Offset amount of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#offset\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {number} [page] Page portion of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#page\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {number} [cache] Reset cache (if was enabled). &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#cache\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getManyBaseOrderControllerOrder(xGuestToken?: string, fields?: Array<string>, s?: string, filter?: Array<string>, or?: Array<string>, sort?: Array<string>, join?: Array<string>, limit?: number, offset?: number, page?: number, cache?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetManyOrderResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getManyBaseOrderControllerOrder(xGuestToken, fields, s, filter, or, sort, join, limit, offset, page, cache, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Retrieve a single Order
         * @param {string} id 
         * @param {string} [xGuestToken] Guest JWT token for unauthenticated users
         * @param {Array<string>} [fields] Selects resource fields. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#select\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {Array<string>} [join] Adds relational resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#join\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {number} [cache] Reset cache (if was enabled). &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#cache\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getOneBaseOrderControllerOrder(id: string, xGuestToken?: string, fields?: Array<string>, join?: Array<string>, cache?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetOrderDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getOneBaseOrderControllerOrder(id, xGuestToken, fields, join, cache, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Abandon the order\'s open Stripe payment attempt so its price pin (and credit) can change again. Idempotent.
         * @param {string} id Order ID
         * @param {string} [xGuestToken] Guest JWT token for unauthenticated users
         * @param {AbandonPaymentDto} [abandonPaymentDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async orderControllerAbandonPayment(id: string, xGuestToken?: string, abandonPaymentDto?: AbandonPaymentDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AbandonPaymentResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.orderControllerAbandonPayment(id, xGuestToken, abandonPaymentDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Add a catalogue artwork to an order
         * @param {string} id Order ID
         * @param {AddArtworkToOrderDto} addArtworkToOrderDto 
         * @param {string} [xGuestToken] Guest JWT token for unauthenticated users
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async orderControllerAddArtwork(id: string, addArtworkToOrderDto: AddArtworkToOrderDto, xGuestToken?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.orderControllerAddArtwork(id, addArtworkToOrderDto, xGuestToken, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Add a map print to an order
         * @param {string} id Order ID
         * @param {AddMapToOrderDto} addMapToOrderDto 
         * @param {string} [xGuestToken] Guest JWT token for unauthenticated users
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async orderControllerAddMap(id: string, addMapToOrderDto: AddMapToOrderDto, xGuestToken?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.orderControllerAddMap(id, addMapToOrderDto, xGuestToken, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary [Deprecated] Add order calendar — use POST /order/:id/calendars instead
         * @param {string} id Order ID
         * @param {OrderControllerAddOrderCalendarFormatEnum} format Calendar format
         * @param {number} quantity Quantity of calendars
         * @param {File} file Calendar PDF file (required)
         * @param {string} [xGuestToken] Guest JWT token for unauthenticated users
         * @param {OrderControllerAddOrderCalendarPaperEnum} [paper] Calendar paper (optional, defaults to \\\&#39;white\\\&#39;)
         * @param {string} [calendarData] Optional calendar configuration data (JSON string)
         * @param {string} [photoSettings] Optional photo settings array (JSON string) - position, rotation, filters, etc.
         * @param {string} [photoKeys] Optional comma-separated list of existing photo keys/IDs to attach to calendar
         * @param {Array<File>} [photos] Optional array of photo files to upload and attach to calendar
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async orderControllerAddOrderCalendar(id: string, format: OrderControllerAddOrderCalendarFormatEnum, quantity: number, file: File, xGuestToken?: string, paper?: OrderControllerAddOrderCalendarPaperEnum, calendarData?: string, photoSettings?: string, photoKeys?: string, photos?: Array<File>, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.orderControllerAddOrderCalendar(id, format, quantity, file, xGuestToken, paper, calendarData, photoSettings, photoKeys, photos, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Add a calendar to an order (multipart)
         * @param {string} id Order ID
         * @param {string} [xGuestToken] Guest JWT token for unauthenticated users
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async orderControllerAddOrderCalendarUnified(id: string, xGuestToken?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.orderControllerAddOrderCalendarUnified(id, xGuestToken, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary [Deprecated] Add order photos — use POST /order/:id/photos instead
         * @param {string} id Order ID
         * @param {OrderControllerAddOrderPhotosRequest} orderControllerAddOrderPhotosRequest Order Data
         * @param {string} [xGuestToken] Guest JWT token for unauthenticated users
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async orderControllerAddOrderPhotos(id: string, orderControllerAddOrderPhotosRequest: OrderControllerAddOrderPhotosRequest, xGuestToken?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.orderControllerAddOrderPhotos(id, orderControllerAddOrderPhotosRequest, xGuestToken, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Add photos to an order
         * @param {string} id Order ID
         * @param {OrderControllerAddOrderPhotosRequest} orderControllerAddOrderPhotosRequest 
         * @param {string} [xGuestToken] Guest JWT token for unauthenticated users
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async orderControllerAddOrderPhotosUnified(id: string, orderControllerAddOrderPhotosRequest: OrderControllerAddOrderPhotosRequest, xGuestToken?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.orderControllerAddOrderPhotosUnified(id, orderControllerAddOrderPhotosRequest, xGuestToken, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary [Deprecated] Add order product detail — use POST /order/:id/products instead
         * @param {string} id Order ID
         * @param {OrderControllerAddOrderProductDetailRequest} orderControllerAddOrderProductDetailRequest Product detail data to add
         * @param {string} [xGuestToken] Guest JWT token for unauthenticated users
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async orderControllerAddOrderProductDetail(id: string, orderControllerAddOrderProductDetailRequest: OrderControllerAddOrderProductDetailRequest, xGuestToken?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.orderControllerAddOrderProductDetail(id, orderControllerAddOrderProductDetailRequest, xGuestToken, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Add party-camera photos to an order (one print group)
         * @param {string} id Order ID
         * @param {AddPartyPhotosDto} addPartyPhotosDto 
         * @param {string} [xGuestToken] Guest JWT token for unauthenticated users
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async orderControllerAddPartyPhotos(id: string, addPartyPhotosDto: AddPartyPhotosDto, xGuestToken?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.orderControllerAddPartyPhotos(id, addPartyPhotosDto, xGuestToken, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Add a product-with-media (greeting card) line to an order
         * @param {string} id Order ID
         * @param {AddProductWithMediaToOrderDto} addProductWithMediaToOrderDto 
         * @param {string} [xGuestToken] Guest JWT token for unauthenticated users
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async orderControllerAddProductWithMedia(id: string, addProductWithMediaToOrderDto: AddProductWithMediaToOrderDto, xGuestToken?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.orderControllerAddProductWithMedia(id, addProductWithMediaToOrderDto, xGuestToken, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Apply the customer\'s granted credit to this order, after any coupon.
         * @param {string} id Order ID
         * @param {UpdateOrderCreditDto} updateOrderCreditDto Credit token, and optionally the lots to spend
         * @param {string} [xGuestToken] Guest JWT token for unauthenticated users
         * @param {string} [xClientChannel] Client channel; re-derives the order\&#39;s channel on the recalculation after the credit is applied, while the order is unpinned. The exact value \&#39;MOBILE\&#39; switches it to the app\&#39;s own pricing chain, any other present value switches it to WEB, and an absent or blank header leaves the stored channel untouched.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async orderControllerApplyCreditToOrder(id: string, updateOrderCreditDto: UpdateOrderCreditDto, xGuestToken?: string, xClientChannel?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.orderControllerApplyCreditToOrder(id, updateOrderCreditDto, xGuestToken, xClientChannel, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Bundles for this order: applied, the selected bundle\'s slot progress, the hint, the coupon block.
         * @param {string} id 
         * @param {string} [xGuestToken] Guest JWT token for unauthenticated users
         * @param {string} [locale] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async orderControllerBundles(id: string, xGuestToken?: string, locale?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OrderBundlesDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.orderControllerBundles(id, xGuestToken, locale, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Calculate total amount for an order
         * @param {string} id Order ID
         * @param {string} [xGuestToken] Guest JWT token for unauthenticated users
         * @param {string} [xClientChannel] Client channel; re-derives the order\&#39;s channel on this post-edit recalculation, while the order is unpinned. The exact value \&#39;MOBILE\&#39; switches it to the app\&#39;s own pricing chain, any other present value switches it to WEB, and an absent or blank header leaves the stored channel untouched.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async orderControllerCalculateAmount(id: string, xGuestToken?: string, xClientChannel?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.orderControllerCalculateAmount(id, xGuestToken, xClientChannel, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Cashback for this order: a live preview while unpaid, pending once placed, the award once recorded.
         * @param {string} id 
         * @param {string} [xGuestToken] Guest JWT token for unauthenticated users
         * @param {OrderControllerCashbackPaymentOptionEnum} [paymentOption] The cart\&#39;s current choice; only an unpaid cart\&#39;s preview uses it.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async orderControllerCashback(id: string, xGuestToken?: string, paymentOption?: OrderControllerCashbackPaymentOptionEnum, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OrderCashbackDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.orderControllerCashback(id, xGuestToken, paymentOption, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Change a photo group\'s size (merges into an existing group of that size with the same options)
         * @param {string} id Order ID
         * @param {string} childId Order Photo ID
         * @param {ChangeOrderPhotoSizeDto} changeOrderPhotoSizeDto 
         * @param {string} [xGuestToken] Guest JWT token for unauthenticated users
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async orderControllerChangeOrderPhotoSize(id: string, childId: string, changeOrderPhotoSizeDto: ChangeOrderPhotoSizeDto, xGuestToken?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.orderControllerChangeOrderPhotoSize(id, childId, changeOrderPhotoSizeDto, xGuestToken, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get coupon by code
         * @param {string} code 
         * @param {string} [xGuestToken] Guest JWT token for unauthenticated users
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async orderControllerCheckCoupon(code: string, xGuestToken?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.orderControllerCheckCoupon(code, xGuestToken, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Choose the photo for the free 30 x 40 enlargement the basket earned. 400 when the order has none; 404 when the photo is not in its paid lines.
         * @param {string} id 
         * @param {ChooseFreeEnlargementDto} chooseFreeEnlargementDto 
         * @param {string} [xGuestToken] Guest JWT token for unauthenticated users
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async orderControllerChooseFreeEnlargement(id: string, chooseFreeEnlargementDto: ChooseFreeEnlargementDto, xGuestToken?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.orderControllerChooseFreeEnlargement(id, chooseFreeEnlargementDto, xGuestToken, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Clear cache
         * @param {string} [xGuestToken] Guest JWT token for unauthenticated users
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async orderControllerClearCache(xGuestToken?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.orderControllerClearCache(xGuestToken, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Create an order
         * @param {CreateUserOrderDTO} createUserOrderDTO Order Data
         * @param {string} [xGuestToken] Guest JWT token for unauthenticated users
         * @param {string} [xClientChannel] Client channel; selects the channel recorded on the new order. The exact value \&#39;MOBILE\&#39; records an app order and prices it down the app\&#39;s own chain; any other present value records WEB; only an absent header falls back to the body\&#39;s (deprecated) orderSource.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async orderControllerCreateOrder(createUserOrderDTO: CreateUserOrderDTO, xGuestToken?: string, xClientChannel?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.orderControllerCreateOrder(createUserOrderDTO, xGuestToken, xClientChannel, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} id 
         * @param {string} [xGuestToken] Guest JWT token for unauthenticated users
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async orderControllerCreateReceipt(id: string, xGuestToken?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.orderControllerCreateReceipt(id, xGuestToken, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Checkout funnel conversion vs the same weekday (admin)
         * @param {string} [xGuestToken] Guest JWT token for unauthenticated users
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async orderControllerFunnelHealth(xGuestToken?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.orderControllerFunnelHealth(xGuestToken, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} id 
         * @param {string} [xGuestToken] Guest JWT token for unauthenticated users
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async orderControllerGetEditorGuestSession(id: string, xGuestToken?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.orderControllerGetEditorGuestSession(id, xGuestToken, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Prepares the parcel if it has not been prepared yet, then returns the label document from MyGLS GetPrintedLabels. Safe to call repeatedly: the stored ParcelId is reused, so no duplicate parcel is registered.
         * @summary Download the printable GLS label (prevoznica) for an order
         * @param {string} id 
         * @param {string} [xGuestToken] Guest JWT token for unauthenticated users
         * @param {string} [printer] GLS label format to request, overriding GLS_TYPE_OF_PRINTER. The 62mm workflow asks for Thermo (an 85x85mm square label) because that is the only output worth downscaling — an A4_* sheet scaled to 62mm would shrink the label itself to roughly 18mm. Invalid values are rejected by GlsService before any call to GLS.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async orderControllerGetGlsLabelDocument(id: string, xGuestToken?: string, printer?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<File>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.orderControllerGetGlsLabelDocument(id, xGuestToken, printer, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get all orders for analytics
         * @param {string} [xGuestToken] Guest JWT token for unauthenticated users
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async orderControllerGetManyForAnalytics(xGuestToken?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.orderControllerGetManyForAnalytics(xGuestToken, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Order event log / audit trail (admin)
         * @param {string} id 
         * @param {string} [xGuestToken] Guest JWT token for unauthenticated users
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async orderControllerGetOrderEvents(id: string, xGuestToken?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.orderControllerGetOrderEvents(id, xGuestToken, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Orders Stripe charged that we never finalized (admin)
         * @param {string} [xGuestToken] Guest JWT token for unauthenticated users
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async orderControllerGetPaymentAlerts(xGuestToken?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.orderControllerGetPaymentAlerts(xGuestToken, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get all orders for the authenticated user
         * @param {string} [xGuestToken] Guest JWT token for unauthenticated users
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async orderControllerGetUserOrders(xGuestToken?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.orderControllerGetUserOrders(xGuestToken, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} id 
         * @param {string} [xGuestToken] Guest JWT token for unauthenticated users
         * @param {PreparePaymentRequestDto} [preparePaymentRequestDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async orderControllerNotifyPaymentOnDelivery(id: string, xGuestToken?: string, preparePaymentRequestDto?: PreparePaymentRequestDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.orderControllerNotifyPaymentOnDelivery(id, xGuestToken, preparePaymentRequestDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Notify user to complete purchase
         * @param {string} id Order ID
         * @param {string} [xGuestToken] Guest JWT token for unauthenticated users
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async orderControllerNotifyUserToCompletePurchase(id: string, xGuestToken?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.orderControllerNotifyUserToCompletePurchase(id, xGuestToken, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Stuck / unfulfillable order counts (admin)
         * @param {string} [xGuestToken] Guest JWT token for unauthenticated users
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async orderControllerOrderHealth(xGuestToken?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.orderControllerOrderHealth(xGuestToken, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get all orders for analytics
         * @param {string} id 
         * @param {string} [xGuestToken] Guest JWT token for unauthenticated users
         * @param {string} [newParcel] true registers a replacement parcel at GLS even though the order already has one. Absent (what every existing caller sends), the stored parcel is returned and GLS is not called, so repeated clicks on GLS Label or Print Order no longer register a parcel each.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async orderControllerPrepareGlsLabel(id: string, xGuestToken?: string, newParcel?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.orderControllerPrepareGlsLabel(id, xGuestToken, newParcel, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Create a native Stripe PaymentIntent for in-app (mobile) payment
         * @param {string} id Order ID
         * @param {string} [xGuestToken] Guest JWT token for unauthenticated users
         * @param {PreparePaymentRequestDto} [preparePaymentRequestDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async orderControllerPrepareNativeOrderPayment(id: string, xGuestToken?: string, preparePaymentRequestDto?: PreparePaymentRequestDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PrepareNativePaymentResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.orderControllerPrepareNativeOrderPayment(id, xGuestToken, preparePaymentRequestDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Process payment for an order
         * @param {string} id Order ID
         * @param {string} [xGuestToken] Guest JWT token for unauthenticated users
         * @param {PreparePaymentRequestDto} [preparePaymentRequestDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async orderControllerPrepareOrderPayment(id: string, xGuestToken?: string, preparePaymentRequestDto?: PreparePaymentRequestDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PreparePaymentResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.orderControllerPrepareOrderPayment(id, xGuestToken, preparePaymentRequestDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Record a checkout-flow checkpoint for an order
         * @param {string} id Order ID
         * @param {RecordCheckpointDto} recordCheckpointDto 
         * @param {string} [xGuestToken] Guest JWT token for unauthenticated users
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async orderControllerRecordCheckpoint(id: string, recordCheckpointDto: RecordCheckpointDto, xGuestToken?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.orderControllerRecordCheckpoint(id, recordCheckpointDto, xGuestToken, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Remove coupon from an order
         * @param {string} id Order ID
         * @param {string} [xGuestToken] Guest JWT token for unauthenticated users
         * @param {string} [xClientChannel] Client channel; re-derives the order\&#39;s channel on the recalculation after the coupon is removed, while the order is unpinned. The exact value \&#39;MOBILE\&#39; switches it to the app\&#39;s own pricing chain, any other present value switches it to WEB, and an absent or blank header leaves the stored channel untouched.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async orderControllerRemoveCouponFromOrder(id: string, xGuestToken?: string, xClientChannel?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.orderControllerRemoveCouponFromOrder(id, xGuestToken, xClientChannel, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Take the applied credit back off this order; the lots are restored.
         * @param {string} id Order ID
         * @param {string} [xGuestToken] Guest JWT token for unauthenticated users
         * @param {string} [xClientChannel] Client channel; re-derives the order\&#39;s channel on the recalculation after the credit is removed, while the order is unpinned. The exact value \&#39;MOBILE\&#39; switches it to the app\&#39;s own pricing chain, any other present value switches it to WEB, and an absent or blank header leaves the stored channel untouched.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async orderControllerRemoveCreditFromOrder(id: string, xGuestToken?: string, xClientChannel?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.orderControllerRemoveCreditFromOrder(id, xGuestToken, xClientChannel, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary [Deprecated] Remove order calendar — use DELETE /order/:id/calendars/:childId instead
         * @param {string} id Order ID
         * @param {OrderControllerRemoveOrderCalendarRequest} orderControllerRemoveOrderCalendarRequest Calendar ID to remove
         * @param {string} [xGuestToken] Guest JWT token for unauthenticated users
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async orderControllerRemoveOrderCalendar(id: string, orderControllerRemoveOrderCalendarRequest: OrderControllerRemoveOrderCalendarRequest, xGuestToken?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.orderControllerRemoveOrderCalendar(id, orderControllerRemoveOrderCalendarRequest, xGuestToken, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Remove an order calendar
         * @param {string} id Order ID
         * @param {string} childId Order calendar ID
         * @param {string} [xGuestToken] Guest JWT token for unauthenticated users
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async orderControllerRemoveOrderCalendarUnified(id: string, childId: string, xGuestToken?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.orderControllerRemoveOrderCalendarUnified(id, childId, xGuestToken, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary [Deprecated] Remove an order photo — use DELETE /order/:id/photos/:childId instead
         * @param {string} id Order ID
         * @param {string} orderPhotoId Order Photo ID
         * @param {string} [xGuestToken] Guest JWT token for unauthenticated users
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async orderControllerRemoveOrderPhoto(id: string, orderPhotoId: string, xGuestToken?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.orderControllerRemoveOrderPhoto(id, orderPhotoId, xGuestToken, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Remove an order photo from an order
         * @param {string} id Order ID
         * @param {string} childId Order Photo ID
         * @param {string} [xGuestToken] Guest JWT token for unauthenticated users
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async orderControllerRemoveOrderPhotoUnified(id: string, childId: string, xGuestToken?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.orderControllerRemoveOrderPhotoUnified(id, childId, xGuestToken, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Remove an order product detail
         * @param {string} id Order ID
         * @param {string} childId Order product detail ID
         * @param {string} [xGuestToken] Guest JWT token for unauthenticated users
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async orderControllerRemoveOrderProduct(id: string, childId: string, xGuestToken?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.orderControllerRemoveOrderProduct(id, childId, xGuestToken, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Remove order product detail from an order
         * @param {string} id Order ID
         * @param {OrderControllerRemoveOrderProductDetailsRequest} orderControllerRemoveOrderProductDetailsRequest Product detail ID to remove
         * @param {string} [xGuestToken] Guest JWT token for unauthenticated users
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async orderControllerRemoveOrderProductDetails(id: string, orderControllerRemoveOrderProductDetailsRequest: OrderControllerRemoveOrderProductDetailsRequest, xGuestToken?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.orderControllerRemoveOrderProductDetails(id, orderControllerRemoveOrderProductDetailsRequest, xGuestToken, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Remove a product-with-media line from an order
         * @param {string} id 
         * @param {string} lineId 
         * @param {string} [xGuestToken] Guest JWT token for unauthenticated users
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async orderControllerRemoveProductWithMedia(id: string, lineId: string, xGuestToken?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.orderControllerRemoveProductWithMedia(id, lineId, xGuestToken, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Admin: send a post-purchase email for an order through Listmonk, without marking it as sent (idempotent for testing).
         * @param {string} id Order ID
         * @param {OrderControllerSendPostPurchaseTestEmailRequest} orderControllerSendPostPurchaseTestEmailRequest 
         * @param {string} [xGuestToken] Guest JWT token for unauthenticated users
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async orderControllerSendPostPurchaseTestEmail(id: string, orderControllerSendPostPurchaseTestEmailRequest: OrderControllerSendPostPurchaseTestEmailRequest, xGuestToken?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.orderControllerSendPostPurchaseTestEmail(id, orderControllerSendPostPurchaseTestEmailRequest, xGuestToken, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Set delivery type for order
         * @param {string} id Order ID
         * @param {UpdateDeliveryTypeDto} updateDeliveryTypeDto Delivery type and optional delivery point information
         * @param {string} [xGuestToken] Guest JWT token for unauthenticated users
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async orderControllerSetDeliveryType(id: string, updateDeliveryTypeDto: UpdateDeliveryTypeDto, xGuestToken?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetOrderDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.orderControllerSetDeliveryType(id, updateDeliveryTypeDto, xGuestToken, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Set (or clear with null) the bundle the customer is filling. 404 when not offered to this order.
         * @param {string} id 
         * @param {SetSelectedBundleDto} setSelectedBundleDto 
         * @param {string} [xGuestToken] Guest JWT token for unauthenticated users
         * @param {string} [locale] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async orderControllerSetSelectedBundle(id: string, setSelectedBundleDto: SetSelectedBundleDto, xGuestToken?: string, locale?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OrderBundlesDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.orderControllerSetSelectedBundle(id, setSelectedBundleDto, xGuestToken, locale, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Update an order shipping
         * @param {any} id Order ID
         * @param {UpdateOrderShippingDto} updateOrderShippingDto Order Data
         * @param {string} [xGuestToken] Guest JWT token for unauthenticated users
         * @param {string} [xClientChannel] Client channel; re-derives the order\&#39;s channel on the recalculation after this shipping update, while the order is unpinned. The exact value \&#39;MOBILE\&#39; switches it to the app\&#39;s own pricing chain, any other present value switches it to WEB, and an absent or blank header leaves the stored channel untouched.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async orderControllerUpdateOneShipping(id: any, updateOrderShippingDto: UpdateOrderShippingDto, xGuestToken?: string, xClientChannel?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.orderControllerUpdateOneShipping(id, updateOrderShippingDto, xGuestToken, xClientChannel, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary [Deprecated] Update order calendar quantity — use PATCH /order/:id/calendars/:childId instead
         * @param {string} id Order ID
         * @param {OrderControllerUpdateOrderCalendarQuantityRequest} orderControllerUpdateOrderCalendarQuantityRequest Order calendar update data
         * @param {string} [xGuestToken] Guest JWT token for unauthenticated users
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async orderControllerUpdateOrderCalendarQuantity(id: string, orderControllerUpdateOrderCalendarQuantityRequest: OrderControllerUpdateOrderCalendarQuantityRequest, xGuestToken?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.orderControllerUpdateOrderCalendarQuantity(id, orderControllerUpdateOrderCalendarQuantityRequest, xGuestToken, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Update an order calendar quantity
         * @param {string} id Order ID
         * @param {string} childId Order calendar ID
         * @param {OrderControllerUpdateOrderProductQuantityRequest} orderControllerUpdateOrderProductQuantityRequest 
         * @param {string} [xGuestToken] Guest JWT token for unauthenticated users
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async orderControllerUpdateOrderCalendarQuantityUnified(id: string, childId: string, orderControllerUpdateOrderProductQuantityRequest: OrderControllerUpdateOrderProductQuantityRequest, xGuestToken?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.orderControllerUpdateOrderCalendarQuantityUnified(id, childId, orderControllerUpdateOrderProductQuantityRequest, xGuestToken, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Update an order
         * @param {string} id 
         * @param {UpdateOrderCouponDto} updateOrderCouponDto Order Data
         * @param {string} [xGuestToken] Guest JWT token for unauthenticated users
         * @param {string} [xClientChannel] Client channel; re-derives the order\&#39;s channel on the recalculation after the coupon is applied, while the order is unpinned. The exact value \&#39;MOBILE\&#39; switches it to the app\&#39;s own pricing chain, any other present value switches it to WEB, and an absent or blank header leaves the stored channel untouched.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async orderControllerUpdateOrderCoupon(id: string, updateOrderCouponDto: UpdateOrderCouponDto, xGuestToken?: string, xClientChannel?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.orderControllerUpdateOrderCoupon(id, updateOrderCouponDto, xGuestToken, xClientChannel, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary [Deprecated] Update product detail quantity — use PATCH /order/:id/products/:childId instead
         * @param {string} id Order ID
         * @param {OrderControllerUpdateOrderProductDetailQuantityRequest} orderControllerUpdateOrderProductDetailQuantityRequest Order product detail update data
         * @param {string} [xGuestToken] Guest JWT token for unauthenticated users
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async orderControllerUpdateOrderProductDetailQuantity(id: string, orderControllerUpdateOrderProductDetailQuantityRequest: OrderControllerUpdateOrderProductDetailQuantityRequest, xGuestToken?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.orderControllerUpdateOrderProductDetailQuantity(id, orderControllerUpdateOrderProductDetailQuantityRequest, xGuestToken, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Update an order product detail quantity
         * @param {string} id Order ID
         * @param {string} childId Order product detail ID
         * @param {OrderControllerUpdateOrderProductQuantityRequest} orderControllerUpdateOrderProductQuantityRequest 
         * @param {string} [xGuestToken] Guest JWT token for unauthenticated users
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async orderControllerUpdateOrderProductQuantity(id: string, childId: string, orderControllerUpdateOrderProductQuantityRequest: OrderControllerUpdateOrderProductQuantityRequest, xGuestToken?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.orderControllerUpdateOrderProductQuantity(id, childId, orderControllerUpdateOrderProductQuantityRequest, xGuestToken, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Change the quantity of a product-with-media (greeting card) line
         * @param {string} id Order ID
         * @param {string} lineId Product-with-media line ID
         * @param {OrderControllerUpdateProductWithMediaQuantityRequest} orderControllerUpdateProductWithMediaQuantityRequest 
         * @param {string} [xGuestToken] Guest JWT token for unauthenticated users
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async orderControllerUpdateProductWithMediaQuantity(id: string, lineId: string, orderControllerUpdateProductWithMediaQuantityRequest: OrderControllerUpdateProductWithMediaQuantityRequest, xGuestToken?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.orderControllerUpdateProductWithMediaQuantity(id, lineId, orderControllerUpdateProductWithMediaQuantityRequest, xGuestToken, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Update total number of photos for all orders
         * @param {string} [xGuestToken] Guest JWT token for unauthenticated users
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async orderControllerUpdateTotalNumberOfPhotosForAllOrders(xGuestToken?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.orderControllerUpdateTotalNumberOfPhotosForAllOrders(xGuestToken, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Update an order with user
         * @param {any} id Order ID
         * @param {UpdateOrderUserDTO} updateOrderUserDTO Order Data
         * @param {string} [xGuestToken] Guest JWT token for unauthenticated users
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async orderControllerUpdateUserOrder(id: any, updateOrderUserDTO: UpdateOrderUserDTO, xGuestToken?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.orderControllerUpdateUserOrder(id, updateOrderUserDTO, xGuestToken, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Add or upsert an order product detail (increments existing line if the product is already in the order)
         * @param {string} id Order ID
         * @param {OrderControllerUpsertOrderProductRequest} orderControllerUpsertOrderProductRequest 
         * @param {string} [xGuestToken] Guest JWT token for unauthenticated users
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async orderControllerUpsertOrderProduct(id: string, orderControllerUpsertOrderProductRequest: OrderControllerUpsertOrderProductRequest, xGuestToken?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.orderControllerUpsertOrderProduct(id, orderControllerUpsertOrderProductRequest, xGuestToken, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Replace a single Order
         * @param {string} id 
         * @param {UpdateOrderDto} updateOrderDto 
         * @param {string} [xGuestToken] Guest JWT token for unauthenticated users
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async replaceOneBaseOrderControllerOrder(id: string, updateOrderDto: UpdateOrderDto, xGuestToken?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.replaceOneBaseOrderControllerOrder(id, updateOrderDto, xGuestToken, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Record the trip-suggestion counts on a PENDING order (suggested, kept ≤ suggested, added). 409 ORDER_NOT_PENDING otherwise.
         * @param {string} id 
         * @param {TripSuggestionDto} tripSuggestionDto 
         * @param {string} [xGuestToken] Guest JWT token for unauthenticated users
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async tripSuggestionControllerRecord(id: string, tripSuggestionDto: TripSuggestionDto, xGuestToken?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.tripSuggestionControllerRecord(id, tripSuggestionDto, xGuestToken, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Update a single Order
         * @param {string} id 
         * @param {UpdateOrderDto} updateOrderDto 
         * @param {string} [xGuestToken] Guest JWT token for unauthenticated users
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateOneBaseOrderControllerOrder(id: string, updateOrderDto: UpdateOrderDto, xGuestToken?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateOneBaseOrderControllerOrder(id, updateOrderDto, xGuestToken, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * OrderApi - factory interface
 * @export
 */
export const OrderApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = OrderApiFp(configuration)
    return {
        /**
         * 
         * @summary Approve: cancel the order (canceledAt, credit, cashback, ORDER_CANCELED email), void the unfiscalized invoice. Card refunds stay manual in Stripe. 409 CANCEL_REQUEST_NOT_OPEN when already decided.
         * @param {string} id 
         * @param {string} [xGuestToken] Guest JWT token for unauthenticated users
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cancelRequestControllerApprove(id: string, xGuestToken?: string, options?: any): AxiosPromise<CancelRequestDecisionDto> {
            return localVarFp.cancelRequestControllerApprove(id, xGuestToken, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Decline: release the hold. No customer email. 409 CANCEL_REQUEST_NOT_OPEN when already decided.
         * @param {string} id 
         * @param {DeclineCancelRequestDto} declineCancelRequestDto 
         * @param {string} [xGuestToken] Guest JWT token for unauthenticated users
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cancelRequestControllerDecline(id: string, declineCancelRequestDto: DeclineCancelRequestDto, xGuestToken?: string, options?: any): AxiosPromise<CancelRequestDecisionDto> {
            return localVarFp.cancelRequestControllerDecline(id, declineCancelRequestDto, xGuestToken, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Open cancel requests, and approved card cancellations whose Stripe refund has not arrived (admin).
         * @param {string} [xGuestToken] Guest JWT token for unauthenticated users
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cancelRequestControllerQueue(xGuestToken?: string, options?: any): AxiosPromise<CancelRequestQueueDto> {
            return localVarFp.cancelRequestControllerQueue(xGuestToken, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Ask for this order to be canceled. Held out of production until an admin decides. 409 CANCEL_REQUEST_NOT_ALLOWED with reason WINDOW_PASSED | IN_PRODUCTION | STATUS | KIND | ALREADY_REQUESTED; 404 while customerCancelRequestEnabled is off.
         * @param {string} id 
         * @param {CreateCancelRequestDto} createCancelRequestDto 
         * @param {string} [xGuestToken] Guest JWT token for unauthenticated users
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cancelRequestControllerRequest(id: string, createCancelRequestDto: CreateCancelRequestDto, xGuestToken?: string, options?: any): AxiosPromise<CancelRequestViewDto> {
            return localVarFp.cancelRequestControllerRequest(id, createCancelRequestDto, xGuestToken, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Create a single Order
         * @param {CreateOrderDto} createOrderDto 
         * @param {string} [xGuestToken] Guest JWT token for unauthenticated users
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createOneBaseOrderControllerOrder(createOrderDto: CreateOrderDto, xGuestToken?: string, options?: any): AxiosPromise<object> {
            return localVarFp.createOneBaseOrderControllerOrder(createOrderDto, xGuestToken, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Delete a single Order
         * @param {string} id 
         * @param {string} [xGuestToken] Guest JWT token for unauthenticated users
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOneBaseOrderControllerOrder(id: string, xGuestToken?: string, options?: any): AxiosPromise<object> {
            return localVarFp.deleteOneBaseOrderControllerOrder(id, xGuestToken, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Retrieve multiple Orders
         * @param {string} [xGuestToken] Guest JWT token for unauthenticated users
         * @param {Array<string>} [fields] Selects resource fields. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#select\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {string} [s] Adds search condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#search\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {Array<string>} [filter] Adds filter condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#filter\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {Array<string>} [or] Adds OR condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#or\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {Array<string>} [sort] Adds sort by field. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#sort\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {Array<string>} [join] Adds relational resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#join\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {number} [limit] Limit amount of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#limit\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {number} [offset] Offset amount of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#offset\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {number} [page] Page portion of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#page\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {number} [cache] Reset cache (if was enabled). &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#cache\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getManyBaseOrderControllerOrder(xGuestToken?: string, fields?: Array<string>, s?: string, filter?: Array<string>, or?: Array<string>, sort?: Array<string>, join?: Array<string>, limit?: number, offset?: number, page?: number, cache?: number, options?: any): AxiosPromise<GetManyOrderResponseDto> {
            return localVarFp.getManyBaseOrderControllerOrder(xGuestToken, fields, s, filter, or, sort, join, limit, offset, page, cache, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Retrieve a single Order
         * @param {string} id 
         * @param {string} [xGuestToken] Guest JWT token for unauthenticated users
         * @param {Array<string>} [fields] Selects resource fields. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#select\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {Array<string>} [join] Adds relational resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#join\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {number} [cache] Reset cache (if was enabled). &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#cache\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOneBaseOrderControllerOrder(id: string, xGuestToken?: string, fields?: Array<string>, join?: Array<string>, cache?: number, options?: any): AxiosPromise<GetOrderDto> {
            return localVarFp.getOneBaseOrderControllerOrder(id, xGuestToken, fields, join, cache, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Abandon the order\'s open Stripe payment attempt so its price pin (and credit) can change again. Idempotent.
         * @param {string} id Order ID
         * @param {string} [xGuestToken] Guest JWT token for unauthenticated users
         * @param {AbandonPaymentDto} [abandonPaymentDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        orderControllerAbandonPayment(id: string, xGuestToken?: string, abandonPaymentDto?: AbandonPaymentDto, options?: any): AxiosPromise<AbandonPaymentResponseDto> {
            return localVarFp.orderControllerAbandonPayment(id, xGuestToken, abandonPaymentDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Add a catalogue artwork to an order
         * @param {string} id Order ID
         * @param {AddArtworkToOrderDto} addArtworkToOrderDto 
         * @param {string} [xGuestToken] Guest JWT token for unauthenticated users
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        orderControllerAddArtwork(id: string, addArtworkToOrderDto: AddArtworkToOrderDto, xGuestToken?: string, options?: any): AxiosPromise<void> {
            return localVarFp.orderControllerAddArtwork(id, addArtworkToOrderDto, xGuestToken, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Add a map print to an order
         * @param {string} id Order ID
         * @param {AddMapToOrderDto} addMapToOrderDto 
         * @param {string} [xGuestToken] Guest JWT token for unauthenticated users
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        orderControllerAddMap(id: string, addMapToOrderDto: AddMapToOrderDto, xGuestToken?: string, options?: any): AxiosPromise<void> {
            return localVarFp.orderControllerAddMap(id, addMapToOrderDto, xGuestToken, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary [Deprecated] Add order calendar — use POST /order/:id/calendars instead
         * @param {string} id Order ID
         * @param {OrderControllerAddOrderCalendarFormatEnum} format Calendar format
         * @param {number} quantity Quantity of calendars
         * @param {File} file Calendar PDF file (required)
         * @param {string} [xGuestToken] Guest JWT token for unauthenticated users
         * @param {OrderControllerAddOrderCalendarPaperEnum} [paper] Calendar paper (optional, defaults to \\\&#39;white\\\&#39;)
         * @param {string} [calendarData] Optional calendar configuration data (JSON string)
         * @param {string} [photoSettings] Optional photo settings array (JSON string) - position, rotation, filters, etc.
         * @param {string} [photoKeys] Optional comma-separated list of existing photo keys/IDs to attach to calendar
         * @param {Array<File>} [photos] Optional array of photo files to upload and attach to calendar
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        orderControllerAddOrderCalendar(id: string, format: OrderControllerAddOrderCalendarFormatEnum, quantity: number, file: File, xGuestToken?: string, paper?: OrderControllerAddOrderCalendarPaperEnum, calendarData?: string, photoSettings?: string, photoKeys?: string, photos?: Array<File>, options?: any): AxiosPromise<void> {
            return localVarFp.orderControllerAddOrderCalendar(id, format, quantity, file, xGuestToken, paper, calendarData, photoSettings, photoKeys, photos, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Add a calendar to an order (multipart)
         * @param {string} id Order ID
         * @param {string} [xGuestToken] Guest JWT token for unauthenticated users
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        orderControllerAddOrderCalendarUnified(id: string, xGuestToken?: string, options?: any): AxiosPromise<void> {
            return localVarFp.orderControllerAddOrderCalendarUnified(id, xGuestToken, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary [Deprecated] Add order photos — use POST /order/:id/photos instead
         * @param {string} id Order ID
         * @param {OrderControllerAddOrderPhotosRequest} orderControllerAddOrderPhotosRequest Order Data
         * @param {string} [xGuestToken] Guest JWT token for unauthenticated users
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        orderControllerAddOrderPhotos(id: string, orderControllerAddOrderPhotosRequest: OrderControllerAddOrderPhotosRequest, xGuestToken?: string, options?: any): AxiosPromise<void> {
            return localVarFp.orderControllerAddOrderPhotos(id, orderControllerAddOrderPhotosRequest, xGuestToken, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Add photos to an order
         * @param {string} id Order ID
         * @param {OrderControllerAddOrderPhotosRequest} orderControllerAddOrderPhotosRequest 
         * @param {string} [xGuestToken] Guest JWT token for unauthenticated users
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        orderControllerAddOrderPhotosUnified(id: string, orderControllerAddOrderPhotosRequest: OrderControllerAddOrderPhotosRequest, xGuestToken?: string, options?: any): AxiosPromise<void> {
            return localVarFp.orderControllerAddOrderPhotosUnified(id, orderControllerAddOrderPhotosRequest, xGuestToken, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary [Deprecated] Add order product detail — use POST /order/:id/products instead
         * @param {string} id Order ID
         * @param {OrderControllerAddOrderProductDetailRequest} orderControllerAddOrderProductDetailRequest Product detail data to add
         * @param {string} [xGuestToken] Guest JWT token for unauthenticated users
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        orderControllerAddOrderProductDetail(id: string, orderControllerAddOrderProductDetailRequest: OrderControllerAddOrderProductDetailRequest, xGuestToken?: string, options?: any): AxiosPromise<void> {
            return localVarFp.orderControllerAddOrderProductDetail(id, orderControllerAddOrderProductDetailRequest, xGuestToken, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Add party-camera photos to an order (one print group)
         * @param {string} id Order ID
         * @param {AddPartyPhotosDto} addPartyPhotosDto 
         * @param {string} [xGuestToken] Guest JWT token for unauthenticated users
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        orderControllerAddPartyPhotos(id: string, addPartyPhotosDto: AddPartyPhotosDto, xGuestToken?: string, options?: any): AxiosPromise<void> {
            return localVarFp.orderControllerAddPartyPhotos(id, addPartyPhotosDto, xGuestToken, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Add a product-with-media (greeting card) line to an order
         * @param {string} id Order ID
         * @param {AddProductWithMediaToOrderDto} addProductWithMediaToOrderDto 
         * @param {string} [xGuestToken] Guest JWT token for unauthenticated users
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        orderControllerAddProductWithMedia(id: string, addProductWithMediaToOrderDto: AddProductWithMediaToOrderDto, xGuestToken?: string, options?: any): AxiosPromise<void> {
            return localVarFp.orderControllerAddProductWithMedia(id, addProductWithMediaToOrderDto, xGuestToken, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Apply the customer\'s granted credit to this order, after any coupon.
         * @param {string} id Order ID
         * @param {UpdateOrderCreditDto} updateOrderCreditDto Credit token, and optionally the lots to spend
         * @param {string} [xGuestToken] Guest JWT token for unauthenticated users
         * @param {string} [xClientChannel] Client channel; re-derives the order\&#39;s channel on the recalculation after the credit is applied, while the order is unpinned. The exact value \&#39;MOBILE\&#39; switches it to the app\&#39;s own pricing chain, any other present value switches it to WEB, and an absent or blank header leaves the stored channel untouched.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        orderControllerApplyCreditToOrder(id: string, updateOrderCreditDto: UpdateOrderCreditDto, xGuestToken?: string, xClientChannel?: string, options?: any): AxiosPromise<void> {
            return localVarFp.orderControllerApplyCreditToOrder(id, updateOrderCreditDto, xGuestToken, xClientChannel, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Bundles for this order: applied, the selected bundle\'s slot progress, the hint, the coupon block.
         * @param {string} id 
         * @param {string} [xGuestToken] Guest JWT token for unauthenticated users
         * @param {string} [locale] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        orderControllerBundles(id: string, xGuestToken?: string, locale?: string, options?: any): AxiosPromise<OrderBundlesDto> {
            return localVarFp.orderControllerBundles(id, xGuestToken, locale, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Calculate total amount for an order
         * @param {string} id Order ID
         * @param {string} [xGuestToken] Guest JWT token for unauthenticated users
         * @param {string} [xClientChannel] Client channel; re-derives the order\&#39;s channel on this post-edit recalculation, while the order is unpinned. The exact value \&#39;MOBILE\&#39; switches it to the app\&#39;s own pricing chain, any other present value switches it to WEB, and an absent or blank header leaves the stored channel untouched.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        orderControllerCalculateAmount(id: string, xGuestToken?: string, xClientChannel?: string, options?: any): AxiosPromise<void> {
            return localVarFp.orderControllerCalculateAmount(id, xGuestToken, xClientChannel, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Cashback for this order: a live preview while unpaid, pending once placed, the award once recorded.
         * @param {string} id 
         * @param {string} [xGuestToken] Guest JWT token for unauthenticated users
         * @param {OrderControllerCashbackPaymentOptionEnum} [paymentOption] The cart\&#39;s current choice; only an unpaid cart\&#39;s preview uses it.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        orderControllerCashback(id: string, xGuestToken?: string, paymentOption?: OrderControllerCashbackPaymentOptionEnum, options?: any): AxiosPromise<OrderCashbackDto> {
            return localVarFp.orderControllerCashback(id, xGuestToken, paymentOption, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Change a photo group\'s size (merges into an existing group of that size with the same options)
         * @param {string} id Order ID
         * @param {string} childId Order Photo ID
         * @param {ChangeOrderPhotoSizeDto} changeOrderPhotoSizeDto 
         * @param {string} [xGuestToken] Guest JWT token for unauthenticated users
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        orderControllerChangeOrderPhotoSize(id: string, childId: string, changeOrderPhotoSizeDto: ChangeOrderPhotoSizeDto, xGuestToken?: string, options?: any): AxiosPromise<void> {
            return localVarFp.orderControllerChangeOrderPhotoSize(id, childId, changeOrderPhotoSizeDto, xGuestToken, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get coupon by code
         * @param {string} code 
         * @param {string} [xGuestToken] Guest JWT token for unauthenticated users
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        orderControllerCheckCoupon(code: string, xGuestToken?: string, options?: any): AxiosPromise<object> {
            return localVarFp.orderControllerCheckCoupon(code, xGuestToken, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Choose the photo for the free 30 x 40 enlargement the basket earned. 400 when the order has none; 404 when the photo is not in its paid lines.
         * @param {string} id 
         * @param {ChooseFreeEnlargementDto} chooseFreeEnlargementDto 
         * @param {string} [xGuestToken] Guest JWT token for unauthenticated users
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        orderControllerChooseFreeEnlargement(id: string, chooseFreeEnlargementDto: ChooseFreeEnlargementDto, xGuestToken?: string, options?: any): AxiosPromise<object> {
            return localVarFp.orderControllerChooseFreeEnlargement(id, chooseFreeEnlargementDto, xGuestToken, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Clear cache
         * @param {string} [xGuestToken] Guest JWT token for unauthenticated users
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        orderControllerClearCache(xGuestToken?: string, options?: any): AxiosPromise<void> {
            return localVarFp.orderControllerClearCache(xGuestToken, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Create an order
         * @param {CreateUserOrderDTO} createUserOrderDTO Order Data
         * @param {string} [xGuestToken] Guest JWT token for unauthenticated users
         * @param {string} [xClientChannel] Client channel; selects the channel recorded on the new order. The exact value \&#39;MOBILE\&#39; records an app order and prices it down the app\&#39;s own chain; any other present value records WEB; only an absent header falls back to the body\&#39;s (deprecated) orderSource.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        orderControllerCreateOrder(createUserOrderDTO: CreateUserOrderDTO, xGuestToken?: string, xClientChannel?: string, options?: any): AxiosPromise<void> {
            return localVarFp.orderControllerCreateOrder(createUserOrderDTO, xGuestToken, xClientChannel, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {string} [xGuestToken] Guest JWT token for unauthenticated users
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        orderControllerCreateReceipt(id: string, xGuestToken?: string, options?: any): AxiosPromise<void> {
            return localVarFp.orderControllerCreateReceipt(id, xGuestToken, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Checkout funnel conversion vs the same weekday (admin)
         * @param {string} [xGuestToken] Guest JWT token for unauthenticated users
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        orderControllerFunnelHealth(xGuestToken?: string, options?: any): AxiosPromise<void> {
            return localVarFp.orderControllerFunnelHealth(xGuestToken, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {string} [xGuestToken] Guest JWT token for unauthenticated users
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        orderControllerGetEditorGuestSession(id: string, xGuestToken?: string, options?: any): AxiosPromise<void> {
            return localVarFp.orderControllerGetEditorGuestSession(id, xGuestToken, options).then((request) => request(axios, basePath));
        },
        /**
         * Prepares the parcel if it has not been prepared yet, then returns the label document from MyGLS GetPrintedLabels. Safe to call repeatedly: the stored ParcelId is reused, so no duplicate parcel is registered.
         * @summary Download the printable GLS label (prevoznica) for an order
         * @param {string} id 
         * @param {string} [xGuestToken] Guest JWT token for unauthenticated users
         * @param {string} [printer] GLS label format to request, overriding GLS_TYPE_OF_PRINTER. The 62mm workflow asks for Thermo (an 85x85mm square label) because that is the only output worth downscaling — an A4_* sheet scaled to 62mm would shrink the label itself to roughly 18mm. Invalid values are rejected by GlsService before any call to GLS.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        orderControllerGetGlsLabelDocument(id: string, xGuestToken?: string, printer?: string, options?: any): AxiosPromise<File> {
            return localVarFp.orderControllerGetGlsLabelDocument(id, xGuestToken, printer, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get all orders for analytics
         * @param {string} [xGuestToken] Guest JWT token for unauthenticated users
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        orderControllerGetManyForAnalytics(xGuestToken?: string, options?: any): AxiosPromise<void> {
            return localVarFp.orderControllerGetManyForAnalytics(xGuestToken, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Order event log / audit trail (admin)
         * @param {string} id 
         * @param {string} [xGuestToken] Guest JWT token for unauthenticated users
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        orderControllerGetOrderEvents(id: string, xGuestToken?: string, options?: any): AxiosPromise<void> {
            return localVarFp.orderControllerGetOrderEvents(id, xGuestToken, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Orders Stripe charged that we never finalized (admin)
         * @param {string} [xGuestToken] Guest JWT token for unauthenticated users
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        orderControllerGetPaymentAlerts(xGuestToken?: string, options?: any): AxiosPromise<void> {
            return localVarFp.orderControllerGetPaymentAlerts(xGuestToken, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get all orders for the authenticated user
         * @param {string} [xGuestToken] Guest JWT token for unauthenticated users
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        orderControllerGetUserOrders(xGuestToken?: string, options?: any): AxiosPromise<void> {
            return localVarFp.orderControllerGetUserOrders(xGuestToken, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {string} [xGuestToken] Guest JWT token for unauthenticated users
         * @param {PreparePaymentRequestDto} [preparePaymentRequestDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        orderControllerNotifyPaymentOnDelivery(id: string, xGuestToken?: string, preparePaymentRequestDto?: PreparePaymentRequestDto, options?: any): AxiosPromise<void> {
            return localVarFp.orderControllerNotifyPaymentOnDelivery(id, xGuestToken, preparePaymentRequestDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Notify user to complete purchase
         * @param {string} id Order ID
         * @param {string} [xGuestToken] Guest JWT token for unauthenticated users
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        orderControllerNotifyUserToCompletePurchase(id: string, xGuestToken?: string, options?: any): AxiosPromise<void> {
            return localVarFp.orderControllerNotifyUserToCompletePurchase(id, xGuestToken, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Stuck / unfulfillable order counts (admin)
         * @param {string} [xGuestToken] Guest JWT token for unauthenticated users
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        orderControllerOrderHealth(xGuestToken?: string, options?: any): AxiosPromise<void> {
            return localVarFp.orderControllerOrderHealth(xGuestToken, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get all orders for analytics
         * @param {string} id 
         * @param {string} [xGuestToken] Guest JWT token for unauthenticated users
         * @param {string} [newParcel] true registers a replacement parcel at GLS even though the order already has one. Absent (what every existing caller sends), the stored parcel is returned and GLS is not called, so repeated clicks on GLS Label or Print Order no longer register a parcel each.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        orderControllerPrepareGlsLabel(id: string, xGuestToken?: string, newParcel?: string, options?: any): AxiosPromise<void> {
            return localVarFp.orderControllerPrepareGlsLabel(id, xGuestToken, newParcel, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Create a native Stripe PaymentIntent for in-app (mobile) payment
         * @param {string} id Order ID
         * @param {string} [xGuestToken] Guest JWT token for unauthenticated users
         * @param {PreparePaymentRequestDto} [preparePaymentRequestDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        orderControllerPrepareNativeOrderPayment(id: string, xGuestToken?: string, preparePaymentRequestDto?: PreparePaymentRequestDto, options?: any): AxiosPromise<PrepareNativePaymentResponseDto> {
            return localVarFp.orderControllerPrepareNativeOrderPayment(id, xGuestToken, preparePaymentRequestDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Process payment for an order
         * @param {string} id Order ID
         * @param {string} [xGuestToken] Guest JWT token for unauthenticated users
         * @param {PreparePaymentRequestDto} [preparePaymentRequestDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        orderControllerPrepareOrderPayment(id: string, xGuestToken?: string, preparePaymentRequestDto?: PreparePaymentRequestDto, options?: any): AxiosPromise<PreparePaymentResponseDto> {
            return localVarFp.orderControllerPrepareOrderPayment(id, xGuestToken, preparePaymentRequestDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Record a checkout-flow checkpoint for an order
         * @param {string} id Order ID
         * @param {RecordCheckpointDto} recordCheckpointDto 
         * @param {string} [xGuestToken] Guest JWT token for unauthenticated users
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        orderControllerRecordCheckpoint(id: string, recordCheckpointDto: RecordCheckpointDto, xGuestToken?: string, options?: any): AxiosPromise<void> {
            return localVarFp.orderControllerRecordCheckpoint(id, recordCheckpointDto, xGuestToken, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Remove coupon from an order
         * @param {string} id Order ID
         * @param {string} [xGuestToken] Guest JWT token for unauthenticated users
         * @param {string} [xClientChannel] Client channel; re-derives the order\&#39;s channel on the recalculation after the coupon is removed, while the order is unpinned. The exact value \&#39;MOBILE\&#39; switches it to the app\&#39;s own pricing chain, any other present value switches it to WEB, and an absent or blank header leaves the stored channel untouched.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        orderControllerRemoveCouponFromOrder(id: string, xGuestToken?: string, xClientChannel?: string, options?: any): AxiosPromise<void> {
            return localVarFp.orderControllerRemoveCouponFromOrder(id, xGuestToken, xClientChannel, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Take the applied credit back off this order; the lots are restored.
         * @param {string} id Order ID
         * @param {string} [xGuestToken] Guest JWT token for unauthenticated users
         * @param {string} [xClientChannel] Client channel; re-derives the order\&#39;s channel on the recalculation after the credit is removed, while the order is unpinned. The exact value \&#39;MOBILE\&#39; switches it to the app\&#39;s own pricing chain, any other present value switches it to WEB, and an absent or blank header leaves the stored channel untouched.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        orderControllerRemoveCreditFromOrder(id: string, xGuestToken?: string, xClientChannel?: string, options?: any): AxiosPromise<void> {
            return localVarFp.orderControllerRemoveCreditFromOrder(id, xGuestToken, xClientChannel, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary [Deprecated] Remove order calendar — use DELETE /order/:id/calendars/:childId instead
         * @param {string} id Order ID
         * @param {OrderControllerRemoveOrderCalendarRequest} orderControllerRemoveOrderCalendarRequest Calendar ID to remove
         * @param {string} [xGuestToken] Guest JWT token for unauthenticated users
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        orderControllerRemoveOrderCalendar(id: string, orderControllerRemoveOrderCalendarRequest: OrderControllerRemoveOrderCalendarRequest, xGuestToken?: string, options?: any): AxiosPromise<void> {
            return localVarFp.orderControllerRemoveOrderCalendar(id, orderControllerRemoveOrderCalendarRequest, xGuestToken, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Remove an order calendar
         * @param {string} id Order ID
         * @param {string} childId Order calendar ID
         * @param {string} [xGuestToken] Guest JWT token for unauthenticated users
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        orderControllerRemoveOrderCalendarUnified(id: string, childId: string, xGuestToken?: string, options?: any): AxiosPromise<void> {
            return localVarFp.orderControllerRemoveOrderCalendarUnified(id, childId, xGuestToken, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary [Deprecated] Remove an order photo — use DELETE /order/:id/photos/:childId instead
         * @param {string} id Order ID
         * @param {string} orderPhotoId Order Photo ID
         * @param {string} [xGuestToken] Guest JWT token for unauthenticated users
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        orderControllerRemoveOrderPhoto(id: string, orderPhotoId: string, xGuestToken?: string, options?: any): AxiosPromise<void> {
            return localVarFp.orderControllerRemoveOrderPhoto(id, orderPhotoId, xGuestToken, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Remove an order photo from an order
         * @param {string} id Order ID
         * @param {string} childId Order Photo ID
         * @param {string} [xGuestToken] Guest JWT token for unauthenticated users
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        orderControllerRemoveOrderPhotoUnified(id: string, childId: string, xGuestToken?: string, options?: any): AxiosPromise<void> {
            return localVarFp.orderControllerRemoveOrderPhotoUnified(id, childId, xGuestToken, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Remove an order product detail
         * @param {string} id Order ID
         * @param {string} childId Order product detail ID
         * @param {string} [xGuestToken] Guest JWT token for unauthenticated users
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        orderControllerRemoveOrderProduct(id: string, childId: string, xGuestToken?: string, options?: any): AxiosPromise<void> {
            return localVarFp.orderControllerRemoveOrderProduct(id, childId, xGuestToken, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Remove order product detail from an order
         * @param {string} id Order ID
         * @param {OrderControllerRemoveOrderProductDetailsRequest} orderControllerRemoveOrderProductDetailsRequest Product detail ID to remove
         * @param {string} [xGuestToken] Guest JWT token for unauthenticated users
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        orderControllerRemoveOrderProductDetails(id: string, orderControllerRemoveOrderProductDetailsRequest: OrderControllerRemoveOrderProductDetailsRequest, xGuestToken?: string, options?: any): AxiosPromise<void> {
            return localVarFp.orderControllerRemoveOrderProductDetails(id, orderControllerRemoveOrderProductDetailsRequest, xGuestToken, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Remove a product-with-media line from an order
         * @param {string} id 
         * @param {string} lineId 
         * @param {string} [xGuestToken] Guest JWT token for unauthenticated users
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        orderControllerRemoveProductWithMedia(id: string, lineId: string, xGuestToken?: string, options?: any): AxiosPromise<void> {
            return localVarFp.orderControllerRemoveProductWithMedia(id, lineId, xGuestToken, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Admin: send a post-purchase email for an order through Listmonk, without marking it as sent (idempotent for testing).
         * @param {string} id Order ID
         * @param {OrderControllerSendPostPurchaseTestEmailRequest} orderControllerSendPostPurchaseTestEmailRequest 
         * @param {string} [xGuestToken] Guest JWT token for unauthenticated users
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        orderControllerSendPostPurchaseTestEmail(id: string, orderControllerSendPostPurchaseTestEmailRequest: OrderControllerSendPostPurchaseTestEmailRequest, xGuestToken?: string, options?: any): AxiosPromise<void> {
            return localVarFp.orderControllerSendPostPurchaseTestEmail(id, orderControllerSendPostPurchaseTestEmailRequest, xGuestToken, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Set delivery type for order
         * @param {string} id Order ID
         * @param {UpdateDeliveryTypeDto} updateDeliveryTypeDto Delivery type and optional delivery point information
         * @param {string} [xGuestToken] Guest JWT token for unauthenticated users
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        orderControllerSetDeliveryType(id: string, updateDeliveryTypeDto: UpdateDeliveryTypeDto, xGuestToken?: string, options?: any): AxiosPromise<GetOrderDto> {
            return localVarFp.orderControllerSetDeliveryType(id, updateDeliveryTypeDto, xGuestToken, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Set (or clear with null) the bundle the customer is filling. 404 when not offered to this order.
         * @param {string} id 
         * @param {SetSelectedBundleDto} setSelectedBundleDto 
         * @param {string} [xGuestToken] Guest JWT token for unauthenticated users
         * @param {string} [locale] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        orderControllerSetSelectedBundle(id: string, setSelectedBundleDto: SetSelectedBundleDto, xGuestToken?: string, locale?: string, options?: any): AxiosPromise<OrderBundlesDto> {
            return localVarFp.orderControllerSetSelectedBundle(id, setSelectedBundleDto, xGuestToken, locale, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update an order shipping
         * @param {any} id Order ID
         * @param {UpdateOrderShippingDto} updateOrderShippingDto Order Data
         * @param {string} [xGuestToken] Guest JWT token for unauthenticated users
         * @param {string} [xClientChannel] Client channel; re-derives the order\&#39;s channel on the recalculation after this shipping update, while the order is unpinned. The exact value \&#39;MOBILE\&#39; switches it to the app\&#39;s own pricing chain, any other present value switches it to WEB, and an absent or blank header leaves the stored channel untouched.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        orderControllerUpdateOneShipping(id: any, updateOrderShippingDto: UpdateOrderShippingDto, xGuestToken?: string, xClientChannel?: string, options?: any): AxiosPromise<void> {
            return localVarFp.orderControllerUpdateOneShipping(id, updateOrderShippingDto, xGuestToken, xClientChannel, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary [Deprecated] Update order calendar quantity — use PATCH /order/:id/calendars/:childId instead
         * @param {string} id Order ID
         * @param {OrderControllerUpdateOrderCalendarQuantityRequest} orderControllerUpdateOrderCalendarQuantityRequest Order calendar update data
         * @param {string} [xGuestToken] Guest JWT token for unauthenticated users
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        orderControllerUpdateOrderCalendarQuantity(id: string, orderControllerUpdateOrderCalendarQuantityRequest: OrderControllerUpdateOrderCalendarQuantityRequest, xGuestToken?: string, options?: any): AxiosPromise<void> {
            return localVarFp.orderControllerUpdateOrderCalendarQuantity(id, orderControllerUpdateOrderCalendarQuantityRequest, xGuestToken, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update an order calendar quantity
         * @param {string} id Order ID
         * @param {string} childId Order calendar ID
         * @param {OrderControllerUpdateOrderProductQuantityRequest} orderControllerUpdateOrderProductQuantityRequest 
         * @param {string} [xGuestToken] Guest JWT token for unauthenticated users
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        orderControllerUpdateOrderCalendarQuantityUnified(id: string, childId: string, orderControllerUpdateOrderProductQuantityRequest: OrderControllerUpdateOrderProductQuantityRequest, xGuestToken?: string, options?: any): AxiosPromise<void> {
            return localVarFp.orderControllerUpdateOrderCalendarQuantityUnified(id, childId, orderControllerUpdateOrderProductQuantityRequest, xGuestToken, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update an order
         * @param {string} id 
         * @param {UpdateOrderCouponDto} updateOrderCouponDto Order Data
         * @param {string} [xGuestToken] Guest JWT token for unauthenticated users
         * @param {string} [xClientChannel] Client channel; re-derives the order\&#39;s channel on the recalculation after the coupon is applied, while the order is unpinned. The exact value \&#39;MOBILE\&#39; switches it to the app\&#39;s own pricing chain, any other present value switches it to WEB, and an absent or blank header leaves the stored channel untouched.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        orderControllerUpdateOrderCoupon(id: string, updateOrderCouponDto: UpdateOrderCouponDto, xGuestToken?: string, xClientChannel?: string, options?: any): AxiosPromise<void> {
            return localVarFp.orderControllerUpdateOrderCoupon(id, updateOrderCouponDto, xGuestToken, xClientChannel, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary [Deprecated] Update product detail quantity — use PATCH /order/:id/products/:childId instead
         * @param {string} id Order ID
         * @param {OrderControllerUpdateOrderProductDetailQuantityRequest} orderControllerUpdateOrderProductDetailQuantityRequest Order product detail update data
         * @param {string} [xGuestToken] Guest JWT token for unauthenticated users
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        orderControllerUpdateOrderProductDetailQuantity(id: string, orderControllerUpdateOrderProductDetailQuantityRequest: OrderControllerUpdateOrderProductDetailQuantityRequest, xGuestToken?: string, options?: any): AxiosPromise<void> {
            return localVarFp.orderControllerUpdateOrderProductDetailQuantity(id, orderControllerUpdateOrderProductDetailQuantityRequest, xGuestToken, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update an order product detail quantity
         * @param {string} id Order ID
         * @param {string} childId Order product detail ID
         * @param {OrderControllerUpdateOrderProductQuantityRequest} orderControllerUpdateOrderProductQuantityRequest 
         * @param {string} [xGuestToken] Guest JWT token for unauthenticated users
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        orderControllerUpdateOrderProductQuantity(id: string, childId: string, orderControllerUpdateOrderProductQuantityRequest: OrderControllerUpdateOrderProductQuantityRequest, xGuestToken?: string, options?: any): AxiosPromise<void> {
            return localVarFp.orderControllerUpdateOrderProductQuantity(id, childId, orderControllerUpdateOrderProductQuantityRequest, xGuestToken, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Change the quantity of a product-with-media (greeting card) line
         * @param {string} id Order ID
         * @param {string} lineId Product-with-media line ID
         * @param {OrderControllerUpdateProductWithMediaQuantityRequest} orderControllerUpdateProductWithMediaQuantityRequest 
         * @param {string} [xGuestToken] Guest JWT token for unauthenticated users
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        orderControllerUpdateProductWithMediaQuantity(id: string, lineId: string, orderControllerUpdateProductWithMediaQuantityRequest: OrderControllerUpdateProductWithMediaQuantityRequest, xGuestToken?: string, options?: any): AxiosPromise<void> {
            return localVarFp.orderControllerUpdateProductWithMediaQuantity(id, lineId, orderControllerUpdateProductWithMediaQuantityRequest, xGuestToken, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update total number of photos for all orders
         * @param {string} [xGuestToken] Guest JWT token for unauthenticated users
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        orderControllerUpdateTotalNumberOfPhotosForAllOrders(xGuestToken?: string, options?: any): AxiosPromise<void> {
            return localVarFp.orderControllerUpdateTotalNumberOfPhotosForAllOrders(xGuestToken, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update an order with user
         * @param {any} id Order ID
         * @param {UpdateOrderUserDTO} updateOrderUserDTO Order Data
         * @param {string} [xGuestToken] Guest JWT token for unauthenticated users
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        orderControllerUpdateUserOrder(id: any, updateOrderUserDTO: UpdateOrderUserDTO, xGuestToken?: string, options?: any): AxiosPromise<void> {
            return localVarFp.orderControllerUpdateUserOrder(id, updateOrderUserDTO, xGuestToken, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Add or upsert an order product detail (increments existing line if the product is already in the order)
         * @param {string} id Order ID
         * @param {OrderControllerUpsertOrderProductRequest} orderControllerUpsertOrderProductRequest 
         * @param {string} [xGuestToken] Guest JWT token for unauthenticated users
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        orderControllerUpsertOrderProduct(id: string, orderControllerUpsertOrderProductRequest: OrderControllerUpsertOrderProductRequest, xGuestToken?: string, options?: any): AxiosPromise<void> {
            return localVarFp.orderControllerUpsertOrderProduct(id, orderControllerUpsertOrderProductRequest, xGuestToken, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Replace a single Order
         * @param {string} id 
         * @param {UpdateOrderDto} updateOrderDto 
         * @param {string} [xGuestToken] Guest JWT token for unauthenticated users
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        replaceOneBaseOrderControllerOrder(id: string, updateOrderDto: UpdateOrderDto, xGuestToken?: string, options?: any): AxiosPromise<object> {
            return localVarFp.replaceOneBaseOrderControllerOrder(id, updateOrderDto, xGuestToken, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Record the trip-suggestion counts on a PENDING order (suggested, kept ≤ suggested, added). 409 ORDER_NOT_PENDING otherwise.
         * @param {string} id 
         * @param {TripSuggestionDto} tripSuggestionDto 
         * @param {string} [xGuestToken] Guest JWT token for unauthenticated users
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        tripSuggestionControllerRecord(id: string, tripSuggestionDto: TripSuggestionDto, xGuestToken?: string, options?: any): AxiosPromise<void> {
            return localVarFp.tripSuggestionControllerRecord(id, tripSuggestionDto, xGuestToken, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update a single Order
         * @param {string} id 
         * @param {UpdateOrderDto} updateOrderDto 
         * @param {string} [xGuestToken] Guest JWT token for unauthenticated users
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateOneBaseOrderControllerOrder(id: string, updateOrderDto: UpdateOrderDto, xGuestToken?: string, options?: any): AxiosPromise<object> {
            return localVarFp.updateOneBaseOrderControllerOrder(id, updateOrderDto, xGuestToken, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * OrderApi - object-oriented interface
 * @export
 * @class OrderApi
 * @extends {BaseAPI}
 */
export class OrderApi extends BaseAPI {
    /**
     * 
     * @summary Approve: cancel the order (canceledAt, credit, cashback, ORDER_CANCELED email), void the unfiscalized invoice. Card refunds stay manual in Stripe. 409 CANCEL_REQUEST_NOT_OPEN when already decided.
     * @param {string} id 
     * @param {string} [xGuestToken] Guest JWT token for unauthenticated users
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrderApi
     */
    public cancelRequestControllerApprove(id: string, xGuestToken?: string, options?: AxiosRequestConfig) {
        return OrderApiFp(this.configuration).cancelRequestControllerApprove(id, xGuestToken, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Decline: release the hold. No customer email. 409 CANCEL_REQUEST_NOT_OPEN when already decided.
     * @param {string} id 
     * @param {DeclineCancelRequestDto} declineCancelRequestDto 
     * @param {string} [xGuestToken] Guest JWT token for unauthenticated users
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrderApi
     */
    public cancelRequestControllerDecline(id: string, declineCancelRequestDto: DeclineCancelRequestDto, xGuestToken?: string, options?: AxiosRequestConfig) {
        return OrderApiFp(this.configuration).cancelRequestControllerDecline(id, declineCancelRequestDto, xGuestToken, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Open cancel requests, and approved card cancellations whose Stripe refund has not arrived (admin).
     * @param {string} [xGuestToken] Guest JWT token for unauthenticated users
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrderApi
     */
    public cancelRequestControllerQueue(xGuestToken?: string, options?: AxiosRequestConfig) {
        return OrderApiFp(this.configuration).cancelRequestControllerQueue(xGuestToken, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Ask for this order to be canceled. Held out of production until an admin decides. 409 CANCEL_REQUEST_NOT_ALLOWED with reason WINDOW_PASSED | IN_PRODUCTION | STATUS | KIND | ALREADY_REQUESTED; 404 while customerCancelRequestEnabled is off.
     * @param {string} id 
     * @param {CreateCancelRequestDto} createCancelRequestDto 
     * @param {string} [xGuestToken] Guest JWT token for unauthenticated users
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrderApi
     */
    public cancelRequestControllerRequest(id: string, createCancelRequestDto: CreateCancelRequestDto, xGuestToken?: string, options?: AxiosRequestConfig) {
        return OrderApiFp(this.configuration).cancelRequestControllerRequest(id, createCancelRequestDto, xGuestToken, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Create a single Order
     * @param {CreateOrderDto} createOrderDto 
     * @param {string} [xGuestToken] Guest JWT token for unauthenticated users
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrderApi
     */
    public createOneBaseOrderControllerOrder(createOrderDto: CreateOrderDto, xGuestToken?: string, options?: AxiosRequestConfig) {
        return OrderApiFp(this.configuration).createOneBaseOrderControllerOrder(createOrderDto, xGuestToken, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Delete a single Order
     * @param {string} id 
     * @param {string} [xGuestToken] Guest JWT token for unauthenticated users
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrderApi
     */
    public deleteOneBaseOrderControllerOrder(id: string, xGuestToken?: string, options?: AxiosRequestConfig) {
        return OrderApiFp(this.configuration).deleteOneBaseOrderControllerOrder(id, xGuestToken, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Retrieve multiple Orders
     * @param {string} [xGuestToken] Guest JWT token for unauthenticated users
     * @param {Array<string>} [fields] Selects resource fields. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#select\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param {string} [s] Adds search condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#search\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param {Array<string>} [filter] Adds filter condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#filter\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param {Array<string>} [or] Adds OR condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#or\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param {Array<string>} [sort] Adds sort by field. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#sort\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param {Array<string>} [join] Adds relational resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#join\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param {number} [limit] Limit amount of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#limit\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param {number} [offset] Offset amount of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#offset\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param {number} [page] Page portion of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#page\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param {number} [cache] Reset cache (if was enabled). &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#cache\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrderApi
     */
    public getManyBaseOrderControllerOrder(xGuestToken?: string, fields?: Array<string>, s?: string, filter?: Array<string>, or?: Array<string>, sort?: Array<string>, join?: Array<string>, limit?: number, offset?: number, page?: number, cache?: number, options?: AxiosRequestConfig) {
        return OrderApiFp(this.configuration).getManyBaseOrderControllerOrder(xGuestToken, fields, s, filter, or, sort, join, limit, offset, page, cache, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Retrieve a single Order
     * @param {string} id 
     * @param {string} [xGuestToken] Guest JWT token for unauthenticated users
     * @param {Array<string>} [fields] Selects resource fields. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#select\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param {Array<string>} [join] Adds relational resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#join\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param {number} [cache] Reset cache (if was enabled). &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#cache\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrderApi
     */
    public getOneBaseOrderControllerOrder(id: string, xGuestToken?: string, fields?: Array<string>, join?: Array<string>, cache?: number, options?: AxiosRequestConfig) {
        return OrderApiFp(this.configuration).getOneBaseOrderControllerOrder(id, xGuestToken, fields, join, cache, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Abandon the order\'s open Stripe payment attempt so its price pin (and credit) can change again. Idempotent.
     * @param {string} id Order ID
     * @param {string} [xGuestToken] Guest JWT token for unauthenticated users
     * @param {AbandonPaymentDto} [abandonPaymentDto] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrderApi
     */
    public orderControllerAbandonPayment(id: string, xGuestToken?: string, abandonPaymentDto?: AbandonPaymentDto, options?: AxiosRequestConfig) {
        return OrderApiFp(this.configuration).orderControllerAbandonPayment(id, xGuestToken, abandonPaymentDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Add a catalogue artwork to an order
     * @param {string} id Order ID
     * @param {AddArtworkToOrderDto} addArtworkToOrderDto 
     * @param {string} [xGuestToken] Guest JWT token for unauthenticated users
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrderApi
     */
    public orderControllerAddArtwork(id: string, addArtworkToOrderDto: AddArtworkToOrderDto, xGuestToken?: string, options?: AxiosRequestConfig) {
        return OrderApiFp(this.configuration).orderControllerAddArtwork(id, addArtworkToOrderDto, xGuestToken, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Add a map print to an order
     * @param {string} id Order ID
     * @param {AddMapToOrderDto} addMapToOrderDto 
     * @param {string} [xGuestToken] Guest JWT token for unauthenticated users
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrderApi
     */
    public orderControllerAddMap(id: string, addMapToOrderDto: AddMapToOrderDto, xGuestToken?: string, options?: AxiosRequestConfig) {
        return OrderApiFp(this.configuration).orderControllerAddMap(id, addMapToOrderDto, xGuestToken, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary [Deprecated] Add order calendar — use POST /order/:id/calendars instead
     * @param {string} id Order ID
     * @param {OrderControllerAddOrderCalendarFormatEnum} format Calendar format
     * @param {number} quantity Quantity of calendars
     * @param {File} file Calendar PDF file (required)
     * @param {string} [xGuestToken] Guest JWT token for unauthenticated users
     * @param {OrderControllerAddOrderCalendarPaperEnum} [paper] Calendar paper (optional, defaults to \\\&#39;white\\\&#39;)
     * @param {string} [calendarData] Optional calendar configuration data (JSON string)
     * @param {string} [photoSettings] Optional photo settings array (JSON string) - position, rotation, filters, etc.
     * @param {string} [photoKeys] Optional comma-separated list of existing photo keys/IDs to attach to calendar
     * @param {Array<File>} [photos] Optional array of photo files to upload and attach to calendar
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrderApi
     */
    public orderControllerAddOrderCalendar(id: string, format: OrderControllerAddOrderCalendarFormatEnum, quantity: number, file: File, xGuestToken?: string, paper?: OrderControllerAddOrderCalendarPaperEnum, calendarData?: string, photoSettings?: string, photoKeys?: string, photos?: Array<File>, options?: AxiosRequestConfig) {
        return OrderApiFp(this.configuration).orderControllerAddOrderCalendar(id, format, quantity, file, xGuestToken, paper, calendarData, photoSettings, photoKeys, photos, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Add a calendar to an order (multipart)
     * @param {string} id Order ID
     * @param {string} [xGuestToken] Guest JWT token for unauthenticated users
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrderApi
     */
    public orderControllerAddOrderCalendarUnified(id: string, xGuestToken?: string, options?: AxiosRequestConfig) {
        return OrderApiFp(this.configuration).orderControllerAddOrderCalendarUnified(id, xGuestToken, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary [Deprecated] Add order photos — use POST /order/:id/photos instead
     * @param {string} id Order ID
     * @param {OrderControllerAddOrderPhotosRequest} orderControllerAddOrderPhotosRequest Order Data
     * @param {string} [xGuestToken] Guest JWT token for unauthenticated users
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrderApi
     */
    public orderControllerAddOrderPhotos(id: string, orderControllerAddOrderPhotosRequest: OrderControllerAddOrderPhotosRequest, xGuestToken?: string, options?: AxiosRequestConfig) {
        return OrderApiFp(this.configuration).orderControllerAddOrderPhotos(id, orderControllerAddOrderPhotosRequest, xGuestToken, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Add photos to an order
     * @param {string} id Order ID
     * @param {OrderControllerAddOrderPhotosRequest} orderControllerAddOrderPhotosRequest 
     * @param {string} [xGuestToken] Guest JWT token for unauthenticated users
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrderApi
     */
    public orderControllerAddOrderPhotosUnified(id: string, orderControllerAddOrderPhotosRequest: OrderControllerAddOrderPhotosRequest, xGuestToken?: string, options?: AxiosRequestConfig) {
        return OrderApiFp(this.configuration).orderControllerAddOrderPhotosUnified(id, orderControllerAddOrderPhotosRequest, xGuestToken, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary [Deprecated] Add order product detail — use POST /order/:id/products instead
     * @param {string} id Order ID
     * @param {OrderControllerAddOrderProductDetailRequest} orderControllerAddOrderProductDetailRequest Product detail data to add
     * @param {string} [xGuestToken] Guest JWT token for unauthenticated users
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrderApi
     */
    public orderControllerAddOrderProductDetail(id: string, orderControllerAddOrderProductDetailRequest: OrderControllerAddOrderProductDetailRequest, xGuestToken?: string, options?: AxiosRequestConfig) {
        return OrderApiFp(this.configuration).orderControllerAddOrderProductDetail(id, orderControllerAddOrderProductDetailRequest, xGuestToken, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Add party-camera photos to an order (one print group)
     * @param {string} id Order ID
     * @param {AddPartyPhotosDto} addPartyPhotosDto 
     * @param {string} [xGuestToken] Guest JWT token for unauthenticated users
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrderApi
     */
    public orderControllerAddPartyPhotos(id: string, addPartyPhotosDto: AddPartyPhotosDto, xGuestToken?: string, options?: AxiosRequestConfig) {
        return OrderApiFp(this.configuration).orderControllerAddPartyPhotos(id, addPartyPhotosDto, xGuestToken, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Add a product-with-media (greeting card) line to an order
     * @param {string} id Order ID
     * @param {AddProductWithMediaToOrderDto} addProductWithMediaToOrderDto 
     * @param {string} [xGuestToken] Guest JWT token for unauthenticated users
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrderApi
     */
    public orderControllerAddProductWithMedia(id: string, addProductWithMediaToOrderDto: AddProductWithMediaToOrderDto, xGuestToken?: string, options?: AxiosRequestConfig) {
        return OrderApiFp(this.configuration).orderControllerAddProductWithMedia(id, addProductWithMediaToOrderDto, xGuestToken, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Apply the customer\'s granted credit to this order, after any coupon.
     * @param {string} id Order ID
     * @param {UpdateOrderCreditDto} updateOrderCreditDto Credit token, and optionally the lots to spend
     * @param {string} [xGuestToken] Guest JWT token for unauthenticated users
     * @param {string} [xClientChannel] Client channel; re-derives the order\&#39;s channel on the recalculation after the credit is applied, while the order is unpinned. The exact value \&#39;MOBILE\&#39; switches it to the app\&#39;s own pricing chain, any other present value switches it to WEB, and an absent or blank header leaves the stored channel untouched.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrderApi
     */
    public orderControllerApplyCreditToOrder(id: string, updateOrderCreditDto: UpdateOrderCreditDto, xGuestToken?: string, xClientChannel?: string, options?: AxiosRequestConfig) {
        return OrderApiFp(this.configuration).orderControllerApplyCreditToOrder(id, updateOrderCreditDto, xGuestToken, xClientChannel, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Bundles for this order: applied, the selected bundle\'s slot progress, the hint, the coupon block.
     * @param {string} id 
     * @param {string} [xGuestToken] Guest JWT token for unauthenticated users
     * @param {string} [locale] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrderApi
     */
    public orderControllerBundles(id: string, xGuestToken?: string, locale?: string, options?: AxiosRequestConfig) {
        return OrderApiFp(this.configuration).orderControllerBundles(id, xGuestToken, locale, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Calculate total amount for an order
     * @param {string} id Order ID
     * @param {string} [xGuestToken] Guest JWT token for unauthenticated users
     * @param {string} [xClientChannel] Client channel; re-derives the order\&#39;s channel on this post-edit recalculation, while the order is unpinned. The exact value \&#39;MOBILE\&#39; switches it to the app\&#39;s own pricing chain, any other present value switches it to WEB, and an absent or blank header leaves the stored channel untouched.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrderApi
     */
    public orderControllerCalculateAmount(id: string, xGuestToken?: string, xClientChannel?: string, options?: AxiosRequestConfig) {
        return OrderApiFp(this.configuration).orderControllerCalculateAmount(id, xGuestToken, xClientChannel, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Cashback for this order: a live preview while unpaid, pending once placed, the award once recorded.
     * @param {string} id 
     * @param {string} [xGuestToken] Guest JWT token for unauthenticated users
     * @param {OrderControllerCashbackPaymentOptionEnum} [paymentOption] The cart\&#39;s current choice; only an unpaid cart\&#39;s preview uses it.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrderApi
     */
    public orderControllerCashback(id: string, xGuestToken?: string, paymentOption?: OrderControllerCashbackPaymentOptionEnum, options?: AxiosRequestConfig) {
        return OrderApiFp(this.configuration).orderControllerCashback(id, xGuestToken, paymentOption, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Change a photo group\'s size (merges into an existing group of that size with the same options)
     * @param {string} id Order ID
     * @param {string} childId Order Photo ID
     * @param {ChangeOrderPhotoSizeDto} changeOrderPhotoSizeDto 
     * @param {string} [xGuestToken] Guest JWT token for unauthenticated users
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrderApi
     */
    public orderControllerChangeOrderPhotoSize(id: string, childId: string, changeOrderPhotoSizeDto: ChangeOrderPhotoSizeDto, xGuestToken?: string, options?: AxiosRequestConfig) {
        return OrderApiFp(this.configuration).orderControllerChangeOrderPhotoSize(id, childId, changeOrderPhotoSizeDto, xGuestToken, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get coupon by code
     * @param {string} code 
     * @param {string} [xGuestToken] Guest JWT token for unauthenticated users
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrderApi
     */
    public orderControllerCheckCoupon(code: string, xGuestToken?: string, options?: AxiosRequestConfig) {
        return OrderApiFp(this.configuration).orderControllerCheckCoupon(code, xGuestToken, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Choose the photo for the free 30 x 40 enlargement the basket earned. 400 when the order has none; 404 when the photo is not in its paid lines.
     * @param {string} id 
     * @param {ChooseFreeEnlargementDto} chooseFreeEnlargementDto 
     * @param {string} [xGuestToken] Guest JWT token for unauthenticated users
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrderApi
     */
    public orderControllerChooseFreeEnlargement(id: string, chooseFreeEnlargementDto: ChooseFreeEnlargementDto, xGuestToken?: string, options?: AxiosRequestConfig) {
        return OrderApiFp(this.configuration).orderControllerChooseFreeEnlargement(id, chooseFreeEnlargementDto, xGuestToken, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Clear cache
     * @param {string} [xGuestToken] Guest JWT token for unauthenticated users
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrderApi
     */
    public orderControllerClearCache(xGuestToken?: string, options?: AxiosRequestConfig) {
        return OrderApiFp(this.configuration).orderControllerClearCache(xGuestToken, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Create an order
     * @param {CreateUserOrderDTO} createUserOrderDTO Order Data
     * @param {string} [xGuestToken] Guest JWT token for unauthenticated users
     * @param {string} [xClientChannel] Client channel; selects the channel recorded on the new order. The exact value \&#39;MOBILE\&#39; records an app order and prices it down the app\&#39;s own chain; any other present value records WEB; only an absent header falls back to the body\&#39;s (deprecated) orderSource.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrderApi
     */
    public orderControllerCreateOrder(createUserOrderDTO: CreateUserOrderDTO, xGuestToken?: string, xClientChannel?: string, options?: AxiosRequestConfig) {
        return OrderApiFp(this.configuration).orderControllerCreateOrder(createUserOrderDTO, xGuestToken, xClientChannel, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {string} [xGuestToken] Guest JWT token for unauthenticated users
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrderApi
     */
    public orderControllerCreateReceipt(id: string, xGuestToken?: string, options?: AxiosRequestConfig) {
        return OrderApiFp(this.configuration).orderControllerCreateReceipt(id, xGuestToken, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Checkout funnel conversion vs the same weekday (admin)
     * @param {string} [xGuestToken] Guest JWT token for unauthenticated users
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrderApi
     */
    public orderControllerFunnelHealth(xGuestToken?: string, options?: AxiosRequestConfig) {
        return OrderApiFp(this.configuration).orderControllerFunnelHealth(xGuestToken, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {string} [xGuestToken] Guest JWT token for unauthenticated users
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrderApi
     */
    public orderControllerGetEditorGuestSession(id: string, xGuestToken?: string, options?: AxiosRequestConfig) {
        return OrderApiFp(this.configuration).orderControllerGetEditorGuestSession(id, xGuestToken, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Prepares the parcel if it has not been prepared yet, then returns the label document from MyGLS GetPrintedLabels. Safe to call repeatedly: the stored ParcelId is reused, so no duplicate parcel is registered.
     * @summary Download the printable GLS label (prevoznica) for an order
     * @param {string} id 
     * @param {string} [xGuestToken] Guest JWT token for unauthenticated users
     * @param {string} [printer] GLS label format to request, overriding GLS_TYPE_OF_PRINTER. The 62mm workflow asks for Thermo (an 85x85mm square label) because that is the only output worth downscaling — an A4_* sheet scaled to 62mm would shrink the label itself to roughly 18mm. Invalid values are rejected by GlsService before any call to GLS.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrderApi
     */
    public orderControllerGetGlsLabelDocument(id: string, xGuestToken?: string, printer?: string, options?: AxiosRequestConfig) {
        return OrderApiFp(this.configuration).orderControllerGetGlsLabelDocument(id, xGuestToken, printer, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get all orders for analytics
     * @param {string} [xGuestToken] Guest JWT token for unauthenticated users
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrderApi
     */
    public orderControllerGetManyForAnalytics(xGuestToken?: string, options?: AxiosRequestConfig) {
        return OrderApiFp(this.configuration).orderControllerGetManyForAnalytics(xGuestToken, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Order event log / audit trail (admin)
     * @param {string} id 
     * @param {string} [xGuestToken] Guest JWT token for unauthenticated users
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrderApi
     */
    public orderControllerGetOrderEvents(id: string, xGuestToken?: string, options?: AxiosRequestConfig) {
        return OrderApiFp(this.configuration).orderControllerGetOrderEvents(id, xGuestToken, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Orders Stripe charged that we never finalized (admin)
     * @param {string} [xGuestToken] Guest JWT token for unauthenticated users
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrderApi
     */
    public orderControllerGetPaymentAlerts(xGuestToken?: string, options?: AxiosRequestConfig) {
        return OrderApiFp(this.configuration).orderControllerGetPaymentAlerts(xGuestToken, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get all orders for the authenticated user
     * @param {string} [xGuestToken] Guest JWT token for unauthenticated users
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrderApi
     */
    public orderControllerGetUserOrders(xGuestToken?: string, options?: AxiosRequestConfig) {
        return OrderApiFp(this.configuration).orderControllerGetUserOrders(xGuestToken, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {string} [xGuestToken] Guest JWT token for unauthenticated users
     * @param {PreparePaymentRequestDto} [preparePaymentRequestDto] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrderApi
     */
    public orderControllerNotifyPaymentOnDelivery(id: string, xGuestToken?: string, preparePaymentRequestDto?: PreparePaymentRequestDto, options?: AxiosRequestConfig) {
        return OrderApiFp(this.configuration).orderControllerNotifyPaymentOnDelivery(id, xGuestToken, preparePaymentRequestDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Notify user to complete purchase
     * @param {string} id Order ID
     * @param {string} [xGuestToken] Guest JWT token for unauthenticated users
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrderApi
     */
    public orderControllerNotifyUserToCompletePurchase(id: string, xGuestToken?: string, options?: AxiosRequestConfig) {
        return OrderApiFp(this.configuration).orderControllerNotifyUserToCompletePurchase(id, xGuestToken, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Stuck / unfulfillable order counts (admin)
     * @param {string} [xGuestToken] Guest JWT token for unauthenticated users
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrderApi
     */
    public orderControllerOrderHealth(xGuestToken?: string, options?: AxiosRequestConfig) {
        return OrderApiFp(this.configuration).orderControllerOrderHealth(xGuestToken, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get all orders for analytics
     * @param {string} id 
     * @param {string} [xGuestToken] Guest JWT token for unauthenticated users
     * @param {string} [newParcel] true registers a replacement parcel at GLS even though the order already has one. Absent (what every existing caller sends), the stored parcel is returned and GLS is not called, so repeated clicks on GLS Label or Print Order no longer register a parcel each.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrderApi
     */
    public orderControllerPrepareGlsLabel(id: string, xGuestToken?: string, newParcel?: string, options?: AxiosRequestConfig) {
        return OrderApiFp(this.configuration).orderControllerPrepareGlsLabel(id, xGuestToken, newParcel, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Create a native Stripe PaymentIntent for in-app (mobile) payment
     * @param {string} id Order ID
     * @param {string} [xGuestToken] Guest JWT token for unauthenticated users
     * @param {PreparePaymentRequestDto} [preparePaymentRequestDto] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrderApi
     */
    public orderControllerPrepareNativeOrderPayment(id: string, xGuestToken?: string, preparePaymentRequestDto?: PreparePaymentRequestDto, options?: AxiosRequestConfig) {
        return OrderApiFp(this.configuration).orderControllerPrepareNativeOrderPayment(id, xGuestToken, preparePaymentRequestDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Process payment for an order
     * @param {string} id Order ID
     * @param {string} [xGuestToken] Guest JWT token for unauthenticated users
     * @param {PreparePaymentRequestDto} [preparePaymentRequestDto] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrderApi
     */
    public orderControllerPrepareOrderPayment(id: string, xGuestToken?: string, preparePaymentRequestDto?: PreparePaymentRequestDto, options?: AxiosRequestConfig) {
        return OrderApiFp(this.configuration).orderControllerPrepareOrderPayment(id, xGuestToken, preparePaymentRequestDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Record a checkout-flow checkpoint for an order
     * @param {string} id Order ID
     * @param {RecordCheckpointDto} recordCheckpointDto 
     * @param {string} [xGuestToken] Guest JWT token for unauthenticated users
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrderApi
     */
    public orderControllerRecordCheckpoint(id: string, recordCheckpointDto: RecordCheckpointDto, xGuestToken?: string, options?: AxiosRequestConfig) {
        return OrderApiFp(this.configuration).orderControllerRecordCheckpoint(id, recordCheckpointDto, xGuestToken, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Remove coupon from an order
     * @param {string} id Order ID
     * @param {string} [xGuestToken] Guest JWT token for unauthenticated users
     * @param {string} [xClientChannel] Client channel; re-derives the order\&#39;s channel on the recalculation after the coupon is removed, while the order is unpinned. The exact value \&#39;MOBILE\&#39; switches it to the app\&#39;s own pricing chain, any other present value switches it to WEB, and an absent or blank header leaves the stored channel untouched.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrderApi
     */
    public orderControllerRemoveCouponFromOrder(id: string, xGuestToken?: string, xClientChannel?: string, options?: AxiosRequestConfig) {
        return OrderApiFp(this.configuration).orderControllerRemoveCouponFromOrder(id, xGuestToken, xClientChannel, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Take the applied credit back off this order; the lots are restored.
     * @param {string} id Order ID
     * @param {string} [xGuestToken] Guest JWT token for unauthenticated users
     * @param {string} [xClientChannel] Client channel; re-derives the order\&#39;s channel on the recalculation after the credit is removed, while the order is unpinned. The exact value \&#39;MOBILE\&#39; switches it to the app\&#39;s own pricing chain, any other present value switches it to WEB, and an absent or blank header leaves the stored channel untouched.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrderApi
     */
    public orderControllerRemoveCreditFromOrder(id: string, xGuestToken?: string, xClientChannel?: string, options?: AxiosRequestConfig) {
        return OrderApiFp(this.configuration).orderControllerRemoveCreditFromOrder(id, xGuestToken, xClientChannel, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary [Deprecated] Remove order calendar — use DELETE /order/:id/calendars/:childId instead
     * @param {string} id Order ID
     * @param {OrderControllerRemoveOrderCalendarRequest} orderControllerRemoveOrderCalendarRequest Calendar ID to remove
     * @param {string} [xGuestToken] Guest JWT token for unauthenticated users
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrderApi
     */
    public orderControllerRemoveOrderCalendar(id: string, orderControllerRemoveOrderCalendarRequest: OrderControllerRemoveOrderCalendarRequest, xGuestToken?: string, options?: AxiosRequestConfig) {
        return OrderApiFp(this.configuration).orderControllerRemoveOrderCalendar(id, orderControllerRemoveOrderCalendarRequest, xGuestToken, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Remove an order calendar
     * @param {string} id Order ID
     * @param {string} childId Order calendar ID
     * @param {string} [xGuestToken] Guest JWT token for unauthenticated users
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrderApi
     */
    public orderControllerRemoveOrderCalendarUnified(id: string, childId: string, xGuestToken?: string, options?: AxiosRequestConfig) {
        return OrderApiFp(this.configuration).orderControllerRemoveOrderCalendarUnified(id, childId, xGuestToken, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary [Deprecated] Remove an order photo — use DELETE /order/:id/photos/:childId instead
     * @param {string} id Order ID
     * @param {string} orderPhotoId Order Photo ID
     * @param {string} [xGuestToken] Guest JWT token for unauthenticated users
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrderApi
     */
    public orderControllerRemoveOrderPhoto(id: string, orderPhotoId: string, xGuestToken?: string, options?: AxiosRequestConfig) {
        return OrderApiFp(this.configuration).orderControllerRemoveOrderPhoto(id, orderPhotoId, xGuestToken, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Remove an order photo from an order
     * @param {string} id Order ID
     * @param {string} childId Order Photo ID
     * @param {string} [xGuestToken] Guest JWT token for unauthenticated users
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrderApi
     */
    public orderControllerRemoveOrderPhotoUnified(id: string, childId: string, xGuestToken?: string, options?: AxiosRequestConfig) {
        return OrderApiFp(this.configuration).orderControllerRemoveOrderPhotoUnified(id, childId, xGuestToken, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Remove an order product detail
     * @param {string} id Order ID
     * @param {string} childId Order product detail ID
     * @param {string} [xGuestToken] Guest JWT token for unauthenticated users
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrderApi
     */
    public orderControllerRemoveOrderProduct(id: string, childId: string, xGuestToken?: string, options?: AxiosRequestConfig) {
        return OrderApiFp(this.configuration).orderControllerRemoveOrderProduct(id, childId, xGuestToken, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Remove order product detail from an order
     * @param {string} id Order ID
     * @param {OrderControllerRemoveOrderProductDetailsRequest} orderControllerRemoveOrderProductDetailsRequest Product detail ID to remove
     * @param {string} [xGuestToken] Guest JWT token for unauthenticated users
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrderApi
     */
    public orderControllerRemoveOrderProductDetails(id: string, orderControllerRemoveOrderProductDetailsRequest: OrderControllerRemoveOrderProductDetailsRequest, xGuestToken?: string, options?: AxiosRequestConfig) {
        return OrderApiFp(this.configuration).orderControllerRemoveOrderProductDetails(id, orderControllerRemoveOrderProductDetailsRequest, xGuestToken, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Remove a product-with-media line from an order
     * @param {string} id 
     * @param {string} lineId 
     * @param {string} [xGuestToken] Guest JWT token for unauthenticated users
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrderApi
     */
    public orderControllerRemoveProductWithMedia(id: string, lineId: string, xGuestToken?: string, options?: AxiosRequestConfig) {
        return OrderApiFp(this.configuration).orderControllerRemoveProductWithMedia(id, lineId, xGuestToken, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Admin: send a post-purchase email for an order through Listmonk, without marking it as sent (idempotent for testing).
     * @param {string} id Order ID
     * @param {OrderControllerSendPostPurchaseTestEmailRequest} orderControllerSendPostPurchaseTestEmailRequest 
     * @param {string} [xGuestToken] Guest JWT token for unauthenticated users
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrderApi
     */
    public orderControllerSendPostPurchaseTestEmail(id: string, orderControllerSendPostPurchaseTestEmailRequest: OrderControllerSendPostPurchaseTestEmailRequest, xGuestToken?: string, options?: AxiosRequestConfig) {
        return OrderApiFp(this.configuration).orderControllerSendPostPurchaseTestEmail(id, orderControllerSendPostPurchaseTestEmailRequest, xGuestToken, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Set delivery type for order
     * @param {string} id Order ID
     * @param {UpdateDeliveryTypeDto} updateDeliveryTypeDto Delivery type and optional delivery point information
     * @param {string} [xGuestToken] Guest JWT token for unauthenticated users
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrderApi
     */
    public orderControllerSetDeliveryType(id: string, updateDeliveryTypeDto: UpdateDeliveryTypeDto, xGuestToken?: string, options?: AxiosRequestConfig) {
        return OrderApiFp(this.configuration).orderControllerSetDeliveryType(id, updateDeliveryTypeDto, xGuestToken, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Set (or clear with null) the bundle the customer is filling. 404 when not offered to this order.
     * @param {string} id 
     * @param {SetSelectedBundleDto} setSelectedBundleDto 
     * @param {string} [xGuestToken] Guest JWT token for unauthenticated users
     * @param {string} [locale] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrderApi
     */
    public orderControllerSetSelectedBundle(id: string, setSelectedBundleDto: SetSelectedBundleDto, xGuestToken?: string, locale?: string, options?: AxiosRequestConfig) {
        return OrderApiFp(this.configuration).orderControllerSetSelectedBundle(id, setSelectedBundleDto, xGuestToken, locale, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update an order shipping
     * @param {any} id Order ID
     * @param {UpdateOrderShippingDto} updateOrderShippingDto Order Data
     * @param {string} [xGuestToken] Guest JWT token for unauthenticated users
     * @param {string} [xClientChannel] Client channel; re-derives the order\&#39;s channel on the recalculation after this shipping update, while the order is unpinned. The exact value \&#39;MOBILE\&#39; switches it to the app\&#39;s own pricing chain, any other present value switches it to WEB, and an absent or blank header leaves the stored channel untouched.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrderApi
     */
    public orderControllerUpdateOneShipping(id: any, updateOrderShippingDto: UpdateOrderShippingDto, xGuestToken?: string, xClientChannel?: string, options?: AxiosRequestConfig) {
        return OrderApiFp(this.configuration).orderControllerUpdateOneShipping(id, updateOrderShippingDto, xGuestToken, xClientChannel, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary [Deprecated] Update order calendar quantity — use PATCH /order/:id/calendars/:childId instead
     * @param {string} id Order ID
     * @param {OrderControllerUpdateOrderCalendarQuantityRequest} orderControllerUpdateOrderCalendarQuantityRequest Order calendar update data
     * @param {string} [xGuestToken] Guest JWT token for unauthenticated users
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrderApi
     */
    public orderControllerUpdateOrderCalendarQuantity(id: string, orderControllerUpdateOrderCalendarQuantityRequest: OrderControllerUpdateOrderCalendarQuantityRequest, xGuestToken?: string, options?: AxiosRequestConfig) {
        return OrderApiFp(this.configuration).orderControllerUpdateOrderCalendarQuantity(id, orderControllerUpdateOrderCalendarQuantityRequest, xGuestToken, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update an order calendar quantity
     * @param {string} id Order ID
     * @param {string} childId Order calendar ID
     * @param {OrderControllerUpdateOrderProductQuantityRequest} orderControllerUpdateOrderProductQuantityRequest 
     * @param {string} [xGuestToken] Guest JWT token for unauthenticated users
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrderApi
     */
    public orderControllerUpdateOrderCalendarQuantityUnified(id: string, childId: string, orderControllerUpdateOrderProductQuantityRequest: OrderControllerUpdateOrderProductQuantityRequest, xGuestToken?: string, options?: AxiosRequestConfig) {
        return OrderApiFp(this.configuration).orderControllerUpdateOrderCalendarQuantityUnified(id, childId, orderControllerUpdateOrderProductQuantityRequest, xGuestToken, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update an order
     * @param {string} id 
     * @param {UpdateOrderCouponDto} updateOrderCouponDto Order Data
     * @param {string} [xGuestToken] Guest JWT token for unauthenticated users
     * @param {string} [xClientChannel] Client channel; re-derives the order\&#39;s channel on the recalculation after the coupon is applied, while the order is unpinned. The exact value \&#39;MOBILE\&#39; switches it to the app\&#39;s own pricing chain, any other present value switches it to WEB, and an absent or blank header leaves the stored channel untouched.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrderApi
     */
    public orderControllerUpdateOrderCoupon(id: string, updateOrderCouponDto: UpdateOrderCouponDto, xGuestToken?: string, xClientChannel?: string, options?: AxiosRequestConfig) {
        return OrderApiFp(this.configuration).orderControllerUpdateOrderCoupon(id, updateOrderCouponDto, xGuestToken, xClientChannel, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary [Deprecated] Update product detail quantity — use PATCH /order/:id/products/:childId instead
     * @param {string} id Order ID
     * @param {OrderControllerUpdateOrderProductDetailQuantityRequest} orderControllerUpdateOrderProductDetailQuantityRequest Order product detail update data
     * @param {string} [xGuestToken] Guest JWT token for unauthenticated users
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrderApi
     */
    public orderControllerUpdateOrderProductDetailQuantity(id: string, orderControllerUpdateOrderProductDetailQuantityRequest: OrderControllerUpdateOrderProductDetailQuantityRequest, xGuestToken?: string, options?: AxiosRequestConfig) {
        return OrderApiFp(this.configuration).orderControllerUpdateOrderProductDetailQuantity(id, orderControllerUpdateOrderProductDetailQuantityRequest, xGuestToken, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update an order product detail quantity
     * @param {string} id Order ID
     * @param {string} childId Order product detail ID
     * @param {OrderControllerUpdateOrderProductQuantityRequest} orderControllerUpdateOrderProductQuantityRequest 
     * @param {string} [xGuestToken] Guest JWT token for unauthenticated users
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrderApi
     */
    public orderControllerUpdateOrderProductQuantity(id: string, childId: string, orderControllerUpdateOrderProductQuantityRequest: OrderControllerUpdateOrderProductQuantityRequest, xGuestToken?: string, options?: AxiosRequestConfig) {
        return OrderApiFp(this.configuration).orderControllerUpdateOrderProductQuantity(id, childId, orderControllerUpdateOrderProductQuantityRequest, xGuestToken, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Change the quantity of a product-with-media (greeting card) line
     * @param {string} id Order ID
     * @param {string} lineId Product-with-media line ID
     * @param {OrderControllerUpdateProductWithMediaQuantityRequest} orderControllerUpdateProductWithMediaQuantityRequest 
     * @param {string} [xGuestToken] Guest JWT token for unauthenticated users
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrderApi
     */
    public orderControllerUpdateProductWithMediaQuantity(id: string, lineId: string, orderControllerUpdateProductWithMediaQuantityRequest: OrderControllerUpdateProductWithMediaQuantityRequest, xGuestToken?: string, options?: AxiosRequestConfig) {
        return OrderApiFp(this.configuration).orderControllerUpdateProductWithMediaQuantity(id, lineId, orderControllerUpdateProductWithMediaQuantityRequest, xGuestToken, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update total number of photos for all orders
     * @param {string} [xGuestToken] Guest JWT token for unauthenticated users
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrderApi
     */
    public orderControllerUpdateTotalNumberOfPhotosForAllOrders(xGuestToken?: string, options?: AxiosRequestConfig) {
        return OrderApiFp(this.configuration).orderControllerUpdateTotalNumberOfPhotosForAllOrders(xGuestToken, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update an order with user
     * @param {any} id Order ID
     * @param {UpdateOrderUserDTO} updateOrderUserDTO Order Data
     * @param {string} [xGuestToken] Guest JWT token for unauthenticated users
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrderApi
     */
    public orderControllerUpdateUserOrder(id: any, updateOrderUserDTO: UpdateOrderUserDTO, xGuestToken?: string, options?: AxiosRequestConfig) {
        return OrderApiFp(this.configuration).orderControllerUpdateUserOrder(id, updateOrderUserDTO, xGuestToken, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Add or upsert an order product detail (increments existing line if the product is already in the order)
     * @param {string} id Order ID
     * @param {OrderControllerUpsertOrderProductRequest} orderControllerUpsertOrderProductRequest 
     * @param {string} [xGuestToken] Guest JWT token for unauthenticated users
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrderApi
     */
    public orderControllerUpsertOrderProduct(id: string, orderControllerUpsertOrderProductRequest: OrderControllerUpsertOrderProductRequest, xGuestToken?: string, options?: AxiosRequestConfig) {
        return OrderApiFp(this.configuration).orderControllerUpsertOrderProduct(id, orderControllerUpsertOrderProductRequest, xGuestToken, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Replace a single Order
     * @param {string} id 
     * @param {UpdateOrderDto} updateOrderDto 
     * @param {string} [xGuestToken] Guest JWT token for unauthenticated users
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrderApi
     */
    public replaceOneBaseOrderControllerOrder(id: string, updateOrderDto: UpdateOrderDto, xGuestToken?: string, options?: AxiosRequestConfig) {
        return OrderApiFp(this.configuration).replaceOneBaseOrderControllerOrder(id, updateOrderDto, xGuestToken, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Record the trip-suggestion counts on a PENDING order (suggested, kept ≤ suggested, added). 409 ORDER_NOT_PENDING otherwise.
     * @param {string} id 
     * @param {TripSuggestionDto} tripSuggestionDto 
     * @param {string} [xGuestToken] Guest JWT token for unauthenticated users
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrderApi
     */
    public tripSuggestionControllerRecord(id: string, tripSuggestionDto: TripSuggestionDto, xGuestToken?: string, options?: AxiosRequestConfig) {
        return OrderApiFp(this.configuration).tripSuggestionControllerRecord(id, tripSuggestionDto, xGuestToken, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update a single Order
     * @param {string} id 
     * @param {UpdateOrderDto} updateOrderDto 
     * @param {string} [xGuestToken] Guest JWT token for unauthenticated users
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrderApi
     */
    public updateOneBaseOrderControllerOrder(id: string, updateOrderDto: UpdateOrderDto, xGuestToken?: string, options?: AxiosRequestConfig) {
        return OrderApiFp(this.configuration).updateOneBaseOrderControllerOrder(id, updateOrderDto, xGuestToken, options).then((request) => request(this.axios, this.basePath));
    }
}

/**
 * @export
 */
export const OrderControllerAddOrderCalendarFormatEnum = {
    A2: 'A2',
    A3: 'A3',
    A4: 'A4',
    A5: 'A5',
    PlannerA3: 'PLANNER_A3',
    SpreadA4: 'SPREAD_A4'
} as const;
export type OrderControllerAddOrderCalendarFormatEnum = typeof OrderControllerAddOrderCalendarFormatEnum[keyof typeof OrderControllerAddOrderCalendarFormatEnum];
/**
 * @export
 */
export const OrderControllerAddOrderCalendarPaperEnum = {
    White: 'white'
} as const;
export type OrderControllerAddOrderCalendarPaperEnum = typeof OrderControllerAddOrderCalendarPaperEnum[keyof typeof OrderControllerAddOrderCalendarPaperEnum];
/**
 * @export
 */
export const OrderControllerCashbackPaymentOptionEnum = {
    Normal: 'NORMAL',
    PaymentOnDelivery: 'PAYMENT_ON_DELIVERY'
} as const;
export type OrderControllerCashbackPaymentOptionEnum = typeof OrderControllerCashbackPaymentOptionEnum[keyof typeof OrderControllerCashbackPaymentOptionEnum];


/**
 * OrderCalendarApi - axios parameter creator
 * @export
 */
export const OrderCalendarApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Create multiple OrderCalendars
         * @param {CreateManyOrderCalendarDto} createManyOrderCalendarDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createManyBaseOrderCalendarControllerOrderCalendar: async (createManyOrderCalendarDto: CreateManyOrderCalendarDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createManyOrderCalendarDto' is not null or undefined
            assertParamExists('createManyBaseOrderCalendarControllerOrderCalendar', 'createManyOrderCalendarDto', createManyOrderCalendarDto)
            const localVarPath = `/orderCalendar/bulk`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createManyOrderCalendarDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Create a single OrderCalendar
         * @param {CreateOrderCalendarDto} createOrderCalendarDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createOneBaseOrderCalendarControllerOrderCalendar: async (createOrderCalendarDto: CreateOrderCalendarDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createOrderCalendarDto' is not null or undefined
            assertParamExists('createOneBaseOrderCalendarControllerOrderCalendar', 'createOrderCalendarDto', createOrderCalendarDto)
            const localVarPath = `/orderCalendar`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createOrderCalendarDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Delete a single OrderCalendar
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOneBaseOrderCalendarControllerOrderCalendar: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('deleteOneBaseOrderCalendarControllerOrderCalendar', 'id', id)
            const localVarPath = `/orderCalendar/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Retrieve multiple OrderCalendars
         * @param {Array<string>} [fields] Selects resource fields. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#select\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {string} [s] Adds search condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#search\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {Array<string>} [filter] Adds filter condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#filter\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {Array<string>} [or] Adds OR condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#or\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {Array<string>} [sort] Adds sort by field. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#sort\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {Array<string>} [join] Adds relational resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#join\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {number} [limit] Limit amount of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#limit\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {number} [offset] Offset amount of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#offset\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {number} [page] Page portion of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#page\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {number} [cache] Reset cache (if was enabled). &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#cache\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getManyBaseOrderCalendarControllerOrderCalendar: async (fields?: Array<string>, s?: string, filter?: Array<string>, or?: Array<string>, sort?: Array<string>, join?: Array<string>, limit?: number, offset?: number, page?: number, cache?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/orderCalendar`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (fields) {
                localVarQueryParameter['fields'] = fields;
            }

            if (s !== undefined) {
                localVarQueryParameter['s'] = s;
            }

            if (filter) {
                localVarQueryParameter['filter'] = filter;
            }

            if (or) {
                localVarQueryParameter['or'] = or;
            }

            if (sort) {
                localVarQueryParameter['sort'] = sort;
            }

            if (join) {
                localVarQueryParameter['join'] = join;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (cache !== undefined) {
                localVarQueryParameter['cache'] = cache;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Retrieve a single OrderCalendar
         * @param {string} id 
         * @param {Array<string>} [fields] Selects resource fields. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#select\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {Array<string>} [join] Adds relational resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#join\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {number} [cache] Reset cache (if was enabled). &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#cache\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOneBaseOrderCalendarControllerOrderCalendar: async (id: string, fields?: Array<string>, join?: Array<string>, cache?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getOneBaseOrderCalendarControllerOrderCalendar', 'id', id)
            const localVarPath = `/orderCalendar/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (fields) {
                localVarQueryParameter['fields'] = fields;
            }

            if (join) {
                localVarQueryParameter['join'] = join;
            }

            if (cache !== undefined) {
                localVarQueryParameter['cache'] = cache;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Download calendar PDF file
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        orderCalendarControllerDownloadPdf: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('orderCalendarControllerDownloadPdf', 'id', id)
            const localVarPath = `/orderCalendar/{id}/download-pdf`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Upload calendar PDF file
         * @param {string} id 
         * @param {File} [file] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        orderCalendarControllerUploadPdf: async (id: string, file?: File, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('orderCalendarControllerUploadPdf', 'id', id)
            const localVarPath = `/orderCalendar/{id}/upload-pdf`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


            if (file !== undefined) { 
                localVarFormParams.append('file', file as any);
            }
    
    
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Replace a single OrderCalendar
         * @param {string} id 
         * @param {UpdateOrderCalendarDto} updateOrderCalendarDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        replaceOneBaseOrderCalendarControllerOrderCalendar: async (id: string, updateOrderCalendarDto: UpdateOrderCalendarDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('replaceOneBaseOrderCalendarControllerOrderCalendar', 'id', id)
            // verify required parameter 'updateOrderCalendarDto' is not null or undefined
            assertParamExists('replaceOneBaseOrderCalendarControllerOrderCalendar', 'updateOrderCalendarDto', updateOrderCalendarDto)
            const localVarPath = `/orderCalendar/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateOrderCalendarDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update a single OrderCalendar
         * @param {string} id 
         * @param {UpdateOrderCalendarDto} updateOrderCalendarDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateOneBaseOrderCalendarControllerOrderCalendar: async (id: string, updateOrderCalendarDto: UpdateOrderCalendarDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('updateOneBaseOrderCalendarControllerOrderCalendar', 'id', id)
            // verify required parameter 'updateOrderCalendarDto' is not null or undefined
            assertParamExists('updateOneBaseOrderCalendarControllerOrderCalendar', 'updateOrderCalendarDto', updateOrderCalendarDto)
            const localVarPath = `/orderCalendar/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateOrderCalendarDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * OrderCalendarApi - functional programming interface
 * @export
 */
export const OrderCalendarApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = OrderCalendarApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Create multiple OrderCalendars
         * @param {CreateManyOrderCalendarDto} createManyOrderCalendarDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createManyBaseOrderCalendarControllerOrderCalendar(createManyOrderCalendarDto: CreateManyOrderCalendarDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<object>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createManyBaseOrderCalendarControllerOrderCalendar(createManyOrderCalendarDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Create a single OrderCalendar
         * @param {CreateOrderCalendarDto} createOrderCalendarDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createOneBaseOrderCalendarControllerOrderCalendar(createOrderCalendarDto: CreateOrderCalendarDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createOneBaseOrderCalendarControllerOrderCalendar(createOrderCalendarDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Delete a single OrderCalendar
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteOneBaseOrderCalendarControllerOrderCalendar(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteOneBaseOrderCalendarControllerOrderCalendar(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Retrieve multiple OrderCalendars
         * @param {Array<string>} [fields] Selects resource fields. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#select\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {string} [s] Adds search condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#search\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {Array<string>} [filter] Adds filter condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#filter\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {Array<string>} [or] Adds OR condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#or\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {Array<string>} [sort] Adds sort by field. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#sort\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {Array<string>} [join] Adds relational resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#join\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {number} [limit] Limit amount of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#limit\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {number} [offset] Offset amount of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#offset\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {number} [page] Page portion of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#page\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {number} [cache] Reset cache (if was enabled). &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#cache\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getManyBaseOrderCalendarControllerOrderCalendar(fields?: Array<string>, s?: string, filter?: Array<string>, or?: Array<string>, sort?: Array<string>, join?: Array<string>, limit?: number, offset?: number, page?: number, cache?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetManyOrderCalendarResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getManyBaseOrderCalendarControllerOrderCalendar(fields, s, filter, or, sort, join, limit, offset, page, cache, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Retrieve a single OrderCalendar
         * @param {string} id 
         * @param {Array<string>} [fields] Selects resource fields. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#select\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {Array<string>} [join] Adds relational resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#join\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {number} [cache] Reset cache (if was enabled). &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#cache\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getOneBaseOrderCalendarControllerOrderCalendar(id: string, fields?: Array<string>, join?: Array<string>, cache?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetOrderCalendarDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getOneBaseOrderCalendarControllerOrderCalendar(id, fields, join, cache, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Download calendar PDF file
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async orderCalendarControllerDownloadPdf(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<File>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.orderCalendarControllerDownloadPdf(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Upload calendar PDF file
         * @param {string} id 
         * @param {File} [file] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async orderCalendarControllerUploadPdf(id: string, file?: File, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.orderCalendarControllerUploadPdf(id, file, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Replace a single OrderCalendar
         * @param {string} id 
         * @param {UpdateOrderCalendarDto} updateOrderCalendarDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async replaceOneBaseOrderCalendarControllerOrderCalendar(id: string, updateOrderCalendarDto: UpdateOrderCalendarDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.replaceOneBaseOrderCalendarControllerOrderCalendar(id, updateOrderCalendarDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Update a single OrderCalendar
         * @param {string} id 
         * @param {UpdateOrderCalendarDto} updateOrderCalendarDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateOneBaseOrderCalendarControllerOrderCalendar(id: string, updateOrderCalendarDto: UpdateOrderCalendarDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateOneBaseOrderCalendarControllerOrderCalendar(id, updateOrderCalendarDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * OrderCalendarApi - factory interface
 * @export
 */
export const OrderCalendarApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = OrderCalendarApiFp(configuration)
    return {
        /**
         * 
         * @summary Create multiple OrderCalendars
         * @param {CreateManyOrderCalendarDto} createManyOrderCalendarDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createManyBaseOrderCalendarControllerOrderCalendar(createManyOrderCalendarDto: CreateManyOrderCalendarDto, options?: any): AxiosPromise<Array<object>> {
            return localVarFp.createManyBaseOrderCalendarControllerOrderCalendar(createManyOrderCalendarDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Create a single OrderCalendar
         * @param {CreateOrderCalendarDto} createOrderCalendarDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createOneBaseOrderCalendarControllerOrderCalendar(createOrderCalendarDto: CreateOrderCalendarDto, options?: any): AxiosPromise<object> {
            return localVarFp.createOneBaseOrderCalendarControllerOrderCalendar(createOrderCalendarDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Delete a single OrderCalendar
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOneBaseOrderCalendarControllerOrderCalendar(id: string, options?: any): AxiosPromise<object> {
            return localVarFp.deleteOneBaseOrderCalendarControllerOrderCalendar(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Retrieve multiple OrderCalendars
         * @param {Array<string>} [fields] Selects resource fields. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#select\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {string} [s] Adds search condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#search\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {Array<string>} [filter] Adds filter condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#filter\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {Array<string>} [or] Adds OR condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#or\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {Array<string>} [sort] Adds sort by field. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#sort\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {Array<string>} [join] Adds relational resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#join\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {number} [limit] Limit amount of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#limit\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {number} [offset] Offset amount of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#offset\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {number} [page] Page portion of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#page\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {number} [cache] Reset cache (if was enabled). &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#cache\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getManyBaseOrderCalendarControllerOrderCalendar(fields?: Array<string>, s?: string, filter?: Array<string>, or?: Array<string>, sort?: Array<string>, join?: Array<string>, limit?: number, offset?: number, page?: number, cache?: number, options?: any): AxiosPromise<GetManyOrderCalendarResponseDto> {
            return localVarFp.getManyBaseOrderCalendarControllerOrderCalendar(fields, s, filter, or, sort, join, limit, offset, page, cache, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Retrieve a single OrderCalendar
         * @param {string} id 
         * @param {Array<string>} [fields] Selects resource fields. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#select\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {Array<string>} [join] Adds relational resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#join\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {number} [cache] Reset cache (if was enabled). &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#cache\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOneBaseOrderCalendarControllerOrderCalendar(id: string, fields?: Array<string>, join?: Array<string>, cache?: number, options?: any): AxiosPromise<GetOrderCalendarDto> {
            return localVarFp.getOneBaseOrderCalendarControllerOrderCalendar(id, fields, join, cache, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Download calendar PDF file
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        orderCalendarControllerDownloadPdf(id: string, options?: any): AxiosPromise<File> {
            return localVarFp.orderCalendarControllerDownloadPdf(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Upload calendar PDF file
         * @param {string} id 
         * @param {File} [file] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        orderCalendarControllerUploadPdf(id: string, file?: File, options?: any): AxiosPromise<void> {
            return localVarFp.orderCalendarControllerUploadPdf(id, file, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Replace a single OrderCalendar
         * @param {string} id 
         * @param {UpdateOrderCalendarDto} updateOrderCalendarDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        replaceOneBaseOrderCalendarControllerOrderCalendar(id: string, updateOrderCalendarDto: UpdateOrderCalendarDto, options?: any): AxiosPromise<object> {
            return localVarFp.replaceOneBaseOrderCalendarControllerOrderCalendar(id, updateOrderCalendarDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update a single OrderCalendar
         * @param {string} id 
         * @param {UpdateOrderCalendarDto} updateOrderCalendarDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateOneBaseOrderCalendarControllerOrderCalendar(id: string, updateOrderCalendarDto: UpdateOrderCalendarDto, options?: any): AxiosPromise<object> {
            return localVarFp.updateOneBaseOrderCalendarControllerOrderCalendar(id, updateOrderCalendarDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * OrderCalendarApi - object-oriented interface
 * @export
 * @class OrderCalendarApi
 * @extends {BaseAPI}
 */
export class OrderCalendarApi extends BaseAPI {
    /**
     * 
     * @summary Create multiple OrderCalendars
     * @param {CreateManyOrderCalendarDto} createManyOrderCalendarDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrderCalendarApi
     */
    public createManyBaseOrderCalendarControllerOrderCalendar(createManyOrderCalendarDto: CreateManyOrderCalendarDto, options?: AxiosRequestConfig) {
        return OrderCalendarApiFp(this.configuration).createManyBaseOrderCalendarControllerOrderCalendar(createManyOrderCalendarDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Create a single OrderCalendar
     * @param {CreateOrderCalendarDto} createOrderCalendarDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrderCalendarApi
     */
    public createOneBaseOrderCalendarControllerOrderCalendar(createOrderCalendarDto: CreateOrderCalendarDto, options?: AxiosRequestConfig) {
        return OrderCalendarApiFp(this.configuration).createOneBaseOrderCalendarControllerOrderCalendar(createOrderCalendarDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Delete a single OrderCalendar
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrderCalendarApi
     */
    public deleteOneBaseOrderCalendarControllerOrderCalendar(id: string, options?: AxiosRequestConfig) {
        return OrderCalendarApiFp(this.configuration).deleteOneBaseOrderCalendarControllerOrderCalendar(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Retrieve multiple OrderCalendars
     * @param {Array<string>} [fields] Selects resource fields. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#select\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param {string} [s] Adds search condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#search\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param {Array<string>} [filter] Adds filter condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#filter\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param {Array<string>} [or] Adds OR condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#or\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param {Array<string>} [sort] Adds sort by field. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#sort\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param {Array<string>} [join] Adds relational resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#join\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param {number} [limit] Limit amount of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#limit\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param {number} [offset] Offset amount of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#offset\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param {number} [page] Page portion of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#page\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param {number} [cache] Reset cache (if was enabled). &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#cache\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrderCalendarApi
     */
    public getManyBaseOrderCalendarControllerOrderCalendar(fields?: Array<string>, s?: string, filter?: Array<string>, or?: Array<string>, sort?: Array<string>, join?: Array<string>, limit?: number, offset?: number, page?: number, cache?: number, options?: AxiosRequestConfig) {
        return OrderCalendarApiFp(this.configuration).getManyBaseOrderCalendarControllerOrderCalendar(fields, s, filter, or, sort, join, limit, offset, page, cache, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Retrieve a single OrderCalendar
     * @param {string} id 
     * @param {Array<string>} [fields] Selects resource fields. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#select\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param {Array<string>} [join] Adds relational resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#join\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param {number} [cache] Reset cache (if was enabled). &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#cache\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrderCalendarApi
     */
    public getOneBaseOrderCalendarControllerOrderCalendar(id: string, fields?: Array<string>, join?: Array<string>, cache?: number, options?: AxiosRequestConfig) {
        return OrderCalendarApiFp(this.configuration).getOneBaseOrderCalendarControllerOrderCalendar(id, fields, join, cache, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Download calendar PDF file
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrderCalendarApi
     */
    public orderCalendarControllerDownloadPdf(id: string, options?: AxiosRequestConfig) {
        return OrderCalendarApiFp(this.configuration).orderCalendarControllerDownloadPdf(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Upload calendar PDF file
     * @param {string} id 
     * @param {File} [file] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrderCalendarApi
     */
    public orderCalendarControllerUploadPdf(id: string, file?: File, options?: AxiosRequestConfig) {
        return OrderCalendarApiFp(this.configuration).orderCalendarControllerUploadPdf(id, file, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Replace a single OrderCalendar
     * @param {string} id 
     * @param {UpdateOrderCalendarDto} updateOrderCalendarDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrderCalendarApi
     */
    public replaceOneBaseOrderCalendarControllerOrderCalendar(id: string, updateOrderCalendarDto: UpdateOrderCalendarDto, options?: AxiosRequestConfig) {
        return OrderCalendarApiFp(this.configuration).replaceOneBaseOrderCalendarControllerOrderCalendar(id, updateOrderCalendarDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update a single OrderCalendar
     * @param {string} id 
     * @param {UpdateOrderCalendarDto} updateOrderCalendarDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrderCalendarApi
     */
    public updateOneBaseOrderCalendarControllerOrderCalendar(id: string, updateOrderCalendarDto: UpdateOrderCalendarDto, options?: AxiosRequestConfig) {
        return OrderCalendarApiFp(this.configuration).updateOneBaseOrderCalendarControllerOrderCalendar(id, updateOrderCalendarDto, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * OrderProductDetailApi - axios parameter creator
 * @export
 */
export const OrderProductDetailApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Create multiple OrderProductDetails
         * @param {CreateManyOrderProductDetailDto} createManyOrderProductDetailDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createManyBaseOrderProductDetailControllerOrderProductDetail: async (createManyOrderProductDetailDto: CreateManyOrderProductDetailDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createManyOrderProductDetailDto' is not null or undefined
            assertParamExists('createManyBaseOrderProductDetailControllerOrderProductDetail', 'createManyOrderProductDetailDto', createManyOrderProductDetailDto)
            const localVarPath = `/orderProductDetail/bulk`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createManyOrderProductDetailDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Create a single OrderProductDetail
         * @param {CreateOrderProductDetailDto} createOrderProductDetailDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createOneBaseOrderProductDetailControllerOrderProductDetail: async (createOrderProductDetailDto: CreateOrderProductDetailDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createOrderProductDetailDto' is not null or undefined
            assertParamExists('createOneBaseOrderProductDetailControllerOrderProductDetail', 'createOrderProductDetailDto', createOrderProductDetailDto)
            const localVarPath = `/orderProductDetail`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createOrderProductDetailDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Delete a single OrderProductDetail
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOneBaseOrderProductDetailControllerOrderProductDetail: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('deleteOneBaseOrderProductDetailControllerOrderProductDetail', 'id', id)
            const localVarPath = `/orderProductDetail/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Retrieve multiple OrderProductDetails
         * @param {Array<string>} [fields] Selects resource fields. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#select\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {string} [s] Adds search condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#search\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {Array<string>} [filter] Adds filter condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#filter\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {Array<string>} [or] Adds OR condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#or\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {Array<string>} [sort] Adds sort by field. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#sort\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {Array<string>} [join] Adds relational resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#join\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {number} [limit] Limit amount of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#limit\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {number} [offset] Offset amount of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#offset\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {number} [page] Page portion of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#page\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {number} [cache] Reset cache (if was enabled). &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#cache\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getManyBaseOrderProductDetailControllerOrderProductDetail: async (fields?: Array<string>, s?: string, filter?: Array<string>, or?: Array<string>, sort?: Array<string>, join?: Array<string>, limit?: number, offset?: number, page?: number, cache?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/orderProductDetail`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (fields) {
                localVarQueryParameter['fields'] = fields;
            }

            if (s !== undefined) {
                localVarQueryParameter['s'] = s;
            }

            if (filter) {
                localVarQueryParameter['filter'] = filter;
            }

            if (or) {
                localVarQueryParameter['or'] = or;
            }

            if (sort) {
                localVarQueryParameter['sort'] = sort;
            }

            if (join) {
                localVarQueryParameter['join'] = join;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (cache !== undefined) {
                localVarQueryParameter['cache'] = cache;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Retrieve a single OrderProductDetail
         * @param {string} id 
         * @param {Array<string>} [fields] Selects resource fields. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#select\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {Array<string>} [join] Adds relational resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#join\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {number} [cache] Reset cache (if was enabled). &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#cache\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOneBaseOrderProductDetailControllerOrderProductDetail: async (id: string, fields?: Array<string>, join?: Array<string>, cache?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getOneBaseOrderProductDetailControllerOrderProductDetail', 'id', id)
            const localVarPath = `/orderProductDetail/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (fields) {
                localVarQueryParameter['fields'] = fields;
            }

            if (join) {
                localVarQueryParameter['join'] = join;
            }

            if (cache !== undefined) {
                localVarQueryParameter['cache'] = cache;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Replace a single OrderProductDetail
         * @param {string} id 
         * @param {UpdateOrderProductDetailDto} updateOrderProductDetailDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        replaceOneBaseOrderProductDetailControllerOrderProductDetail: async (id: string, updateOrderProductDetailDto: UpdateOrderProductDetailDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('replaceOneBaseOrderProductDetailControllerOrderProductDetail', 'id', id)
            // verify required parameter 'updateOrderProductDetailDto' is not null or undefined
            assertParamExists('replaceOneBaseOrderProductDetailControllerOrderProductDetail', 'updateOrderProductDetailDto', updateOrderProductDetailDto)
            const localVarPath = `/orderProductDetail/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateOrderProductDetailDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update a single OrderProductDetail
         * @param {string} id 
         * @param {UpdateOrderProductDetailDto} updateOrderProductDetailDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateOneBaseOrderProductDetailControllerOrderProductDetail: async (id: string, updateOrderProductDetailDto: UpdateOrderProductDetailDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('updateOneBaseOrderProductDetailControllerOrderProductDetail', 'id', id)
            // verify required parameter 'updateOrderProductDetailDto' is not null or undefined
            assertParamExists('updateOneBaseOrderProductDetailControllerOrderProductDetail', 'updateOrderProductDetailDto', updateOrderProductDetailDto)
            const localVarPath = `/orderProductDetail/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateOrderProductDetailDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * OrderProductDetailApi - functional programming interface
 * @export
 */
export const OrderProductDetailApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = OrderProductDetailApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Create multiple OrderProductDetails
         * @param {CreateManyOrderProductDetailDto} createManyOrderProductDetailDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createManyBaseOrderProductDetailControllerOrderProductDetail(createManyOrderProductDetailDto: CreateManyOrderProductDetailDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<object>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createManyBaseOrderProductDetailControllerOrderProductDetail(createManyOrderProductDetailDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Create a single OrderProductDetail
         * @param {CreateOrderProductDetailDto} createOrderProductDetailDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createOneBaseOrderProductDetailControllerOrderProductDetail(createOrderProductDetailDto: CreateOrderProductDetailDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createOneBaseOrderProductDetailControllerOrderProductDetail(createOrderProductDetailDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Delete a single OrderProductDetail
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteOneBaseOrderProductDetailControllerOrderProductDetail(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteOneBaseOrderProductDetailControllerOrderProductDetail(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Retrieve multiple OrderProductDetails
         * @param {Array<string>} [fields] Selects resource fields. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#select\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {string} [s] Adds search condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#search\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {Array<string>} [filter] Adds filter condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#filter\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {Array<string>} [or] Adds OR condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#or\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {Array<string>} [sort] Adds sort by field. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#sort\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {Array<string>} [join] Adds relational resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#join\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {number} [limit] Limit amount of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#limit\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {number} [offset] Offset amount of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#offset\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {number} [page] Page portion of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#page\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {number} [cache] Reset cache (if was enabled). &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#cache\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getManyBaseOrderProductDetailControllerOrderProductDetail(fields?: Array<string>, s?: string, filter?: Array<string>, or?: Array<string>, sort?: Array<string>, join?: Array<string>, limit?: number, offset?: number, page?: number, cache?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetManyOrderProductDetailResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getManyBaseOrderProductDetailControllerOrderProductDetail(fields, s, filter, or, sort, join, limit, offset, page, cache, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Retrieve a single OrderProductDetail
         * @param {string} id 
         * @param {Array<string>} [fields] Selects resource fields. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#select\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {Array<string>} [join] Adds relational resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#join\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {number} [cache] Reset cache (if was enabled). &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#cache\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getOneBaseOrderProductDetailControllerOrderProductDetail(id: string, fields?: Array<string>, join?: Array<string>, cache?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetOrderProductDetailDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getOneBaseOrderProductDetailControllerOrderProductDetail(id, fields, join, cache, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Replace a single OrderProductDetail
         * @param {string} id 
         * @param {UpdateOrderProductDetailDto} updateOrderProductDetailDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async replaceOneBaseOrderProductDetailControllerOrderProductDetail(id: string, updateOrderProductDetailDto: UpdateOrderProductDetailDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.replaceOneBaseOrderProductDetailControllerOrderProductDetail(id, updateOrderProductDetailDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Update a single OrderProductDetail
         * @param {string} id 
         * @param {UpdateOrderProductDetailDto} updateOrderProductDetailDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateOneBaseOrderProductDetailControllerOrderProductDetail(id: string, updateOrderProductDetailDto: UpdateOrderProductDetailDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateOneBaseOrderProductDetailControllerOrderProductDetail(id, updateOrderProductDetailDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * OrderProductDetailApi - factory interface
 * @export
 */
export const OrderProductDetailApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = OrderProductDetailApiFp(configuration)
    return {
        /**
         * 
         * @summary Create multiple OrderProductDetails
         * @param {CreateManyOrderProductDetailDto} createManyOrderProductDetailDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createManyBaseOrderProductDetailControllerOrderProductDetail(createManyOrderProductDetailDto: CreateManyOrderProductDetailDto, options?: any): AxiosPromise<Array<object>> {
            return localVarFp.createManyBaseOrderProductDetailControllerOrderProductDetail(createManyOrderProductDetailDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Create a single OrderProductDetail
         * @param {CreateOrderProductDetailDto} createOrderProductDetailDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createOneBaseOrderProductDetailControllerOrderProductDetail(createOrderProductDetailDto: CreateOrderProductDetailDto, options?: any): AxiosPromise<object> {
            return localVarFp.createOneBaseOrderProductDetailControllerOrderProductDetail(createOrderProductDetailDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Delete a single OrderProductDetail
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOneBaseOrderProductDetailControllerOrderProductDetail(id: string, options?: any): AxiosPromise<object> {
            return localVarFp.deleteOneBaseOrderProductDetailControllerOrderProductDetail(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Retrieve multiple OrderProductDetails
         * @param {Array<string>} [fields] Selects resource fields. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#select\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {string} [s] Adds search condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#search\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {Array<string>} [filter] Adds filter condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#filter\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {Array<string>} [or] Adds OR condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#or\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {Array<string>} [sort] Adds sort by field. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#sort\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {Array<string>} [join] Adds relational resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#join\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {number} [limit] Limit amount of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#limit\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {number} [offset] Offset amount of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#offset\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {number} [page] Page portion of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#page\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {number} [cache] Reset cache (if was enabled). &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#cache\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getManyBaseOrderProductDetailControllerOrderProductDetail(fields?: Array<string>, s?: string, filter?: Array<string>, or?: Array<string>, sort?: Array<string>, join?: Array<string>, limit?: number, offset?: number, page?: number, cache?: number, options?: any): AxiosPromise<GetManyOrderProductDetailResponseDto> {
            return localVarFp.getManyBaseOrderProductDetailControllerOrderProductDetail(fields, s, filter, or, sort, join, limit, offset, page, cache, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Retrieve a single OrderProductDetail
         * @param {string} id 
         * @param {Array<string>} [fields] Selects resource fields. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#select\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {Array<string>} [join] Adds relational resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#join\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {number} [cache] Reset cache (if was enabled). &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#cache\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOneBaseOrderProductDetailControllerOrderProductDetail(id: string, fields?: Array<string>, join?: Array<string>, cache?: number, options?: any): AxiosPromise<GetOrderProductDetailDto> {
            return localVarFp.getOneBaseOrderProductDetailControllerOrderProductDetail(id, fields, join, cache, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Replace a single OrderProductDetail
         * @param {string} id 
         * @param {UpdateOrderProductDetailDto} updateOrderProductDetailDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        replaceOneBaseOrderProductDetailControllerOrderProductDetail(id: string, updateOrderProductDetailDto: UpdateOrderProductDetailDto, options?: any): AxiosPromise<object> {
            return localVarFp.replaceOneBaseOrderProductDetailControllerOrderProductDetail(id, updateOrderProductDetailDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update a single OrderProductDetail
         * @param {string} id 
         * @param {UpdateOrderProductDetailDto} updateOrderProductDetailDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateOneBaseOrderProductDetailControllerOrderProductDetail(id: string, updateOrderProductDetailDto: UpdateOrderProductDetailDto, options?: any): AxiosPromise<object> {
            return localVarFp.updateOneBaseOrderProductDetailControllerOrderProductDetail(id, updateOrderProductDetailDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * OrderProductDetailApi - object-oriented interface
 * @export
 * @class OrderProductDetailApi
 * @extends {BaseAPI}
 */
export class OrderProductDetailApi extends BaseAPI {
    /**
     * 
     * @summary Create multiple OrderProductDetails
     * @param {CreateManyOrderProductDetailDto} createManyOrderProductDetailDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrderProductDetailApi
     */
    public createManyBaseOrderProductDetailControllerOrderProductDetail(createManyOrderProductDetailDto: CreateManyOrderProductDetailDto, options?: AxiosRequestConfig) {
        return OrderProductDetailApiFp(this.configuration).createManyBaseOrderProductDetailControllerOrderProductDetail(createManyOrderProductDetailDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Create a single OrderProductDetail
     * @param {CreateOrderProductDetailDto} createOrderProductDetailDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrderProductDetailApi
     */
    public createOneBaseOrderProductDetailControllerOrderProductDetail(createOrderProductDetailDto: CreateOrderProductDetailDto, options?: AxiosRequestConfig) {
        return OrderProductDetailApiFp(this.configuration).createOneBaseOrderProductDetailControllerOrderProductDetail(createOrderProductDetailDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Delete a single OrderProductDetail
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrderProductDetailApi
     */
    public deleteOneBaseOrderProductDetailControllerOrderProductDetail(id: string, options?: AxiosRequestConfig) {
        return OrderProductDetailApiFp(this.configuration).deleteOneBaseOrderProductDetailControllerOrderProductDetail(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Retrieve multiple OrderProductDetails
     * @param {Array<string>} [fields] Selects resource fields. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#select\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param {string} [s] Adds search condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#search\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param {Array<string>} [filter] Adds filter condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#filter\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param {Array<string>} [or] Adds OR condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#or\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param {Array<string>} [sort] Adds sort by field. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#sort\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param {Array<string>} [join] Adds relational resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#join\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param {number} [limit] Limit amount of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#limit\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param {number} [offset] Offset amount of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#offset\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param {number} [page] Page portion of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#page\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param {number} [cache] Reset cache (if was enabled). &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#cache\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrderProductDetailApi
     */
    public getManyBaseOrderProductDetailControllerOrderProductDetail(fields?: Array<string>, s?: string, filter?: Array<string>, or?: Array<string>, sort?: Array<string>, join?: Array<string>, limit?: number, offset?: number, page?: number, cache?: number, options?: AxiosRequestConfig) {
        return OrderProductDetailApiFp(this.configuration).getManyBaseOrderProductDetailControllerOrderProductDetail(fields, s, filter, or, sort, join, limit, offset, page, cache, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Retrieve a single OrderProductDetail
     * @param {string} id 
     * @param {Array<string>} [fields] Selects resource fields. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#select\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param {Array<string>} [join] Adds relational resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#join\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param {number} [cache] Reset cache (if was enabled). &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#cache\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrderProductDetailApi
     */
    public getOneBaseOrderProductDetailControllerOrderProductDetail(id: string, fields?: Array<string>, join?: Array<string>, cache?: number, options?: AxiosRequestConfig) {
        return OrderProductDetailApiFp(this.configuration).getOneBaseOrderProductDetailControllerOrderProductDetail(id, fields, join, cache, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Replace a single OrderProductDetail
     * @param {string} id 
     * @param {UpdateOrderProductDetailDto} updateOrderProductDetailDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrderProductDetailApi
     */
    public replaceOneBaseOrderProductDetailControllerOrderProductDetail(id: string, updateOrderProductDetailDto: UpdateOrderProductDetailDto, options?: AxiosRequestConfig) {
        return OrderProductDetailApiFp(this.configuration).replaceOneBaseOrderProductDetailControllerOrderProductDetail(id, updateOrderProductDetailDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update a single OrderProductDetail
     * @param {string} id 
     * @param {UpdateOrderProductDetailDto} updateOrderProductDetailDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrderProductDetailApi
     */
    public updateOneBaseOrderProductDetailControllerOrderProductDetail(id: string, updateOrderProductDetailDto: UpdateOrderProductDetailDto, options?: AxiosRequestConfig) {
        return OrderProductDetailApiFp(this.configuration).updateOneBaseOrderProductDetailControllerOrderProductDetail(id, updateOrderProductDetailDto, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * PaperApi - axios parameter creator
 * @export
 */
export const PaperApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Create multiple Papers
         * @param {CreateManyPaperDto} createManyPaperDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createManyBasePaperControllerPaper: async (createManyPaperDto: CreateManyPaperDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createManyPaperDto' is not null or undefined
            assertParamExists('createManyBasePaperControllerPaper', 'createManyPaperDto', createManyPaperDto)
            const localVarPath = `/paper/bulk`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createManyPaperDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Create a single Paper
         * @param {CreatePaperDto} createPaperDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createOneBasePaperControllerPaper: async (createPaperDto: CreatePaperDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createPaperDto' is not null or undefined
            assertParamExists('createOneBasePaperControllerPaper', 'createPaperDto', createPaperDto)
            const localVarPath = `/paper`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createPaperDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Delete a single Paper
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOneBasePaperControllerPaper: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('deleteOneBasePaperControllerPaper', 'id', id)
            const localVarPath = `/paper/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Retrieve multiple Papers
         * @param {Array<string>} [fields] Selects resource fields. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#select\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {string} [s] Adds search condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#search\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {Array<string>} [filter] Adds filter condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#filter\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {Array<string>} [or] Adds OR condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#or\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {Array<string>} [sort] Adds sort by field. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#sort\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {Array<string>} [join] Adds relational resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#join\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {number} [limit] Limit amount of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#limit\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {number} [offset] Offset amount of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#offset\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {number} [page] Page portion of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#page\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {number} [cache] Reset cache (if was enabled). &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#cache\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getManyBasePaperControllerPaper: async (fields?: Array<string>, s?: string, filter?: Array<string>, or?: Array<string>, sort?: Array<string>, join?: Array<string>, limit?: number, offset?: number, page?: number, cache?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/paper`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (fields) {
                localVarQueryParameter['fields'] = fields;
            }

            if (s !== undefined) {
                localVarQueryParameter['s'] = s;
            }

            if (filter) {
                localVarQueryParameter['filter'] = filter;
            }

            if (or) {
                localVarQueryParameter['or'] = or;
            }

            if (sort) {
                localVarQueryParameter['sort'] = sort;
            }

            if (join) {
                localVarQueryParameter['join'] = join;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (cache !== undefined) {
                localVarQueryParameter['cache'] = cache;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Retrieve a single Paper
         * @param {string} id 
         * @param {Array<string>} [fields] Selects resource fields. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#select\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {Array<string>} [join] Adds relational resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#join\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {number} [cache] Reset cache (if was enabled). &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#cache\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOneBasePaperControllerPaper: async (id: string, fields?: Array<string>, join?: Array<string>, cache?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getOneBasePaperControllerPaper', 'id', id)
            const localVarPath = `/paper/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (fields) {
                localVarQueryParameter['fields'] = fields;
            }

            if (join) {
                localVarQueryParameter['join'] = join;
            }

            if (cache !== undefined) {
                localVarQueryParameter['cache'] = cache;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Replace a single Paper
         * @param {string} id 
         * @param {UpdatePaperDto} updatePaperDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        replaceOneBasePaperControllerPaper: async (id: string, updatePaperDto: UpdatePaperDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('replaceOneBasePaperControllerPaper', 'id', id)
            // verify required parameter 'updatePaperDto' is not null or undefined
            assertParamExists('replaceOneBasePaperControllerPaper', 'updatePaperDto', updatePaperDto)
            const localVarPath = `/paper/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updatePaperDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update a single Paper
         * @param {string} id 
         * @param {UpdatePaperDto} updatePaperDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateOneBasePaperControllerPaper: async (id: string, updatePaperDto: UpdatePaperDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('updateOneBasePaperControllerPaper', 'id', id)
            // verify required parameter 'updatePaperDto' is not null or undefined
            assertParamExists('updateOneBasePaperControllerPaper', 'updatePaperDto', updatePaperDto)
            const localVarPath = `/paper/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updatePaperDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * PaperApi - functional programming interface
 * @export
 */
export const PaperApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = PaperApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Create multiple Papers
         * @param {CreateManyPaperDto} createManyPaperDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createManyBasePaperControllerPaper(createManyPaperDto: CreateManyPaperDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<object>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createManyBasePaperControllerPaper(createManyPaperDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Create a single Paper
         * @param {CreatePaperDto} createPaperDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createOneBasePaperControllerPaper(createPaperDto: CreatePaperDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createOneBasePaperControllerPaper(createPaperDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Delete a single Paper
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteOneBasePaperControllerPaper(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteOneBasePaperControllerPaper(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Retrieve multiple Papers
         * @param {Array<string>} [fields] Selects resource fields. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#select\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {string} [s] Adds search condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#search\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {Array<string>} [filter] Adds filter condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#filter\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {Array<string>} [or] Adds OR condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#or\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {Array<string>} [sort] Adds sort by field. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#sort\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {Array<string>} [join] Adds relational resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#join\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {number} [limit] Limit amount of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#limit\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {number} [offset] Offset amount of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#offset\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {number} [page] Page portion of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#page\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {number} [cache] Reset cache (if was enabled). &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#cache\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getManyBasePaperControllerPaper(fields?: Array<string>, s?: string, filter?: Array<string>, or?: Array<string>, sort?: Array<string>, join?: Array<string>, limit?: number, offset?: number, page?: number, cache?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetManyPaperResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getManyBasePaperControllerPaper(fields, s, filter, or, sort, join, limit, offset, page, cache, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Retrieve a single Paper
         * @param {string} id 
         * @param {Array<string>} [fields] Selects resource fields. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#select\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {Array<string>} [join] Adds relational resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#join\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {number} [cache] Reset cache (if was enabled). &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#cache\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getOneBasePaperControllerPaper(id: string, fields?: Array<string>, join?: Array<string>, cache?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getOneBasePaperControllerPaper(id, fields, join, cache, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Replace a single Paper
         * @param {string} id 
         * @param {UpdatePaperDto} updatePaperDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async replaceOneBasePaperControllerPaper(id: string, updatePaperDto: UpdatePaperDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.replaceOneBasePaperControllerPaper(id, updatePaperDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Update a single Paper
         * @param {string} id 
         * @param {UpdatePaperDto} updatePaperDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateOneBasePaperControllerPaper(id: string, updatePaperDto: UpdatePaperDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateOneBasePaperControllerPaper(id, updatePaperDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * PaperApi - factory interface
 * @export
 */
export const PaperApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = PaperApiFp(configuration)
    return {
        /**
         * 
         * @summary Create multiple Papers
         * @param {CreateManyPaperDto} createManyPaperDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createManyBasePaperControllerPaper(createManyPaperDto: CreateManyPaperDto, options?: any): AxiosPromise<Array<object>> {
            return localVarFp.createManyBasePaperControllerPaper(createManyPaperDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Create a single Paper
         * @param {CreatePaperDto} createPaperDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createOneBasePaperControllerPaper(createPaperDto: CreatePaperDto, options?: any): AxiosPromise<object> {
            return localVarFp.createOneBasePaperControllerPaper(createPaperDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Delete a single Paper
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOneBasePaperControllerPaper(id: string, options?: any): AxiosPromise<object> {
            return localVarFp.deleteOneBasePaperControllerPaper(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Retrieve multiple Papers
         * @param {Array<string>} [fields] Selects resource fields. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#select\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {string} [s] Adds search condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#search\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {Array<string>} [filter] Adds filter condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#filter\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {Array<string>} [or] Adds OR condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#or\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {Array<string>} [sort] Adds sort by field. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#sort\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {Array<string>} [join] Adds relational resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#join\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {number} [limit] Limit amount of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#limit\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {number} [offset] Offset amount of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#offset\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {number} [page] Page portion of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#page\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {number} [cache] Reset cache (if was enabled). &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#cache\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getManyBasePaperControllerPaper(fields?: Array<string>, s?: string, filter?: Array<string>, or?: Array<string>, sort?: Array<string>, join?: Array<string>, limit?: number, offset?: number, page?: number, cache?: number, options?: any): AxiosPromise<GetManyPaperResponseDto> {
            return localVarFp.getManyBasePaperControllerPaper(fields, s, filter, or, sort, join, limit, offset, page, cache, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Retrieve a single Paper
         * @param {string} id 
         * @param {Array<string>} [fields] Selects resource fields. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#select\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {Array<string>} [join] Adds relational resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#join\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {number} [cache] Reset cache (if was enabled). &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#cache\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOneBasePaperControllerPaper(id: string, fields?: Array<string>, join?: Array<string>, cache?: number, options?: any): AxiosPromise<object> {
            return localVarFp.getOneBasePaperControllerPaper(id, fields, join, cache, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Replace a single Paper
         * @param {string} id 
         * @param {UpdatePaperDto} updatePaperDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        replaceOneBasePaperControllerPaper(id: string, updatePaperDto: UpdatePaperDto, options?: any): AxiosPromise<object> {
            return localVarFp.replaceOneBasePaperControllerPaper(id, updatePaperDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update a single Paper
         * @param {string} id 
         * @param {UpdatePaperDto} updatePaperDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateOneBasePaperControllerPaper(id: string, updatePaperDto: UpdatePaperDto, options?: any): AxiosPromise<object> {
            return localVarFp.updateOneBasePaperControllerPaper(id, updatePaperDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * PaperApi - object-oriented interface
 * @export
 * @class PaperApi
 * @extends {BaseAPI}
 */
export class PaperApi extends BaseAPI {
    /**
     * 
     * @summary Create multiple Papers
     * @param {CreateManyPaperDto} createManyPaperDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PaperApi
     */
    public createManyBasePaperControllerPaper(createManyPaperDto: CreateManyPaperDto, options?: AxiosRequestConfig) {
        return PaperApiFp(this.configuration).createManyBasePaperControllerPaper(createManyPaperDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Create a single Paper
     * @param {CreatePaperDto} createPaperDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PaperApi
     */
    public createOneBasePaperControllerPaper(createPaperDto: CreatePaperDto, options?: AxiosRequestConfig) {
        return PaperApiFp(this.configuration).createOneBasePaperControllerPaper(createPaperDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Delete a single Paper
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PaperApi
     */
    public deleteOneBasePaperControllerPaper(id: string, options?: AxiosRequestConfig) {
        return PaperApiFp(this.configuration).deleteOneBasePaperControllerPaper(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Retrieve multiple Papers
     * @param {Array<string>} [fields] Selects resource fields. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#select\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param {string} [s] Adds search condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#search\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param {Array<string>} [filter] Adds filter condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#filter\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param {Array<string>} [or] Adds OR condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#or\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param {Array<string>} [sort] Adds sort by field. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#sort\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param {Array<string>} [join] Adds relational resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#join\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param {number} [limit] Limit amount of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#limit\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param {number} [offset] Offset amount of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#offset\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param {number} [page] Page portion of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#page\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param {number} [cache] Reset cache (if was enabled). &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#cache\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PaperApi
     */
    public getManyBasePaperControllerPaper(fields?: Array<string>, s?: string, filter?: Array<string>, or?: Array<string>, sort?: Array<string>, join?: Array<string>, limit?: number, offset?: number, page?: number, cache?: number, options?: AxiosRequestConfig) {
        return PaperApiFp(this.configuration).getManyBasePaperControllerPaper(fields, s, filter, or, sort, join, limit, offset, page, cache, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Retrieve a single Paper
     * @param {string} id 
     * @param {Array<string>} [fields] Selects resource fields. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#select\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param {Array<string>} [join] Adds relational resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#join\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param {number} [cache] Reset cache (if was enabled). &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#cache\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PaperApi
     */
    public getOneBasePaperControllerPaper(id: string, fields?: Array<string>, join?: Array<string>, cache?: number, options?: AxiosRequestConfig) {
        return PaperApiFp(this.configuration).getOneBasePaperControllerPaper(id, fields, join, cache, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Replace a single Paper
     * @param {string} id 
     * @param {UpdatePaperDto} updatePaperDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PaperApi
     */
    public replaceOneBasePaperControllerPaper(id: string, updatePaperDto: UpdatePaperDto, options?: AxiosRequestConfig) {
        return PaperApiFp(this.configuration).replaceOneBasePaperControllerPaper(id, updatePaperDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update a single Paper
     * @param {string} id 
     * @param {UpdatePaperDto} updatePaperDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PaperApi
     */
    public updateOneBasePaperControllerPaper(id: string, updatePaperDto: UpdatePaperDto, options?: AxiosRequestConfig) {
        return PaperApiFp(this.configuration).updateOneBasePaperControllerPaper(id, updatePaperDto, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * PartyApi - axios parameter creator
 * @export
 */
export const PartyApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Confirm an upload; the server checks and previews it
         * @param {string} code 
         * @param {string} photoId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        partyGuestControllerComplete: async (code: string, photoId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'code' is not null or undefined
            assertParamExists('partyGuestControllerComplete', 'code', code)
            // verify required parameter 'photoId' is not null or undefined
            assertParamExists('partyGuestControllerComplete', 'photoId', photoId)
            const localVarPath = `/party/{code}/photos/{photoId}/complete`
                .replace(`{${"code"}}`, encodeURIComponent(String(code)))
                .replace(`{${"photoId"}}`, encodeURIComponent(String(photoId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary The shared album: guest photos after the reveal, professional photos once published
         * @param {string} code 
         * @param {PartyGuestControllerGetAlbumSectionEnum} [section] 
         * @param {string} [cursor] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        partyGuestControllerGetAlbum: async (code: string, section?: PartyGuestControllerGetAlbumSectionEnum, cursor?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'code' is not null or undefined
            assertParamExists('partyGuestControllerGetAlbum', 'code', code)
            const localVarPath = `/party/{code}/album`
                .replace(`{${"code"}}`, encodeURIComponent(String(code)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (section !== undefined) {
                localVarQueryParameter['section'] = section;
            }

            if (cursor !== undefined) {
                localVarQueryParameter['cursor'] = cursor;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Join a party as a guest (web callers get a party token)
         * @param {string} code 
         * @param {JoinPartyDto} joinPartyDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        partyGuestControllerJoin: async (code: string, joinPartyDto: JoinPartyDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'code' is not null or undefined
            assertParamExists('partyGuestControllerJoin', 'code', code)
            // verify required parameter 'joinPartyDto' is not null or undefined
            assertParamExists('partyGuestControllerJoin', 'joinPartyDto', joinPartyDto)
            const localVarPath = `/party/{code}/join`
                .replace(`{${"code"}}`, encodeURIComponent(String(code)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(joinPartyDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Parties the logged-in user has joined
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        partyGuestControllerJoined: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/party/joined`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Like a photo
         * @param {string} code 
         * @param {string} photoId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        partyGuestControllerLike: async (code: string, photoId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'code' is not null or undefined
            assertParamExists('partyGuestControllerLike', 'code', code)
            // verify required parameter 'photoId' is not null or undefined
            assertParamExists('partyGuestControllerLike', 'photoId', photoId)
            const localVarPath = `/party/{code}/photos/{photoId}/like`
                .replace(`{${"code"}}`, encodeURIComponent(String(code)))
                .replace(`{${"photoId"}}`, encodeURIComponent(String(photoId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Leave an email to hear when the photographer\'s photos are published
         * @param {string} code 
         * @param {NotifyPartyDto} notifyPartyDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        partyGuestControllerNotify: async (code: string, notifyPartyDto: NotifyPartyDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'code' is not null or undefined
            assertParamExists('partyGuestControllerNotify', 'code', code)
            // verify required parameter 'notifyPartyDto' is not null or undefined
            assertParamExists('partyGuestControllerNotify', 'notifyPartyDto', notifyPartyDto)
            const localVarPath = `/party/{code}/notify`
                .replace(`{${"code"}}`, encodeURIComponent(String(code)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(notifyPartyDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Delete one of your own photos
         * @param {string} code 
         * @param {string} photoId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        partyGuestControllerRemove: async (code: string, photoId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'code' is not null or undefined
            assertParamExists('partyGuestControllerRemove', 'code', code)
            // verify required parameter 'photoId' is not null or undefined
            assertParamExists('partyGuestControllerRemove', 'photoId', photoId)
            const localVarPath = `/party/{code}/photos/{photoId}`
                .replace(`{${"code"}}`, encodeURIComponent(String(code)))
                .replace(`{${"photoId"}}`, encodeURIComponent(String(photoId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Report a photo to the host
         * @param {string} code 
         * @param {string} photoId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        partyGuestControllerReport: async (code: string, photoId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'code' is not null or undefined
            assertParamExists('partyGuestControllerReport', 'code', code)
            // verify required parameter 'photoId' is not null or undefined
            assertParamExists('partyGuestControllerReport', 'photoId', photoId)
            const localVarPath = `/party/{code}/photos/{photoId}/report`
                .replace(`{${"code"}}`, encodeURIComponent(String(code)))
                .replace(`{${"photoId"}}`, encodeURIComponent(String(photoId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Claim a shot and get a presigned upload URL
         * @param {string} code 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        partyGuestControllerSlot: async (code: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'code' is not null or undefined
            assertParamExists('partyGuestControllerSlot', 'code', code)
            const localVarPath = `/party/{code}/photos`
                .replace(`{${"code"}}`, encodeURIComponent(String(code)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Public party summary for the join page
         * @param {string} code 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        partyGuestControllerSummary: async (code: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'code' is not null or undefined
            assertParamExists('partyGuestControllerSummary', 'code', code)
            const localVarPath = `/party/{code}`
                .replace(`{${"code"}}`, encodeURIComponent(String(code)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Remove your like
         * @param {string} code 
         * @param {string} photoId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        partyGuestControllerUnlike: async (code: string, photoId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'code' is not null or undefined
            assertParamExists('partyGuestControllerUnlike', 'code', code)
            // verify required parameter 'photoId' is not null or undefined
            assertParamExists('partyGuestControllerUnlike', 'photoId', photoId)
            const localVarPath = `/party/{code}/photos/{photoId}/like`
                .replace(`{${"code"}}`, encodeURIComponent(String(code)))
                .replace(`{${"photoId"}}`, encodeURIComponent(String(photoId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get a nameless guest identity (to like, select and order) without joining
         * @param {string} code 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        partyGuestControllerVisit: async (code: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'code' is not null or undefined
            assertParamExists('partyGuestControllerVisit', 'code', code)
            const localVarPath = `/party/{code}/visit`
                .replace(`{${"code"}}`, encodeURIComponent(String(code)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * PartyApi - functional programming interface
 * @export
 */
export const PartyApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = PartyApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Confirm an upload; the server checks and previews it
         * @param {string} code 
         * @param {string} photoId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async partyGuestControllerComplete(code: string, photoId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.partyGuestControllerComplete(code, photoId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary The shared album: guest photos after the reveal, professional photos once published
         * @param {string} code 
         * @param {PartyGuestControllerGetAlbumSectionEnum} [section] 
         * @param {string} [cursor] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async partyGuestControllerGetAlbum(code: string, section?: PartyGuestControllerGetAlbumSectionEnum, cursor?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.partyGuestControllerGetAlbum(code, section, cursor, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Join a party as a guest (web callers get a party token)
         * @param {string} code 
         * @param {JoinPartyDto} joinPartyDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async partyGuestControllerJoin(code: string, joinPartyDto: JoinPartyDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.partyGuestControllerJoin(code, joinPartyDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Parties the logged-in user has joined
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async partyGuestControllerJoined(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.partyGuestControllerJoined(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Like a photo
         * @param {string} code 
         * @param {string} photoId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async partyGuestControllerLike(code: string, photoId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.partyGuestControllerLike(code, photoId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Leave an email to hear when the photographer\'s photos are published
         * @param {string} code 
         * @param {NotifyPartyDto} notifyPartyDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async partyGuestControllerNotify(code: string, notifyPartyDto: NotifyPartyDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.partyGuestControllerNotify(code, notifyPartyDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Delete one of your own photos
         * @param {string} code 
         * @param {string} photoId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async partyGuestControllerRemove(code: string, photoId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.partyGuestControllerRemove(code, photoId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Report a photo to the host
         * @param {string} code 
         * @param {string} photoId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async partyGuestControllerReport(code: string, photoId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.partyGuestControllerReport(code, photoId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Claim a shot and get a presigned upload URL
         * @param {string} code 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async partyGuestControllerSlot(code: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.partyGuestControllerSlot(code, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Public party summary for the join page
         * @param {string} code 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async partyGuestControllerSummary(code: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.partyGuestControllerSummary(code, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Remove your like
         * @param {string} code 
         * @param {string} photoId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async partyGuestControllerUnlike(code: string, photoId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.partyGuestControllerUnlike(code, photoId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get a nameless guest identity (to like, select and order) without joining
         * @param {string} code 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async partyGuestControllerVisit(code: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.partyGuestControllerVisit(code, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * PartyApi - factory interface
 * @export
 */
export const PartyApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = PartyApiFp(configuration)
    return {
        /**
         * 
         * @summary Confirm an upload; the server checks and previews it
         * @param {string} code 
         * @param {string} photoId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        partyGuestControllerComplete(code: string, photoId: string, options?: any): AxiosPromise<void> {
            return localVarFp.partyGuestControllerComplete(code, photoId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary The shared album: guest photos after the reveal, professional photos once published
         * @param {string} code 
         * @param {PartyGuestControllerGetAlbumSectionEnum} [section] 
         * @param {string} [cursor] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        partyGuestControllerGetAlbum(code: string, section?: PartyGuestControllerGetAlbumSectionEnum, cursor?: string, options?: any): AxiosPromise<void> {
            return localVarFp.partyGuestControllerGetAlbum(code, section, cursor, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Join a party as a guest (web callers get a party token)
         * @param {string} code 
         * @param {JoinPartyDto} joinPartyDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        partyGuestControllerJoin(code: string, joinPartyDto: JoinPartyDto, options?: any): AxiosPromise<void> {
            return localVarFp.partyGuestControllerJoin(code, joinPartyDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Parties the logged-in user has joined
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        partyGuestControllerJoined(options?: any): AxiosPromise<void> {
            return localVarFp.partyGuestControllerJoined(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Like a photo
         * @param {string} code 
         * @param {string} photoId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        partyGuestControllerLike(code: string, photoId: string, options?: any): AxiosPromise<void> {
            return localVarFp.partyGuestControllerLike(code, photoId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Leave an email to hear when the photographer\'s photos are published
         * @param {string} code 
         * @param {NotifyPartyDto} notifyPartyDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        partyGuestControllerNotify(code: string, notifyPartyDto: NotifyPartyDto, options?: any): AxiosPromise<void> {
            return localVarFp.partyGuestControllerNotify(code, notifyPartyDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Delete one of your own photos
         * @param {string} code 
         * @param {string} photoId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        partyGuestControllerRemove(code: string, photoId: string, options?: any): AxiosPromise<void> {
            return localVarFp.partyGuestControllerRemove(code, photoId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Report a photo to the host
         * @param {string} code 
         * @param {string} photoId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        partyGuestControllerReport(code: string, photoId: string, options?: any): AxiosPromise<void> {
            return localVarFp.partyGuestControllerReport(code, photoId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Claim a shot and get a presigned upload URL
         * @param {string} code 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        partyGuestControllerSlot(code: string, options?: any): AxiosPromise<void> {
            return localVarFp.partyGuestControllerSlot(code, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Public party summary for the join page
         * @param {string} code 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        partyGuestControllerSummary(code: string, options?: any): AxiosPromise<void> {
            return localVarFp.partyGuestControllerSummary(code, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Remove your like
         * @param {string} code 
         * @param {string} photoId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        partyGuestControllerUnlike(code: string, photoId: string, options?: any): AxiosPromise<void> {
            return localVarFp.partyGuestControllerUnlike(code, photoId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get a nameless guest identity (to like, select and order) without joining
         * @param {string} code 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        partyGuestControllerVisit(code: string, options?: any): AxiosPromise<void> {
            return localVarFp.partyGuestControllerVisit(code, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * PartyApi - object-oriented interface
 * @export
 * @class PartyApi
 * @extends {BaseAPI}
 */
export class PartyApi extends BaseAPI {
    /**
     * 
     * @summary Confirm an upload; the server checks and previews it
     * @param {string} code 
     * @param {string} photoId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PartyApi
     */
    public partyGuestControllerComplete(code: string, photoId: string, options?: AxiosRequestConfig) {
        return PartyApiFp(this.configuration).partyGuestControllerComplete(code, photoId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary The shared album: guest photos after the reveal, professional photos once published
     * @param {string} code 
     * @param {PartyGuestControllerGetAlbumSectionEnum} [section] 
     * @param {string} [cursor] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PartyApi
     */
    public partyGuestControllerGetAlbum(code: string, section?: PartyGuestControllerGetAlbumSectionEnum, cursor?: string, options?: AxiosRequestConfig) {
        return PartyApiFp(this.configuration).partyGuestControllerGetAlbum(code, section, cursor, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Join a party as a guest (web callers get a party token)
     * @param {string} code 
     * @param {JoinPartyDto} joinPartyDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PartyApi
     */
    public partyGuestControllerJoin(code: string, joinPartyDto: JoinPartyDto, options?: AxiosRequestConfig) {
        return PartyApiFp(this.configuration).partyGuestControllerJoin(code, joinPartyDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Parties the logged-in user has joined
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PartyApi
     */
    public partyGuestControllerJoined(options?: AxiosRequestConfig) {
        return PartyApiFp(this.configuration).partyGuestControllerJoined(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Like a photo
     * @param {string} code 
     * @param {string} photoId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PartyApi
     */
    public partyGuestControllerLike(code: string, photoId: string, options?: AxiosRequestConfig) {
        return PartyApiFp(this.configuration).partyGuestControllerLike(code, photoId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Leave an email to hear when the photographer\'s photos are published
     * @param {string} code 
     * @param {NotifyPartyDto} notifyPartyDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PartyApi
     */
    public partyGuestControllerNotify(code: string, notifyPartyDto: NotifyPartyDto, options?: AxiosRequestConfig) {
        return PartyApiFp(this.configuration).partyGuestControllerNotify(code, notifyPartyDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Delete one of your own photos
     * @param {string} code 
     * @param {string} photoId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PartyApi
     */
    public partyGuestControllerRemove(code: string, photoId: string, options?: AxiosRequestConfig) {
        return PartyApiFp(this.configuration).partyGuestControllerRemove(code, photoId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Report a photo to the host
     * @param {string} code 
     * @param {string} photoId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PartyApi
     */
    public partyGuestControllerReport(code: string, photoId: string, options?: AxiosRequestConfig) {
        return PartyApiFp(this.configuration).partyGuestControllerReport(code, photoId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Claim a shot and get a presigned upload URL
     * @param {string} code 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PartyApi
     */
    public partyGuestControllerSlot(code: string, options?: AxiosRequestConfig) {
        return PartyApiFp(this.configuration).partyGuestControllerSlot(code, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Public party summary for the join page
     * @param {string} code 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PartyApi
     */
    public partyGuestControllerSummary(code: string, options?: AxiosRequestConfig) {
        return PartyApiFp(this.configuration).partyGuestControllerSummary(code, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Remove your like
     * @param {string} code 
     * @param {string} photoId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PartyApi
     */
    public partyGuestControllerUnlike(code: string, photoId: string, options?: AxiosRequestConfig) {
        return PartyApiFp(this.configuration).partyGuestControllerUnlike(code, photoId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get a nameless guest identity (to like, select and order) without joining
     * @param {string} code 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PartyApi
     */
    public partyGuestControllerVisit(code: string, options?: AxiosRequestConfig) {
        return PartyApiFp(this.configuration).partyGuestControllerVisit(code, options).then((request) => request(this.axios, this.basePath));
    }
}

/**
 * @export
 */
export const PartyGuestControllerGetAlbumSectionEnum = {
    Popular: 'popular',
    Liked: 'liked',
    All: 'all',
    Pro: 'pro',
    Mine: 'mine'
} as const;
export type PartyGuestControllerGetAlbumSectionEnum = typeof PartyGuestControllerGetAlbumSectionEnum[keyof typeof PartyGuestControllerGetAlbumSectionEnum];


/**
 * PartyEventsApi - axios parameter creator
 * @export
 */
export const PartyEventsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Accept an organizer/photographer invite (idempotent)
         * @param {AcceptInviteDto} acceptInviteDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        partyHostControllerAccept: async (acceptInviteDto: AcceptInviteDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'acceptInviteDto' is not null or undefined
            assertParamExists('partyHostControllerAccept', 'acceptInviteDto', acceptInviteDto)
            const localVarPath = `/party-events/invites/accept`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(acceptInviteDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Create an event (as organizer or photographer)
         * @param {CreatePartyDto} createPartyDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        partyHostControllerCreate: async (createPartyDto: CreatePartyDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createPartyDto' is not null or undefined
            assertParamExists('partyHostControllerCreate', 'createPartyDto', createPartyDto)
            const localVarPath = `/party-events`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createPartyDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary One event I created or am a member of, with counts and my role
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        partyHostControllerGet: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('partyHostControllerGet', 'id', id)
            const localVarPath = `/party-events/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        partyHostControllerGoLive: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('partyHostControllerGoLive', 'id', id)
            const localVarPath = `/party-events/{id}/go-live`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Guests of an event, by join time (organizer or lead)
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        partyHostControllerGuests: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('partyHostControllerGuests', 'id', id)
            const localVarPath = `/party-events/{id}/guests`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Hide a photo from guests (guest photo: organizer or lead; professional: its photographer or the lead)
         * @param {string} id 
         * @param {string} photoId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        partyHostControllerHide: async (id: string, photoId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('partyHostControllerHide', 'id', id)
            // verify required parameter 'photoId' is not null or undefined
            assertParamExists('partyHostControllerHide', 'photoId', photoId)
            const localVarPath = `/party-events/{id}/photos/{photoId}/hide`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)))
                .replace(`{${"photoId"}}`, encodeURIComponent(String(photoId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Invite link for a photographer (or, by a photographer creator, an organizer)
         * @param {string} id 
         * @param {CreateInviteDto} createInviteDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        partyHostControllerInvite: async (id: string, createInviteDto: CreateInviteDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('partyHostControllerInvite', 'id', id)
            // verify required parameter 'createInviteDto' is not null or undefined
            assertParamExists('partyHostControllerInvite', 'createInviteDto', createInviteDto)
            const localVarPath = `/party-events/{id}/invites`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createInviteDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Organizers and photographers of an event
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        partyHostControllerMembers: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('partyHostControllerMembers', 'id', id)
            const localVarPath = `/party-events/{id}/members`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Events I created or am a member of, with my role
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        partyHostControllerMine: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/party-events/mine`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Finish a professional upload: convert, preview, mark ready (unpublished)
         * @param {string} id 
         * @param {string} photoId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        partyHostControllerProComplete: async (id: string, photoId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('partyHostControllerProComplete', 'id', id)
            // verify required parameter 'photoId' is not null or undefined
            assertParamExists('partyHostControllerProComplete', 'photoId', photoId)
            const localVarPath = `/party-events/{id}/pro-photos/{photoId}/complete`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)))
                .replace(`{${"photoId"}}`, encodeURIComponent(String(photoId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Delete a professional photo (its photographer or the lead)
         * @param {string} id 
         * @param {string} photoId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        partyHostControllerProRemove: async (id: string, photoId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('partyHostControllerProRemove', 'id', id)
            // verify required parameter 'photoId' is not null or undefined
            assertParamExists('partyHostControllerProRemove', 'photoId', photoId)
            const localVarPath = `/party-events/{id}/pro-photos/{photoId}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)))
                .replace(`{${"photoId"}}`, encodeURIComponent(String(photoId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Upload slot for a full-size professional photo (photographers)
         * @param {string} id 
         * @param {ProSlotDto} proSlotDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        partyHostControllerProSlot: async (id: string, proSlotDto: ProSlotDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('partyHostControllerProSlot', 'id', id)
            // verify required parameter 'proSlotDto' is not null or undefined
            assertParamExists('partyHostControllerProSlot', 'proSlotDto', proSlotDto)
            const localVarPath = `/party-events/{id}/pro-photos`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(proSlotDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Publish every professional photo uploaded so far (lead); the first publish notifies guests once
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        partyHostControllerPublish: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('partyHostControllerPublish', 'id', id)
            const localVarPath = `/party-events/{id}/publish`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        partyHostControllerRemove: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('partyHostControllerRemove', 'id', id)
            const localVarPath = `/party-events/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Remove a member (organizer or lead; not the lead, the creator or yourself)
         * @param {string} id 
         * @param {string} memberId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        partyHostControllerRemoveMember: async (id: string, memberId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('partyHostControllerRemoveMember', 'id', id)
            // verify required parameter 'memberId' is not null or undefined
            assertParamExists('partyHostControllerRemoveMember', 'memberId', memberId)
            const localVarPath = `/party-events/{id}/members/{memberId}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)))
                .replace(`{${"memberId"}}`, encodeURIComponent(String(memberId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        partyHostControllerReveal: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('partyHostControllerReveal', 'id', id)
            const localVarPath = `/party-events/{id}/reveal`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Hand the lead to another photographer (creator or current lead)
         * @param {string} id 
         * @param {SetLeadDto} setLeadDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        partyHostControllerSetLead: async (id: string, setLeadDto: SetLeadDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('partyHostControllerSetLead', 'id', id)
            // verify required parameter 'setLeadDto' is not null or undefined
            assertParamExists('partyHostControllerSetLead', 'setLeadDto', setLeadDto)
            const localVarPath = `/party-events/{id}/lead`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(setLeadDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Show a hidden photo again (same rules as hide)
         * @param {string} id 
         * @param {string} photoId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        partyHostControllerUnhide: async (id: string, photoId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('partyHostControllerUnhide', 'id', id)
            // verify required parameter 'photoId' is not null or undefined
            assertParamExists('partyHostControllerUnhide', 'photoId', photoId)
            const localVarPath = `/party-events/{id}/photos/{photoId}/unhide`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)))
                .replace(`{${"photoId"}}`, encodeURIComponent(String(photoId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {UpdatePartyDto} updatePartyDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        partyHostControllerUpdate: async (id: string, updatePartyDto: UpdatePartyDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('partyHostControllerUpdate', 'id', id)
            // verify required parameter 'updatePartyDto' is not null or undefined
            assertParamExists('partyHostControllerUpdate', 'updatePartyDto', updatePartyDto)
            const localVarPath = `/party-events/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updatePartyDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Set my credit name on this event
         * @param {string} id 
         * @param {UpdateMyMembershipDto} updateMyMembershipDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        partyHostControllerUpdateMe: async (id: string, updateMyMembershipDto: UpdateMyMembershipDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('partyHostControllerUpdateMe', 'id', id)
            // verify required parameter 'updateMyMembershipDto' is not null or undefined
            assertParamExists('partyHostControllerUpdateMe', 'updateMyMembershipDto', updateMyMembershipDto)
            const localVarPath = `/party-events/{id}/members/me`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateMyMembershipDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * PartyEventsApi - functional programming interface
 * @export
 */
export const PartyEventsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = PartyEventsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Accept an organizer/photographer invite (idempotent)
         * @param {AcceptInviteDto} acceptInviteDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async partyHostControllerAccept(acceptInviteDto: AcceptInviteDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.partyHostControllerAccept(acceptInviteDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Create an event (as organizer or photographer)
         * @param {CreatePartyDto} createPartyDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async partyHostControllerCreate(createPartyDto: CreatePartyDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.partyHostControllerCreate(createPartyDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary One event I created or am a member of, with counts and my role
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async partyHostControllerGet(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.partyHostControllerGet(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async partyHostControllerGoLive(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.partyHostControllerGoLive(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Guests of an event, by join time (organizer or lead)
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async partyHostControllerGuests(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.partyHostControllerGuests(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Hide a photo from guests (guest photo: organizer or lead; professional: its photographer or the lead)
         * @param {string} id 
         * @param {string} photoId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async partyHostControllerHide(id: string, photoId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.partyHostControllerHide(id, photoId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Invite link for a photographer (or, by a photographer creator, an organizer)
         * @param {string} id 
         * @param {CreateInviteDto} createInviteDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async partyHostControllerInvite(id: string, createInviteDto: CreateInviteDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.partyHostControllerInvite(id, createInviteDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Organizers and photographers of an event
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async partyHostControllerMembers(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.partyHostControllerMembers(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Events I created or am a member of, with my role
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async partyHostControllerMine(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.partyHostControllerMine(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Finish a professional upload: convert, preview, mark ready (unpublished)
         * @param {string} id 
         * @param {string} photoId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async partyHostControllerProComplete(id: string, photoId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.partyHostControllerProComplete(id, photoId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Delete a professional photo (its photographer or the lead)
         * @param {string} id 
         * @param {string} photoId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async partyHostControllerProRemove(id: string, photoId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.partyHostControllerProRemove(id, photoId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Upload slot for a full-size professional photo (photographers)
         * @param {string} id 
         * @param {ProSlotDto} proSlotDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async partyHostControllerProSlot(id: string, proSlotDto: ProSlotDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.partyHostControllerProSlot(id, proSlotDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Publish every professional photo uploaded so far (lead); the first publish notifies guests once
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async partyHostControllerPublish(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.partyHostControllerPublish(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async partyHostControllerRemove(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.partyHostControllerRemove(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Remove a member (organizer or lead; not the lead, the creator or yourself)
         * @param {string} id 
         * @param {string} memberId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async partyHostControllerRemoveMember(id: string, memberId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.partyHostControllerRemoveMember(id, memberId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async partyHostControllerReveal(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.partyHostControllerReveal(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Hand the lead to another photographer (creator or current lead)
         * @param {string} id 
         * @param {SetLeadDto} setLeadDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async partyHostControllerSetLead(id: string, setLeadDto: SetLeadDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.partyHostControllerSetLead(id, setLeadDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Show a hidden photo again (same rules as hide)
         * @param {string} id 
         * @param {string} photoId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async partyHostControllerUnhide(id: string, photoId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.partyHostControllerUnhide(id, photoId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} id 
         * @param {UpdatePartyDto} updatePartyDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async partyHostControllerUpdate(id: string, updatePartyDto: UpdatePartyDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.partyHostControllerUpdate(id, updatePartyDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Set my credit name on this event
         * @param {string} id 
         * @param {UpdateMyMembershipDto} updateMyMembershipDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async partyHostControllerUpdateMe(id: string, updateMyMembershipDto: UpdateMyMembershipDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.partyHostControllerUpdateMe(id, updateMyMembershipDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * PartyEventsApi - factory interface
 * @export
 */
export const PartyEventsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = PartyEventsApiFp(configuration)
    return {
        /**
         * 
         * @summary Accept an organizer/photographer invite (idempotent)
         * @param {AcceptInviteDto} acceptInviteDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        partyHostControllerAccept(acceptInviteDto: AcceptInviteDto, options?: any): AxiosPromise<void> {
            return localVarFp.partyHostControllerAccept(acceptInviteDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Create an event (as organizer or photographer)
         * @param {CreatePartyDto} createPartyDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        partyHostControllerCreate(createPartyDto: CreatePartyDto, options?: any): AxiosPromise<void> {
            return localVarFp.partyHostControllerCreate(createPartyDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary One event I created or am a member of, with counts and my role
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        partyHostControllerGet(id: string, options?: any): AxiosPromise<void> {
            return localVarFp.partyHostControllerGet(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        partyHostControllerGoLive(id: string, options?: any): AxiosPromise<void> {
            return localVarFp.partyHostControllerGoLive(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Guests of an event, by join time (organizer or lead)
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        partyHostControllerGuests(id: string, options?: any): AxiosPromise<void> {
            return localVarFp.partyHostControllerGuests(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Hide a photo from guests (guest photo: organizer or lead; professional: its photographer or the lead)
         * @param {string} id 
         * @param {string} photoId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        partyHostControllerHide(id: string, photoId: string, options?: any): AxiosPromise<void> {
            return localVarFp.partyHostControllerHide(id, photoId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Invite link for a photographer (or, by a photographer creator, an organizer)
         * @param {string} id 
         * @param {CreateInviteDto} createInviteDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        partyHostControllerInvite(id: string, createInviteDto: CreateInviteDto, options?: any): AxiosPromise<void> {
            return localVarFp.partyHostControllerInvite(id, createInviteDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Organizers and photographers of an event
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        partyHostControllerMembers(id: string, options?: any): AxiosPromise<void> {
            return localVarFp.partyHostControllerMembers(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Events I created or am a member of, with my role
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        partyHostControllerMine(options?: any): AxiosPromise<void> {
            return localVarFp.partyHostControllerMine(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Finish a professional upload: convert, preview, mark ready (unpublished)
         * @param {string} id 
         * @param {string} photoId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        partyHostControllerProComplete(id: string, photoId: string, options?: any): AxiosPromise<void> {
            return localVarFp.partyHostControllerProComplete(id, photoId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Delete a professional photo (its photographer or the lead)
         * @param {string} id 
         * @param {string} photoId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        partyHostControllerProRemove(id: string, photoId: string, options?: any): AxiosPromise<void> {
            return localVarFp.partyHostControllerProRemove(id, photoId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Upload slot for a full-size professional photo (photographers)
         * @param {string} id 
         * @param {ProSlotDto} proSlotDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        partyHostControllerProSlot(id: string, proSlotDto: ProSlotDto, options?: any): AxiosPromise<void> {
            return localVarFp.partyHostControllerProSlot(id, proSlotDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Publish every professional photo uploaded so far (lead); the first publish notifies guests once
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        partyHostControllerPublish(id: string, options?: any): AxiosPromise<void> {
            return localVarFp.partyHostControllerPublish(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        partyHostControllerRemove(id: string, options?: any): AxiosPromise<void> {
            return localVarFp.partyHostControllerRemove(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Remove a member (organizer or lead; not the lead, the creator or yourself)
         * @param {string} id 
         * @param {string} memberId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        partyHostControllerRemoveMember(id: string, memberId: string, options?: any): AxiosPromise<void> {
            return localVarFp.partyHostControllerRemoveMember(id, memberId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        partyHostControllerReveal(id: string, options?: any): AxiosPromise<void> {
            return localVarFp.partyHostControllerReveal(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Hand the lead to another photographer (creator or current lead)
         * @param {string} id 
         * @param {SetLeadDto} setLeadDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        partyHostControllerSetLead(id: string, setLeadDto: SetLeadDto, options?: any): AxiosPromise<void> {
            return localVarFp.partyHostControllerSetLead(id, setLeadDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Show a hidden photo again (same rules as hide)
         * @param {string} id 
         * @param {string} photoId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        partyHostControllerUnhide(id: string, photoId: string, options?: any): AxiosPromise<void> {
            return localVarFp.partyHostControllerUnhide(id, photoId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} id 
         * @param {UpdatePartyDto} updatePartyDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        partyHostControllerUpdate(id: string, updatePartyDto: UpdatePartyDto, options?: any): AxiosPromise<void> {
            return localVarFp.partyHostControllerUpdate(id, updatePartyDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Set my credit name on this event
         * @param {string} id 
         * @param {UpdateMyMembershipDto} updateMyMembershipDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        partyHostControllerUpdateMe(id: string, updateMyMembershipDto: UpdateMyMembershipDto, options?: any): AxiosPromise<void> {
            return localVarFp.partyHostControllerUpdateMe(id, updateMyMembershipDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * PartyEventsApi - object-oriented interface
 * @export
 * @class PartyEventsApi
 * @extends {BaseAPI}
 */
export class PartyEventsApi extends BaseAPI {
    /**
     * 
     * @summary Accept an organizer/photographer invite (idempotent)
     * @param {AcceptInviteDto} acceptInviteDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PartyEventsApi
     */
    public partyHostControllerAccept(acceptInviteDto: AcceptInviteDto, options?: AxiosRequestConfig) {
        return PartyEventsApiFp(this.configuration).partyHostControllerAccept(acceptInviteDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Create an event (as organizer or photographer)
     * @param {CreatePartyDto} createPartyDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PartyEventsApi
     */
    public partyHostControllerCreate(createPartyDto: CreatePartyDto, options?: AxiosRequestConfig) {
        return PartyEventsApiFp(this.configuration).partyHostControllerCreate(createPartyDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary One event I created or am a member of, with counts and my role
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PartyEventsApi
     */
    public partyHostControllerGet(id: string, options?: AxiosRequestConfig) {
        return PartyEventsApiFp(this.configuration).partyHostControllerGet(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PartyEventsApi
     */
    public partyHostControllerGoLive(id: string, options?: AxiosRequestConfig) {
        return PartyEventsApiFp(this.configuration).partyHostControllerGoLive(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Guests of an event, by join time (organizer or lead)
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PartyEventsApi
     */
    public partyHostControllerGuests(id: string, options?: AxiosRequestConfig) {
        return PartyEventsApiFp(this.configuration).partyHostControllerGuests(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Hide a photo from guests (guest photo: organizer or lead; professional: its photographer or the lead)
     * @param {string} id 
     * @param {string} photoId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PartyEventsApi
     */
    public partyHostControllerHide(id: string, photoId: string, options?: AxiosRequestConfig) {
        return PartyEventsApiFp(this.configuration).partyHostControllerHide(id, photoId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Invite link for a photographer (or, by a photographer creator, an organizer)
     * @param {string} id 
     * @param {CreateInviteDto} createInviteDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PartyEventsApi
     */
    public partyHostControllerInvite(id: string, createInviteDto: CreateInviteDto, options?: AxiosRequestConfig) {
        return PartyEventsApiFp(this.configuration).partyHostControllerInvite(id, createInviteDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Organizers and photographers of an event
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PartyEventsApi
     */
    public partyHostControllerMembers(id: string, options?: AxiosRequestConfig) {
        return PartyEventsApiFp(this.configuration).partyHostControllerMembers(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Events I created or am a member of, with my role
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PartyEventsApi
     */
    public partyHostControllerMine(options?: AxiosRequestConfig) {
        return PartyEventsApiFp(this.configuration).partyHostControllerMine(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Finish a professional upload: convert, preview, mark ready (unpublished)
     * @param {string} id 
     * @param {string} photoId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PartyEventsApi
     */
    public partyHostControllerProComplete(id: string, photoId: string, options?: AxiosRequestConfig) {
        return PartyEventsApiFp(this.configuration).partyHostControllerProComplete(id, photoId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Delete a professional photo (its photographer or the lead)
     * @param {string} id 
     * @param {string} photoId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PartyEventsApi
     */
    public partyHostControllerProRemove(id: string, photoId: string, options?: AxiosRequestConfig) {
        return PartyEventsApiFp(this.configuration).partyHostControllerProRemove(id, photoId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Upload slot for a full-size professional photo (photographers)
     * @param {string} id 
     * @param {ProSlotDto} proSlotDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PartyEventsApi
     */
    public partyHostControllerProSlot(id: string, proSlotDto: ProSlotDto, options?: AxiosRequestConfig) {
        return PartyEventsApiFp(this.configuration).partyHostControllerProSlot(id, proSlotDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Publish every professional photo uploaded so far (lead); the first publish notifies guests once
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PartyEventsApi
     */
    public partyHostControllerPublish(id: string, options?: AxiosRequestConfig) {
        return PartyEventsApiFp(this.configuration).partyHostControllerPublish(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PartyEventsApi
     */
    public partyHostControllerRemove(id: string, options?: AxiosRequestConfig) {
        return PartyEventsApiFp(this.configuration).partyHostControllerRemove(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Remove a member (organizer or lead; not the lead, the creator or yourself)
     * @param {string} id 
     * @param {string} memberId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PartyEventsApi
     */
    public partyHostControllerRemoveMember(id: string, memberId: string, options?: AxiosRequestConfig) {
        return PartyEventsApiFp(this.configuration).partyHostControllerRemoveMember(id, memberId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PartyEventsApi
     */
    public partyHostControllerReveal(id: string, options?: AxiosRequestConfig) {
        return PartyEventsApiFp(this.configuration).partyHostControllerReveal(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Hand the lead to another photographer (creator or current lead)
     * @param {string} id 
     * @param {SetLeadDto} setLeadDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PartyEventsApi
     */
    public partyHostControllerSetLead(id: string, setLeadDto: SetLeadDto, options?: AxiosRequestConfig) {
        return PartyEventsApiFp(this.configuration).partyHostControllerSetLead(id, setLeadDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Show a hidden photo again (same rules as hide)
     * @param {string} id 
     * @param {string} photoId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PartyEventsApi
     */
    public partyHostControllerUnhide(id: string, photoId: string, options?: AxiosRequestConfig) {
        return PartyEventsApiFp(this.configuration).partyHostControllerUnhide(id, photoId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} id 
     * @param {UpdatePartyDto} updatePartyDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PartyEventsApi
     */
    public partyHostControllerUpdate(id: string, updatePartyDto: UpdatePartyDto, options?: AxiosRequestConfig) {
        return PartyEventsApiFp(this.configuration).partyHostControllerUpdate(id, updatePartyDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Set my credit name on this event
     * @param {string} id 
     * @param {UpdateMyMembershipDto} updateMyMembershipDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PartyEventsApi
     */
    public partyHostControllerUpdateMe(id: string, updateMyMembershipDto: UpdateMyMembershipDto, options?: AxiosRequestConfig) {
        return PartyEventsApiFp(this.configuration).partyHostControllerUpdateMe(id, updateMyMembershipDto, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * PartyEventsAdminApi - axios parameter creator
 * @export
 */
export const PartyEventsAdminApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Extend retention by 3 or 12 months (staff)
         * @param {string} id 
         * @param {object} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        partyAdminControllerExtend: async (id: string, body: object, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('partyAdminControllerExtend', 'id', id)
            // verify required parameter 'body' is not null or undefined
            assertParamExists('partyAdminControllerExtend', 'body', body)
            const localVarPath = `/party-events/admin/{id}/extend`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Set (ISO date) or clear (null) the keep-until override that wins over every retention rule (staff)
         * @param {string} id 
         * @param {AdminKeepUntilDto} adminKeepUntilDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        partyAdminControllerKeepUntil: async (id: string, adminKeepUntilDto: AdminKeepUntilDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('partyAdminControllerKeepUntil', 'id', id)
            // verify required parameter 'adminKeepUntilDto' is not null or undefined
            assertParamExists('partyAdminControllerKeepUntil', 'adminKeepUntilDto', adminKeepUntilDto)
            const localVarPath = `/party-events/admin/{id}/keep-until`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(adminKeepUntilDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Latest 200 parties with guest and photo counts (staff)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        partyAdminControllerList: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/party-events/admin`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Raise the photo limit (staff)
         * @param {string} id 
         * @param {object} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        partyAdminControllerPhotoLimit: async (id: string, body: object, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('partyAdminControllerPhotoLimit', 'id', id)
            // verify required parameter 'body' is not null or undefined
            assertParamExists('partyAdminControllerPhotoLimit', 'body', body)
            const localVarPath = `/party-events/admin/{id}/photo-limit`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Delete a party now: retention ends and the job removes it (staff)
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        partyAdminControllerRemove: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('partyAdminControllerRemove', 'id', id)
            const localVarPath = `/party-events/admin/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * PartyEventsAdminApi - functional programming interface
 * @export
 */
export const PartyEventsAdminApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = PartyEventsAdminApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Extend retention by 3 or 12 months (staff)
         * @param {string} id 
         * @param {object} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async partyAdminControllerExtend(id: string, body: object, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.partyAdminControllerExtend(id, body, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Set (ISO date) or clear (null) the keep-until override that wins over every retention rule (staff)
         * @param {string} id 
         * @param {AdminKeepUntilDto} adminKeepUntilDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async partyAdminControllerKeepUntil(id: string, adminKeepUntilDto: AdminKeepUntilDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.partyAdminControllerKeepUntil(id, adminKeepUntilDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Latest 200 parties with guest and photo counts (staff)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async partyAdminControllerList(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.partyAdminControllerList(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Raise the photo limit (staff)
         * @param {string} id 
         * @param {object} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async partyAdminControllerPhotoLimit(id: string, body: object, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.partyAdminControllerPhotoLimit(id, body, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Delete a party now: retention ends and the job removes it (staff)
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async partyAdminControllerRemove(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.partyAdminControllerRemove(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * PartyEventsAdminApi - factory interface
 * @export
 */
export const PartyEventsAdminApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = PartyEventsAdminApiFp(configuration)
    return {
        /**
         * 
         * @summary Extend retention by 3 or 12 months (staff)
         * @param {string} id 
         * @param {object} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        partyAdminControllerExtend(id: string, body: object, options?: any): AxiosPromise<void> {
            return localVarFp.partyAdminControllerExtend(id, body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Set (ISO date) or clear (null) the keep-until override that wins over every retention rule (staff)
         * @param {string} id 
         * @param {AdminKeepUntilDto} adminKeepUntilDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        partyAdminControllerKeepUntil(id: string, adminKeepUntilDto: AdminKeepUntilDto, options?: any): AxiosPromise<void> {
            return localVarFp.partyAdminControllerKeepUntil(id, adminKeepUntilDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Latest 200 parties with guest and photo counts (staff)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        partyAdminControllerList(options?: any): AxiosPromise<void> {
            return localVarFp.partyAdminControllerList(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Raise the photo limit (staff)
         * @param {string} id 
         * @param {object} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        partyAdminControllerPhotoLimit(id: string, body: object, options?: any): AxiosPromise<void> {
            return localVarFp.partyAdminControllerPhotoLimit(id, body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Delete a party now: retention ends and the job removes it (staff)
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        partyAdminControllerRemove(id: string, options?: any): AxiosPromise<void> {
            return localVarFp.partyAdminControllerRemove(id, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * PartyEventsAdminApi - object-oriented interface
 * @export
 * @class PartyEventsAdminApi
 * @extends {BaseAPI}
 */
export class PartyEventsAdminApi extends BaseAPI {
    /**
     * 
     * @summary Extend retention by 3 or 12 months (staff)
     * @param {string} id 
     * @param {object} body 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PartyEventsAdminApi
     */
    public partyAdminControllerExtend(id: string, body: object, options?: AxiosRequestConfig) {
        return PartyEventsAdminApiFp(this.configuration).partyAdminControllerExtend(id, body, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Set (ISO date) or clear (null) the keep-until override that wins over every retention rule (staff)
     * @param {string} id 
     * @param {AdminKeepUntilDto} adminKeepUntilDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PartyEventsAdminApi
     */
    public partyAdminControllerKeepUntil(id: string, adminKeepUntilDto: AdminKeepUntilDto, options?: AxiosRequestConfig) {
        return PartyEventsAdminApiFp(this.configuration).partyAdminControllerKeepUntil(id, adminKeepUntilDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Latest 200 parties with guest and photo counts (staff)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PartyEventsAdminApi
     */
    public partyAdminControllerList(options?: AxiosRequestConfig) {
        return PartyEventsAdminApiFp(this.configuration).partyAdminControllerList(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Raise the photo limit (staff)
     * @param {string} id 
     * @param {object} body 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PartyEventsAdminApi
     */
    public partyAdminControllerPhotoLimit(id: string, body: object, options?: AxiosRequestConfig) {
        return PartyEventsAdminApiFp(this.configuration).partyAdminControllerPhotoLimit(id, body, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Delete a party now: retention ends and the job removes it (staff)
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PartyEventsAdminApi
     */
    public partyAdminControllerRemove(id: string, options?: AxiosRequestConfig) {
        return PartyEventsAdminApiFp(this.configuration).partyAdminControllerRemove(id, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * PhotoSizeApi - axios parameter creator
 * @export
 */
export const PhotoSizeApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Create multiple PhotoSizes
         * @param {CreateManyPhotoSizeDto} createManyPhotoSizeDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createManyBasePhotoSizeControllerPhotoSize: async (createManyPhotoSizeDto: CreateManyPhotoSizeDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createManyPhotoSizeDto' is not null or undefined
            assertParamExists('createManyBasePhotoSizeControllerPhotoSize', 'createManyPhotoSizeDto', createManyPhotoSizeDto)
            const localVarPath = `/photo-size/bulk`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createManyPhotoSizeDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Create a single PhotoSize
         * @param {CreatePhotoSizeDto} createPhotoSizeDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createOneBasePhotoSizeControllerPhotoSize: async (createPhotoSizeDto: CreatePhotoSizeDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createPhotoSizeDto' is not null or undefined
            assertParamExists('createOneBasePhotoSizeControllerPhotoSize', 'createPhotoSizeDto', createPhotoSizeDto)
            const localVarPath = `/photo-size`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createPhotoSizeDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Delete a single PhotoSize
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOneBasePhotoSizeControllerPhotoSize: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('deleteOneBasePhotoSizeControllerPhotoSize', 'id', id)
            const localVarPath = `/photo-size/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Retrieve multiple PhotoSizes
         * @param {boolean} [includeHidden] When true, include hidden (promotional) sizes. Admin use.
         * @param {Array<string>} [fields] Selects resource fields. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#select\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {string} [s] Adds search condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#search\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {Array<string>} [filter] Adds filter condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#filter\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {Array<string>} [or] Adds OR condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#or\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {Array<string>} [sort] Adds sort by field. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#sort\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {Array<string>} [join] Adds relational resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#join\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {number} [limit] Limit amount of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#limit\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {number} [offset] Offset amount of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#offset\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {number} [page] Page portion of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#page\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {number} [cache] Reset cache (if was enabled). &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#cache\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getManyBasePhotoSizeControllerPhotoSize: async (includeHidden?: boolean, fields?: Array<string>, s?: string, filter?: Array<string>, or?: Array<string>, sort?: Array<string>, join?: Array<string>, limit?: number, offset?: number, page?: number, cache?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/photo-size`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (includeHidden !== undefined) {
                localVarQueryParameter['includeHidden'] = includeHidden;
            }

            if (fields) {
                localVarQueryParameter['fields'] = fields;
            }

            if (s !== undefined) {
                localVarQueryParameter['s'] = s;
            }

            if (filter) {
                localVarQueryParameter['filter'] = filter;
            }

            if (or) {
                localVarQueryParameter['or'] = or;
            }

            if (sort) {
                localVarQueryParameter['sort'] = sort;
            }

            if (join) {
                localVarQueryParameter['join'] = join;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (cache !== undefined) {
                localVarQueryParameter['cache'] = cache;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Retrieve a single PhotoSize
         * @param {string} id 
         * @param {Array<string>} [fields] Selects resource fields. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#select\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {Array<string>} [join] Adds relational resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#join\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {number} [cache] Reset cache (if was enabled). &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#cache\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOneBasePhotoSizeControllerPhotoSize: async (id: string, fields?: Array<string>, join?: Array<string>, cache?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getOneBasePhotoSizeControllerPhotoSize', 'id', id)
            const localVarPath = `/photo-size/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (fields) {
                localVarQueryParameter['fields'] = fields;
            }

            if (join) {
                localVarQueryParameter['join'] = join;
            }

            if (cache !== undefined) {
                localVarQueryParameter['cache'] = cache;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Replace a single PhotoSize
         * @param {string} id 
         * @param {UpdatePhotoSizeDto} updatePhotoSizeDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        replaceOneBasePhotoSizeControllerPhotoSize: async (id: string, updatePhotoSizeDto: UpdatePhotoSizeDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('replaceOneBasePhotoSizeControllerPhotoSize', 'id', id)
            // verify required parameter 'updatePhotoSizeDto' is not null or undefined
            assertParamExists('replaceOneBasePhotoSizeControllerPhotoSize', 'updatePhotoSizeDto', updatePhotoSizeDto)
            const localVarPath = `/photo-size/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updatePhotoSizeDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update a single PhotoSize
         * @param {string} id 
         * @param {UpdatePhotoSizeDto} updatePhotoSizeDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateOneBasePhotoSizeControllerPhotoSize: async (id: string, updatePhotoSizeDto: UpdatePhotoSizeDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('updateOneBasePhotoSizeControllerPhotoSize', 'id', id)
            // verify required parameter 'updatePhotoSizeDto' is not null or undefined
            assertParamExists('updateOneBasePhotoSizeControllerPhotoSize', 'updatePhotoSizeDto', updatePhotoSizeDto)
            const localVarPath = `/photo-size/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updatePhotoSizeDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * PhotoSizeApi - functional programming interface
 * @export
 */
export const PhotoSizeApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = PhotoSizeApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Create multiple PhotoSizes
         * @param {CreateManyPhotoSizeDto} createManyPhotoSizeDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createManyBasePhotoSizeControllerPhotoSize(createManyPhotoSizeDto: CreateManyPhotoSizeDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<object>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createManyBasePhotoSizeControllerPhotoSize(createManyPhotoSizeDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Create a single PhotoSize
         * @param {CreatePhotoSizeDto} createPhotoSizeDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createOneBasePhotoSizeControllerPhotoSize(createPhotoSizeDto: CreatePhotoSizeDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createOneBasePhotoSizeControllerPhotoSize(createPhotoSizeDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Delete a single PhotoSize
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteOneBasePhotoSizeControllerPhotoSize(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteOneBasePhotoSizeControllerPhotoSize(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Retrieve multiple PhotoSizes
         * @param {boolean} [includeHidden] When true, include hidden (promotional) sizes. Admin use.
         * @param {Array<string>} [fields] Selects resource fields. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#select\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {string} [s] Adds search condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#search\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {Array<string>} [filter] Adds filter condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#filter\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {Array<string>} [or] Adds OR condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#or\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {Array<string>} [sort] Adds sort by field. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#sort\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {Array<string>} [join] Adds relational resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#join\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {number} [limit] Limit amount of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#limit\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {number} [offset] Offset amount of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#offset\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {number} [page] Page portion of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#page\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {number} [cache] Reset cache (if was enabled). &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#cache\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getManyBasePhotoSizeControllerPhotoSize(includeHidden?: boolean, fields?: Array<string>, s?: string, filter?: Array<string>, or?: Array<string>, sort?: Array<string>, join?: Array<string>, limit?: number, offset?: number, page?: number, cache?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetManyPhotoSizeResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getManyBasePhotoSizeControllerPhotoSize(includeHidden, fields, s, filter, or, sort, join, limit, offset, page, cache, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Retrieve a single PhotoSize
         * @param {string} id 
         * @param {Array<string>} [fields] Selects resource fields. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#select\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {Array<string>} [join] Adds relational resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#join\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {number} [cache] Reset cache (if was enabled). &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#cache\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getOneBasePhotoSizeControllerPhotoSize(id: string, fields?: Array<string>, join?: Array<string>, cache?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetPhotoSizeDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getOneBasePhotoSizeControllerPhotoSize(id, fields, join, cache, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Replace a single PhotoSize
         * @param {string} id 
         * @param {UpdatePhotoSizeDto} updatePhotoSizeDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async replaceOneBasePhotoSizeControllerPhotoSize(id: string, updatePhotoSizeDto: UpdatePhotoSizeDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.replaceOneBasePhotoSizeControllerPhotoSize(id, updatePhotoSizeDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Update a single PhotoSize
         * @param {string} id 
         * @param {UpdatePhotoSizeDto} updatePhotoSizeDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateOneBasePhotoSizeControllerPhotoSize(id: string, updatePhotoSizeDto: UpdatePhotoSizeDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateOneBasePhotoSizeControllerPhotoSize(id, updatePhotoSizeDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * PhotoSizeApi - factory interface
 * @export
 */
export const PhotoSizeApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = PhotoSizeApiFp(configuration)
    return {
        /**
         * 
         * @summary Create multiple PhotoSizes
         * @param {CreateManyPhotoSizeDto} createManyPhotoSizeDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createManyBasePhotoSizeControllerPhotoSize(createManyPhotoSizeDto: CreateManyPhotoSizeDto, options?: any): AxiosPromise<Array<object>> {
            return localVarFp.createManyBasePhotoSizeControllerPhotoSize(createManyPhotoSizeDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Create a single PhotoSize
         * @param {CreatePhotoSizeDto} createPhotoSizeDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createOneBasePhotoSizeControllerPhotoSize(createPhotoSizeDto: CreatePhotoSizeDto, options?: any): AxiosPromise<object> {
            return localVarFp.createOneBasePhotoSizeControllerPhotoSize(createPhotoSizeDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Delete a single PhotoSize
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOneBasePhotoSizeControllerPhotoSize(id: string, options?: any): AxiosPromise<object> {
            return localVarFp.deleteOneBasePhotoSizeControllerPhotoSize(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Retrieve multiple PhotoSizes
         * @param {boolean} [includeHidden] When true, include hidden (promotional) sizes. Admin use.
         * @param {Array<string>} [fields] Selects resource fields. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#select\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {string} [s] Adds search condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#search\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {Array<string>} [filter] Adds filter condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#filter\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {Array<string>} [or] Adds OR condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#or\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {Array<string>} [sort] Adds sort by field. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#sort\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {Array<string>} [join] Adds relational resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#join\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {number} [limit] Limit amount of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#limit\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {number} [offset] Offset amount of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#offset\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {number} [page] Page portion of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#page\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {number} [cache] Reset cache (if was enabled). &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#cache\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getManyBasePhotoSizeControllerPhotoSize(includeHidden?: boolean, fields?: Array<string>, s?: string, filter?: Array<string>, or?: Array<string>, sort?: Array<string>, join?: Array<string>, limit?: number, offset?: number, page?: number, cache?: number, options?: any): AxiosPromise<GetManyPhotoSizeResponseDto> {
            return localVarFp.getManyBasePhotoSizeControllerPhotoSize(includeHidden, fields, s, filter, or, sort, join, limit, offset, page, cache, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Retrieve a single PhotoSize
         * @param {string} id 
         * @param {Array<string>} [fields] Selects resource fields. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#select\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {Array<string>} [join] Adds relational resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#join\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {number} [cache] Reset cache (if was enabled). &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#cache\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOneBasePhotoSizeControllerPhotoSize(id: string, fields?: Array<string>, join?: Array<string>, cache?: number, options?: any): AxiosPromise<GetPhotoSizeDto> {
            return localVarFp.getOneBasePhotoSizeControllerPhotoSize(id, fields, join, cache, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Replace a single PhotoSize
         * @param {string} id 
         * @param {UpdatePhotoSizeDto} updatePhotoSizeDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        replaceOneBasePhotoSizeControllerPhotoSize(id: string, updatePhotoSizeDto: UpdatePhotoSizeDto, options?: any): AxiosPromise<object> {
            return localVarFp.replaceOneBasePhotoSizeControllerPhotoSize(id, updatePhotoSizeDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update a single PhotoSize
         * @param {string} id 
         * @param {UpdatePhotoSizeDto} updatePhotoSizeDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateOneBasePhotoSizeControllerPhotoSize(id: string, updatePhotoSizeDto: UpdatePhotoSizeDto, options?: any): AxiosPromise<object> {
            return localVarFp.updateOneBasePhotoSizeControllerPhotoSize(id, updatePhotoSizeDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * PhotoSizeApi - object-oriented interface
 * @export
 * @class PhotoSizeApi
 * @extends {BaseAPI}
 */
export class PhotoSizeApi extends BaseAPI {
    /**
     * 
     * @summary Create multiple PhotoSizes
     * @param {CreateManyPhotoSizeDto} createManyPhotoSizeDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PhotoSizeApi
     */
    public createManyBasePhotoSizeControllerPhotoSize(createManyPhotoSizeDto: CreateManyPhotoSizeDto, options?: AxiosRequestConfig) {
        return PhotoSizeApiFp(this.configuration).createManyBasePhotoSizeControllerPhotoSize(createManyPhotoSizeDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Create a single PhotoSize
     * @param {CreatePhotoSizeDto} createPhotoSizeDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PhotoSizeApi
     */
    public createOneBasePhotoSizeControllerPhotoSize(createPhotoSizeDto: CreatePhotoSizeDto, options?: AxiosRequestConfig) {
        return PhotoSizeApiFp(this.configuration).createOneBasePhotoSizeControllerPhotoSize(createPhotoSizeDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Delete a single PhotoSize
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PhotoSizeApi
     */
    public deleteOneBasePhotoSizeControllerPhotoSize(id: string, options?: AxiosRequestConfig) {
        return PhotoSizeApiFp(this.configuration).deleteOneBasePhotoSizeControllerPhotoSize(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Retrieve multiple PhotoSizes
     * @param {boolean} [includeHidden] When true, include hidden (promotional) sizes. Admin use.
     * @param {Array<string>} [fields] Selects resource fields. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#select\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param {string} [s] Adds search condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#search\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param {Array<string>} [filter] Adds filter condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#filter\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param {Array<string>} [or] Adds OR condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#or\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param {Array<string>} [sort] Adds sort by field. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#sort\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param {Array<string>} [join] Adds relational resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#join\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param {number} [limit] Limit amount of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#limit\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param {number} [offset] Offset amount of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#offset\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param {number} [page] Page portion of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#page\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param {number} [cache] Reset cache (if was enabled). &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#cache\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PhotoSizeApi
     */
    public getManyBasePhotoSizeControllerPhotoSize(includeHidden?: boolean, fields?: Array<string>, s?: string, filter?: Array<string>, or?: Array<string>, sort?: Array<string>, join?: Array<string>, limit?: number, offset?: number, page?: number, cache?: number, options?: AxiosRequestConfig) {
        return PhotoSizeApiFp(this.configuration).getManyBasePhotoSizeControllerPhotoSize(includeHidden, fields, s, filter, or, sort, join, limit, offset, page, cache, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Retrieve a single PhotoSize
     * @param {string} id 
     * @param {Array<string>} [fields] Selects resource fields. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#select\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param {Array<string>} [join] Adds relational resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#join\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param {number} [cache] Reset cache (if was enabled). &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#cache\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PhotoSizeApi
     */
    public getOneBasePhotoSizeControllerPhotoSize(id: string, fields?: Array<string>, join?: Array<string>, cache?: number, options?: AxiosRequestConfig) {
        return PhotoSizeApiFp(this.configuration).getOneBasePhotoSizeControllerPhotoSize(id, fields, join, cache, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Replace a single PhotoSize
     * @param {string} id 
     * @param {UpdatePhotoSizeDto} updatePhotoSizeDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PhotoSizeApi
     */
    public replaceOneBasePhotoSizeControllerPhotoSize(id: string, updatePhotoSizeDto: UpdatePhotoSizeDto, options?: AxiosRequestConfig) {
        return PhotoSizeApiFp(this.configuration).replaceOneBasePhotoSizeControllerPhotoSize(id, updatePhotoSizeDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update a single PhotoSize
     * @param {string} id 
     * @param {UpdatePhotoSizeDto} updatePhotoSizeDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PhotoSizeApi
     */
    public updateOneBasePhotoSizeControllerPhotoSize(id: string, updatePhotoSizeDto: UpdatePhotoSizeDto, options?: AxiosRequestConfig) {
        return PhotoSizeApiFp(this.configuration).updateOneBasePhotoSizeControllerPhotoSize(id, updatePhotoSizeDto, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * PhotosApi - axios parameter creator
 * @export
 */
export const PhotosApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Confirm uploaded object keys for a photo group
         * @param {PhotoControllerConfirmUploadsRequest} photoControllerConfirmUploadsRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        photoControllerConfirmUploads: async (photoControllerConfirmUploadsRequest: PhotoControllerConfirmUploadsRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'photoControllerConfirmUploadsRequest' is not null or undefined
            assertParamExists('photoControllerConfirmUploads', 'photoControllerConfirmUploadsRequest', photoControllerConfirmUploadsRequest)
            const localVarPath = `/photos/confirm-uploads`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(photoControllerConfirmUploadsRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        photoControllerDemo: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/photos/demo`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get a presigned download URL for an S3 key
         * @param {string} key 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        photoControllerGetDownloadUrl: async (key: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'key' is not null or undefined
            assertParamExists('photoControllerGetDownloadUrl', 'key', key)
            const localVarPath = `/photos/download-url`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (key !== undefined) {
                localVarQueryParameter['key'] = key;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} fileName 
         * @param {string} type 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        photoControllerGetPresignedUrl: async (fileName: string, type: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'fileName' is not null or undefined
            assertParamExists('photoControllerGetPresignedUrl', 'fileName', fileName)
            // verify required parameter 'type' is not null or undefined
            assertParamExists('photoControllerGetPresignedUrl', 'type', type)
            const localVarPath = `/photos/presigned-url`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (fileName !== undefined) {
                localVarQueryParameter['fileName'] = fileName;
            }

            if (type !== undefined) {
                localVarQueryParameter['type'] = type;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {PhotoControllerGetPresignedUrlsRequest} photoControllerGetPresignedUrlsRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        photoControllerGetPresignedUrls: async (photoControllerGetPresignedUrlsRequest: PhotoControllerGetPresignedUrlsRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'photoControllerGetPresignedUrlsRequest' is not null or undefined
            assertParamExists('photoControllerGetPresignedUrls', 'photoControllerGetPresignedUrlsRequest', photoControllerGetPresignedUrlsRequest)
            const localVarPath = `/photos/presigned-urls`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(photoControllerGetPresignedUrlsRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {File} [file] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        photoControllerUploadFile: async (file?: File, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/photos/uploadFile`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


            if (file !== undefined) { 
                localVarFormParams.append('file', file as any);
            }
    
    
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {File} [file] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        photoControllerUploadFileWithoutOrder: async (file?: File, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/photos/uploadFileWithoutOrder`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


            if (file !== undefined) { 
                localVarFormParams.append('file', file as any);
            }
    
    
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {PhotoControllerUploadMetadataRequest} photoControllerUploadMetadataRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        photoControllerUploadMetadata: async (photoControllerUploadMetadataRequest: PhotoControllerUploadMetadataRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'photoControllerUploadMetadataRequest' is not null or undefined
            assertParamExists('photoControllerUploadMetadata', 'photoControllerUploadMetadataRequest', photoControllerUploadMetadataRequest)
            const localVarPath = `/photos/uploadMetadata`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(photoControllerUploadMetadataRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {PhotoControllerUploadMetadataBatchRequest} photoControllerUploadMetadataBatchRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        photoControllerUploadMetadataBatch: async (photoControllerUploadMetadataBatchRequest: PhotoControllerUploadMetadataBatchRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'photoControllerUploadMetadataBatchRequest' is not null or undefined
            assertParamExists('photoControllerUploadMetadataBatch', 'photoControllerUploadMetadataBatchRequest', photoControllerUploadMetadataBatchRequest)
            const localVarPath = `/photos/uploadMetadataBatch`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(photoControllerUploadMetadataBatchRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {Array<File>} [files] 
         * @param {string} [counts] 
         * @param {string} [ranks] 
         * @param {string} [orderId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        photoControllerUploadMultipleFiles: async (files?: Array<File>, counts?: string, ranks?: string, orderId?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/photos/uploadMultipleFiles`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (files) {
                files.forEach((element) => {
                    localVarFormParams.append('files', element as any);
                })
            }

    
            if (counts !== undefined) { 
                localVarFormParams.append('counts', counts as any);
            }
    
            if (ranks !== undefined) { 
                localVarFormParams.append('ranks', ranks as any);
            }
    
            if (orderId !== undefined) { 
                localVarFormParams.append('order_id', orderId as any);
            }
    
    
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * PhotosApi - functional programming interface
 * @export
 */
export const PhotosApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = PhotosApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Confirm uploaded object keys for a photo group
         * @param {PhotoControllerConfirmUploadsRequest} photoControllerConfirmUploadsRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async photoControllerConfirmUploads(photoControllerConfirmUploadsRequest: PhotoControllerConfirmUploadsRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.photoControllerConfirmUploads(photoControllerConfirmUploadsRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async photoControllerDemo(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.photoControllerDemo(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get a presigned download URL for an S3 key
         * @param {string} key 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async photoControllerGetDownloadUrl(key: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.photoControllerGetDownloadUrl(key, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} fileName 
         * @param {string} type 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async photoControllerGetPresignedUrl(fileName: string, type: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.photoControllerGetPresignedUrl(fileName, type, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {PhotoControllerGetPresignedUrlsRequest} photoControllerGetPresignedUrlsRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async photoControllerGetPresignedUrls(photoControllerGetPresignedUrlsRequest: PhotoControllerGetPresignedUrlsRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PhotoControllerGetPresignedUrls200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.photoControllerGetPresignedUrls(photoControllerGetPresignedUrlsRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {File} [file] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async photoControllerUploadFile(file?: File, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.photoControllerUploadFile(file, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {File} [file] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async photoControllerUploadFileWithoutOrder(file?: File, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UploadPhotoResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.photoControllerUploadFileWithoutOrder(file, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {PhotoControllerUploadMetadataRequest} photoControllerUploadMetadataRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async photoControllerUploadMetadata(photoControllerUploadMetadataRequest: PhotoControllerUploadMetadataRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.photoControllerUploadMetadata(photoControllerUploadMetadataRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {PhotoControllerUploadMetadataBatchRequest} photoControllerUploadMetadataBatchRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async photoControllerUploadMetadataBatch(photoControllerUploadMetadataBatchRequest: PhotoControllerUploadMetadataBatchRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.photoControllerUploadMetadataBatch(photoControllerUploadMetadataBatchRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {Array<File>} [files] 
         * @param {string} [counts] 
         * @param {string} [ranks] 
         * @param {string} [orderId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async photoControllerUploadMultipleFiles(files?: Array<File>, counts?: string, ranks?: string, orderId?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.photoControllerUploadMultipleFiles(files, counts, ranks, orderId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * PhotosApi - factory interface
 * @export
 */
export const PhotosApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = PhotosApiFp(configuration)
    return {
        /**
         * 
         * @summary Confirm uploaded object keys for a photo group
         * @param {PhotoControllerConfirmUploadsRequest} photoControllerConfirmUploadsRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        photoControllerConfirmUploads(photoControllerConfirmUploadsRequest: PhotoControllerConfirmUploadsRequest, options?: any): AxiosPromise<void> {
            return localVarFp.photoControllerConfirmUploads(photoControllerConfirmUploadsRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        photoControllerDemo(options?: any): AxiosPromise<void> {
            return localVarFp.photoControllerDemo(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get a presigned download URL for an S3 key
         * @param {string} key 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        photoControllerGetDownloadUrl(key: string, options?: any): AxiosPromise<void> {
            return localVarFp.photoControllerGetDownloadUrl(key, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} fileName 
         * @param {string} type 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        photoControllerGetPresignedUrl(fileName: string, type: string, options?: any): AxiosPromise<void> {
            return localVarFp.photoControllerGetPresignedUrl(fileName, type, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {PhotoControllerGetPresignedUrlsRequest} photoControllerGetPresignedUrlsRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        photoControllerGetPresignedUrls(photoControllerGetPresignedUrlsRequest: PhotoControllerGetPresignedUrlsRequest, options?: any): AxiosPromise<PhotoControllerGetPresignedUrls200Response> {
            return localVarFp.photoControllerGetPresignedUrls(photoControllerGetPresignedUrlsRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {File} [file] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        photoControllerUploadFile(file?: File, options?: any): AxiosPromise<void> {
            return localVarFp.photoControllerUploadFile(file, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {File} [file] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        photoControllerUploadFileWithoutOrder(file?: File, options?: any): AxiosPromise<UploadPhotoResponseDto> {
            return localVarFp.photoControllerUploadFileWithoutOrder(file, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {PhotoControllerUploadMetadataRequest} photoControllerUploadMetadataRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        photoControllerUploadMetadata(photoControllerUploadMetadataRequest: PhotoControllerUploadMetadataRequest, options?: any): AxiosPromise<void> {
            return localVarFp.photoControllerUploadMetadata(photoControllerUploadMetadataRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {PhotoControllerUploadMetadataBatchRequest} photoControllerUploadMetadataBatchRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        photoControllerUploadMetadataBatch(photoControllerUploadMetadataBatchRequest: PhotoControllerUploadMetadataBatchRequest, options?: any): AxiosPromise<void> {
            return localVarFp.photoControllerUploadMetadataBatch(photoControllerUploadMetadataBatchRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {Array<File>} [files] 
         * @param {string} [counts] 
         * @param {string} [ranks] 
         * @param {string} [orderId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        photoControllerUploadMultipleFiles(files?: Array<File>, counts?: string, ranks?: string, orderId?: string, options?: any): AxiosPromise<void> {
            return localVarFp.photoControllerUploadMultipleFiles(files, counts, ranks, orderId, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * PhotosApi - object-oriented interface
 * @export
 * @class PhotosApi
 * @extends {BaseAPI}
 */
export class PhotosApi extends BaseAPI {
    /**
     * 
     * @summary Confirm uploaded object keys for a photo group
     * @param {PhotoControllerConfirmUploadsRequest} photoControllerConfirmUploadsRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PhotosApi
     */
    public photoControllerConfirmUploads(photoControllerConfirmUploadsRequest: PhotoControllerConfirmUploadsRequest, options?: AxiosRequestConfig) {
        return PhotosApiFp(this.configuration).photoControllerConfirmUploads(photoControllerConfirmUploadsRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PhotosApi
     */
    public photoControllerDemo(options?: AxiosRequestConfig) {
        return PhotosApiFp(this.configuration).photoControllerDemo(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get a presigned download URL for an S3 key
     * @param {string} key 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PhotosApi
     */
    public photoControllerGetDownloadUrl(key: string, options?: AxiosRequestConfig) {
        return PhotosApiFp(this.configuration).photoControllerGetDownloadUrl(key, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} fileName 
     * @param {string} type 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PhotosApi
     */
    public photoControllerGetPresignedUrl(fileName: string, type: string, options?: AxiosRequestConfig) {
        return PhotosApiFp(this.configuration).photoControllerGetPresignedUrl(fileName, type, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {PhotoControllerGetPresignedUrlsRequest} photoControllerGetPresignedUrlsRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PhotosApi
     */
    public photoControllerGetPresignedUrls(photoControllerGetPresignedUrlsRequest: PhotoControllerGetPresignedUrlsRequest, options?: AxiosRequestConfig) {
        return PhotosApiFp(this.configuration).photoControllerGetPresignedUrls(photoControllerGetPresignedUrlsRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {File} [file] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PhotosApi
     */
    public photoControllerUploadFile(file?: File, options?: AxiosRequestConfig) {
        return PhotosApiFp(this.configuration).photoControllerUploadFile(file, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {File} [file] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PhotosApi
     */
    public photoControllerUploadFileWithoutOrder(file?: File, options?: AxiosRequestConfig) {
        return PhotosApiFp(this.configuration).photoControllerUploadFileWithoutOrder(file, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {PhotoControllerUploadMetadataRequest} photoControllerUploadMetadataRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PhotosApi
     */
    public photoControllerUploadMetadata(photoControllerUploadMetadataRequest: PhotoControllerUploadMetadataRequest, options?: AxiosRequestConfig) {
        return PhotosApiFp(this.configuration).photoControllerUploadMetadata(photoControllerUploadMetadataRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {PhotoControllerUploadMetadataBatchRequest} photoControllerUploadMetadataBatchRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PhotosApi
     */
    public photoControllerUploadMetadataBatch(photoControllerUploadMetadataBatchRequest: PhotoControllerUploadMetadataBatchRequest, options?: AxiosRequestConfig) {
        return PhotosApiFp(this.configuration).photoControllerUploadMetadataBatch(photoControllerUploadMetadataBatchRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {Array<File>} [files] 
     * @param {string} [counts] 
     * @param {string} [ranks] 
     * @param {string} [orderId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PhotosApi
     */
    public photoControllerUploadMultipleFiles(files?: Array<File>, counts?: string, ranks?: string, orderId?: string, options?: AxiosRequestConfig) {
        return PhotosApiFp(this.configuration).photoControllerUploadMultipleFiles(files, counts, ranks, orderId, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * PostApi - axios parameter creator
 * @export
 */
export const PostApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Create multiple Posts
         * @param {CreateManyPostDto} createManyPostDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createManyBasePostControllerPost: async (createManyPostDto: CreateManyPostDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createManyPostDto' is not null or undefined
            assertParamExists('createManyBasePostControllerPost', 'createManyPostDto', createManyPostDto)
            const localVarPath = `/post/bulk`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createManyPostDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Create a single Post
         * @param {CreatePostDto} createPostDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createOneBasePostControllerPost: async (createPostDto: CreatePostDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createPostDto' is not null or undefined
            assertParamExists('createOneBasePostControllerPost', 'createPostDto', createPostDto)
            const localVarPath = `/post`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createPostDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Delete a single Post
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOneBasePostControllerPost: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('deleteOneBasePostControllerPost', 'id', id)
            const localVarPath = `/post/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Retrieve multiple Posts
         * @param {Array<string>} [fields] Selects resource fields. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#select\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {string} [s] Adds search condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#search\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {Array<string>} [filter] Adds filter condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#filter\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {Array<string>} [or] Adds OR condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#or\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {Array<string>} [sort] Adds sort by field. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#sort\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {Array<string>} [join] Adds relational resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#join\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {number} [limit] Limit amount of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#limit\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {number} [offset] Offset amount of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#offset\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {number} [page] Page portion of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#page\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {number} [cache] Reset cache (if was enabled). &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#cache\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getManyBasePostControllerPost: async (fields?: Array<string>, s?: string, filter?: Array<string>, or?: Array<string>, sort?: Array<string>, join?: Array<string>, limit?: number, offset?: number, page?: number, cache?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/post`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (fields) {
                localVarQueryParameter['fields'] = fields;
            }

            if (s !== undefined) {
                localVarQueryParameter['s'] = s;
            }

            if (filter) {
                localVarQueryParameter['filter'] = filter;
            }

            if (or) {
                localVarQueryParameter['or'] = or;
            }

            if (sort) {
                localVarQueryParameter['sort'] = sort;
            }

            if (join) {
                localVarQueryParameter['join'] = join;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (cache !== undefined) {
                localVarQueryParameter['cache'] = cache;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Retrieve a single Post
         * @param {string} id 
         * @param {Array<string>} [fields] Selects resource fields. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#select\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {Array<string>} [join] Adds relational resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#join\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {number} [cache] Reset cache (if was enabled). &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#cache\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOneBasePostControllerPost: async (id: string, fields?: Array<string>, join?: Array<string>, cache?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getOneBasePostControllerPost', 'id', id)
            const localVarPath = `/post/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (fields) {
                localVarQueryParameter['fields'] = fields;
            }

            if (join) {
                localVarQueryParameter['join'] = join;
            }

            if (cache !== undefined) {
                localVarQueryParameter['cache'] = cache;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {any} [locale] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postControllerGetFeed: async (locale?: any, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/post/feed`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (locale !== undefined) {
                localVarQueryParameter['locale'] = locale;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Replace a single Post
         * @param {string} id 
         * @param {UpdatePostDto} updatePostDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        replaceOneBasePostControllerPost: async (id: string, updatePostDto: UpdatePostDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('replaceOneBasePostControllerPost', 'id', id)
            // verify required parameter 'updatePostDto' is not null or undefined
            assertParamExists('replaceOneBasePostControllerPost', 'updatePostDto', updatePostDto)
            const localVarPath = `/post/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updatePostDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update a single Post
         * @param {string} id 
         * @param {UpdatePostDto} updatePostDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateOneBasePostControllerPost: async (id: string, updatePostDto: UpdatePostDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('updateOneBasePostControllerPost', 'id', id)
            // verify required parameter 'updatePostDto' is not null or undefined
            assertParamExists('updateOneBasePostControllerPost', 'updatePostDto', updatePostDto)
            const localVarPath = `/post/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updatePostDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * PostApi - functional programming interface
 * @export
 */
export const PostApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = PostApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Create multiple Posts
         * @param {CreateManyPostDto} createManyPostDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createManyBasePostControllerPost(createManyPostDto: CreateManyPostDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<object>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createManyBasePostControllerPost(createManyPostDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Create a single Post
         * @param {CreatePostDto} createPostDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createOneBasePostControllerPost(createPostDto: CreatePostDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createOneBasePostControllerPost(createPostDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Delete a single Post
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteOneBasePostControllerPost(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteOneBasePostControllerPost(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Retrieve multiple Posts
         * @param {Array<string>} [fields] Selects resource fields. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#select\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {string} [s] Adds search condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#search\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {Array<string>} [filter] Adds filter condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#filter\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {Array<string>} [or] Adds OR condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#or\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {Array<string>} [sort] Adds sort by field. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#sort\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {Array<string>} [join] Adds relational resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#join\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {number} [limit] Limit amount of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#limit\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {number} [offset] Offset amount of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#offset\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {number} [page] Page portion of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#page\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {number} [cache] Reset cache (if was enabled). &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#cache\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getManyBasePostControllerPost(fields?: Array<string>, s?: string, filter?: Array<string>, or?: Array<string>, sort?: Array<string>, join?: Array<string>, limit?: number, offset?: number, page?: number, cache?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetManyPostResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getManyBasePostControllerPost(fields, s, filter, or, sort, join, limit, offset, page, cache, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Retrieve a single Post
         * @param {string} id 
         * @param {Array<string>} [fields] Selects resource fields. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#select\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {Array<string>} [join] Adds relational resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#join\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {number} [cache] Reset cache (if was enabled). &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#cache\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getOneBasePostControllerPost(id: string, fields?: Array<string>, join?: Array<string>, cache?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetPostDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getOneBasePostControllerPost(id, fields, join, cache, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {any} [locale] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async postControllerGetFeed(locale?: any, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.postControllerGetFeed(locale, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Replace a single Post
         * @param {string} id 
         * @param {UpdatePostDto} updatePostDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async replaceOneBasePostControllerPost(id: string, updatePostDto: UpdatePostDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.replaceOneBasePostControllerPost(id, updatePostDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Update a single Post
         * @param {string} id 
         * @param {UpdatePostDto} updatePostDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateOneBasePostControllerPost(id: string, updatePostDto: UpdatePostDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateOneBasePostControllerPost(id, updatePostDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * PostApi - factory interface
 * @export
 */
export const PostApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = PostApiFp(configuration)
    return {
        /**
         * 
         * @summary Create multiple Posts
         * @param {CreateManyPostDto} createManyPostDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createManyBasePostControllerPost(createManyPostDto: CreateManyPostDto, options?: any): AxiosPromise<Array<object>> {
            return localVarFp.createManyBasePostControllerPost(createManyPostDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Create a single Post
         * @param {CreatePostDto} createPostDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createOneBasePostControllerPost(createPostDto: CreatePostDto, options?: any): AxiosPromise<object> {
            return localVarFp.createOneBasePostControllerPost(createPostDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Delete a single Post
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOneBasePostControllerPost(id: string, options?: any): AxiosPromise<object> {
            return localVarFp.deleteOneBasePostControllerPost(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Retrieve multiple Posts
         * @param {Array<string>} [fields] Selects resource fields. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#select\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {string} [s] Adds search condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#search\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {Array<string>} [filter] Adds filter condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#filter\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {Array<string>} [or] Adds OR condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#or\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {Array<string>} [sort] Adds sort by field. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#sort\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {Array<string>} [join] Adds relational resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#join\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {number} [limit] Limit amount of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#limit\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {number} [offset] Offset amount of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#offset\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {number} [page] Page portion of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#page\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {number} [cache] Reset cache (if was enabled). &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#cache\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getManyBasePostControllerPost(fields?: Array<string>, s?: string, filter?: Array<string>, or?: Array<string>, sort?: Array<string>, join?: Array<string>, limit?: number, offset?: number, page?: number, cache?: number, options?: any): AxiosPromise<GetManyPostResponseDto> {
            return localVarFp.getManyBasePostControllerPost(fields, s, filter, or, sort, join, limit, offset, page, cache, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Retrieve a single Post
         * @param {string} id 
         * @param {Array<string>} [fields] Selects resource fields. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#select\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {Array<string>} [join] Adds relational resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#join\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {number} [cache] Reset cache (if was enabled). &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#cache\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOneBasePostControllerPost(id: string, fields?: Array<string>, join?: Array<string>, cache?: number, options?: any): AxiosPromise<GetPostDto> {
            return localVarFp.getOneBasePostControllerPost(id, fields, join, cache, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {any} [locale] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postControllerGetFeed(locale?: any, options?: any): AxiosPromise<void> {
            return localVarFp.postControllerGetFeed(locale, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Replace a single Post
         * @param {string} id 
         * @param {UpdatePostDto} updatePostDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        replaceOneBasePostControllerPost(id: string, updatePostDto: UpdatePostDto, options?: any): AxiosPromise<object> {
            return localVarFp.replaceOneBasePostControllerPost(id, updatePostDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update a single Post
         * @param {string} id 
         * @param {UpdatePostDto} updatePostDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateOneBasePostControllerPost(id: string, updatePostDto: UpdatePostDto, options?: any): AxiosPromise<object> {
            return localVarFp.updateOneBasePostControllerPost(id, updatePostDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * PostApi - object-oriented interface
 * @export
 * @class PostApi
 * @extends {BaseAPI}
 */
export class PostApi extends BaseAPI {
    /**
     * 
     * @summary Create multiple Posts
     * @param {CreateManyPostDto} createManyPostDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PostApi
     */
    public createManyBasePostControllerPost(createManyPostDto: CreateManyPostDto, options?: AxiosRequestConfig) {
        return PostApiFp(this.configuration).createManyBasePostControllerPost(createManyPostDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Create a single Post
     * @param {CreatePostDto} createPostDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PostApi
     */
    public createOneBasePostControllerPost(createPostDto: CreatePostDto, options?: AxiosRequestConfig) {
        return PostApiFp(this.configuration).createOneBasePostControllerPost(createPostDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Delete a single Post
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PostApi
     */
    public deleteOneBasePostControllerPost(id: string, options?: AxiosRequestConfig) {
        return PostApiFp(this.configuration).deleteOneBasePostControllerPost(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Retrieve multiple Posts
     * @param {Array<string>} [fields] Selects resource fields. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#select\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param {string} [s] Adds search condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#search\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param {Array<string>} [filter] Adds filter condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#filter\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param {Array<string>} [or] Adds OR condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#or\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param {Array<string>} [sort] Adds sort by field. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#sort\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param {Array<string>} [join] Adds relational resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#join\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param {number} [limit] Limit amount of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#limit\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param {number} [offset] Offset amount of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#offset\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param {number} [page] Page portion of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#page\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param {number} [cache] Reset cache (if was enabled). &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#cache\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PostApi
     */
    public getManyBasePostControllerPost(fields?: Array<string>, s?: string, filter?: Array<string>, or?: Array<string>, sort?: Array<string>, join?: Array<string>, limit?: number, offset?: number, page?: number, cache?: number, options?: AxiosRequestConfig) {
        return PostApiFp(this.configuration).getManyBasePostControllerPost(fields, s, filter, or, sort, join, limit, offset, page, cache, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Retrieve a single Post
     * @param {string} id 
     * @param {Array<string>} [fields] Selects resource fields. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#select\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param {Array<string>} [join] Adds relational resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#join\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param {number} [cache] Reset cache (if was enabled). &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#cache\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PostApi
     */
    public getOneBasePostControllerPost(id: string, fields?: Array<string>, join?: Array<string>, cache?: number, options?: AxiosRequestConfig) {
        return PostApiFp(this.configuration).getOneBasePostControllerPost(id, fields, join, cache, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {any} [locale] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PostApi
     */
    public postControllerGetFeed(locale?: any, options?: AxiosRequestConfig) {
        return PostApiFp(this.configuration).postControllerGetFeed(locale, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Replace a single Post
     * @param {string} id 
     * @param {UpdatePostDto} updatePostDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PostApi
     */
    public replaceOneBasePostControllerPost(id: string, updatePostDto: UpdatePostDto, options?: AxiosRequestConfig) {
        return PostApiFp(this.configuration).replaceOneBasePostControllerPost(id, updatePostDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update a single Post
     * @param {string} id 
     * @param {UpdatePostDto} updatePostDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PostApi
     */
    public updateOneBasePostControllerPost(id: string, updatePostDto: UpdatePostDto, options?: AxiosRequestConfig) {
        return PostApiFp(this.configuration).updateOneBasePostControllerPost(id, updatePostDto, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * PricingApi - axios parameter creator
 * @export
 */
export const PricingApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Calculate price for photos and products
         * @param {CalculatePriceDto} calculatePriceDto Data for calculating the price
         * @param {string} [xClientChannel] Client channel; the exact value \&#39;MOBILE\&#39; prices the preview down the app\&#39;s own chain. Anything else (or absent) prices all-channels.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pricingControllerCalculatePrice: async (calculatePriceDto: CalculatePriceDto, xClientChannel?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'calculatePriceDto' is not null or undefined
            assertParamExists('pricingControllerCalculatePrice', 'calculatePriceDto', calculatePriceDto)
            const localVarPath = `/pricing/calculate`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (xClientChannel != null) {
                localVarHeaderParameter['x-client-channel'] = String(xClientChannel);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(calculatePriceDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary All shipping rates + photo options for every supported country/currency in one call (web bootstrap; avoids an N+1 of per-country / per-currency requests)
         * @param {string} [xClientChannel] Client channel; the exact value \&#39;MOBILE\&#39; seeds the tables with the app\&#39;s own rows.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pricingControllerGetBootstrap: async (xClientChannel?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/pricing/bootstrap`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (xClientChannel != null) {
                localVarHeaderParameter['x-client-channel'] = String(xClientChannel);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get the catalog of additional photo options with pricing metadata
         * @param {string} currency 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pricingControllerGetPhotoOptions: async (currency: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'currency' is not null or undefined
            assertParamExists('pricingControllerGetPhotoOptions', 'currency', currency)
            const localVarPath = `/pricing/photo-options`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (currency !== undefined) {
                localVarQueryParameter['currency'] = currency;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get shipping rate table for a country (single source of truth for web + mobile)
         * @param {string} country 
         * @param {string} currency 
         * @param {string} [xClientChannel] Client channel; the exact value \&#39;MOBILE\&#39; quotes the app\&#39;s own rows. Anything else (or absent) quotes the all-channels prices.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pricingControllerGetShippingRates: async (country: string, currency: string, xClientChannel?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'country' is not null or undefined
            assertParamExists('pricingControllerGetShippingRates', 'country', country)
            // verify required parameter 'currency' is not null or undefined
            assertParamExists('pricingControllerGetShippingRates', 'currency', currency)
            const localVarPath = `/pricing/shipping`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (country !== undefined) {
                localVarQueryParameter['country'] = country;
            }

            if (currency !== undefined) {
                localVarQueryParameter['currency'] = currency;
            }

            if (xClientChannel != null) {
                localVarHeaderParameter['x-client-channel'] = String(xClientChannel);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * PricingApi - functional programming interface
 * @export
 */
export const PricingApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = PricingApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Calculate price for photos and products
         * @param {CalculatePriceDto} calculatePriceDto Data for calculating the price
         * @param {string} [xClientChannel] Client channel; the exact value \&#39;MOBILE\&#39; prices the preview down the app\&#39;s own chain. Anything else (or absent) prices all-channels.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async pricingControllerCalculatePrice(calculatePriceDto: CalculatePriceDto, xClientChannel?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PriceCalculationResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.pricingControllerCalculatePrice(calculatePriceDto, xClientChannel, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary All shipping rates + photo options for every supported country/currency in one call (web bootstrap; avoids an N+1 of per-country / per-currency requests)
         * @param {string} [xClientChannel] Client channel; the exact value \&#39;MOBILE\&#39; seeds the tables with the app\&#39;s own rows.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async pricingControllerGetBootstrap(xClientChannel?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PricingBootstrapResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.pricingControllerGetBootstrap(xClientChannel, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get the catalog of additional photo options with pricing metadata
         * @param {string} currency 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async pricingControllerGetPhotoOptions(currency: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PhotoOptionsResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.pricingControllerGetPhotoOptions(currency, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get shipping rate table for a country (single source of truth for web + mobile)
         * @param {string} country 
         * @param {string} currency 
         * @param {string} [xClientChannel] Client channel; the exact value \&#39;MOBILE\&#39; quotes the app\&#39;s own rows. Anything else (or absent) quotes the all-channels prices.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async pricingControllerGetShippingRates(country: string, currency: string, xClientChannel?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ShippingRatesResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.pricingControllerGetShippingRates(country, currency, xClientChannel, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * PricingApi - factory interface
 * @export
 */
export const PricingApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = PricingApiFp(configuration)
    return {
        /**
         * 
         * @summary Calculate price for photos and products
         * @param {CalculatePriceDto} calculatePriceDto Data for calculating the price
         * @param {string} [xClientChannel] Client channel; the exact value \&#39;MOBILE\&#39; prices the preview down the app\&#39;s own chain. Anything else (or absent) prices all-channels.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pricingControllerCalculatePrice(calculatePriceDto: CalculatePriceDto, xClientChannel?: string, options?: any): AxiosPromise<PriceCalculationResponseDto> {
            return localVarFp.pricingControllerCalculatePrice(calculatePriceDto, xClientChannel, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary All shipping rates + photo options for every supported country/currency in one call (web bootstrap; avoids an N+1 of per-country / per-currency requests)
         * @param {string} [xClientChannel] Client channel; the exact value \&#39;MOBILE\&#39; seeds the tables with the app\&#39;s own rows.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pricingControllerGetBootstrap(xClientChannel?: string, options?: any): AxiosPromise<PricingBootstrapResponseDto> {
            return localVarFp.pricingControllerGetBootstrap(xClientChannel, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get the catalog of additional photo options with pricing metadata
         * @param {string} currency 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pricingControllerGetPhotoOptions(currency: string, options?: any): AxiosPromise<PhotoOptionsResponseDto> {
            return localVarFp.pricingControllerGetPhotoOptions(currency, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get shipping rate table for a country (single source of truth for web + mobile)
         * @param {string} country 
         * @param {string} currency 
         * @param {string} [xClientChannel] Client channel; the exact value \&#39;MOBILE\&#39; quotes the app\&#39;s own rows. Anything else (or absent) quotes the all-channels prices.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pricingControllerGetShippingRates(country: string, currency: string, xClientChannel?: string, options?: any): AxiosPromise<ShippingRatesResponseDto> {
            return localVarFp.pricingControllerGetShippingRates(country, currency, xClientChannel, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * PricingApi - object-oriented interface
 * @export
 * @class PricingApi
 * @extends {BaseAPI}
 */
export class PricingApi extends BaseAPI {
    /**
     * 
     * @summary Calculate price for photos and products
     * @param {CalculatePriceDto} calculatePriceDto Data for calculating the price
     * @param {string} [xClientChannel] Client channel; the exact value \&#39;MOBILE\&#39; prices the preview down the app\&#39;s own chain. Anything else (or absent) prices all-channels.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PricingApi
     */
    public pricingControllerCalculatePrice(calculatePriceDto: CalculatePriceDto, xClientChannel?: string, options?: AxiosRequestConfig) {
        return PricingApiFp(this.configuration).pricingControllerCalculatePrice(calculatePriceDto, xClientChannel, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary All shipping rates + photo options for every supported country/currency in one call (web bootstrap; avoids an N+1 of per-country / per-currency requests)
     * @param {string} [xClientChannel] Client channel; the exact value \&#39;MOBILE\&#39; seeds the tables with the app\&#39;s own rows.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PricingApi
     */
    public pricingControllerGetBootstrap(xClientChannel?: string, options?: AxiosRequestConfig) {
        return PricingApiFp(this.configuration).pricingControllerGetBootstrap(xClientChannel, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get the catalog of additional photo options with pricing metadata
     * @param {string} currency 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PricingApi
     */
    public pricingControllerGetPhotoOptions(currency: string, options?: AxiosRequestConfig) {
        return PricingApiFp(this.configuration).pricingControllerGetPhotoOptions(currency, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get shipping rate table for a country (single source of truth for web + mobile)
     * @param {string} country 
     * @param {string} currency 
     * @param {string} [xClientChannel] Client channel; the exact value \&#39;MOBILE\&#39; quotes the app\&#39;s own rows. Anything else (or absent) quotes the all-channels prices.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PricingApi
     */
    public pricingControllerGetShippingRates(country: string, currency: string, xClientChannel?: string, options?: AxiosRequestConfig) {
        return PricingApiFp(this.configuration).pricingControllerGetShippingRates(country, currency, xClientChannel, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * PricingOverrideApi - axios parameter creator
 * @export
 */
export const PricingOverrideApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Record a service-price override. Always appends — this endpoint never updates or deletes. Send valueCents: null to revert a slot to its default.
         * @param {CreatePricingOverrideDto} createPricingOverrideDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pricingOverrideControllerCreate: async (createPricingOverrideDto: CreatePricingOverrideDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createPricingOverrideDto' is not null or undefined
            assertParamExists('pricingOverrideControllerCreate', 'createPricingOverrideDto', createPricingOverrideDto)
            const localVarPath = `/pricing-override`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createPricingOverrideDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Every pricing decision, newest first.
         * @param {string} limit 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pricingOverrideControllerHistory: async (limit: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'limit' is not null or undefined
            assertParamExists('pricingOverrideControllerHistory', 'limit', limit)
            const localVarPath = `/pricing-override/history`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * PricingOverrideApi - functional programming interface
 * @export
 */
export const PricingOverrideApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = PricingOverrideApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Record a service-price override. Always appends — this endpoint never updates or deletes. Send valueCents: null to revert a slot to its default.
         * @param {CreatePricingOverrideDto} createPricingOverrideDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async pricingOverrideControllerCreate(createPricingOverrideDto: CreatePricingOverrideDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.pricingOverrideControllerCreate(createPricingOverrideDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Every pricing decision, newest first.
         * @param {string} limit 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async pricingOverrideControllerHistory(limit: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.pricingOverrideControllerHistory(limit, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * PricingOverrideApi - factory interface
 * @export
 */
export const PricingOverrideApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = PricingOverrideApiFp(configuration)
    return {
        /**
         * 
         * @summary Record a service-price override. Always appends — this endpoint never updates or deletes. Send valueCents: null to revert a slot to its default.
         * @param {CreatePricingOverrideDto} createPricingOverrideDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pricingOverrideControllerCreate(createPricingOverrideDto: CreatePricingOverrideDto, options?: any): AxiosPromise<void> {
            return localVarFp.pricingOverrideControllerCreate(createPricingOverrideDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Every pricing decision, newest first.
         * @param {string} limit 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pricingOverrideControllerHistory(limit: string, options?: any): AxiosPromise<void> {
            return localVarFp.pricingOverrideControllerHistory(limit, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * PricingOverrideApi - object-oriented interface
 * @export
 * @class PricingOverrideApi
 * @extends {BaseAPI}
 */
export class PricingOverrideApi extends BaseAPI {
    /**
     * 
     * @summary Record a service-price override. Always appends — this endpoint never updates or deletes. Send valueCents: null to revert a slot to its default.
     * @param {CreatePricingOverrideDto} createPricingOverrideDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PricingOverrideApi
     */
    public pricingOverrideControllerCreate(createPricingOverrideDto: CreatePricingOverrideDto, options?: AxiosRequestConfig) {
        return PricingOverrideApiFp(this.configuration).pricingOverrideControllerCreate(createPricingOverrideDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Every pricing decision, newest first.
     * @param {string} limit 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PricingOverrideApi
     */
    public pricingOverrideControllerHistory(limit: string, options?: AxiosRequestConfig) {
        return PricingOverrideApiFp(this.configuration).pricingOverrideControllerHistory(limit, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * ProductApi - axios parameter creator
 * @export
 */
export const ProductApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Create multiple Products
         * @param {CreateManyProductDto} createManyProductDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createManyBaseProductControllerProduct: async (createManyProductDto: CreateManyProductDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createManyProductDto' is not null or undefined
            assertParamExists('createManyBaseProductControllerProduct', 'createManyProductDto', createManyProductDto)
            const localVarPath = `/product/bulk`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createManyProductDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Create a single Product
         * @param {CreateProductDto} createProductDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createOneBaseProductControllerProduct: async (createProductDto: CreateProductDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createProductDto' is not null or undefined
            assertParamExists('createOneBaseProductControllerProduct', 'createProductDto', createProductDto)
            const localVarPath = `/product`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createProductDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Delete a single Product
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOneBaseProductControllerProduct: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('deleteOneBaseProductControllerProduct', 'id', id)
            const localVarPath = `/product/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Retrieve multiple Products
         * @param {Array<string>} [fields] Selects resource fields. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#select\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {string} [s] Adds search condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#search\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {Array<string>} [filter] Adds filter condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#filter\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {Array<string>} [or] Adds OR condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#or\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {Array<string>} [sort] Adds sort by field. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#sort\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {Array<string>} [join] Adds relational resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#join\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {number} [limit] Limit amount of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#limit\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {number} [offset] Offset amount of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#offset\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {number} [page] Page portion of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#page\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {number} [cache] Reset cache (if was enabled). &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#cache\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getManyBaseProductControllerProduct: async (fields?: Array<string>, s?: string, filter?: Array<string>, or?: Array<string>, sort?: Array<string>, join?: Array<string>, limit?: number, offset?: number, page?: number, cache?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/product`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (fields) {
                localVarQueryParameter['fields'] = fields;
            }

            if (s !== undefined) {
                localVarQueryParameter['s'] = s;
            }

            if (filter) {
                localVarQueryParameter['filter'] = filter;
            }

            if (or) {
                localVarQueryParameter['or'] = or;
            }

            if (sort) {
                localVarQueryParameter['sort'] = sort;
            }

            if (join) {
                localVarQueryParameter['join'] = join;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (cache !== undefined) {
                localVarQueryParameter['cache'] = cache;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Retrieve a single Product
         * @param {string} id 
         * @param {Array<string>} [fields] Selects resource fields. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#select\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {Array<string>} [join] Adds relational resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#join\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {number} [cache] Reset cache (if was enabled). &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#cache\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOneBaseProductControllerProduct: async (id: string, fields?: Array<string>, join?: Array<string>, cache?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getOneBaseProductControllerProduct', 'id', id)
            const localVarPath = `/product/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (fields) {
                localVarQueryParameter['fields'] = fields;
            }

            if (join) {
                localVarQueryParameter['join'] = join;
            }

            if (cache !== undefined) {
                localVarQueryParameter['cache'] = cache;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Public: redirect to the product\'s first photo (for emails)
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        productControllerImage: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('productControllerImage', 'id', id)
            const localVarPath = `/product/{id}/image`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Replace a single Product
         * @param {string} id 
         * @param {UpdateProductDto} updateProductDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        replaceOneBaseProductControllerProduct: async (id: string, updateProductDto: UpdateProductDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('replaceOneBaseProductControllerProduct', 'id', id)
            // verify required parameter 'updateProductDto' is not null or undefined
            assertParamExists('replaceOneBaseProductControllerProduct', 'updateProductDto', updateProductDto)
            const localVarPath = `/product/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateProductDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update a single Product
         * @param {string} id 
         * @param {UpdateProductDto} updateProductDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateOneBaseProductControllerProduct: async (id: string, updateProductDto: UpdateProductDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('updateOneBaseProductControllerProduct', 'id', id)
            // verify required parameter 'updateProductDto' is not null or undefined
            assertParamExists('updateOneBaseProductControllerProduct', 'updateProductDto', updateProductDto)
            const localVarPath = `/product/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateProductDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ProductApi - functional programming interface
 * @export
 */
export const ProductApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ProductApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Create multiple Products
         * @param {CreateManyProductDto} createManyProductDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createManyBaseProductControllerProduct(createManyProductDto: CreateManyProductDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<object>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createManyBaseProductControllerProduct(createManyProductDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Create a single Product
         * @param {CreateProductDto} createProductDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createOneBaseProductControllerProduct(createProductDto: CreateProductDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createOneBaseProductControllerProduct(createProductDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Delete a single Product
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteOneBaseProductControllerProduct(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteOneBaseProductControllerProduct(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Retrieve multiple Products
         * @param {Array<string>} [fields] Selects resource fields. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#select\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {string} [s] Adds search condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#search\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {Array<string>} [filter] Adds filter condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#filter\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {Array<string>} [or] Adds OR condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#or\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {Array<string>} [sort] Adds sort by field. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#sort\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {Array<string>} [join] Adds relational resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#join\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {number} [limit] Limit amount of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#limit\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {number} [offset] Offset amount of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#offset\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {number} [page] Page portion of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#page\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {number} [cache] Reset cache (if was enabled). &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#cache\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getManyBaseProductControllerProduct(fields?: Array<string>, s?: string, filter?: Array<string>, or?: Array<string>, sort?: Array<string>, join?: Array<string>, limit?: number, offset?: number, page?: number, cache?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetManyProductResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getManyBaseProductControllerProduct(fields, s, filter, or, sort, join, limit, offset, page, cache, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Retrieve a single Product
         * @param {string} id 
         * @param {Array<string>} [fields] Selects resource fields. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#select\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {Array<string>} [join] Adds relational resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#join\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {number} [cache] Reset cache (if was enabled). &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#cache\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getOneBaseProductControllerProduct(id: string, fields?: Array<string>, join?: Array<string>, cache?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetProductDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getOneBaseProductControllerProduct(id, fields, join, cache, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Public: redirect to the product\'s first photo (for emails)
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async productControllerImage(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.productControllerImage(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Replace a single Product
         * @param {string} id 
         * @param {UpdateProductDto} updateProductDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async replaceOneBaseProductControllerProduct(id: string, updateProductDto: UpdateProductDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.replaceOneBaseProductControllerProduct(id, updateProductDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Update a single Product
         * @param {string} id 
         * @param {UpdateProductDto} updateProductDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateOneBaseProductControllerProduct(id: string, updateProductDto: UpdateProductDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateOneBaseProductControllerProduct(id, updateProductDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * ProductApi - factory interface
 * @export
 */
export const ProductApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ProductApiFp(configuration)
    return {
        /**
         * 
         * @summary Create multiple Products
         * @param {CreateManyProductDto} createManyProductDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createManyBaseProductControllerProduct(createManyProductDto: CreateManyProductDto, options?: any): AxiosPromise<Array<object>> {
            return localVarFp.createManyBaseProductControllerProduct(createManyProductDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Create a single Product
         * @param {CreateProductDto} createProductDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createOneBaseProductControllerProduct(createProductDto: CreateProductDto, options?: any): AxiosPromise<object> {
            return localVarFp.createOneBaseProductControllerProduct(createProductDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Delete a single Product
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOneBaseProductControllerProduct(id: string, options?: any): AxiosPromise<object> {
            return localVarFp.deleteOneBaseProductControllerProduct(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Retrieve multiple Products
         * @param {Array<string>} [fields] Selects resource fields. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#select\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {string} [s] Adds search condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#search\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {Array<string>} [filter] Adds filter condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#filter\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {Array<string>} [or] Adds OR condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#or\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {Array<string>} [sort] Adds sort by field. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#sort\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {Array<string>} [join] Adds relational resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#join\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {number} [limit] Limit amount of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#limit\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {number} [offset] Offset amount of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#offset\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {number} [page] Page portion of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#page\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {number} [cache] Reset cache (if was enabled). &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#cache\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getManyBaseProductControllerProduct(fields?: Array<string>, s?: string, filter?: Array<string>, or?: Array<string>, sort?: Array<string>, join?: Array<string>, limit?: number, offset?: number, page?: number, cache?: number, options?: any): AxiosPromise<GetManyProductResponseDto> {
            return localVarFp.getManyBaseProductControllerProduct(fields, s, filter, or, sort, join, limit, offset, page, cache, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Retrieve a single Product
         * @param {string} id 
         * @param {Array<string>} [fields] Selects resource fields. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#select\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {Array<string>} [join] Adds relational resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#join\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {number} [cache] Reset cache (if was enabled). &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#cache\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOneBaseProductControllerProduct(id: string, fields?: Array<string>, join?: Array<string>, cache?: number, options?: any): AxiosPromise<GetProductDto> {
            return localVarFp.getOneBaseProductControllerProduct(id, fields, join, cache, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Public: redirect to the product\'s first photo (for emails)
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        productControllerImage(id: string, options?: any): AxiosPromise<void> {
            return localVarFp.productControllerImage(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Replace a single Product
         * @param {string} id 
         * @param {UpdateProductDto} updateProductDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        replaceOneBaseProductControllerProduct(id: string, updateProductDto: UpdateProductDto, options?: any): AxiosPromise<object> {
            return localVarFp.replaceOneBaseProductControllerProduct(id, updateProductDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update a single Product
         * @param {string} id 
         * @param {UpdateProductDto} updateProductDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateOneBaseProductControllerProduct(id: string, updateProductDto: UpdateProductDto, options?: any): AxiosPromise<object> {
            return localVarFp.updateOneBaseProductControllerProduct(id, updateProductDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ProductApi - object-oriented interface
 * @export
 * @class ProductApi
 * @extends {BaseAPI}
 */
export class ProductApi extends BaseAPI {
    /**
     * 
     * @summary Create multiple Products
     * @param {CreateManyProductDto} createManyProductDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductApi
     */
    public createManyBaseProductControllerProduct(createManyProductDto: CreateManyProductDto, options?: AxiosRequestConfig) {
        return ProductApiFp(this.configuration).createManyBaseProductControllerProduct(createManyProductDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Create a single Product
     * @param {CreateProductDto} createProductDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductApi
     */
    public createOneBaseProductControllerProduct(createProductDto: CreateProductDto, options?: AxiosRequestConfig) {
        return ProductApiFp(this.configuration).createOneBaseProductControllerProduct(createProductDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Delete a single Product
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductApi
     */
    public deleteOneBaseProductControllerProduct(id: string, options?: AxiosRequestConfig) {
        return ProductApiFp(this.configuration).deleteOneBaseProductControllerProduct(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Retrieve multiple Products
     * @param {Array<string>} [fields] Selects resource fields. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#select\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param {string} [s] Adds search condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#search\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param {Array<string>} [filter] Adds filter condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#filter\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param {Array<string>} [or] Adds OR condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#or\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param {Array<string>} [sort] Adds sort by field. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#sort\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param {Array<string>} [join] Adds relational resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#join\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param {number} [limit] Limit amount of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#limit\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param {number} [offset] Offset amount of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#offset\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param {number} [page] Page portion of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#page\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param {number} [cache] Reset cache (if was enabled). &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#cache\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductApi
     */
    public getManyBaseProductControllerProduct(fields?: Array<string>, s?: string, filter?: Array<string>, or?: Array<string>, sort?: Array<string>, join?: Array<string>, limit?: number, offset?: number, page?: number, cache?: number, options?: AxiosRequestConfig) {
        return ProductApiFp(this.configuration).getManyBaseProductControllerProduct(fields, s, filter, or, sort, join, limit, offset, page, cache, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Retrieve a single Product
     * @param {string} id 
     * @param {Array<string>} [fields] Selects resource fields. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#select\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param {Array<string>} [join] Adds relational resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#join\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param {number} [cache] Reset cache (if was enabled). &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#cache\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductApi
     */
    public getOneBaseProductControllerProduct(id: string, fields?: Array<string>, join?: Array<string>, cache?: number, options?: AxiosRequestConfig) {
        return ProductApiFp(this.configuration).getOneBaseProductControllerProduct(id, fields, join, cache, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Public: redirect to the product\'s first photo (for emails)
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductApi
     */
    public productControllerImage(id: string, options?: AxiosRequestConfig) {
        return ProductApiFp(this.configuration).productControllerImage(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Replace a single Product
     * @param {string} id 
     * @param {UpdateProductDto} updateProductDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductApi
     */
    public replaceOneBaseProductControllerProduct(id: string, updateProductDto: UpdateProductDto, options?: AxiosRequestConfig) {
        return ProductApiFp(this.configuration).replaceOneBaseProductControllerProduct(id, updateProductDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update a single Product
     * @param {string} id 
     * @param {UpdateProductDto} updateProductDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductApi
     */
    public updateOneBaseProductControllerProduct(id: string, updateProductDto: UpdateProductDto, options?: AxiosRequestConfig) {
        return ProductApiFp(this.configuration).updateOneBaseProductControllerProduct(id, updateProductDto, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * ProductTagApi - axios parameter creator
 * @export
 */
export const ProductTagApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Create multiple ProductTags
         * @param {CreateManyProductTagDto} createManyProductTagDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createManyBaseProductTagControllerProductTag: async (createManyProductTagDto: CreateManyProductTagDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createManyProductTagDto' is not null or undefined
            assertParamExists('createManyBaseProductTagControllerProductTag', 'createManyProductTagDto', createManyProductTagDto)
            const localVarPath = `/product-tag/bulk`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createManyProductTagDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Create a single ProductTag
         * @param {CreateProductTagDto} createProductTagDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createOneBaseProductTagControllerProductTag: async (createProductTagDto: CreateProductTagDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createProductTagDto' is not null or undefined
            assertParamExists('createOneBaseProductTagControllerProductTag', 'createProductTagDto', createProductTagDto)
            const localVarPath = `/product-tag`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createProductTagDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Delete a single ProductTag
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOneBaseProductTagControllerProductTag: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('deleteOneBaseProductTagControllerProductTag', 'id', id)
            const localVarPath = `/product-tag/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Retrieve multiple ProductTags
         * @param {Array<string>} [fields] Selects resource fields. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#select\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {string} [s] Adds search condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#search\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {Array<string>} [filter] Adds filter condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#filter\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {Array<string>} [or] Adds OR condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#or\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {Array<string>} [sort] Adds sort by field. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#sort\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {Array<string>} [join] Adds relational resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#join\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {number} [limit] Limit amount of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#limit\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {number} [offset] Offset amount of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#offset\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {number} [page] Page portion of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#page\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {number} [cache] Reset cache (if was enabled). &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#cache\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getManyBaseProductTagControllerProductTag: async (fields?: Array<string>, s?: string, filter?: Array<string>, or?: Array<string>, sort?: Array<string>, join?: Array<string>, limit?: number, offset?: number, page?: number, cache?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/product-tag`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (fields) {
                localVarQueryParameter['fields'] = fields;
            }

            if (s !== undefined) {
                localVarQueryParameter['s'] = s;
            }

            if (filter) {
                localVarQueryParameter['filter'] = filter;
            }

            if (or) {
                localVarQueryParameter['or'] = or;
            }

            if (sort) {
                localVarQueryParameter['sort'] = sort;
            }

            if (join) {
                localVarQueryParameter['join'] = join;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (cache !== undefined) {
                localVarQueryParameter['cache'] = cache;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Retrieve a single ProductTag
         * @param {string} id 
         * @param {Array<string>} [fields] Selects resource fields. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#select\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {Array<string>} [join] Adds relational resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#join\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {number} [cache] Reset cache (if was enabled). &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#cache\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOneBaseProductTagControllerProductTag: async (id: string, fields?: Array<string>, join?: Array<string>, cache?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getOneBaseProductTagControllerProductTag', 'id', id)
            const localVarPath = `/product-tag/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (fields) {
                localVarQueryParameter['fields'] = fields;
            }

            if (join) {
                localVarQueryParameter['join'] = join;
            }

            if (cache !== undefined) {
                localVarQueryParameter['cache'] = cache;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Replace a single ProductTag
         * @param {string} id 
         * @param {UpdateProductTagDto} updateProductTagDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        replaceOneBaseProductTagControllerProductTag: async (id: string, updateProductTagDto: UpdateProductTagDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('replaceOneBaseProductTagControllerProductTag', 'id', id)
            // verify required parameter 'updateProductTagDto' is not null or undefined
            assertParamExists('replaceOneBaseProductTagControllerProductTag', 'updateProductTagDto', updateProductTagDto)
            const localVarPath = `/product-tag/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateProductTagDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update a single ProductTag
         * @param {string} id 
         * @param {UpdateProductTagDto} updateProductTagDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateOneBaseProductTagControllerProductTag: async (id: string, updateProductTagDto: UpdateProductTagDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('updateOneBaseProductTagControllerProductTag', 'id', id)
            // verify required parameter 'updateProductTagDto' is not null or undefined
            assertParamExists('updateOneBaseProductTagControllerProductTag', 'updateProductTagDto', updateProductTagDto)
            const localVarPath = `/product-tag/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateProductTagDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ProductTagApi - functional programming interface
 * @export
 */
export const ProductTagApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ProductTagApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Create multiple ProductTags
         * @param {CreateManyProductTagDto} createManyProductTagDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createManyBaseProductTagControllerProductTag(createManyProductTagDto: CreateManyProductTagDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<object>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createManyBaseProductTagControllerProductTag(createManyProductTagDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Create a single ProductTag
         * @param {CreateProductTagDto} createProductTagDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createOneBaseProductTagControllerProductTag(createProductTagDto: CreateProductTagDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createOneBaseProductTagControllerProductTag(createProductTagDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Delete a single ProductTag
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteOneBaseProductTagControllerProductTag(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteOneBaseProductTagControllerProductTag(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Retrieve multiple ProductTags
         * @param {Array<string>} [fields] Selects resource fields. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#select\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {string} [s] Adds search condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#search\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {Array<string>} [filter] Adds filter condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#filter\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {Array<string>} [or] Adds OR condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#or\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {Array<string>} [sort] Adds sort by field. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#sort\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {Array<string>} [join] Adds relational resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#join\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {number} [limit] Limit amount of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#limit\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {number} [offset] Offset amount of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#offset\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {number} [page] Page portion of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#page\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {number} [cache] Reset cache (if was enabled). &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#cache\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getManyBaseProductTagControllerProductTag(fields?: Array<string>, s?: string, filter?: Array<string>, or?: Array<string>, sort?: Array<string>, join?: Array<string>, limit?: number, offset?: number, page?: number, cache?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetManyProductTagResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getManyBaseProductTagControllerProductTag(fields, s, filter, or, sort, join, limit, offset, page, cache, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Retrieve a single ProductTag
         * @param {string} id 
         * @param {Array<string>} [fields] Selects resource fields. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#select\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {Array<string>} [join] Adds relational resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#join\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {number} [cache] Reset cache (if was enabled). &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#cache\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getOneBaseProductTagControllerProductTag(id: string, fields?: Array<string>, join?: Array<string>, cache?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetProductTagDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getOneBaseProductTagControllerProductTag(id, fields, join, cache, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Replace a single ProductTag
         * @param {string} id 
         * @param {UpdateProductTagDto} updateProductTagDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async replaceOneBaseProductTagControllerProductTag(id: string, updateProductTagDto: UpdateProductTagDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.replaceOneBaseProductTagControllerProductTag(id, updateProductTagDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Update a single ProductTag
         * @param {string} id 
         * @param {UpdateProductTagDto} updateProductTagDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateOneBaseProductTagControllerProductTag(id: string, updateProductTagDto: UpdateProductTagDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateOneBaseProductTagControllerProductTag(id, updateProductTagDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * ProductTagApi - factory interface
 * @export
 */
export const ProductTagApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ProductTagApiFp(configuration)
    return {
        /**
         * 
         * @summary Create multiple ProductTags
         * @param {CreateManyProductTagDto} createManyProductTagDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createManyBaseProductTagControllerProductTag(createManyProductTagDto: CreateManyProductTagDto, options?: any): AxiosPromise<Array<object>> {
            return localVarFp.createManyBaseProductTagControllerProductTag(createManyProductTagDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Create a single ProductTag
         * @param {CreateProductTagDto} createProductTagDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createOneBaseProductTagControllerProductTag(createProductTagDto: CreateProductTagDto, options?: any): AxiosPromise<object> {
            return localVarFp.createOneBaseProductTagControllerProductTag(createProductTagDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Delete a single ProductTag
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOneBaseProductTagControllerProductTag(id: string, options?: any): AxiosPromise<object> {
            return localVarFp.deleteOneBaseProductTagControllerProductTag(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Retrieve multiple ProductTags
         * @param {Array<string>} [fields] Selects resource fields. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#select\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {string} [s] Adds search condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#search\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {Array<string>} [filter] Adds filter condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#filter\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {Array<string>} [or] Adds OR condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#or\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {Array<string>} [sort] Adds sort by field. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#sort\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {Array<string>} [join] Adds relational resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#join\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {number} [limit] Limit amount of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#limit\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {number} [offset] Offset amount of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#offset\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {number} [page] Page portion of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#page\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {number} [cache] Reset cache (if was enabled). &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#cache\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getManyBaseProductTagControllerProductTag(fields?: Array<string>, s?: string, filter?: Array<string>, or?: Array<string>, sort?: Array<string>, join?: Array<string>, limit?: number, offset?: number, page?: number, cache?: number, options?: any): AxiosPromise<GetManyProductTagResponseDto> {
            return localVarFp.getManyBaseProductTagControllerProductTag(fields, s, filter, or, sort, join, limit, offset, page, cache, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Retrieve a single ProductTag
         * @param {string} id 
         * @param {Array<string>} [fields] Selects resource fields. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#select\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {Array<string>} [join] Adds relational resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#join\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {number} [cache] Reset cache (if was enabled). &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#cache\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOneBaseProductTagControllerProductTag(id: string, fields?: Array<string>, join?: Array<string>, cache?: number, options?: any): AxiosPromise<GetProductTagDto> {
            return localVarFp.getOneBaseProductTagControllerProductTag(id, fields, join, cache, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Replace a single ProductTag
         * @param {string} id 
         * @param {UpdateProductTagDto} updateProductTagDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        replaceOneBaseProductTagControllerProductTag(id: string, updateProductTagDto: UpdateProductTagDto, options?: any): AxiosPromise<object> {
            return localVarFp.replaceOneBaseProductTagControllerProductTag(id, updateProductTagDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update a single ProductTag
         * @param {string} id 
         * @param {UpdateProductTagDto} updateProductTagDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateOneBaseProductTagControllerProductTag(id: string, updateProductTagDto: UpdateProductTagDto, options?: any): AxiosPromise<object> {
            return localVarFp.updateOneBaseProductTagControllerProductTag(id, updateProductTagDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ProductTagApi - object-oriented interface
 * @export
 * @class ProductTagApi
 * @extends {BaseAPI}
 */
export class ProductTagApi extends BaseAPI {
    /**
     * 
     * @summary Create multiple ProductTags
     * @param {CreateManyProductTagDto} createManyProductTagDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductTagApi
     */
    public createManyBaseProductTagControllerProductTag(createManyProductTagDto: CreateManyProductTagDto, options?: AxiosRequestConfig) {
        return ProductTagApiFp(this.configuration).createManyBaseProductTagControllerProductTag(createManyProductTagDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Create a single ProductTag
     * @param {CreateProductTagDto} createProductTagDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductTagApi
     */
    public createOneBaseProductTagControllerProductTag(createProductTagDto: CreateProductTagDto, options?: AxiosRequestConfig) {
        return ProductTagApiFp(this.configuration).createOneBaseProductTagControllerProductTag(createProductTagDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Delete a single ProductTag
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductTagApi
     */
    public deleteOneBaseProductTagControllerProductTag(id: string, options?: AxiosRequestConfig) {
        return ProductTagApiFp(this.configuration).deleteOneBaseProductTagControllerProductTag(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Retrieve multiple ProductTags
     * @param {Array<string>} [fields] Selects resource fields. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#select\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param {string} [s] Adds search condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#search\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param {Array<string>} [filter] Adds filter condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#filter\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param {Array<string>} [or] Adds OR condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#or\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param {Array<string>} [sort] Adds sort by field. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#sort\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param {Array<string>} [join] Adds relational resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#join\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param {number} [limit] Limit amount of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#limit\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param {number} [offset] Offset amount of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#offset\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param {number} [page] Page portion of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#page\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param {number} [cache] Reset cache (if was enabled). &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#cache\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductTagApi
     */
    public getManyBaseProductTagControllerProductTag(fields?: Array<string>, s?: string, filter?: Array<string>, or?: Array<string>, sort?: Array<string>, join?: Array<string>, limit?: number, offset?: number, page?: number, cache?: number, options?: AxiosRequestConfig) {
        return ProductTagApiFp(this.configuration).getManyBaseProductTagControllerProductTag(fields, s, filter, or, sort, join, limit, offset, page, cache, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Retrieve a single ProductTag
     * @param {string} id 
     * @param {Array<string>} [fields] Selects resource fields. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#select\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param {Array<string>} [join] Adds relational resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#join\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param {number} [cache] Reset cache (if was enabled). &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#cache\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductTagApi
     */
    public getOneBaseProductTagControllerProductTag(id: string, fields?: Array<string>, join?: Array<string>, cache?: number, options?: AxiosRequestConfig) {
        return ProductTagApiFp(this.configuration).getOneBaseProductTagControllerProductTag(id, fields, join, cache, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Replace a single ProductTag
     * @param {string} id 
     * @param {UpdateProductTagDto} updateProductTagDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductTagApi
     */
    public replaceOneBaseProductTagControllerProductTag(id: string, updateProductTagDto: UpdateProductTagDto, options?: AxiosRequestConfig) {
        return ProductTagApiFp(this.configuration).replaceOneBaseProductTagControllerProductTag(id, updateProductTagDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update a single ProductTag
     * @param {string} id 
     * @param {UpdateProductTagDto} updateProductTagDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductTagApi
     */
    public updateOneBaseProductTagControllerProductTag(id: string, updateProductTagDto: UpdateProductTagDto, options?: AxiosRequestConfig) {
        return ProductTagApiFp(this.configuration).updateOneBaseProductTagControllerProductTag(id, updateProductTagDto, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * ProductWithMediaDefinitionApi - axios parameter creator
 * @export
 */
export const ProductWithMediaDefinitionApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Create multiple ProductWithMediaDefinitions
         * @param {CreateManyProductWithMediaDefinitionDto} createManyProductWithMediaDefinitionDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createManyBaseProductWithMediaDefinitionControllerProductWithMediaDefinition: async (createManyProductWithMediaDefinitionDto: CreateManyProductWithMediaDefinitionDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createManyProductWithMediaDefinitionDto' is not null or undefined
            assertParamExists('createManyBaseProductWithMediaDefinitionControllerProductWithMediaDefinition', 'createManyProductWithMediaDefinitionDto', createManyProductWithMediaDefinitionDto)
            const localVarPath = `/productWithMediaDefinition/bulk`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createManyProductWithMediaDefinitionDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Create a single ProductWithMediaDefinition
         * @param {CreateProductWithMediaDefinitionDto} createProductWithMediaDefinitionDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createOneBaseProductWithMediaDefinitionControllerProductWithMediaDefinition: async (createProductWithMediaDefinitionDto: CreateProductWithMediaDefinitionDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createProductWithMediaDefinitionDto' is not null or undefined
            assertParamExists('createOneBaseProductWithMediaDefinitionControllerProductWithMediaDefinition', 'createProductWithMediaDefinitionDto', createProductWithMediaDefinitionDto)
            const localVarPath = `/productWithMediaDefinition`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createProductWithMediaDefinitionDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Delete a single ProductWithMediaDefinition
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOneBaseProductWithMediaDefinitionControllerProductWithMediaDefinition: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('deleteOneBaseProductWithMediaDefinitionControllerProductWithMediaDefinition', 'id', id)
            const localVarPath = `/productWithMediaDefinition/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Retrieve multiple ProductWithMediaDefinitions
         * @param {Array<string>} [fields] Selects resource fields. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#select\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {string} [s] Adds search condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#search\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {Array<string>} [filter] Adds filter condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#filter\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {Array<string>} [or] Adds OR condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#or\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {Array<string>} [sort] Adds sort by field. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#sort\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {Array<string>} [join] Adds relational resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#join\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {number} [limit] Limit amount of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#limit\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {number} [offset] Offset amount of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#offset\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {number} [page] Page portion of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#page\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {number} [cache] Reset cache (if was enabled). &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#cache\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getManyBaseProductWithMediaDefinitionControllerProductWithMediaDefinition: async (fields?: Array<string>, s?: string, filter?: Array<string>, or?: Array<string>, sort?: Array<string>, join?: Array<string>, limit?: number, offset?: number, page?: number, cache?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/productWithMediaDefinition`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (fields) {
                localVarQueryParameter['fields'] = fields;
            }

            if (s !== undefined) {
                localVarQueryParameter['s'] = s;
            }

            if (filter) {
                localVarQueryParameter['filter'] = filter;
            }

            if (or) {
                localVarQueryParameter['or'] = or;
            }

            if (sort) {
                localVarQueryParameter['sort'] = sort;
            }

            if (join) {
                localVarQueryParameter['join'] = join;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (cache !== undefined) {
                localVarQueryParameter['cache'] = cache;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Retrieve a single ProductWithMediaDefinition
         * @param {string} id 
         * @param {Array<string>} [fields] Selects resource fields. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#select\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {Array<string>} [join] Adds relational resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#join\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {number} [cache] Reset cache (if was enabled). &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#cache\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOneBaseProductWithMediaDefinitionControllerProductWithMediaDefinition: async (id: string, fields?: Array<string>, join?: Array<string>, cache?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getOneBaseProductWithMediaDefinitionControllerProductWithMediaDefinition', 'id', id)
            const localVarPath = `/productWithMediaDefinition/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (fields) {
                localVarQueryParameter['fields'] = fields;
            }

            if (join) {
                localVarQueryParameter['join'] = join;
            }

            if (cache !== undefined) {
                localVarQueryParameter['cache'] = cache;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Replace a single ProductWithMediaDefinition
         * @param {string} id 
         * @param {UpdateProductWithMediaDefinitionDto} updateProductWithMediaDefinitionDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        replaceOneBaseProductWithMediaDefinitionControllerProductWithMediaDefinition: async (id: string, updateProductWithMediaDefinitionDto: UpdateProductWithMediaDefinitionDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('replaceOneBaseProductWithMediaDefinitionControllerProductWithMediaDefinition', 'id', id)
            // verify required parameter 'updateProductWithMediaDefinitionDto' is not null or undefined
            assertParamExists('replaceOneBaseProductWithMediaDefinitionControllerProductWithMediaDefinition', 'updateProductWithMediaDefinitionDto', updateProductWithMediaDefinitionDto)
            const localVarPath = `/productWithMediaDefinition/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateProductWithMediaDefinitionDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update a single ProductWithMediaDefinition
         * @param {string} id 
         * @param {UpdateProductWithMediaDefinitionDto} updateProductWithMediaDefinitionDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateOneBaseProductWithMediaDefinitionControllerProductWithMediaDefinition: async (id: string, updateProductWithMediaDefinitionDto: UpdateProductWithMediaDefinitionDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('updateOneBaseProductWithMediaDefinitionControllerProductWithMediaDefinition', 'id', id)
            // verify required parameter 'updateProductWithMediaDefinitionDto' is not null or undefined
            assertParamExists('updateOneBaseProductWithMediaDefinitionControllerProductWithMediaDefinition', 'updateProductWithMediaDefinitionDto', updateProductWithMediaDefinitionDto)
            const localVarPath = `/productWithMediaDefinition/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateProductWithMediaDefinitionDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ProductWithMediaDefinitionApi - functional programming interface
 * @export
 */
export const ProductWithMediaDefinitionApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ProductWithMediaDefinitionApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Create multiple ProductWithMediaDefinitions
         * @param {CreateManyProductWithMediaDefinitionDto} createManyProductWithMediaDefinitionDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createManyBaseProductWithMediaDefinitionControllerProductWithMediaDefinition(createManyProductWithMediaDefinitionDto: CreateManyProductWithMediaDefinitionDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<object>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createManyBaseProductWithMediaDefinitionControllerProductWithMediaDefinition(createManyProductWithMediaDefinitionDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Create a single ProductWithMediaDefinition
         * @param {CreateProductWithMediaDefinitionDto} createProductWithMediaDefinitionDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createOneBaseProductWithMediaDefinitionControllerProductWithMediaDefinition(createProductWithMediaDefinitionDto: CreateProductWithMediaDefinitionDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createOneBaseProductWithMediaDefinitionControllerProductWithMediaDefinition(createProductWithMediaDefinitionDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Delete a single ProductWithMediaDefinition
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteOneBaseProductWithMediaDefinitionControllerProductWithMediaDefinition(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteOneBaseProductWithMediaDefinitionControllerProductWithMediaDefinition(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Retrieve multiple ProductWithMediaDefinitions
         * @param {Array<string>} [fields] Selects resource fields. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#select\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {string} [s] Adds search condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#search\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {Array<string>} [filter] Adds filter condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#filter\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {Array<string>} [or] Adds OR condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#or\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {Array<string>} [sort] Adds sort by field. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#sort\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {Array<string>} [join] Adds relational resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#join\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {number} [limit] Limit amount of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#limit\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {number} [offset] Offset amount of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#offset\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {number} [page] Page portion of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#page\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {number} [cache] Reset cache (if was enabled). &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#cache\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getManyBaseProductWithMediaDefinitionControllerProductWithMediaDefinition(fields?: Array<string>, s?: string, filter?: Array<string>, or?: Array<string>, sort?: Array<string>, join?: Array<string>, limit?: number, offset?: number, page?: number, cache?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetManyProductWithMediaDefinitionResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getManyBaseProductWithMediaDefinitionControllerProductWithMediaDefinition(fields, s, filter, or, sort, join, limit, offset, page, cache, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Retrieve a single ProductWithMediaDefinition
         * @param {string} id 
         * @param {Array<string>} [fields] Selects resource fields. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#select\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {Array<string>} [join] Adds relational resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#join\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {number} [cache] Reset cache (if was enabled). &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#cache\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getOneBaseProductWithMediaDefinitionControllerProductWithMediaDefinition(id: string, fields?: Array<string>, join?: Array<string>, cache?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getOneBaseProductWithMediaDefinitionControllerProductWithMediaDefinition(id, fields, join, cache, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Replace a single ProductWithMediaDefinition
         * @param {string} id 
         * @param {UpdateProductWithMediaDefinitionDto} updateProductWithMediaDefinitionDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async replaceOneBaseProductWithMediaDefinitionControllerProductWithMediaDefinition(id: string, updateProductWithMediaDefinitionDto: UpdateProductWithMediaDefinitionDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.replaceOneBaseProductWithMediaDefinitionControllerProductWithMediaDefinition(id, updateProductWithMediaDefinitionDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Update a single ProductWithMediaDefinition
         * @param {string} id 
         * @param {UpdateProductWithMediaDefinitionDto} updateProductWithMediaDefinitionDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateOneBaseProductWithMediaDefinitionControllerProductWithMediaDefinition(id: string, updateProductWithMediaDefinitionDto: UpdateProductWithMediaDefinitionDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateOneBaseProductWithMediaDefinitionControllerProductWithMediaDefinition(id, updateProductWithMediaDefinitionDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * ProductWithMediaDefinitionApi - factory interface
 * @export
 */
export const ProductWithMediaDefinitionApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ProductWithMediaDefinitionApiFp(configuration)
    return {
        /**
         * 
         * @summary Create multiple ProductWithMediaDefinitions
         * @param {CreateManyProductWithMediaDefinitionDto} createManyProductWithMediaDefinitionDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createManyBaseProductWithMediaDefinitionControllerProductWithMediaDefinition(createManyProductWithMediaDefinitionDto: CreateManyProductWithMediaDefinitionDto, options?: any): AxiosPromise<Array<object>> {
            return localVarFp.createManyBaseProductWithMediaDefinitionControllerProductWithMediaDefinition(createManyProductWithMediaDefinitionDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Create a single ProductWithMediaDefinition
         * @param {CreateProductWithMediaDefinitionDto} createProductWithMediaDefinitionDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createOneBaseProductWithMediaDefinitionControllerProductWithMediaDefinition(createProductWithMediaDefinitionDto: CreateProductWithMediaDefinitionDto, options?: any): AxiosPromise<object> {
            return localVarFp.createOneBaseProductWithMediaDefinitionControllerProductWithMediaDefinition(createProductWithMediaDefinitionDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Delete a single ProductWithMediaDefinition
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOneBaseProductWithMediaDefinitionControllerProductWithMediaDefinition(id: string, options?: any): AxiosPromise<object> {
            return localVarFp.deleteOneBaseProductWithMediaDefinitionControllerProductWithMediaDefinition(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Retrieve multiple ProductWithMediaDefinitions
         * @param {Array<string>} [fields] Selects resource fields. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#select\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {string} [s] Adds search condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#search\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {Array<string>} [filter] Adds filter condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#filter\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {Array<string>} [or] Adds OR condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#or\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {Array<string>} [sort] Adds sort by field. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#sort\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {Array<string>} [join] Adds relational resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#join\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {number} [limit] Limit amount of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#limit\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {number} [offset] Offset amount of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#offset\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {number} [page] Page portion of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#page\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {number} [cache] Reset cache (if was enabled). &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#cache\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getManyBaseProductWithMediaDefinitionControllerProductWithMediaDefinition(fields?: Array<string>, s?: string, filter?: Array<string>, or?: Array<string>, sort?: Array<string>, join?: Array<string>, limit?: number, offset?: number, page?: number, cache?: number, options?: any): AxiosPromise<GetManyProductWithMediaDefinitionResponseDto> {
            return localVarFp.getManyBaseProductWithMediaDefinitionControllerProductWithMediaDefinition(fields, s, filter, or, sort, join, limit, offset, page, cache, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Retrieve a single ProductWithMediaDefinition
         * @param {string} id 
         * @param {Array<string>} [fields] Selects resource fields. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#select\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {Array<string>} [join] Adds relational resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#join\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {number} [cache] Reset cache (if was enabled). &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#cache\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOneBaseProductWithMediaDefinitionControllerProductWithMediaDefinition(id: string, fields?: Array<string>, join?: Array<string>, cache?: number, options?: any): AxiosPromise<object> {
            return localVarFp.getOneBaseProductWithMediaDefinitionControllerProductWithMediaDefinition(id, fields, join, cache, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Replace a single ProductWithMediaDefinition
         * @param {string} id 
         * @param {UpdateProductWithMediaDefinitionDto} updateProductWithMediaDefinitionDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        replaceOneBaseProductWithMediaDefinitionControllerProductWithMediaDefinition(id: string, updateProductWithMediaDefinitionDto: UpdateProductWithMediaDefinitionDto, options?: any): AxiosPromise<object> {
            return localVarFp.replaceOneBaseProductWithMediaDefinitionControllerProductWithMediaDefinition(id, updateProductWithMediaDefinitionDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update a single ProductWithMediaDefinition
         * @param {string} id 
         * @param {UpdateProductWithMediaDefinitionDto} updateProductWithMediaDefinitionDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateOneBaseProductWithMediaDefinitionControllerProductWithMediaDefinition(id: string, updateProductWithMediaDefinitionDto: UpdateProductWithMediaDefinitionDto, options?: any): AxiosPromise<object> {
            return localVarFp.updateOneBaseProductWithMediaDefinitionControllerProductWithMediaDefinition(id, updateProductWithMediaDefinitionDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ProductWithMediaDefinitionApi - object-oriented interface
 * @export
 * @class ProductWithMediaDefinitionApi
 * @extends {BaseAPI}
 */
export class ProductWithMediaDefinitionApi extends BaseAPI {
    /**
     * 
     * @summary Create multiple ProductWithMediaDefinitions
     * @param {CreateManyProductWithMediaDefinitionDto} createManyProductWithMediaDefinitionDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductWithMediaDefinitionApi
     */
    public createManyBaseProductWithMediaDefinitionControllerProductWithMediaDefinition(createManyProductWithMediaDefinitionDto: CreateManyProductWithMediaDefinitionDto, options?: AxiosRequestConfig) {
        return ProductWithMediaDefinitionApiFp(this.configuration).createManyBaseProductWithMediaDefinitionControllerProductWithMediaDefinition(createManyProductWithMediaDefinitionDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Create a single ProductWithMediaDefinition
     * @param {CreateProductWithMediaDefinitionDto} createProductWithMediaDefinitionDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductWithMediaDefinitionApi
     */
    public createOneBaseProductWithMediaDefinitionControllerProductWithMediaDefinition(createProductWithMediaDefinitionDto: CreateProductWithMediaDefinitionDto, options?: AxiosRequestConfig) {
        return ProductWithMediaDefinitionApiFp(this.configuration).createOneBaseProductWithMediaDefinitionControllerProductWithMediaDefinition(createProductWithMediaDefinitionDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Delete a single ProductWithMediaDefinition
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductWithMediaDefinitionApi
     */
    public deleteOneBaseProductWithMediaDefinitionControllerProductWithMediaDefinition(id: string, options?: AxiosRequestConfig) {
        return ProductWithMediaDefinitionApiFp(this.configuration).deleteOneBaseProductWithMediaDefinitionControllerProductWithMediaDefinition(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Retrieve multiple ProductWithMediaDefinitions
     * @param {Array<string>} [fields] Selects resource fields. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#select\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param {string} [s] Adds search condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#search\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param {Array<string>} [filter] Adds filter condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#filter\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param {Array<string>} [or] Adds OR condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#or\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param {Array<string>} [sort] Adds sort by field. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#sort\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param {Array<string>} [join] Adds relational resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#join\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param {number} [limit] Limit amount of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#limit\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param {number} [offset] Offset amount of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#offset\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param {number} [page] Page portion of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#page\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param {number} [cache] Reset cache (if was enabled). &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#cache\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductWithMediaDefinitionApi
     */
    public getManyBaseProductWithMediaDefinitionControllerProductWithMediaDefinition(fields?: Array<string>, s?: string, filter?: Array<string>, or?: Array<string>, sort?: Array<string>, join?: Array<string>, limit?: number, offset?: number, page?: number, cache?: number, options?: AxiosRequestConfig) {
        return ProductWithMediaDefinitionApiFp(this.configuration).getManyBaseProductWithMediaDefinitionControllerProductWithMediaDefinition(fields, s, filter, or, sort, join, limit, offset, page, cache, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Retrieve a single ProductWithMediaDefinition
     * @param {string} id 
     * @param {Array<string>} [fields] Selects resource fields. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#select\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param {Array<string>} [join] Adds relational resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#join\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param {number} [cache] Reset cache (if was enabled). &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#cache\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductWithMediaDefinitionApi
     */
    public getOneBaseProductWithMediaDefinitionControllerProductWithMediaDefinition(id: string, fields?: Array<string>, join?: Array<string>, cache?: number, options?: AxiosRequestConfig) {
        return ProductWithMediaDefinitionApiFp(this.configuration).getOneBaseProductWithMediaDefinitionControllerProductWithMediaDefinition(id, fields, join, cache, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Replace a single ProductWithMediaDefinition
     * @param {string} id 
     * @param {UpdateProductWithMediaDefinitionDto} updateProductWithMediaDefinitionDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductWithMediaDefinitionApi
     */
    public replaceOneBaseProductWithMediaDefinitionControllerProductWithMediaDefinition(id: string, updateProductWithMediaDefinitionDto: UpdateProductWithMediaDefinitionDto, options?: AxiosRequestConfig) {
        return ProductWithMediaDefinitionApiFp(this.configuration).replaceOneBaseProductWithMediaDefinitionControllerProductWithMediaDefinition(id, updateProductWithMediaDefinitionDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update a single ProductWithMediaDefinition
     * @param {string} id 
     * @param {UpdateProductWithMediaDefinitionDto} updateProductWithMediaDefinitionDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductWithMediaDefinitionApi
     */
    public updateOneBaseProductWithMediaDefinitionControllerProductWithMediaDefinition(id: string, updateProductWithMediaDefinitionDto: UpdateProductWithMediaDefinitionDto, options?: AxiosRequestConfig) {
        return ProductWithMediaDefinitionApiFp(this.configuration).updateOneBaseProductWithMediaDefinitionControllerProductWithMediaDefinition(id, updateProductWithMediaDefinitionDto, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * ProductWithMediaOrderApi - axios parameter creator
 * @export
 */
export const ProductWithMediaOrderApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Create multiple ProductWithMediaOrders
         * @param {CreateManyProductWithMediaOrderDto} createManyProductWithMediaOrderDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createManyBaseProductWithMediaOrderControllerProductWithMediaOrder: async (createManyProductWithMediaOrderDto: CreateManyProductWithMediaOrderDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createManyProductWithMediaOrderDto' is not null or undefined
            assertParamExists('createManyBaseProductWithMediaOrderControllerProductWithMediaOrder', 'createManyProductWithMediaOrderDto', createManyProductWithMediaOrderDto)
            const localVarPath = `/productWithMediaOrder/bulk`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createManyProductWithMediaOrderDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Create a single ProductWithMediaOrder
         * @param {CreateProductWithMediaOrderDto} createProductWithMediaOrderDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createOneBaseProductWithMediaOrderControllerProductWithMediaOrder: async (createProductWithMediaOrderDto: CreateProductWithMediaOrderDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createProductWithMediaOrderDto' is not null or undefined
            assertParamExists('createOneBaseProductWithMediaOrderControllerProductWithMediaOrder', 'createProductWithMediaOrderDto', createProductWithMediaOrderDto)
            const localVarPath = `/productWithMediaOrder`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createProductWithMediaOrderDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Delete a single ProductWithMediaOrder
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOneBaseProductWithMediaOrderControllerProductWithMediaOrder: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('deleteOneBaseProductWithMediaOrderControllerProductWithMediaOrder', 'id', id)
            const localVarPath = `/productWithMediaOrder/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Retrieve multiple ProductWithMediaOrders
         * @param {Array<string>} [fields] Selects resource fields. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#select\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {string} [s] Adds search condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#search\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {Array<string>} [filter] Adds filter condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#filter\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {Array<string>} [or] Adds OR condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#or\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {Array<string>} [sort] Adds sort by field. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#sort\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {Array<string>} [join] Adds relational resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#join\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {number} [limit] Limit amount of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#limit\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {number} [offset] Offset amount of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#offset\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {number} [page] Page portion of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#page\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {number} [cache] Reset cache (if was enabled). &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#cache\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getManyBaseProductWithMediaOrderControllerProductWithMediaOrder: async (fields?: Array<string>, s?: string, filter?: Array<string>, or?: Array<string>, sort?: Array<string>, join?: Array<string>, limit?: number, offset?: number, page?: number, cache?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/productWithMediaOrder`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (fields) {
                localVarQueryParameter['fields'] = fields;
            }

            if (s !== undefined) {
                localVarQueryParameter['s'] = s;
            }

            if (filter) {
                localVarQueryParameter['filter'] = filter;
            }

            if (or) {
                localVarQueryParameter['or'] = or;
            }

            if (sort) {
                localVarQueryParameter['sort'] = sort;
            }

            if (join) {
                localVarQueryParameter['join'] = join;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (cache !== undefined) {
                localVarQueryParameter['cache'] = cache;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Retrieve a single ProductWithMediaOrder
         * @param {string} id 
         * @param {Array<string>} [fields] Selects resource fields. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#select\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {Array<string>} [join] Adds relational resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#join\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {number} [cache] Reset cache (if was enabled). &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#cache\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOneBaseProductWithMediaOrderControllerProductWithMediaOrder: async (id: string, fields?: Array<string>, join?: Array<string>, cache?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getOneBaseProductWithMediaOrderControllerProductWithMediaOrder', 'id', id)
            const localVarPath = `/productWithMediaOrder/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (fields) {
                localVarQueryParameter['fields'] = fields;
            }

            if (join) {
                localVarQueryParameter['join'] = join;
            }

            if (cache !== undefined) {
                localVarQueryParameter['cache'] = cache;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Force a canvas item to re-render
         * @param {string} itemId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        productWithMediaOrderControllerReRender: async (itemId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'itemId' is not null or undefined
            assertParamExists('productWithMediaOrderControllerReRender', 'itemId', itemId)
            const localVarPath = `/productWithMediaOrder/item/{itemId}/re-render`
                .replace(`{${"itemId"}}`, encodeURIComponent(String(itemId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Replace a single ProductWithMediaOrder
         * @param {string} id 
         * @param {object} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        replaceOneBaseProductWithMediaOrderControllerProductWithMediaOrder: async (id: string, body: object, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('replaceOneBaseProductWithMediaOrderControllerProductWithMediaOrder', 'id', id)
            // verify required parameter 'body' is not null or undefined
            assertParamExists('replaceOneBaseProductWithMediaOrderControllerProductWithMediaOrder', 'body', body)
            const localVarPath = `/productWithMediaOrder/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update a single ProductWithMediaOrder
         * @param {string} id 
         * @param {object} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateOneBaseProductWithMediaOrderControllerProductWithMediaOrder: async (id: string, body: object, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('updateOneBaseProductWithMediaOrderControllerProductWithMediaOrder', 'id', id)
            // verify required parameter 'body' is not null or undefined
            assertParamExists('updateOneBaseProductWithMediaOrderControllerProductWithMediaOrder', 'body', body)
            const localVarPath = `/productWithMediaOrder/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ProductWithMediaOrderApi - functional programming interface
 * @export
 */
export const ProductWithMediaOrderApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ProductWithMediaOrderApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Create multiple ProductWithMediaOrders
         * @param {CreateManyProductWithMediaOrderDto} createManyProductWithMediaOrderDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createManyBaseProductWithMediaOrderControllerProductWithMediaOrder(createManyProductWithMediaOrderDto: CreateManyProductWithMediaOrderDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<object>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createManyBaseProductWithMediaOrderControllerProductWithMediaOrder(createManyProductWithMediaOrderDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Create a single ProductWithMediaOrder
         * @param {CreateProductWithMediaOrderDto} createProductWithMediaOrderDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createOneBaseProductWithMediaOrderControllerProductWithMediaOrder(createProductWithMediaOrderDto: CreateProductWithMediaOrderDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createOneBaseProductWithMediaOrderControllerProductWithMediaOrder(createProductWithMediaOrderDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Delete a single ProductWithMediaOrder
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteOneBaseProductWithMediaOrderControllerProductWithMediaOrder(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteOneBaseProductWithMediaOrderControllerProductWithMediaOrder(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Retrieve multiple ProductWithMediaOrders
         * @param {Array<string>} [fields] Selects resource fields. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#select\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {string} [s] Adds search condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#search\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {Array<string>} [filter] Adds filter condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#filter\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {Array<string>} [or] Adds OR condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#or\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {Array<string>} [sort] Adds sort by field. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#sort\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {Array<string>} [join] Adds relational resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#join\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {number} [limit] Limit amount of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#limit\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {number} [offset] Offset amount of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#offset\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {number} [page] Page portion of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#page\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {number} [cache] Reset cache (if was enabled). &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#cache\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getManyBaseProductWithMediaOrderControllerProductWithMediaOrder(fields?: Array<string>, s?: string, filter?: Array<string>, or?: Array<string>, sort?: Array<string>, join?: Array<string>, limit?: number, offset?: number, page?: number, cache?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetManyProductWithMediaOrderResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getManyBaseProductWithMediaOrderControllerProductWithMediaOrder(fields, s, filter, or, sort, join, limit, offset, page, cache, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Retrieve a single ProductWithMediaOrder
         * @param {string} id 
         * @param {Array<string>} [fields] Selects resource fields. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#select\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {Array<string>} [join] Adds relational resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#join\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {number} [cache] Reset cache (if was enabled). &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#cache\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getOneBaseProductWithMediaOrderControllerProductWithMediaOrder(id: string, fields?: Array<string>, join?: Array<string>, cache?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getOneBaseProductWithMediaOrderControllerProductWithMediaOrder(id, fields, join, cache, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Force a canvas item to re-render
         * @param {string} itemId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async productWithMediaOrderControllerReRender(itemId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.productWithMediaOrderControllerReRender(itemId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Replace a single ProductWithMediaOrder
         * @param {string} id 
         * @param {object} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async replaceOneBaseProductWithMediaOrderControllerProductWithMediaOrder(id: string, body: object, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.replaceOneBaseProductWithMediaOrderControllerProductWithMediaOrder(id, body, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Update a single ProductWithMediaOrder
         * @param {string} id 
         * @param {object} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateOneBaseProductWithMediaOrderControllerProductWithMediaOrder(id: string, body: object, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateOneBaseProductWithMediaOrderControllerProductWithMediaOrder(id, body, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * ProductWithMediaOrderApi - factory interface
 * @export
 */
export const ProductWithMediaOrderApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ProductWithMediaOrderApiFp(configuration)
    return {
        /**
         * 
         * @summary Create multiple ProductWithMediaOrders
         * @param {CreateManyProductWithMediaOrderDto} createManyProductWithMediaOrderDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createManyBaseProductWithMediaOrderControllerProductWithMediaOrder(createManyProductWithMediaOrderDto: CreateManyProductWithMediaOrderDto, options?: any): AxiosPromise<Array<object>> {
            return localVarFp.createManyBaseProductWithMediaOrderControllerProductWithMediaOrder(createManyProductWithMediaOrderDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Create a single ProductWithMediaOrder
         * @param {CreateProductWithMediaOrderDto} createProductWithMediaOrderDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createOneBaseProductWithMediaOrderControllerProductWithMediaOrder(createProductWithMediaOrderDto: CreateProductWithMediaOrderDto, options?: any): AxiosPromise<object> {
            return localVarFp.createOneBaseProductWithMediaOrderControllerProductWithMediaOrder(createProductWithMediaOrderDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Delete a single ProductWithMediaOrder
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOneBaseProductWithMediaOrderControllerProductWithMediaOrder(id: string, options?: any): AxiosPromise<object> {
            return localVarFp.deleteOneBaseProductWithMediaOrderControllerProductWithMediaOrder(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Retrieve multiple ProductWithMediaOrders
         * @param {Array<string>} [fields] Selects resource fields. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#select\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {string} [s] Adds search condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#search\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {Array<string>} [filter] Adds filter condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#filter\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {Array<string>} [or] Adds OR condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#or\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {Array<string>} [sort] Adds sort by field. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#sort\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {Array<string>} [join] Adds relational resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#join\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {number} [limit] Limit amount of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#limit\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {number} [offset] Offset amount of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#offset\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {number} [page] Page portion of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#page\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {number} [cache] Reset cache (if was enabled). &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#cache\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getManyBaseProductWithMediaOrderControllerProductWithMediaOrder(fields?: Array<string>, s?: string, filter?: Array<string>, or?: Array<string>, sort?: Array<string>, join?: Array<string>, limit?: number, offset?: number, page?: number, cache?: number, options?: any): AxiosPromise<GetManyProductWithMediaOrderResponseDto> {
            return localVarFp.getManyBaseProductWithMediaOrderControllerProductWithMediaOrder(fields, s, filter, or, sort, join, limit, offset, page, cache, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Retrieve a single ProductWithMediaOrder
         * @param {string} id 
         * @param {Array<string>} [fields] Selects resource fields. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#select\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {Array<string>} [join] Adds relational resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#join\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {number} [cache] Reset cache (if was enabled). &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#cache\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOneBaseProductWithMediaOrderControllerProductWithMediaOrder(id: string, fields?: Array<string>, join?: Array<string>, cache?: number, options?: any): AxiosPromise<object> {
            return localVarFp.getOneBaseProductWithMediaOrderControllerProductWithMediaOrder(id, fields, join, cache, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Force a canvas item to re-render
         * @param {string} itemId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        productWithMediaOrderControllerReRender(itemId: string, options?: any): AxiosPromise<void> {
            return localVarFp.productWithMediaOrderControllerReRender(itemId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Replace a single ProductWithMediaOrder
         * @param {string} id 
         * @param {object} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        replaceOneBaseProductWithMediaOrderControllerProductWithMediaOrder(id: string, body: object, options?: any): AxiosPromise<object> {
            return localVarFp.replaceOneBaseProductWithMediaOrderControllerProductWithMediaOrder(id, body, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update a single ProductWithMediaOrder
         * @param {string} id 
         * @param {object} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateOneBaseProductWithMediaOrderControllerProductWithMediaOrder(id: string, body: object, options?: any): AxiosPromise<object> {
            return localVarFp.updateOneBaseProductWithMediaOrderControllerProductWithMediaOrder(id, body, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ProductWithMediaOrderApi - object-oriented interface
 * @export
 * @class ProductWithMediaOrderApi
 * @extends {BaseAPI}
 */
export class ProductWithMediaOrderApi extends BaseAPI {
    /**
     * 
     * @summary Create multiple ProductWithMediaOrders
     * @param {CreateManyProductWithMediaOrderDto} createManyProductWithMediaOrderDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductWithMediaOrderApi
     */
    public createManyBaseProductWithMediaOrderControllerProductWithMediaOrder(createManyProductWithMediaOrderDto: CreateManyProductWithMediaOrderDto, options?: AxiosRequestConfig) {
        return ProductWithMediaOrderApiFp(this.configuration).createManyBaseProductWithMediaOrderControllerProductWithMediaOrder(createManyProductWithMediaOrderDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Create a single ProductWithMediaOrder
     * @param {CreateProductWithMediaOrderDto} createProductWithMediaOrderDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductWithMediaOrderApi
     */
    public createOneBaseProductWithMediaOrderControllerProductWithMediaOrder(createProductWithMediaOrderDto: CreateProductWithMediaOrderDto, options?: AxiosRequestConfig) {
        return ProductWithMediaOrderApiFp(this.configuration).createOneBaseProductWithMediaOrderControllerProductWithMediaOrder(createProductWithMediaOrderDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Delete a single ProductWithMediaOrder
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductWithMediaOrderApi
     */
    public deleteOneBaseProductWithMediaOrderControllerProductWithMediaOrder(id: string, options?: AxiosRequestConfig) {
        return ProductWithMediaOrderApiFp(this.configuration).deleteOneBaseProductWithMediaOrderControllerProductWithMediaOrder(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Retrieve multiple ProductWithMediaOrders
     * @param {Array<string>} [fields] Selects resource fields. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#select\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param {string} [s] Adds search condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#search\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param {Array<string>} [filter] Adds filter condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#filter\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param {Array<string>} [or] Adds OR condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#or\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param {Array<string>} [sort] Adds sort by field. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#sort\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param {Array<string>} [join] Adds relational resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#join\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param {number} [limit] Limit amount of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#limit\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param {number} [offset] Offset amount of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#offset\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param {number} [page] Page portion of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#page\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param {number} [cache] Reset cache (if was enabled). &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#cache\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductWithMediaOrderApi
     */
    public getManyBaseProductWithMediaOrderControllerProductWithMediaOrder(fields?: Array<string>, s?: string, filter?: Array<string>, or?: Array<string>, sort?: Array<string>, join?: Array<string>, limit?: number, offset?: number, page?: number, cache?: number, options?: AxiosRequestConfig) {
        return ProductWithMediaOrderApiFp(this.configuration).getManyBaseProductWithMediaOrderControllerProductWithMediaOrder(fields, s, filter, or, sort, join, limit, offset, page, cache, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Retrieve a single ProductWithMediaOrder
     * @param {string} id 
     * @param {Array<string>} [fields] Selects resource fields. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#select\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param {Array<string>} [join] Adds relational resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#join\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param {number} [cache] Reset cache (if was enabled). &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#cache\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductWithMediaOrderApi
     */
    public getOneBaseProductWithMediaOrderControllerProductWithMediaOrder(id: string, fields?: Array<string>, join?: Array<string>, cache?: number, options?: AxiosRequestConfig) {
        return ProductWithMediaOrderApiFp(this.configuration).getOneBaseProductWithMediaOrderControllerProductWithMediaOrder(id, fields, join, cache, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Force a canvas item to re-render
     * @param {string} itemId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductWithMediaOrderApi
     */
    public productWithMediaOrderControllerReRender(itemId: string, options?: AxiosRequestConfig) {
        return ProductWithMediaOrderApiFp(this.configuration).productWithMediaOrderControllerReRender(itemId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Replace a single ProductWithMediaOrder
     * @param {string} id 
     * @param {object} body 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductWithMediaOrderApi
     */
    public replaceOneBaseProductWithMediaOrderControllerProductWithMediaOrder(id: string, body: object, options?: AxiosRequestConfig) {
        return ProductWithMediaOrderApiFp(this.configuration).replaceOneBaseProductWithMediaOrderControllerProductWithMediaOrder(id, body, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update a single ProductWithMediaOrder
     * @param {string} id 
     * @param {object} body 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductWithMediaOrderApi
     */
    public updateOneBaseProductWithMediaOrderControllerProductWithMediaOrder(id: string, body: object, options?: AxiosRequestConfig) {
        return ProductWithMediaOrderApiFp(this.configuration).updateOneBaseProductWithMediaOrderControllerProductWithMediaOrder(id, body, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * ProductWithMediaVariantApi - axios parameter creator
 * @export
 */
export const ProductWithMediaVariantApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Create multiple ProductWithMediaVariants
         * @param {CreateManyProductWithMediaVariantDto} createManyProductWithMediaVariantDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createManyBaseProductWithMediaVariantControllerProductWithMediaVariant: async (createManyProductWithMediaVariantDto: CreateManyProductWithMediaVariantDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createManyProductWithMediaVariantDto' is not null or undefined
            assertParamExists('createManyBaseProductWithMediaVariantControllerProductWithMediaVariant', 'createManyProductWithMediaVariantDto', createManyProductWithMediaVariantDto)
            const localVarPath = `/productWithMediaVariant/bulk`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createManyProductWithMediaVariantDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Create a single ProductWithMediaVariant
         * @param {CreateProductWithMediaVariantDto} createProductWithMediaVariantDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createOneBaseProductWithMediaVariantControllerProductWithMediaVariant: async (createProductWithMediaVariantDto: CreateProductWithMediaVariantDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createProductWithMediaVariantDto' is not null or undefined
            assertParamExists('createOneBaseProductWithMediaVariantControllerProductWithMediaVariant', 'createProductWithMediaVariantDto', createProductWithMediaVariantDto)
            const localVarPath = `/productWithMediaVariant`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createProductWithMediaVariantDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Delete a single ProductWithMediaVariant
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOneBaseProductWithMediaVariantControllerProductWithMediaVariant: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('deleteOneBaseProductWithMediaVariantControllerProductWithMediaVariant', 'id', id)
            const localVarPath = `/productWithMediaVariant/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Retrieve multiple ProductWithMediaVariants
         * @param {Array<string>} [fields] Selects resource fields. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#select\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {string} [s] Adds search condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#search\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {Array<string>} [filter] Adds filter condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#filter\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {Array<string>} [or] Adds OR condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#or\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {Array<string>} [sort] Adds sort by field. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#sort\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {Array<string>} [join] Adds relational resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#join\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {number} [limit] Limit amount of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#limit\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {number} [offset] Offset amount of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#offset\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {number} [page] Page portion of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#page\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {number} [cache] Reset cache (if was enabled). &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#cache\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getManyBaseProductWithMediaVariantControllerProductWithMediaVariant: async (fields?: Array<string>, s?: string, filter?: Array<string>, or?: Array<string>, sort?: Array<string>, join?: Array<string>, limit?: number, offset?: number, page?: number, cache?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/productWithMediaVariant`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (fields) {
                localVarQueryParameter['fields'] = fields;
            }

            if (s !== undefined) {
                localVarQueryParameter['s'] = s;
            }

            if (filter) {
                localVarQueryParameter['filter'] = filter;
            }

            if (or) {
                localVarQueryParameter['or'] = or;
            }

            if (sort) {
                localVarQueryParameter['sort'] = sort;
            }

            if (join) {
                localVarQueryParameter['join'] = join;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (cache !== undefined) {
                localVarQueryParameter['cache'] = cache;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Retrieve a single ProductWithMediaVariant
         * @param {string} id 
         * @param {Array<string>} [fields] Selects resource fields. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#select\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {Array<string>} [join] Adds relational resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#join\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {number} [cache] Reset cache (if was enabled). &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#cache\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOneBaseProductWithMediaVariantControllerProductWithMediaVariant: async (id: string, fields?: Array<string>, join?: Array<string>, cache?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getOneBaseProductWithMediaVariantControllerProductWithMediaVariant', 'id', id)
            const localVarPath = `/productWithMediaVariant/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (fields) {
                localVarQueryParameter['fields'] = fields;
            }

            if (join) {
                localVarQueryParameter['join'] = join;
            }

            if (cache !== undefined) {
                localVarQueryParameter['cache'] = cache;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Replace a single ProductWithMediaVariant
         * @param {string} id 
         * @param {UpdateProductWithMediaVariantDto} updateProductWithMediaVariantDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        replaceOneBaseProductWithMediaVariantControllerProductWithMediaVariant: async (id: string, updateProductWithMediaVariantDto: UpdateProductWithMediaVariantDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('replaceOneBaseProductWithMediaVariantControllerProductWithMediaVariant', 'id', id)
            // verify required parameter 'updateProductWithMediaVariantDto' is not null or undefined
            assertParamExists('replaceOneBaseProductWithMediaVariantControllerProductWithMediaVariant', 'updateProductWithMediaVariantDto', updateProductWithMediaVariantDto)
            const localVarPath = `/productWithMediaVariant/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateProductWithMediaVariantDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update a single ProductWithMediaVariant
         * @param {string} id 
         * @param {UpdateProductWithMediaVariantDto} updateProductWithMediaVariantDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateOneBaseProductWithMediaVariantControllerProductWithMediaVariant: async (id: string, updateProductWithMediaVariantDto: UpdateProductWithMediaVariantDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('updateOneBaseProductWithMediaVariantControllerProductWithMediaVariant', 'id', id)
            // verify required parameter 'updateProductWithMediaVariantDto' is not null or undefined
            assertParamExists('updateOneBaseProductWithMediaVariantControllerProductWithMediaVariant', 'updateProductWithMediaVariantDto', updateProductWithMediaVariantDto)
            const localVarPath = `/productWithMediaVariant/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateProductWithMediaVariantDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ProductWithMediaVariantApi - functional programming interface
 * @export
 */
export const ProductWithMediaVariantApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ProductWithMediaVariantApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Create multiple ProductWithMediaVariants
         * @param {CreateManyProductWithMediaVariantDto} createManyProductWithMediaVariantDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createManyBaseProductWithMediaVariantControllerProductWithMediaVariant(createManyProductWithMediaVariantDto: CreateManyProductWithMediaVariantDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<object>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createManyBaseProductWithMediaVariantControllerProductWithMediaVariant(createManyProductWithMediaVariantDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Create a single ProductWithMediaVariant
         * @param {CreateProductWithMediaVariantDto} createProductWithMediaVariantDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createOneBaseProductWithMediaVariantControllerProductWithMediaVariant(createProductWithMediaVariantDto: CreateProductWithMediaVariantDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createOneBaseProductWithMediaVariantControllerProductWithMediaVariant(createProductWithMediaVariantDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Delete a single ProductWithMediaVariant
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteOneBaseProductWithMediaVariantControllerProductWithMediaVariant(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteOneBaseProductWithMediaVariantControllerProductWithMediaVariant(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Retrieve multiple ProductWithMediaVariants
         * @param {Array<string>} [fields] Selects resource fields. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#select\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {string} [s] Adds search condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#search\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {Array<string>} [filter] Adds filter condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#filter\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {Array<string>} [or] Adds OR condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#or\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {Array<string>} [sort] Adds sort by field. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#sort\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {Array<string>} [join] Adds relational resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#join\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {number} [limit] Limit amount of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#limit\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {number} [offset] Offset amount of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#offset\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {number} [page] Page portion of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#page\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {number} [cache] Reset cache (if was enabled). &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#cache\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getManyBaseProductWithMediaVariantControllerProductWithMediaVariant(fields?: Array<string>, s?: string, filter?: Array<string>, or?: Array<string>, sort?: Array<string>, join?: Array<string>, limit?: number, offset?: number, page?: number, cache?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetManyProductWithMediaVariantResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getManyBaseProductWithMediaVariantControllerProductWithMediaVariant(fields, s, filter, or, sort, join, limit, offset, page, cache, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Retrieve a single ProductWithMediaVariant
         * @param {string} id 
         * @param {Array<string>} [fields] Selects resource fields. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#select\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {Array<string>} [join] Adds relational resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#join\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {number} [cache] Reset cache (if was enabled). &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#cache\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getOneBaseProductWithMediaVariantControllerProductWithMediaVariant(id: string, fields?: Array<string>, join?: Array<string>, cache?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getOneBaseProductWithMediaVariantControllerProductWithMediaVariant(id, fields, join, cache, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Replace a single ProductWithMediaVariant
         * @param {string} id 
         * @param {UpdateProductWithMediaVariantDto} updateProductWithMediaVariantDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async replaceOneBaseProductWithMediaVariantControllerProductWithMediaVariant(id: string, updateProductWithMediaVariantDto: UpdateProductWithMediaVariantDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.replaceOneBaseProductWithMediaVariantControllerProductWithMediaVariant(id, updateProductWithMediaVariantDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Update a single ProductWithMediaVariant
         * @param {string} id 
         * @param {UpdateProductWithMediaVariantDto} updateProductWithMediaVariantDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateOneBaseProductWithMediaVariantControllerProductWithMediaVariant(id: string, updateProductWithMediaVariantDto: UpdateProductWithMediaVariantDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateOneBaseProductWithMediaVariantControllerProductWithMediaVariant(id, updateProductWithMediaVariantDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * ProductWithMediaVariantApi - factory interface
 * @export
 */
export const ProductWithMediaVariantApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ProductWithMediaVariantApiFp(configuration)
    return {
        /**
         * 
         * @summary Create multiple ProductWithMediaVariants
         * @param {CreateManyProductWithMediaVariantDto} createManyProductWithMediaVariantDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createManyBaseProductWithMediaVariantControllerProductWithMediaVariant(createManyProductWithMediaVariantDto: CreateManyProductWithMediaVariantDto, options?: any): AxiosPromise<Array<object>> {
            return localVarFp.createManyBaseProductWithMediaVariantControllerProductWithMediaVariant(createManyProductWithMediaVariantDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Create a single ProductWithMediaVariant
         * @param {CreateProductWithMediaVariantDto} createProductWithMediaVariantDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createOneBaseProductWithMediaVariantControllerProductWithMediaVariant(createProductWithMediaVariantDto: CreateProductWithMediaVariantDto, options?: any): AxiosPromise<object> {
            return localVarFp.createOneBaseProductWithMediaVariantControllerProductWithMediaVariant(createProductWithMediaVariantDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Delete a single ProductWithMediaVariant
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOneBaseProductWithMediaVariantControllerProductWithMediaVariant(id: string, options?: any): AxiosPromise<object> {
            return localVarFp.deleteOneBaseProductWithMediaVariantControllerProductWithMediaVariant(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Retrieve multiple ProductWithMediaVariants
         * @param {Array<string>} [fields] Selects resource fields. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#select\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {string} [s] Adds search condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#search\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {Array<string>} [filter] Adds filter condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#filter\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {Array<string>} [or] Adds OR condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#or\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {Array<string>} [sort] Adds sort by field. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#sort\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {Array<string>} [join] Adds relational resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#join\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {number} [limit] Limit amount of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#limit\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {number} [offset] Offset amount of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#offset\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {number} [page] Page portion of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#page\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {number} [cache] Reset cache (if was enabled). &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#cache\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getManyBaseProductWithMediaVariantControllerProductWithMediaVariant(fields?: Array<string>, s?: string, filter?: Array<string>, or?: Array<string>, sort?: Array<string>, join?: Array<string>, limit?: number, offset?: number, page?: number, cache?: number, options?: any): AxiosPromise<GetManyProductWithMediaVariantResponseDto> {
            return localVarFp.getManyBaseProductWithMediaVariantControllerProductWithMediaVariant(fields, s, filter, or, sort, join, limit, offset, page, cache, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Retrieve a single ProductWithMediaVariant
         * @param {string} id 
         * @param {Array<string>} [fields] Selects resource fields. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#select\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {Array<string>} [join] Adds relational resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#join\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {number} [cache] Reset cache (if was enabled). &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#cache\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOneBaseProductWithMediaVariantControllerProductWithMediaVariant(id: string, fields?: Array<string>, join?: Array<string>, cache?: number, options?: any): AxiosPromise<object> {
            return localVarFp.getOneBaseProductWithMediaVariantControllerProductWithMediaVariant(id, fields, join, cache, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Replace a single ProductWithMediaVariant
         * @param {string} id 
         * @param {UpdateProductWithMediaVariantDto} updateProductWithMediaVariantDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        replaceOneBaseProductWithMediaVariantControllerProductWithMediaVariant(id: string, updateProductWithMediaVariantDto: UpdateProductWithMediaVariantDto, options?: any): AxiosPromise<object> {
            return localVarFp.replaceOneBaseProductWithMediaVariantControllerProductWithMediaVariant(id, updateProductWithMediaVariantDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update a single ProductWithMediaVariant
         * @param {string} id 
         * @param {UpdateProductWithMediaVariantDto} updateProductWithMediaVariantDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateOneBaseProductWithMediaVariantControllerProductWithMediaVariant(id: string, updateProductWithMediaVariantDto: UpdateProductWithMediaVariantDto, options?: any): AxiosPromise<object> {
            return localVarFp.updateOneBaseProductWithMediaVariantControllerProductWithMediaVariant(id, updateProductWithMediaVariantDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ProductWithMediaVariantApi - object-oriented interface
 * @export
 * @class ProductWithMediaVariantApi
 * @extends {BaseAPI}
 */
export class ProductWithMediaVariantApi extends BaseAPI {
    /**
     * 
     * @summary Create multiple ProductWithMediaVariants
     * @param {CreateManyProductWithMediaVariantDto} createManyProductWithMediaVariantDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductWithMediaVariantApi
     */
    public createManyBaseProductWithMediaVariantControllerProductWithMediaVariant(createManyProductWithMediaVariantDto: CreateManyProductWithMediaVariantDto, options?: AxiosRequestConfig) {
        return ProductWithMediaVariantApiFp(this.configuration).createManyBaseProductWithMediaVariantControllerProductWithMediaVariant(createManyProductWithMediaVariantDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Create a single ProductWithMediaVariant
     * @param {CreateProductWithMediaVariantDto} createProductWithMediaVariantDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductWithMediaVariantApi
     */
    public createOneBaseProductWithMediaVariantControllerProductWithMediaVariant(createProductWithMediaVariantDto: CreateProductWithMediaVariantDto, options?: AxiosRequestConfig) {
        return ProductWithMediaVariantApiFp(this.configuration).createOneBaseProductWithMediaVariantControllerProductWithMediaVariant(createProductWithMediaVariantDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Delete a single ProductWithMediaVariant
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductWithMediaVariantApi
     */
    public deleteOneBaseProductWithMediaVariantControllerProductWithMediaVariant(id: string, options?: AxiosRequestConfig) {
        return ProductWithMediaVariantApiFp(this.configuration).deleteOneBaseProductWithMediaVariantControllerProductWithMediaVariant(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Retrieve multiple ProductWithMediaVariants
     * @param {Array<string>} [fields] Selects resource fields. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#select\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param {string} [s] Adds search condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#search\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param {Array<string>} [filter] Adds filter condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#filter\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param {Array<string>} [or] Adds OR condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#or\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param {Array<string>} [sort] Adds sort by field. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#sort\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param {Array<string>} [join] Adds relational resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#join\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param {number} [limit] Limit amount of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#limit\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param {number} [offset] Offset amount of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#offset\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param {number} [page] Page portion of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#page\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param {number} [cache] Reset cache (if was enabled). &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#cache\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductWithMediaVariantApi
     */
    public getManyBaseProductWithMediaVariantControllerProductWithMediaVariant(fields?: Array<string>, s?: string, filter?: Array<string>, or?: Array<string>, sort?: Array<string>, join?: Array<string>, limit?: number, offset?: number, page?: number, cache?: number, options?: AxiosRequestConfig) {
        return ProductWithMediaVariantApiFp(this.configuration).getManyBaseProductWithMediaVariantControllerProductWithMediaVariant(fields, s, filter, or, sort, join, limit, offset, page, cache, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Retrieve a single ProductWithMediaVariant
     * @param {string} id 
     * @param {Array<string>} [fields] Selects resource fields. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#select\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param {Array<string>} [join] Adds relational resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#join\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param {number} [cache] Reset cache (if was enabled). &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#cache\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductWithMediaVariantApi
     */
    public getOneBaseProductWithMediaVariantControllerProductWithMediaVariant(id: string, fields?: Array<string>, join?: Array<string>, cache?: number, options?: AxiosRequestConfig) {
        return ProductWithMediaVariantApiFp(this.configuration).getOneBaseProductWithMediaVariantControllerProductWithMediaVariant(id, fields, join, cache, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Replace a single ProductWithMediaVariant
     * @param {string} id 
     * @param {UpdateProductWithMediaVariantDto} updateProductWithMediaVariantDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductWithMediaVariantApi
     */
    public replaceOneBaseProductWithMediaVariantControllerProductWithMediaVariant(id: string, updateProductWithMediaVariantDto: UpdateProductWithMediaVariantDto, options?: AxiosRequestConfig) {
        return ProductWithMediaVariantApiFp(this.configuration).replaceOneBaseProductWithMediaVariantControllerProductWithMediaVariant(id, updateProductWithMediaVariantDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update a single ProductWithMediaVariant
     * @param {string} id 
     * @param {UpdateProductWithMediaVariantDto} updateProductWithMediaVariantDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProductWithMediaVariantApi
     */
    public updateOneBaseProductWithMediaVariantControllerProductWithMediaVariant(id: string, updateProductWithMediaVariantDto: UpdateProductWithMediaVariantDto, options?: AxiosRequestConfig) {
        return ProductWithMediaVariantApiFp(this.configuration).updateOneBaseProductWithMediaVariantControllerProductWithMediaVariant(id, updateProductWithMediaVariantDto, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * PublicUnsubscribeApi - axios parameter creator
 * @export
 */
export const PublicUnsubscribeApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Public unsubscribe handler (token-gated)
         * @param {string} t 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        publicUnsubscribeControllerHandle: async (t: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 't' is not null or undefined
            assertParamExists('publicUnsubscribeControllerHandle', 't', t)
            const localVarPath = `/unsubscribe`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (t !== undefined) {
                localVarQueryParameter['t'] = t;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * PublicUnsubscribeApi - functional programming interface
 * @export
 */
export const PublicUnsubscribeApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = PublicUnsubscribeApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Public unsubscribe handler (token-gated)
         * @param {string} t 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async publicUnsubscribeControllerHandle(t: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.publicUnsubscribeControllerHandle(t, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * PublicUnsubscribeApi - factory interface
 * @export
 */
export const PublicUnsubscribeApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = PublicUnsubscribeApiFp(configuration)
    return {
        /**
         * 
         * @summary Public unsubscribe handler (token-gated)
         * @param {string} t 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        publicUnsubscribeControllerHandle(t: string, options?: any): AxiosPromise<void> {
            return localVarFp.publicUnsubscribeControllerHandle(t, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * PublicUnsubscribeApi - object-oriented interface
 * @export
 * @class PublicUnsubscribeApi
 * @extends {BaseAPI}
 */
export class PublicUnsubscribeApi extends BaseAPI {
    /**
     * 
     * @summary Public unsubscribe handler (token-gated)
     * @param {string} t 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PublicUnsubscribeApi
     */
    public publicUnsubscribeControllerHandle(t: string, options?: AxiosRequestConfig) {
        return PublicUnsubscribeApiFp(this.configuration).publicUnsubscribeControllerHandle(t, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * PushApi - axios parameter creator
 * @export
 */
export const PushApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary How many devices a market would reach
         * @param {string} market 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pushControllerAudienceSize: async (market: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'market' is not null or undefined
            assertParamExists('pushControllerAudienceSize', 'market', market)
            const localVarPath = `/push/audience`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (market !== undefined) {
                localVarQueryParameter['market'] = market;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Send one notification to a market, or to everyone
         * @param {BroadcastPushDto} broadcastPushDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pushControllerBroadcast: async (broadcastPushDto: BroadcastPushDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'broadcastPushDto' is not null or undefined
            assertParamExists('pushControllerBroadcast', 'broadcastPushDto', broadcastPushDto)
            const localVarPath = `/push/broadcast`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(broadcastPushDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * PushApi - functional programming interface
 * @export
 */
export const PushApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = PushApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary How many devices a market would reach
         * @param {string} market 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async pushControllerAudienceSize(market: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.pushControllerAudienceSize(market, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Send one notification to a market, or to everyone
         * @param {BroadcastPushDto} broadcastPushDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async pushControllerBroadcast(broadcastPushDto: BroadcastPushDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.pushControllerBroadcast(broadcastPushDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * PushApi - factory interface
 * @export
 */
export const PushApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = PushApiFp(configuration)
    return {
        /**
         * 
         * @summary How many devices a market would reach
         * @param {string} market 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pushControllerAudienceSize(market: string, options?: any): AxiosPromise<void> {
            return localVarFp.pushControllerAudienceSize(market, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Send one notification to a market, or to everyone
         * @param {BroadcastPushDto} broadcastPushDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pushControllerBroadcast(broadcastPushDto: BroadcastPushDto, options?: any): AxiosPromise<void> {
            return localVarFp.pushControllerBroadcast(broadcastPushDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * PushApi - object-oriented interface
 * @export
 * @class PushApi
 * @extends {BaseAPI}
 */
export class PushApi extends BaseAPI {
    /**
     * 
     * @summary How many devices a market would reach
     * @param {string} market 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PushApi
     */
    public pushControllerAudienceSize(market: string, options?: AxiosRequestConfig) {
        return PushApiFp(this.configuration).pushControllerAudienceSize(market, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Send one notification to a market, or to everyone
     * @param {BroadcastPushDto} broadcastPushDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PushApi
     */
    public pushControllerBroadcast(broadcastPushDto: BroadcastPushDto, options?: AxiosRequestConfig) {
        return PushApiFp(this.configuration).pushControllerBroadcast(broadcastPushDto, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * ScanApi - axios parameter creator
 * @export
 */
export const ScanApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Resolve a scanned code to an order (admin)
         * @param {ResolveScanDto} resolveScanDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        scanControllerResolve: async (resolveScanDto: ResolveScanDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'resolveScanDto' is not null or undefined
            assertParamExists('scanControllerResolve', 'resolveScanDto', resolveScanDto)
            const localVarPath = `/scan/resolve`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(resolveScanDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Set a scanned order’s status (admin)
         * @param {string} id 
         * @param {SetScannedOrderStatusDto} setScannedOrderStatusDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        scanControllerSetStatus: async (id: string, setScannedOrderStatusDto: SetScannedOrderStatusDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('scanControllerSetStatus', 'id', id)
            // verify required parameter 'setScannedOrderStatusDto' is not null or undefined
            assertParamExists('scanControllerSetStatus', 'setScannedOrderStatusDto', setScannedOrderStatusDto)
            const localVarPath = `/scan/order/{id}/status`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(setScannedOrderStatusDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ScanApi - functional programming interface
 * @export
 */
export const ScanApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ScanApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Resolve a scanned code to an order (admin)
         * @param {ResolveScanDto} resolveScanDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async scanControllerResolve(resolveScanDto: ResolveScanDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.scanControllerResolve(resolveScanDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Set a scanned order’s status (admin)
         * @param {string} id 
         * @param {SetScannedOrderStatusDto} setScannedOrderStatusDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async scanControllerSetStatus(id: string, setScannedOrderStatusDto: SetScannedOrderStatusDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.scanControllerSetStatus(id, setScannedOrderStatusDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * ScanApi - factory interface
 * @export
 */
export const ScanApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ScanApiFp(configuration)
    return {
        /**
         * 
         * @summary Resolve a scanned code to an order (admin)
         * @param {ResolveScanDto} resolveScanDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        scanControllerResolve(resolveScanDto: ResolveScanDto, options?: any): AxiosPromise<void> {
            return localVarFp.scanControllerResolve(resolveScanDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Set a scanned order’s status (admin)
         * @param {string} id 
         * @param {SetScannedOrderStatusDto} setScannedOrderStatusDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        scanControllerSetStatus(id: string, setScannedOrderStatusDto: SetScannedOrderStatusDto, options?: any): AxiosPromise<void> {
            return localVarFp.scanControllerSetStatus(id, setScannedOrderStatusDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ScanApi - object-oriented interface
 * @export
 * @class ScanApi
 * @extends {BaseAPI}
 */
export class ScanApi extends BaseAPI {
    /**
     * 
     * @summary Resolve a scanned code to an order (admin)
     * @param {ResolveScanDto} resolveScanDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ScanApi
     */
    public scanControllerResolve(resolveScanDto: ResolveScanDto, options?: AxiosRequestConfig) {
        return ScanApiFp(this.configuration).scanControllerResolve(resolveScanDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Set a scanned order’s status (admin)
     * @param {string} id 
     * @param {SetScannedOrderStatusDto} setScannedOrderStatusDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ScanApi
     */
    public scanControllerSetStatus(id: string, setScannedOrderStatusDto: SetScannedOrderStatusDto, options?: AxiosRequestConfig) {
        return ScanApiFp(this.configuration).scanControllerSetStatus(id, setScannedOrderStatusDto, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * SettingApi - axios parameter creator
 * @export
 */
export const SettingApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary All switches, with defaults marked (admin)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        settingControllerListForAdmin: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/setting/admin`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Server-only numeric settings, with defaults (admin)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        settingControllerListNumbersForAdmin: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/setting/admin/numbers`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Runtime switches the storefront reads
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        settingControllerPublicSettings: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/setting/public`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Throw a switch (admin)
         * @param {string} key 
         * @param {SetSettingDto} setSettingDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        settingControllerSet: async (key: string, setSettingDto: SetSettingDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'key' is not null or undefined
            assertParamExists('settingControllerSet', 'key', key)
            // verify required parameter 'setSettingDto' is not null or undefined
            assertParamExists('settingControllerSet', 'setSettingDto', setSettingDto)
            const localVarPath = `/setting/admin/{key}`
                .replace(`{${"key"}}`, encodeURIComponent(String(key)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(setSettingDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Set a server-only numeric setting (admin)
         * @param {string} key 
         * @param {SetNumberSettingDto} setNumberSettingDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        settingControllerSetNumber: async (key: string, setNumberSettingDto: SetNumberSettingDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'key' is not null or undefined
            assertParamExists('settingControllerSetNumber', 'key', key)
            // verify required parameter 'setNumberSettingDto' is not null or undefined
            assertParamExists('settingControllerSetNumber', 'setNumberSettingDto', setNumberSettingDto)
            const localVarPath = `/setting/admin/numbers/{key}`
                .replace(`{${"key"}}`, encodeURIComponent(String(key)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(setNumberSettingDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * SettingApi - functional programming interface
 * @export
 */
export const SettingApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = SettingApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary All switches, with defaults marked (admin)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async settingControllerListForAdmin(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.settingControllerListForAdmin(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Server-only numeric settings, with defaults (admin)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async settingControllerListNumbersForAdmin(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.settingControllerListNumbersForAdmin(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Runtime switches the storefront reads
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async settingControllerPublicSettings(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.settingControllerPublicSettings(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Throw a switch (admin)
         * @param {string} key 
         * @param {SetSettingDto} setSettingDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async settingControllerSet(key: string, setSettingDto: SetSettingDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.settingControllerSet(key, setSettingDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Set a server-only numeric setting (admin)
         * @param {string} key 
         * @param {SetNumberSettingDto} setNumberSettingDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async settingControllerSetNumber(key: string, setNumberSettingDto: SetNumberSettingDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.settingControllerSetNumber(key, setNumberSettingDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * SettingApi - factory interface
 * @export
 */
export const SettingApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = SettingApiFp(configuration)
    return {
        /**
         * 
         * @summary All switches, with defaults marked (admin)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        settingControllerListForAdmin(options?: any): AxiosPromise<void> {
            return localVarFp.settingControllerListForAdmin(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Server-only numeric settings, with defaults (admin)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        settingControllerListNumbersForAdmin(options?: any): AxiosPromise<void> {
            return localVarFp.settingControllerListNumbersForAdmin(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Runtime switches the storefront reads
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        settingControllerPublicSettings(options?: any): AxiosPromise<void> {
            return localVarFp.settingControllerPublicSettings(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Throw a switch (admin)
         * @param {string} key 
         * @param {SetSettingDto} setSettingDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        settingControllerSet(key: string, setSettingDto: SetSettingDto, options?: any): AxiosPromise<void> {
            return localVarFp.settingControllerSet(key, setSettingDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Set a server-only numeric setting (admin)
         * @param {string} key 
         * @param {SetNumberSettingDto} setNumberSettingDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        settingControllerSetNumber(key: string, setNumberSettingDto: SetNumberSettingDto, options?: any): AxiosPromise<void> {
            return localVarFp.settingControllerSetNumber(key, setNumberSettingDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * SettingApi - object-oriented interface
 * @export
 * @class SettingApi
 * @extends {BaseAPI}
 */
export class SettingApi extends BaseAPI {
    /**
     * 
     * @summary All switches, with defaults marked (admin)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SettingApi
     */
    public settingControllerListForAdmin(options?: AxiosRequestConfig) {
        return SettingApiFp(this.configuration).settingControllerListForAdmin(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Server-only numeric settings, with defaults (admin)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SettingApi
     */
    public settingControllerListNumbersForAdmin(options?: AxiosRequestConfig) {
        return SettingApiFp(this.configuration).settingControllerListNumbersForAdmin(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Runtime switches the storefront reads
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SettingApi
     */
    public settingControllerPublicSettings(options?: AxiosRequestConfig) {
        return SettingApiFp(this.configuration).settingControllerPublicSettings(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Throw a switch (admin)
     * @param {string} key 
     * @param {SetSettingDto} setSettingDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SettingApi
     */
    public settingControllerSet(key: string, setSettingDto: SetSettingDto, options?: AxiosRequestConfig) {
        return SettingApiFp(this.configuration).settingControllerSet(key, setSettingDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Set a server-only numeric setting (admin)
     * @param {string} key 
     * @param {SetNumberSettingDto} setNumberSettingDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SettingApi
     */
    public settingControllerSetNumber(key: string, setNumberSettingDto: SetNumberSettingDto, options?: AxiosRequestConfig) {
        return SettingApiFp(this.configuration).settingControllerSetNumber(key, setNumberSettingDto, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * StripeWebhookApi - axios parameter creator
 * @export
 */
export const StripeWebhookApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} stripeSignature 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        stripeWebhookControllerHandleStripeWebhook: async (stripeSignature: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'stripeSignature' is not null or undefined
            assertParamExists('stripeWebhookControllerHandleStripeWebhook', 'stripeSignature', stripeSignature)
            const localVarPath = `/stripe-webhook`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (stripeSignature != null) {
                localVarHeaderParameter['stripe-signature'] = String(stripeSignature);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * StripeWebhookApi - functional programming interface
 * @export
 */
export const StripeWebhookApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = StripeWebhookApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} stripeSignature 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async stripeWebhookControllerHandleStripeWebhook(stripeSignature: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.stripeWebhookControllerHandleStripeWebhook(stripeSignature, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * StripeWebhookApi - factory interface
 * @export
 */
export const StripeWebhookApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = StripeWebhookApiFp(configuration)
    return {
        /**
         * 
         * @param {string} stripeSignature 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        stripeWebhookControllerHandleStripeWebhook(stripeSignature: string, options?: any): AxiosPromise<void> {
            return localVarFp.stripeWebhookControllerHandleStripeWebhook(stripeSignature, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * StripeWebhookApi - object-oriented interface
 * @export
 * @class StripeWebhookApi
 * @extends {BaseAPI}
 */
export class StripeWebhookApi extends BaseAPI {
    /**
     * 
     * @param {string} stripeSignature 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StripeWebhookApi
     */
    public stripeWebhookControllerHandleStripeWebhook(stripeSignature: string, options?: AxiosRequestConfig) {
        return StripeWebhookApiFp(this.configuration).stripeWebhookControllerHandleStripeWebhook(stripeSignature, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * TemplateApi - axios parameter creator
 * @export
 */
export const TemplateApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Create multiple Templates
         * @param {CreateManyTemplateDto} createManyTemplateDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createManyBaseTemplateControllerTemplate: async (createManyTemplateDto: CreateManyTemplateDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createManyTemplateDto' is not null or undefined
            assertParamExists('createManyBaseTemplateControllerTemplate', 'createManyTemplateDto', createManyTemplateDto)
            const localVarPath = `/template/bulk`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createManyTemplateDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Create a single Template
         * @param {CreateTemplateDto} createTemplateDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createOneBaseTemplateControllerTemplate: async (createTemplateDto: CreateTemplateDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createTemplateDto' is not null or undefined
            assertParamExists('createOneBaseTemplateControllerTemplate', 'createTemplateDto', createTemplateDto)
            const localVarPath = `/template`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createTemplateDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Delete a single Template
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOneBaseTemplateControllerTemplate: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('deleteOneBaseTemplateControllerTemplate', 'id', id)
            const localVarPath = `/template/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Retrieve multiple Templates
         * @param {Array<string>} [fields] Selects resource fields. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#select\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {string} [s] Adds search condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#search\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {Array<string>} [filter] Adds filter condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#filter\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {Array<string>} [or] Adds OR condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#or\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {Array<string>} [sort] Adds sort by field. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#sort\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {Array<string>} [join] Adds relational resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#join\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {number} [limit] Limit amount of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#limit\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {number} [offset] Offset amount of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#offset\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {number} [page] Page portion of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#page\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {number} [cache] Reset cache (if was enabled). &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#cache\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getManyBaseTemplateControllerTemplate: async (fields?: Array<string>, s?: string, filter?: Array<string>, or?: Array<string>, sort?: Array<string>, join?: Array<string>, limit?: number, offset?: number, page?: number, cache?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/template`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (fields) {
                localVarQueryParameter['fields'] = fields;
            }

            if (s !== undefined) {
                localVarQueryParameter['s'] = s;
            }

            if (filter) {
                localVarQueryParameter['filter'] = filter;
            }

            if (or) {
                localVarQueryParameter['or'] = or;
            }

            if (sort) {
                localVarQueryParameter['sort'] = sort;
            }

            if (join) {
                localVarQueryParameter['join'] = join;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (cache !== undefined) {
                localVarQueryParameter['cache'] = cache;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Retrieve a single Template
         * @param {string} id 
         * @param {Array<string>} [fields] Selects resource fields. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#select\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {Array<string>} [join] Adds relational resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#join\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {number} [cache] Reset cache (if was enabled). &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#cache\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOneBaseTemplateControllerTemplate: async (id: string, fields?: Array<string>, join?: Array<string>, cache?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getOneBaseTemplateControllerTemplate', 'id', id)
            const localVarPath = `/template/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (fields) {
                localVarQueryParameter['fields'] = fields;
            }

            if (join) {
                localVarQueryParameter['join'] = join;
            }

            if (cache !== undefined) {
                localVarQueryParameter['cache'] = cache;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Replace a single Template
         * @param {string} id 
         * @param {UpdateTemplateDto} updateTemplateDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        replaceOneBaseTemplateControllerTemplate: async (id: string, updateTemplateDto: UpdateTemplateDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('replaceOneBaseTemplateControllerTemplate', 'id', id)
            // verify required parameter 'updateTemplateDto' is not null or undefined
            assertParamExists('replaceOneBaseTemplateControllerTemplate', 'updateTemplateDto', updateTemplateDto)
            const localVarPath = `/template/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateTemplateDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        templateControllerLibrary: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/template/library`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [kind] 
         * @param {string} [codes] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        templateControllerResolve: async (kind?: string, codes?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/template/resolve`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (kind !== undefined) {
                localVarQueryParameter['kind'] = kind;
            }

            if (codes !== undefined) {
                localVarQueryParameter['codes'] = codes;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update a single Template
         * @param {string} id 
         * @param {UpdateTemplateDto} updateTemplateDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateOneBaseTemplateControllerTemplate: async (id: string, updateTemplateDto: UpdateTemplateDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('updateOneBaseTemplateControllerTemplate', 'id', id)
            // verify required parameter 'updateTemplateDto' is not null or undefined
            assertParamExists('updateOneBaseTemplateControllerTemplate', 'updateTemplateDto', updateTemplateDto)
            const localVarPath = `/template/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateTemplateDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * TemplateApi - functional programming interface
 * @export
 */
export const TemplateApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = TemplateApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Create multiple Templates
         * @param {CreateManyTemplateDto} createManyTemplateDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createManyBaseTemplateControllerTemplate(createManyTemplateDto: CreateManyTemplateDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<object>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createManyBaseTemplateControllerTemplate(createManyTemplateDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Create a single Template
         * @param {CreateTemplateDto} createTemplateDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createOneBaseTemplateControllerTemplate(createTemplateDto: CreateTemplateDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createOneBaseTemplateControllerTemplate(createTemplateDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Delete a single Template
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteOneBaseTemplateControllerTemplate(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteOneBaseTemplateControllerTemplate(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Retrieve multiple Templates
         * @param {Array<string>} [fields] Selects resource fields. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#select\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {string} [s] Adds search condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#search\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {Array<string>} [filter] Adds filter condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#filter\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {Array<string>} [or] Adds OR condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#or\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {Array<string>} [sort] Adds sort by field. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#sort\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {Array<string>} [join] Adds relational resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#join\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {number} [limit] Limit amount of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#limit\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {number} [offset] Offset amount of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#offset\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {number} [page] Page portion of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#page\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {number} [cache] Reset cache (if was enabled). &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#cache\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getManyBaseTemplateControllerTemplate(fields?: Array<string>, s?: string, filter?: Array<string>, or?: Array<string>, sort?: Array<string>, join?: Array<string>, limit?: number, offset?: number, page?: number, cache?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetManyTemplateResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getManyBaseTemplateControllerTemplate(fields, s, filter, or, sort, join, limit, offset, page, cache, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Retrieve a single Template
         * @param {string} id 
         * @param {Array<string>} [fields] Selects resource fields. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#select\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {Array<string>} [join] Adds relational resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#join\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {number} [cache] Reset cache (if was enabled). &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#cache\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getOneBaseTemplateControllerTemplate(id: string, fields?: Array<string>, join?: Array<string>, cache?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getOneBaseTemplateControllerTemplate(id, fields, join, cache, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Replace a single Template
         * @param {string} id 
         * @param {UpdateTemplateDto} updateTemplateDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async replaceOneBaseTemplateControllerTemplate(id: string, updateTemplateDto: UpdateTemplateDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.replaceOneBaseTemplateControllerTemplate(id, updateTemplateDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async templateControllerLibrary(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.templateControllerLibrary(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} [kind] 
         * @param {string} [codes] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async templateControllerResolve(kind?: string, codes?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.templateControllerResolve(kind, codes, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Update a single Template
         * @param {string} id 
         * @param {UpdateTemplateDto} updateTemplateDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateOneBaseTemplateControllerTemplate(id: string, updateTemplateDto: UpdateTemplateDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateOneBaseTemplateControllerTemplate(id, updateTemplateDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * TemplateApi - factory interface
 * @export
 */
export const TemplateApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = TemplateApiFp(configuration)
    return {
        /**
         * 
         * @summary Create multiple Templates
         * @param {CreateManyTemplateDto} createManyTemplateDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createManyBaseTemplateControllerTemplate(createManyTemplateDto: CreateManyTemplateDto, options?: any): AxiosPromise<Array<object>> {
            return localVarFp.createManyBaseTemplateControllerTemplate(createManyTemplateDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Create a single Template
         * @param {CreateTemplateDto} createTemplateDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createOneBaseTemplateControllerTemplate(createTemplateDto: CreateTemplateDto, options?: any): AxiosPromise<object> {
            return localVarFp.createOneBaseTemplateControllerTemplate(createTemplateDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Delete a single Template
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOneBaseTemplateControllerTemplate(id: string, options?: any): AxiosPromise<object> {
            return localVarFp.deleteOneBaseTemplateControllerTemplate(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Retrieve multiple Templates
         * @param {Array<string>} [fields] Selects resource fields. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#select\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {string} [s] Adds search condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#search\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {Array<string>} [filter] Adds filter condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#filter\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {Array<string>} [or] Adds OR condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#or\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {Array<string>} [sort] Adds sort by field. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#sort\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {Array<string>} [join] Adds relational resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#join\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {number} [limit] Limit amount of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#limit\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {number} [offset] Offset amount of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#offset\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {number} [page] Page portion of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#page\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {number} [cache] Reset cache (if was enabled). &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#cache\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getManyBaseTemplateControllerTemplate(fields?: Array<string>, s?: string, filter?: Array<string>, or?: Array<string>, sort?: Array<string>, join?: Array<string>, limit?: number, offset?: number, page?: number, cache?: number, options?: any): AxiosPromise<GetManyTemplateResponseDto> {
            return localVarFp.getManyBaseTemplateControllerTemplate(fields, s, filter, or, sort, join, limit, offset, page, cache, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Retrieve a single Template
         * @param {string} id 
         * @param {Array<string>} [fields] Selects resource fields. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#select\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {Array<string>} [join] Adds relational resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#join\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {number} [cache] Reset cache (if was enabled). &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#cache\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOneBaseTemplateControllerTemplate(id: string, fields?: Array<string>, join?: Array<string>, cache?: number, options?: any): AxiosPromise<object> {
            return localVarFp.getOneBaseTemplateControllerTemplate(id, fields, join, cache, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Replace a single Template
         * @param {string} id 
         * @param {UpdateTemplateDto} updateTemplateDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        replaceOneBaseTemplateControllerTemplate(id: string, updateTemplateDto: UpdateTemplateDto, options?: any): AxiosPromise<object> {
            return localVarFp.replaceOneBaseTemplateControllerTemplate(id, updateTemplateDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        templateControllerLibrary(options?: any): AxiosPromise<void> {
            return localVarFp.templateControllerLibrary(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [kind] 
         * @param {string} [codes] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        templateControllerResolve(kind?: string, codes?: string, options?: any): AxiosPromise<void> {
            return localVarFp.templateControllerResolve(kind, codes, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update a single Template
         * @param {string} id 
         * @param {UpdateTemplateDto} updateTemplateDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateOneBaseTemplateControllerTemplate(id: string, updateTemplateDto: UpdateTemplateDto, options?: any): AxiosPromise<object> {
            return localVarFp.updateOneBaseTemplateControllerTemplate(id, updateTemplateDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * TemplateApi - object-oriented interface
 * @export
 * @class TemplateApi
 * @extends {BaseAPI}
 */
export class TemplateApi extends BaseAPI {
    /**
     * 
     * @summary Create multiple Templates
     * @param {CreateManyTemplateDto} createManyTemplateDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TemplateApi
     */
    public createManyBaseTemplateControllerTemplate(createManyTemplateDto: CreateManyTemplateDto, options?: AxiosRequestConfig) {
        return TemplateApiFp(this.configuration).createManyBaseTemplateControllerTemplate(createManyTemplateDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Create a single Template
     * @param {CreateTemplateDto} createTemplateDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TemplateApi
     */
    public createOneBaseTemplateControllerTemplate(createTemplateDto: CreateTemplateDto, options?: AxiosRequestConfig) {
        return TemplateApiFp(this.configuration).createOneBaseTemplateControllerTemplate(createTemplateDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Delete a single Template
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TemplateApi
     */
    public deleteOneBaseTemplateControllerTemplate(id: string, options?: AxiosRequestConfig) {
        return TemplateApiFp(this.configuration).deleteOneBaseTemplateControllerTemplate(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Retrieve multiple Templates
     * @param {Array<string>} [fields] Selects resource fields. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#select\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param {string} [s] Adds search condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#search\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param {Array<string>} [filter] Adds filter condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#filter\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param {Array<string>} [or] Adds OR condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#or\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param {Array<string>} [sort] Adds sort by field. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#sort\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param {Array<string>} [join] Adds relational resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#join\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param {number} [limit] Limit amount of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#limit\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param {number} [offset] Offset amount of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#offset\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param {number} [page] Page portion of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#page\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param {number} [cache] Reset cache (if was enabled). &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#cache\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TemplateApi
     */
    public getManyBaseTemplateControllerTemplate(fields?: Array<string>, s?: string, filter?: Array<string>, or?: Array<string>, sort?: Array<string>, join?: Array<string>, limit?: number, offset?: number, page?: number, cache?: number, options?: AxiosRequestConfig) {
        return TemplateApiFp(this.configuration).getManyBaseTemplateControllerTemplate(fields, s, filter, or, sort, join, limit, offset, page, cache, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Retrieve a single Template
     * @param {string} id 
     * @param {Array<string>} [fields] Selects resource fields. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#select\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param {Array<string>} [join] Adds relational resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#join\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param {number} [cache] Reset cache (if was enabled). &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#cache\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TemplateApi
     */
    public getOneBaseTemplateControllerTemplate(id: string, fields?: Array<string>, join?: Array<string>, cache?: number, options?: AxiosRequestConfig) {
        return TemplateApiFp(this.configuration).getOneBaseTemplateControllerTemplate(id, fields, join, cache, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Replace a single Template
     * @param {string} id 
     * @param {UpdateTemplateDto} updateTemplateDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TemplateApi
     */
    public replaceOneBaseTemplateControllerTemplate(id: string, updateTemplateDto: UpdateTemplateDto, options?: AxiosRequestConfig) {
        return TemplateApiFp(this.configuration).replaceOneBaseTemplateControllerTemplate(id, updateTemplateDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TemplateApi
     */
    public templateControllerLibrary(options?: AxiosRequestConfig) {
        return TemplateApiFp(this.configuration).templateControllerLibrary(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} [kind] 
     * @param {string} [codes] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TemplateApi
     */
    public templateControllerResolve(kind?: string, codes?: string, options?: AxiosRequestConfig) {
        return TemplateApiFp(this.configuration).templateControllerResolve(kind, codes, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update a single Template
     * @param {string} id 
     * @param {UpdateTemplateDto} updateTemplateDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TemplateApi
     */
    public updateOneBaseTemplateControllerTemplate(id: string, updateTemplateDto: UpdateTemplateDto, options?: AxiosRequestConfig) {
        return TemplateApiFp(this.configuration).updateOneBaseTemplateControllerTemplate(id, updateTemplateDto, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * UploadIntentApi - axios parameter creator
 * @export
 */
export const UploadIntentApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Client upload diagnostics (diagnostic only)
         * @param {UploadJournalControllerIngestRequest} uploadJournalControllerIngestRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadJournalControllerIngest: async (uploadJournalControllerIngestRequest: UploadJournalControllerIngestRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'uploadJournalControllerIngestRequest' is not null or undefined
            assertParamExists('uploadJournalControllerIngest', 'uploadJournalControllerIngestRequest', uploadJournalControllerIngestRequest)
            const localVarPath = `/upload-intent/journal`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(uploadJournalControllerIngestRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * UploadIntentApi - functional programming interface
 * @export
 */
export const UploadIntentApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = UploadIntentApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Client upload diagnostics (diagnostic only)
         * @param {UploadJournalControllerIngestRequest} uploadJournalControllerIngestRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async uploadJournalControllerIngest(uploadJournalControllerIngestRequest: UploadJournalControllerIngestRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.uploadJournalControllerIngest(uploadJournalControllerIngestRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * UploadIntentApi - factory interface
 * @export
 */
export const UploadIntentApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = UploadIntentApiFp(configuration)
    return {
        /**
         * 
         * @summary Client upload diagnostics (diagnostic only)
         * @param {UploadJournalControllerIngestRequest} uploadJournalControllerIngestRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadJournalControllerIngest(uploadJournalControllerIngestRequest: UploadJournalControllerIngestRequest, options?: any): AxiosPromise<void> {
            return localVarFp.uploadJournalControllerIngest(uploadJournalControllerIngestRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * UploadIntentApi - object-oriented interface
 * @export
 * @class UploadIntentApi
 * @extends {BaseAPI}
 */
export class UploadIntentApi extends BaseAPI {
    /**
     * 
     * @summary Client upload diagnostics (diagnostic only)
     * @param {UploadJournalControllerIngestRequest} uploadJournalControllerIngestRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UploadIntentApi
     */
    public uploadJournalControllerIngest(uploadJournalControllerIngestRequest: UploadJournalControllerIngestRequest, options?: AxiosRequestConfig) {
        return UploadIntentApiFp(this.configuration).uploadJournalControllerIngest(uploadJournalControllerIngestRequest, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * UserApi - axios parameter creator
 * @export
 */
export const UserApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Create a single User
         * @param {CreateUserDto} createUserDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createOneBaseUserControllerUser: async (createUserDto: CreateUserDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createUserDto' is not null or undefined
            assertParamExists('createOneBaseUserControllerUser', 'createUserDto', createUserDto)
            const localVarPath = `/user`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createUserDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Delete a single User
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOneBaseUserControllerUser: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('deleteOneBaseUserControllerUser', 'id', id)
            const localVarPath = `/user/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Retrieve multiple Users
         * @param {Array<string>} [fields] Selects resource fields. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#select\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {string} [s] Adds search condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#search\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {Array<string>} [filter] Adds filter condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#filter\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {Array<string>} [or] Adds OR condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#or\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {Array<string>} [sort] Adds sort by field. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#sort\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {Array<string>} [join] Adds relational resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#join\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {number} [limit] Limit amount of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#limit\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {number} [offset] Offset amount of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#offset\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {number} [page] Page portion of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#page\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {number} [cache] Reset cache (if was enabled). &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#cache\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getManyBaseUserControllerUser: async (fields?: Array<string>, s?: string, filter?: Array<string>, or?: Array<string>, sort?: Array<string>, join?: Array<string>, limit?: number, offset?: number, page?: number, cache?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/user`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (fields) {
                localVarQueryParameter['fields'] = fields;
            }

            if (s !== undefined) {
                localVarQueryParameter['s'] = s;
            }

            if (filter) {
                localVarQueryParameter['filter'] = filter;
            }

            if (or) {
                localVarQueryParameter['or'] = or;
            }

            if (sort) {
                localVarQueryParameter['sort'] = sort;
            }

            if (join) {
                localVarQueryParameter['join'] = join;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (cache !== undefined) {
                localVarQueryParameter['cache'] = cache;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Retrieve a single User
         * @param {string} id 
         * @param {Array<string>} [fields] Selects resource fields. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#select\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {Array<string>} [join] Adds relational resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#join\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {number} [cache] Reset cache (if was enabled). &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#cache\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOneBaseUserControllerUser: async (id: string, fields?: Array<string>, join?: Array<string>, cache?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getOneBaseUserControllerUser', 'id', id)
            const localVarPath = `/user/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (fields) {
                localVarQueryParameter['fields'] = fields;
            }

            if (join) {
                localVarQueryParameter['join'] = join;
            }

            if (cache !== undefined) {
                localVarQueryParameter['cache'] = cache;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Replace a single User
         * @param {string} id 
         * @param {UpdateUserDto} updateUserDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        replaceOneBaseUserControllerUser: async (id: string, updateUserDto: UpdateUserDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('replaceOneBaseUserControllerUser', 'id', id)
            // verify required parameter 'updateUserDto' is not null or undefined
            assertParamExists('replaceOneBaseUserControllerUser', 'updateUserDto', updateUserDto)
            const localVarPath = `/user/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateUserDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update a single User
         * @param {string} id 
         * @param {UpdateUserDto} updateUserDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateOneBaseUserControllerUser: async (id: string, updateUserDto: UpdateUserDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('updateOneBaseUserControllerUser', 'id', id)
            // verify required parameter 'updateUserDto' is not null or undefined
            assertParamExists('updateOneBaseUserControllerUser', 'updateUserDto', updateUserDto)
            const localVarPath = `/user/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateUserDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Delete the signed-in user\'s own account
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userControllerDeleteMe: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/user/me`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get an user from token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userControllerGetMe: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/user/me`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get a user role from token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userControllerGetRole: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/user/role`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Register an Expo push token for the current user
         * @param {RegisterDeviceTokenDto} registerDeviceTokenDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userControllerRegisterDeviceToken: async (registerDeviceTokenDto: RegisterDeviceTokenDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'registerDeviceTokenDto' is not null or undefined
            assertParamExists('userControllerRegisterDeviceToken', 'registerDeviceTokenDto', registerDeviceTokenDto)
            const localVarPath = `/user/me/device-token`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(registerDeviceTokenDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Save the signed-in user\'s delivery address
         * @param {SaveShippingAddressDto} saveShippingAddressDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userControllerSaveMyShippingAddress: async (saveShippingAddressDto: SaveShippingAddressDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'saveShippingAddressDto' is not null or undefined
            assertParamExists('userControllerSaveMyShippingAddress', 'saveShippingAddressDto', saveShippingAddressDto)
            const localVarPath = `/user/me/shipping-address`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(saveShippingAddressDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Record the signed-in user\'s tracking answer
         * @param {SetTrackingConsentDto} setTrackingConsentDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userControllerSetMyTrackingConsent: async (setTrackingConsentDto: SetTrackingConsentDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'setTrackingConsentDto' is not null or undefined
            assertParamExists('userControllerSetMyTrackingConsent', 'setTrackingConsentDto', setTrackingConsentDto)
            const localVarPath = `/user/me/tracking-consent`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(setTrackingConsentDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Unregister an Expo push token for the current user
         * @param {RegisterDeviceTokenDto} registerDeviceTokenDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userControllerUnregisterDeviceToken: async (registerDeviceTokenDto: RegisterDeviceTokenDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'registerDeviceTokenDto' is not null or undefined
            assertParamExists('userControllerUnregisterDeviceToken', 'registerDeviceTokenDto', registerDeviceTokenDto)
            const localVarPath = `/user/me/device-token`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(registerDeviceTokenDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * UserApi - functional programming interface
 * @export
 */
export const UserApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = UserApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Create a single User
         * @param {CreateUserDto} createUserDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createOneBaseUserControllerUser(createUserDto: CreateUserDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createOneBaseUserControllerUser(createUserDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Delete a single User
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteOneBaseUserControllerUser(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteOneBaseUserControllerUser(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Retrieve multiple Users
         * @param {Array<string>} [fields] Selects resource fields. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#select\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {string} [s] Adds search condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#search\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {Array<string>} [filter] Adds filter condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#filter\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {Array<string>} [or] Adds OR condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#or\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {Array<string>} [sort] Adds sort by field. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#sort\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {Array<string>} [join] Adds relational resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#join\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {number} [limit] Limit amount of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#limit\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {number} [offset] Offset amount of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#offset\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {number} [page] Page portion of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#page\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {number} [cache] Reset cache (if was enabled). &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#cache\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getManyBaseUserControllerUser(fields?: Array<string>, s?: string, filter?: Array<string>, or?: Array<string>, sort?: Array<string>, join?: Array<string>, limit?: number, offset?: number, page?: number, cache?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetManyUserResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getManyBaseUserControllerUser(fields, s, filter, or, sort, join, limit, offset, page, cache, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Retrieve a single User
         * @param {string} id 
         * @param {Array<string>} [fields] Selects resource fields. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#select\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {Array<string>} [join] Adds relational resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#join\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {number} [cache] Reset cache (if was enabled). &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#cache\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getOneBaseUserControllerUser(id: string, fields?: Array<string>, join?: Array<string>, cache?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetUserDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getOneBaseUserControllerUser(id, fields, join, cache, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Replace a single User
         * @param {string} id 
         * @param {UpdateUserDto} updateUserDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async replaceOneBaseUserControllerUser(id: string, updateUserDto: UpdateUserDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.replaceOneBaseUserControllerUser(id, updateUserDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Update a single User
         * @param {string} id 
         * @param {UpdateUserDto} updateUserDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateOneBaseUserControllerUser(id: string, updateUserDto: UpdateUserDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateOneBaseUserControllerUser(id, updateUserDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Delete the signed-in user\'s own account
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async userControllerDeleteMe(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.userControllerDeleteMe(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get an user from token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async userControllerGetMe(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetUserDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.userControllerGetMe(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get a user role from token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async userControllerGetRole(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.userControllerGetRole(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Register an Expo push token for the current user
         * @param {RegisterDeviceTokenDto} registerDeviceTokenDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async userControllerRegisterDeviceToken(registerDeviceTokenDto: RegisterDeviceTokenDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.userControllerRegisterDeviceToken(registerDeviceTokenDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Save the signed-in user\'s delivery address
         * @param {SaveShippingAddressDto} saveShippingAddressDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async userControllerSaveMyShippingAddress(saveShippingAddressDto: SaveShippingAddressDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.userControllerSaveMyShippingAddress(saveShippingAddressDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Record the signed-in user\'s tracking answer
         * @param {SetTrackingConsentDto} setTrackingConsentDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async userControllerSetMyTrackingConsent(setTrackingConsentDto: SetTrackingConsentDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.userControllerSetMyTrackingConsent(setTrackingConsentDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Unregister an Expo push token for the current user
         * @param {RegisterDeviceTokenDto} registerDeviceTokenDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async userControllerUnregisterDeviceToken(registerDeviceTokenDto: RegisterDeviceTokenDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.userControllerUnregisterDeviceToken(registerDeviceTokenDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * UserApi - factory interface
 * @export
 */
export const UserApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = UserApiFp(configuration)
    return {
        /**
         * 
         * @summary Create a single User
         * @param {CreateUserDto} createUserDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createOneBaseUserControllerUser(createUserDto: CreateUserDto, options?: any): AxiosPromise<object> {
            return localVarFp.createOneBaseUserControllerUser(createUserDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Delete a single User
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOneBaseUserControllerUser(id: string, options?: any): AxiosPromise<object> {
            return localVarFp.deleteOneBaseUserControllerUser(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Retrieve multiple Users
         * @param {Array<string>} [fields] Selects resource fields. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#select\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {string} [s] Adds search condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#search\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {Array<string>} [filter] Adds filter condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#filter\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {Array<string>} [or] Adds OR condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#or\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {Array<string>} [sort] Adds sort by field. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#sort\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {Array<string>} [join] Adds relational resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#join\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {number} [limit] Limit amount of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#limit\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {number} [offset] Offset amount of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#offset\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {number} [page] Page portion of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#page\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {number} [cache] Reset cache (if was enabled). &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#cache\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getManyBaseUserControllerUser(fields?: Array<string>, s?: string, filter?: Array<string>, or?: Array<string>, sort?: Array<string>, join?: Array<string>, limit?: number, offset?: number, page?: number, cache?: number, options?: any): AxiosPromise<GetManyUserResponseDto> {
            return localVarFp.getManyBaseUserControllerUser(fields, s, filter, or, sort, join, limit, offset, page, cache, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Retrieve a single User
         * @param {string} id 
         * @param {Array<string>} [fields] Selects resource fields. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#select\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {Array<string>} [join] Adds relational resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#join\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {number} [cache] Reset cache (if was enabled). &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#cache\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOneBaseUserControllerUser(id: string, fields?: Array<string>, join?: Array<string>, cache?: number, options?: any): AxiosPromise<GetUserDto> {
            return localVarFp.getOneBaseUserControllerUser(id, fields, join, cache, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Replace a single User
         * @param {string} id 
         * @param {UpdateUserDto} updateUserDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        replaceOneBaseUserControllerUser(id: string, updateUserDto: UpdateUserDto, options?: any): AxiosPromise<object> {
            return localVarFp.replaceOneBaseUserControllerUser(id, updateUserDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update a single User
         * @param {string} id 
         * @param {UpdateUserDto} updateUserDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateOneBaseUserControllerUser(id: string, updateUserDto: UpdateUserDto, options?: any): AxiosPromise<object> {
            return localVarFp.updateOneBaseUserControllerUser(id, updateUserDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Delete the signed-in user\'s own account
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userControllerDeleteMe(options?: any): AxiosPromise<void> {
            return localVarFp.userControllerDeleteMe(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get an user from token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userControllerGetMe(options?: any): AxiosPromise<GetUserDto> {
            return localVarFp.userControllerGetMe(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get a user role from token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userControllerGetRole(options?: any): AxiosPromise<void> {
            return localVarFp.userControllerGetRole(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Register an Expo push token for the current user
         * @param {RegisterDeviceTokenDto} registerDeviceTokenDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userControllerRegisterDeviceToken(registerDeviceTokenDto: RegisterDeviceTokenDto, options?: any): AxiosPromise<void> {
            return localVarFp.userControllerRegisterDeviceToken(registerDeviceTokenDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Save the signed-in user\'s delivery address
         * @param {SaveShippingAddressDto} saveShippingAddressDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userControllerSaveMyShippingAddress(saveShippingAddressDto: SaveShippingAddressDto, options?: any): AxiosPromise<void> {
            return localVarFp.userControllerSaveMyShippingAddress(saveShippingAddressDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Record the signed-in user\'s tracking answer
         * @param {SetTrackingConsentDto} setTrackingConsentDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userControllerSetMyTrackingConsent(setTrackingConsentDto: SetTrackingConsentDto, options?: any): AxiosPromise<void> {
            return localVarFp.userControllerSetMyTrackingConsent(setTrackingConsentDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Unregister an Expo push token for the current user
         * @param {RegisterDeviceTokenDto} registerDeviceTokenDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userControllerUnregisterDeviceToken(registerDeviceTokenDto: RegisterDeviceTokenDto, options?: any): AxiosPromise<void> {
            return localVarFp.userControllerUnregisterDeviceToken(registerDeviceTokenDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * UserApi - object-oriented interface
 * @export
 * @class UserApi
 * @extends {BaseAPI}
 */
export class UserApi extends BaseAPI {
    /**
     * 
     * @summary Create a single User
     * @param {CreateUserDto} createUserDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserApi
     */
    public createOneBaseUserControllerUser(createUserDto: CreateUserDto, options?: AxiosRequestConfig) {
        return UserApiFp(this.configuration).createOneBaseUserControllerUser(createUserDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Delete a single User
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserApi
     */
    public deleteOneBaseUserControllerUser(id: string, options?: AxiosRequestConfig) {
        return UserApiFp(this.configuration).deleteOneBaseUserControllerUser(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Retrieve multiple Users
     * @param {Array<string>} [fields] Selects resource fields. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#select\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param {string} [s] Adds search condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#search\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param {Array<string>} [filter] Adds filter condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#filter\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param {Array<string>} [or] Adds OR condition. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#or\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param {Array<string>} [sort] Adds sort by field. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#sort\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param {Array<string>} [join] Adds relational resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#join\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param {number} [limit] Limit amount of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#limit\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param {number} [offset] Offset amount of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#offset\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param {number} [page] Page portion of resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#page\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param {number} [cache] Reset cache (if was enabled). &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#cache\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserApi
     */
    public getManyBaseUserControllerUser(fields?: Array<string>, s?: string, filter?: Array<string>, or?: Array<string>, sort?: Array<string>, join?: Array<string>, limit?: number, offset?: number, page?: number, cache?: number, options?: AxiosRequestConfig) {
        return UserApiFp(this.configuration).getManyBaseUserControllerUser(fields, s, filter, or, sort, join, limit, offset, page, cache, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Retrieve a single User
     * @param {string} id 
     * @param {Array<string>} [fields] Selects resource fields. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#select\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param {Array<string>} [join] Adds relational resources. &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#join\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param {number} [cache] Reset cache (if was enabled). &lt;a href&#x3D;\&quot;https://github.com/nestjsx/crud/wiki/Requests#cache\&quot; target&#x3D;\&quot;_blank\&quot;&gt;Docs&lt;/a&gt;
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserApi
     */
    public getOneBaseUserControllerUser(id: string, fields?: Array<string>, join?: Array<string>, cache?: number, options?: AxiosRequestConfig) {
        return UserApiFp(this.configuration).getOneBaseUserControllerUser(id, fields, join, cache, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Replace a single User
     * @param {string} id 
     * @param {UpdateUserDto} updateUserDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserApi
     */
    public replaceOneBaseUserControllerUser(id: string, updateUserDto: UpdateUserDto, options?: AxiosRequestConfig) {
        return UserApiFp(this.configuration).replaceOneBaseUserControllerUser(id, updateUserDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update a single User
     * @param {string} id 
     * @param {UpdateUserDto} updateUserDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserApi
     */
    public updateOneBaseUserControllerUser(id: string, updateUserDto: UpdateUserDto, options?: AxiosRequestConfig) {
        return UserApiFp(this.configuration).updateOneBaseUserControllerUser(id, updateUserDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Delete the signed-in user\'s own account
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserApi
     */
    public userControllerDeleteMe(options?: AxiosRequestConfig) {
        return UserApiFp(this.configuration).userControllerDeleteMe(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get an user from token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserApi
     */
    public userControllerGetMe(options?: AxiosRequestConfig) {
        return UserApiFp(this.configuration).userControllerGetMe(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get a user role from token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserApi
     */
    public userControllerGetRole(options?: AxiosRequestConfig) {
        return UserApiFp(this.configuration).userControllerGetRole(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Register an Expo push token for the current user
     * @param {RegisterDeviceTokenDto} registerDeviceTokenDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserApi
     */
    public userControllerRegisterDeviceToken(registerDeviceTokenDto: RegisterDeviceTokenDto, options?: AxiosRequestConfig) {
        return UserApiFp(this.configuration).userControllerRegisterDeviceToken(registerDeviceTokenDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Save the signed-in user\'s delivery address
     * @param {SaveShippingAddressDto} saveShippingAddressDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserApi
     */
    public userControllerSaveMyShippingAddress(saveShippingAddressDto: SaveShippingAddressDto, options?: AxiosRequestConfig) {
        return UserApiFp(this.configuration).userControllerSaveMyShippingAddress(saveShippingAddressDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Record the signed-in user\'s tracking answer
     * @param {SetTrackingConsentDto} setTrackingConsentDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserApi
     */
    public userControllerSetMyTrackingConsent(setTrackingConsentDto: SetTrackingConsentDto, options?: AxiosRequestConfig) {
        return UserApiFp(this.configuration).userControllerSetMyTrackingConsent(setTrackingConsentDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Unregister an Expo push token for the current user
     * @param {RegisterDeviceTokenDto} registerDeviceTokenDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserApi
     */
    public userControllerUnregisterDeviceToken(registerDeviceTokenDto: RegisterDeviceTokenDto, options?: AxiosRequestConfig) {
        return UserApiFp(this.configuration).userControllerUnregisterDeviceToken(registerDeviceTokenDto, options).then((request) => request(this.axios, this.basePath));
    }
}



